
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec100"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec100"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("7dGEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $541ad4d15ffa42f6$export$2e2bcd8739ae039);

var $l7O8P = parcelRequire("l7O8P");
var $541ad4d15ffa42f6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $541ad4d15ffa42f6$var$index = (0, $l7O8P.default)(function(prop) {
    return $541ad4d15ffa42f6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $541ad4d15ffa42f6$export$2e2bcd8739ae039 = $541ad4d15ffa42f6$var$index;

});
parcelRegister("l7O8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6112573aba91cb3$export$2e2bcd8739ae039);
function $f6112573aba91cb3$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f6112573aba91cb3$export$2e2bcd8739ae039 = $f6112573aba91cb3$var$memoize;

});


parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});
parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


// TYPES
// UTILS
const $f8b865b18d670cc6$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $f8b865b18d670cc6$export$8793edee2d425525() {
    return undefined;
}
function $f8b865b18d670cc6$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $f8b865b18d670cc6$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $f8b865b18d670cc6$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $f8b865b18d670cc6$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $f8b865b18d670cc6$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $f8b865b18d670cc6$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$f8b865b18d670cc6$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $f8b865b18d670cc6$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === 'function') return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $f8b865b18d670cc6$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $f8b865b18d670cc6$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $f8b865b18d670cc6$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $f8b865b18d670cc6$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $f8b865b18d670cc6$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $f8b865b18d670cc6$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$f8b865b18d670cc6$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $f8b865b18d670cc6$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($f8b865b18d670cc6$export$5fcb678681417b54(mutation.options.mutationKey) !== $f8b865b18d670cc6$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$f8b865b18d670cc6$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $f8b865b18d670cc6$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $f8b865b18d670cc6$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $f8b865b18d670cc6$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$f8b865b18d670cc6$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $f8b865b18d670cc6$export$2f07189bb9fa26a7(a, b) {
    return $f8b865b18d670cc6$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $f8b865b18d670cc6$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$f8b865b18d670cc6$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $f8b865b18d670cc6$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $f8b865b18d670cc6$export$7a8558113332b71e(a) && $f8b865b18d670cc6$export$7a8558113332b71e(b);
    if (array || $f8b865b18d670cc6$export$53b83ca8eaab0383(a) && $f8b865b18d670cc6$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $f8b865b18d670cc6$export$77a71fc411098696(a[key], b[key], depth + 1);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $f8b865b18d670cc6$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $f8b865b18d670cc6$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $f8b865b18d670cc6$export$53b83ca8eaab0383(o) {
    if (!$f8b865b18d670cc6$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$f8b865b18d670cc6$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $f8b865b18d670cc6$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $f8b865b18d670cc6$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $f8b865b18d670cc6$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $f8b865b18d670cc6$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $f8b865b18d670cc6$export$4304cb76768ca134(callback) {
    $f8b865b18d670cc6$export$e772c8ff12451969(0).then(callback);
}
function $f8b865b18d670cc6$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $f8b865b18d670cc6$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $f8b865b18d670cc6$export$77a71fc411098696(prevData, data);
    return data;
}




const $9bd79d53e26c8f96$export$1cf3d545f2d4635c = console;



function $9c9aacadc80c6826$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $f8b865b18d670cc6$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $f8b865b18d670cc6$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $9c9aacadc80c6826$export$520687f44db6e1ab = $9c9aacadc80c6826$export$316a8efd03cd1458();


class $29a2986ef88e4ed5$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $2a29005856faa11a$export$86f1af424b2ca4de extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $f8b865b18d670cc6$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
}
const $2a29005856faa11a$export$6bf54661be5b02cf = new $2a29005856faa11a$export$86f1af424b2ca4de();




const $bdda8765d46ccf87$var$onlineEvents = [
    'online',
    'offline'
];
class $bdda8765d46ccf87$export$58774fb55d5ff7fc extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $f8b865b18d670cc6$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $bdda8765d46ccf87$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $bdda8765d46ccf87$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
}
const $bdda8765d46ccf87$export$b113e788b2dd3fdc = new $bdda8765d46ccf87$export$58774fb55d5ff7fc();



function $cd25260720ff3eef$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $cd25260720ff3eef$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline() : true;
}
class $cd25260720ff3eef$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $cd25260720ff3eef$export$986cc6445c1d323(value) {
    return value instanceof $cd25260720ff3eef$export$a8430ed4188f35a9;
}
function $cd25260720ff3eef$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $cd25260720ff3eef$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused() || config.networkMode !== 'always' && !(0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $cd25260720ff3eef$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $f8b865b18d670cc6$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($cd25260720ff3eef$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}



class $3141b454c0d4745f$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $f8b865b18d670cc6$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $f8b865b18d670cc6$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


// CLASS
class $e66552176030227e$export$62297b13309008b2 extends (0, $3141b454c0d4745f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $e66552176030227e$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $f8b865b18d670cc6$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $f8b865b18d670cc6$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $cd25260720ff3eef$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $cd25260720ff3eef$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $cd25260720ff3eef$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        fetchStatus: 'paused'
                    };
                case 'continue':
                    return {
                        ...state,
                        fetchStatus: 'fetching'
                    };
                case 'fetch':
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $cd25260720ff3eef$export$61b92f63f30245cf)(this.options.networkMode) ? 'fetching' : 'paused',
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: 'loading'
                        }
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success',
                        ...!action.manual && {
                            fetchStatus: 'idle',
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case 'error':
                    const error = action.error;
                    if ((0, $cd25260720ff3eef$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: 'idle'
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    };
                case 'invalidate':
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $e66552176030227e$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}




// CLASS
class $013b25af9cb1d94e$export$5dde0cd941da8468 extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $f8b865b18d670cc6$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $e66552176030227e$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ find(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $f8b865b18d670cc6$export$c5d1efe363797780)(filters, query));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ findAll(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $f8b865b18d670cc6$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}







// CLASS
class $da939cdf983103e1$export$17b8b19c814bcf56 extends (0, $3141b454c0d4745f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $da939cdf983103e1$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $cd25260720ff3eef$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        isPaused: true
                    };
                case 'continue':
                    return {
                        ...state,
                        isPaused: false
                    };
                case 'loading':
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $cd25260720ff3eef$export$61b92f63f30245cf)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    };
                case 'error':
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $da939cdf983103e1$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}




// CLASS
class $cc7bef81aaa407d7$export$1fcfd9a244434844 extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $da939cdf983103e1$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $f8b865b18d670cc6$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $f8b865b18d670cc6$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $f8b865b18d670cc6$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}





function $2fb8e98898cdca1c$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $2fb8e98898cdca1c$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $2fb8e98898cdca1c$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $2fb8e98898cdca1c$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $2fb8e98898cdca1c$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $2fb8e98898cdca1c$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $2fb8e98898cdca1c$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $2fb8e98898cdca1c$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $2fb8e98898cdca1c$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $2fb8e98898cdca1c$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $993a0f6ad9d6681b$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $013b25af9cb1d94e$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $cc7bef81aaa407d7$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $2a29005856faa11a$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ isFetching(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    /**
   * @deprecated This method will accept only queryKey in the next major version.
   */ getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $f8b865b18d670cc6$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, /**
   * @deprecated This filters will be removed in the next major version.
   */ filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ removeQueries(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: 'active',
            ...filters
        };
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $f8b865b18d670cc6$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
        return promise;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $2fb8e98898cdca1c$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $f8b865b18d670cc6$export$5fcb678681417b54)(queryKey) === (0, $f8b865b18d670cc6$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $f8b865b18d670cc6$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $f8b865b18d670cc6$export$5fcb678681417b54)(mutationKey) === (0, $f8b865b18d670cc6$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $f8b865b18d670cc6$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $f8b865b18d670cc6$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}


var $acw62 = parcelRequire("acw62");
'use client';
const $0126047dd734bc33$export$2fba198b5b2e37fa = /*#__PURE__*/ $acw62.createContext(undefined);
const $0126047dd734bc33$var$QueryClientSharingContext = /*#__PURE__*/ $acw62.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $0126047dd734bc33$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $0126047dd734bc33$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $0126047dd734bc33$export$2fba198b5b2e37fa;
}
const $0126047dd734bc33$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $acw62.useContext($0126047dd734bc33$var$getQueryClientContext(context, $acw62.useContext($0126047dd734bc33$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $0126047dd734bc33$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $0126047dd734bc33$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $acw62.createElement($0126047dd734bc33$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: client
    }, children));
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $e5577d74aee99e62$export$2e2bcd8739ae039() {
    const { pathname: pathname } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


function $ab278db22d2b79f2$var$Button(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ...props,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("common-button", props.className),
        children: props.children
    });
}
var $ab278db22d2b79f2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($ab278db22d2b79f2$var$Button);




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);




var $acw62 = parcelRequire("acw62");
const $784730508f12f72c$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $9dc069bda924fd3f$export$9fd24a634729c672)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);


function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
    const lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $acw62.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $acw62.useRef)(Boolean(props[0, $5fd2b57c27674a98$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $acw62.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}



var $acw62 = parcelRequire("acw62");
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $0172fb3d3512f551$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $0172fb3d3512f551$export$1405a65085f40b9 = [
    "initial",
    ...$0172fb3d3512f551$export$16e45afcc206d3a8
];


function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(props.animate) || (0, $0172fb3d3512f551$export$1405a65085f40b9).some((name)=>(0, $a35be4d5814e7c66$export$720b90e312cea233)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a35be4d5814e7c66$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a35be4d5814e7c66$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $a8d82256030e9525$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a8d82256030e9525$export$65570e08d843624d = {};
for(const key in $a8d82256030e9525$var$featureProps)$a8d82256030e9525$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a8d82256030e9525$var$featureProps[key].some((name)=>!!props[name])
};


function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a8d82256030e9525$export$65570e08d843624d)[key] = {
        ...(0, $a8d82256030e9525$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $acw62 = parcelRequire("acw62");
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});




var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});


const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $b9879783068c1762$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
            const isStrict = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $acw62.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $acw62.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $9b94ea54d3350cc1$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $ac502869c4d3e65a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ac502869c4d3e65a$export$7b42a0094fb00b6e = new Set($ac502869c4d3e65a$export$280dc01950909d86);


function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $55c3387a92452647$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1724c99b9b724858$var$numTransforms = (0, $ac502869c4d3e65a$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1724c99b9b724858$var$numTransforms; i++){
        const key = (0, $ac502869c4d3e65a$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $1724c99b9b724858$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $f9c5e88311214d2a$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f9c5e88311214d2a$export$9de1236619d9e756 = $f9c5e88311214d2a$var$checkStringStartsWith("--");
const $f9c5e88311214d2a$export$31f9caa2600b5723 = $f9c5e88311214d2a$var$checkStringStartsWith("var(--");
const $f9c5e88311214d2a$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a19b1277e1098e3a$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $965bce4b5aab9d94$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $965bce4b5aab9d94$export$58f0f39f63f3cf42 = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    transform: (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $965bce4b5aab9d94$export$dcdf75081b88279d = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $9d068be114f1d873$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $9d068be114f1d873$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $9d068be114f1d873$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $9d068be114f1d873$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $9d068be114f1d873$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $25ca921ba8e55794$var$createUnitType = (unit)=>({
        test: (v)=>(0, $9d068be114f1d873$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $25ca921ba8e55794$export$41fc368e1a942b97 = $25ca921ba8e55794$var$createUnitType("deg");
const $25ca921ba8e55794$export$626336c2cd4b14de = $25ca921ba8e55794$var$createUnitType("%");
const $25ca921ba8e55794$export$91c0eda1d06bf008 = $25ca921ba8e55794$var$createUnitType("px");
const $25ca921ba8e55794$export$f91e8c45a95a32f2 = $25ca921ba8e55794$var$createUnitType("vh");
const $25ca921ba8e55794$export$aed3d7b7d206c196 = $25ca921ba8e55794$var$createUnitType("vw");
const $25ca921ba8e55794$export$44e2e1705876d7ed = {
    ...$25ca921ba8e55794$export$626336c2cd4b14de,
    parse: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.transform(v * 100)
};



const $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: Math.round
};


const $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRightWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    radius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    height: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxHeight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    size: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    top: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    right: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    bottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    left: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    margin: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateZ: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    scale: $965bce4b5aab9d94$export$dcdf75081b88279d,
    scaleX: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleY: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleZ: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    skew: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    distance: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateX: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateY: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    x: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    y: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    z: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    perspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    transformPerspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    opacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    originX: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originY: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    numOctaves: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e)
};


function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $55c3387a92452647$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("7dGEo")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $acw62 = parcelRequire("acw62");



function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2860344bf6c6c49f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $57bb451bc3d87577$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $acw62.useMemo)(()=>(0, $55c3387a92452647$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $acw62.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $55c3387a92452647$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps.style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $55c3387a92452647$export$605d60a2578142d3)(props[key]) || (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ac502869c4d3e65a$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $acw62 = parcelRequire("acw62");


function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $21f654501c04362b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $21f654501c04362b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $21f654501c04362b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $5c26ebcca6422185$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(make);
    };
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $448ce039afb5ec07$export$8793edee2d425525 = (any)=>any;


class $f4ac54c83388ba0d$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $f4ac54c83388ba0d$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $f4ac54c83388ba0d$var$Queue();
    let nextFrame = new $f4ac54c83388ba0d$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $d022ffbd5a1b0ae4$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $d022ffbd5a1b0ae4$var$maxElapsed = 40;
function $d022ffbd5a1b0ae4$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $f4ac54c83388ba0d$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $d022ffbd5a1b0ae4$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $d022ffbd5a1b0ae4$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$d022ffbd5a1b0ae4$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $9f96722ff12dbfe7$export$2cef06c20297c17d, cancel: $9f96722ff12dbfe7$export$ec99c0ef4978dccb, state: $9f96722ff12dbfe7$export$fff89137e9e818ce, steps: $9f96722ff12dbfe7$export$be3f796aed065412 } = (0, $d022ffbd5a1b0ae4$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $448ce039afb5ec07$export$8793edee2d425525), true);


const $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
        createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(()=>{
                (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a8ee53e44f8c4ac8$export$16da615486abaa45,
        createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
    })
};


function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $fde6d634ecc7ed6c$export$44dabd3fae512e85) : (0, $dcb38e10dcfb6316$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $dc80cb5954e76638$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $43ace1b5a11c3a40$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $6b2f8b101475710a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};


function $7fd40e38993f1c69$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(target, eventName, (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $21841eadb135946f$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $21841eadb135946f$export$a4627e546088548d = (...transformers)=>transformers.reduce($21841eadb135946f$var$combineFunctions);


function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
const $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        const openHorizontal = $df8cc4eab047d382$var$globalHorizontalLock();
        const openVertical = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $5b9241b1e863e695$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $dfb80d799aa36175$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $df8cc4eab047d382$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $dfb80d799aa36175$export$93a81ea037eac456 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)($dfb80d799aa36175$var$addHoverEvent(this.node, true), $dfb80d799aa36175$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $46d14c2f8ccf5da4$export$d4826db40d47595b extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)((0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ae5289b89bf4fd95$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};




function $b3902e3e20ea107a$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $23ab615c547792c0$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $b3902e3e20ea107a$export$f026abdbba7f0c9e extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeEndListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !globalTapTarget && !(0, $ae5289b89bf4fd95$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b3902e3e20ea107a$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $df8cc4eab047d382$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $3926a5d0685d183c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $3926a5d0685d183c$export$150851c8cc2f0c72 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $3926a5d0685d183c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($3926a5d0685d183c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $3926a5d0685d183c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $3926a5d0685d183c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b3902e3e20ea107a$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $46d14c2f8ccf5da4$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $dfb80d799aa36175$export$93a81ea037eac456)
    }
};





function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $58c1fda9d3891d8d$var$getCurrent(visualElement), $58c1fda9d3891d8d$var$getVelocity(visualElement));
}







let $bf99d85f7a843912$export$491112666e282270 = (0, $448ce039afb5ec07$export$8793edee2d425525);
let $bf99d85f7a843912$export$f5708dca728d7177 = (0, $448ce039afb5ec07$export$8793edee2d425525);
var $bf99d85f7a843912$var$check, $bf99d85f7a843912$var$message, $bf99d85f7a843912$var$check1, $bf99d85f7a843912$var$message1;


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $083454c8244247d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $083454c8244247d6$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};


const $8a5eba8ea233e901$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $877fa42e69510d34$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $877fa42e69510d34$export$2cf569f5e2221176[easing] || (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($877fa42e69510d34$export$fcdd8f3f2160beda));
}
const $877fa42e69510d34$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $877fa42e69510d34$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $877fa42e69510d34$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) ? $877fa42e69510d34$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($877fa42e69510d34$export$916ea73bcd3a6030) : $877fa42e69510d34$export$2cf569f5e2221176[easing];
}


function $db913f3e2f893030$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $877fa42e69510d34$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $b7455746a6cabbfe$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $cdee14e408821ec6$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $cdee14e408821ec6$var$subdivisionPrecision = 0.0000001;
const $cdee14e408821ec6$var$subdivisionMaxIterations = 12;
function $cdee14e408821ec6$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $cdee14e408821ec6$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $cdee14e408821ec6$var$subdivisionPrecision && ++i < $cdee14e408821ec6$var$subdivisionMaxIterations);
    return currentT;
}
function $cdee14e408821ec6$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $448ce039afb5ec07$export$8793edee2d425525;
    const getTForX = (aX)=>$cdee14e408821ec6$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $cdee14e408821ec6$var$calcBezier(getTForX(t), mY1, mY2);
}


const $c24ef35c6cea05c0$export$929e5a82286172a6 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c24ef35c6cea05c0$export$57636bb43b1ccbb0 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c24ef35c6cea05c0$export$c07234257a03d5e9 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $b8e36ee1e1d53e83$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6fc2fca13a5370f0$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $daf16ad73b68faf0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $66a2361fd99a4040$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $66a2361fd99a4040$export$c8d67a19199d1a50 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($66a2361fd99a4040$export$e444123e42d03385);
const $66a2361fd99a4040$export$30d3455eee55bed5 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($66a2361fd99a4040$export$e444123e42d03385);





const $a7ddcde2a4282efd$export$77edfce482316a60 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $a7ddcde2a4282efd$export$b01116c84cdfe1a2 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($a7ddcde2a4282efd$export$77edfce482316a60);
const $a7ddcde2a4282efd$export$ddc5fd596f6c71b2 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($a7ddcde2a4282efd$export$b01116c84cdfe1a2);



const $5e5a5cfe1fa796ef$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $a7ddcde2a4282efd$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $15a4078bfbf4856a$var$easingLookup = {
    linear: (0, $448ce039afb5ec07$export$8793edee2d425525),
    easeIn: $c24ef35c6cea05c0$export$929e5a82286172a6,
    easeInOut: $c24ef35c6cea05c0$export$c07234257a03d5e9,
    easeOut: $c24ef35c6cea05c0$export$57636bb43b1ccbb0,
    circIn: $66a2361fd99a4040$export$e444123e42d03385,
    circInOut: $66a2361fd99a4040$export$30d3455eee55bed5,
    circOut: $66a2361fd99a4040$export$c8d67a19199d1a50,
    backIn: $a7ddcde2a4282efd$export$b01116c84cdfe1a2,
    backInOut: $a7ddcde2a4282efd$export$ddc5fd596f6c71b2,
    backOut: $a7ddcde2a4282efd$export$77edfce482316a60,
    anticipate: $5e5a5cfe1fa796ef$export$6b0af63b873d419e
};
const $15a4078bfbf4856a$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $bf99d85f7a843912$export$f5708dca728d7177)($15a4078bfbf4856a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $15a4078bfbf4856a$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ded99e01d9b518c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (0, $9d068be114f1d873$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ded99e01d9b518c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $9d068be114f1d873$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $c79d1e7d77418d04$var$clampRgbUnit = (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 255, v);
const $c79d1e7d77418d04$export$7a99c86b5b1f4c9e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: (v)=>Math.round($c79d1e7d77418d04$var$clampRgbUnit(v))
};
const $c79d1e7d77418d04$export$4e46ac54fc82cf3b = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $875e9bff470aaa65$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875e9bff470aaa65$export$834dfc94dde4b3d8 = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("#"),
    parse: $875e9bff470aaa65$var$parseHex,
    transform: (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform
};






const $8bf8a43b3506d305$export$810b04175080204c = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d8fe6ea9e8bd3d9c$export$35e9368ef982300f = {
    test: (v)=>(0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v) || (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).test(v) || (0, $8bf8a43b3506d305$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v)) return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $8bf8a43b3506d305$export$810b04175080204c).test(v)) return (0, $8bf8a43b3506d305$export$810b04175080204c).parse(v);
        else return (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $9d068be114f1d873$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(v) : (0, $8bf8a43b3506d305$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $70c54e935a247717$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $fd6f5ba04ea8bac3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue);
        blue = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $7691d9e96675321f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $7691d9e96675321f$var$colorTypes = [
    (0, $875e9bff470aaa65$export$834dfc94dde4b3d8),
    (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b),
    (0, $8bf8a43b3506d305$export$810b04175080204c)
];
const $7691d9e96675321f$var$getColorType = (v)=>$7691d9e96675321f$var$colorTypes.find((type)=>type.test(v));
function $7691d9e96675321f$var$asRGBA(color) {
    const type = $7691d9e96675321f$var$getColorType(color);
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $8bf8a43b3506d305$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $7691d9e96675321f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $7691d9e96675321f$var$asRGBA(from);
    const toRGBA = $7691d9e96675321f$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $b7b50ce2c2d54405$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (((_a = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $b7b50ce2c2d54405$var$cssVarTokeniser = {
    regex: (0, $f9c5e88311214d2a$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $448ce039afb5ec07$export$8793edee2d425525)
};
const $b7b50ce2c2d54405$var$colorTokeniser = {
    regex: (0, $9d068be114f1d873$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).parse
};
const $b7b50ce2c2d54405$var$numberTokeniser = {
    regex: (0, $9d068be114f1d873$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $965bce4b5aab9d94$export$98e628dec113755e).parse
};
function $b7b50ce2c2d54405$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $b7b50ce2c2d54405$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$cssVarTokeniser);
    $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$colorTokeniser);
    $b7b50ce2c2d54405$var$tokenise(info, $b7b50ce2c2d54405$var$numberTokeniser);
    return info;
}
function $b7b50ce2c2d54405$var$parseComplexValue(v) {
    return $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v).values;
}
function $b7b50ce2c2d54405$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $b7b50ce2c2d54405$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($b7b50ce2c2d54405$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($b7b50ce2c2d54405$var$colorTokeniser.token, (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($b7b50ce2c2d54405$var$numberTokeniser.token, (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $b7b50ce2c2d54405$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b7b50ce2c2d54405$var$getAnimatableNone(v) {
    const parsed = $b7b50ce2c2d54405$var$parseComplexValue(v);
    const transformer = $b7b50ce2c2d54405$var$createTransformer(v);
    return transformer(parsed.map($b7b50ce2c2d54405$var$convertNumbersToZero));
}
const $b7b50ce2c2d54405$export$83a0e34f1302825b = {
    test: $b7b50ce2c2d54405$var$test,
    parse: $b7b50ce2c2d54405$var$parseComplexValue,
    createTransformer: $b7b50ce2c2d54405$var$createTransformer,
    getAnimatableNone: $b7b50ce2c2d54405$var$getAnimatableNone
};


const $6ec69123567a0d66$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $6ec69123567a0d66$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(origin)) return (0, $7691d9e96675321f$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $6ec69123567a0d66$var$mixImmediate(origin, target) : $6ec69123567a0d66$export$65516310a87d8205(origin, target);
}
const $6ec69123567a0d66$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$6ec69123567a0d66$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $6ec69123567a0d66$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $6ec69123567a0d66$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $6ec69123567a0d66$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $21841eadb135946f$export$a4627e546088548d)($6ec69123567a0d66$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $bf99d85f7a843912$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $6ec69123567a0d66$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $3a28fe0c82ae45f8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $ec602dd05d6627bc$var$mixNumber = (from, to)=>(p)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(from, to, p);
function $ec602dd05d6627bc$var$detectMixerFactory(v) {
    if (typeof v === "number") return $ec602dd05d6627bc$var$mixNumber;
    else if (typeof v === "string") return (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(v) ? (0, $7691d9e96675321f$export$51e568cf5c039bac) : (0, $6ec69123567a0d66$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $6ec69123567a0d66$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $6ec69123567a0d66$export$ebc23b6840c51ba1;
    return $ec602dd05d6627bc$var$mixNumber;
}
function $ec602dd05d6627bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $ec602dd05d6627bc$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $448ce039afb5ec07$export$8793edee2d425525) : ease;
            mixer = (0, $21841eadb135946f$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec602dd05d6627bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec602dd05d6627bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a4ecf42dec726852$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $481477152292f1a1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a4ecf42dec726852$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $d61eba3ef0284b9c$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c24ef35c6cea05c0$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $b8e36ee1e1d53e83$export$216948827bbdc797)(ease) ? ease.map((0, $15a4078bfbf4856a$export$ef97fe084f156ca4)) : (0, $15a4078bfbf4856a$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d61eba3ef0284b9c$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $481477152292f1a1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $acbc43562ac6dbd8$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $8896dd99c5adcd8e$var$velocitySampleDuration = 5; // ms
function $8896dd99c5adcd8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $8896dd99c5adcd8e$var$velocitySampleDuration, 0);
    return (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $18564078b4b5453e$var$safeMin = 0.001;
const $18564078b4b5453e$export$a3cdb76e84ee608e = 0.01;
const $18564078b4b5453e$export$1824b851fad8862b = 10.0;
const $18564078b4b5453e$export$ff08f2d53484465 = 0.05;
const $18564078b4b5453e$export$201ca48e54038115 = 1;
function $18564078b4b5453e$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $bf99d85f7a843912$export$491112666e282270)(duration <= (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)($18564078b4b5453e$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$ff08f2d53484465, $18564078b4b5453e$export$201ca48e54038115, dampingRatio);
    duration = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$a3cdb76e84ee608e, $18564078b4b5453e$export$1824b851fad8862b, (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $18564078b4b5453e$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $18564078b4b5453e$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $18564078b4b5453e$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$18564078b4b5453e$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $18564078b4b5453e$var$rootIterations = 12;
function $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $18564078b4b5453e$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $74970353647274e4$var$durationKeys = [
    "duration",
    "bounce"
];
const $74970353647274e4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $74970353647274e4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $74970353647274e4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$74970353647274e4$var$isSpringType(options, $74970353647274e4$var$physicsKeys) && $74970353647274e4$var$isSpringType(options, $74970353647274e4$var$durationKeys)) {
        const derived = (0, $18564078b4b5453e$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $74970353647274e4$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $74970353647274e4$var$getSpringOptions({
        ...options,
        velocity: -(0, $083454c8244247d6$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $18564078b4b5453e$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $8896dd99c5adcd8e$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $32590f88ff47d1eb$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $74970353647274e4$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $8896dd99c5adcd8e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $cf38d8859c00efa2$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing ? (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $506ba0ac589a486f$export$f4ff70a5b4808fd8 = 20000;
function $506ba0ac589a486f$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $506ba0ac589a486f$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $506ba0ac589a486f$export$f4ff70a5b4808fd8 ? Infinity : duration;
}



const $f8b512b91d9f08e1$var$types = {
    decay: (0, $32590f88ff47d1eb$export$ee3ff3a17106998),
    inertia: $32590f88ff47d1eb$export$ee3ff3a17106998,
    tween: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    keyframes: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    spring: $74970353647274e4$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $f8b512b91d9f08e1$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $cf38d8859c00efa2$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $f8b512b91d9f08e1$var$types[type] || (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $af0183976178f4ae$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $132e6771f76a8482$var$supportsWaapi = (0, $af0183976178f4ae$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $132e6771f76a8482$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $132e6771f76a8482$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $132e6771f76a8482$var$maxDuration = 20000;
const $132e6771f76a8482$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $877fa42e69510d34$export$fcdd8f3f2160beda)(options.ease);
function $132e6771f76a8482$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $132e6771f76a8482$var$supportsWaapi() && $132e6771f76a8482$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Cancelling an animation will write to the DOM. For safety we want to defer
     * this until the next `update` frame lifecycle. This flag tracks whether we
     * have a pending cancel, if so we shouldn't allow animations to finish.
     */ let pendingCancel = false;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($132e6771f76a8482$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $132e6771f76a8482$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $132e6771f76a8482$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $132e6771f76a8482$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $db913f3e2f893030$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    const cancelAnimation = ()=>{
        pendingCancel = false;
        animation.cancel();
    };
    const safeCancel = ()=>{
        pendingCancel = true;
        (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        if (pendingCancel) return;
        value.set((0, $b7455746a6cabbfe$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $448ce039afb5ec07$export$8793edee2d425525;
        },
        get time () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $132e6771f76a8482$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $132e6771f76a8482$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>{
            if (pendingCancel) return;
            animation.finish();
        },
        cancel: safeCancel
    };
    return controls;
}




function $8aad9a13037709d9$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $448ce039afb5ec07$export$8793edee2d425525),
            pause: (0, $448ce039afb5ec07$export$8793edee2d425525),
            stop: (0, $448ce039afb5ec07$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $448ce039afb5ec07$export$8793edee2d425525),
            complete: (0, $448ce039afb5ec07$export$8793edee2d425525)
        };
    };
    return delay ? (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $5f1d5ca1d398e82d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $5f1d5ca1d398e82d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $5f1d5ca1d398e82d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $5f1d5ca1d398e82d$var$criticallyDampedSpring(keyframes[1]) : $5f1d5ca1d398e82d$var$underDampedSpring;
    return $5f1d5ca1d398e82d$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ef4086713d7b0bdb$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $c55938f2e5f09a1e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c55938f2e5f09a1e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9d068be114f1d873$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c55938f2e5f09a1e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c55938f2e5f09a1e$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $c55938f2e5f09a1e$export$3dea766d36a8935f = {
    ...(0, $b7b50ce2c2d54405$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c55938f2e5f09a1e$var$functionRegex);
        return functions ? functions.map($c55938f2e5f09a1e$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = {
    ...(0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b),
    color: // Color props
    $d8fe6ea9e8bd3d9c$export$35e9368ef982300f,
    backgroundColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    outlineColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    fill: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    stroke: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderTopColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderRightColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderBottomColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderLeftColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    filter: $c55938f2e5f09a1e$export$3dea766d36a8935f,
    WebkitFilter: (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6da1de6e0a9a8c9d$export$67d1babe0338d23b = (key)=>$6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];


function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)) defaultValueType = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $933209bc9c035719$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $e0feaef7a76d9154$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value);
}


function $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $e0feaef7a76d9154$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $f69e8e67d72e77c2$export$dd826089e3c5e502 = {
    skipAnimations: false
};


const $9e7a9f8af70c9aa6$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $bf99d85f7a843912$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $77818709e1bb6833$export$888a3d84909f9e3d).current || valueTransition.type === false || (0, $f69e8e67d72e77c2$export$dd826089e3c5e502).skipAnimations) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $8aad9a13037709d9$export$6f34fc8ef6c42b70)((0, $77818709e1bb6833$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (/**
         * If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $132e6771f76a8482$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $f8b512b91d9f08e1$export$ee9b76de7353d815)(options);
    };
};



function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $55c3387a92452647$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $d56714d1e4e43615$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ad746ac6e5aa4783$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $e32104bb79321603$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $e32104bb79321603$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $e32104bb79321603$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.18.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($e32104bb79321603$export$67fcd818a264039d.current) $e32104bb79321603$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $e32104bb79321603$export$ce8bdc721e76545f(init, options) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $a1e2618328995be8$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $965bce4b5aab9d94$export$98e628dec113755e),
    (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    (0, $25ca921ba8e55794$export$626336c2cd4b14de),
    (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    (0, $25ca921ba8e55794$export$aed3d7b7d206c196),
    (0, $25ca921ba8e55794$export$f91e8c45a95a32f2),
    (0, $c231a4375b038d3c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a90ec5e4ad59372f$export$eefdd52e3ccae428 = (v)=>$a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $0bb49f6c51badae3$var$valueTypes = [
    ...(0, $a90ec5e4ad59372f$export$d176691c1998a1f5),
    (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $0bb49f6c51badae3$export$950e7e59ea1ffed7 = (v)=>$0bb49f6c51badae3$var$valueTypes.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $21f654501c04362b$export$5485128c47bd48bb)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}
function $ea04fe669600292a$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $ea04fe669600292a$var$setVariants(child, variantLabels);
        });
    });
}
function $ea04fe669600292a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ea04fe669600292a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ea04fe669600292a$var$setVariants(visualElement, [
        definition
    ]);
    else $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition);
}
function $ea04fe669600292a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $d56714d1e4e43615$export$65583ed5a868f2d9)(value) || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $0bb49f6c51badae3$export$950e7e59ea1ffed7)(value) && (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(targetValue)) value = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $ea04fe669600292a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ea04fe669600292a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $ea04fe669600292a$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}




/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $14d5e29c1a7af8ca$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $14d5e29c1a7af8ca$var$hasKeyframesChanged(value, target) {
    const current = value.get();
    if (Array.isArray(target)) for(let i = 0; i < target.length; i++){
        if (target[i] !== current) return true;
    }
    else return current !== target;
}
function $14d5e29c1a7af8ca$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $14d5e29c1a7af8ca$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations) {
            const appearId = visualElement.getProps()[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $9f96722ff12dbfe7$export$2cef06c20297c17d));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    valueTransition.isHandoff = true;
                }
            }
        }
        let canSkip = !valueTransition.isHandoff && !$14d5e29c1a7af8ca$var$hasKeyframesChanged(value, valueTarget);
        if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) canSkip = false;
        /**
         * Temporarily disable skipping animations if there's an animation in
         * progress. Better would be to track the current target of a value
         * and compare that against valueTarget.
         */ if (value.animation) canSkip = false;
        if (canSkip) continue;
        value.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $697c3fc694c39c2d$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($697c3fc694c39c2d$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($697c3fc694c39c2d$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $697c3fc694c39c2d$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $7d7d5f8a14d3a662$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...(0, $0172fb3d3512f551$export$16e45afcc206d3a8)
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = (0, $0172fb3d3512f551$export$16e45afcc206d3a8).length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $7d7d5f8a14d3a662$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    const state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a35be4d5814e7c66$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        animate: $351ff45a987b08cc$var$createTypeState(true),
        whileInView: $351ff45a987b08cc$var$createTypeState(),
        whileHover: $351ff45a987b08cc$var$createTypeState(),
        whileTap: $351ff45a987b08cc$var$createTypeState(),
        whileDrag: $351ff45a987b08cc$var$createTypeState(),
        whileFocus: $351ff45a987b08cc$var$createTypeState(),
        exit: $351ff45a987b08cc$var$createTypeState()
    };
}



class $bfc36aed86970b83$export$b45b3fe5caabdca extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $7ad505f20eee7073$var$id = 0;
class $7ad505f20eee7073$export$4989d1eb6104cc6c extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $7ad505f20eee7073$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bfc36aed86970b83$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $7ad505f20eee7073$export$4989d1eb6104cc6c)
    }
};









const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $2bb1a5b2e1002b2e$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2bb1a5b2e1002b2e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $8eeaeb5692ba8175$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $2bb1a5b2e1002b2e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        const initialInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2bb1a5b2e1002b2e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $21841eadb135946f$export$a4627e546088548d)((0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $2bb1a5b2e1002b2e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2bb1a5b2e1002b2e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2bb1a5b2e1002b2e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$lastDevicePoint(history)),
        offset: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$startDevicePoint(history)),
        velocity: $2bb1a5b2e1002b2e$var$getVelocity(history, 0.1)
    };
}
function $2bb1a5b2e1002b2e$var$startDevicePoint(history) {
    return history[0];
}
function $2bb1a5b2e1002b2e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2bb1a5b2e1002b2e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2bb1a5b2e1002b2e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    const targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });


function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $d8332eb74969584e$var$snapToDefault(treeScale.x);
    treeScale.y = $d8332eb74969584e$var$snapToDefault(treeScale.y);
}
function $d8332eb74969584e$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d8332eb74969584e$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d8332eb74969584e$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform, $d8332eb74969584e$var$xKeys);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform, $d8332eb74969584e$var$yKeys);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $763b481d779908b7$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};



const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $df8cc4eab047d382$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $763b481d779908b7$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $abae7830ca84eed8$export$5d97dc2872682820 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.controls = new (0, $59924ee873defaad$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $d43ff984f7bd7f1a$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $763b481d779908b7$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanSessionStart),
            onStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $eced91e16bda42df$export$de9e7791c71225fd)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $967b202c839557ef$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};








const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $70c54e935a247717$export$2c9e8a9632a706b2)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(leadRadius) || (0, $25ca921ba8e55794$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $66a2361fd99a4040$export$c8d67a19199d1a50));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $448ce039afb5ec07$export$8793edee2d425525));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $b070f9c5f268d45c$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.x) / (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.y);
}



class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
}



function $0b58405220d0640d$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $c4715fe9f944e8b8$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $f5de8fc8cd768a38$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value : (0, $e32104bb79321603$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $d2ca41ba1b84bcfe$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $d2ca41ba1b84bcfe$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes = $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas = $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
                this.nodes.forEach($d2ca41ba1b84bcfe$export$c2664f37bc951031);
                (0, $0b58405220d0640d$export$e5185e241753e543)($d2ca41ba1b84bcfe$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $c4715fe9f944e8b8$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $fab50a206e6cc096$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $b070f9c5f268d45c$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d2ca41ba1b84bcfe$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($d2ca41ba1b84bcfe$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).delta = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp);
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp = now;
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = true;
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).update.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).preRender.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).render.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $f5de8fc8cd768a38$export$335a17c977067b99)(0, $d2ca41ba1b84bcfe$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const xLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                const key = "rotate" + $d2ca41ba1b84bcfe$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $d2ca41ba1b84bcfe$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $b070f9c5f268d45c$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d2ca41ba1b84bcfe$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetRotation(node) {
    node.resetRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $d2ca41ba1b84bcfe$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $d2ca41ba1b84bcfe$var$roundPoint = $d2ca41ba1b84bcfe$var$userAgentContains("applewebkit/") && !$d2ca41ba1b84bcfe$var$userAgentContains("chrome/") ? Math.round : (0, $448ce039afb5ec07$export$8793edee2d425525);
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $d2ca41ba1b84bcfe$var$roundPoint(axis.min);
    axis.max = $d2ca41ba1b84bcfe$var$roundPoint(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $b352f7cdd42c49d7$export$28d0384c4b79bde2)((0, $b070f9c5f268d45c$export$c5706146bc63213)(snapshot), (0, $b070f9c5f268d45c$export$c5706146bc63213)(layout), 0.2);
}




const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $abae7830ca84eed8$export$5d97dc2872682820),
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};













/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ac0e5a3978f40f61$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    const match = $ac0e5a3978f40f61$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$var$getVariableValue(current, element, depth = 1) {
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(depth <= $ac0e5a3978f40f61$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $d56714d1e4e43615$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $f9c5e88311214d2a$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ac0e5a3978f40f61$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ac0e5a3978f40f61$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) return;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) continue;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $a731b8aa4fe311d9$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $a731b8aa4fe311d9$var$isPositionalKey = (key)=>$a731b8aa4fe311d9$var$positionalKeys.has(key);
const $a731b8aa4fe311d9$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($a731b8aa4fe311d9$var$isPositionalKey);
};
const $a731b8aa4fe311d9$var$isNumOrPxType = (v)=>v === (0, $965bce4b5aab9d94$export$98e628dec113755e) || v === (0, $25ca921ba8e55794$export$91c0eda1d06bf008);
const $a731b8aa4fe311d9$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a731b8aa4fe311d9$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $ac502869c4d3e65a$export$280dc01950909d86).filter((key)=>!$a731b8aa4fe311d9$var$transformKeys.has(key));
function $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateX = $a731b8aa4fe311d9$export$781d46a8aa670d52.x;
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateY = $a731b8aa4fe311d9$export$781d46a8aa670d52.y;
const $a731b8aa4fe311d9$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($a731b8aa4fe311d9$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]);
                    (0, $bf99d85f7a843912$export$f5708dca728d7177)(toType === fromType || $a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $bf99d85f7a843912$export$f5708dca728d7177)((0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $25ca921ba8e55794$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $a731b8aa4fe311d9$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $784730508f12f72c$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a731b8aa4fe311d9$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a731b8aa4fe311d9$var$hasPositionalKey(target) ? $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $d9a589b84d5ec1d1$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $ac0e5a3978f40f61$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $a731b8aa4fe311d9$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};


function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = false;
}














function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $55c3387a92452647$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $a4ccbde0d696dfdf$export$bc2a978a17abfdde = new WeakMap();



const $e66750f3fb0f96bb$var$featureNames = Object.keys((0, $a8d82256030e9525$export$65570e08d843624d));
const $e66750f3fb0f96bb$var$numFeatures = $e66750f3fb0f96bb$var$featureNames.length;
const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $e66750f3fb0f96bb$var$numVariantProps = (0, $0172fb3d3512f551$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $55c3387a92452647$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current) (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $e66750f3fb0f96bb$var$numFeatures; i++){
            const name = $e66750f3fb0f96bb$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $a8d82256030e9525$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e66750f3fb0f96bb$var$numVariantProps; i++){
            const name = (0, $0172fb3d3512f551$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $a35be4d5814e7c66$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $e32104bb79321603$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $55c3387a92452647$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $e66750f3fb0f96bb$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $ea04fe669600292a$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $ea04fe669600292a$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $d9a589b84d5ec1d1$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $eac085b45c9e0925$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? new (0, $a0798b9f9973cb35$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $bce82b8bf0dbf6b7$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $2c407ffdaf3c120a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};


const $a93b6401f922fd1e$var$preloadedFeatures = {
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2c407ffdaf3c120a$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $16a09bb264d348bb$export$a28d6df673050e18)((Component, config)=>(0, $73e3a8d89278ed7b$export$732916c0e88175fb)(Component, config, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)((0, $73e3a8d89278ed7b$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
}


function $1a40c751dd310c2b$var$Navigation({ isOpen: isOpen, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        className: "navigation-panel",
        initial: {
            opacity: 0,
            y: "-120%"
        },
        animate: {
            opacity: isOpen ? 1 : 0,
            y: isOpen ? 0 : "-120%"
        },
        exit: {
            opacity: 0,
            y: "-120%"
        },
        transition: {
            type: "tween",
            damping: 15,
            stiffness: 100
        },
        children: children
    });
}
var $1a40c751dd310c2b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($1a40c751dd310c2b$var$Navigation);




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $6cdb796ffe249f75$var$__assign = function() {
    $6cdb796ffe249f75$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6cdb796ffe249f75$var$__assign.apply(this, arguments);
};
function $6cdb796ffe249f75$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $6cdb796ffe249f75$var$hashFragment = '';
var $6cdb796ffe249f75$var$observer = null;
var $6cdb796ffe249f75$var$asyncTimerId = null;
var $6cdb796ffe249f75$var$scrollFunction = null;
function $6cdb796ffe249f75$var$reset() {
    $6cdb796ffe249f75$var$hashFragment = '';
    if ($6cdb796ffe249f75$var$observer !== null) $6cdb796ffe249f75$var$observer.disconnect();
    if ($6cdb796ffe249f75$var$asyncTimerId !== null) {
        window.clearTimeout($6cdb796ffe249f75$var$asyncTimerId);
        $6cdb796ffe249f75$var$asyncTimerId = null;
    }
}
function $6cdb796ffe249f75$var$isInteractiveElement(element) {
    var formTags = [
        'BUTTON',
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    var linkTags = [
        'A',
        'AREA'
    ];
    return formTags.includes(element.tagName) && !element.hasAttribute('disabled') || linkTags.includes(element.tagName) && element.hasAttribute('href');
}
function $6cdb796ffe249f75$var$getElAndScroll() {
    var element = null;
    if ($6cdb796ffe249f75$var$hashFragment === '#') // use document.body instead of document.documentElement because of a bug in smoothscroll-polyfill in safari
    // see https://github.com/iamdustan/smoothscroll/issues/138
    // while smoothscroll-polyfill is not included, it is the recommended way to implement smoothscroll
    // in browsers that don't natively support el.scrollIntoView({ behavior: 'smooth' })
    element = document.body;
    else {
        // check for element with matching id before assume '#top' is the top of the document
        // see https://html.spec.whatwg.org/multipage/browsing-the-web.html#target-element
        var id = $6cdb796ffe249f75$var$hashFragment.replace('#', '');
        element = document.getElementById(id);
        if (element === null && $6cdb796ffe249f75$var$hashFragment === '#top') // see above comment for why document.body instead of document.documentElement
        element = document.body;
    }
    if (element !== null) {
        $6cdb796ffe249f75$var$scrollFunction(element);
        // update focus to where the page is scrolled to
        // unfortunately this doesn't work in safari (desktop and iOS) when blur() is called
        var originalTabIndex = element.getAttribute('tabindex');
        if (originalTabIndex === null && !$6cdb796ffe249f75$var$isInteractiveElement(element)) element.setAttribute('tabindex', -1);
        element.focus({
            preventScroll: true
        });
        if (originalTabIndex === null && !$6cdb796ffe249f75$var$isInteractiveElement(element)) {
            // for some reason calling blur() in safari resets the focus region to where it was previously,
            // if blur() is not called it works in safari, but then are stuck with default focus styles
            // on an element that otherwise might never had focus styles applied, so not an option
            element.blur();
            element.removeAttribute('tabindex');
        }
        $6cdb796ffe249f75$var$reset();
        return true;
    }
    return false;
}
function $6cdb796ffe249f75$var$hashLinkScroll(timeout) {
    // Push onto callback queue so it runs after the DOM is updated
    window.setTimeout(function() {
        if ($6cdb796ffe249f75$var$getElAndScroll() === false) {
            if ($6cdb796ffe249f75$var$observer === null) $6cdb796ffe249f75$var$observer = new MutationObserver($6cdb796ffe249f75$var$getElAndScroll);
            $6cdb796ffe249f75$var$observer.observe(document, {
                attributes: true,
                childList: true,
                subtree: true
            });
            // if the element doesn't show up in specified timeout or 10 seconds, stop checking
            $6cdb796ffe249f75$var$asyncTimerId = window.setTimeout(function() {
                $6cdb796ffe249f75$var$reset();
            }, timeout || 10000);
        }
    }, 0);
}
function $6cdb796ffe249f75$export$68b36bde1041b215(As) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        var linkHash = '';
        if (typeof props.to === 'string' && props.to.includes('#')) linkHash = "#" + props.to.split('#').slice(1).join('#');
        else if (typeof props.to === 'object' && typeof props.to.hash === 'string') linkHash = props.to.hash;
        var passDownProps = {};
        if (As === (0, $040dbb9c344a508d$export$b0d92dbee9b5b60d)) passDownProps.isActive = function(match, location) {
            return match && match.isExact && location.hash === linkHash;
        };
        function handleClick(e) {
            $6cdb796ffe249f75$var$reset();
            $6cdb796ffe249f75$var$hashFragment = props.elementId ? "#" + props.elementId : linkHash;
            if (props.onClick) props.onClick(e);
            if ($6cdb796ffe249f75$var$hashFragment !== '' && // ignore non-vanilla click events, same as react-router
            // below logic adapted from react-router: https://github.com/ReactTraining/react-router/blob/fc91700e08df8147bd2bb1be19a299cbb14dbcaa/packages/react-router-dom/modules/Link.js#L43-L48
            !e.defaultPrevented && // onClick prevented default
            e.button === 0 && // ignore everything but left clicks
            (!props.target || props.target === '_self') && // let browser handle "target=_blank" etc
            !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey // ignore clicks with modifier keys
            )) {
                $6cdb796ffe249f75$var$scrollFunction = props.scroll || function(el) {
                    return props.smooth ? el.scrollIntoView({
                        behavior: 'smooth'
                    }) : el.scrollIntoView();
                };
                $6cdb796ffe249f75$var$hashLinkScroll(props.timeout);
            }
        }
        var filteredProps = $6cdb796ffe249f75$var$__rest(props, [
            "scroll",
            "smooth",
            "timeout",
            "elementId"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(As, $6cdb796ffe249f75$var$__assign({}, passDownProps, filteredProps, {
            onClick: handleClick,
            ref: ref
        }), props.children);
    });
}
var $6cdb796ffe249f75$export$4ca9840115f43bad = $6cdb796ffe249f75$export$68b36bde1041b215((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a));
var $6cdb796ffe249f75$export$137982c271569408 = $6cdb796ffe249f75$export$68b36bde1041b215((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d));
var $6cdb796ffe249f75$var$propTypes;



function $e91257f7345c1a13$var$NavigationList({ onClick: onClick }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                    to: "#about",
                    onClick: onClick,
                    children: "about"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                    to: "#menu",
                    onClick: onClick,
                    children: "menu"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "https://angust.order.tryperdiem.com/order",
                    children: "order"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                    to: "#career",
                    onClick: onClick,
                    children: "career"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                    to: "#contact-locations",
                    onClick: onClick,
                    children: "contact"
                })
            })
        ]
    });
}
var $e91257f7345c1a13$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($e91257f7345c1a13$var$NavigationList);



var $af540f293314ba66$exports = {};
'use strict';
function $af540f293314ba66$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $af540f293314ba66$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $af540f293314ba66$var$_unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af540f293314ba66$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $af540f293314ba66$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $af540f293314ba66$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $af540f293314ba66$var$shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $af540f293314ba66$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $af540f293314ba66$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var _i = 0, _keysA = keysA; _i < _keysA.length; _i++){
        var keyA = _keysA[_i];
        if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) return false;
    }
    return true;
}
var $af540f293314ba66$var$shallow = function(objA, objB) {
    return $af540f293314ba66$var$shallow$1(objA, objB);
};
$af540f293314ba66$exports.default = $af540f293314ba66$var$shallow;
$af540f293314ba66$exports.shallow = $af540f293314ba66$var$shallow$1;
$af540f293314ba66$exports = $af540f293314ba66$var$shallow;
$af540f293314ba66$exports.shallow = $af540f293314ba66$var$shallow$1;
$af540f293314ba66$exports.default = $af540f293314ba66$exports;


var $6d940318c7b48507$export$c883e057baa24e24;
var $6d940318c7b48507$export$2951cba41945c0c8;
'use strict';

var $acw62 = parcelRequire("acw62");
var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("i5mAx"));


var $daecaa38e3584fd1$exports = {};
'use strict';
var $daecaa38e3584fd1$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $daecaa38e3584fd1$var$createStore = function createStore(createState) {
    return createState ? $daecaa38e3584fd1$var$createStoreImpl(createState) : $daecaa38e3584fd1$var$createStoreImpl;
};
var $daecaa38e3584fd1$var$vanilla = function(createState) {
    return $daecaa38e3584fd1$var$createStore(createState);
};
$daecaa38e3584fd1$exports.createStore = $daecaa38e3584fd1$var$createStore;
$daecaa38e3584fd1$exports.default = $daecaa38e3584fd1$var$vanilla;
$daecaa38e3584fd1$exports = $daecaa38e3584fd1$var$vanilla;
$daecaa38e3584fd1$exports.createStore = $daecaa38e3584fd1$var$createStore;
$daecaa38e3584fd1$exports.default = $daecaa38e3584fd1$exports;


var $6d940318c7b48507$var$useDebugValue = $acw62.useDebugValue;
var $6d940318c7b48507$var$useSyncExternalStoreWithSelector = $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector;
var $6d940318c7b48507$var$identity = function identity(arg) {
    return arg;
};
function $6d940318c7b48507$var$useStoreWithEqualityFn(api, selector, equalityFn) {
    if (selector === void 0) selector = $6d940318c7b48507$var$identity;
    var slice = $6d940318c7b48507$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $6d940318c7b48507$var$useDebugValue(slice);
    return slice;
}
var $6d940318c7b48507$var$createWithEqualityFnImpl = function createWithEqualityFnImpl(createState, defaultEqualityFn) {
    var api = $daecaa38e3584fd1$exports.createStore(createState);
    var useBoundStoreWithEqualityFn = function useBoundStoreWithEqualityFn(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = defaultEqualityFn;
        return $6d940318c7b48507$var$useStoreWithEqualityFn(api, selector, equalityFn);
    };
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
var $6d940318c7b48507$var$createWithEqualityFn = function createWithEqualityFn(createState, defaultEqualityFn) {
    return createState ? $6d940318c7b48507$var$createWithEqualityFnImpl(createState, defaultEqualityFn) : $6d940318c7b48507$var$createWithEqualityFnImpl;
};
$6d940318c7b48507$export$c883e057baa24e24 = $6d940318c7b48507$var$createWithEqualityFn;
$6d940318c7b48507$export$2951cba41945c0c8 = $6d940318c7b48507$var$useStoreWithEqualityFn;


var $6901b3de930503c1$export$428de7ec69ac95c;
'use strict';
var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$getPrototypeOf = Object.getPrototypeOf;
function $5f9e38360d79f95a$export$541ac630993a4c84(value) {
    return !!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
}
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || Array.isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = Object.prototype.constructor.toString();
var $5f9e38360d79f95a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null || proto === Object.prototype) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    if (typeof Ctor !== "function") return false;
    let ctorString = $5f9e38360d79f95a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $5f9e38360d79f95a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter, strict = true) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : Object.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $5f9e38360d79f95a$var$has(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $5f9e38360d79f95a$var$get(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $5f9e38360d79f95a$var$set(thing, propOrOldValue, value) {
    const t = $5f9e38360d79f95a$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5f9e38360d79f95a$var$isMap(target) {
    return target instanceof Map;
}
function $5f9e38360d79f95a$var$isSet(target) {
    return target instanceof Set;
}
function $5f9e38360d79f95a$var$latest(state) {
    return state.copy_ || state.base_;
}
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) Object.defineProperties(obj, {
        set: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        add: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        clear: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        delete: $5f9e38360d79f95a$var$dontMutateMethodOverride
    });
    Object.freeze(obj);
    if (deep) Object.values(obj).forEach((value)=>$5f9e38360d79f95a$export$792f3d81ea979f55(value, true));
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
var $5f9e38360d79f95a$var$dontMutateMethodOverride = {
    value: $5f9e38360d79f95a$var$dontMutateFrozenCollections
};
function $5f9e38360d79f95a$var$isFrozen(obj) {
    if (obj === null || typeof obj !== "object") return true;
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
function $5f9e38360d79f95a$var$getCurrentScope() {
    return $5f9e38360d79f95a$var$currentScope;
}
function $5f9e38360d79f95a$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $5f9e38360d79f95a$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
function $5f9e38360d79f95a$var$enterScope(immer2) {
    return $5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
}
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) {
            result = $5f9e38360d79f95a$var$finalize(scope, result);
            if (!scope.parent_) $5f9e38360d79f95a$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft, []);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value, path) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const useStrictIteration = rootScope.immer_.shouldUseStrictIteration();
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        $5f9e38360d79f95a$var$each(value, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, value, key, childValue, path), useStrictIteration);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $5f9e38360d79f95a$var$each(resultEach, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2), useStrictIteration);
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (childValue == null) return;
    if (typeof childValue !== "object" && !targetIsSet) return;
    const childIsFrozen = $5f9e38360d79f95a$var$isFrozen(childValue);
    if (childIsFrozen && !targetIsSet) return;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$5f9e38360d79f95a$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $5f9e38360d79f95a$var$finalize(rootScope, childValue, path);
        $5f9e38360d79f95a$var$set(targetObject, prop, res);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($5f9e38360d79f95a$export$16e3aed3edb85946(childValue) && !childIsFrozen) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        if (parentState && parentState.base_ && parentState.base_[prop] === childValue && childIsFrozen) return;
        $5f9e38360d79f95a$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && ($5f9e38360d79f95a$var$isMap(targetObject) ? targetObject.has(prop) : Object.prototype.propertyIsEnumerable.call(targetObject, prop))) $5f9e38360d79f95a$var$maybeFreeze(rootScope, childValue);
    }
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            return state.copy_[prop] = $5f9e38360d79f95a$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
$5f9e38360d79f95a$var$each($5f9e38360d79f95a$var$objectTraps, (key, fn)=>{
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = true;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (typeof (config == null ? void 0 : config.useStrictIteration) === "boolean") this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin("Patches").applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(value, parent) {
    const draft = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key);
            const value = $5f9e38360d79f95a$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (typeof base !== "object") $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    $5f9e38360d79f95a$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$1045b3be3904c489 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictIteration.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
function $5f9e38360d79f95a$export$c05b21e3257751e5(value) {
    return value;
}
function $5f9e38360d79f95a$export$20f911b3f8cf0b74(value) {
    return value;
}


var $6901b3de930503c1$var$immerImpl = function immerImpl(initializer) {
    return function(set, get, store) {
        store.setState = function(updater, replace) {
            var nextState = typeof updater === 'function' ? $5f9e38360d79f95a$export$b46cabe22e78bc00(updater) : updater;
            for(var _len = arguments.length, a = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)a[_key - 2] = arguments[_key];
            return set.apply(void 0, [
                nextState,
                replace
            ].concat(a));
        };
        return initializer(store.setState, get, store);
    };
};
var $6901b3de930503c1$var$immer = $6901b3de930503c1$var$immerImpl;
$6901b3de930503c1$export$428de7ec69ac95c = $6901b3de930503c1$var$immer;







class $d07b9a140ad50c23$export$a06cf8c0066f0d4c extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($d07b9a140ad50c23$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $d07b9a140ad50c23$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $d07b9a140ad50c23$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $d07b9a140ad50c23$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($d07b9a140ad50c23$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $f8b865b18d670cc6$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $f8b865b18d670cc6$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $f8b865b18d670cc6$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $f8b865b18d670cc6$export$6acf61af03e62db) || this.options.enabled === false || !(0, $f8b865b18d670cc6$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $d07b9a140ad50c23$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $d07b9a140ad50c23$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $cd25260720ff3eef$export$61b92f63f30245cf)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === 'success',
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $d07b9a140ad50c23$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, $cd25260720ff3eef$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
}
function $d07b9a140ad50c23$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $d07b9a140ad50c23$var$shouldFetchOnMount(query, options) {
    return $d07b9a140ad50c23$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $d07b9a140ad50c23$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $d07b9a140ad50c23$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $d07b9a140ad50c23$var$isStale(query, options);
    }
    return false;
}
function $d07b9a140ad50c23$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $d07b9a140ad50c23$var$isStale(query, options);
}
function $d07b9a140ad50c23$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $d07b9a140ad50c23$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



var $acw62 = parcelRequire("acw62");


var $hfliI = parcelRequire("hfliI");
'use client';
const $cb54322a339eb896$export$306c0aa65ff9ec16 = (0, $hfliI.useSyncExternalStore);



var $acw62 = parcelRequire("acw62");
'use client';
function $d8c18f57bc93d04e$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $acw62.createContext($d8c18f57bc93d04e$var$createValue()); // HOOK
const $d8c18f57bc93d04e$export$50dfac555130cafd = ()=>$acw62.useContext($d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext); // COMPONENT
const $d8c18f57bc93d04e$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$d8c18f57bc93d04e$var$createValue());
    return /*#__PURE__*/ $acw62.createElement($d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




var $acw62 = parcelRequire("acw62");
'use client';
const $d73410633d0f0f28$var$IsRestoringContext = /*#__PURE__*/ $acw62.createContext(false);
const $d73410633d0f0f28$export$4da0178d6b5f553 = ()=>$acw62.useContext($d73410633d0f0f28$var$IsRestoringContext);
const $d73410633d0f0f28$export$593807d4e94f9621 = $d73410633d0f0f28$var$IsRestoringContext.Provider;



var $acw62 = parcelRequire("acw62");
function $a6837397414c8694$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


'use client';
const $2cae4142f68cd6ce$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $2cae4142f68cd6ce$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $2cae4142f68cd6ce$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a6837397414c8694$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


/**
 * Ensures minimum staleTime and cacheTime values when suspense is enabled.
 * Despite the name, this function guards both staleTime and cacheTime to prevent
 * infinite re-render loops with synchronous queries.
 *
 * @deprecated in v5 - replaced by ensureSuspenseTimers
 */ const $bf865f1d403d5a28$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
        if (typeof defaultedOptions.cacheTime === 'number') defaultedOptions.cacheTime = Math.max(defaultedOptions.cacheTime, 1000);
    }
};
const $bf865f1d403d5a28$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $bf865f1d403d5a28$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $bf865f1d403d5a28$export$e0a3f29513afe430(result, isRestoring);
const $bf865f1d403d5a28$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


'use client';
function $ede1b94721233a5e$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $0126047dd734bc33$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $d73410633d0f0f28$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $d8c18f57bc93d04e$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $bf865f1d403d5a28$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $2cae4142f68cd6ce$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $2cae4142f68cd6ce$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $acw62.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $cb54322a339eb896$export$306c0aa65ff9ec16)($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $bf865f1d403d5a28$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $bf865f1d403d5a28$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2cae4142f68cd6ce$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


'use client';
function $6f7384520c92f99a$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $ede1b94721233a5e$export$fff0865807e996c5)(parsedOptions, (0, $d07b9a140ad50c23$export$a06cf8c0066f0d4c));
}


'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};







'use strict';
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
const $e52be20a9fc15e96$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $c319b2c832c2914a$export$2e2bcd8739ae039).global);
const { ReadableStream: $e52be20a9fc15e96$var$ReadableStream, TextEncoder: $e52be20a9fc15e96$var$TextEncoder } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global;
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $e52be20a9fc15e96$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction($e52be20a9fc15e96$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $e52be20a9fc15e96$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $e52be20a9fc15e96$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new $e52be20a9fc15e96$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.13.6";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


const $60e11fe1c33f6f43$export$b0bf9af1d1ce188f = `${"https://main.d2f24xphf7fua5.amplifyapp.com"}/api/data`;


var $25746eb61037a613$export$fb8073518f34e6ec = /*#__PURE__*/ function(Collection) {
    Collection["FEATURE_PRODUCTS"] = "features";
    Collection["MENU"] = "menu";
    Collection["CAREERS"] = "careers";
    Collection["HOME_DISPLAY"] = "home";
    Collection["MERCHANDISE_PRODUCTS"] = "merchandise";
    return Collection;
}({});


const $ac89d34379d08c2d$export$b7ecd1cb26186dab = async ()=>{
    const { data: data } = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, $60e11fe1c33f6f43$export$b0bf9af1d1ce188f), {
        params: {
            type: (0, $25746eb61037a613$export$fb8073518f34e6ec).CAREERS
        }
    });
    return data.sort(({ order: o1 }, { order: o2 })=>o1 - o2);
};





const $315dcbf8a826574a$export$95d70ea8b3786cb7 = async ()=>{
    const { data: data } = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, $60e11fe1c33f6f43$export$b0bf9af1d1ce188f), {
        params: {
            type: (0, $25746eb61037a613$export$fb8073518f34e6ec).FEATURE_PRODUCTS
        }
    });
    return data.sort(({ order: o1 }, { order: o2 })=>o1 - o2);
};





const $2e1fafd9433cef4b$export$91688e7eb91e0ccb = async ()=>{
    const { data: data } = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, $60e11fe1c33f6f43$export$b0bf9af1d1ce188f), {
        params: {
            type: (0, $25746eb61037a613$export$fb8073518f34e6ec).HOME_DISPLAY
        }
    });
    return data.sort(({ order: o1 }, { order: o2 })=>o1 - o2);
};





const $453bfe9446abeb38$export$29825b8cbcad0ecc = async ()=>{
    const { data: data } = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, $60e11fe1c33f6f43$export$b0bf9af1d1ce188f), {
        params: {
            type: (0, $25746eb61037a613$export$fb8073518f34e6ec).MENU
        }
    });
    return data.sort(({ order: o1 }, { order: o2 })=>o1 - o2);
};
function $453bfe9446abeb38$export$4264d5c1fe0b6503(data) {
    const oddResults = [];
    const evenResults = [];
    data.forEach((section, index)=>{
        if (index % 2 === 0) oddResults.push(section);
        else evenResults.push(section);
    });
    return [
        oddResults,
        evenResults
    ];
}





const $861faf10b7743d31$export$b36a5e90870650e7 = async ()=>{
    const { data: data } = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get((0, $60e11fe1c33f6f43$export$b0bf9af1d1ce188f), {
        params: {
            type: (0, $25746eb61037a613$export$fb8073518f34e6ec).MERCHANDISE_PRODUCTS
        }
    });
    return data.sort(({ order: o1 }, { order: o2 })=>o1 - o2);
};


function $7f1ca03e50a4c851$export$2e2bcd8739ae039() {
    (0, $6f7384520c92f99a$export$dd0a697e1782aedd)({
        queryKey: [
            "repoData"
        ],
        queryFn: async ()=>{
            const [careers, featureProducts, homeDisplay, menu, merchandiseProducts] = await Promise.all([
                (0, $ac89d34379d08c2d$export$b7ecd1cb26186dab)(),
                (0, $315dcbf8a826574a$export$95d70ea8b3786cb7)(),
                (0, $2e1fafd9433cef4b$export$91688e7eb91e0ccb)(),
                (0, $453bfe9446abeb38$export$29825b8cbcad0ecc)(),
                (0, $861faf10b7743d31$export$b36a5e90870650e7)()
            ]);
            $7f1ca03e50a4c851$export$16fe725363162b27.getState().initialize({
                careers: careers,
                featureProducts: featureProducts,
                homeDisplay: homeDisplay,
                menu: menu,
                merchandiseProducts: merchandiseProducts
            });
        }
    });
}
const $7f1ca03e50a4c851$var$INITIAL_DATA = {
    careers: undefined,
    featureProducts: undefined,
    homeDisplay: undefined,
    menu: undefined,
    merchandiseProducts: undefined,
    shouldHeaderHide: false,
    isMobile: false,
    passing: {
        home: false,
        features: false,
        career: false,
        location: false
    }
};
const $7f1ca03e50a4c851$export$16fe725363162b27 = (0, $6d940318c7b48507$export$c883e057baa24e24)((0, $6901b3de930503c1$export$428de7ec69ac95c)((set)=>({
        ...$7f1ca03e50a4c851$var$INITIAL_DATA,
        initialize: (d)=>set(()=>d),
        showHeader: ()=>set(()=>({
                    shouldHeaderHide: true
                })),
        hideHeader: ()=>set(()=>({
                    shouldHeaderHide: false
                })),
        updateIsMobile: (isMobile)=>set(()=>({
                    isMobile: isMobile
                })),
        setPassing: (section, flag)=>set(({ passing: passing })=>{
                passing[section] = flag;
            })
    })), (0, $af540f293314ba66$exports.shallow));




var $acw62 = parcelRequire("acw62");



const $4bdf025898ed5789$var$BEHIKD_INS = "fvqgbC1f3hYzefRXR6Oz";
function $4bdf025898ed5789$var$Footer({}) {
    const [insFeeds, setInsFeeds] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            try {
                const { data: feeds } = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`https://feeds.behold.so/${$4bdf025898ed5789$var$BEHIKD_INS}`);
                setInsFeeds(feeds.posts.map(({ sizes: sizes, permalink: permalink })=>({
                        src: sizes.medium.mediaUrl,
                        href: permalink
                    })));
            } catch (e) {
                console.error(e);
            }
        })();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
        className: "z-footer",
        children: [
            insFeeds && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ins-mobile mb-[60px] md:mb-[50px]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4bdf025898ed5789$var$InsImages, {
                    feeds: insFeeds
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "top-left-mobile space-y-[20px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-col justify-start md:flex-row md:mt-5 gap-[20px] md:gap-[83px] mb-[25px] md:mb-[31px]",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e91257f7345c1a13$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex md:hidden items-center space-x-[24px]",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4bdf025898ed5789$export$baafb546dd70f2d3, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4bdf025898ed5789$export$ee5d15dadfca9a99, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "top-right-mobile",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4bdf025898ed5789$var$FooterLogo, {
                                    className: "w-[174px] md:w-[253px] md:mb-[31px]"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "font-montserrat text-[10px] md:text-[14px]",
                                children: "All rights reserved \xa9 Angus T 2023-2024"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $4bdf025898ed5789$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($4bdf025898ed5789$var$Footer);
const $4bdf025898ed5789$var$FooterLogo = ({ className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "249",
        height: "79",
        viewBox: "0 0 249 79",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_35_3251)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.201 68.8346C236.268 68.845 236.332 68.8575 236.399 68.8679C236.399 68.8825 236.399 68.8991 236.399 68.9137C236.311 68.9137 236.22 68.9324 236.139 68.9137C235.916 68.8596 235.918 68.8533 235.866 69.1196C235.907 69.078 235.68 69.4108 235.712 69.3796C235.445 69.8351 235.385 69.9017 235.014 70.3718C234.878 70.4342 234.764 70.5548 234.624 70.6089C234.476 70.6671 234.31 70.4966 234.152 70.5028C233.993 70.5111 233.779 70.5631 233.683 70.6713C233.312 71.0873 232.935 71.4284 232.331 71.4264C232.163 71.4264 231.931 71.5761 231.815 71.7196C231.45 72.1689 231.148 72.6661 230.78 73.1112C230.603 73.3254 230.155 73.1486 230.147 72.872C230.132 72.2916 230.138 71.7092 230.147 71.1268C230.153 70.7025 230.255 70.2574 230.174 69.8601C230.032 69.1737 230.19 68.5185 230.33 67.8445C230.39 67.5512 230.419 67.2267 230.349 66.9522C230.186 66.3157 230.473 65.8227 230.884 65.3568C231.111 65.0989 231.359 64.843 231.638 64.6454C231.871 64.479 231.85 64.2481 231.958 64.063C232.219 63.6137 232.56 63.1998 232.889 62.7879C233.112 62.5113 233.346 62.2326 233.618 62.0058C234.093 61.6106 234.579 61.2113 235.205 61.0761C235.503 61.0116 235.493 61.0345 235.718 61.0573C235.805 61.0719 235.826 61.074 235.901 61.0657C235.947 61.049 235.957 61.0449 235.991 61.0324C236.203 60.9887 236.416 60.9242 236.63 60.9076C237.436 60.841 238.259 60.6226 239.04 60.8597C239.388 60.9658 239.685 61.2009 240.01 61.3714C240.06 61.3964 240.137 61.3881 240.2 61.3797C240.629 61.3111 241.058 61.1634 241.477 61.3693C241.624 61.4421 241.858 61.3901 241.972 61.4879C242.308 61.7729 242.693 61.7874 243.13 61.7999C243.678 61.8165 244.149 62.0953 244.553 62.4364C244.663 62.53 244.826 62.7172 244.79 62.7879C244.682 63.0043 244.521 63.258 244.211 63.1956C243.951 63.1415 243.738 63.1769 243.516 63.3558C243.397 63.4494 243.224 63.4764 243.078 63.5347C243.066 63.5388 243.049 63.5596 243.049 63.57C243.082 64.0048 242.657 64.0755 242.428 64.3043C242.155 64.5768 241.903 64.868 241.633 65.1446C241.554 65.2257 241.443 65.2819 241.347 65.3485C241.312 65.3734 241.254 65.3901 241.245 65.4192C241.058 66.0058 240.579 66.3178 240.071 66.5819C239.785 66.7317 239.211 66.3198 238.981 66.5174C238.734 66.7296 238.425 66.8711 238.244 67.2101C238.028 67.6157 237.682 67.988 237.321 68.2959C237.019 68.5538 236.618 68.7015 236.259 68.897C236.243 68.8783 236.226 68.8596 236.209 68.8409L236.201 68.8346ZM234.897 62.7921C234.595 62.6215 234.316 62.4676 234.043 62.3074C233.86 62.2014 233.698 62.2118 233.541 62.3823C233.435 62.4988 233.304 62.6007 233.223 62.7297C232.979 63.1207 232.929 63.3724 232.719 63.778C232.606 63.9923 232.517 64.2398 232.771 64.4208C232.896 64.5102 233.025 64.5996 233.131 64.7078C233.533 65.1176 233.958 65.5086 234.314 65.9558C234.787 66.5507 235.268 67.1539 235.622 67.8237C235.836 68.2293 235.878 68.1316 236.297 68.2813C236.463 68.3416 236.536 68.402 236.726 68.3125C236.997 68.1856 237.265 68.0234 237.486 67.8237C238.005 67.3515 238.105 66.7213 238.138 66.1014C238.157 65.7333 238.284 65.7853 238.213 65.4275C238.123 64.9741 237.996 64.5289 237.871 64.0838C237.83 63.934 237.751 63.7947 237.684 63.6553C237.544 63.3662 237.399 63.0791 237.259 62.79C237.201 62.6673 237.18 62.5196 237.097 62.4177C236.865 62.1327 236.603 61.8769 236.372 61.5919C236.124 61.2861 235.899 61.2341 235.528 61.4338C235.582 61.4817 235.641 61.5295 235.697 61.5773C235.614 61.5669 235.53 61.5545 235.445 61.5503C235.349 61.5461 235.247 61.5295 235.153 61.5524C235.058 61.5774 234.97 61.6439 234.878 61.6917C234.937 61.7333 234.997 61.7729 235.051 61.8186C235.095 61.854 235.139 61.8935 235.168 61.9393C235.176 61.9538 235.126 62.0308 235.116 62.0287C234.883 61.9934 234.656 61.9351 234.42 61.9143C234.329 61.906 234.224 61.9767 234.127 62.01C234.162 62.0454 234.195 62.0786 234.231 62.114C234.445 62.3262 234.901 62.2846 234.899 62.7859L234.897 62.7921ZM231.015 67.4327C231.025 67.4243 231.038 67.416 231.048 67.4077C231.102 67.4451 231.15 67.4971 231.211 67.5138C231.275 67.5325 231.363 67.4971 231.421 67.5221C231.821 67.6927 232.14 67.9568 232.348 68.3354C232.481 68.5767 232.592 68.8346 232.758 69.0489C232.942 69.2881 233.214 69.4607 233.383 69.7082C233.623 70.0618 233.947 70.2511 234.366 70.3218C234.427 70.3322 234.495 70.3135 234.562 70.3073C234.545 70.2615 234.522 70.2158 234.512 70.1679C234.506 70.1471 234.512 70.1055 234.526 70.0993C234.56 70.0847 234.41 69.6438 234.437 69.6542C234.516 69.6833 234.587 69.7498 234.668 69.7561C234.743 69.7623 234.826 69.7103 234.908 69.6833C234.864 69.6479 234.822 69.6084 234.778 69.5751C234.689 69.5085 234.785 69.8767 234.704 69.8018C234.668 69.7686 234.668 69.6978 234.651 69.6438C234.72 69.6604 234.793 69.6687 234.856 69.6978C234.96 69.7478 234.856 69.3983 234.964 69.4399C235.008 69.4565 235.08 69.417 235.139 69.4025C235.114 69.3588 235.093 69.3109 235.062 69.2714C234.872 69.026 234.874 69.209 234.689 68.9615C234.67 68.9365 234.703 68.8762 234.712 68.8325C234.745 68.8596 234.785 68.8845 234.814 68.9178C235.003 69.1321 234.993 68.9261 235.187 69.1362C235.21 69.1612 235.283 69.1445 235.333 69.1466C235.322 69.1009 235.324 69.0468 235.299 69.0093C235.062 68.6682 235.012 68.7556 234.776 68.4103C234.758 68.3812 234.803 68.3063 234.82 68.2522C234.874 68.2709 234.956 68.2709 234.981 68.3084C235.212 68.6453 235.237 68.5663 235.47 68.9012C235.487 68.9241 235.612 68.9116 235.641 68.8783C235.68 68.8346 235.709 68.7285 235.684 68.6911C235.537 68.4768 235.562 68.7057 235.412 68.4914C235.326 68.3708 235.276 68.2272 235.197 68.1045C235.103 67.9568 234.993 67.8196 234.889 67.6802C234.733 67.468 234.57 67.2621 234.42 67.0479C234.306 66.8856 234.216 66.7067 234.095 66.5507C234.002 66.4301 233.877 66.3302 233.766 66.2221C233.725 66.1826 233.673 66.1014 233.641 66.1098C233.371 66.1826 233.302 65.9954 233.225 65.8269C233.206 65.7853 233.241 65.7083 233.214 65.6813C233.066 65.5294 232.885 65.4025 232.758 65.2361C232.437 64.8201 232.077 64.7369 231.6 65.0219C231.667 65.0219 231.704 65.024 231.742 65.0261C231.954 65.0323 232.196 64.9865 232.263 65.2632C232.269 65.2881 232.263 65.3152 232.263 65.3401C232.24 65.3401 232.215 65.3443 232.194 65.3401C232.083 65.3089 231.975 65.2653 231.861 65.2465C231.617 65.2091 231.346 65.0739 231.159 65.4317C231.252 65.4192 231.329 65.4046 231.409 65.3984C231.448 65.3963 231.49 65.4088 231.529 65.415C231.49 65.4296 231.45 65.4587 231.413 65.4587C231 65.4587 230.84 65.7478 230.803 66.064C230.757 66.4654 230.782 66.8731 230.8 67.2746C230.803 67.3328 230.94 67.3786 231.015 67.4285V67.4327ZM238.842 66.0536C238.842 66.0536 238.806 66.1243 238.771 66.1971C238.804 66.2096 238.836 66.2242 238.869 66.2366C238.886 66.2013 238.902 66.1659 238.886 66.2013C239.025 66.1826 239.113 66.1534 239.194 66.1618C239.365 66.1763 239.519 66.2346 239.429 65.9434C239.348 65.6813 239.344 65.3942 239.306 65.1155C239.302 65.0822 239.306 65.0469 239.306 65.0115C239.338 65.0344 239.392 65.0489 239.4 65.0801C239.475 65.3734 239.544 65.6709 239.615 65.9662C239.623 65.9995 239.633 66.0328 239.642 66.064C239.673 66.0266 239.731 65.987 239.731 65.9538C239.731 65.8227 239.715 65.6917 239.702 65.5606C239.696 65.5024 239.685 65.4462 239.677 65.3901C239.715 65.4317 239.765 65.4691 239.785 65.519C239.846 65.6625 239.756 65.9142 240.117 65.675C240.585 65.3651 241 65.4566 240.856 65.0177C240.631 64.3313 240.443 63.6283 240.244 62.9315C240.096 62.4218 240.123 61.8457 239.654 61.4629C238.927 60.8722 238.065 60.8868 237.234 61.0241C237.446 61.2716 237.684 61.5503 237.923 61.827C237.898 61.8519 237.873 61.8769 237.848 61.8998C237.561 61.4629 237.276 61.022 236.693 61.0865C236.924 61.3735 237.174 61.671 237.407 61.9809C237.471 62.0682 237.486 62.193 237.53 62.295C237.611 62.4863 237.711 62.6694 237.782 62.8649C237.917 63.2435 238.038 63.6283 238.159 64.0131C238.267 64.3604 238.373 64.7078 238.473 65.0593C238.525 65.2445 238.317 64.9969 238.561 65.1113C238.7 65.1779 238.684 65.5211 238.74 65.7374C238.765 65.8352 238.8 65.9288 238.84 66.0515L238.842 66.0536ZM232.081 68.2397C231.948 68.1815 231.748 68.0692 231.529 68.0088C231.354 67.961 231.155 67.9568 230.967 67.9756C230.84 67.988 230.638 68.0567 230.609 68.1378C230.519 68.3874 230.484 68.6557 230.451 68.9178C230.388 69.4212 230.528 69.8705 230.778 70.2844C230.828 70.3676 230.917 70.4258 230.967 70.5091C231.221 70.923 231.673 71.0457 232.1 71.2038C232.148 71.2225 232.229 71.1518 232.294 71.1518C232.481 71.1518 232.667 71.1767 232.854 71.1663C232.917 71.1622 232.981 71.0852 233.044 71.0415C233.035 71.0311 233.031 71.0124 233.021 71.0083C232.846 70.95 232.671 70.8959 232.498 70.8335C232.454 70.8169 232.421 70.7753 232.392 70.7399C232.385 70.7316 232.421 70.6734 232.44 70.6713C232.492 70.6651 232.55 70.663 232.594 70.6817C232.685 70.7191 232.773 70.8169 232.858 70.8065C233.081 70.7815 233.302 70.7108 233.523 70.6567C233.531 70.6567 233.535 70.6318 233.539 70.6193C233.379 70.5777 233.219 70.5361 233.06 70.4924C233.021 70.482 232.983 70.4633 232.952 70.4383C232.939 70.4279 232.946 70.3946 232.948 70.3697C232.954 70.2345 232.998 70.0868 232.96 69.9682C232.904 69.7831 232.796 69.6146 232.706 69.4399C232.517 69.0738 232.325 68.7098 232.079 68.2418L232.081 68.2397ZM241.928 64.35C241.891 64.3438 241.854 64.3376 241.816 64.3313C241.756 64.0422 241.693 63.7551 241.641 63.4639C241.637 63.439 241.697 63.3995 241.729 63.3662C241.749 63.3932 241.781 63.4182 241.787 63.4473C241.812 63.5617 241.822 63.6782 241.853 63.7905C241.864 63.8259 241.92 63.8446 241.956 63.8696C241.97 63.8384 241.991 63.8072 241.997 63.7739C242.024 63.647 242.039 63.5201 242.076 63.3953C242.085 63.3683 242.162 63.3537 242.208 63.335C242.216 63.3579 242.23 63.3807 242.23 63.4036C242.226 63.6387 242.222 63.8716 242.22 64.1067C242.22 64.1108 242.27 64.1254 242.287 64.115C242.424 64.0422 242.562 63.9673 242.697 63.8904C242.72 63.8779 242.759 63.8529 242.757 63.8404C242.72 63.5596 242.682 63.2767 242.632 63.0001C242.499 62.2742 242.131 61.7458 241.364 61.5649C241.337 61.5586 241.306 61.5607 241.277 61.5586C241.277 61.5815 241.277 61.6044 241.277 61.6252C241.283 61.6751 241.291 61.7271 241.299 61.777C241.262 61.7313 241.233 61.673 241.183 61.6439C241.095 61.594 240.998 61.5607 240.904 61.5212C240.914 61.5877 240.918 61.6564 240.939 61.7188C240.964 61.7978 241.014 61.8686 241.033 61.9476C241.043 61.9892 241.012 62.0433 241 62.0932C240.962 62.0662 240.893 62.0433 240.893 62.0142C240.881 61.6169 240.598 61.673 240.327 61.7167C240.3 61.7209 240.25 61.7958 240.258 61.8249C240.331 62.1265 240.423 62.4239 240.491 62.7276C240.558 63.0167 240.581 63.3183 240.666 63.5992C240.718 63.7718 240.837 63.9236 240.95 64.0672C241.122 64.2876 241.312 64.4915 241.499 64.6995C241.547 64.7536 241.608 64.7952 241.664 64.843C241.754 64.6787 241.841 64.5123 241.931 64.348L241.928 64.35ZM230.455 71.0686C230.405 71.4659 230.346 71.8652 230.309 72.2625C230.299 72.3686 230.34 72.483 230.384 72.5808C230.438 72.7014 230.501 72.8907 230.59 72.9053C230.698 72.9219 230.88 72.8096 230.963 72.7035C231.123 72.4996 231.242 72.2625 231.371 72.0358C231.457 71.886 231.588 71.7259 231.388 71.5865C231.334 71.5491 231.252 71.547 231.198 71.5075C230.953 71.3223 230.713 71.131 230.469 70.9438C230.444 70.9251 230.409 70.923 230.378 70.9126C230.369 70.9708 230.363 71.0291 230.355 71.0852C230.39 71.079 230.424 71.0727 230.453 71.0686H230.455ZM243.122 62.1764C243.064 62.1702 242.976 62.1577 242.889 62.1473C242.901 62.2097 242.914 62.2721 242.928 62.3366C242.974 62.5466 243.005 62.7651 243.074 62.9668C243.118 63.0958 243.132 63.2955 243.397 63.1852C243.649 63.0812 243.922 63.0271 244.182 62.9419C244.28 62.9086 244.372 62.8524 244.463 62.7983C244.469 62.7942 244.455 62.7214 244.432 62.6985C244.367 62.6361 244.301 62.5695 244.219 62.5342C243.995 62.4302 243.761 62.3366 243.528 62.2492C243.501 62.2388 243.428 62.2929 243.403 62.3324C243.37 62.3823 243.363 62.4489 243.347 62.5071C243.303 62.4593 243.255 62.4156 243.216 62.3636C243.186 62.3241 243.172 62.2762 243.124 62.1764H243.122Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.201 68.8346C236.268 68.845 236.332 68.8575 236.399 68.8679C236.399 68.8825 236.399 68.8991 236.399 68.9137C236.311 68.9137 236.22 68.9324 236.139 68.9137C235.916 68.8596 235.918 68.8533 235.866 69.1196C235.907 69.078 235.68 69.4108 235.712 69.3796C235.445 69.8351 235.385 69.9017 235.014 70.3718C234.878 70.4342 234.764 70.5548 234.624 70.6089C234.476 70.6671 234.31 70.4966 234.152 70.5028C233.993 70.5111 233.779 70.5631 233.683 70.6713C233.312 71.0873 232.935 71.4284 232.331 71.4264C232.163 71.4264 231.931 71.5761 231.815 71.7196C231.45 72.1689 231.148 72.6661 230.78 73.1112C230.603 73.3254 230.155 73.1486 230.147 72.872C230.132 72.2916 230.138 71.7092 230.147 71.1268C230.153 70.7025 230.255 70.2574 230.174 69.8601C230.032 69.1737 230.19 68.5185 230.33 67.8445C230.39 67.5512 230.419 67.2267 230.349 66.9522C230.186 66.3157 230.473 65.8227 230.884 65.3568C231.111 65.0989 231.359 64.843 231.638 64.6454C231.871 64.479 231.85 64.2481 231.958 64.063C232.219 63.6137 232.56 63.1998 232.889 62.7879C233.112 62.5113 233.346 62.2326 233.618 62.0058C234.093 61.6106 234.579 61.2113 235.205 61.0761C235.503 61.0116 235.493 61.0345 235.718 61.0573C235.805 61.0719 235.826 61.074 235.901 61.0657C235.947 61.049 235.957 61.0449 235.991 61.0324C236.203 60.9887 236.416 60.9242 236.63 60.9076C237.436 60.841 238.259 60.6226 239.04 60.8597C239.388 60.9658 239.685 61.2009 240.01 61.3714C240.06 61.3964 240.137 61.3881 240.2 61.3797C240.629 61.3111 241.058 61.1634 241.477 61.3693C241.624 61.4421 241.858 61.3901 241.972 61.4879C242.308 61.7729 242.693 61.7874 243.13 61.7999C243.678 61.8165 244.149 62.0953 244.553 62.4364C244.663 62.53 244.826 62.7172 244.79 62.7879C244.682 63.0043 244.521 63.258 244.211 63.1956C243.951 63.1415 243.738 63.1769 243.516 63.3558C243.397 63.4494 243.224 63.4764 243.078 63.5347C243.066 63.5388 243.049 63.5596 243.049 63.57C243.082 64.0048 242.657 64.0755 242.428 64.3043C242.155 64.5768 241.903 64.868 241.633 65.1446C241.554 65.2257 241.443 65.2819 241.347 65.3485C241.312 65.3734 241.254 65.3901 241.245 65.4192C241.058 66.0058 240.579 66.3178 240.071 66.5819C239.785 66.7317 239.211 66.3198 238.981 66.5174C238.734 66.7296 238.425 66.8711 238.244 67.2101C238.028 67.6157 237.682 67.988 237.321 68.2959C237.019 68.5538 236.618 68.7015 236.259 68.897C236.243 68.8783 236.226 68.8596 236.209 68.8409L236.201 68.8346ZM234.897 62.7921C234.595 62.6215 234.316 62.4676 234.043 62.3074C233.86 62.2014 233.698 62.2118 233.541 62.3823C233.435 62.4988 233.304 62.6007 233.223 62.7297C232.979 63.1207 232.929 63.3724 232.719 63.778C232.606 63.9923 232.517 64.2398 232.771 64.4208C232.896 64.5102 233.025 64.5996 233.131 64.7078C233.533 65.1176 233.958 65.5086 234.314 65.9558C234.787 66.5507 235.268 67.1539 235.622 67.8237C235.836 68.2293 235.878 68.1316 236.297 68.2813C236.463 68.3416 236.536 68.402 236.726 68.3125C236.997 68.1856 237.265 68.0234 237.486 67.8237C238.005 67.3515 238.105 66.7213 238.138 66.1014C238.157 65.7333 238.284 65.7853 238.213 65.4275C238.123 64.9741 237.996 64.5289 237.871 64.0838C237.83 63.934 237.751 63.7947 237.684 63.6553C237.544 63.3662 237.399 63.0791 237.259 62.79C237.201 62.6673 237.18 62.5196 237.097 62.4177C236.865 62.1327 236.603 61.8769 236.372 61.5919C236.124 61.2861 235.899 61.2341 235.528 61.4338C235.582 61.4817 235.641 61.5295 235.697 61.5773C235.614 61.5669 235.53 61.5545 235.445 61.5503C235.349 61.5461 235.247 61.5295 235.153 61.5524C235.058 61.5774 234.97 61.6439 234.878 61.6917C234.937 61.7333 234.997 61.7729 235.051 61.8186C235.095 61.854 235.139 61.8935 235.168 61.9393C235.176 61.9538 235.126 62.0308 235.116 62.0287C234.883 61.9934 234.656 61.9351 234.42 61.9143C234.329 61.906 234.224 61.9767 234.127 62.01C234.162 62.0454 234.195 62.0786 234.231 62.114C234.445 62.3262 234.901 62.2846 234.899 62.7859L234.897 62.7921ZM231.015 67.4327C231.025 67.4243 231.038 67.416 231.048 67.4077C231.102 67.4451 231.15 67.4971 231.211 67.5138C231.275 67.5325 231.363 67.4971 231.421 67.5221C231.821 67.6927 232.14 67.9568 232.348 68.3354C232.481 68.5767 232.592 68.8346 232.758 69.0489C232.942 69.2881 233.214 69.4607 233.383 69.7082C233.623 70.0618 233.947 70.2511 234.366 70.3218C234.427 70.3322 234.495 70.3135 234.562 70.3073C234.545 70.2615 234.522 70.2158 234.512 70.1679C234.506 70.1471 234.512 70.1055 234.526 70.0993C234.56 70.0847 234.41 69.6438 234.437 69.6542C234.516 69.6833 234.587 69.7498 234.668 69.7561C234.743 69.7623 234.826 69.7103 234.908 69.6833C234.864 69.6479 234.822 69.6084 234.778 69.5751C234.689 69.5085 234.785 69.8767 234.704 69.8018C234.668 69.7686 234.668 69.6978 234.651 69.6438C234.72 69.6604 234.793 69.6687 234.856 69.6978C234.96 69.7478 234.856 69.3983 234.964 69.4399C235.008 69.4565 235.08 69.417 235.139 69.4025C235.114 69.3588 235.093 69.3109 235.062 69.2714C234.872 69.026 234.874 69.209 234.689 68.9615C234.67 68.9365 234.703 68.8762 234.712 68.8325C234.745 68.8596 234.785 68.8845 234.814 68.9178C235.003 69.1321 234.993 68.9261 235.187 69.1362C235.21 69.1612 235.283 69.1445 235.333 69.1466C235.322 69.1009 235.324 69.0468 235.299 69.0093C235.062 68.6682 235.012 68.7556 234.776 68.4103C234.758 68.3812 234.803 68.3063 234.82 68.2522C234.874 68.2709 234.956 68.2709 234.981 68.3084C235.212 68.6453 235.237 68.5663 235.47 68.9012C235.487 68.9241 235.612 68.9116 235.641 68.8783C235.68 68.8346 235.709 68.7285 235.684 68.6911C235.537 68.4768 235.562 68.7057 235.412 68.4914C235.326 68.3708 235.276 68.2272 235.197 68.1045C235.103 67.9568 234.993 67.8196 234.889 67.6802C234.733 67.468 234.57 67.2621 234.42 67.0479C234.306 66.8856 234.216 66.7067 234.095 66.5507C234.002 66.4301 233.877 66.3302 233.766 66.2221C233.725 66.1826 233.673 66.1014 233.641 66.1098C233.371 66.1826 233.302 65.9954 233.225 65.8269C233.206 65.7853 233.241 65.7083 233.214 65.6813C233.066 65.5294 232.885 65.4025 232.758 65.2361C232.437 64.8201 232.077 64.7369 231.6 65.0219C231.667 65.0219 231.704 65.024 231.742 65.0261C231.954 65.0323 232.196 64.9865 232.263 65.2632C232.269 65.2881 232.263 65.3152 232.263 65.3401C232.24 65.3401 232.215 65.3443 232.194 65.3401C232.083 65.3089 231.975 65.2653 231.861 65.2465C231.617 65.2091 231.346 65.0739 231.159 65.4317C231.252 65.4192 231.329 65.4046 231.409 65.3984C231.448 65.3963 231.49 65.4088 231.529 65.415C231.49 65.4296 231.45 65.4587 231.413 65.4587C231 65.4587 230.84 65.7478 230.803 66.064C230.757 66.4654 230.782 66.8731 230.8 67.2746C230.803 67.3328 230.94 67.3786 231.015 67.4285V67.4327ZM238.842 66.0536C238.842 66.0536 238.806 66.1243 238.771 66.1971C238.804 66.2096 238.836 66.2242 238.869 66.2366C238.886 66.2013 238.902 66.1659 238.886 66.2013C239.025 66.1826 239.113 66.1534 239.194 66.1618C239.365 66.1763 239.519 66.2346 239.429 65.9434C239.348 65.6813 239.344 65.3942 239.306 65.1155C239.302 65.0822 239.306 65.0469 239.306 65.0115C239.338 65.0344 239.392 65.0489 239.4 65.0801C239.475 65.3734 239.544 65.6709 239.615 65.9662C239.623 65.9995 239.633 66.0328 239.642 66.064C239.673 66.0266 239.731 65.987 239.731 65.9538C239.731 65.8227 239.715 65.6917 239.702 65.5606C239.696 65.5024 239.685 65.4462 239.677 65.3901C239.715 65.4317 239.765 65.4691 239.785 65.519C239.846 65.6625 239.756 65.9142 240.117 65.675C240.585 65.3651 241 65.4566 240.856 65.0177C240.631 64.3313 240.443 63.6283 240.244 62.9315C240.096 62.4218 240.123 61.8457 239.654 61.4629C238.927 60.8722 238.065 60.8868 237.234 61.0241C237.446 61.2716 237.684 61.5503 237.923 61.827C237.898 61.8519 237.873 61.8769 237.848 61.8998C237.561 61.4629 237.276 61.022 236.693 61.0865C236.924 61.3735 237.174 61.671 237.407 61.9809C237.471 62.0682 237.486 62.193 237.53 62.295C237.611 62.4863 237.711 62.6694 237.782 62.8649C237.917 63.2435 238.038 63.6283 238.159 64.0131C238.267 64.3604 238.373 64.7078 238.473 65.0593C238.525 65.2445 238.317 64.9969 238.561 65.1113C238.7 65.1779 238.684 65.5211 238.74 65.7374C238.765 65.8352 238.8 65.9288 238.84 66.0515L238.842 66.0536ZM232.081 68.2397C231.948 68.1815 231.748 68.0692 231.529 68.0088C231.354 67.961 231.155 67.9568 230.967 67.9756C230.84 67.988 230.638 68.0567 230.609 68.1378C230.519 68.3874 230.484 68.6557 230.451 68.9178C230.388 69.4212 230.528 69.8705 230.778 70.2844C230.828 70.3676 230.917 70.4258 230.967 70.5091C231.221 70.923 231.673 71.0457 232.1 71.2038C232.148 71.2225 232.229 71.1518 232.294 71.1518C232.481 71.1518 232.667 71.1767 232.854 71.1663C232.917 71.1622 232.981 71.0852 233.044 71.0415C233.035 71.0311 233.031 71.0124 233.021 71.0083C232.846 70.95 232.671 70.8959 232.498 70.8335C232.454 70.8169 232.421 70.7753 232.392 70.7399C232.385 70.7316 232.421 70.6734 232.44 70.6713C232.492 70.6651 232.55 70.663 232.594 70.6817C232.685 70.7191 232.773 70.8169 232.858 70.8065C233.081 70.7815 233.302 70.7108 233.523 70.6567C233.531 70.6567 233.535 70.6318 233.539 70.6193C233.379 70.5777 233.219 70.5361 233.06 70.4924C233.021 70.482 232.983 70.4633 232.952 70.4383C232.939 70.4279 232.946 70.3946 232.948 70.3697C232.954 70.2345 232.998 70.0868 232.96 69.9682C232.904 69.7831 232.796 69.6146 232.706 69.4399C232.517 69.0738 232.325 68.7098 232.079 68.2418L232.081 68.2397ZM241.928 64.35C241.891 64.3438 241.854 64.3376 241.816 64.3313C241.756 64.0422 241.693 63.7551 241.641 63.4639C241.637 63.439 241.697 63.3995 241.729 63.3662C241.749 63.3932 241.781 63.4182 241.787 63.4473C241.812 63.5617 241.822 63.6782 241.853 63.7905C241.864 63.8259 241.92 63.8446 241.956 63.8696C241.97 63.8384 241.991 63.8072 241.997 63.7739C242.024 63.647 242.039 63.5201 242.076 63.3953C242.085 63.3683 242.162 63.3537 242.208 63.335C242.216 63.3579 242.23 63.3807 242.23 63.4036C242.226 63.6387 242.222 63.8716 242.22 64.1067C242.22 64.1108 242.27 64.1254 242.287 64.115C242.424 64.0422 242.562 63.9673 242.697 63.8904C242.72 63.8779 242.759 63.8529 242.757 63.8404C242.72 63.5596 242.682 63.2767 242.632 63.0001C242.499 62.2742 242.131 61.7458 241.364 61.5649C241.337 61.5586 241.306 61.5607 241.277 61.5586C241.277 61.5815 241.277 61.6044 241.277 61.6252C241.283 61.6751 241.291 61.7271 241.299 61.777C241.262 61.7313 241.233 61.673 241.183 61.6439C241.095 61.594 240.998 61.5607 240.904 61.5212C240.914 61.5877 240.918 61.6564 240.939 61.7188C240.964 61.7978 241.014 61.8686 241.033 61.9476C241.043 61.9892 241.012 62.0433 241 62.0932C240.962 62.0662 240.893 62.0433 240.893 62.0142C240.881 61.6169 240.598 61.673 240.327 61.7167C240.3 61.7209 240.25 61.7958 240.258 61.8249C240.331 62.1265 240.423 62.4239 240.491 62.7276C240.558 63.0167 240.581 63.3183 240.666 63.5992C240.718 63.7718 240.837 63.9236 240.95 64.0672C241.122 64.2876 241.312 64.4915 241.499 64.6995C241.547 64.7536 241.608 64.7952 241.664 64.843C241.754 64.6787 241.841 64.5123 241.931 64.348L241.928 64.35ZM230.455 71.0686C230.405 71.4659 230.346 71.8652 230.309 72.2625C230.299 72.3686 230.34 72.483 230.384 72.5808C230.438 72.7014 230.501 72.8907 230.59 72.9053C230.698 72.9219 230.88 72.8096 230.963 72.7035C231.123 72.4996 231.242 72.2625 231.371 72.0358C231.457 71.886 231.588 71.7259 231.388 71.5865C231.334 71.5491 231.252 71.547 231.198 71.5075C230.953 71.3223 230.713 71.131 230.469 70.9438C230.444 70.9251 230.409 70.923 230.378 70.9126C230.369 70.9708 230.363 71.0291 230.355 71.0852C230.39 71.079 230.424 71.0727 230.453 71.0686H230.455ZM243.122 62.1764C243.064 62.1702 242.976 62.1577 242.889 62.1473C242.901 62.2097 242.914 62.2721 242.928 62.3366C242.974 62.5466 243.005 62.7651 243.074 62.9668C243.118 63.0958 243.132 63.2955 243.397 63.1852C243.649 63.0812 243.922 63.0271 244.182 62.9419C244.28 62.9086 244.372 62.8524 244.463 62.7983C244.469 62.7942 244.455 62.7214 244.432 62.6985C244.367 62.6361 244.301 62.5695 244.219 62.5342C243.995 62.4302 243.761 62.3366 243.528 62.2492C243.501 62.2388 243.428 62.2929 243.403 62.3324C243.37 62.3823 243.363 62.4489 243.347 62.5071C243.303 62.4593 243.255 62.4156 243.216 62.3636C243.186 62.3241 243.172 62.2762 243.124 62.1764H243.122Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.935 62.27C242.935 62.27 242.904 62.2805 242.897 62.2826C242.908 62.2889 242.943 62.2659 242.935 62.27Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.054 62.335L243.039 62.3391L243.079 62.3412L243.054 62.335Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.117 62.4492C243.117 62.4492 243.129 62.4325 243.129 62.4284C243.127 62.4096 243.081 62.4076 243.085 62.3805L243.096 62.3701L243.048 62.3805C243.067 62.4034 243.102 62.42 243.115 62.4367C243.117 62.4388 243.119 62.4429 243.117 62.4471V62.4492Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.054 62.5767C243.071 62.5596 243.08 62.5745 243.05 62.5596C243.05 62.5617 243.05 62.5638 243.048 62.566C243.048 62.566 243.052 62.5702 243.054 62.5767Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.097 62.6006H243.07C243.062 62.6131 243.07 62.6257 243.058 62.6278C243.079 62.634 243.087 62.6215 243.097 62.6006Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.141 62.584H243.128C243.128 62.584 243.124 62.5928 243.141 62.584Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.102 62.5826H243.129C243.129 62.5826 243.15 62.5638 243.118 62.5826C243.133 62.5721 243.118 62.5826 243.102 62.5826Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.102 62.5675C243.106 62.5528 243.104 62.5382 243.131 62.5382C243.104 62.5215 243.072 62.5507 243.102 62.5675Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.171 62.4167L243.177 62.3975H243.166L243.151 62.4017C243.153 62.4017 243.156 62.4017 243.158 62.406C243.16 62.4124 243.158 62.4274 243.168 62.4167H243.171Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.605 62.5842C243.605 62.5842 243.589 62.5801 243.578 62.5801L243.162 62.6758C243.162 62.6758 243.172 62.6633 243.176 62.657H243.158C243.158 62.657 243.158 62.6758 243.151 62.6841V62.6903L243.591 62.5822C243.595 62.5822 243.599 62.5822 243.605 62.5822V62.5842Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.177 62.6591H243.183L243.587 62.6341L243.554 62.5717L243.541 62.5488C243.541 62.5488 243.537 62.5634 243.541 62.5675L243.585 62.6404L243.196 62.6487C243.196 62.6487 243.185 62.6528 243.179 62.6591H243.177Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.194 62.543L243.14 62.5513L243.198 62.5451L243.194 62.543Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.627 62.5114L243.654 62.5261L243.612 62.501L243.627 62.5114Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.629 62.4827C243.652 62.4932 243.671 62.4911 243.683 62.4973C243.679 62.4932 243.66 62.4848 243.642 62.4785C243.652 62.4827 243.648 62.4827 243.627 62.4827H243.629Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.616 62.4658C243.616 62.4658 243.631 62.4722 243.642 62.4765C243.635 62.4744 243.629 62.4701 243.616 62.4658Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.554 62.5198C243.554 62.5198 243.583 62.5219 243.593 62.5156H243.556L243.554 62.5198Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.556 62.5142C243.556 62.5142 243.56 62.5032 243.56 62.501C243.56 62.501 243.558 62.5076 243.554 62.5142H243.556Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.199 62.5965C243.222 62.5902 243.252 62.5923 243.26 62.5547C243.237 62.5651 243.231 62.5861 243.199 62.5965Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.508 62.5195L243.495 62.5363C243.495 62.5363 243.518 62.5363 243.526 62.5467L243.508 62.5195Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.497 62.5068L243.508 62.5201L243.512 62.5134L243.497 62.5068Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.583 62.4619C243.568 62.4535 243.568 62.4494 243.566 62.4473C243.558 62.4473 243.554 62.4494 243.552 62.4556C243.562 62.4598 243.581 62.4682 243.581 62.4619H243.583Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.569 62.4498L243.562 62.4424L243.569 62.4498Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.545 62.4531C243.545 62.4531 243.545 62.4619 243.556 62.4664C243.554 62.4619 243.551 62.4575 243.554 62.4531C243.549 62.4531 243.545 62.4509 243.547 62.4531H243.545Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.564 62.4404C243.564 62.4404 243.579 62.449 243.586 62.4511C243.577 62.4468 243.573 62.4447 243.564 62.4404Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.575 62.4786C243.575 62.4786 243.562 62.4701 243.556 62.4658C243.556 62.4701 243.56 62.4744 243.566 62.4786C243.568 62.4786 243.573 62.4786 243.577 62.4786H243.575Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.433 62.256C243.452 62.2851 243.458 62.3184 243.423 62.3038C243.429 62.3329 243.519 62.3995 243.563 62.4432C243.552 62.4328 243.542 62.4224 243.536 62.4016C243.523 62.3891 243.492 62.3849 243.477 62.3558C243.477 62.3309 243.496 62.3558 243.513 62.3641C243.479 62.335 243.494 62.3038 243.456 62.2539C243.456 62.2643 243.454 62.2726 243.452 62.283C243.446 62.2747 243.444 62.2581 243.433 62.256Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.542 62.43L243.517 62.4111C243.546 62.4321 243.565 62.451 243.592 62.4762C243.582 62.4636 243.573 62.4552 243.567 62.4468H243.563L243.533 62.4237L243.542 62.43Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.564 62.4412C243.531 62.4244 243.52 62.4118 243.484 62.395C243.482 62.4055 243.51 62.416 243.522 62.4265C243.518 62.4118 243.541 62.437 243.562 62.4391C243.569 62.4433 243.569 62.4433 243.571 62.4454C243.575 62.4454 243.581 62.4454 243.588 62.4496H243.585C243.585 62.4496 243.579 62.4454 243.581 62.4475C243.581 62.4475 243.573 62.4433 243.569 62.4412C243.575 62.4454 243.577 62.4454 243.581 62.4475H243.585V62.4496L243.564 62.437L243.554 62.4307L243.491 62.3887L243.495 62.3929L243.503 62.3971L243.518 62.4076C243.518 62.4076 243.503 62.3971 243.497 62.3929L243.491 62.3887H243.487L243.55 62.4286H243.554C243.554 62.4286 243.56 62.4349 243.562 62.437L243.564 62.4412Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.33 62.5177C243.33 62.5177 243.326 62.5219 243.324 62.5239H243.326L243.358 62.5156C243.358 62.5156 243.355 62.5135 243.353 62.5156L243.33 62.5219C243.33 62.5219 243.33 62.5219 243.33 62.5198V62.5177Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.379 62.5068C243.379 62.5068 243.385 62.511 243.389 62.5131C243.389 62.5131 243.391 62.5152 243.393 62.5172V62.5214L243.307 62.5422C243.312 62.5297 243.32 62.5297 243.328 62.5214C243.318 62.5256 243.297 62.5276 243.295 62.5505H243.301L243.404 62.5276L243.408 62.5256C243.41 62.5256 243.414 62.5235 243.418 62.5214C243.424 62.5214 243.433 62.5172 243.441 62.5172C243.456 62.5152 243.468 62.5131 243.47 62.5172C243.437 62.5131 243.414 62.511 243.381 62.511L243.379 62.5068Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.467 62.451L243.456 62.4238H243.423L243.442 62.4301C243.431 62.4406 243.454 62.4447 243.469 62.4489L243.467 62.451Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.579 62.46L243.604 62.4892C243.591 62.4746 243.581 62.46 243.57 62.4453L243.579 62.46Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.583 62.4512L243.604 62.4784L243.591 62.4616L243.583 62.4512Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.77 63.2705L243.766 63.2812C243.766 63.2812 243.77 63.2726 243.77 63.2705Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.827 63.2588L243.822 63.2412C243.822 63.2412 243.822 63.2588 243.827 63.2588Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.961 62.6592C243.919 62.676 243.847 62.6991 243.904 62.6823L243.959 62.6655C243.946 62.6655 243.95 62.6655 243.961 62.6592Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.235 62.9319L244.251 62.9361C244.239 62.9277 244.226 62.9194 244.216 62.9131C244.222 62.9194 244.23 62.9256 244.237 62.9319H244.235Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.394 63.0188L244.35 63.0146C244.362 63.0167 244.377 63.0188 244.394 63.0188Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.443 63.4229L243.431 63.4668C243.456 63.4584 243.443 63.4417 243.443 63.4229Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.721 62.5486C243.725 62.5653 243.729 62.5737 243.735 62.5779C243.733 62.5528 243.735 62.5214 243.721 62.5486Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.683 62.8896C243.683 62.8896 243.68 62.9046 243.683 62.9131C243.687 62.9046 243.687 62.8982 243.683 62.8896Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.761 62.5891C243.761 62.5891 243.761 62.5825 243.761 62.5781C243.752 62.5803 243.743 62.5825 243.734 62.5781C243.737 62.598 243.743 62.6112 243.763 62.5891H243.761Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.723 62.3902C242.723 62.3902 242.726 62.3902 242.73 62.3828C242.723 62.3828 242.723 62.3828 242.723 62.3902Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.005 62.3262C243.005 62.3262 242.996 62.3262 242.989 62.3262C242.991 62.3284 242.996 62.3284 243.005 62.3262Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.528 62.3458C243.528 62.3458 243.535 62.3369 243.537 62.3281C243.533 62.3369 243.53 62.3414 243.528 62.3458Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.506 62.4736C243.506 62.4736 243.508 62.4847 243.51 62.4891C243.51 62.4847 243.51 62.4802 243.506 62.4736Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.502 62.4915C243.502 62.4915 243.497 62.4867 243.497 62.4844C243.495 62.4915 243.493 62.4938 243.502 62.4915Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.52 62.4968C243.52 62.4968 243.514 62.4926 243.51 62.4883C243.51 62.4904 243.51 62.4926 243.51 62.4947C243.512 62.4947 243.516 62.4947 243.52 62.4947V62.4968Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.957 62.9759H242.959C242.941 62.9692 242.944 62.9714 242.957 62.9759Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.641 62.6967C244.587 62.6863 244.589 62.6821 244.595 62.6738L244.484 62.6863L244.641 62.6967Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.648 63.3206L243.675 63.3456C243.671 63.4038 243.652 63.3913 243.681 63.4288C243.648 63.3185 243.741 63.3976 243.71 63.2873L243.729 63.306C243.729 63.306 243.727 63.3123 243.723 63.3123C243.76 63.358 243.714 63.227 243.75 63.2353C243.762 63.2416 243.775 63.254 243.771 63.2707L243.785 63.2374C243.785 63.2374 243.796 63.2582 243.789 63.2561L243.823 63.2374V63.2416C243.823 63.2228 243.827 63.1937 243.829 63.1792C243.841 63.1916 243.829 63.1916 243.833 63.2062L243.846 63.1729C243.862 63.2 243.854 63.2312 243.839 63.2312C243.889 63.3372 243.848 63.1979 243.906 63.252L243.891 63.2707C243.921 63.331 243.929 63.304 243.96 63.3372C243.95 63.3185 243.891 63.2499 243.904 63.2166C243.912 63.2228 243.921 63.2249 243.927 63.2C243.935 63.2395 243.952 63.2249 243.973 63.2166L243.989 63.2686C244.012 63.2457 243.998 63.2208 244.004 63.1937C244.033 63.1916 244.058 63.227 244.083 63.2582C244.135 63.252 244.018 63.2062 244.068 63.1812C244.116 63.1896 244.131 63.1604 244.148 63.123C244.185 63.1313 244.166 63.1521 244.187 63.1625L244.177 63.1209C244.177 63.1209 244.191 63.1313 244.195 63.1376C244.2 63.1188 244.156 63.0939 244.168 63.0731C244.123 63.0273 244.293 63.1209 244.264 63.0585C244.287 63.0668 244.293 63.0835 244.314 63.096C244.314 63.046 244.318 63.0564 244.289 63.0065L244.352 63.0169C244.289 63.0024 244.262 62.9628 244.235 62.9337C244.204 62.9233 244.179 62.915 244.166 62.9108C244.162 62.9004 244.158 62.8921 244.152 62.8817C244.166 62.8859 244.189 62.8984 244.216 62.915L244.204 62.9046C244.243 62.915 244.275 62.9316 244.3 62.9504C244.285 62.9462 244.268 62.942 244.252 62.9379C244.281 62.9587 244.314 62.9836 244.35 63.0003C244.345 62.9961 244.343 62.9899 244.343 62.9878C244.352 62.994 244.358 62.9982 244.366 63.0003C244.375 63.0024 244.364 62.994 244.354 62.9836L244.429 63.0107L244.404 62.9961H244.431L244.491 62.9899C244.45 62.94 244.36 62.89 244.368 62.8609C244.412 62.8796 244.454 62.8838 244.514 62.9004C244.437 62.89 244.516 62.9337 244.481 62.9462C244.5 62.94 244.527 62.9504 244.535 62.9566C244.527 62.94 244.518 62.9233 244.508 62.9067C244.558 62.9212 244.554 62.9108 244.581 62.9067C244.475 62.888 244.535 62.8672 244.518 62.8505C244.552 62.8547 244.581 62.8651 244.56 62.8796C244.645 62.8755 244.468 62.838 244.543 62.8339C244.541 62.838 244.535 62.838 244.55 62.8422C244.531 62.8297 244.57 62.8151 244.591 62.8214V62.8256C244.625 62.8006 244.585 62.7091 244.508 62.7111C244.518 62.7111 244.602 62.7153 244.616 62.7174C244.516 62.6945 244.454 62.682 244.262 62.682C244.418 62.6758 244.535 62.6487 244.597 62.6716C244.604 62.6633 244.61 62.6529 244.575 62.6404C244.568 62.6467 244.481 62.6612 244.47 62.655C244.535 62.63 244.504 62.6404 244.554 62.6092C244.543 62.6196 244.425 62.6259 244.42 62.6155C244.439 62.6155 244.531 62.5967 244.547 62.5988C244.504 62.5947 244.458 62.5926 244.412 62.5905C244.437 62.5926 244.508 62.5739 244.533 62.5593C244.514 62.5676 244.512 62.5323 244.493 62.5281L244.479 62.5468C244.462 62.5115 244.293 62.5614 244.268 62.5406C244.293 62.5343 244.412 62.5011 244.408 62.4823C244.377 62.4886 244.304 62.5073 244.231 62.5281C244.148 62.5551 244.066 62.5801 244.037 62.5884L244.066 62.5697L244.016 62.5822C244.058 62.5614 244.137 62.5281 244.212 62.5052C244.285 62.4823 244.36 62.4678 244.404 62.4615C244.414 62.4428 244.435 62.4428 244.412 62.4303C244.433 62.4116 244.466 62.4199 244.475 62.4241L244.441 62.3763C244.385 62.4075 244.339 62.3804 244.293 62.4095C244.333 62.4095 244.373 62.4095 244.412 62.4137C244.354 62.4428 244.21 62.4803 244.189 62.4615C244.202 62.4428 244.295 62.4012 244.314 62.3908C244.289 62.3991 244.239 62.395 244.25 62.3825L244.295 62.3721C244.291 62.343 244.189 62.4054 244.208 62.3534C244.202 62.3471 244.235 62.2847 244.206 62.3097C244.175 62.3679 244.008 62.5156 243.966 62.551C243.971 62.5468 243.987 62.4927 243.998 62.4615C244.016 62.4137 244.1 62.3721 244.116 62.3326C244.106 62.3451 244.083 62.3575 244.077 62.3596C244.077 62.3451 244.112 62.3222 244.085 62.318C244.046 62.3638 244.043 62.2951 244.046 62.3534C244.016 62.3596 244.031 62.3347 244.004 62.3263C243.991 62.3617 243.923 62.4303 243.906 62.4407C243.912 62.4283 243.916 62.4075 243.918 62.3991C243.887 62.3804 243.881 62.3492 243.85 62.3367C243.852 62.3222 243.843 62.3014 243.86 62.2806C243.852 62.2889 243.841 62.3055 243.831 62.3014C243.831 62.2473 243.854 62.3014 243.864 62.2411C243.85 62.2723 243.823 62.2743 243.802 62.2868C243.787 62.3367 243.829 62.3097 243.85 62.2951C243.823 62.3617 243.771 62.422 243.727 62.4387C243.696 62.4449 243.733 62.3908 243.727 62.3991C243.685 62.3679 243.641 62.499 243.621 62.4345C243.621 62.3867 243.652 62.3492 243.66 62.318C243.687 62.3097 243.681 62.3575 243.696 62.3617L243.687 62.3347C243.7 62.3243 243.716 62.318 243.721 62.3347C243.721 62.291 243.644 62.2951 243.621 62.2431C243.608 62.2556 243.591 62.2639 243.591 62.2847H243.606C243.604 62.3222 243.566 62.3222 243.575 62.3451C243.55 62.3638 243.519 62.3929 243.504 62.3659L243.519 62.3159C243.514 62.3305 243.523 62.3513 243.533 62.3388C243.525 62.3471 243.523 62.3284 243.519 62.3139C243.519 62.3097 243.516 62.3076 243.514 62.3035H243.512V62.2993L243.527 62.2598C243.525 62.266 243.525 62.2743 243.527 62.2827C243.527 62.2764 243.527 62.266 243.527 62.2639V62.2598L243.496 62.3451V62.3492V62.3596L243.492 62.3638H243.489V62.3659L243.529 62.2598C243.529 62.2598 243.529 62.266 243.529 62.2743C243.529 62.2847 243.533 62.3035 243.539 62.3222C243.546 62.3409 243.554 62.3617 243.564 62.3825C243.573 62.4033 243.591 62.4303 243.583 62.4199C243.587 62.4262 243.589 62.4283 243.589 62.4324C243.589 62.4283 243.585 62.4262 243.585 62.4262C243.579 62.4158 243.579 62.4179 243.579 62.4158C243.579 62.4158 243.579 62.4158 243.556 62.3679C243.569 62.395 243.539 62.3367 243.531 62.2951C243.531 62.2847 243.529 62.2785 243.531 62.2702C243.531 62.2681 243.531 62.266 243.531 62.2639L243.467 62.4366C243.467 62.4366 243.471 62.4303 243.473 62.4262C243.473 62.4241 243.473 62.4199 243.475 62.4158V62.4095V62.4054V62.4033V62.4075V62.4137C243.475 62.4137 243.475 62.4199 243.475 62.4241C243.475 62.4303 243.475 62.4345 243.475 62.4387C243.475 62.447 243.477 62.4511 243.479 62.4553C243.483 62.4636 243.489 62.4719 243.487 62.5031C243.494 62.4865 243.492 62.4699 243.506 62.4844C243.508 62.4803 243.512 62.474 243.514 62.4719C243.514 62.4699 243.514 62.4699 243.514 62.4719C243.514 62.4636 243.514 62.4532 243.514 62.4449C243.535 62.4116 243.56 62.422 243.577 62.4075C243.583 62.4199 243.566 62.4241 243.564 62.4428L243.587 62.4199C243.575 62.4553 243.589 62.4886 243.56 62.5011L243.579 62.5115C243.583 62.5364 243.596 62.551 243.612 62.5406C243.619 62.5531 243.652 62.5115 243.633 62.5364L243.673 62.5281L243.669 62.5364C243.698 62.5531 243.756 62.5052 243.766 62.5822C243.781 62.578 243.796 62.5718 243.808 62.5884L243.8 62.6196C243.816 62.6134 243.831 62.6675 243.839 62.6342C243.804 62.7153 243.843 62.6571 243.841 62.6737L243.871 62.6404C243.871 62.6404 243.887 62.6363 243.91 62.6279L243.941 62.6009C243.979 62.5822 243.941 62.63 243.954 62.63C243.937 62.6383 243.939 62.6363 243.946 62.63C243.908 62.6612 243.927 62.6529 243.958 62.6446C243.987 62.6363 244.025 62.6279 243.989 62.6487C244.01 62.6425 244.008 62.6487 243.996 62.6529C243.996 62.6529 243.996 62.6529 243.991 62.6529C243.991 62.6529 243.975 62.6633 243.966 62.6654C243.979 62.6612 243.987 62.655 243.991 62.6529C243.996 62.6529 244.004 62.6529 244.023 62.6529L243.964 62.6716C243.964 62.6716 243.964 62.6716 243.966 62.6716C243.946 62.6799 243.998 62.6654 244.041 62.6508C244.054 62.6508 244.066 62.6467 244.083 62.6446C243.985 62.6737 244.129 62.6446 244.023 62.6737C244.081 62.6633 244.081 62.6779 244.208 62.6633C244.191 62.6654 244.185 62.6675 244.183 62.6654C244.175 62.6716 244.164 62.6779 244.206 62.6779L244.114 62.6883C244.158 62.6883 244.206 62.6883 244.252 62.6883C244.202 62.6987 244.166 62.7028 244.087 62.7028C244.214 62.7091 244.141 62.707 244.27 62.7216H244.204C244.204 62.7216 244.304 62.7382 244.25 62.7403C244.185 62.7424 244.198 62.7632 244.175 62.7736C244.156 62.7819 244.133 62.7943 244.071 62.7881C244.245 62.8297 243.983 62.7756 244.112 62.811C244.073 62.8006 244.048 62.7964 244.016 62.7839C244.041 62.8027 243.946 62.7715 244.033 62.811C244 62.7964 243.983 62.7902 243.962 62.7839C243.968 62.7881 243.989 62.7964 243.968 62.7902C243.948 62.7819 243.941 62.7777 243.927 62.7715C243.927 62.7736 243.956 62.7902 243.998 62.8089C244.033 62.8255 244.075 62.8443 244.114 62.863C244.06 62.8484 244.064 62.8505 244.114 62.8838C244.081 62.8713 244.048 62.8568 244.05 62.8484C244.037 62.8484 243.979 62.838 244.037 62.8776C244.021 62.8692 244.025 62.8776 244.029 62.8817C244.01 62.8838 244.004 62.8817 243.996 62.89L244.008 62.8963C244.062 62.9483 244.008 62.9129 244.002 62.9212L243.998 62.915C243.933 62.8838 243.998 62.9379 243.935 62.9004L243.962 62.9358C244.012 63.0128 243.904 62.8984 243.908 62.9316L243.925 62.9504C243.925 62.9816 243.848 62.8484 243.844 62.838C243.839 62.8318 243.841 62.8255 243.839 62.8214C243.812 62.7756 243.856 62.8713 243.848 62.888C243.835 62.8609 243.835 62.8151 243.816 62.8151C243.802 62.7943 243.791 62.9192 243.754 62.8734C243.764 62.8942 243.777 62.9129 243.769 62.9316C243.752 62.9441 243.696 62.8651 243.698 62.9379C243.694 62.9337 243.691 62.9275 243.689 62.9212C243.681 62.942 243.652 62.9628 243.654 63.0024C243.6 62.8713 243.587 63.0939 243.548 62.9712L243.506 62.992V62.9795C243.473 62.9795 243.473 63.0148 243.473 63.046C243.462 63.0398 243.464 63.0273 243.462 63.0211C243.417 63.0107 243.431 63.0107 243.419 63.0835L243.41 63.0419C243.404 63.071 243.379 62.9857 243.358 63.0419C243.358 63.0356 243.36 63.0273 243.362 63.0211C243.348 63.0523 243.339 63.0211 243.335 63.0024C243.331 62.9836 243.329 62.9795 243.285 63.0627C243.273 63.0752 243.26 63.0856 243.248 63.096C243.267 63.1209 243.206 63.1667 243.204 63.2C243.183 63.202 243.204 63.1292 243.221 63.1313V63.1417C243.269 63.0606 243.208 63.0876 243.248 63.0336C243.217 62.9961 243.25 62.9275 243.242 62.8963L243.185 62.9233V62.9046C243.185 62.9046 243.227 62.8838 243.229 62.8963C243.26 62.8817 243.194 62.8859 243.181 62.888C243.196 62.8505 243.254 62.8796 243.252 62.8692L243.244 62.8588L243.237 62.863C243.21 62.8609 243.183 62.8672 243.181 62.8464C243.19 62.8318 243.217 62.8297 243.217 62.8235C243.221 62.8235 243.223 62.8193 243.217 62.8151V62.786L243.171 62.8089C243.144 62.8027 243.167 62.7819 243.117 62.8089C243.194 62.7673 243.121 62.6924 243.144 62.6737C243.104 62.6633 243.102 62.6446 243.102 62.6196C243.094 62.6279 243.04 62.6425 243.042 62.6196C243.154 62.6051 243.083 62.5739 243.16 62.5406C243.11 62.5655 243.135 62.4865 243.065 62.5239C243.071 62.5052 243.106 62.5156 243.129 62.4969C243.077 62.4657 243.14 62.4033 243.115 62.3534C243.1 62.3555 243.079 62.3679 243.056 62.3617L243.123 62.3201C243.123 62.3201 243.037 62.3284 243.083 62.2993C243.071 62.3035 243.054 62.3118 243.048 62.3076C243.079 62.239 243.035 62.187 243.023 62.1267L242.877 62.2847C242.917 62.2889 242.954 62.3055 242.988 62.3638C242.977 62.3326 242.987 62.3326 242.998 62.3326C242.992 62.3243 243.002 62.2951 243.004 62.2764L243.04 62.3367C243.054 62.2827 243.085 62.3367 243.096 62.2847L243.081 62.2931C243.106 62.2327 243.073 62.1495 243.085 62.0705C243.056 62.1391 243.046 61.9582 243.002 62.0559C242.998 62.0393 243.01 62.031 243.01 62.0123C242.998 62.0455 242.987 62.0518 242.971 62.0331L242.975 62.0247C242.95 62.0247 242.931 62.0185 242.915 62.006L242.819 61.9395L242.75 62.1828C242.744 62.2036 242.733 62.2286 242.729 62.2598L242.767 62.2473C242.765 62.2598 242.752 62.266 242.744 62.2743C242.806 62.2743 242.74 62.239 242.808 62.2369C242.731 62.2702 242.825 62.3243 242.738 62.3555C242.742 62.3742 242.781 62.3409 242.785 62.3596L242.763 62.37H242.796C242.794 62.3804 242.765 62.3929 242.744 62.3991C242.744 62.395 242.735 62.3929 242.733 62.3887C242.708 62.4095 242.752 62.4303 242.744 62.4366L242.756 62.4158C242.79 62.4615 242.769 62.5281 242.829 62.5697L242.848 62.5614C242.89 62.5926 242.833 62.5967 242.858 62.6342H242.854C242.875 62.6383 242.885 62.6487 242.885 62.6591C242.863 62.6529 242.848 62.6883 242.821 62.6779C242.867 62.7132 242.854 62.6924 242.929 62.707L242.9 62.7195C242.929 62.7236 242.944 62.7195 242.958 62.7403C242.927 62.7278 242.915 62.7652 242.875 62.7528C242.819 62.8131 242.958 62.8047 242.865 62.8484C242.954 62.8484 242.902 62.7985 242.923 62.8048C242.948 62.7881 242.99 62.8047 242.985 62.8214C242.985 62.8359 242.883 62.8734 242.896 62.9108C242.896 62.9067 242.89 62.9088 242.888 62.9046C242.871 62.9254 242.923 62.9233 242.894 62.9504C242.948 62.9441 242.898 62.9732 242.963 62.9566L242.937 62.9275C242.96 62.942 243.04 62.9337 243.015 62.9795C243.002 62.9816 242.981 62.9795 242.969 62.9732C242.954 62.9899 242.987 62.9899 242.973 63.0065C242.91 63.0294 242.942 62.9608 242.888 62.9587C242.863 62.9753 242.946 62.9857 242.873 62.9961C242.967 62.9836 242.877 63.0481 242.954 63.0564L242.917 63.0731C242.917 63.0731 242.946 63.0793 242.948 63.0897L242.896 63.096C242.946 63.1043 242.881 63.1771 242.915 63.1916C242.89 63.1313 242.95 63.15 242.967 63.1084C243.035 63.1396 242.89 63.2124 242.95 63.2769C242.938 63.2707 242.948 63.2208 242.969 63.2249C242.969 63.2457 242.969 63.2728 242.96 63.2977C243 63.3352 242.983 63.2603 243.015 63.2603C242.994 63.3123 243.044 63.2665 243.067 63.2686L243.042 63.3019C243.069 63.3643 243.1 63.2436 243.121 63.3019C243.106 63.3144 243.09 63.3268 243.075 63.3372C243.085 63.3393 243.096 63.3393 243.104 63.3414L243.075 63.3788C243.119 63.3664 243.123 63.3788 243.146 63.4017C243.15 63.3726 243.179 63.3352 243.202 63.3393C243.21 63.3664 243.179 63.3747 243.217 63.3747C243.202 63.3976 243.179 63.4288 243.177 63.3872C243.171 63.3996 243.16 63.408 243.152 63.4204C243.16 63.4537 243.2 63.4392 243.215 63.4412C243.21 63.4392 243.204 63.435 243.202 63.4288C243.227 63.4142 243.25 63.3955 243.271 63.3768C243.275 63.3913 243.267 63.4038 243.256 63.4163C243.269 63.4121 243.279 63.3955 243.296 63.3892C243.285 63.4225 243.281 63.46 243.252 63.4745C243.273 63.4641 243.296 63.4475 243.314 63.435C243.314 63.4496 243.339 63.4745 243.331 63.487C243.367 63.5016 243.412 63.408 243.454 63.4163C243.454 63.408 243.458 63.4017 243.467 63.3934C243.504 63.3892 243.556 63.4121 243.579 63.3539L243.612 63.4059C243.627 63.3872 243.569 63.3414 243.594 63.3081C243.61 63.2811 243.619 63.3539 243.633 63.3664C243.633 63.3352 243.637 63.2686 243.675 63.3081C243.671 63.3206 243.662 63.3144 243.656 63.3206H243.648ZM243.902 63.2187C243.902 63.2187 243.896 63.2561 243.885 63.2353C243.879 63.1896 243.889 63.2083 243.902 63.2187ZM244.364 62.9524C244.364 62.9524 244.364 62.9608 244.35 62.9587C244.345 62.9587 244.341 62.9587 244.337 62.9587C244.337 62.9587 244.337 62.9587 244.339 62.9566C244.343 62.9545 244.35 62.9524 244.364 62.9545V62.9524ZM243.596 62.4948C243.6 62.5052 243.602 62.5135 243.596 62.4948V62.4948ZM243.579 62.4678C243.579 62.4678 243.573 62.4782 243.571 62.4823C243.577 62.474 243.581 62.474 243.585 62.4803C243.587 62.4699 243.585 62.4615 243.577 62.4678H243.579ZM243.196 62.8193L243.187 62.8256C243.173 62.8193 243.185 62.8193 243.196 62.8193Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.375 63.0091C244.375 63.0091 244.355 63.0025 244.347 62.998C244.351 63.0025 244.362 63.0091 244.375 63.0091Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.446 63.416L243.443 63.4231L243.446 63.416Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.116 62.3135C244.116 62.3135 244.118 62.3284 244.116 62.337C244.123 62.3284 244.127 62.3199 244.116 62.3135Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.517 62.2748C243.517 62.2748 243.517 62.2706 243.517 62.2686L243.438 62.4849H243.44L243.448 62.4828C243.444 62.4828 243.442 62.4786 243.442 62.4766V62.4724L243.517 62.2706V62.2748C243.517 62.2748 243.517 62.2686 243.517 62.2769V62.2748Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.401 62.3247C243.401 62.3247 243.399 62.329 243.401 62.3333L243.418 62.344C243.418 62.344 243.416 62.3205 243.401 62.3247Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.524 62.3185C243.524 62.3185 243.531 62.3436 243.531 62.3373C243.531 62.3373 243.531 62.3415 243.531 62.3457C243.541 62.3666 243.545 62.3729 243.545 62.3729C243.545 62.377 243.539 62.3624 243.537 62.352C243.533 62.3415 243.529 62.329 243.524 62.3164V62.3185Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.529 62.3467C243.529 62.3467 243.529 62.3511 243.524 62.3511C243.535 62.3687 243.529 62.3533 243.529 62.3467Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.541 62.4785C243.541 62.4785 243.522 62.5183 243.524 62.5036C243.503 62.5434 243.577 62.4681 243.541 62.4785Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.495 62.2559C243.501 62.2684 243.508 62.281 243.514 62.2956C243.512 62.2851 243.51 62.2726 243.508 62.2621L243.495 62.258V62.2559Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.571 62.3044L243.559 62.2852C243.559 62.2852 243.552 62.2958 243.548 62.298C243.558 62.3044 243.567 62.3172 243.571 62.3044Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.548 62.2969C243.548 62.2969 243.537 62.2925 243.53 62.2969C243.532 62.2969 243.541 62.2969 243.548 62.2969Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.522 62.2373C243.522 62.2373 243.527 62.2439 243.527 62.2483L243.538 62.2571C243.538 62.2571 243.531 62.2439 243.522 62.2373Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.747 62.3861L243.771 62.3817C243.778 62.3685 243.778 62.3575 243.767 62.3597C243.758 62.3685 243.749 62.3707 243.747 62.3861Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.735 62.2539C243.735 62.2539 243.735 62.2727 243.73 62.2874L243.751 62.2393L243.735 62.2539Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.793 62.2641C243.799 62.2515 243.835 62.2369 243.812 62.2285C243.803 62.2411 243.78 62.2452 243.793 62.2641Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.054 62.4424H244.047L243.984 62.5096L244.054 62.4424Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.538 62.4913C244.538 62.4619 244.47 62.506 244.479 62.4766C244.449 62.4808 244.472 62.4997 244.447 62.5018C244.485 62.506 244.479 62.5165 244.538 62.4913Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.054 62.3786L243.066 62.3995L243.06 62.3682L243.054 62.3786Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.091 62.3184L243.087 62.3727L243.102 62.3246C243.102 62.3246 243.091 62.3309 243.089 62.3184H243.091Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.984 63.3115V63.2982C243.973 63.285 243.966 63.285 243.953 63.2872C243.962 63.296 243.973 63.3049 243.984 63.3115Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.769 63.3292H243.773L243.752 63.2832L243.769 63.3292Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.637 63.4376C243.637 63.4376 243.647 63.4251 243.653 63.4251C243.643 63.4376 243.614 63.3791 243.637 63.4376Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.413 70.8669C230.413 70.8669 230.413 70.8334 230.413 70.8271C230.403 70.8376 230.415 70.8752 230.413 70.8669Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.487 71.0686L230.501 71.0728L230.468 71.0498L230.487 71.0686Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.503 70.9521C230.441 70.9542 230.507 70.9958 230.482 71.0146H230.468L230.516 71.0312C230.512 71.0042 230.485 70.9688 230.503 70.9521Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.332 71.1671C230.339 71.1429 230.343 71.1473 230.332 71.1583C230.332 71.1605 230.332 71.1627 230.332 71.1649V71.1671Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.349 71.1562L230.337 71.1751C230.332 71.1876 230.332 71.1918 230.326 71.2002C230.332 71.1897 230.341 71.1793 230.349 71.1562Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.374 71.1182L230.367 71.1246C230.367 71.1246 230.365 71.1331 230.374 71.1182Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.353 71.1394L230.367 71.1244C230.367 71.1244 230.38 71.0967 230.361 71.1287C230.37 71.1116 230.361 71.1287 230.353 71.1394Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.353 71.1286C230.355 71.1161 230.353 71.1056 230.368 71.0889C230.351 71.093 230.341 71.1349 230.353 71.1286Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.441 70.9375L230.422 70.9485L230.441 70.9617C230.441 70.9617 230.461 70.9397 230.441 70.9375Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.374 71.2138C230.374 71.2138 230.391 71.1825 230.399 71.1699L230.38 71.1741C230.38 71.1846 230.384 71.1992 230.374 71.2138Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.4 71.171L230.429 71.1644C230.418 71.1512 230.407 71.1578 230.4 71.171Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.41 71.0625C230.397 71.073 230.384 71.0834 230.374 71.096C230.387 71.0834 230.399 71.073 230.412 71.0646H230.41V71.0625Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.428 71.2582L230.4 71.2771L230.444 71.252L230.428 71.2582Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.467 71.2822C230.446 71.2969 230.45 71.322 230.434 71.3282C230.446 71.3324 230.467 71.322 230.486 71.3136C230.471 71.3157 230.465 71.3073 230.465 71.2822H230.467Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.519 71.3018C230.519 71.3018 230.499 71.3084 230.488 71.315C230.497 71.315 230.506 71.3106 230.519 71.3018Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.449 71.1895C230.449 71.1895 230.434 71.2145 230.438 71.2271L230.455 71.1936L230.449 71.1895Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.455 71.1914C230.455 71.1914 230.464 71.2024 230.466 71.2046C230.466 71.2046 230.462 71.2002 230.455 71.1914Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.413 71.1059C230.434 71.0954 230.465 71.0933 230.467 71.0557C230.447 71.0703 230.444 71.0933 230.413 71.1059Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.468 71.1458L230.457 71.127C230.457 71.127 230.447 71.1479 230.437 71.152L230.468 71.1437V71.1458Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.483 71.1416L230.468 71.146L230.472 71.1526L230.483 71.1416Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.511 71.2539C230.528 71.2455 230.536 71.2518 230.545 71.2539C230.54 71.2413 230.534 71.2309 230.526 71.2246C230.517 71.233 230.501 71.2455 230.511 71.2518V71.2539Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.486 71.2254H230.492C230.492 71.2254 230.492 71.2148 230.486 71.2254Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.625 71.3186L230.628 71.3115L230.623 71.3163L230.625 71.3186Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.528 71.2204C230.526 71.2097 230.516 71.214 230.505 71.2204C230.511 71.2204 230.52 71.2225 230.524 71.2268C230.528 71.2225 230.53 71.2204 230.526 71.2204H230.528Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.551 71.3059C230.551 71.3059 230.551 71.2888 230.551 71.2803C230.547 71.2931 230.542 71.3123 230.551 71.3059Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.484 71.2314C230.484 71.2314 230.499 71.225 230.508 71.2207C230.501 71.2207 230.495 71.2207 230.489 71.2207C230.489 71.2228 230.487 71.2271 230.484 71.2314Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.791 71.1515C230.77 71.1765 230.732 71.1889 230.741 71.1494C230.712 71.1577 230.653 71.2534 230.628 71.3117C230.636 71.3013 230.645 71.2888 230.672 71.2846C230.678 71.2659 230.666 71.2243 230.695 71.2097C230.726 71.2097 230.703 71.2326 230.703 71.2534C230.72 71.2139 230.766 71.2243 230.799 71.1723L230.768 71.1765C230.768 71.1765 230.789 71.1619 230.789 71.1515H230.791Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.601 71.2871H230.592C230.592 71.2871 230.592 71.3101 230.586 71.3394C230.607 71.3352 230.615 71.3268 230.624 71.3185L230.596 71.2913H230.601V71.2871Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.566 71.264C230.593 71.2391 230.618 71.237 230.633 71.1996C230.614 71.1871 230.601 71.2141 230.58 71.2183C230.616 71.2328 230.559 71.2287 230.568 71.2599C230.557 71.2599 230.551 71.2599 230.547 71.2557C230.549 71.264 230.551 71.2724 230.551 71.2807V71.2786C230.551 71.2786 230.553 71.2703 230.553 71.2744C230.553 71.2744 230.559 71.2682 230.564 71.264C230.568 71.2765 230.559 71.2724 230.553 71.2744L230.549 71.2786L230.591 71.2848C230.589 71.2765 230.578 71.2703 230.564 71.264H230.566Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.53 71.0039C230.53 71.0039 230.528 71.0103 230.525 71.0124C230.53 71.0103 230.532 71.0082 230.53 71.0039Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.528 71.0314C230.528 71.0314 230.511 71.0439 230.507 71.0356C230.507 71.0231 230.518 71.021 230.526 71.0127C230.516 71.0169 230.495 71.0231 230.497 71.046H230.501C230.505 71.0626 230.493 71.1105 230.486 71.1125C230.503 71.0834 230.513 71.0626 230.526 71.0314H230.528Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.553 71.1417L230.588 71.1459L230.595 71.1104L230.584 71.125C230.576 71.1083 230.563 71.1292 230.553 71.1396V71.1417Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.617 71.3343L230.59 71.3614L230.638 71.3301L230.617 71.3343Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.651 71.3555L230.63 71.3811L230.651 71.3726V71.3555Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.843 73.0488L230.832 73.0643C230.832 73.0643 230.841 73.0532 230.843 73.0488Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.932 73.0001L230.928 72.9824C230.928 72.9934 230.928 73.0023 230.932 73.0001Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.247 71.8193C231.209 71.8277 231.153 71.8298 231.197 71.8298H231.239C231.239 71.8298 231.239 71.8235 231.247 71.8193Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.18 72.3965H231.193C231.193 72.3965 231.173 72.3816 231.167 72.373C231.171 72.3795 231.175 72.388 231.182 72.3965H231.18Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.308 72.4805L231.277 72.4849C231.277 72.4849 231.297 72.4849 231.308 72.4805Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.342 73.0156L230.309 73.0344C230.327 73.0554 230.329 73.0303 230.342 73.0156Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.983 71.5966C230.983 71.6154 230.988 71.6259 230.992 71.6321C230.992 71.607 231.004 71.5736 230.983 71.5966Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.753 72.6426C230.753 72.6426 230.753 72.6597 230.757 72.6682C230.757 72.6597 230.757 72.6511 230.753 72.6426Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.02 71.6512C231.02 71.6512 231.02 71.6448 231.02 71.6406C231.009 71.6406 230.999 71.6406 230.992 71.6299C230.992 71.6491 230.992 71.6641 231.02 71.6512Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.187 71.531C230.187 71.531 230.189 71.531 230.192 71.5283C230.187 71.5283 230.184 71.5283 230.187 71.531Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.601 71.1973C230.601 71.1973 230.601 71.2083 230.601 71.2149C230.603 71.2127 230.605 71.2083 230.601 71.1973Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.825 71.3267C230.825 71.3267 230.834 71.3201 230.838 71.3135C230.832 71.3201 230.827 71.3245 230.825 71.3267Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.761 71.4617C230.761 71.4617 230.759 71.4553 230.756 71.4531C230.752 71.4574 230.75 71.4617 230.761 71.4617Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.78 71.4732C230.78 71.4732 230.774 71.4666 230.771 71.46C230.771 71.4622 230.771 71.4644 230.771 71.4666C230.774 71.4666 230.778 71.4688 230.782 71.4732H230.78Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.201 72.2333C230.201 72.2333 230.201 72.2333 230.206 72.2333C230.19 72.2223 230.192 72.2267 230.201 72.2333Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.544 72.0865V72.0791L231.54 72.0828L231.544 72.0865Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.553 72.1214C231.52 72.0881 231.528 72.0861 231.541 72.0798C231.507 72.0673 231.476 72.0507 231.442 72.0361L231.551 72.1214H231.553Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.615 73.1169C230.624 73.1273 230.634 73.1397 230.644 73.1501C230.599 73.2084 230.567 73.1834 230.594 73.2333C230.615 73.1252 230.738 73.2105 230.738 73.0877L230.761 73.1065C230.761 73.1065 230.755 73.1148 230.749 73.1148C230.796 73.1585 230.769 73.0212 230.817 73.017C230.836 73.017 230.851 73.0295 230.842 73.0482L230.871 73.0004C230.882 72.9962 230.886 73.017 230.876 73.0212C230.892 73.0066 230.911 72.9941 230.928 72.9796V72.9837C230.93 72.9609 230.932 72.9255 230.934 72.9109C230.955 72.9172 230.934 72.9255 230.944 72.9359L230.957 72.8922C230.984 72.9089 230.978 72.9505 230.955 72.9629C231.042 73.042 230.963 72.9234 231.059 72.9276C231.053 72.9401 231.046 72.9525 231.04 72.9629C231.098 73.0004 231.109 72.9609 231.169 72.9546C231.144 72.9525 231.036 72.9401 231.048 72.8901C231.063 72.8901 231.075 72.8818 231.073 72.8506C231.103 72.8797 231.113 72.8527 231.125 72.834L231.167 72.8693C231.167 72.8423 231.144 72.8277 231.132 72.8028C231.148 72.7882 231.186 72.8111 231.217 72.8277C231.244 72.8049 231.148 72.8069 231.165 72.7674C231.198 72.757 231.192 72.7258 231.186 72.6801C231.213 72.6738 231.211 72.7009 231.228 72.705L231.203 72.6655C231.203 72.6655 231.215 72.6717 231.221 72.6759C231.215 72.6551 231.178 72.6447 231.178 72.6177C231.13 72.5802 231.278 72.626 231.234 72.5657C231.25 72.5677 231.261 72.5865 231.28 72.5948C231.263 72.5386 231.269 72.549 231.234 72.4908L231.277 72.4866C231.232 72.4825 231.205 72.4367 231.18 72.3972C231.159 72.393 231.142 72.3889 231.132 72.3889L231.123 72.3452C231.123 72.3452 231.148 72.3577 231.165 72.3743L231.157 72.3618C231.18 72.3618 231.205 72.3826 231.225 72.4055C231.215 72.4055 231.203 72.4013 231.19 72.3993C231.215 72.4221 231.242 72.4492 231.269 72.4637C231.265 72.4596 231.263 72.4513 231.263 72.4471C231.269 72.4533 231.275 72.4596 231.282 72.4617C231.288 72.4617 231.28 72.4533 231.269 72.4429L231.325 72.4658L231.305 72.4513L231.361 72.4305C231.323 72.3722 231.259 72.3036 231.263 72.2474C231.296 72.2807 231.325 72.2849 231.371 72.3119C231.315 72.2973 231.371 72.3577 231.35 72.3764C231.363 72.3681 231.382 72.3826 231.388 72.3889L231.367 72.3223C231.405 72.3431 231.4 72.3285 231.421 72.3265C231.342 72.2932 231.388 72.2682 231.375 72.2391C231.4 72.2516 231.423 72.2703 231.407 72.2869C231.475 72.2953 231.336 72.21 231.394 72.2141C231.392 72.2204 231.386 72.2204 231.398 72.2287C231.382 72.2058 231.415 72.1871 231.434 72.2058V72.2121C231.459 72.1829 231.488 72.1143 231.427 72.0727C231.436 72.0768 231.5 72.1205 231.513 72.1288C231.452 72.0727 231.396 72.0082 231.334 71.9541C231.384 71.9916 231.532 72.0311 231.54 72.0852C231.555 72.0789 231.573 72.0664 231.567 72.0332C231.555 72.0394 231.475 72.0144 231.475 72.002C231.555 72.002 231.519 72.002 231.594 71.9832C231.575 71.9916 231.488 71.9479 231.498 71.9354C231.511 71.9416 231.594 71.9583 231.6 71.9687C231.575 71.9437 231.552 71.9229 231.525 71.9042C231.538 71.9167 231.607 71.9208 231.638 71.9125C231.617 71.9146 231.654 71.8688 231.648 71.8543L231.619 71.873C231.648 71.8168 231.496 71.821 231.509 71.7815C231.527 71.7815 231.629 71.7815 231.642 71.7524C231.617 71.7503 231.559 71.7461 231.502 71.744C231.44 71.744 231.369 71.7524 231.344 71.7482L231.373 71.7316C231.359 71.7316 231.344 71.7316 231.33 71.7316C231.369 71.7191 231.446 71.6983 231.505 71.6983C231.563 71.6983 231.619 71.7087 231.65 71.7212C231.669 71.6941 231.682 71.7087 231.673 71.6754C231.696 71.6567 231.715 71.6837 231.719 71.6941C231.719 71.665 231.719 71.6359 231.713 71.6068C231.661 71.6296 231.634 71.5714 231.59 71.5964C231.621 71.6109 231.652 71.6276 231.679 71.6504C231.625 71.6671 231.515 71.6588 231.498 71.6255C231.511 71.6047 231.592 71.5839 231.611 71.5756C231.59 71.5756 231.548 71.5548 231.557 71.5423H231.598C231.598 71.5069 231.505 71.5485 231.521 71.4944C231.517 71.484 231.548 71.4196 231.521 71.4424C231.494 71.5007 231.336 71.6338 231.286 71.6733C231.29 71.6692 231.307 71.6109 231.317 71.5797C231.336 71.5319 231.419 71.4924 231.436 71.4528C231.425 71.4653 231.402 71.4757 231.394 71.4778C231.392 71.4632 231.43 71.4404 231.4 71.4362C231.361 71.482 231.352 71.4133 231.359 71.4716C231.325 71.4778 231.34 71.4528 231.311 71.4445C231.298 71.4799 231.232 71.5527 231.207 71.5589C231.215 71.5464 231.219 71.5277 231.221 71.5173C231.192 71.4944 231.192 71.457 231.163 71.4341C231.169 71.4216 231.163 71.3967 231.186 71.3821C231.175 71.3863 231.161 71.3988 231.15 71.3946C231.163 71.3405 231.175 71.405 231.198 71.3468C231.178 71.3717 231.146 71.3655 231.121 71.3717C231.094 71.4154 231.144 71.4029 231.171 71.3967C231.128 71.4528 231.061 71.4965 231.011 71.4986C230.976 71.4944 231.028 71.4528 231.017 71.4591C230.98 71.4133 230.903 71.5277 230.896 71.4591C230.909 71.4112 230.951 71.3863 230.967 71.3572C230.998 71.3572 230.98 71.4029 230.994 71.4133L230.99 71.3842C231.005 71.378 231.025 71.378 231.025 71.3946C231.038 71.353 230.953 71.328 230.94 71.2719C230.926 71.2802 230.905 71.2844 230.898 71.301L230.913 71.3052C230.901 71.3426 230.861 71.3301 230.865 71.353C230.834 71.3613 230.792 71.3821 230.784 71.3488L230.811 71.3052C230.803 71.3176 230.807 71.3405 230.821 71.3322C230.798 71.3447 230.832 71.2511 230.78 71.2968L230.773 71.3364C230.742 71.3447 230.69 71.3759 230.682 71.3468C230.659 71.3946 230.69 71.3468 230.667 71.4029C230.701 71.3343 230.713 71.4424 230.742 71.3655C230.713 71.432 230.748 71.4071 230.73 71.4695C230.74 71.4549 230.742 71.4383 230.755 71.457C230.759 71.4528 230.763 71.4508 230.767 71.4466C230.769 71.4466 230.769 71.4466 230.767 71.4466C230.767 71.4383 230.771 71.4279 230.776 71.4196C230.807 71.3946 230.832 71.4154 230.853 71.405C230.857 71.4196 230.836 71.4175 230.832 71.4362L230.863 71.4216C230.842 71.4528 230.851 71.4903 230.815 71.4924L230.834 71.509C230.834 71.536 230.844 71.5548 230.863 71.5485C230.867 71.5631 230.913 71.534 230.886 71.5506L230.932 71.5568L230.926 71.5652C230.953 71.5922 231.028 71.5652 231.021 71.6463C231.038 71.6463 231.055 71.6463 231.065 71.6671L231.048 71.6962C231.048 71.6962 231.078 71.7212 231.098 71.7399C231.119 71.7586 231.138 71.7669 231.15 71.7544C231.113 71.8356 231.155 71.7752 231.153 71.7919L231.184 71.7565C231.184 71.7565 231.203 71.7524 231.225 71.7461L231.259 71.7191C231.296 71.7045 231.255 71.7544 231.265 71.7628C231.248 71.769 231.25 71.7648 231.259 71.7586C231.219 71.7898 231.238 71.7836 231.261 71.7856C231.284 71.7856 231.311 71.7919 231.275 71.8064C231.292 71.8064 231.286 71.8127 231.275 71.8168C231.275 71.8168 231.275 71.8168 231.273 71.8168C231.273 71.8168 231.257 71.8231 231.248 71.8252C231.259 71.8231 231.269 71.821 231.273 71.8189C231.273 71.821 231.28 71.8252 231.288 71.8293L231.24 71.8335C231.221 71.8376 231.261 71.8376 231.296 71.8335C231.303 71.8356 231.311 71.8376 231.321 71.8397C231.246 71.8397 231.34 71.8564 231.261 71.8543C231.296 71.8626 231.278 71.8792 231.346 71.9042C231.336 71.9021 231.332 71.9042 231.334 71.898C231.321 71.9021 231.311 71.9063 231.325 71.9188L231.275 71.9021C231.294 71.9146 231.313 71.9292 231.332 71.9458C231.298 71.9416 231.282 71.9333 231.25 71.9084C231.292 71.9604 231.257 71.9437 231.294 71.9999L231.265 71.9812C231.261 71.9916 231.29 72.029 231.265 72.0228C231.196 72.0144 231.196 72.1309 231.113 72.158C231.205 72.1954 231.059 72.1621 231.125 72.2016C231.103 72.1933 231.088 72.1954 231.075 72.1767C231.08 72.2162 231.019 72.2016 231.065 72.2536C231.042 72.2453 231.038 72.2308 231.025 72.2266C231.028 72.2308 231.038 72.2453 231.025 72.2412C231.011 72.237 231.011 72.2266 231.005 72.2183C230.992 72.2495 231.053 72.2869 231.109 72.3244C231.073 72.3244 231.071 72.3327 231.105 72.366C231.082 72.3597 231.057 72.3556 231.061 72.3348C231.053 72.3431 230.996 72.3785 231.042 72.4076C231.028 72.4034 231.03 72.4201 231.034 72.4242C231.017 72.445 231.013 72.4429 231.003 72.4679H231.013C231.063 72.5095 231.013 72.4929 231.009 72.5137L231.003 72.5095C230.938 72.522 231.011 72.5386 230.94 72.5469L230.976 72.5677C231.044 72.6218 230.909 72.5719 230.921 72.6114L230.946 72.6177C230.961 72.6489 230.828 72.5781 230.811 72.5823C230.803 72.5802 230.805 72.5719 230.803 72.5636C230.746 72.5511 230.84 72.601 230.84 72.6218C230.817 72.6031 230.788 72.5719 230.78 72.5719C230.765 72.5532 230.823 72.6593 230.78 72.6218C230.792 72.6405 230.809 72.6572 230.811 72.6759C230.801 72.6946 230.753 72.6135 230.769 72.6884C230.765 72.6821 230.763 72.678 230.763 72.6717C230.763 72.6946 230.746 72.7175 230.746 72.7633C230.732 72.6863 230.726 72.7113 230.711 72.7362C230.699 72.7633 230.68 72.7903 230.69 72.7113C230.682 72.7154 230.671 72.7196 230.663 72.7217L230.667 72.705C230.655 72.6946 230.638 72.7279 230.617 72.7612C230.617 72.7487 230.626 72.7362 230.63 72.7279C230.621 72.6801 230.624 72.6905 230.567 72.7341L230.592 72.6905C230.569 72.705 230.621 72.6031 230.576 72.6218C230.58 72.6197 230.586 72.6135 230.592 72.6114C230.538 72.6114 230.678 72.5157 230.524 72.5449C230.507 72.5386 230.49 72.5345 230.476 72.5282C230.482 72.5719 230.413 72.549 230.397 72.574C230.382 72.5615 230.422 72.5157 230.438 72.5324L230.432 72.5386C230.509 72.5137 230.438 72.4804 230.49 72.4617C230.459 72.3889 230.49 72.3161 230.499 72.2807C230.478 72.2807 230.457 72.2807 230.436 72.2807L230.442 72.2557C230.457 72.2495 230.492 72.2495 230.486 72.2703C230.521 72.2641 230.461 72.2349 230.446 72.2328C230.476 72.1954 230.517 72.2557 230.519 72.2433V72.2266L230.509 72.2287C230.486 72.2141 230.459 72.21 230.465 72.185C230.48 72.1705 230.505 72.1808 230.507 72.1746C230.511 72.1746 230.513 72.1746 230.509 72.1663L230.519 72.1309L230.469 72.1413C230.446 72.1226 230.476 72.108 230.419 72.1184C230.507 72.1018 230.465 71.9895 230.494 71.977C230.461 71.952 230.465 71.9292 230.471 71.9042C230.461 71.9104 230.405 71.9084 230.415 71.8855C230.528 71.9063 230.469 71.848 230.553 71.8376C230.496 71.848 230.546 71.7711 230.467 71.7898C230.48 71.7711 230.509 71.794 230.538 71.7815C230.501 71.7316 230.58 71.6837 230.571 71.6255C230.557 71.6234 230.532 71.6296 230.513 71.6151L230.59 71.5943C230.584 71.5818 230.505 71.5735 230.559 71.5589C230.546 71.5589 230.528 71.5631 230.524 71.5548C230.609 71.4528 230.492 71.3218 230.64 71.224C230.609 71.2365 230.609 71.224 230.609 71.2136C230.601 71.2199 230.571 71.2095 230.553 71.2074L230.615 71.1679C230.561 71.1533 230.617 71.1179 230.565 71.1055L230.574 71.1221C230.513 71.0951 230.43 71.1325 230.351 71.12C230.419 71.1512 230.238 71.1658 230.336 71.2157C230.319 71.222 230.311 71.2053 230.292 71.2074C230.326 71.2199 230.332 71.2323 230.313 71.2511L230.305 71.2469C230.305 71.3072 230.269 71.328 230.238 71.3904H230.278C230.272 71.4029 230.257 71.405 230.247 71.4112C230.305 71.4341 230.255 71.3717 230.319 71.3946C230.236 71.4029 230.307 71.4944 230.213 71.4965C230.211 71.5173 230.261 71.4965 230.257 71.5173H230.232L230.263 71.5298C230.257 71.5444 230.224 71.5464 230.203 71.5444C230.205 71.5402 230.199 71.534 230.197 71.5298C230.165 71.5444 230.201 71.5839 230.19 71.588L230.209 71.5693C230.226 71.6317 230.184 71.7004 230.228 71.7628H230.247C230.276 71.8085 230.222 71.794 230.232 71.8439H230.228C230.244 71.8543 230.253 71.8668 230.249 71.8792C230.228 71.8647 230.203 71.898 230.18 71.8792C230.211 71.9312 230.207 71.9063 230.274 71.9437L230.242 71.9479C230.269 71.9604 230.284 71.9645 230.29 71.9895C230.265 71.9666 230.24 71.9999 230.207 71.9749C230.132 72.0186 230.267 72.056 230.163 72.0706C230.247 72.1018 230.217 72.0311 230.234 72.0456C230.263 72.0373 230.297 72.0706 230.286 72.0852C230.282 72.1018 230.172 72.1018 230.17 72.1434C230.17 72.1392 230.163 72.1392 230.165 72.1351C230.142 72.1476 230.192 72.1684 230.153 72.1829C230.205 72.1975 230.147 72.2058 230.213 72.2162L230.203 72.1767C230.217 72.1996 230.294 72.2266 230.251 72.2578C230.238 72.2537 230.222 72.2412 230.211 72.2349C230.19 72.2433 230.222 72.2537 230.201 72.2682C230.134 72.2537 230.192 72.2204 230.142 72.1913C230.113 72.1996 230.186 72.2391 230.115 72.2204C230.161 72.2328 230.157 72.2412 230.149 72.2557C230.142 72.2724 230.132 72.2932 230.167 72.3119H230.128C230.128 72.3119 230.153 72.3285 230.153 72.3389L230.099 72.3202C230.145 72.3514 230.065 72.3889 230.095 72.4159C230.084 72.3514 230.14 72.3951 230.165 72.366C230.23 72.4263 230.067 72.4263 230.107 72.5053C230.099 72.497 230.12 72.4596 230.142 72.4721C230.138 72.4887 230.128 72.5116 230.111 72.5282C230.134 72.5761 230.149 72.5074 230.178 72.522C230.136 72.5532 230.205 72.5386 230.226 72.5532L230.188 72.5677C230.182 72.6281 230.274 72.5511 230.261 72.6052L230.201 72.6093L230.224 72.626L230.178 72.6385C230.219 72.6489 230.215 72.6634 230.211 72.6863C230.236 72.6697 230.28 72.6593 230.29 72.678C230.274 72.7029 230.249 72.678 230.269 72.7154C230.242 72.7154 230.207 72.7154 230.238 72.6925C230.226 72.6946 230.213 72.6988 230.199 72.7009C230.176 72.7196 230.211 72.7466 230.219 72.7653C230.219 72.7591 230.217 72.7487 230.219 72.7425C230.247 72.757 230.272 72.7674 230.294 72.7757C230.286 72.7924 230.272 72.7924 230.259 72.7924C230.267 72.8028 230.288 72.8007 230.299 72.8153C230.269 72.8298 230.242 72.8527 230.215 72.834C230.236 72.8485 230.255 72.8631 230.276 72.8735C230.265 72.886 230.261 72.9317 230.247 72.9317C230.253 72.9837 230.34 72.9629 230.353 73.017C230.359 73.0129 230.365 73.0108 230.374 73.0149C230.397 73.0503 230.407 73.1148 230.469 73.0961C230.469 73.119 230.469 73.1418 230.474 73.1647C230.515 73.1647 230.463 73.0815 230.53 73.0815C230.578 73.0753 230.532 73.1356 230.544 73.1543C230.578 73.1314 230.624 73.069 230.657 73.1148C230.642 73.1273 230.632 73.1189 230.619 73.1231L230.615 73.1169ZM231.044 72.8881C231.044 72.9005 231.044 72.9359 231.023 72.9213C231.003 72.8777 231.023 72.8901 231.044 72.8881ZM231.271 72.3909C231.282 72.4013 231.271 72.4055 231.255 72.4034C231.255 72.3972 231.259 72.3909 231.271 72.3909ZM230.863 71.4965C230.863 71.509 230.863 71.5173 230.863 71.4965V71.4965ZM230.851 71.4653C230.851 71.4653 230.842 71.4736 230.838 71.4778C230.846 71.4716 230.851 71.4736 230.855 71.482C230.859 71.4716 230.861 71.4632 230.848 71.4653H230.851ZM230.484 72.1684L230.474 72.1725C230.463 72.158 230.474 72.1642 230.484 72.1684Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.293 72.4705C231.293 72.4705 231.278 72.464 231.271 72.4619C231.276 72.4683 231.284 72.4726 231.293 72.4705Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.35 73.0131L230.347 73.0107L230.343 73.0155L230.35 73.0131Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.438 71.4258C231.438 71.4258 231.44 71.4429 231.438 71.4514C231.444 71.4429 231.448 71.4343 231.438 71.4258Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.688 71.4284H230.71C230.71 71.4284 230.703 71.4177 230.705 71.4092C230.699 71.4177 230.695 71.4305 230.688 71.4284Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.716 71.1289C230.716 71.1289 230.711 71.1267 230.705 71.1289L230.694 71.1438C230.694 71.1438 230.72 71.1438 230.716 71.1289Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.757 71.3095C230.775 71.2803 230.761 71.2824 230.746 71.2803C230.715 71.3179 230.734 71.3137 230.755 71.3095H230.757Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.745 71.2791C230.745 71.2791 230.736 71.2769 230.734 71.2725C230.721 71.2879 230.734 71.2791 230.745 71.2791Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.809 71.4616C230.809 71.4511 230.779 71.495 230.786 71.4804C230.754 71.5118 230.851 71.4637 230.809 71.4616Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.818 71.2119L230.797 71.2496L230.822 71.2266L230.818 71.2119Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.88 71.2999L230.871 71.2764C230.871 71.2764 230.863 71.2849 230.858 71.2849C230.867 71.2934 230.873 71.3105 230.882 71.2999H230.88Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.857 71.2869C230.857 71.2869 230.846 71.2781 230.84 71.2825C230.842 71.2825 230.851 71.2891 230.857 71.2869Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.849 71.2207L230.847 71.2314L230.857 71.2421L230.849 71.2207Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.051 71.4425L231.076 71.4467C231.086 71.4362 231.086 71.4258 231.076 71.4258C231.066 71.43 231.055 71.43 231.049 71.4425H231.051Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.067 71.3073C231.067 71.3178 231.061 71.3262 231.055 71.3387L231.088 71.2969L231.067 71.3073Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.126 71.3389C231.136 71.3284 231.176 71.3263 231.153 71.3096C231.142 71.32 231.117 71.3158 231.126 71.3389Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.38 71.5568L231.374 71.5547L231.311 71.6219L231.38 71.5568Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.717 71.8095C231.743 71.7654 231.665 71.8032 231.694 71.7654C231.673 71.7591 231.671 71.7969 231.654 71.7885C231.675 71.8095 231.658 71.8242 231.719 71.8095H231.717Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.653 71.7884C231.653 71.7884 231.646 71.7818 231.64 71.7773C231.644 71.784 231.648 71.7862 231.653 71.7884Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.655 71.1424L230.675 71.127L230.645 71.1358L230.655 71.1424Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.595 71.1014H230.649L230.601 71.0889C230.601 71.093 230.607 71.1014 230.595 71.1014Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.182 72.9075L231.174 72.897C231.159 72.8908 231.153 72.897 231.143 72.9075C231.155 72.9075 231.17 72.9075 231.182 72.9075Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.821 73.1153H230.827L230.809 73.0693L230.821 73.1153Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.499 73.2087C230.512 73.2191 230.53 73.2087 230.543 73.2128C230.509 73.217 230.514 73.148 230.499 73.2087Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.743 64.2604C241.743 64.2604 241.718 64.2395 241.712 64.2354C241.712 64.2521 241.749 64.2646 241.743 64.2604Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.706 64.4954L241.702 64.4766V64.5477L241.706 64.4954Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.6 64.6075C241.608 64.6574 241.625 64.672 241.637 64.6678C241.646 64.6345 241.654 64.5971 241.666 64.595L241.675 64.6096L241.664 64.5264C241.656 64.5492 241.648 64.5867 241.637 64.6179C241.633 64.6408 241.627 64.6366 241.618 64.6304C241.612 64.6262 241.604 64.6179 241.6 64.6075Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.565 64.3848C241.56 64.4147 241.552 64.404 241.569 64.3997C241.569 64.3954 241.569 64.3933 241.569 64.3912C241.569 64.3912 241.567 64.3912 241.565 64.3848Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.539 64.381C241.539 64.381 241.55 64.3726 241.556 64.3663C241.56 64.3496 241.558 64.3433 241.564 64.335C241.556 64.3433 241.547 64.3538 241.539 64.3789V64.381Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.508 64.4102H241.519C241.519 64.4102 241.521 64.3992 241.508 64.4102Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.538 64.4014C241.538 64.4014 241.525 64.4056 241.519 64.4078C241.515 64.4185 241.506 64.4377 241.528 64.4078C241.517 64.4249 241.527 64.4099 241.538 64.4014Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.539 64.4189C241.539 64.4378 241.545 64.4587 241.526 64.4691C241.554 64.488 241.558 64.4273 241.539 64.4189Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.596 64.6951L241.617 64.7391C241.617 64.7391 241.627 64.7286 241.631 64.7223C241.625 64.7307 241.594 64.6659 241.596 64.6951Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.456 64.2373C241.443 64.2436 241.439 64.2708 241.429 64.2833L241.46 64.2959C241.456 64.2791 241.443 64.2519 241.458 64.2373H241.456Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.429 64.2835L241.383 64.2646C241.408 64.296 241.42 64.296 241.429 64.2835Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.464 64.4647C241.483 64.4647 241.5 64.4584 241.514 64.4521C241.498 64.4584 241.479 64.4605 241.458 64.4584L241.464 64.4647Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.346 64.1088H241.385L241.32 64.1025L241.346 64.1088Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.269 64.0257C241.3 64.0257 241.286 63.9795 241.311 63.9858C241.288 63.9648 241.252 63.9584 241.223 63.9521C241.248 63.9647 241.263 63.9858 241.271 64.0257H241.269Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.173 63.9404C241.185 63.9467 241.202 63.9488 241.221 63.953C241.208 63.9467 241.192 63.9425 241.173 63.9404Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.338 64.2025C241.338 64.2025 241.352 64.1774 241.342 64.1523L241.325 64.1879C241.325 64.1879 241.331 64.1963 241.336 64.2025H241.338Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.325 64.1896C241.312 64.1728 241.304 64.1624 241.302 64.1582C241.304 64.1624 241.312 64.1707 241.325 64.1896Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.341 64.2076V64.2002C241.341 64.2002 241.334 64.2076 241.341 64.2076Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.432 64.3769C241.398 64.3706 241.345 64.3412 241.356 64.4021C241.387 64.4021 241.381 64.3664 241.432 64.3769Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.32 64.25L241.345 64.2918C241.345 64.2918 241.358 64.2688 241.375 64.273L241.32 64.25Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.296 64.2396L241.321 64.2503L241.311 64.2354L241.296 64.2396Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.201 64.0214C241.175 64.015 241.159 63.9982 241.14 63.9814C241.152 64.0066 241.167 64.0297 241.186 64.0508C241.196 64.0465 241.222 64.0424 241.201 64.0214Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.261 64.1045H241.254C241.254 64.1045 241.254 64.1119 241.261 64.1045Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.99 63.79L240.987 63.7971L240.992 63.7948L240.99 63.79Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.183 64.0591C241.191 64.0801 241.206 64.0822 241.223 64.0842C241.21 64.0759 241.198 64.0633 241.185 64.0508C241.181 64.0508 241.177 64.055 241.183 64.0591Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.114 63.8959C241.114 63.9085 241.116 63.9231 241.121 63.9356C241.123 63.921 241.125 63.8917 241.114 63.8959Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.256 64.0931H241.261C241.261 64.0813 241.261 64.086 241.256 64.0931Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.256 64.0922C241.246 64.088 241.233 64.0859 241.221 64.0859C241.231 64.0943 241.242 64.1006 241.252 64.1048C241.252 64.1006 241.252 64.0964 241.256 64.0922Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.756 63.8588C240.787 63.8442 240.842 63.8713 240.84 63.9316C240.888 63.9545 240.959 63.863 240.988 63.7985C240.975 63.8047 240.963 63.813 240.923 63.7881C240.915 63.811 240.946 63.8942 240.898 63.8817C240.848 63.8422 240.879 63.8338 240.877 63.8006C240.856 63.8442 240.785 63.7673 240.739 63.8089L240.787 63.8442C240.787 63.8442 240.756 63.8422 240.756 63.8588Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.036 63.867L241.05 63.8795C241.042 63.8587 241.044 63.8379 241.05 63.8004C241.019 63.7859 241.007 63.788 240.996 63.7921L241.046 63.867H241.038H241.036Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.102 63.9485C241.064 63.9589 241.022 63.9319 241.008 63.9776C241.045 64.0213 241.058 63.9901 241.091 64.0068C241.025 63.9423 241.125 64.0151 241.098 63.9506C241.114 63.961 241.127 63.9714 241.137 63.9818C241.129 63.9672 241.125 63.9506 241.119 63.936V63.9402C241.119 63.9402 241.116 63.9485 241.114 63.9444C241.114 63.9444 241.106 63.9485 241.1 63.9485C241.089 63.9236 241.104 63.9402 241.114 63.9423H241.119V63.9402L241.045 63.8799C241.054 63.8986 241.068 63.9152 241.098 63.9485H241.102Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.264 64.4148C241.264 64.4148 241.267 64.4084 241.269 64.4063C241.26 64.4063 241.258 64.4062 241.264 64.4148Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.256 64.3728C241.256 64.3728 241.279 64.3687 241.291 64.3895C241.296 64.4103 241.279 64.3999 241.268 64.4082C241.285 64.4123 241.319 64.4269 241.306 64.3832H241.298C241.283 64.3458 241.287 64.2792 241.293 64.2813C241.275 64.3104 241.264 64.3333 241.256 64.3728Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.17 64.1635L241.104 64.1152V64.1656L241.119 64.153C241.142 64.1908 241.155 64.1698 241.17 64.1635Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241 63.7736L241.038 63.7589L240.971 63.7568L241 63.7736Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.948 63.7028L240.98 63.6861L240.95 63.6777L240.948 63.7028Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.514 62.124L242.537 62.1411C242.537 62.1411 242.52 62.1262 242.514 62.124Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.409 61.9707L242.392 61.9771C242.404 61.9771 242.413 61.9771 242.409 61.9707Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.583 61.8996C240.591 61.933 240.577 61.9811 240.591 61.9435L240.602 61.9058C240.602 61.9058 240.587 61.9058 240.583 61.8975V61.8996Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.289 61.7786L241.308 61.7723V61.7598C241.296 61.7598 241.281 61.7619 241.269 61.7639L241.306 61.7744L241.294 61.7807L241.289 61.7786Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.136 61.7795L241.152 61.7314C241.146 61.7419 241.14 61.7586 241.136 61.7795Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.879 63.0394L242.921 63.0603C242.914 63.0185 242.898 63.0394 242.879 63.0394Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.707 62.7753C240.715 62.742 240.715 62.7171 240.713 62.6963C240.7 62.7379 240.675 62.7712 240.707 62.7753Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.156 62.2869C242.169 62.2935 242.178 62.2935 242.185 62.2869C242.172 62.2781 242.163 62.2781 242.156 62.2869Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.692 62.6152C240.692 62.6152 240.69 62.6256 240.688 62.6319C240.698 62.6506 240.708 62.6693 240.713 62.6964C240.723 62.6652 240.723 62.636 240.692 62.6152Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.589 63.5338L241.596 63.5264C241.596 63.5264 241.589 63.5301 241.589 63.5338Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.625 64.2046C241.625 64.2046 241.618 64.1795 241.614 64.167C241.614 64.1754 241.614 64.1858 241.625 64.2046Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.848 63.3828C240.852 63.3849 240.854 63.402 240.848 63.3828V63.3828Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.729 63.514C240.729 63.514 240.718 63.5098 240.71 63.5098C240.718 63.5098 240.725 63.5098 240.729 63.514Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.838 63.4159C240.838 63.4159 240.842 63.3991 240.842 63.3887C240.842 63.3929 240.838 63.4012 240.838 63.4159Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.854 63.4072C240.854 63.4072 240.854 63.4205 240.854 63.4249C240.861 63.4249 240.865 63.4227 240.854 63.4072Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.84 63.3555C240.842 63.3659 240.844 63.3764 240.844 63.3889C240.844 63.3847 240.848 63.3827 240.848 63.3827C240.848 63.3764 240.844 63.368 240.84 63.3555Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.11 63.9726C242.11 63.9726 242.11 63.9704 242.115 63.9682C242.099 63.9461 242.102 63.9549 242.11 63.9726Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.031 61.9141L241.027 61.9178L241.031 61.9215V61.9141Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.816 62.0159C240.823 62.0283 240.827 62.0387 240.829 62.0491L241.102 61.9493C241.054 61.9431 241.043 61.9327 241.029 61.916L241.002 62.0221C241.027 62.0034 241.052 61.9826 241.085 61.9722L240.856 62.0575L240.816 62.0159Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.718 62.5152L242.726 62.4466C242.804 62.4944 242.806 62.5548 242.829 62.484C242.772 62.4986 242.749 62.4445 242.724 62.3904C242.697 62.3364 242.668 62.2844 242.616 62.3052C242.616 62.2885 242.618 62.274 242.62 62.2594C242.624 62.2698 242.631 62.2677 242.637 62.2802C242.647 62.1845 242.537 62.2677 242.502 62.1762C242.491 62.1429 242.491 62.1138 242.516 62.1263L242.449 62.0764C242.437 62.0576 242.458 62.0493 242.468 62.0701L242.389 61.9807H242.393C242.37 61.9765 242.322 61.9661 242.302 61.962C242.293 61.9287 242.32 61.964 242.327 61.9495L242.262 61.9204C242.266 61.8808 242.322 61.8995 242.352 61.937C242.393 61.8143 242.297 61.9141 242.245 61.7747L242.302 61.808C242.316 61.7331 242.264 61.7123 242.229 61.6354C242.233 61.6624 242.275 61.8101 242.2 61.7831C242.191 61.7623 242.17 61.7435 242.127 61.7373C242.152 61.7061 242.116 61.6874 242.075 61.6624L242.108 61.6208C242.054 61.6042 242.043 61.6291 242.004 61.6333C241.96 61.5979 241.968 61.5563 241.975 61.5189C241.895 61.4669 241.997 61.6083 241.895 61.5647C241.839 61.5085 241.779 61.5085 241.685 61.5043C241.643 61.469 241.706 61.4773 241.693 61.4565L241.635 61.4815C241.635 61.4815 241.633 61.4648 241.635 61.4607C241.593 61.4627 241.614 61.5106 241.554 61.5043C241.521 61.5563 241.464 61.3837 241.369 61.4357C241.35 61.4191 241.385 61.4045 241.383 61.3837C241.325 61.3962 241.298 61.4024 241.283 61.4107L241.085 61.496L241.114 61.5688C241.127 61.6 241.135 61.625 241.175 61.6666L241.15 61.7373C241.183 61.6832 241.239 61.7373 241.287 61.7872C241.304 61.7664 241.319 61.7498 241.327 61.7394L241.348 61.7789L241.433 61.9453L241.258 61.8184L241.219 61.7893C241.219 61.7747 241.239 61.7727 241.266 61.7706C241.26 61.7706 241.252 61.7664 241.246 61.7643C241.246 61.7269 241.279 61.7227 241.316 61.7227C241.314 61.7373 241.31 61.7519 241.308 61.7664H241.323L241.264 61.7893C241.233 61.7747 241.2 61.7664 241.173 61.7727C241.179 61.7768 241.187 61.7872 241.192 61.7997C241.181 61.7955 241.173 61.7935 241.169 61.7955C241.166 61.7955 241.169 61.7997 241.169 61.8018L241.394 61.7019C241.394 61.7019 241.381 61.7019 241.371 61.7019L241.41 61.6541L241.387 61.6645C241.379 61.6312 241.348 61.5626 241.312 61.521C241.162 61.4919 241.077 61.5667 240.946 61.5376C240.992 61.5085 240.979 61.4731 241 61.4253C241.01 61.4898 241.1 61.4378 241.164 61.4794C241.131 61.4586 241.15 61.4399 241.162 61.4357C241.114 61.4336 241.069 61.4336 241.027 61.4357C241.046 61.3962 241.014 61.3962 240.996 61.3691C240.992 61.4066 240.971 61.4149 240.948 61.4149L240.683 61.3962L240.777 61.5501C240.792 61.5751 240.796 61.6229 240.815 61.6499C240.787 61.6583 240.756 61.6458 240.754 61.5896C240.7 61.6624 240.862 61.6603 240.829 61.7435C240.823 61.7269 240.825 61.7165 240.81 61.7123C240.842 61.7477 240.862 61.8434 240.831 61.833L240.825 61.8184C240.833 61.8455 240.848 61.8767 240.86 61.9037C240.869 61.9203 240.879 61.937 240.889 61.9536C240.914 61.9869 240.914 62.0244 240.95 62.0368C240.942 62.0348 240.867 62.0119 240.852 62.0077C240.883 62.0264 240.912 62.041 240.935 62.0868L241.033 62.0514C240.971 62.0639 240.933 62.1034 240.869 62.1159C240.91 62.068 240.975 61.9349 241.025 61.9245L241.017 61.9141V61.91C241.017 61.91 241.021 61.9037 241.006 61.9245L240.985 61.9536C240.958 61.9911 240.931 62.016 240.919 62.0223C240.914 62.0223 240.912 62.0244 240.912 62.0244L241.069 62.0202V62.0119C241.067 62.0056 241.062 61.9973 241.06 61.9869C241.056 61.9994 241.035 62.014 241.014 62.0202H241.01H240.917V62.0223H240.973C240.973 62.0223 240.969 62.016 240.967 62.014C241.027 61.9349 241.004 61.9661 241.037 61.8475C241.031 61.885 240.935 61.8787 240.923 61.8413C240.937 61.8413 241.006 61.7935 241.023 61.808C240.979 61.7789 240.933 61.7602 240.887 61.7519C240.917 61.7623 240.954 61.7061 240.954 61.6624C240.954 61.6811 240.871 61.5771 240.829 61.5751C240.844 61.5896 240.854 61.6063 240.867 61.6208C240.808 61.573 240.754 61.5959 240.712 61.6208C240.669 61.6458 240.635 61.6791 240.583 61.677C240.596 61.6583 240.631 61.5563 240.558 61.5439C240.517 61.5938 240.467 61.7872 240.385 61.8392L240.365 61.8143L240.348 61.8247L240.335 61.7435V61.7519L240.34 61.7623C240.34 61.7623 240.35 61.7789 240.356 61.7872C240.398 61.8371 240.385 61.8205 240.39 61.833C240.383 61.8247 240.377 61.8163 240.371 61.808L240.36 61.7935C240.36 61.7935 240.342 61.7685 240.338 61.7581L240.333 61.7498V61.7456V61.7435L240.338 61.7727L240.344 61.7602L240.356 61.7373L240.381 61.6915C240.417 61.6291 240.456 61.5688 240.492 61.5355C240.446 61.5189 240.475 61.5043 240.413 61.5147C240.385 61.4919 240.442 61.4711 240.46 61.4669L240.315 61.4711C240.319 61.4856 240.315 61.496 240.306 61.5064L240.3 61.5147C240.3 61.5147 240.3 61.5147 240.294 61.5189C240.279 61.5231 240.267 61.5272 240.252 61.5335C240.211 61.5543 240.192 61.5751 240.179 61.5896C240.136 61.6479 240.133 61.6895 240.152 61.6978C240.158 61.677 240.167 61.6583 240.179 61.6354C240.2 61.6146 240.196 61.5834 240.3 61.548L240.369 61.5064C240.377 61.5335 240.36 61.5771 240.331 61.6146L240.321 61.6291L240.315 61.6354C240.315 61.6354 240.294 61.6437 240.288 61.6479C240.261 61.6687 240.256 61.6853 240.248 61.6999C240.233 61.7331 240.223 61.7581 240.211 61.7851C240.175 61.8205 240.125 61.7186 240.111 61.7123C240.111 61.7207 240.111 61.7352 240.106 61.7581C240.106 61.7706 240.102 61.7831 240.102 61.808C240.102 61.8184 240.102 61.833 240.106 61.8538C240.113 61.8808 240.111 61.8663 240.113 61.8725C240.123 61.8933 240.129 61.9141 240.123 61.9204L240.083 61.8892C240.075 61.9453 240.179 61.9557 240.142 62.0285C240.142 62.0514 240.088 62.1096 240.121 62.1055C240.175 62.0555 240.369 62.0015 240.423 62.014C240.421 62.0223 240.392 62.1408 240.367 62.172C240.327 62.2178 240.236 62.1471 240.2 62.1866C240.215 62.1845 240.24 62.1991 240.248 62.2053C240.242 62.2303 240.198 62.2053 240.219 62.2532C240.277 62.249 240.24 62.353 240.273 62.2656C240.302 62.3093 240.273 62.3197 240.292 62.3738C240.323 62.3468 240.429 62.3946 240.456 62.4383C240.442 62.4383 240.425 62.4528 240.419 62.4612C240.44 62.5589 240.427 62.6172 240.45 62.7087C240.44 62.7212 240.433 62.7669 240.404 62.7544C240.417 62.7648 240.44 62.7732 240.446 62.8002C240.408 62.8647 240.425 62.7399 240.375 62.794C240.408 62.7898 240.435 62.8564 240.463 62.8917C240.51 62.8688 240.454 62.796 240.425 62.7628C240.494 62.7461 240.585 62.8023 240.635 62.8938C240.667 62.9687 240.596 62.9354 240.608 62.9479C240.621 63.0956 240.752 63.0519 240.723 63.1788C240.685 63.2329 240.633 63.1975 240.604 63.2121C240.577 63.1517 240.617 63.1122 240.608 63.0685L240.596 63.1247C240.577 63.1081 240.558 63.0665 240.569 63.0415C240.535 63.0893 240.6 63.2869 240.588 63.4055C240.606 63.4221 240.629 63.4533 240.644 63.4325L240.629 63.3993C240.658 63.3597 240.694 63.4533 240.7 63.4055C240.735 63.445 240.787 63.4845 240.785 63.5511L240.74 63.5781C240.754 63.5719 240.758 63.5282 240.737 63.5157C240.767 63.5345 240.698 63.6322 240.773 63.6343C240.779 63.6156 240.785 63.5989 240.792 63.5823C240.829 63.6135 240.898 63.6322 240.908 63.6821C240.942 63.6385 240.898 63.6738 240.935 63.6177C240.877 63.6759 240.894 63.5116 240.837 63.5802C240.894 63.5303 240.846 63.5095 240.892 63.445C240.875 63.4513 240.865 63.4721 240.86 63.4242C240.854 63.4242 240.848 63.4201 240.844 63.418V63.4138V63.4159C240.84 63.4159 240.842 63.4159 240.844 63.4159C240.84 63.4284 240.833 63.4388 240.823 63.445C240.779 63.4325 240.762 63.3577 240.737 63.3348C240.74 63.3057 240.758 63.3431 240.775 63.3244L240.737 63.2932C240.775 63.2828 240.785 63.2058 240.821 63.2682L240.81 63.2079C240.825 63.1684 240.825 63.1185 240.804 63.0893C240.808 63.0581 240.75 63.0228 240.783 63.0436L240.744 62.9479H240.752C240.74 62.848 240.654 62.7503 240.692 62.6255C240.675 62.5964 240.654 62.5652 240.65 62.509L240.679 62.4903C240.658 62.4528 240.679 62.3592 240.642 62.3488C240.717 62.2844 240.608 62.145 240.606 62.0701L240.565 62.0764C240.554 62.0264 240.529 61.9807 240.498 61.9245L240.463 61.937C240.44 61.9141 240.438 61.8788 240.438 61.8372V61.806V61.7893V61.781V61.7768L240.283 61.8143H240.286H240.29C240.346 61.8059 240.477 61.8788 240.44 61.858C240.442 61.86 240.454 61.8683 240.44 61.86C240.423 61.8517 240.39 61.8371 240.36 61.8267C240.41 61.8434 240.452 61.8663 240.458 61.8704C240.465 61.8746 240.433 61.8559 240.396 61.8184C240.377 61.7997 240.358 61.7789 240.346 61.7581C240.34 61.7477 240.335 61.7394 240.335 61.7331C240.308 61.5626 240.373 61.9661 240.367 61.9245H240.369H240.373C240.385 61.9162 240.398 61.9099 240.41 61.9037C240.458 61.8767 240.504 61.8496 240.546 61.8767C240.558 61.8621 240.571 61.8663 240.577 61.8767C240.577 61.8767 240.577 61.8767 240.575 61.8767H240.579L240.59 61.8975C240.59 61.8891 240.585 61.8808 240.581 61.8767C240.59 61.8767 240.6 61.8725 240.617 61.8642L240.608 61.9058C240.608 61.9058 240.608 61.9058 240.61 61.9058C240.613 61.9224 240.627 61.8892 240.631 61.858C240.64 61.8517 240.65 61.8475 240.66 61.8392C240.635 61.9016 240.71 61.8392 240.673 61.9058C240.708 61.8829 240.727 61.937 240.796 61.9224C240.787 61.9266 240.783 61.9328 240.781 61.9224C240.777 61.9474 240.775 61.964 240.796 61.9807L240.746 61.9952C240.758 61.9994 240.771 62.0056 240.783 62.014C240.802 62.0847 240.848 62.0992 240.867 62.1013C240.898 62.1616 240.91 62.1866 240.84 62.1928C240.923 62.2032 240.923 62.197 240.933 62.197H241.252L241.135 62.1221C241.135 62.1221 241.135 62.0868 241.121 62.0368L241.152 62.0472C241.164 62.0077 241.125 61.9495 241.144 61.9245C241.154 61.9037 241.154 61.8704 241.144 61.8288C241.137 61.808 241.127 61.7831 241.119 61.7643C241.112 61.7477 241.104 61.7311 241.098 61.7144C241.083 61.6811 241.077 61.6603 241.073 61.6229C241.069 61.5875 241.069 61.5418 241.071 61.4919L240.85 61.6666C240.865 61.677 240.877 61.6874 240.889 61.6978C240.896 61.5938 240.948 61.7685 240.979 61.6978C240.979 61.7227 240.994 61.7435 240.962 61.7519C241.004 61.756 241.025 61.7747 241.044 61.7893C241.067 61.8039 241.062 61.8018 241.098 61.7851C241.085 61.8059 241.071 61.808 241.064 61.8226C241.069 61.8184 241.085 61.8122 241.079 61.8247C241.071 61.8372 241.062 61.8371 241.054 61.8434C241.071 61.8538 241.131 61.8163 241.192 61.7851C241.192 61.8163 241.2 61.8392 241.219 61.8517L241.652 62.1284L241.423 61.7623C241.416 61.7519 241.404 61.7415 241.383 61.7331C241.402 61.7144 241.423 61.6874 241.437 61.7373C241.437 61.7227 241.437 61.677 241.433 61.6354C241.427 61.5917 241.427 61.5709 241.398 61.5688C241.4 61.5688 241.402 61.5647 241.404 61.5605L241.277 61.6791C241.277 61.6791 241.304 61.6791 241.31 61.6728C241.362 61.6749 241.373 61.6915 241.433 61.7019L241.419 61.6895C241.46 61.6333 241.475 61.6874 241.525 61.6978L241.521 61.704C241.614 61.7872 241.579 61.6978 241.662 61.7935L241.673 61.7539C241.721 61.677 241.743 61.8434 241.814 61.8455L241.804 61.8143C241.854 61.8059 241.827 61.9703 241.848 61.9952C241.848 62.0056 241.831 61.9994 241.818 61.9973C241.86 62.0868 241.858 61.9599 241.918 61.989C241.91 62.0181 241.862 62.0368 241.891 62.068C241.891 62.0951 242.05 62.0805 242.052 62.1658C242.06 62.1408 242.066 62.1159 242.1 62.1284C242.141 62.1596 242.116 62.2802 242.197 62.274C242.197 62.2823 242.193 62.2885 242.187 62.2906C242.222 62.3114 242.277 62.3759 242.32 62.38C242.216 62.4695 242.485 62.5693 242.364 62.6213C242.381 62.6567 242.395 62.692 242.41 62.7295H242.395C242.41 62.8044 242.445 62.8231 242.483 62.8397C242.479 62.8584 242.464 62.8501 242.458 62.8501C242.458 62.9645 242.466 62.9708 242.545 63.0561L242.506 63.0727C242.533 63.0956 242.466 63.2516 242.531 63.3577C242.527 63.3577 242.518 63.3577 242.51 63.3473C242.543 63.4076 242.527 63.4887 242.52 63.5573C242.518 63.5927 242.516 63.6239 242.527 63.6468C242.537 63.6759 242.556 63.6676 242.595 63.678C242.61 63.6946 242.626 63.7133 242.641 63.7362C242.641 63.6572 242.712 63.7612 242.733 63.73C242.749 63.7778 242.699 63.8173 242.685 63.7695L242.691 63.7653C242.647 63.7466 242.643 63.7695 242.643 63.7903C242.631 63.8111 242.599 63.8194 242.579 63.8028C242.552 63.8194 242.522 63.8319 242.493 63.8444L242.347 63.9068L242.275 63.938L242.239 63.9525L242.22 63.9609L242.212 63.965H242.21C242.145 63.8423 242.297 64.1314 242.281 64.1023V64.0982C242.281 64.094 242.279 64.0898 242.277 64.0836C242.266 64.042 242.281 63.9484 242.277 63.9671C242.277 63.9754 242.262 64.0274 242.239 64.0815C242.233 64.094 242.227 64.1044 242.222 64.1065C242.574 64.1086 242.32 64.1065 242.399 64.1065V64.1023V64.0919L242.404 64.015L242.341 64.0378L242.345 63.9671C242.36 63.9484 242.393 63.9422 242.391 63.9942C242.427 63.9671 242.362 63.9089 242.349 63.9068C242.377 63.8069 242.42 63.9463 242.422 63.9151L242.418 63.8735L242.41 63.8818C242.385 63.8485 242.358 63.8444 242.362 63.7841C242.374 63.7445 242.402 63.7653 242.404 63.7487C242.408 63.7487 242.41 63.7445 242.406 63.7258L242.412 63.6364L242.362 63.6717C242.339 63.6322 242.366 63.5865 242.31 63.6281C242.341 63.6073 242.354 63.5553 242.36 63.4991V63.4554C242.364 63.4346 242.364 63.4138 242.364 63.393C242.364 63.3535 242.343 63.3119 242.333 63.289L242.277 63.1559L242.154 63.2121C242.139 63.2183 242.104 63.2287 242.089 63.2245C242.077 63.2391 242.06 63.2516 242.037 63.2703C242.025 63.2807 242.01 63.289 241.987 63.3223C241.958 63.3743 241.97 63.3701 241.968 63.3785C241.966 63.4097 241.958 63.4388 241.95 63.4721C241.962 63.4575 242.018 63.4617 242 63.5199C241.893 63.47 241.929 63.6156 241.839 63.6447C241.87 63.6301 241.864 63.6717 241.862 63.7133C241.862 63.7445 241.862 63.7633 241.908 63.757C241.887 63.7861 241.866 63.7466 241.833 63.7549C241.837 63.7633 241.829 63.782 241.82 63.807L242.045 63.7508C242.004 63.7258 241.977 63.7133 241.973 63.705C241.981 63.6905 241.945 63.7404 241.933 63.7508C241.918 63.7674 241.906 63.7757 241.898 63.7778H241.893C241.943 63.7633 241.779 63.809 242.008 63.7466V63.7321V63.7092C242.006 63.6509 242.004 63.5885 241.987 63.5324C241.973 63.5324 241.954 63.5615 241.927 63.5386C241.945 63.5053 241.966 63.4845 241.983 63.4388C241.979 63.4305 241.973 63.4242 241.966 63.4221C241.937 63.4076 241.908 63.4117 241.914 63.3431C241.908 63.3577 241.9 63.3785 241.881 63.3597C241.873 63.3348 241.845 63.2994 241.839 63.2869L241.789 63.185L241.633 63.2745C241.621 63.2828 241.593 63.2973 241.552 63.3369C241.541 63.3493 241.529 63.3597 241.51 63.3993C241.506 63.4097 241.502 63.4263 241.5 63.4409C241.496 63.4554 241.5 63.4949 241.5 63.4908V63.5033L241.512 63.5532C241.529 63.6177 241.546 63.6842 241.562 63.7487C241.593 63.8798 241.614 64.0129 241.579 64.1564C241.6 64.1127 241.608 64.1377 241.614 64.1668C241.616 64.146 241.65 64.1606 241.671 64.1522L241.639 64.2812C241.673 64.2874 241.677 64.3249 241.685 64.3582L241.706 64.4497L241.793 64.4622C241.82 64.4663 241.845 64.4663 241.854 64.4455L241.814 64.4497C241.845 64.4226 241.833 64.3831 241.814 64.3394L241.808 64.3332C241.839 64.3041 241.87 64.2708 241.91 64.2666C241.829 64.225 241.985 64.0982 241.866 64.0274C241.879 64.0046 241.895 64.0399 241.912 64.0254C241.873 64.0087 241.86 63.9817 241.866 63.9276L241.877 63.9317C241.839 63.7882 241.86 63.7196 241.85 63.5532L241.812 63.5719C241.812 63.5365 241.82 63.5261 241.829 63.5074C241.76 63.4783 241.845 63.6073 241.773 63.5823C241.806 63.5532 241.798 63.4991 241.787 63.445V63.4409C241.527 63.4866 241.716 63.4533 241.658 63.4637H241.66C241.666 63.4637 241.675 63.4679 241.685 63.4741C241.698 63.4804 241.708 63.4887 241.727 63.5012L241.752 63.522L241.766 63.5345L241.785 63.522C241.804 63.5095 241.831 63.4991 241.858 63.4908L241.585 63.4762C241.587 63.4887 241.585 63.497 241.581 63.5012C241.598 63.5199 241.612 63.4679 241.631 63.4887L241.614 63.5074L241.648 63.497C241.652 63.5137 241.631 63.5303 241.612 63.5386C241.608 63.5407 241.604 63.5428 241.6 63.5449C241.6 63.5449 241.591 63.5365 241.589 63.5345C241.585 63.5407 241.583 63.5449 241.581 63.549C241.581 63.5553 241.581 63.5615 241.585 63.5677C241.589 63.5781 241.593 63.5906 241.598 63.601C241.606 63.6218 241.614 63.6385 241.612 63.6468L241.616 63.5885C241.637 63.6468 241.65 63.7133 241.664 63.7778L241.675 63.8277V63.8402C241.675 63.8402 241.689 63.8798 241.698 63.8922C241.718 63.9276 241.739 63.9463 241.756 63.9609C241.789 63.9879 241.81 63.9962 241.827 64.0046L241.845 64.0129H241.85L241.862 63.9962L242.114 63.9442C242.114 63.9442 242.139 63.8756 242.141 63.834L242.118 63.8423C242.125 63.757 242.127 63.7529 242.141 63.7279C242.154 63.7071 242.168 63.6863 242.172 63.626L242.177 63.6322C242.164 63.6052 242.16 63.5698 242.168 63.5386C242.183 63.574 242.22 63.4949 242.237 63.5386C242.231 63.4762 242.227 63.4596 242.218 63.4471C242.216 63.445 242.214 63.4409 242.21 63.4367L242.097 63.4034H242.1L242.106 63.4076C242.112 63.4117 242.118 63.418 242.135 63.4409C242.158 63.4804 242.143 63.4533 242.147 63.4471L242.17 63.4721C242.183 63.4388 242.179 63.4263 242.235 63.3951L242.147 63.3577C242.147 63.3577 242.15 63.3618 242.152 63.366C242.15 63.366 242.145 63.3597 242.143 63.3597L242.239 63.4013C242.229 63.4159 242.239 63.4221 242.252 63.4284L242.118 63.3701C242.11 63.3847 242.102 63.3951 242.081 63.3826L242.268 63.4637C242.268 63.4637 242.264 63.4721 242.258 63.4762H242.272L242.068 63.3868C242.06 63.4367 242.068 63.4346 242.083 63.4741C242.095 63.5116 242.102 63.5407 242.054 63.5698C242.139 63.6301 242.104 63.4596 242.122 63.4929C242.152 63.4658 242.187 63.5428 242.177 63.5823C242.175 63.6239 242.064 63.6509 242.064 63.7529C242.064 63.7425 242.058 63.7425 242.058 63.7321C242.035 63.7695 242.087 63.8069 242.05 63.8548C242.102 63.8818 242.045 63.9151 242.112 63.9234L242.097 63.8298C242.114 63.8839 242.191 63.9338 242.152 64.0212C242.139 64.015 242.12 63.9879 242.112 63.9692C242.091 63.9942 242.125 64.0191 242.104 64.0462C242.037 64.0378 242.091 63.9317 242.041 63.8735C242.012 63.9005 242.089 63.9817 242.016 63.9525C242.062 63.9733 242.058 63.9983 242.054 64.0274C242.052 64.042 242.048 64.0566 242.048 64.0732C242.048 64.0815 242.05 64.0898 242.054 64.0982L242.058 64.1044C242.058 64.1044 242.058 64.1044 242.058 64.1065C242.058 64.1335 242.066 64.1647 242.083 64.1918C242.089 64.2042 242.102 64.2167 242.108 64.223L242.114 64.2292L242.129 64.2396C242.154 64.2562 242.15 64.25 242.16 64.2562C242.183 64.2625 242.191 64.2604 242.202 64.2583L242.179 64.2937C242.195 64.2937 242.212 64.2937 242.235 64.2916C242.262 64.2854 242.275 64.2937 242.352 64.2708C242.268 64.3145 242.252 64.3166 242.214 64.3332C242.241 64.3311 242.258 64.329 242.275 64.327C242.287 64.327 242.302 64.3249 242.322 64.3207C242.335 64.3186 242.343 64.3166 242.364 64.3082L242.389 64.2978C242.402 64.2916 242.416 64.2895 242.431 64.2895C242.46 64.2874 242.491 64.2874 242.51 64.2625C242.41 64.3186 242.464 64.2313 242.408 64.2292C242.506 64.1148 242.529 64.2833 242.66 64.1897C242.643 64.2042 242.577 64.2063 242.597 64.1751C242.633 64.1647 242.66 64.1689 242.708 64.1647C242.858 64.0732 242.66 64.1439 242.71 64.0878C242.789 64.1002 242.77 64.0337 242.806 63.99L242.841 64.015C242.918 63.9692 242.899 63.9442 242.889 63.9297C242.874 63.913 242.868 63.9005 242.885 63.8423C242.903 63.8673 242.918 63.8922 242.933 63.9213C242.933 63.8943 242.933 63.8714 242.928 63.8423L242.974 63.8735C242.943 63.7716 242.943 63.7487 242.943 63.653C242.918 63.6801 242.864 63.6322 242.856 63.5865C242.874 63.5469 242.897 63.601 242.881 63.5282C242.908 63.5407 242.943 63.5553 242.91 63.5927C242.924 63.5948 242.937 63.6031 242.951 63.6093C242.972 63.5615 242.943 63.5095 242.939 63.4825C242.939 63.4929 242.939 63.5053 242.935 63.5137L242.862 63.4159C242.874 63.3972 242.889 63.4076 242.903 63.4201C242.895 63.3993 242.874 63.3868 242.866 63.3556C242.899 63.3577 242.933 63.3514 242.956 63.393L242.903 63.2973C242.916 63.289 242.935 63.2391 242.949 63.2495C242.96 63.1892 242.864 63.1205 242.879 63.0415C242.872 63.0394 242.864 63.0311 242.858 63.0165C242.858 62.9458 242.878 62.8668 242.814 62.7898L242.858 62.7253C242.826 62.6588 242.804 62.8127 242.751 62.7045C242.71 62.6296 242.791 62.6608 242.797 62.6276C242.756 62.5943 242.676 62.5485 242.691 62.457C242.71 62.4778 242.71 62.4986 242.722 62.5194L242.718 62.5152ZM242.2 61.781C242.218 61.7872 242.262 61.7914 242.256 61.8184C242.208 61.8392 242.214 61.8122 242.2 61.781ZM241.289 61.625C241.308 61.625 241.319 61.6499 241.321 61.6791C241.308 61.6666 241.298 61.6499 241.289 61.625ZM240.771 63.1684C240.771 63.1684 240.771 63.1684 240.769 63.1684C240.779 63.1309 240.775 63.1455 240.771 63.1684ZM240.767 63.2412C240.767 63.2412 240.779 63.2453 240.783 63.2412C240.773 63.2391 240.769 63.2225 240.769 63.2037C240.758 63.21 240.754 63.2204 240.767 63.2391V63.2412ZM242.389 63.7445L242.379 63.7591C242.368 63.7279 242.379 63.7362 242.389 63.7445Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.154 61.7797C241.154 61.7797 241.169 61.7712 241.176 61.769C241.167 61.7626 241.161 61.7648 241.154 61.7797Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.872 63.0353V63.0375C242.874 63.0375 242.878 63.0375 242.881 63.0375L242.872 63.0332V63.0353Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.186 62.2161C240.186 62.1993 240.192 62.191 240.198 62.1826C240.188 62.1826 240.182 62.1931 240.186 62.2161Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.917 63.5594L240.896 63.5322C240.902 63.5469 240.896 63.5531 240.892 63.5636C240.9 63.5594 240.91 63.549 240.915 63.5573L240.917 63.5594Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.887 63.9962C240.887 63.9962 240.896 64.0067 240.904 64.0088L240.919 63.9962C240.9 63.9732 240.875 63.967 240.887 63.9962Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.802 63.6426C240.77 63.6593 240.793 63.6802 240.812 63.7032C240.812 63.7032 240.812 63.7011 240.81 63.699C240.856 63.6844 240.829 63.6656 240.802 63.6447V63.6426Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.816 63.707C240.816 63.707 240.827 63.722 240.831 63.7305C240.85 63.7241 240.831 63.7177 240.816 63.707Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.806 63.3243C240.8 63.341 240.852 63.3243 240.84 63.3348C240.886 63.3431 240.769 63.249 240.806 63.3243Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.71 63.7119L240.744 63.6847L240.704 63.6826L240.71 63.7119Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.66 63.4593V63.5116C240.66 63.5116 240.673 63.5137 240.679 63.5221C240.673 63.4907 240.673 63.4551 240.66 63.4593Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.679 63.5225C240.683 63.5392 240.687 63.5538 240.698 63.5601C240.695 63.5517 240.687 63.5329 240.679 63.5225Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.668 63.6509V63.6342L240.662 63.5986C240.662 63.6154 240.664 63.6342 240.668 63.653V63.6509Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.567 62.911L240.544 62.8566C240.529 62.8545 240.523 62.8713 240.531 62.8901C240.544 62.9026 240.552 62.9215 240.565 62.911H240.567Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.481 63.0996C240.487 63.0829 240.496 63.0808 240.508 63.0703L240.456 63.0766L240.481 63.0996Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.442 62.9395C240.427 62.9374 240.386 62.8663 240.402 62.9353C240.417 62.9374 240.44 62.9918 240.442 62.9395Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.302 62.0973L240.308 62.1099L240.392 62.0889L240.302 62.0973Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.744 61.4749C240.638 61.4375 240.707 61.5186 240.612 61.4874C240.587 61.5061 240.688 61.5124 240.658 61.529C240.723 61.5145 240.755 61.5394 240.742 61.477L240.744 61.4749Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.658 61.5293C240.658 61.5293 240.638 61.5356 240.625 61.5398C240.644 61.5356 240.652 61.5314 240.658 61.5293Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.61 64.3682V64.3744L241.6 64.4243L241.779 64.5366L241.815 64.5595L241.794 64.5262L241.781 64.5325L241.614 64.3723L241.61 64.3682Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.868 64.4854V64.5418L241.904 64.4958C241.893 64.4958 241.874 64.4979 241.868 64.4854Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.16 61.6064L242.15 61.6148C242.148 61.6315 242.156 61.6399 242.175 61.6566L242.162 61.6064H242.16Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.595 62.1491L242.589 62.1387L242.558 62.1826L242.595 62.1491Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.874 62.6421C242.87 62.6191 242.851 62.5961 242.845 62.5752C242.868 62.6212 242.815 62.6672 242.874 62.6421Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.905 68.3479C231.901 68.3312 231.872 68.3542 231.863 68.3542C231.884 68.3751 231.911 68.3437 231.905 68.3479Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.104 68.5576L232.09 68.5618L232.14 68.5806L232.104 68.5576Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.225 68.791C232.267 68.7411 232.173 68.7119 232.171 68.6599L232.179 68.6475L232.127 68.6516C232.16 68.6974 232.223 68.7494 232.227 68.791H232.225Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.174 68.9747C232.19 68.9559 232.205 68.9915 232.165 68.9434C232.165 68.9475 232.165 68.9496 232.163 68.9517C232.165 68.9559 232.169 68.9643 232.174 68.9768V68.9747Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.163 68.9521C232.148 68.9278 232.155 68.9785 232.163 68.9521V68.9521Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.234 69.0572L232.198 69.0342C232.19 69.0467 232.202 69.0781 232.188 69.0718C232.215 69.099 232.223 69.0865 232.234 69.0572Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.29 69.0689L232.273 69.0557C232.273 69.0557 232.268 69.0667 232.29 69.0689Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.237 69.0283L232.273 69.0555C232.273 69.0555 232.296 69.0367 232.258 69.043C232.275 69.0367 232.258 69.0388 232.237 69.0283Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.236 69.0036C232.238 68.9785 232.234 68.9513 232.269 68.9743C232.229 68.9157 232.196 68.945 232.236 69.0036Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.288 68.7745V68.7411L232.263 68.7285C232.277 68.7348 232.273 68.7829 232.288 68.7724V68.7745Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.311 69.2721C232.323 69.268 232.336 69.245 232.348 69.2345L232.323 69.2178C232.323 69.2345 232.327 69.2617 232.311 69.2721Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.348 69.2361L232.385 69.2612C232.371 69.2277 232.358 69.2277 232.348 69.2361Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.353 69.0427L232.279 69.0049L232.359 69.0532L232.353 69.0427Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.379 69.4086L232.344 69.4023L232.402 69.417L232.379 69.4086Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.432 69.4964C232.403 69.4922 232.405 69.5363 232.384 69.5279C232.401 69.551 232.43 69.5615 232.457 69.572C232.436 69.5573 232.428 69.5342 232.432 69.4964Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.5 69.5922C232.489 69.5838 232.473 69.5776 232.458 69.5713C232.468 69.5797 232.483 69.588 232.5 69.5922Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.413 69.3232C232.413 69.3232 232.392 69.3442 232.394 69.3692L232.419 69.3379C232.419 69.3379 232.415 69.3295 232.413 69.3232Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.421 69.3379C232.427 69.3546 232.433 69.3651 232.436 69.3693C232.436 69.3651 232.429 69.3546 232.423 69.3379H232.421Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.41 69.3193V69.3267C232.41 69.3267 232.418 69.3193 232.41 69.3193Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.371 69.1515C232.401 69.1641 232.443 69.1977 232.449 69.141C232.419 69.1368 232.415 69.1704 232.371 69.1515Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.442 69.2821L232.43 69.2402C232.43 69.2402 232.413 69.2591 232.398 69.2528L232.442 69.2821Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.463 69.295L232.441 69.2822L232.448 69.2972L232.463 69.295Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.494 69.5085C232.517 69.5169 232.527 69.5336 232.54 69.5545C232.534 69.5273 232.525 69.5043 232.515 69.4834C232.502 69.4855 232.479 69.4855 232.494 69.5085Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.461 69.4252H232.468C232.468 69.4252 232.468 69.4178 232.461 69.4252Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.648 69.7528L232.653 69.748L232.646 69.7504L232.648 69.7528Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.521 69.4775C232.519 69.4587 232.507 69.4524 232.492 69.4482C232.503 69.4587 232.511 69.4712 232.517 69.4838C232.524 69.4838 232.526 69.4817 232.521 69.4775Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.546 69.6402C232.546 69.6276 232.548 69.6151 232.546 69.6025C232.54 69.6172 232.534 69.6423 232.546 69.6402Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.459 69.4355H232.457C232.452 69.445 232.457 69.4426 232.459 69.4355Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.458 69.4362C232.458 69.4362 232.479 69.4446 232.489 69.4467C232.481 69.4383 232.473 69.43 232.464 69.4258C232.464 69.43 232.46 69.4321 232.458 69.4362Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.886 69.7043C232.855 69.7168 232.805 69.6877 232.817 69.6357C232.776 69.6107 232.692 69.6877 232.652 69.748C232.665 69.7418 232.677 69.7355 232.715 69.7626C232.725 69.7418 232.711 69.6627 232.753 69.6794C232.794 69.7189 232.763 69.7251 232.759 69.7563C232.786 69.7168 232.845 69.7896 232.895 69.7522L232.853 69.7189C232.853 69.7189 232.882 69.723 232.884 69.7064L232.886 69.7043Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.619 69.6775L232.606 69.665C232.61 69.6858 232.606 69.7046 232.594 69.7378C232.621 69.7545 232.636 69.7545 232.646 69.7503L232.61 69.6754H232.617L232.619 69.6775Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.569 69.5941C232.609 69.59 232.642 69.6191 232.665 69.5775C232.638 69.5338 232.621 69.5608 232.592 69.54C232.64 69.6108 232.563 69.5276 232.573 69.592C232.561 69.5796 232.55 69.5671 232.542 69.5567C232.546 69.5733 232.548 69.5879 232.548 69.6045V69.6024C232.548 69.6024 232.552 69.5941 232.552 69.6004C232.552 69.6004 232.563 69.6004 232.567 69.6004C232.571 69.6253 232.561 69.6087 232.552 69.6045H232.546V69.6066L232.605 69.6711C232.6 69.6524 232.59 69.6357 232.567 69.6024L232.569 69.5941Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.538 69.1426C232.538 69.1426 232.533 69.1468 232.531 69.149C232.538 69.1511 232.542 69.1511 232.538 69.1426Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.533 69.1826C232.533 69.1826 232.51 69.1826 232.504 69.1638C232.504 69.143 232.519 69.1555 232.529 69.1493C232.515 69.143 232.487 69.1243 232.487 69.1659H232.494C232.498 69.2034 232.477 69.2616 232.471 69.2595C232.496 69.2366 232.513 69.2179 232.531 69.1826H232.533Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.559 69.3835L232.607 69.4358L232.619 69.3898L232.603 69.4002C232.592 69.3626 232.573 69.3814 232.559 69.3835Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.635 69.7686L232.598 69.7791L232.663 69.7854L232.635 69.7686Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.677 69.8398L232.646 69.8524L232.673 69.8628L232.677 69.8398Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.506 71.199L231.517 71.1836C231.517 71.1836 231.5 71.1946 231.506 71.199Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.833 70.5759C232.835 70.5591 232.842 70.5403 232.846 70.5278C232.846 70.5131 232.837 70.5048 232.829 70.5236L232.816 70.5591C232.833 70.5633 232.829 70.5654 232.831 70.5759H232.833Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.737 71.1774L232.746 71.1879C232.752 71.1753 232.76 71.1628 232.767 71.1523C232.758 71.1607 232.748 71.167 232.737 71.1753V71.1774Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.713 71.3288L232.673 71.3037C232.673 71.3037 232.694 71.3204 232.713 71.3288Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.713 70.5801L230.669 70.5905C230.694 70.6156 230.696 70.5905 230.713 70.5801Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.031 70.6907C233.063 70.7138 233.094 70.7285 233.122 70.739C233.078 70.7054 233.059 70.6676 233.031 70.6907Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.593 70.8047C231.58 70.8047 231.572 70.8111 231.567 70.8175C231.58 70.8175 231.591 70.8132 231.593 70.8047Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.205 70.7614C233.205 70.7614 233.199 70.753 233.195 70.7488C233.172 70.7488 233.163 70.753 233.121 70.7383C233.161 70.7656 233.169 70.7782 233.205 70.7614Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.032 67.7617C231.032 67.7617 231.039 67.7639 231.041 67.766C231.041 67.7617 231.039 67.7617 231.032 67.7617Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.792 68.2839C231.792 68.2839 231.771 68.2776 231.761 68.2734C231.765 68.2776 231.773 68.2818 231.792 68.2839Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.746 70.0821C232.741 70.0821 232.744 70.0687 232.746 70.0821V70.0821Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.886 70.0098C232.886 70.0098 232.896 70.014 232.905 70.0098C232.896 70.0098 232.89 70.0098 232.886 70.0098Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.763 70.0645C232.763 70.0645 232.754 70.0733 232.752 70.0799C232.754 70.0799 232.758 70.0711 232.763 70.0645Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.743 70.0662C232.743 70.0662 232.746 70.0598 232.748 70.0576C232.741 70.0576 232.737 70.0576 232.743 70.0662Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.748 70.098C232.748 70.098 232.748 70.0825 232.753 70.0781C232.75 70.0803 232.748 70.0803 232.746 70.0803C232.746 70.0825 232.746 70.0891 232.746 70.098H232.748Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.324 69.1809C230.324 69.1809 230.324 69.1787 230.329 69.1765C230.313 69.1544 230.315 69.1655 230.324 69.1809Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.553 70.665H232.548L232.553 70.6703V70.665Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.592 70.6572C232.559 70.6947 232.55 70.6822 232.55 70.6676C232.53 70.6988 232.513 70.73 232.496 70.7633C232.532 70.7321 232.565 70.6967 232.592 70.6593V70.6572Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.03 70.9106C231.036 70.9314 231.042 70.9522 231.051 70.973C230.963 70.9709 230.936 70.9169 230.946 70.9917C231.026 70.9169 231.134 71.1269 231.207 71.0333L231.223 71.0729C231.223 71.0729 231.211 71.0729 231.203 71.0645C231.234 71.1477 231.29 71.0229 231.357 71.077C231.38 71.0999 231.39 71.1249 231.365 71.127L231.438 71.1311C231.455 71.1415 231.442 71.1581 231.425 71.1477C231.457 71.1602 231.488 71.1706 231.521 71.181C231.542 71.1727 231.582 71.1602 231.6 71.154C231.617 71.1789 231.584 71.1602 231.584 71.1769L231.644 71.1706C231.652 71.206 231.6 71.2164 231.567 71.1977C231.571 71.3225 231.619 71.1893 231.696 71.2913L231.644 71.2871C231.65 71.3599 231.698 71.3516 231.738 71.4098C231.732 71.3849 231.667 71.2746 231.732 71.2663C231.744 71.2809 231.763 71.2913 231.8 71.2809C231.786 71.3204 231.819 71.3204 231.854 71.3308L231.834 71.3807C231.877 71.3807 231.884 71.3516 231.913 71.337C231.948 71.3558 231.963 71.4057 231.969 71.4452C231.988 71.4535 231.998 71.4556 232.004 71.4556C232.015 71.4556 232.013 71.4473 232.009 71.439C231.996 71.414 231.969 71.3766 232.019 71.3828C232.025 71.3828 232.034 71.3828 232.042 71.3849C232.129 71.439 232.206 71.3932 232.29 71.3204C232.329 71.3246 232.302 71.3516 232.319 71.362C232.319 71.3537 232.319 71.3474 232.319 71.3391C232.319 71.3266 232.319 71.3391 232.311 71.3038C232.304 71.2767 232.306 71.285 232.306 71.2892C232.3 71.2414 232.302 71.2497 232.302 71.2414V71.3017V71.2954C232.302 71.2913 232.304 71.2892 232.306 71.2871C232.311 71.2809 232.317 71.2767 232.329 71.2726C232.344 71.2122 232.421 71.362 232.483 71.2975C232.498 71.3142 232.475 71.3308 232.477 71.3516C232.561 71.3121 232.55 71.3225 232.621 71.2663L232.679 71.3038C232.638 71.2621 232.696 71.2164 232.744 71.1769C232.729 71.1561 232.717 71.1394 232.708 71.1311C232.733 71.1228 232.76 71.1124 232.781 71.102C232.79 71.1103 232.783 71.129 232.771 71.1519C232.777 71.1478 232.781 71.1436 232.783 71.1394C232.808 71.1582 232.802 71.1914 232.779 71.2206C232.769 71.2101 232.76 71.1977 232.75 71.1873C232.731 71.2205 232.713 71.2559 232.715 71.2871C232.721 71.2809 232.729 71.2767 232.742 71.2726C232.738 71.2809 232.733 71.2892 232.735 71.2954C232.738 71.3017 232.746 71.2892 232.76 71.2746C232.767 71.2954 232.771 71.3142 232.779 71.335L232.785 71.31C232.833 71.3204 232.885 71.335 232.938 71.3329C233.015 71.2497 233.017 71.1228 233.058 71.0541L233.071 71.0313L233.062 71.0271C233.062 71.0271 233.048 71.0105 233.031 71.0001C233.092 71.0042 233.1 70.9689 233.137 70.9293C233.144 70.9501 233.144 70.9605 233.144 70.9689C233.144 70.973 233.144 70.9751 233.144 70.9751L233.117 70.9897L233.087 71.0084L233.112 71.127C233.094 71.1415 233.1 71.1894 233.04 71.2289C233.077 71.206 233.085 71.2309 233.081 71.2455C233.117 71.1956 233.115 71.1748 233.125 71.1457L233.085 71.0084L233.115 70.9897C233.115 70.9897 233.11 70.9897 233.156 70.9668C233.196 70.946 233.183 70.9522 233.187 70.9481C233.187 70.9481 233.187 70.9439 233.187 70.9397C233.183 70.9314 233.183 70.9169 233.148 70.8773C233.137 70.8669 233.125 70.8565 233.106 70.8461C233.098 70.842 233.081 70.8337 233.081 70.8337C233.081 70.8337 233.077 70.8274 233.073 70.8233C233.065 70.9106 232.981 70.8524 232.933 70.8628C232.94 70.8357 232.958 70.8108 233.006 70.8337C232.973 70.7546 232.904 70.9044 232.869 70.8357C232.881 70.8399 232.885 70.8461 232.896 70.8337C232.86 70.8482 232.798 70.8066 232.823 70.7879L232.835 70.7921C232.76 70.7567 232.592 70.7109 232.563 70.7754C232.567 70.7671 232.604 70.6985 232.611 70.6839C232.6 70.6964 232.59 70.7068 232.577 70.7172C232.525 70.7733 232.452 70.8087 232.373 70.817C232.421 70.7775 232.508 70.6548 232.558 70.6548C232.558 70.6485 232.558 70.6402 232.554 70.6361C232.554 70.634 232.55 70.6319 232.546 70.6298C232.544 70.6298 232.542 70.6298 232.54 70.6277L232.404 70.7317C232.404 70.7317 232.413 70.7317 232.417 70.7317C232.429 70.7317 232.446 70.7401 232.465 70.7463C232.442 70.738 232.417 70.7297 232.406 70.7317L232.519 70.6444L232.517 70.6465L232.513 70.6527L232.502 70.6652C232.488 70.6818 232.471 70.6964 232.465 70.6922V70.6881L232.406 70.7317H232.408C232.411 70.7317 232.421 70.7317 232.427 70.7317C232.444 70.7338 232.458 70.7421 232.475 70.7463C232.483 70.7505 232.492 70.7546 232.5 70.7567H232.506C232.506 70.7567 232.519 70.7609 232.523 70.7609C232.523 70.7609 232.538 70.765 232.531 70.7609C232.517 70.7484 232.496 70.7317 232.479 70.7109C232.471 70.7005 232.463 70.6901 232.458 70.6797C232.458 70.6777 232.458 70.6756 232.456 70.6735V70.6693L232.477 70.8191L232.481 70.8253C232.481 70.8253 232.477 70.8212 232.475 70.817C232.475 70.817 232.475 70.817 232.475 70.8149L232.456 70.6714L232.473 70.7879V70.7671C232.475 70.7401 232.483 70.7172 232.498 70.7172C232.494 70.7317 232.502 70.8129 232.498 70.8233C232.511 70.79 232.529 70.7588 232.556 70.7297C232.538 70.7442 232.542 70.8108 232.542 70.8378C232.542 70.817 232.571 70.8503 232.583 70.8482C232.583 70.8399 232.581 70.8295 232.577 70.8191C232.606 70.8503 232.713 70.7505 232.783 70.7941C232.769 70.8087 232.704 70.8919 232.763 70.9293C232.794 70.9065 232.869 70.8212 232.908 70.738C232.927 70.7047 232.933 70.6777 232.956 70.6631L232.975 70.6881L233.027 70.6465C233.008 70.7047 232.977 70.8108 232.91 70.8919C232.881 70.921 232.85 70.946 232.825 70.9585C232.873 70.9834 232.835 70.9959 232.913 70.9876H232.915C232.925 70.9959 232.923 71.0042 232.913 71.0125C232.896 71.0229 232.86 71.0333 232.844 71.0313C232.867 71.0354 232.89 71.0333 232.913 71.0354L233.029 71.0292C233.015 70.9751 233.115 70.9543 233.1 70.9085C233.056 70.9377 233.025 70.9647 232.967 70.9917C232.967 70.9356 233.025 70.8191 233.11 70.8108C233.137 70.8274 233.117 70.9127 233.121 70.9314C233.129 70.9106 233.194 70.8773 233.204 70.8877L233.175 70.9252C233.227 70.9356 233.233 70.8337 233.302 70.8711C233.323 70.8711 233.377 70.9273 233.373 70.894C233.325 70.8399 233.269 70.6465 233.277 70.5945C233.285 70.5965 233.392 70.6277 233.421 70.6548C233.464 70.6964 233.406 70.7837 233.444 70.8191C233.442 70.8045 233.452 70.7817 233.458 70.7733C233.481 70.7817 233.462 70.8212 233.502 70.8045C233.494 70.7463 233.589 70.7879 233.51 70.7525C233.529 70.7401 233.541 70.7401 233.554 70.7401H233.564C233.571 70.7401 233.581 70.7359 233.589 70.7317C233.602 70.7255 233.614 70.7151 233.619 70.7109C233.631 70.6964 233.635 70.6901 233.639 70.6839C233.646 70.6714 233.65 70.6652 233.652 70.6589V70.6506H233.656L233.627 70.6402C233.627 70.6402 233.641 70.6465 233.65 70.6485L233.641 70.6444C233.641 70.6444 233.621 70.6361 233.61 70.6298L233.579 70.5425C233.556 70.5799 233.502 70.6173 233.469 70.6215C233.475 70.6069 233.469 70.5861 233.469 70.5778C233.385 70.5508 233.346 70.5133 233.267 70.4905C233.26 70.4738 233.233 70.4489 233.254 70.4301C233.244 70.4385 233.229 70.4551 233.206 70.4509C233.192 70.3948 233.25 70.4551 233.246 70.3906C233.233 70.4218 233.183 70.4218 233.142 70.4322C233.117 70.4801 233.208 70.4613 233.239 70.4468C233.223 70.5133 233.127 70.5757 232.998 70.5612C232.908 70.5362 233 70.5113 232.979 70.5133C232.95 70.4925 232.923 70.4801 232.902 70.4697C232.885 70.4551 232.873 70.4468 232.856 70.4385C232.829 70.4218 232.798 70.3969 232.831 70.3137C232.883 70.2471 232.925 70.2929 232.958 70.2741C232.969 70.3261 232.921 70.3761 232.925 70.4156L232.946 70.3573C232.962 70.3698 232.965 70.401 232.96 70.4281C232.99 70.3698 232.987 70.2117 233.031 70.1098C233.017 70.0911 233.002 70.0599 232.983 70.0745L232.99 70.1057C232.952 70.1306 232.94 70.0495 232.923 70.0848C232.898 70.0412 232.856 70.0266 232.863 69.9788L232.908 69.9538C232.894 69.96 232.89 69.9975 232.908 70.0037C232.885 69.9975 232.95 69.9018 232.877 69.9039L232.856 69.9517C232.819 69.9247 232.75 69.9039 232.746 69.854C232.708 69.8956 232.756 69.8623 232.715 69.9164C232.773 69.8623 232.754 70.0224 232.81 69.9538C232.756 70.0058 232.804 70.0266 232.746 70.0453C232.763 70.0453 232.777 70.0328 232.771 70.0536C232.775 70.0536 232.783 70.0557 232.785 70.0578C232.788 70.0578 232.79 70.0578 232.785 70.0578C232.794 70.0516 232.802 70.0474 232.81 70.0432C232.852 70.0495 232.85 70.1036 232.869 70.1285C232.858 70.1514 232.85 70.1181 232.831 70.1285C232.84 70.141 232.85 70.1493 232.858 70.1639C232.821 70.1618 232.781 70.27 232.771 70.168L232.758 70.2596C232.731 70.3157 232.715 70.3989 232.738 70.4364C232.735 70.4842 232.798 70.5092 232.763 70.4946C232.777 70.53 232.81 70.5633 232.848 70.5841L232.842 70.5903C232.89 70.634 232.96 70.6506 233.031 70.6652C233.067 70.6735 233.102 70.6797 233.137 70.6922C233.154 70.6985 233.173 70.7068 233.187 70.7151C233.198 70.7234 233.208 70.7317 233.219 70.7442C233.25 70.7442 233.281 70.738 233.325 70.7609V70.7941C233.364 70.7941 233.425 70.8545 233.45 70.8253C233.454 70.8524 233.471 70.8711 233.494 70.8815L233.31 70.4988L233.294 70.5341V70.5404H233.292L233.406 70.5799C233.5 70.6132 233.514 70.6215 233.535 70.634C233.544 70.6402 233.548 70.6444 233.548 70.6444L233.481 70.3761H233.477C233.46 70.3823 233.442 70.3885 233.427 70.3969C233.394 70.4114 233.362 70.4239 233.339 70.4239L233.348 70.4655C233.304 70.4738 233.264 70.4967 233.217 70.5279L233.229 70.5633C233.192 70.6049 233.106 70.5674 233.037 70.5841C233.037 70.5695 233.058 70.5695 233.073 70.5737C233.037 70.5508 233.008 70.5549 232.979 70.5695C232.967 70.5757 232.95 70.5861 232.94 70.5945C232.933 70.6028 232.925 70.609 232.919 70.6153C232.906 70.6236 232.892 70.6257 232.885 70.6028C232.873 70.6153 232.869 70.6069 232.867 70.5945C232.867 70.5945 232.867 70.5945 232.869 70.5945C232.869 70.5945 232.869 70.5945 232.867 70.5924C232.867 70.5841 232.867 70.5757 232.867 70.5674C232.867 70.5778 232.867 70.5861 232.867 70.5903C232.86 70.5882 232.85 70.5861 232.835 70.5903C232.842 70.5778 232.846 70.5653 232.852 70.5508C232.852 70.5508 232.85 70.5508 232.846 70.5508C232.833 70.5237 232.819 70.557 232.813 70.5882C232.798 70.5882 232.785 70.5882 232.769 70.5882C232.777 70.5154 232.683 70.5633 232.671 70.4863C232.64 70.5029 232.483 70.4884 232.477 70.5695C232.477 70.5612 232.465 70.557 232.481 70.5549C232.473 70.5549 232.465 70.5549 232.456 70.5529C232.392 70.5674 232.388 70.5841 232.375 70.5924C232.354 70.6132 232.348 70.6298 232.346 70.6506C232.327 70.6465 232.311 70.6444 232.29 70.6444C232.29 70.6589 232.29 70.6673 232.29 70.6943C232.29 70.6985 232.29 70.713 232.29 70.7276V70.738C232.29 70.738 232.294 70.7588 232.298 70.7692C232.304 70.7879 232.325 70.817 232.321 70.8087H232.334C232.35 70.8129 232.367 70.8149 232.383 70.817C232.39 70.8711 232.398 70.9023 232.334 70.8961C232.444 70.9293 232.433 70.9377 232.502 70.9335C232.511 70.9314 232.523 70.9273 232.54 70.9231L232.523 70.9522C232.552 70.9605 232.602 70.9293 232.611 70.9626C232.627 71.0021 232.694 71.0271 232.771 71.0541C232.81 71.0687 232.85 71.0833 232.89 71.0999C232.908 71.1082 232.929 71.1186 232.946 71.129L232.971 71.1457L232.983 71.154L232.99 71.1582H232.992V71.1623C233.015 71.0957 232.942 71.3142 233.042 71.0105L232.992 71.1602V71.1519V71.1436C232.992 71.1436 232.994 71.1353 232.996 71.1332C232.996 71.1311 232.998 71.129 233 71.129L233.04 71.0125C233.04 71.0125 233.04 71.0125 233.04 71.0146C233.04 71.0167 233.033 71.0209 233.025 71.0292C233.012 71.0375 233.008 71.0437 232.946 71.077C232.923 71.0895 232.935 71.0833 232.931 71.0853C232.931 71.0853 232.931 71.0916 232.931 71.0937C232.931 71.0999 232.933 71.1082 232.942 71.1207L232.981 70.9002C232.956 70.9065 232.94 70.9169 232.956 70.9418C232.933 70.9293 232.906 70.9356 232.915 70.9023C232.881 70.9439 232.875 70.9397 232.865 70.9418C232.854 70.9439 232.85 70.9501 232.85 70.9855C232.84 70.9647 232.844 70.9501 232.835 70.9377C232.835 70.9439 232.835 70.9605 232.827 70.946C232.821 70.9335 232.827 70.9252 232.825 70.9148C232.81 70.9231 232.81 70.9917 232.813 71.0604C232.785 71.0292 232.76 71.0333 232.735 71.077C232.723 71.0541 232.702 71.0313 232.748 71.025C232.723 71.0229 232.594 70.9855 232.588 71.0396C232.579 71.025 232.55 71.0333 232.544 71.0396C232.483 71.0333 232.479 71.0271 232.419 71.0313L232.436 71.0417C232.411 71.1062 232.386 71.0542 232.336 71.0625V71.0562C232.336 71.0562 232.302 71.0458 232.286 71.0479C232.269 71.0479 232.259 71.0479 232.25 71.0521C232.234 71.0562 232.229 71.0604 232.223 71.0666C232.221 71.0729 232.209 71.0833 232.173 71.0666L232.184 71.1062C232.188 71.1436 232.171 71.1477 232.152 71.1373C232.131 71.1269 232.115 71.0895 232.098 71.0791C232.092 71.0729 232.084 71.0708 232.075 71.075L232.086 71.1041C232.056 71.1249 232.044 70.9626 232.017 70.9418C232.013 70.9314 232.032 70.9335 232.044 70.9314C231.979 70.8524 232.015 70.9772 231.95 70.9668C231.95 70.9356 231.99 70.9044 231.95 70.8836C231.938 70.8545 231.798 70.9273 231.767 70.8545C231.771 70.8794 231.773 70.9044 231.74 70.9085C231.694 70.8981 231.665 70.7837 231.598 70.8295C231.596 70.8212 231.598 70.8149 231.598 70.8108C231.561 70.8108 231.49 70.7879 231.453 70.8087C231.475 70.7401 231.425 70.7297 231.375 70.7172C231.328 70.7047 231.28 70.6922 231.323 70.6423C231.298 70.6215 231.271 70.6049 231.248 70.582L231.259 70.5737C231.223 70.5258 231.188 70.5279 231.148 70.5279C231.146 70.5113 231.163 70.5113 231.169 70.5092C231.153 70.4655 231.144 70.4426 231.126 70.426C231.103 70.401 231.065 70.3802 231.009 70.3657L231.032 70.3303C231.015 70.3303 230.996 70.2866 230.978 70.2492C230.957 70.2076 230.959 70.1909 230.909 70.1535C230.913 70.1535 230.921 70.1493 230.93 70.1535C230.83 70.0807 230.917 69.8768 230.761 69.906L230.699 69.854C230.724 69.9455 230.632 69.8664 230.624 69.9122C230.599 69.8789 230.632 69.804 230.655 69.8456L230.651 69.856C230.73 69.8436 230.636 69.7375 230.69 69.7208C230.63 69.5503 230.644 69.3693 230.642 69.2092L230.582 69.2299C230.582 69.2112 230.582 69.1904 230.582 69.1717C230.597 69.1571 230.63 69.1509 230.628 69.1925C230.663 69.1717 230.599 69.1239 230.584 69.1218C230.611 69.0407 230.655 69.1551 230.657 69.1301L230.653 69.0968L230.644 69.1031C230.622 69.076 230.594 69.0719 230.599 69.0219C230.613 68.9907 230.638 69.0095 230.642 68.997C230.647 68.997 230.649 68.9928 230.647 68.9783L230.659 68.9055L230.607 68.9304C230.588 68.893 230.619 68.8576 230.559 68.8867C230.649 68.8431 230.628 68.6018 230.661 68.5768C230.634 68.5248 230.644 68.477 230.661 68.4229C230.649 68.4354 230.592 68.4312 230.611 68.3834C230.717 68.4271 230.68 68.3064 230.771 68.2919C230.755 68.2981 230.749 68.2856 230.746 68.2752C230.744 68.2669 230.746 68.2544 230.746 68.2419C230.746 68.2253 230.74 68.2045 230.705 68.2024C230.724 68.1795 230.742 68.2232 230.774 68.2232C230.778 68.1483 230.884 68.1858 230.982 68.1525C230.982 68.1379 230.961 68.1171 230.98 68.0922L231.046 68.1608C231.067 68.1525 231.061 68.0734 231.107 68.1213C231.101 68.1088 231.09 68.0901 231.107 68.0859C231.225 68.1171 231.34 68.1067 231.453 68.1213C231.563 68.1358 231.68 68.1816 231.759 68.2919C231.742 68.2523 231.761 68.2586 231.786 68.2669C231.773 68.2544 231.8 68.2336 231.807 68.2128L231.875 68.3064C231.917 68.2648 231.979 68.3522 232.013 68.3085L231.977 68.3023C232.046 68.2648 231.982 68.1483 232.023 68.0776C231.948 68.1213 231.948 67.9237 231.825 67.9819C231.815 67.959 231.85 67.9632 231.848 67.9424C231.815 67.9653 231.788 67.9632 231.746 67.9299L231.755 67.9237C231.621 67.8842 231.569 67.8301 231.407 67.7843L231.413 67.8259C231.38 67.8155 231.373 67.803 231.357 67.7906C231.311 67.8467 231.455 67.8051 231.409 67.8675C231.371 67.776 231.171 67.8488 231.14 67.7594C231.086 67.7594 231.157 67.8051 231.105 67.8072L231.09 67.7822L231.078 67.8155C231.044 67.8114 231.023 67.7822 231.021 67.7614C231.03 67.7614 231.044 67.7531 231.055 67.751C231.032 67.7386 230.998 67.7427 230.971 67.751C230.94 67.7594 230.911 67.7718 230.901 67.7698L230.963 67.776C230.874 67.7989 230.803 67.8134 230.705 67.853C230.601 67.8946 230.501 67.9674 230.49 68.0693H230.511C230.509 68.0859 230.505 68.1005 230.503 68.113C230.488 68.2003 230.449 68.1837 230.438 68.2814L230.434 68.2773C230.447 68.3043 230.449 68.3355 230.44 68.3647C230.426 68.3314 230.386 68.4083 230.372 68.3647C230.386 68.4811 230.388 68.425 230.444 68.5103L230.411 68.5207C230.434 68.5498 230.449 68.5539 230.449 68.6101C230.43 68.5623 230.397 68.6371 230.369 68.581C230.284 68.685 230.413 68.7599 230.307 68.7973C230.386 68.8597 230.367 68.7058 230.382 68.737C230.413 68.7162 230.44 68.789 230.428 68.8223C230.422 68.8597 230.309 68.8659 230.301 68.9658C230.301 68.9554 230.297 68.9554 230.297 68.945C230.27 68.9803 230.32 69.0178 230.282 69.0615C230.332 69.0885 230.278 69.1197 230.344 69.128C230.338 69.0989 230.336 69.0698 230.332 69.0386C230.347 69.0906 230.424 69.1364 230.388 69.2154C230.374 69.2092 230.355 69.1863 230.347 69.1696C230.326 69.1946 230.361 69.2154 230.342 69.2404C230.274 69.2362 230.324 69.1343 230.276 69.0781C230.247 69.1051 230.324 69.1821 230.251 69.1551C230.342 69.1925 230.24 69.2549 230.317 69.3173H230.278C230.278 69.3173 230.307 69.3464 230.307 69.3652L230.251 69.3339C230.299 69.3839 230.224 69.4442 230.255 69.4941C230.238 69.3839 230.299 69.4629 230.322 69.413C230.394 69.5357 230.228 69.5066 230.28 69.6543C230.27 69.6356 230.286 69.5732 230.311 69.6002C230.311 69.6293 230.303 69.6709 230.286 69.6938C230.322 69.7895 230.322 69.6688 230.357 69.7021C230.32 69.7479 230.388 69.7437 230.417 69.7791L230.378 69.7916C230.388 69.906 230.467 69.7916 230.472 69.8956L230.403 69.8748L230.434 69.9184L230.386 69.9247C230.438 69.9663 230.438 69.985 230.447 70.0432C230.467 70.0204 230.517 70.0204 230.538 70.064C230.53 70.1036 230.494 70.064 230.53 70.1244C230.501 70.1223 230.463 70.1202 230.484 70.0765C230.472 70.0786 230.455 70.0724 230.44 70.0765C230.43 70.1223 230.474 70.1639 230.486 70.1847C230.484 70.1743 230.48 70.1639 230.482 70.1556C230.515 70.1784 230.547 70.1992 230.578 70.22C230.572 70.2409 230.555 70.2367 230.538 70.2305C230.553 70.2471 230.576 70.2492 230.592 70.2741C230.559 70.2825 230.53 70.3012 230.497 70.2721L230.576 70.3386C230.567 70.3511 230.567 70.401 230.551 70.3969C230.551 70.4031 230.555 70.4114 230.559 70.4177C230.565 70.426 230.574 70.4385 230.584 70.4468C230.603 70.4655 230.626 70.4801 230.647 70.4925C230.688 70.5175 230.728 70.5341 230.738 70.5653C230.744 70.5633 230.755 70.5653 230.765 70.5674C230.78 70.5882 230.782 70.609 230.782 70.6194C230.786 70.6361 230.817 70.6818 230.859 70.7005L230.844 70.7775C230.899 70.8233 230.861 70.6777 230.951 70.7525C231.017 70.7983 230.932 70.8087 230.94 70.8399C230.99 70.8503 231.08 70.8524 231.105 70.9356C231.078 70.9293 231.069 70.9106 231.051 70.8981L231.03 70.9106ZM231.725 71.2663C231.709 71.2705 231.673 71.2829 231.671 71.258C231.702 71.2205 231.707 71.2455 231.725 71.2663ZM232.86 71.2538C232.85 71.2684 232.827 71.2642 232.804 71.2476C232.821 71.2434 232.838 71.2455 232.86 71.2538ZM232.754 70.3324C232.735 70.3865 232.742 70.3677 232.754 70.3324V70.3324ZM232.783 70.2305C232.783 70.2305 232.773 70.2221 232.767 70.2263C232.777 70.2325 232.775 70.2554 232.767 70.2804C232.779 70.2721 232.788 70.2596 232.781 70.2305H232.783ZM230.607 68.9949L230.594 69.0053C230.586 68.9783 230.594 68.9866 230.607 68.9949Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.717 71.3125C232.717 71.3125 232.712 71.2976 232.71 71.2891C232.704 71.2955 232.704 71.304 232.717 71.3125Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.72 70.5785V70.5762L230.713 70.5809L230.72 70.5785Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.457 70.8445C233.442 70.8423 233.433 70.8357 233.427 70.8291C233.427 70.8401 233.438 70.8467 233.457 70.8445Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.702 69.9809L232.723 70.0081C232.715 69.9934 232.723 69.9851 232.725 69.9746C232.717 69.9788 232.706 69.9892 232.702 69.9809Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.783 69.5732C232.783 69.5732 232.777 69.5628 232.769 69.5586L232.752 69.569C232.765 69.59 232.788 69.5983 232.781 69.5711L232.783 69.5732Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.817 69.9002C232.848 69.8835 232.827 69.8668 232.811 69.8438C232.811 69.8438 232.811 69.8458 232.811 69.8479C232.763 69.8605 232.79 69.8793 232.815 69.9002H232.817Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.809 69.8399C232.809 69.8399 232.798 69.8249 232.796 69.8164C232.777 69.8228 232.796 69.8271 232.809 69.8399Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.771 70.127C232.782 70.1165 232.727 70.1165 232.742 70.1123C232.7 70.0956 232.788 70.1918 232.771 70.127Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.913 69.835L232.877 69.8621L232.917 69.8642L232.913 69.835Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.944 70.0542C232.948 70.0396 232.95 70.025 232.95 70.0103C232.944 70.0103 232.938 70.0082 232.934 70.002C232.938 70.027 232.929 70.0563 232.942 70.0542H232.944Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.936 70.0021C232.933 69.9895 232.929 69.977 232.921 69.9707C232.923 69.9791 232.929 69.9916 232.936 70.0021Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.948 69.8896L232.946 69.9064L232.953 69.9377L232.948 69.8896Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.017 70.5158C233.038 70.52 233.057 70.52 233.078 70.5221C233.092 70.5116 233.084 70.499 233.061 70.499C233.042 70.5032 233.019 70.5011 233.017 70.5158Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.03 70.3488C233.019 70.3634 233.009 70.3697 232.994 70.3843L233.051 70.353C233.051 70.353 233.036 70.3488 233.03 70.3467V70.3488Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.108 70.4111C233.125 70.4007 233.183 70.3881 233.144 70.3818C233.131 70.3944 233.087 70.3902 233.108 70.4111Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.344 70.7251L233.356 70.7209L233.331 70.6377L233.344 70.7251Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.575 70.9343C232.647 71.0057 232.619 70.9007 232.682 70.9658C232.71 70.9574 232.63 70.9133 232.659 70.907C232.598 70.8944 232.592 70.8755 232.575 70.9322V70.9343Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.658 70.9089C232.658 70.9089 232.678 70.9111 232.689 70.9089C232.673 70.9067 232.665 70.9067 232.658 70.9089Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.896 68.3831L231.924 68.4166L231.913 68.3789L231.896 68.3831Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.992 68.3584L231.978 68.4128L232.021 68.3772C232.021 68.3772 231.992 68.373 231.992 68.3584Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.788 71.4079L231.795 71.3954C231.795 71.3807 231.786 71.3765 231.77 71.3682L231.788 71.4079Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.29 71.1476L231.298 71.1538L231.307 71.1016L231.29 71.1476Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.838 70.8688C230.853 70.8877 230.878 70.9002 230.892 70.9169C230.85 70.8856 230.88 70.8228 230.838 70.8688Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.032 65.97C239.038 65.9993 239.069 65.9784 239.076 65.9805C239.053 65.9366 239.023 65.9742 239.032 65.97Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.832 65.5383L238.847 65.5446L238.803 65.4756L238.832 65.5383Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.645 65.0177C238.688 65.1009 238.795 65.2257 238.789 65.3193L238.778 65.3359L238.833 65.3672C238.805 65.2673 238.755 65.1092 238.645 65.0156V65.0177Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.695 64.9033C238.673 64.9232 238.682 64.9099 238.684 64.921C238.689 64.921 238.689 64.9165 238.693 64.9165C238.693 64.9165 238.693 64.9121 238.695 64.9055V64.9033Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.663 64.849L238.682 64.8762C238.682 64.8762 238.69 64.8762 238.692 64.8762C238.699 64.8699 238.703 64.8762 238.705 64.8637C238.705 64.849 238.705 64.8407 238.713 64.849C238.682 64.7884 238.674 64.8051 238.663 64.849Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.603 64.8018L238.621 64.831C238.621 64.831 238.626 64.8143 238.603 64.8018Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.657 64.8864C238.657 64.8864 238.631 64.8488 238.621 64.832C238.615 64.8446 238.596 64.8508 238.638 64.8613C238.617 64.8571 238.642 64.878 238.659 64.8864H238.657Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.653 64.9014V64.9056C238.644 64.9223 238.642 64.9453 238.617 64.9286C238.64 64.9787 238.669 64.9348 238.655 64.9035L238.653 64.9014Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.59 65.059C238.59 65.059 238.609 65.0821 238.623 65.101C238.642 65.1094 238.659 65.1199 238.674 65.1304C238.663 65.122 238.647 65.0947 238.623 65.0716C238.602 65.0527 238.596 65.0506 238.59 65.0569V65.059Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.578 64.4521C238.565 64.4521 238.551 64.4833 238.536 64.4917L238.563 64.5333C238.563 64.5062 238.559 64.4605 238.576 64.4521H238.578Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.536 64.4934L238.494 64.4307C238.511 64.4934 238.523 64.5018 238.536 64.4934Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.536 64.81C238.561 64.8391 238.59 64.8828 238.613 64.9015C238.588 64.8765 238.556 64.8246 238.529 64.7871L238.536 64.8079V64.81Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.501 64.1904L238.541 64.2219L238.476 64.1631L238.501 64.1904Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.442 64.0172C238.476 64.038 238.47 63.9652 238.495 63.9901C238.476 63.9444 238.444 63.909 238.413 63.8799C238.436 63.9152 238.447 63.9568 238.442 64.0172Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.367 63.8281C238.38 63.8449 238.396 63.8616 238.413 63.8804C238.401 63.8616 238.386 63.8449 238.367 63.8281Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.465 64.3129C238.465 64.3129 238.488 64.2899 238.484 64.248L238.457 64.2857C238.457 64.2857 238.461 64.3024 238.465 64.3129Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.457 64.2862C238.449 64.2549 238.444 64.234 238.442 64.2256C238.442 64.234 238.449 64.2507 238.457 64.2862Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.468 64.3196V64.3125C238.468 64.3125 238.463 64.3196 238.468 64.3196Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.514 64.6209C238.482 64.5852 238.436 64.5075 238.43 64.5978C238.463 64.6188 238.465 64.5684 238.514 64.6209Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.434 64.3643L238.448 64.4395C238.448 64.4395 238.467 64.4186 238.482 64.4354L238.434 64.3643Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.411 64.333L238.434 64.3644L238.428 64.3372L238.411 64.333Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.374 63.963C238.348 63.936 238.336 63.9027 238.321 63.8652C238.328 63.9089 238.34 63.9526 238.351 63.9942C238.363 63.9963 238.388 64.0088 238.374 63.9651V63.963Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.412 64.1223L238.407 64.1152C238.407 64.1152 238.407 64.1247 238.412 64.1223Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.197 63.4844L238.192 63.4929H238.199L238.197 63.4844Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.347 64.0025C238.349 64.036 238.364 64.0527 238.38 64.0673C238.37 64.0443 238.359 64.0213 238.351 63.9941C238.345 63.9941 238.343 63.9941 238.347 64.0025Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.315 63.7275C238.315 63.7464 238.315 63.7673 238.315 63.7882C238.322 63.7694 238.328 63.7317 238.315 63.7275Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.413 64.1008V64.1051C238.422 64.0923 238.417 64.0944 238.413 64.1008Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.413 64.101C238.403 64.0863 238.39 64.0759 238.38 64.0654C238.388 64.0843 238.397 64.101 238.407 64.1135C238.407 64.1093 238.411 64.1031 238.413 64.0989V64.101Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.938 63.4432C237.972 63.437 238.028 63.5098 238.017 63.5909C238.063 63.6512 238.155 63.5722 238.192 63.4932C238.178 63.4952 238.165 63.4994 238.124 63.4349C238.115 63.4661 238.134 63.6076 238.086 63.5556C238.038 63.4661 238.072 63.4744 238.074 63.4224C238.047 63.4744 237.976 63.3226 237.926 63.3621L237.974 63.437C237.974 63.437 237.94 63.4162 237.94 63.4432H237.938Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.234 63.6304L238.248 63.6596C238.242 63.6242 238.248 63.5951 238.259 63.5431C238.227 63.4994 238.211 63.4932 238.2 63.4932L238.244 63.6388L238.236 63.6304H238.234Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.293 63.7902C238.251 63.7777 238.211 63.7133 238.188 63.7673C238.22 63.8526 238.237 63.8193 238.27 63.8651C238.216 63.7278 238.303 63.8984 238.289 63.7923C238.303 63.8173 238.314 63.8422 238.322 63.8651C238.318 63.8381 238.316 63.8131 238.314 63.7881V63.7923C238.314 63.7923 238.31 63.8027 238.31 63.7944C238.31 63.7944 238.299 63.7902 238.295 63.7902C238.289 63.7486 238.301 63.7819 238.31 63.7923C238.31 63.7923 238.314 63.7923 238.316 63.7923L238.251 63.6592C238.255 63.6904 238.27 63.7278 238.295 63.7902H238.293Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.332 64.5465C238.332 64.5465 238.336 64.5399 238.338 64.5399C238.332 64.5311 238.327 64.5289 238.332 64.5465Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.336 64.4828C238.336 64.4828 238.361 64.4953 238.367 64.5307C238.367 64.5619 238.351 64.5348 238.34 64.5411C238.355 64.5577 238.386 64.6035 238.384 64.5348L238.376 64.5265C238.371 64.4662 238.392 64.3809 238.401 64.3892C238.374 64.4142 238.357 64.4371 238.336 64.4828Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.307 64.1358L238.255 64.0234L238.242 64.0921L238.259 64.0838C238.271 64.1524 238.29 64.1316 238.307 64.1358Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.211 63.4663L238.253 63.4684L238.178 63.418L238.211 63.4663Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.157 63.3161L238.191 63.3098L238.157 63.2764V63.3161Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.323 62.3447L240.34 62.3782C240.334 62.3615 240.327 62.351 240.323 62.3447Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.263 62.0762H240.244C240.257 62.0847 240.265 62.0868 240.263 62.0762Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.524 61.7959C237.526 61.8541 237.517 61.9269 237.544 61.902L237.565 61.8687C237.54 61.8437 237.528 61.8188 237.521 61.7959H237.524Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.453 60.9598L238.438 60.9473C238.424 60.9577 238.411 60.9682 238.398 60.9786C238.415 60.9724 238.432 60.9661 238.451 60.9598H238.453Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.509 60.8115L238.578 60.8472C238.563 60.8367 238.54 60.8241 238.509 60.8115Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.717 63.6798L240.765 63.7091C240.746 63.6464 240.736 63.6798 240.717 63.6798Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.499 61.7748C237.482 61.7311 237.463 61.6999 237.446 61.6729C237.463 61.729 237.465 61.781 237.499 61.7748Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.921 62.3261C239.932 62.346 239.943 62.3526 239.951 62.3504C239.941 62.3305 239.93 62.3195 239.921 62.3261Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.365 61.5713C237.365 61.5713 237.372 61.5858 237.374 61.5962C237.399 61.6191 237.424 61.642 237.447 61.6753C237.434 61.6337 237.413 61.5921 237.365 61.5734V61.5713Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.517 65.1113C239.517 65.1113 239.517 65.1201 239.515 65.1246C239.519 65.1246 239.519 65.1201 239.517 65.1113Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.952 66.0283C238.967 66.0241 238.99 66.0199 239.013 66.0137C239 66.0137 238.981 66.0179 238.952 66.0283Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.965 62.6963C237.971 62.7007 237.982 62.7316 237.965 62.6963V62.6963Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.887 62.9062C237.887 62.9062 237.874 62.8976 237.865 62.8998C237.874 62.8998 237.882 62.9019 237.887 62.9062Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.969 62.7551C237.969 62.7405 237.967 62.7238 237.963 62.707C237.963 62.7154 237.963 62.73 237.969 62.7551Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.982 62.7402C237.987 62.7528 237.989 62.7632 237.991 62.7716C237.999 62.7737 238.001 62.7674 237.982 62.7402Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.942 62.6504C237.951 62.6692 237.957 62.688 237.961 62.7069C237.961 62.6985 237.961 62.6964 237.963 62.6964C237.959 62.6859 237.953 62.6734 237.942 62.6504Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.23 65.7373C240.23 65.7373 240.225 65.7373 240.221 65.7373C240.202 65.7672 240.213 65.7587 240.23 65.7373Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.459 61.5463L237.464 61.551L237.459 61.5439V61.5463Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.31 61.415C237.412 61.465 237.431 61.4941 237.46 61.544C237.477 61.5107 237.498 61.4795 237.521 61.4504C237.458 61.4462 237.387 61.4338 237.31 61.415Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.466 62.9293C240.468 62.9001 240.471 62.8669 240.475 62.8419C240.554 62.9209 240.558 63 240.579 62.9085C240.458 62.9209 240.489 62.6235 240.377 62.6297L240.389 62.5715C240.389 62.586 240.398 62.5881 240.4 62.6027C240.433 62.4883 240.302 62.5424 240.291 62.4009C240.291 62.351 240.3 62.3136 240.321 62.3427L240.269 62.2387C240.264 62.2054 240.285 62.2096 240.289 62.2428C240.275 62.1867 240.256 62.1305 240.237 62.0744H240.241C240.216 62.0556 240.175 62.0078 240.152 61.987C240.152 61.9392 240.171 62.0036 240.181 61.987L240.121 61.9038C240.133 61.8539 240.191 61.9225 240.21 61.9891C240.283 61.8601 240.164 61.9204 240.129 61.702C240.148 61.7291 240.171 61.7582 240.187 61.7873C240.219 61.6999 240.16 61.6375 240.127 61.5107C240.131 61.5502 240.162 61.7686 240.079 61.6791C240.069 61.6479 240.052 61.6063 239.996 61.571C240.027 61.5481 239.985 61.5003 239.931 61.4462L239.975 61.415C239.904 61.3609 239.89 61.3859 239.837 61.3713C239.773 61.3047 239.783 61.2631 239.79 61.2236C239.683 61.1321 239.825 61.3339 239.687 61.2444C239.608 61.1591 239.525 61.1321 239.392 61.0947C239.331 61.0406 239.419 61.0718 239.402 61.0447L239.319 61.0489C239.304 61.0406 239.315 61.0302 239.319 61.026C239.258 61.0156 239.29 61.0718 239.2 61.0468C239.156 61.0905 239.059 60.8908 238.925 60.9241C238.902 60.9012 238.948 60.8971 238.946 60.8742C238.782 60.8742 238.806 60.87 238.671 60.8991C238.638 60.8804 238.604 60.8638 238.571 60.845C238.642 60.8991 238.534 60.9283 238.446 60.9574C238.471 60.9782 238.49 60.999 238.504 61.0094C238.459 61.0094 238.415 61.0198 238.369 61.0239C238.355 61.0135 238.369 60.9969 238.392 60.9761C238.384 60.9803 238.373 60.9844 238.367 60.9865C238.321 60.9615 238.348 60.9324 238.386 60.9054C238.4 60.9179 238.417 60.9303 238.432 60.9428C238.469 60.9137 238.504 60.8804 238.502 60.8492C238.492 60.8534 238.475 60.8575 238.455 60.8575C238.465 60.8492 238.471 60.843 238.467 60.8367C238.463 60.8305 238.446 60.8409 238.423 60.8534L238.398 60.791L238.388 60.8138C238.327 60.793 238.267 60.7806 238.205 60.7639C238.067 60.8201 237.961 60.9095 237.759 60.9491C237.798 60.9012 237.751 60.8783 237.734 60.8263C237.83 60.8721 237.923 60.7889 238.032 60.7993C237.975 60.793 237.988 60.7702 238 60.7598L237.796 60.8201C237.796 60.7764 237.734 60.793 237.653 60.7826C237.738 60.8575 237.488 60.8575 237.415 60.8929C237.378 60.87 237.374 60.8409 237.511 60.8305C237.413 60.8118 237.382 60.8388 237.367 60.8679C237.351 60.8971 237.349 60.9241 237.249 60.9116C237.276 60.9075 237.297 60.9075 237.29 60.895C237.257 60.9241 237.065 60.9345 237.059 60.9095L237.088 60.9033C237.045 60.9137 236.915 60.8991 237.007 60.9719C237.051 61.026 237.101 61.0822 237.151 61.1342C237.249 61.2403 237.349 61.3214 237.399 61.3255C237.39 61.3297 237.276 61.3172 237.249 61.3068C237.438 61.4046 237.582 61.4483 237.69 61.4483C237.659 61.4587 237.63 61.5065 237.596 61.5419C237.559 61.5731 237.532 61.6126 237.453 61.5481C237.486 61.6022 237.505 61.6375 237.569 61.6812C237.561 61.6563 237.599 61.5772 237.624 61.598C237.63 61.7124 237.636 61.6708 237.665 61.7935C237.653 61.7582 237.753 61.7249 237.786 61.7707C237.769 61.7727 237.717 61.8372 237.694 61.8268L237.778 61.8497L237.819 61.8622L237.84 61.8684H237.851L237.855 61.8726H237.857C237.832 61.8622 237.811 61.8892 237.801 61.9204L237.809 61.7208C237.794 61.7166 237.78 61.7145 237.767 61.7166C237.782 61.7166 237.748 61.7457 237.715 61.7769L237.978 61.806C237.961 61.779 237.944 61.7499 237.932 61.7374L237.946 61.7998C237.869 61.6563 237.746 61.7395 237.659 61.6063C237.686 61.6105 237.786 61.5751 237.746 61.5003C237.682 61.4982 237.459 61.5044 237.34 61.4441V61.4067C237.311 61.39 237.278 61.3775 237.247 61.3671C237.336 61.338 237.586 61.3713 237.703 61.4254C237.68 61.3609 237.717 61.39 237.653 61.3172C237.648 61.2735 237.717 61.3318 237.738 61.3547C237.692 61.2902 237.644 61.2278 237.588 61.1654C237.559 61.2111 237.407 61.0822 237.384 61.13C237.463 61.1675 237.544 61.2111 237.615 61.2611C237.578 61.3068 237.405 61.2652 237.282 61.1737C237.259 61.1321 237.363 61.1071 237.374 61.0905C237.344 61.0905 237.213 61.0364 237.203 61.0198C237.23 61.0198 237.257 61.0239 237.284 61.0281C237.203 60.9574 237.109 61.0281 237.013 60.9449C236.976 60.9345 236.901 60.8513 236.888 60.8867C236.953 60.9595 236.922 61.1612 236.886 61.2028C236.88 61.1924 236.73 61.1342 236.684 61.1092C236.684 61.1092 236.68 61.1071 236.68 61.1051L236.69 61.0801C236.688 61.103 236.67 61.1113 236.649 61.1134H236.647L236.676 61.051C236.693 61.0115 236.747 60.9678 236.709 60.9428C236.709 60.9574 236.682 60.974 236.668 60.9844L236.486 61.1009L236.595 61.1591C236.595 61.1591 236.599 61.1612 236.601 61.1633C236.613 61.2007 236.553 61.182 236.609 61.2382C236.663 61.2132 236.705 61.3651 236.67 61.2382C236.73 61.2881 236.711 61.3089 236.77 61.3775C236.78 61.3318 236.92 61.3609 236.98 61.4108C236.965 61.4171 236.961 61.442 236.959 61.4545C237.053 61.5814 237.084 61.6625 237.176 61.7769C237.174 61.7956 237.203 61.8622 237.165 61.8539C237.186 61.8643 237.213 61.8664 237.244 61.9017C237.259 61.9995 237.176 61.8268 237.169 61.9163C237.201 61.8996 237.28 61.9787 237.336 62.0161C237.365 61.9704 237.251 61.8934 237.194 61.856C237.224 61.8352 237.269 61.8331 237.324 61.8518C237.351 61.8601 237.38 61.8747 237.411 61.8913C237.44 61.91 237.471 61.9246 237.507 61.9683C237.588 62.0972 237.49 62.0432 237.511 62.064C237.574 62.3032 237.68 62.1908 237.711 62.3864C237.701 62.4737 237.63 62.428 237.607 62.4571C237.551 62.376 237.567 62.3052 237.544 62.2491C237.544 62.2761 237.551 62.3032 237.555 62.3302C237.528 62.3073 237.492 62.2512 237.496 62.2116C237.467 62.2886 237.646 62.5673 237.68 62.7441C237.707 62.767 237.74 62.8107 237.748 62.7795L237.721 62.7296C237.736 62.6672 237.809 62.8086 237.798 62.7358C237.853 62.7982 237.919 62.8669 237.932 62.9729L237.888 63.0083C237.903 63.0021 237.896 62.9334 237.871 62.9105C237.907 62.9459 237.855 63.0873 237.934 63.1102L237.944 63.027C237.992 63.0894 238.073 63.1601 238.088 63.2558C238.123 63.1997 238.075 63.2371 238.111 63.1539C238.059 63.2329 238.038 62.9251 237.994 63.0374C238.038 62.9501 237.986 62.9147 238.013 62.8107C237.996 62.819 237.992 62.8544 237.973 62.7733C237.967 62.7733 237.959 62.7649 237.953 62.7608C237.953 62.7587 237.953 62.7566 237.953 62.7545V62.7587C237.953 62.7795 237.95 62.8003 237.942 62.8086C237.892 62.7816 237.844 62.6588 237.807 62.6276C237.794 62.5798 237.834 62.638 237.838 62.6068L237.784 62.5611C237.815 62.5403 237.788 62.4196 237.855 62.5132L237.813 62.4217C237.807 62.3593 237.782 62.2865 237.748 62.2512C237.736 62.2033 237.676 62.1825 237.711 62.1971C237.69 62.168 237.671 62.1222 237.646 62.0681L237.655 62.064C237.642 62.0224 237.621 61.9745 237.588 61.9225C237.546 61.8601 237.517 61.8414 237.49 61.8102C237.434 61.7519 237.38 61.6854 237.353 61.5959C237.313 61.5606 237.269 61.5273 237.226 61.4524L237.24 61.4191C237.19 61.3734 237.142 61.2423 237.097 61.2423C237.117 61.1467 236.963 61.0198 236.882 60.922L236.703 61.3567C236.718 61.3567 236.732 61.3567 236.745 61.3567V61.3131C236.807 61.311 236.863 61.3027 236.94 61.3027L236.945 61.2652C237.022 61.2507 237.103 61.3443 237.188 61.4067C237.174 61.4129 237.153 61.3963 237.142 61.3775C237.174 61.4462 237.23 61.4795 237.297 61.5169C237.359 61.5564 237.426 61.6001 237.442 61.675C237.474 61.6937 237.484 61.7166 237.492 61.7415C237.492 61.7395 237.488 61.7374 237.486 61.7353C237.488 61.7374 237.49 61.7436 237.494 61.7478C237.499 61.7644 237.503 61.7811 237.505 61.7977C237.505 61.7811 237.503 61.7644 237.499 61.7519C237.515 61.7728 237.542 61.8039 237.574 61.8331L237.549 61.8705C237.549 61.8705 237.553 61.8747 237.555 61.8768C237.565 61.9184 237.588 61.8934 237.603 61.858C237.619 61.8705 237.638 61.883 237.653 61.8892C237.626 61.935 237.678 61.9558 237.696 61.9912L237.782 62.1492L237.942 62.0182C237.955 62.0078 237.971 62.0016 237.994 62.0078C237.994 61.9953 238.005 61.9745 238.021 61.9495L238.128 61.7956L238.034 61.7228C237.982 61.6833 237.913 61.6209 237.865 61.6417C237.871 61.6355 237.865 61.623 237.882 61.6396C237.857 61.598 237.834 61.5585 237.79 61.5398L237.817 61.4919L237.698 61.4607C237.682 61.3942 237.703 61.3879 237.751 61.3838C237.703 61.3755 237.682 61.3609 237.667 61.3505C237.651 61.3401 237.636 61.3318 237.569 61.3006H237.613C237.596 61.2839 237.499 61.2382 237.526 61.2278C237.538 61.2195 237.536 61.2007 237.521 61.1799C237.515 61.1695 237.507 61.1571 237.496 61.1425C237.496 61.1321 237.532 61.1363 237.549 61.13C237.63 61.1196 237.736 61.1071 237.809 61.1321C237.776 61.0843 237.798 61.0947 237.823 61.1071C237.836 61.1134 237.846 61.1196 237.855 61.1196C237.867 61.1196 237.882 61.1134 237.882 61.0947C237.898 61.1175 237.932 61.13 237.894 61.1508C238.021 61.1217 238.082 61.1841 238.169 61.1217C238.182 61.1467 238.142 61.155 238.155 61.1695C238.165 61.1654 238.194 61.1508 238.207 61.1654C238.219 61.1799 238.188 61.1841 238.167 61.1924C238.292 61.1924 238.311 61.1238 238.325 61.0572C238.388 61.0967 238.421 61.0926 238.473 61.0572C238.494 61.0822 238.527 61.1113 238.446 61.1071C238.492 61.1134 238.709 61.1862 238.725 61.1363C238.736 61.1508 238.786 61.1571 238.798 61.1529C238.894 61.182 238.9 61.1924 238.996 61.2215L238.973 61.2049C239.034 61.1571 239.056 61.2215 239.131 61.2465L239.127 61.2507C239.269 61.3755 239.213 61.2631 239.342 61.4025L239.354 61.363C239.417 61.2985 239.463 61.494 239.563 61.5315L239.546 61.4899C239.617 61.5023 239.59 61.6791 239.608 61.7208C239.608 61.7332 239.588 61.7166 239.573 61.7103C239.619 61.8372 239.625 61.6833 239.698 61.754C239.685 61.7852 239.627 61.7811 239.66 61.8331C239.658 61.8539 239.706 61.8767 239.746 61.9184C239.79 61.9579 239.829 62.014 239.819 62.0702C239.833 62.0432 239.846 62.014 239.879 62.0556C239.914 62.1284 239.86 62.2782 239.942 62.3344C239.937 62.3448 239.933 62.351 239.927 62.3531C239.958 62.4092 239.998 62.5465 240.042 62.5777C239.91 62.663 240.196 62.9605 240.073 62.9896L240.135 63.1768H240.121C240.148 63.2995 240.189 63.3328 240.233 63.3661C240.233 63.3973 240.214 63.3785 240.208 63.3785C240.235 63.5637 240.246 63.5782 240.352 63.7093L240.316 63.7363C240.352 63.7696 240.329 64.0109 240.427 64.171C240.423 64.171 240.412 64.171 240.404 64.1565C240.508 64.3374 240.429 64.6578 240.598 64.6848L240.671 64.8034C240.633 64.6328 240.741 64.8075 240.746 64.7326C240.773 64.795 240.752 64.9157 240.721 64.8366L240.725 64.8221C240.639 64.8159 240.758 65.0384 240.706 65.0488C240.723 65.1008 240.731 65.1487 240.71 65.1944C240.685 65.2381 240.641 65.2547 240.593 65.2693C240.462 65.313 240.279 65.3629 240.127 65.4461L240.192 65.4815C240.156 65.4981 240.121 65.5168 240.085 65.5376C240.05 65.5418 240.023 65.5189 240.1 65.4752C240.071 65.4711 240.044 65.4981 240.023 65.5251C240.004 65.5522 240 65.5771 240.002 65.5855C239.873 65.6333 240.008 65.4981 239.973 65.5168C239.958 65.5272 239.942 65.5397 239.929 65.548H239.942C239.931 65.5688 239.927 65.5875 239.917 65.6021C239.912 65.6146 239.887 65.6312 239.881 65.6312C239.883 65.6458 239.883 65.6666 239.881 65.6791C239.881 65.6874 239.881 65.6895 239.881 65.6936C239.881 65.7019 239.877 65.704 239.877 65.7061C239.877 65.7061 239.883 65.6999 239.887 65.6957C239.896 65.6895 239.894 65.6936 239.917 65.677C240.014 65.6416 239.973 65.652 239.979 65.6312L239.971 65.5563C239.96 65.5917 239.946 65.6083 239.931 65.6271C239.917 65.6042 239.91 65.5563 239.9 65.5355C239.89 65.5127 239.885 65.5168 239.867 65.5626C239.879 65.5355 239.881 65.4856 239.86 65.4315C239.842 65.3816 239.775 65.3171 239.76 65.2963L239.45 64.8741L239.525 65.4045C239.546 65.5439 239.567 65.6999 239.554 65.7331C239.575 65.7706 239.588 65.8226 239.594 65.8517C239.594 65.885 239.615 65.9204 239.581 65.9474C239.6 65.9391 239.671 65.9516 239.606 66.0036C239.577 65.9744 239.552 65.9724 239.527 65.9848L239.737 66.0327C239.737 65.9765 239.708 65.885 239.748 65.8268C239.71 65.9037 239.673 65.5751 239.623 65.6957C239.615 65.6187 239.662 65.6811 239.675 65.6187C239.631 65.5355 239.615 65.4357 239.6 65.3296C239.592 65.2755 239.585 65.2215 239.577 65.1674L239.56 65.0842L239.55 65.0426V65.0384C239.55 65.0384 239.542 65.0176 239.538 65.0072C239.529 64.9885 239.517 64.9698 239.508 64.9594C239.488 64.9344 239.469 64.9219 239.456 64.9115C239.448 64.9157 239.46 64.9344 239.46 64.949C239.46 64.9635 239.44 64.9573 239.402 64.949C239.392 64.9344 239.383 64.9219 239.377 64.9115C239.375 64.9053 239.373 64.9011 239.371 64.897C239.371 64.8949 239.371 64.8928 239.371 64.8907L239.358 64.9074L239.125 65.0114L239.092 65.0779C239.1 65.1362 239.175 65.1258 239.136 65.2069C239.146 65.1944 239.163 65.1757 239.171 65.2048C239.161 65.4024 239.181 65.6104 239.233 65.8247C239.246 65.8788 239.263 65.9308 239.279 65.9848C239.292 66.0264 239.302 66.0743 239.298 66.0868C239.283 66.0868 239.338 66.093 239.348 66.1013C239.365 66.1076 239.365 66.1138 239.36 66.1055C239.356 66.0992 239.344 66.068 239.34 66.041C239.34 66.041 239.333 66.041 239.327 66.0389C239.296 66.0327 239.244 66.0181 239.188 66.0015C239.121 65.9869 239.063 65.9869 239.015 65.9807C239.09 65.9973 239.04 66.0077 238.992 66.0181C239.025 66.0181 238.998 66.0535 239.006 66.0743C238.948 66.068 238.894 66.0618 238.842 66.0535L239.004 66.274L239.013 66.2636H239.015V66.2615C239.025 66.2656 238.986 66.2469 238.969 66.2386V66.2428C238.959 66.2428 238.95 66.249 238.942 66.2594C238.929 66.2552 238.915 66.249 238.9 66.2428L238.879 66.2344C238.879 66.2344 238.884 66.222 238.884 66.2178C238.884 66.2053 238.884 66.197 238.873 66.1845L238.865 66.224C238.854 66.2074 238.84 66.1991 238.821 66.197C238.806 66.1949 238.765 66.2074 238.773 66.2074C238.773 66.2116 238.752 66.2178 238.694 66.2032C238.704 66.2032 238.713 66.2178 238.721 66.2053C238.729 66.197 238.736 66.1866 238.742 66.1783C238.748 66.17 238.752 66.1575 238.757 66.1471L238.761 66.1388C238.748 66.1304 238.802 66.1575 238.786 66.1492V66.1512L238.777 66.1616L238.692 66.276L238.875 66.2948C238.965 66.3031 239.09 66.3426 239.148 66.2719C239.167 66.2885 239.131 66.2968 239.142 66.3176C239.146 66.3093 239.152 66.3031 239.158 66.2968C239.19 66.2823 239.223 66.2885 239.298 66.3052L239.286 66.3135C239.321 66.3135 239.361 66.3176 239.417 66.301C239.475 66.2885 239.544 66.2199 239.556 66.1637C239.583 66.0597 239.567 66.0119 239.563 65.9578C239.554 65.9016 239.548 65.8663 239.544 65.8205C239.54 65.7748 239.535 65.7227 239.531 65.6645L239.494 65.6895C239.49 65.6354 239.502 65.6229 239.508 65.5979C239.44 65.5459 239.527 65.7456 239.452 65.7019C239.517 65.6229 239.406 65.3213 239.494 65.2568C239.485 65.1695 239.45 65.288 239.442 65.2007L239.465 65.1736L239.429 65.1549C239.425 65.0925 239.46 65.0717 239.481 65.0675C239.477 65.0759 239.485 65.0925 239.49 65.1112C239.498 65.0696 239.504 65.0509 239.498 65.0176L239.154 65.1903C239.206 65.2215 239.225 65.2235 239.229 65.2256C239.292 65.1237 239.325 65.0967 239.331 65.0925C239.321 65.0987 239.306 65.1133 239.288 65.1362C239.277 65.1507 239.267 65.1632 239.252 65.1882L239.233 65.2173C239.233 65.2173 239.221 65.2027 239.204 65.1923C239.223 65.2007 239.236 65.2069 239.24 65.2069C239.233 65.2173 239.254 65.1819 239.271 65.1611C239.281 65.1445 239.296 65.1279 239.304 65.1195C239.323 65.0987 239.336 65.0904 239.342 65.0883C239.038 65.1674 239.258 65.1091 239.19 65.1279V65.1341L239.194 65.1445L239.2 65.1674L239.213 65.2131C239.227 65.2755 239.244 65.3379 239.258 65.4003C239.29 65.5251 239.325 65.6479 239.375 65.7519L239.39 65.7311C239.465 65.8912 239.4 65.8684 239.465 66.0535L239.458 66.0472C239.471 66.0618 239.481 66.0764 239.49 66.0951L239.598 66.3031L239.704 66.1429C239.723 66.1159 239.752 66.0847 239.777 66.0535C239.767 66.0826 239.796 66.066 239.823 66.0452C239.848 66.0244 239.869 65.9994 239.86 66.0493C239.881 65.9807 239.862 65.9349 239.86 65.9079C239.852 65.8808 239.848 65.8663 239.84 65.8559C239.827 65.8351 239.81 65.8226 239.771 65.7623L239.8 65.7311C239.769 65.6895 239.754 65.6874 239.737 65.5917C239.771 65.6687 239.781 65.5251 239.823 65.6125C239.852 65.5043 239.815 65.4274 239.796 65.3671L239.533 65.4877C239.567 65.5147 239.592 65.5314 239.596 65.5397C239.604 65.5522 239.604 65.5688 239.588 65.5896C239.635 65.5896 239.642 65.5647 239.623 65.5376C239.613 65.521 239.558 65.4752 239.588 65.4898C239.579 65.4607 239.608 65.469 239.64 65.4815C239.667 65.4898 239.7 65.5147 239.706 65.5418C239.715 65.5667 239.694 65.6 239.671 65.6291C239.66 65.6479 239.648 65.6707 239.646 65.7103C239.646 65.729 239.646 65.7519 239.656 65.7872C239.667 65.8184 239.692 65.8767 239.765 65.9141C239.712 65.8829 239.706 65.8829 239.673 65.8413C239.692 65.8829 239.748 65.9287 239.798 65.9391C239.856 65.9536 239.887 65.9453 239.925 65.9391C239.981 65.9204 240.021 65.8996 240.069 65.8933C240.089 65.8247 240.167 65.8392 240.142 65.7768C240.1 65.8101 240.058 65.8413 240.002 65.8725C240.094 65.8143 240.11 65.6978 240.246 65.6666C240.244 65.6832 240.217 65.7165 240.202 65.7394C240.244 65.7352 240.258 65.6915 240.302 65.6915C240.312 65.7248 240.277 65.7456 240.237 65.7727C240.2 65.7976 240.144 65.833 240.108 65.8829C240.139 65.8829 240.173 65.8455 240.198 65.8226C240.219 65.8018 240.233 65.7914 240.235 65.833C240.235 65.7227 240.36 65.7727 240.421 65.6687L240.431 65.7082C240.444 65.6957 240.466 65.6666 240.493 65.6541L240.464 65.7227C240.523 65.6499 240.625 65.6999 240.702 65.6437C240.529 65.7123 240.646 65.6146 240.562 65.6146C240.654 65.5501 240.693 65.5626 240.756 65.5667C240.785 65.5709 240.818 65.5709 240.868 65.5543C240.916 65.5376 240.979 65.5002 241.033 65.4128C241.01 65.469 240.873 65.5439 240.923 65.4752C240.983 65.4336 241.052 65.3587 241.081 65.3151C241.118 65.0509 241.039 65.3442 241.033 65.2277C241.091 65.1528 241.018 65.1008 240.979 65.0114L241.018 65.001C241.012 64.9615 241.008 64.9427 241.004 64.9323C241 64.9199 240.995 64.9095 240.989 64.9032C240.979 64.8907 240.966 64.8887 240.956 64.8866C240.933 64.8824 240.912 64.8824 240.904 64.7971L240.977 64.8471L240.939 64.768L240.989 64.7722C240.929 64.6931 240.931 64.6619 240.916 64.5704C240.895 64.5995 240.841 64.5808 240.818 64.5038C240.827 64.4435 240.864 64.5226 240.827 64.4123C240.858 64.429 240.898 64.4477 240.875 64.508C240.889 64.508 240.906 64.5246 240.92 64.5267C240.931 64.4602 240.885 64.3811 240.873 64.3416C240.875 64.3582 240.879 64.377 240.877 64.3874L240.775 64.2438C240.781 64.2147 240.8 64.2314 240.816 64.2459C240.802 64.2147 240.779 64.1981 240.76 64.1502C240.795 64.1523 240.827 64.1398 240.862 64.2022L240.781 64.0608C240.791 64.0462 240.795 63.9714 240.814 63.988C240.808 63.8986 240.691 63.7987 240.683 63.6781C240.675 63.6739 240.666 63.6635 240.654 63.6406C240.631 63.5325 240.641 63.4285 240.56 63.3161L240.596 63.2288C240.554 63.1352 240.552 63.3453 240.483 63.1893C240.431 63.079 240.518 63.131 240.523 63.0873C240.477 63.0395 240.387 62.9521 240.406 62.8377C240.425 62.8669 240.425 62.8981 240.439 62.9293H240.466ZM240.083 61.6854C240.104 61.7062 240.154 61.7436 240.142 61.7728C240.085 61.7644 240.094 61.7332 240.083 61.6854ZM238.271 60.8658C238.29 60.8534 238.319 60.8617 238.35 60.8783C238.327 60.8783 238.3 60.8783 238.271 60.8658ZM237.78 62.3656H237.778C237.769 62.3094 237.771 62.3281 237.78 62.3656ZM237.811 62.4758C237.811 62.4758 237.826 62.48 237.83 62.4758C237.817 62.4737 237.805 62.4508 237.796 62.4217C237.79 62.4342 237.79 62.4508 237.813 62.4779L237.811 62.4758ZM239.9 65.7082C239.9 65.7082 239.898 65.7082 239.896 65.7124C239.892 65.7165 239.917 65.6915 239.915 65.6957C239.915 65.6957 239.906 65.6999 239.9 65.7061V65.7082Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.501 60.8281C238.501 60.8281 238.509 60.8452 238.509 60.8516C238.52 60.8452 238.522 60.8388 238.501 60.8281Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.708 63.674V63.6783C240.708 63.6783 240.714 63.6783 240.717 63.6783L240.708 63.6719V63.674Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.566 61.1966C236.566 61.1966 236.566 61.1925 236.566 61.1904L236.451 60.8867L236.676 60.9242C236.701 60.9283 236.714 60.9346 236.724 60.9408C236.724 60.9304 236.714 60.9242 236.676 60.9242L236.389 60.9179L236.566 61.1925C236.566 61.1925 236.566 61.1946 236.568 61.1966H236.566Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.099 63.0298L238.065 62.9629C238.078 62.9964 238.074 63.011 238.074 63.0298C238.082 63.0256 238.091 63.0068 238.099 63.0298Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.055 63.7091C238.055 63.7091 238.063 63.7301 238.071 63.7384L238.088 63.7301C238.074 63.6882 238.048 63.661 238.055 63.7091Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.99 63.1377C237.959 63.1543 237.984 63.1939 238.007 63.2396C238.007 63.2375 238.005 63.2334 238.005 63.2313C238.055 63.2313 238.024 63.1835 237.99 63.1377Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.011 63.25C238.017 63.2646 238.023 63.2793 238.025 63.2939C238.046 63.2939 238.023 63.2751 238.011 63.25Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.893 62.5994C237.895 62.6267 237.939 62.5973 237.933 62.6162C237.985 62.6246 237.815 62.4818 237.893 62.5994Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.897 63.212L237.931 63.1807L237.889 63.166L237.897 63.212Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.799 62.8208L237.816 62.9019C237.816 62.9019 237.828 62.9061 237.836 62.9186C237.822 62.8707 237.811 62.8145 237.801 62.8208H237.799Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.834 62.9189C237.842 62.944 237.851 62.967 237.861 62.9796C237.857 62.967 237.847 62.9378 237.834 62.9189Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.848 63.1124L237.851 63.0853L237.836 63.0312L237.848 63.1124Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.47 62.0089C237.451 61.9816 237.428 61.9564 237.405 61.9375C237.388 61.9375 237.397 61.9627 237.422 61.9879C237.443 62.0005 237.464 62.0299 237.47 62.0089Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.451 62.308C237.451 62.2808 237.46 62.2745 237.468 62.2578L237.418 62.2725L237.454 62.3101L237.451 62.308Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.359 62.0749C237.343 62.0707 237.278 62.0268 237.319 62.0833C237.334 62.077 237.376 62.1418 237.359 62.0749Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.826 61.0615H236.803L236.805 61.1468L236.826 61.0615Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.932 61.6123C237.886 61.5104 237.874 61.6207 237.838 61.525C237.807 61.5167 237.868 61.604 237.838 61.5915C237.895 61.6331 237.903 61.6685 237.932 61.6123Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.837 61.5933C237.837 61.5933 237.818 61.5801 237.807 61.5713C237.822 61.5845 237.831 61.5889 237.837 61.5933Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.986 66.2575C238.986 66.2575 238.99 66.2513 239 66.2471C238.99 66.2471 238.975 66.2492 238.967 66.2513L238.986 66.2575Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.946 66.1702L239.003 66.1806L238.976 66.1221C238.971 66.1367 238.963 66.166 238.946 66.1702Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.044 61.4355L240.03 61.4397C240.027 61.4586 240.038 61.4753 240.059 61.5087L240.042 61.4376L240.044 61.4355Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.394 62.42L240.392 62.4033L240.348 62.4431L240.394 62.42Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.635 63.1249C240.629 63.0937 240.608 63.0625 240.6 63.0312C240.627 63.0937 240.577 63.1498 240.635 63.1249Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.096 67.2438C231.136 67.271 231.142 67.2334 231.151 67.2334C231.071 67.1937 231.094 67.2543 231.096 67.2438Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.911 66.9753L230.927 66.9836L230.888 66.9062L230.911 66.9753Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.904 66.4736C230.842 66.5194 230.913 66.6546 230.894 66.744L230.881 66.7586L230.932 66.7981C230.921 66.69 230.888 66.5485 230.906 66.4736H230.904Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.047 66.2204C231.022 66.2351 231.03 66.164 231.034 66.279C231.038 66.2748 231.038 66.2727 231.04 66.2685C231.04 66.2581 231.04 66.2434 231.045 66.2204H231.047Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.042 66.2683C231.042 66.3196 231.065 66.2363 231.042 66.2683V66.2683Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.05 66.0478L231.062 66.1065C231.077 66.0939 231.088 66.0499 231.096 66.0688C231.096 66.0142 231.079 66.0205 231.05 66.0478Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.019 65.9873V66.0187C231.019 66.0187 231.031 66.0082 231.019 65.9873Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.03 66.0814C231.026 66.0605 231.024 66.0375 231.021 66.0166C231.011 66.0229 230.99 66.0208 231.021 66.0459C231.005 66.0375 231.021 66.0542 231.028 66.0814H231.03Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.015 66.1182C230.998 66.1535 230.984 66.2014 230.971 66.1327C230.967 66.2617 231.011 66.245 231.015 66.1182Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.842 66.4463L230.823 66.4983L230.842 66.5441C230.832 66.5212 230.861 66.4443 230.842 66.4463Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.19 65.8122C231.184 65.8017 231.159 65.7955 231.144 65.7871C231.14 65.7976 231.138 65.808 231.136 65.8206C231.152 65.8122 231.178 65.7997 231.19 65.8122Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.144 65.7874C231.148 65.7706 231.154 65.756 231.163 65.7393C231.127 65.7644 231.133 65.7811 231.144 65.7874Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.956 65.9602C230.962 65.9998 230.971 66.0393 230.981 66.0767C230.971 66.031 230.964 65.9873 230.96 65.9395L230.956 65.9602Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.319 65.7501L231.305 65.7857C231.313 65.7689 231.324 65.748 231.338 65.7334C231.332 65.7397 231.326 65.7439 231.319 65.7522V65.7501Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.54 65.7104C231.49 65.7561 231.634 65.7187 231.578 65.7582C231.601 65.7478 231.622 65.7353 231.64 65.7229C231.651 65.7062 231.661 65.7457 231.611 65.623L231.576 65.1113C231.576 65.1113 231.544 65.1238 231.494 65.1259C231.544 65.128 231.569 65.1321 231.571 65.1342L231.611 65.6209C231.62 65.6417 231.628 65.6625 231.638 65.6854C231.638 65.6854 231.638 65.6854 231.636 65.6854C231.634 65.6854 231.632 65.6854 231.617 65.6917C231.594 65.7 231.569 65.7083 231.542 65.7125L231.54 65.7104Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.373 65.1533C231.373 65.1533 231.384 65.1491 231.388 65.147C231.419 65.1386 231.455 65.1302 231.493 65.126C231.457 65.126 231.421 65.1302 231.388 65.1428L231.373 65.1512V65.1533Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.233 65.7045C231.233 65.7045 231.254 65.7275 231.281 65.7254L231.252 65.6982C231.252 65.6982 231.24 65.7024 231.233 65.7045Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.25 65.698C231.269 65.6917 231.286 65.6896 231.292 65.6875C231.288 65.6875 231.271 65.6875 231.25 65.698Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.229 65.7074H231.237C231.237 65.7074 231.229 65.7 231.229 65.7074Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.047 65.8183C231.045 65.7809 231.076 65.706 231.005 65.7476C231.011 65.7829 231.049 65.7601 231.047 65.8183Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.186 65.6768C231.167 65.683 231.151 65.6914 231.134 65.7019C231.14 65.7081 231.157 65.7144 231.151 65.7311C231.159 65.7123 231.171 65.6956 231.186 65.6789V65.6768Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.207 65.6543L231.186 65.6778L231.207 65.6714V65.6543Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.61 65.625L231.56 65.2027C231.552 65.2194 231.477 65.1986 231.408 65.2027C231.469 65.2048 231.548 65.2297 231.556 65.2318L232.235 65.3254L231.6 65.5958L231.589 65.6C231.589 65.6 231.587 65.6166 231.589 65.6229C231.594 65.6291 231.608 65.625 231.61 65.6229V65.625Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.375 65.677H231.382C231.382 65.677 231.375 65.6699 231.375 65.677Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.405 65.4379L231.398 65.4355L231.403 65.4403L231.405 65.4379Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.58 65.5979C231.527 65.6168 231.5 65.6357 231.471 65.6546C231.511 65.6441 231.557 65.6189 231.591 65.6C231.591 65.5958 231.591 65.5895 231.58 65.5979Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.242 65.1866C231.263 65.1908 231.286 65.195 231.309 65.1971C231.288 65.1887 231.248 65.1761 231.242 65.1866Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.398 65.6836H231.39C231.409 65.6924 231.407 65.688 231.398 65.6836Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.398 65.6837H231.404C231.431 65.6753 231.453 65.6648 231.471 65.6543C231.446 65.6606 231.423 65.6648 231.402 65.669C231.394 65.669 231.383 65.6732 231.379 65.6753C231.383 65.6774 231.392 65.6816 231.396 65.6837H231.398Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.366 65.1902C231.366 65.2235 231.307 65.2838 231.23 65.3233C231.201 65.4065 231.33 65.4128 231.397 65.4336C231.389 65.4232 231.376 65.4107 231.403 65.3691C231.382 65.3525 231.282 65.4232 231.297 65.3649C231.349 65.288 231.359 65.3254 231.399 65.3213C231.376 65.3109 231.389 65.2838 231.414 65.2568C231.439 65.2318 231.476 65.2069 231.46 65.1777C231.428 65.1881 231.397 65.2048 231.37 65.2235C231.364 65.2152 231.393 65.1881 231.364 65.1902H231.366Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.336 65.5147L231.332 65.5272L231.134 65.2463L231.15 65.2422H231.134L231.338 65.5292C231.357 65.5147 231.375 65.5001 231.409 65.496C231.413 65.4585 231.409 65.4523 231.402 65.4398C231.382 65.4564 231.359 65.4897 231.338 65.523V65.5126L231.336 65.5147Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.307 65.219C231.282 65.2586 231.201 65.2856 231.257 65.3189C231.359 65.3022 231.321 65.2794 231.388 65.2544C231.219 65.2856 231.432 65.2274 231.309 65.2232C231.338 65.2149 231.363 65.2086 231.392 65.2024C231.399 65.2024 231.405 65.2024 231.409 65.2024C231.403 65.2024 231.396 65.2024 231.392 65.2024C231.359 65.2024 231.336 65.2024 231.311 65.1982H231.315C231.315 65.1982 231.326 65.2045 231.315 65.2024H231.311C231.311 65.2024 231.307 65.2128 231.305 65.219C231.255 65.219 231.296 65.2107 231.311 65.2045C231.311 65.2045 231.311 65.2003 231.311 65.1982L231.146 65.2398C231.182 65.2398 231.226 65.2336 231.305 65.219H231.307Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.994 65.64C230.994 65.64 231.003 65.64 231.005 65.6422C231.009 65.6312 231.009 65.6268 230.994 65.64Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.055 65.6123C231.051 65.6248 231.051 65.6373 231.026 65.6601C230.997 65.6747 231.013 65.6477 231.003 65.6414C230.992 65.6643 230.974 65.7121 231.03 65.6768L231.034 65.6664C231.084 65.631 231.166 65.6373 231.16 65.6477C231.13 65.6289 231.105 65.6123 231.055 65.6123Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.388 65.5712H231.394C231.45 65.567 231.505 65.5379 231.544 65.5088C231.517 65.5088 231.486 65.515 231.459 65.5129L231.467 65.5296C231.404 65.54 231.394 65.5421 231.392 65.5566C231.392 65.5608 231.392 65.567 231.388 65.5712Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.423 65.4461L231.444 65.4796C231.438 65.4587 231.433 65.4399 231.431 65.4189C231.427 65.4252 231.425 65.4378 231.421 65.4461H231.423Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.476 65.415L231.482 65.4485C231.482 65.4485 231.488 65.4339 231.494 65.4255L231.476 65.415Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.291 68.6846L235.329 68.7118C235.312 68.6971 235.301 68.6888 235.291 68.6846Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.087 68.4854L235.07 68.4918C235.085 68.4918 235.094 68.4918 235.087 68.4854Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.471 66.3369C233.554 66.3806 233.682 66.4014 233.663 66.3681L233.627 66.3369C233.563 66.3556 233.51 66.3494 233.471 66.3369Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.316 68.3151V68.2942C235.301 68.2879 235.284 68.2817 235.27 68.2754C235.284 68.2879 235.299 68.3005 235.316 68.3151Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.468 68.2812L235.48 68.3524C235.48 68.3356 235.476 68.3126 235.468 68.2812Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.126 68.9993C235.155 69.0077 235.185 69.0182 235.212 69.0308C235.128 68.9468 235.147 68.9972 235.126 68.9993Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.754 65.1698C231.798 65.1593 231.832 65.1551 231.857 65.1425C231.805 65.1425 231.75 65.1341 231.754 65.1698Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.937 68.882C234.957 68.8925 234.97 68.8925 234.974 68.8862C234.953 68.8758 234.939 68.8716 234.937 68.882Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.964 65.1046C231.964 65.1046 231.949 65.1046 231.943 65.1025C231.917 65.1151 231.892 65.134 231.858 65.1424C231.898 65.1424 231.936 65.1382 231.966 65.1046H231.964Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.35 68.7977C232.35 68.7977 232.348 68.7888 232.348 68.7822C232.344 68.7822 232.346 68.7888 232.35 68.7977Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.511 67.3887C231.528 67.3929 231.553 67.4055 231.578 67.416C231.568 67.4076 231.546 67.3992 231.511 67.3887Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.042 65.5399C232.004 65.5314 232.036 65.5399 232.042 65.5399V65.5399Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.921 65.3509C231.921 65.3509 231.936 65.3445 231.94 65.3359C231.936 65.3445 231.929 65.3488 231.921 65.3509Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.265 64.8727H232.267C232.267 64.8727 232.257 64.8647 232.265 64.8727Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.994 65.5068C232.005 65.5152 232.019 65.5236 232.036 65.5319C232.03 65.5277 232.017 65.5194 231.994 65.5068Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.996 65.5252C231.985 65.5211 231.975 65.5169 231.967 65.5127C231.96 65.5169 231.962 65.5211 231.996 65.5252Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.102 65.5565C232.067 65.546 232.056 65.5418 232.035 65.5312C232.041 65.5355 232.044 65.5397 232.041 65.5397C232.054 65.5439 232.073 65.5481 232.102 65.5565Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.635 70.0449V70.0493C234.652 70.0758 234.648 70.0648 234.635 70.0449Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.348 66.617L234.341 66.6133L234.345 66.6207L234.348 66.617Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.44 66.7149C234.371 66.69 234.358 66.6588 234.341 66.6172L234.274 66.7108L234.437 66.7149H234.44Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.99 69.2152C234.97 69.2547 234.974 69.2402 234.974 69.2527C234.974 69.2547 234.974 69.2568 234.974 69.261L234.993 69.288L235.013 69.3171C235.003 69.3109 234.992 69.3067 234.984 69.3005C234.974 69.2943 234.965 69.288 234.955 69.2839C234.951 69.2839 234.951 69.2859 234.949 69.288H234.947V69.2901L234.963 69.2651V69.2631C234.972 69.2527 234.978 69.2402 234.984 69.2298C235.007 69.184 235.005 69.1757 235.003 69.1861V69.1903C234.995 69.236 234.988 69.2818 234.98 69.3255C234.98 69.3255 234.978 69.3317 234.98 69.3338C234.988 69.2901 234.995 69.2402 235.003 69.1882V69.184L235.005 69.1778C235.005 69.1819 235.003 69.1882 234.999 69.1944C234.999 69.1986 234.995 69.2007 234.995 69.2027C234.99 69.2131 234.982 69.2298 234.972 69.2464L234.963 69.2589V69.2631H234.961L234.938 69.2984L234.943 69.2943C234.945 69.2943 234.943 69.2901 234.949 69.2943L234.974 69.313C235.022 69.3504 235.074 69.392 235.142 69.4045C235.176 69.4108 235.209 69.4128 235.24 69.4108L235.288 69.4066C235.305 69.4045 235.319 69.4024 235.315 69.4003L234.838 69.2693L235.561 69.0925C235.574 69.0904 235.576 69.0883 235.574 69.0883C235.574 69.0883 235.569 69.0863 235.569 69.0842C235.565 69.0821 235.561 69.0717 235.555 69.0613C235.544 69.0426 235.53 69.0343 235.515 69.0343C235.515 69.001 235.515 68.9656 235.509 68.9303C235.519 68.9573 235.528 68.9594 235.534 68.9885C235.532 68.8824 235.474 68.8575 235.434 68.8429C235.397 68.8346 235.353 68.8263 235.305 68.7555C235.274 68.7056 235.253 68.6619 235.292 68.6827C235.253 68.6557 235.213 68.6307 235.176 68.6079C235.151 68.5829 235.17 68.5725 235.197 68.5995C235.145 68.5558 235.105 68.5267 235.07 68.4914H235.074C235.047 68.4872 234.99 68.4664 234.965 68.4518C234.953 68.4082 234.988 68.4602 234.993 68.4435C234.965 68.4269 234.94 68.4061 234.915 68.3874C234.918 68.3395 234.986 68.3874 235.02 68.4352C235.038 68.3686 235.024 68.3582 234.995 68.3416C234.98 68.3333 234.963 68.3208 234.947 68.3021C234.88 68.3478 235.095 68.2022 234.799 68.4019H234.801L234.807 68.3978C234.811 68.3978 234.824 68.3957 234.834 68.3978C234.863 68.3978 234.901 68.4061 234.97 68.4269C234.984 68.431 234.986 68.4165 235.007 68.3957C235.003 68.4123 234.999 68.4248 234.999 68.4331V68.4373L234.976 68.431L234.938 68.4186C234.886 68.404 234.855 68.3998 234.83 68.3998C234.861 68.3998 234.911 68.4102 234.999 68.4373C235.011 68.4414 235.022 68.4456 235.034 68.4498H235.038C235.04 68.4498 235.045 68.4456 235.049 68.4435C235.063 68.429 235.078 68.4102 235.105 68.3458L234.734 68.5392C234.747 68.5434 234.761 68.5496 234.776 68.5559C234.782 68.5579 234.782 68.56 234.782 68.5621C234.782 68.5663 234.782 68.5704 234.78 68.5767C234.78 68.5725 234.784 68.5642 234.786 68.5538C234.786 68.5496 234.79 68.5434 234.786 68.5371C234.786 68.5309 234.759 68.5184 234.747 68.508L235.078 68.3354C235.051 68.3749 235.028 68.3853 235.013 68.3853C234.999 68.3853 234.99 68.377 234.999 68.3312C235.001 68.325 235.005 68.3187 235.007 68.3125L234.768 68.4373C234.78 68.4435 234.793 68.4477 234.803 68.4518C234.809 68.4539 234.813 68.4539 234.818 68.4539C234.826 68.4539 234.836 68.4498 234.853 68.4456C234.836 68.4789 234.853 68.481 234.865 68.4997L234.872 68.5059L234.83 68.5392C234.83 68.5392 234.847 68.5454 234.859 68.5538C234.87 68.56 234.88 68.5642 234.89 68.5663C234.909 68.5704 234.926 68.5725 234.951 68.585C235.007 68.664 234.992 68.7056 234.982 68.7472C235.084 68.8637 234.957 68.6266 235.09 68.7472C235.155 68.8408 235.209 68.8679 235.313 68.9573C235.342 69.0301 235.278 68.9656 235.282 68.9968L235.319 69.0114C235.319 69.0114 235.319 69.0072 235.328 69.0176C235.34 69.0322 235.355 69.0467 235.372 69.0571C235.397 69.0738 235.413 69.0779 235.43 69.0821C235.455 69.0863 235.474 69.0863 235.488 69.0821C235.526 69.0863 235.513 69.0987 235.505 69.105C235.563 69.0987 235.559 69.0821 235.567 69.0675C235.576 69.0509 235.586 69.0426 235.653 69.0135C235.659 68.9927 235.678 68.9947 235.73 68.949C235.759 68.9219 235.786 68.8928 235.811 68.8554C235.834 68.8159 235.861 68.7784 235.855 68.6931C235.853 68.6723 235.844 68.6411 235.824 68.6079C235.815 68.5975 235.811 68.5912 235.805 68.585C235.792 68.5704 235.774 68.5579 235.755 68.5475C235.738 68.5059 235.792 68.5413 235.801 68.5163C235.776 68.4976 235.753 68.4789 235.717 68.4581C235.686 68.4394 235.634 68.4248 235.594 68.4248C235.557 68.4248 235.536 68.4331 235.538 68.4352L235.54 68.4851V68.4914C235.54 68.4997 235.54 68.5059 235.54 68.5122C235.54 68.533 235.54 68.5247 235.54 68.5267C235.54 68.533 235.544 68.508 235.553 68.4997C235.559 68.4872 235.565 68.4768 235.574 68.4664C235.578 68.4622 235.574 68.4685 235.571 68.4664C235.563 68.4685 235.544 68.4664 235.515 68.4518C235.505 68.4206 235.499 68.3853 235.492 68.3499C235.497 68.4352 235.405 68.3811 235.328 68.3125C235.324 68.3478 235.319 68.377 235.322 68.3978L235.228 68.2792C235.228 68.2605 235.251 68.2646 235.282 68.275C235.274 68.2688 235.265 68.2626 235.259 68.2563C235.253 68.2002 235.292 68.2106 235.338 68.2314C235.338 68.2522 235.334 68.273 235.332 68.2938C235.378 68.3125 235.426 68.325 235.451 68.3021C235.44 68.2979 235.428 68.2834 235.417 68.2667C235.43 68.2709 235.44 68.273 235.442 68.2667C235.444 68.2605 235.428 68.2522 235.405 68.2355L235.444 68.1773L235.419 68.1814C235.403 68.119 235.376 68.0421 235.347 67.9797C235.213 67.8986 235.067 67.8507 234.92 67.6885C234.988 67.7072 234.984 67.6552 235.03 67.6261C235.02 67.7072 235.151 67.753 235.209 67.8528C235.178 67.8008 235.207 67.7966 235.224 67.805L235.061 67.6656C235.099 67.6448 235.061 67.6115 235.045 67.5574C235.001 67.6406 234.909 67.4701 234.838 67.4201C234.859 67.3993 234.895 67.3973 234.949 67.4825C234.934 67.3557 234.782 67.4264 234.761 67.3078C234.776 67.3265 234.78 67.3411 234.799 67.339C234.745 67.3078 234.678 67.183 234.718 67.1955L234.732 67.2142C234.688 67.1456 234.613 67.0457 234.543 66.9667C234.478 66.8897 234.413 66.8253 234.378 66.8336C234.384 66.8273 234.463 66.8065 234.48 66.8065C234.361 66.7691 234.241 66.7233 234.12 66.6901C234.186 66.6776 234.251 66.5091 234.359 66.6089C234.345 66.5694 234.326 66.5195 234.253 66.4612C234.264 66.4904 234.222 66.5715 234.195 66.5445C234.186 66.4197 234.18 66.4612 234.132 66.324C234.153 66.3656 234.049 66.3968 234.007 66.351C234.024 66.3468 234.07 66.2782 234.095 66.2865C234.032 66.2699 233.972 66.2595 233.914 66.247C233.953 66.2616 233.974 66.1929 233.966 66.1492C233.966 66.1638 233.934 66.1326 233.905 66.1014C233.895 66.091 233.868 66.0536 233.849 66.039C233.862 66.064 233.87 66.0868 233.876 66.1035C233.855 66.0744 233.826 66.0473 233.782 66.0224C233.76 66.014 233.73 65.987 233.653 65.9974C233.63 66.0016 233.635 66.0036 233.632 66.0057L233.628 66.014L233.618 66.0286C233.593 66.0681 233.545 66.118 233.464 66.091C233.495 66.0785 233.535 65.9828 233.499 65.9537C233.48 65.9683 233.433 66.0036 233.364 66.0016C233.33 66.0016 233.293 65.9912 233.255 65.9704C233.218 65.9496 233.187 65.9329 233.153 65.8913C233.143 65.8768 233.131 65.8622 233.122 65.8456C233.128 65.831 233.135 65.8164 233.143 65.8019C233.137 65.7769 233.135 65.752 233.133 65.7249C233.139 65.7104 233.103 65.7166 233.168 65.7104C233.187 65.7083 233.199 65.7041 233.206 65.702L233.212 65.6979L233.143 65.7644L233.139 65.7624H233.143L233.21 65.6979L233.201 65.7041C233.195 65.7062 233.174 65.7124 233.147 65.7145C233.16 65.7104 233.17 65.7332 233.183 65.754C233.203 65.7915 233.237 65.8289 233.283 65.8497C233.32 65.8684 233.362 65.8934 233.395 65.9059C233.426 65.9163 233.453 65.9163 233.472 65.9163C233.468 65.8726 233.493 65.8913 233.466 65.8497C233.472 65.8331 233.485 65.8372 233.497 65.8456C233.505 65.8476 233.514 65.8518 233.516 65.856C233.512 65.8456 233.516 65.8456 233.505 65.8268L233.493 65.7956C233.489 65.7832 233.491 65.7852 233.489 65.7811C233.489 65.7769 233.489 65.7728 233.489 65.7665C233.46 65.7665 233.445 65.7728 233.435 65.7312C233.43 65.7083 233.433 65.6729 233.403 65.6147C233.349 65.5336 233.351 65.5585 233.341 65.5481C233.322 65.5398 233.31 65.5398 233.303 65.5481L233.33 65.5647C233.33 65.5647 233.337 65.5689 233.345 65.5752C233.368 65.598 233.383 65.623 233.391 65.6459C233.416 65.727 233.405 65.7499 233.412 65.752C233.418 65.7686 233.428 65.7852 233.445 65.7936L233.455 65.7998C233.441 65.806 233.424 65.8123 233.401 65.8081C233.37 65.806 233.33 65.7873 233.32 65.7478C233.316 65.7395 233.314 65.7291 233.31 65.7041C233.305 65.6916 233.303 65.6792 233.293 65.6604C233.289 65.6542 233.278 65.6417 233.274 65.6376L233.266 65.6313C233.241 65.6147 233.218 65.5939 233.197 65.571C233.181 65.5252 233.291 65.519 233.301 65.5044C233.27 65.5003 233.158 65.4233 233.156 65.4025L233.228 65.4275C233.174 65.3484 233.064 65.3838 233.026 65.2735C233.001 65.2465 233.008 65.1508 232.981 65.1695C232.968 65.2507 232.837 65.4046 232.77 65.4067C232.766 65.4004 232.741 65.3505 232.72 65.2943C232.702 65.2423 232.685 65.1841 232.683 65.1591C232.679 65.0759 232.837 65.1508 232.835 65.0822C232.822 65.0905 232.783 65.0739 232.768 65.0676C232.747 65.0281 232.816 65.0468 232.745 64.9844C232.695 65.0135 232.604 64.8513 232.679 64.9886C232.599 64.9407 232.614 64.9137 232.516 64.8555C232.524 64.9033 232.37 64.9158 232.293 64.9158C232.302 64.9033 232.289 64.8804 232.283 64.87C232.116 64.8284 232.01 64.8222 231.852 64.87C231.833 64.8617 231.75 64.8763 231.773 64.8409C231.752 64.8596 231.741 64.8867 231.696 64.9116C231.581 64.9116 231.798 64.8534 231.702 64.8326C231.708 64.8596 231.633 64.9116 231.579 64.9615L231.379 65.1508L231.614 65.0967C231.629 65.0926 231.641 65.0905 231.656 65.0884C231.65 65.0739 231.635 65.0676 231.616 65.0635L231.481 65.0427L231.598 64.9907C231.648 64.9699 231.714 64.9033 231.76 64.8679C231.783 64.9199 231.735 65.0031 231.66 65.0926L231.621 64.9449C231.65 64.9345 231.683 64.9283 231.718 64.922C231.85 64.9075 231.775 64.9699 231.798 64.9595C231.92 64.9657 231.979 64.9345 232.041 64.9158C232.073 64.9075 232.104 64.8991 232.148 64.9075C232.189 64.9158 232.247 64.9387 232.302 65.0073C232.329 65.0718 232.308 65.0843 232.285 65.0905C232.262 65.0967 232.237 65.0967 232.231 65.1155C232.143 65.0447 232.087 64.9969 232.006 64.9865C232.037 64.9969 232.068 65.0094 232.098 65.026C232.058 65.0281 231.985 65.0323 231.945 65.0177C231.975 65.0385 232.06 65.0385 232.145 65.0843C232.227 65.13 232.287 65.2507 232.26 65.3422L232.283 65.3193C232.252 65.3193 232.225 65.3172 232.204 65.3027C232.172 65.3089 232.106 65.3047 232.129 65.3318L232.189 65.3443C232.189 65.3443 232.193 65.3505 232.193 65.3526C232.202 65.363 232.197 65.3671 232.189 65.3713C232.158 65.3838 232.081 65.3713 232.133 65.3983C232.043 65.3983 231.95 65.4046 231.858 65.3692L231.843 65.3131C231.848 65.3297 231.91 65.3547 231.941 65.3484C231.9 65.3609 231.783 65.2486 231.718 65.3006L231.791 65.3526C231.7 65.3609 231.593 65.39 231.533 65.3755C231.56 65.4275 231.55 65.3692 231.593 65.4337C231.575 65.3942 231.623 65.4004 231.679 65.4129C231.735 65.4254 231.796 65.4379 231.75 65.3879C231.779 65.4295 231.818 65.4441 231.852 65.4566C231.875 65.467 231.904 65.4774 231.935 65.5169C231.939 65.5003 231.914 65.4753 231.987 65.5065C231.991 65.5023 232.002 65.5003 232.008 65.4982C232.01 65.4982 232.01 65.4982 232.012 65.5003L232.008 65.4961C231.991 65.4836 231.979 65.4691 231.977 65.4587C232.016 65.44 232.081 65.4566 232.166 65.4691C232.197 65.4753 232.225 65.4732 232.241 65.467C232.312 65.4732 232.21 65.4878 232.25 65.5044C232.26 65.5003 232.285 65.494 232.281 65.4919L232.435 65.338C232.435 65.338 232.424 65.3214 232.418 65.3006C232.47 65.2923 232.429 65.0302 232.504 65.2715C232.504 65.2611 232.504 65.2486 232.499 65.234C232.497 65.2174 232.493 65.2049 232.493 65.2007L232.483 65.1612C232.477 65.1363 232.464 65.1071 232.452 65.0801C232.437 65.0281 232.402 64.9595 232.345 64.9095C232.291 64.8575 232.225 64.8305 232.179 64.8243C232.093 64.7868 231.985 64.8326 232.05 64.8076C231.97 64.8076 231.908 64.8159 231.85 64.8222V64.8118C231.779 64.8118 231.706 64.8201 231.625 64.8263L231.718 65.1799C231.787 65.1279 231.87 65.0822 231.962 65.0926C232 65.0718 232.043 65.0468 232.112 65.0531C232.116 65.0635 232.12 65.0739 232.125 65.0863C232.177 65.0718 232.25 65.1342 232.279 65.1134C232.287 65.1612 232.329 65.1883 232.383 65.2257C232.437 65.2611 232.504 65.311 232.531 65.3567L232.566 65.3318C232.579 65.3484 232.587 65.3588 232.604 65.3775C232.62 65.3983 232.639 65.4171 232.66 65.4358C232.699 65.4732 232.743 65.5065 232.791 65.5398L232.812 65.5065C232.906 65.5523 232.983 65.6916 233.081 65.7832C233.064 65.7873 233.043 65.7603 233.031 65.7374C233.039 65.7603 233.049 65.7811 233.062 65.7977L233.07 65.8102L233.074 65.8164H233.076V65.8206C233.347 65.5606 233.151 65.7478 233.212 65.6896C233.212 65.6896 233.183 65.7062 233.101 65.7062H233.026C233.026 65.7062 233.026 65.7104 233.026 65.7145V65.7436C233.026 65.7644 233.026 65.7832 233.028 65.8019C233.033 65.8414 233.053 65.8768 233.072 65.91C233.114 65.9787 233.128 65.9953 233.168 66.0556C233.203 66.1076 233.237 66.1555 233.272 66.2054C233.328 66.2345 233.364 66.2574 233.401 66.2803C233.395 66.2803 233.391 66.2782 233.387 66.2782C233.393 66.2803 233.401 66.2844 233.412 66.2865C233.435 66.3011 233.462 66.3136 233.493 66.324C233.466 66.3094 233.441 66.2969 233.424 66.2886C233.47 66.3011 233.545 66.3052 233.616 66.2865C233.626 66.299 233.639 66.3115 233.649 66.3219C233.655 66.3219 233.66 66.3198 233.666 66.3177C233.685 66.3177 233.697 66.3177 233.705 66.3115C233.703 66.3115 233.672 66.3156 233.666 66.3115C233.66 66.3115 233.655 66.3094 233.653 66.3073L233.664 66.118L233.653 66.2969L233.657 66.2948C233.666 66.2907 233.676 66.2865 233.687 66.2824C233.707 66.274 233.687 66.274 233.687 66.2699L233.672 66.2616L233.685 66.2553H233.691C233.691 66.2553 233.674 66.2553 233.668 66.2553H233.655L233.664 66.118V66.1222V66.1284C233.664 66.1284 233.657 66.143 233.653 66.1472C233.645 66.1721 233.582 66.2428 233.603 66.22C233.576 66.2574 233.626 66.2678 233.67 66.324C233.682 66.3385 233.689 66.3552 233.685 66.378C233.735 66.378 233.872 66.5153 233.937 66.48C233.93 66.4883 233.937 66.5008 233.92 66.4841C233.949 66.5237 233.974 66.5632 234.016 66.5819L233.987 66.6297C234.026 66.6422 234.066 66.6568 234.103 66.6734C234.114 66.7462 234.112 66.7774 234.043 66.7462C234.178 66.844 234.13 66.8419 234.255 66.9272L234.224 66.9397C234.251 66.9813 234.332 67.027 234.328 67.0665C234.343 67.1955 234.649 67.5137 234.77 67.78C234.818 67.6781 234.809 67.911 234.878 67.8757C234.868 67.9027 234.88 67.9422 234.836 67.9173C234.938 68.0192 234.93 68.1107 235.04 68.1544C235.03 68.1794 234.995 68.1482 234.99 68.1669C235.001 68.1731 235.034 68.1918 235.03 68.2106C235.026 68.2293 235.003 68.2043 234.98 68.1918C235.057 68.2938 235.117 68.275 235.186 68.2542C235.19 68.3333 235.211 68.3666 235.278 68.3957C235.272 68.429 235.274 68.483 235.22 68.3998C235.23 68.4248 235.261 68.5039 235.313 68.5767C235.338 68.612 235.369 68.6474 235.411 68.6744C235.453 68.7056 235.522 68.7098 235.524 68.6931C235.532 68.6973 235.553 68.6994 235.565 68.6994H235.58H235.582V68.6661C235.582 68.6661 235.582 68.6474 235.582 68.6453C235.582 68.6453 235.582 68.6453 235.578 68.6557C235.576 68.6619 235.571 68.6661 235.569 68.6703C235.565 68.6765 235.563 68.6827 235.561 68.6869C235.561 68.6869 235.576 68.7035 235.584 68.7139C235.588 68.7202 235.592 68.7264 235.596 68.7327L235.603 68.741V68.7451H235.607L235.671 68.7015C235.657 68.7181 235.578 68.7181 235.601 68.7223C235.601 68.7285 235.601 68.7431 235.594 68.7597L235.609 68.7431C235.638 68.7639 235.634 68.7867 235.621 68.8034C235.617 68.8075 235.615 68.8096 235.611 68.8138H235.609L235.64 68.8408L235.636 68.8387C235.628 68.8325 235.621 68.82 235.611 68.8075C235.611 68.8075 235.594 68.8096 235.58 68.8138V68.8075C235.561 68.8055 235.544 68.8013 235.538 68.7992C235.538 68.7639 235.522 68.8824 235.505 68.8803L235.582 68.8263L235.58 68.8221L235.576 68.8159L235.567 68.8075C235.567 68.8075 235.559 68.7992 235.555 68.7951C235.536 68.7784 235.524 68.7639 235.476 68.6599L235.451 68.6952C235.411 68.7139 235.39 68.6703 235.363 68.612C235.334 68.5517 235.301 68.4851 235.253 68.456L235.263 68.5018C235.23 68.4893 235.222 68.4373 235.224 68.3811C235.222 68.3229 235.236 68.2771 235.211 68.2314C235.203 68.2085 235.245 68.2584 235.255 68.2626C235.251 68.2397 235.22 68.1898 235.211 68.1752C235.149 68.1086 235.186 68.2397 235.07 68.1461C235.051 68.1066 235.157 68.1024 235.026 68.0421C235.015 68.0358 234.997 68.0296 234.972 68.0275C234.959 68.0275 234.947 68.0275 234.932 68.0234C234.924 68.0234 234.922 68.0234 234.922 68.0234C234.922 68.0254 234.922 68.0171 234.915 68.0421L234.851 68.2355L234.661 68.1794C234.628 68.169 234.643 68.1752 234.641 68.1731C234.641 68.1731 234.641 68.1731 234.641 68.1752C234.641 68.1773 234.641 68.1814 234.641 68.1856C234.641 68.1939 234.641 68.2043 234.636 68.2189C234.632 68.2501 234.622 68.2709 234.613 68.3562C234.613 68.379 234.613 68.4144 234.632 68.4623C234.638 68.4747 234.645 68.4872 234.651 68.4976L234.655 68.5018L234.661 68.5101C234.67 68.5205 234.678 68.5309 234.684 68.5413C234.697 68.5621 234.709 68.585 234.715 68.6079C234.715 68.5704 234.715 68.5371 234.77 68.5787C234.826 68.6515 234.905 68.8512 235.005 68.845C235.009 68.8575 235.007 68.8637 235.005 68.8679C235.063 68.8928 235.161 68.9968 235.215 69.0093C235.197 69.0343 235.195 69.053 235.199 69.0717C235.199 69.0821 235.201 69.0925 235.205 69.1029C235.211 69.1216 235.217 69.1424 235.224 69.1632L235.369 68.9885C235.326 68.9927 235.311 69.0114 235.28 69.0114C235.255 69.0072 235.242 68.9864 235.238 68.9719C235.236 68.9615 235.238 68.9469 235.249 68.9303C235.228 68.9136 235.203 68.8991 235.172 68.8845C235.145 68.872 235.092 68.8595 235.076 68.8595C235.049 68.8595 235.034 68.8595 235.015 68.8512L235.024 68.8408C234.995 68.82 234.984 68.8075 234.953 68.7951C234.913 68.7743 234.88 68.768 234.849 68.7618C234.826 68.7327 234.855 68.7389 234.861 68.7368C234.851 68.7264 234.84 68.716 234.832 68.7077L234.703 68.5725L234.597 68.7909C234.591 68.8055 234.568 68.8367 234.557 68.9053C234.557 68.924 234.553 68.949 234.566 68.9927C234.566 69.0072 234.597 69.0488 234.593 69.0426L234.599 69.0509C234.609 69.0613 234.618 69.0717 234.628 69.0821C234.649 69.1008 234.672 69.1195 234.705 69.1383C234.72 69.1466 234.745 69.1591 234.759 69.1632C234.776 69.1674 234.788 69.1674 234.807 69.1674C234.801 69.1799 234.795 69.1903 234.786 69.2027C234.82 69.1923 234.851 69.2527 234.865 69.3067C234.87 69.3234 234.876 69.3379 234.886 69.3525C234.886 69.3567 234.895 69.3608 234.893 69.3629L234.884 69.3671C234.884 69.3671 234.876 69.3733 234.874 69.3775C234.868 69.3775 234.859 69.3733 234.857 69.3691C234.857 69.3691 234.855 69.3733 234.851 69.3754C234.845 69.3795 234.83 69.3858 234.815 69.3816C234.801 69.3754 234.786 69.3691 234.768 69.442C234.747 69.5376 234.745 69.6 234.732 69.6146C234.747 69.6146 234.82 69.6354 234.834 69.6354C234.857 69.6396 234.884 69.6583 234.888 69.6583C234.901 69.6708 234.893 69.6645 234.897 69.6624C234.897 69.652 234.899 69.6292 234.909 69.6208C234.859 69.7248 234.978 69.4773 234.965 69.5043H234.961L234.955 69.5002L234.94 69.494L234.913 69.4835C234.897 69.4773 234.882 69.4752 234.868 69.4731C234.811 69.4669 234.776 69.4794 234.751 69.5106H234.705L234.416 69.5314L234.555 69.6708C234.568 69.6832 234.58 69.7165 234.599 69.756C234.572 69.5626 234.668 69.7644 234.678 69.6832C234.691 69.7186 234.684 69.7685 234.701 69.806C234.707 69.8247 234.724 69.8413 234.72 69.8455C234.72 69.8517 234.684 69.8434 234.663 69.8122C234.663 69.8039 234.659 69.7956 234.659 69.7893C234.636 69.7872 234.628 69.8039 234.647 69.8434C234.653 69.8538 234.659 69.8642 234.676 69.8767C234.684 69.8829 234.691 69.8892 234.705 69.8954C234.732 69.9079 234.78 69.9016 234.803 69.8871C234.824 69.8767 234.851 69.8392 234.851 69.8309C234.855 69.8205 234.857 69.8122 234.861 69.8018C234.865 69.7852 234.865 69.7748 234.868 69.7644C234.872 69.6832 234.868 69.6333 234.897 69.6333C234.897 69.6271 234.897 69.6146 234.897 69.6146C234.897 69.6146 234.857 69.6042 234.853 69.6042C234.832 69.6042 234.797 69.5813 234.793 69.5834C234.788 69.5834 234.782 69.573 234.782 69.573C234.782 69.5751 234.782 69.5792 234.782 69.5792C234.782 69.5896 234.772 69.6167 234.757 69.6271C234.788 69.5855 234.713 69.6853 234.722 69.6749H234.724L234.73 69.6832L234.743 69.6936L234.84 69.7789L234.886 69.5355C234.843 69.548 234.807 69.5626 234.778 69.573C234.763 69.5792 234.749 69.5834 234.736 69.5855C234.736 69.5959 234.701 69.5543 234.688 69.5564L234.638 69.5439C234.568 69.5293 234.511 69.5293 234.478 69.5314C234.445 69.5314 234.422 69.5314 234.399 69.5272C234.378 69.5272 234.353 69.5106 234.33 69.5314C234.318 69.5605 234.311 69.5876 234.305 69.6208C234.293 69.6874 234.299 69.781 234.328 69.885C234.347 69.8704 234.364 69.86 234.384 69.8496L234.422 70.014C234.416 70.0576 234.389 70.0784 234.357 69.9453C234.353 69.9599 234.357 69.9828 234.364 70.0077C234.368 70.0181 234.372 70.0306 234.376 70.0452C234.38 70.0556 234.386 70.0784 234.391 70.066H234.48H234.484H234.503L234.532 70.0701C234.541 70.0722 234.545 70.0764 234.547 70.0764L234.48 69.9391L234.463 69.9495C234.453 69.9578 234.443 69.9661 234.438 69.9703C234.397 70.0223 234.405 70.0368 234.401 70.0535C234.401 70.0826 234.405 70.0951 234.409 70.0972C234.405 70.118 234.403 70.1367 234.403 70.1596C234.407 70.1928 234.405 70.1845 234.407 70.1949C234.407 70.2053 234.407 70.2116 234.403 70.2157C234.397 70.2199 234.384 70.2095 234.37 70.1949C234.349 70.1429 234.349 70.0951 234.351 70.0639C234.355 70.0285 234.361 70.0056 234.345 70.0493C234.336 70.0847 234.334 70.1096 234.336 70.1471C234.336 70.1596 234.345 70.2074 234.347 70.2032L234.355 70.222V70.2032C234.397 70.2532 234.424 70.2552 234.457 70.3384L234.576 70.1512C234.576 70.1512 234.557 70.1512 234.543 70.1554C234.47 70.1533 234.501 70.1221 234.476 70.1242C234.476 70.12 234.466 70.12 234.447 70.1242C234.436 70.1242 234.424 70.1242 234.414 70.12L234.347 70.1034L234.393 70.1616C234.326 70.1741 234.261 70.1304 234.314 70.1991C234.274 70.1471 234.147 70.1076 234.034 70.0535C233.92 70.0036 233.818 69.9349 233.803 69.9079C233.714 69.8829 233.647 69.8226 233.582 69.7352C233.593 69.7623 233.56 69.8122 233.505 69.7311C233.562 69.7103 233.545 69.6687 233.52 69.6188C233.491 69.5584 233.439 69.4898 233.441 69.4295C233.455 69.5189 233.218 69.2194 233.249 69.3608C233.193 69.2943 233.274 69.3255 233.245 69.2631C233.156 69.209 233.078 69.132 233.012 69.0467C232.945 68.9615 232.893 68.872 232.826 68.7763C232.812 68.7805 232.814 68.8263 232.768 68.7951V68.6495C232.741 68.612 232.672 68.6536 232.679 68.5517C232.672 68.5683 232.666 68.5933 232.645 68.5663C232.606 68.4519 232.556 68.3395 232.493 68.2272C232.427 68.1107 232.345 68.0046 232.254 67.9069C232.07 67.7093 231.858 67.5533 231.648 67.3744C231.7 67.4326 231.654 67.4139 231.606 67.391C231.635 67.4139 231.589 67.4243 231.587 67.4451C231.556 67.4201 231.533 67.3993 231.496 67.3723C231.423 67.3349 231.36 67.339 231.337 67.3286C231.329 67.3557 231.294 67.3661 231.264 67.3515C231.235 67.339 231.214 67.3203 231.189 67.3349C231.204 67.3432 231.217 67.3473 231.231 67.3536C231.194 67.364 231.185 67.4056 231.204 67.4597C231.221 67.5158 231.273 67.5595 231.26 67.599C231.294 67.5845 231.331 67.5782 231.369 67.5803C231.402 67.5845 231.41 67.5949 231.412 67.6115C231.466 67.6594 231.523 67.7093 231.614 67.701C231.635 67.7322 231.577 67.7093 231.583 67.7342C231.633 67.7218 231.677 67.7384 231.739 67.7987H231.727C231.923 67.9318 231.981 68.0254 232.116 68.2438L232.137 68.2043C232.166 68.2542 232.162 68.2709 232.166 68.2979C232.254 68.3187 232.081 68.1648 232.166 68.1752C232.156 68.2314 232.212 68.3104 232.258 68.3978C232.306 68.4872 232.347 68.5787 232.32 68.6245C232.364 68.7098 232.35 68.5787 232.391 68.664L232.381 68.6973L232.42 68.7035C232.445 68.7618 232.433 68.8055 232.416 68.8179C232.412 68.8034 232.389 68.7826 232.381 68.768C232.393 68.8554 232.508 68.9719 232.516 69.001L232.479 68.9095C232.558 69.0197 232.647 69.157 232.758 69.2693C232.866 69.3816 232.976 69.469 233.081 69.5335V69.5064C233.233 69.6104 233.174 69.6208 233.297 69.7581H233.289C233.328 69.7789 233.372 69.8247 233.41 69.8725C233.355 69.8413 233.447 69.9828 233.378 69.9412C233.564 70.0847 233.478 70.0077 233.635 70.0535L233.641 70.0992C233.699 70.1055 233.71 70.0992 233.805 70.1512C233.714 70.1263 233.841 70.2303 233.735 70.2053C233.82 70.301 233.914 70.3239 233.987 70.3384C234.059 70.353 234.114 70.3613 234.153 70.4237C234.28 70.3717 233.972 70.3176 234.037 70.3156C234.001 70.2719 234.141 70.2864 234.205 70.3114C234.255 70.326 234.278 70.3905 234.366 70.4383C234.405 70.4612 234.482 70.4653 234.534 70.4549C234.516 70.457 234.513 70.4632 234.493 70.4653C234.543 70.4736 234.576 70.4528 234.603 70.4466L234.832 70.38L234.745 70.222C234.732 70.1991 234.722 70.1741 234.726 70.1429C234.709 70.1367 234.701 70.1284 234.693 70.12L234.688 70.1138V70.1096H234.686L234.58 70.1367C234.601 70.1304 234.628 70.1304 234.643 70.1304C234.709 70.1388 234.582 70.118 234.576 70.1013C234.595 70.1138 234.626 70.1221 234.643 70.1263C234.663 70.1304 234.649 70.1263 234.653 70.1304C234.649 70.1304 234.618 70.1304 234.593 70.1346H234.582L234.58 70.1367L234.655 70.118V70.1221L234.661 70.1304L234.695 70.197C234.684 70.1783 234.668 70.1616 234.653 70.145L234.641 70.1325L234.634 70.1263C234.68 70.1138 234.572 70.1429 234.582 70.1388L234.591 70.1367H234.607C234.643 70.1325 234.62 70.1325 234.624 70.1304L234.618 70.1242C234.618 70.1242 234.622 70.1242 234.609 70.12C234.597 70.1159 234.584 70.1096 234.576 70.1034C234.572 70.1013 234.568 70.0972 234.563 70.0951L234.559 70.0909V70.0888C234.572 70.1138 234.532 70.0348 234.586 70.1429H234.591L234.597 70.1367C234.605 70.1304 234.613 70.12 234.62 70.1117C234.622 70.1055 234.624 70.1034 234.624 70.0992C234.626 70.0888 234.628 70.0826 234.626 70.0805C234.626 70.0452 234.62 70.0452 234.618 70.0306C234.611 70.0056 234.607 69.9786 234.609 69.9536C234.626 69.9682 234.653 70.0036 234.668 70.0223C234.682 69.9973 234.641 69.964 234.655 69.9412C234.693 69.962 234.705 69.9869 234.713 70.016L234.72 70.0389C234.72 70.0389 234.72 70.0431 234.722 70.0722V70.0972C234.718 70.1117 234.711 70.1325 234.701 70.1554C234.688 70.1804 234.666 70.2032 234.641 70.2178L234.632 70.222H234.63C234.601 70.1616 234.695 70.3613 234.561 70.0868C234.561 70.0868 234.568 70.0951 234.574 70.0992C234.595 70.1138 234.63 70.1242 234.649 70.1284C234.668 70.1325 234.668 70.1304 234.651 70.1284C234.643 70.1284 234.63 70.1284 234.618 70.1284H234.597L234.586 70.1325H234.582C234.466 70.1616 234.74 70.093 234.713 70.0992C234.718 70.1034 234.722 70.1076 234.728 70.1117C234.728 70.1096 234.728 70.1055 234.728 70.1034V70.0992V70.0972L234.582 70.1325H234.584C234.616 70.1263 234.655 70.1263 234.661 70.1284C234.67 70.1284 234.634 70.1263 234.601 70.1117C234.584 70.1055 234.568 70.0951 234.561 70.0868V70.0826L234.638 70.2365L234.641 70.2344L234.653 70.2282C234.684 70.2116 234.715 70.17 234.722 70.1512C234.732 70.1325 234.74 70.0909 234.738 70.0888C234.74 70.041 234.736 70.0368 234.736 70.0348C234.736 70.0327 234.736 70.0285 234.736 70.0285C234.738 70.0244 234.749 70.0285 234.768 70.0306C234.72 70.0181 234.715 69.9911 234.715 69.9724C234.715 69.9495 234.72 69.937 234.67 69.8788L234.72 69.9162C234.709 69.9037 234.682 69.8684 234.68 69.8517C234.705 69.8808 234.728 69.9079 234.751 69.9287C234.722 69.8975 234.72 69.8663 234.757 69.8996C234.786 69.9204 234.809 69.9432 234.809 69.937C234.759 69.91 234.751 69.8788 234.688 69.8288C234.718 69.8309 234.765 69.8684 234.799 69.8975C234.815 69.912 234.832 69.9266 234.847 69.9349C234.851 69.9349 234.853 69.9391 234.857 69.9391C234.863 69.9391 234.882 69.9349 234.897 69.9308C234.926 69.9224 234.955 69.91 234.98 69.8975C234.961 69.912 234.824 69.9328 234.886 69.8892C234.938 69.8767 234.986 69.8663 235.007 69.8767L235.451 70.1076L235.082 69.4794C235.082 69.4794 235.074 69.4648 235.072 69.4565C234.92 69.34 235.067 69.5064 234.99 69.4752C234.98 69.4357 234.959 69.4253 234.932 69.4191C234.913 69.4191 234.924 69.4191 234.834 69.3899C234.824 69.3858 234.755 69.3816 234.72 69.4024C234.682 69.4191 234.663 69.444 234.645 69.4752C234.626 69.5148 234.626 69.5418 234.626 69.5584L234.584 69.5543C234.57 69.6479 234.578 69.6604 234.584 69.6832C234.591 69.6999 234.601 69.7061 234.611 69.7103C234.622 69.7144 234.632 69.7207 234.638 69.7311C234.641 69.7373 234.643 69.7456 234.643 69.7477C234.643 69.7477 234.641 69.7477 234.659 69.7519C234.67 69.7519 234.678 69.7519 234.688 69.754C234.705 69.754 234.736 69.7727 234.738 69.7706C234.743 69.7706 234.747 69.7789 234.747 69.781C234.747 69.7768 234.747 69.7748 234.747 69.7727C234.751 69.7623 234.763 69.7311 234.784 69.7186C234.774 69.7269 234.763 69.7373 234.757 69.7498C234.753 69.756 234.751 69.7623 234.749 69.7706C234.749 69.7727 234.747 69.7727 234.745 69.7748C234.745 69.7748 234.745 69.7789 234.745 69.781C234.745 69.7789 234.74 69.7748 234.738 69.7727C234.734 69.7706 234.726 69.7685 234.707 69.7602C234.691 69.754 234.676 69.7519 234.659 69.7498L234.591 69.7394C234.591 69.7394 234.582 69.7394 234.576 69.7332C234.576 69.7332 234.576 69.7394 234.576 69.7373C234.578 69.7373 234.566 69.7352 234.616 69.7415C234.657 69.7498 234.672 69.7477 234.693 69.754C234.713 69.7602 234.732 69.7706 234.736 69.7706C234.74 69.7706 234.743 69.7789 234.743 69.7789C234.743 69.7768 234.743 69.7727 234.743 69.7706C234.743 69.7748 234.753 69.7415 234.763 69.7332C234.77 69.7269 234.776 69.7207 234.782 69.7144H234.784V69.7124L234.772 69.7269L234.782 69.7165C234.776 69.7186 234.765 69.7352 234.77 69.7228C234.77 69.729 234.803 69.6978 234.861 69.6791C234.888 69.6687 234.882 69.6728 234.88 69.6728C234.88 69.6728 234.88 69.6728 234.878 69.6708C234.878 69.6687 234.874 69.6645 234.872 69.6604C234.865 69.6416 234.863 69.6167 234.853 69.5668L234.618 69.8122C234.638 69.8184 234.661 69.8268 234.688 69.8372C234.668 69.8039 234.726 69.7664 234.788 69.7831C234.803 69.8018 234.793 69.808 234.79 69.8143C234.79 69.8164 234.79 69.8184 234.793 69.8226H234.797C234.797 69.8226 234.828 69.8372 234.849 69.8413C234.861 69.8413 234.868 69.8455 234.89 69.8455C234.913 69.8455 234.938 69.8392 234.963 69.8288C234.99 69.8184 235.003 69.806 235.02 69.7872C235.036 69.7706 235.051 69.7456 235.055 69.7373C235.055 69.7456 235.045 69.7706 235.03 69.7914C235.013 69.8122 234.999 69.8309 234.963 69.8476C234.934 69.8642 234.88 69.8704 234.865 69.8684C234.843 69.8684 234.82 69.8642 234.795 69.8559C234.77 69.8517 234.776 69.8538 234.759 69.8288C234.753 69.8413 234.734 69.8496 234.726 69.86C234.736 69.8704 234.747 69.8767 234.755 69.8808L234.765 69.885H234.768C234.78 69.8912 234.822 69.9058 234.849 69.91C234.868 69.9162 234.938 69.9141 234.988 69.8912C235.042 69.8684 235.063 69.8434 235.092 69.808C235.107 69.7893 235.115 69.7748 235.117 69.7685L235.128 69.7415C235.134 69.7228 235.14 69.704 235.14 69.6957C235.149 69.65 235.147 69.6312 235.149 69.6125C235.147 69.6271 235.145 69.6416 235.142 69.6562C235.138 69.677 235.132 69.6936 235.126 69.7082C235.136 69.6188 235.12 69.5959 235.113 69.5605C235.105 69.5293 235.095 69.5002 235.088 69.4877C235.099 69.494 235.117 69.4856 235.128 69.5002C235.124 69.496 235.132 69.4919 235.115 69.4919L235.078 69.4835L235.059 69.4794H235.051L235.047 69.4752L235.12 69.496H235.136C235.149 69.4981 235.147 69.469 235.153 69.4669C235.157 69.4586 235.159 69.4648 235.165 69.4628C235.178 69.469 235.195 69.469 235.207 69.4752C235.213 69.4752 235.217 69.4794 235.217 69.4919C235.217 69.496 235.217 69.5168 235.209 69.5189L235.188 69.5127H235.182L235.047 69.4752H235.049H235.059L235.099 69.4877L235.067 69.4794L235.053 69.4752H235.045L235.182 69.5106L235.201 69.5148C235.217 69.5252 235.215 69.5044 235.222 69.494C235.228 69.4752 235.228 69.4773 235.228 69.4773C235.23 69.4731 235.242 69.4524 235.251 69.4357V69.4315C235.274 69.4253 235.324 69.3858 235.322 69.3983C235.33 69.3962 235.342 69.3483 235.349 69.3213C235.357 69.2901 235.361 69.2568 235.363 69.2215C235.288 69.1299 235.211 69.0426 235.136 68.9635C235.124 68.9615 235.103 68.9511 235.063 68.9344C235.03 68.9115 234.974 68.8783 234.951 68.8679C234.951 68.8616 234.94 68.8471 234.93 68.8304L234.911 68.8034L234.901 68.7888C235.057 68.6723 234.688 68.9469 234.726 68.9178C234.726 68.9178 234.732 68.9157 234.734 68.9157C234.743 68.9157 234.753 68.9136 234.768 68.9136C234.801 68.9136 234.834 68.9199 234.913 68.9386C234.938 68.9448 234.932 68.9427 234.932 68.9427V68.9344C234.932 68.9136 234.936 68.8928 234.938 68.8679L234.951 68.8491L234.586 68.9802C234.588 69.0051 234.591 69.028 234.591 69.0509C234.626 69.0675 234.624 69.0447 234.628 69.0239C234.634 69.0072 234.632 68.9719 234.713 69.028C234.872 69.1487 234.738 69.1195 234.788 69.1819C234.838 69.1986 234.907 69.209 234.982 69.2007C234.99 69.2007 235.005 69.2007 235.007 69.1986H235.015L235.02 69.1965L235.026 69.1591C235.026 69.1591 235.028 69.1466 235.026 69.1528C235.024 69.1611 235.022 69.1674 235.017 69.1736C235.009 69.1944 235.013 69.1861 235.013 69.1882C235.013 69.1882 235.013 69.1882 235.017 69.1923C235.026 69.2027 235.034 69.2111 235.042 69.2235C235.055 69.2381 235.067 69.2547 235.08 69.2693C235.061 69.261 235.047 69.2485 235.032 69.236L235.009 69.2152L235.005 69.2111L235.001 69.209L235.011 69.1861L234.99 69.2152ZM234.986 68.3333C234.978 68.379 234.982 68.4331 234.961 68.4248C234.92 68.3978 234.951 68.3894 234.986 68.3333ZM235.286 68.0941C235.309 68.1066 235.319 68.1378 235.322 68.1773C235.307 68.1565 235.294 68.1294 235.286 68.0941ZM232.325 64.9803C232.325 64.9803 232.322 64.9803 232.32 64.9782C232.245 64.895 232.275 64.9241 232.325 64.9803ZM232.416 65.1633C232.427 65.1779 232.433 65.1758 232.435 65.1654C232.422 65.1571 232.406 65.1175 232.383 65.0718C232.383 65.0905 232.387 65.1155 232.416 65.1633ZM234.438 70.1637L234.461 70.172C234.416 70.1908 234.43 70.1762 234.438 70.1637Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.451 68.2832C235.451 68.2832 235.443 68.2982 235.437 68.3046C235.447 68.311 235.456 68.3067 235.451 68.2832Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.112 68.9951L235.116 68.9995C235.116 68.9995 235.125 68.9995 235.127 68.9995L235.109 68.9951H235.112Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.798 65.0303C232.812 65.0554 232.819 65.0721 232.819 65.0846C232.827 65.0805 232.827 65.0637 232.798 65.0303Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.691 65.4733L231.778 65.4796C231.733 65.4733 231.721 65.4607 231.704 65.4502C231.704 65.4607 231.717 65.4775 231.691 65.4712V65.4733Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.165 65.4404C231.175 65.4341 231.19 65.4362 231.2 65.43L231.194 65.4111C231.18 65.4132 231.167 65.4174 231.157 65.4195L231.173 65.4446C231.18 65.4216 231.177 65.4111 231.157 65.4362L231.152 65.4404H231.159C231.159 65.4404 231.161 65.4404 231.163 65.4404H231.165Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.651 65.3255C231.651 65.2898 231.601 65.2919 231.555 65.294C231.557 65.294 231.561 65.294 231.563 65.294C231.546 65.3423 231.593 65.3276 231.651 65.3234V65.3255Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.542 65.2939C231.528 65.2939 231.513 65.296 231.501 65.2939C231.496 65.3128 231.515 65.2981 231.542 65.2939Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.221 65.5505C232.179 65.5401 232.19 65.5942 232.167 65.5755C232.152 65.5838 232.167 65.59 232.192 65.588C232.204 65.588 232.219 65.5838 232.234 65.5796L232.254 65.5734C232.254 65.5734 232.265 65.5713 232.263 65.5692V65.5048L232.261 65.3425H232.467H232.486H232.484H232.479C232.479 65.3425 232.475 65.3363 232.471 65.3363C232.467 65.3342 232.463 65.3425 232.465 65.3446L232.265 65.5068C232.265 65.5651 232.265 65.538 232.254 65.5464C232.246 65.5464 232.236 65.5484 232.223 65.5505H232.221Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.627 65.2051L231.639 65.2511L231.675 65.2239L231.627 65.2051Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.049 65.3317L231.967 65.2939C231.967 65.2939 231.954 65.3023 231.939 65.3023C231.992 65.317 232.047 65.3443 232.049 65.3317Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.94 65.303C231.913 65.2946 231.888 65.2904 231.871 65.2946C231.886 65.2946 231.917 65.3009 231.94 65.303Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.75 65.2178L231.773 65.2325L231.834 65.2472L231.75 65.2178Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.711 64.9902L231.613 65.0007C231.602 65.0154 231.629 65.0238 231.665 65.0196C231.688 65.0091 231.726 65.0049 231.711 64.9902Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.992 65.1137C231.971 65.1011 231.969 65.0928 231.956 65.0781L231.95 65.1304L231.992 65.1137Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.717 65.1172C231.707 65.1319 231.574 65.155 231.698 65.155C231.709 65.1403 231.81 65.1298 231.717 65.1172Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.788 65.2445L232.773 65.2256L232.706 65.2802L232.788 65.2445Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.577 65.8956C233.543 65.8767 233.564 65.9541 233.529 65.9228C233.51 65.9416 233.56 65.9479 233.545 65.9646C233.583 65.9416 233.594 65.9479 233.577 65.8956Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.546 65.9639C233.546 65.9639 233.533 65.9703 233.524 65.9767C233.537 65.9724 233.541 65.9681 233.546 65.9639Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.257 67.3056C231.257 67.3056 231.246 67.2847 231.244 67.2764C231.244 67.2868 231.244 67.2994 231.244 67.3119L231.257 67.3056Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.151 67.3076C231.158 67.2888 231.162 67.2701 231.164 67.2493H231.158L230.932 67.2514L230.926 67.3138C230.926 67.3138 230.947 67.2951 230.957 67.2868L231.062 67.2285L231.133 67.2868C231.133 67.2868 231.147 67.3013 231.149 67.3076H231.151Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.789 68.5577L234.8 68.5473C234.808 68.5347 234.808 68.5305 234.804 68.5264C234.802 68.5368 234.797 68.5473 234.791 68.5577H234.789Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.403 68.7305L235.391 68.7158L235.376 68.7765L235.403 68.7305Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.631 69.1943C234.679 69.2421 234.75 69.2795 234.811 69.3066C234.671 69.2504 234.66 69.1298 234.631 69.1943Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.101 62.761C235.101 62.8028 235.135 62.7882 235.141 62.7945C235.131 62.7213 235.091 62.7631 235.101 62.761Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.681 62.2256L234.698 62.2172C234.664 62.213 234.633 62.2109 234.604 62.2109C234.629 62.2151 234.654 62.2193 234.681 62.2256Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.278 61.9912C234.276 62.0807 234.391 62.0807 234.46 62.1347L234.467 62.1535L234.523 62.1243C234.471 62.1056 234.418 62.0911 234.375 62.0723C234.352 62.0619 234.335 62.0515 234.32 62.0391C234.306 62.0287 234.287 62.0058 234.276 61.9912H234.278Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.383 62.1869C234.36 62.1702 234.419 62.1492 234.333 62.1994C234.339 62.1994 234.341 62.1994 234.346 62.1994C234.354 62.1953 234.366 62.189 234.383 62.1848V62.1869Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.346 62.2012C234.301 62.2225 234.384 62.2054 234.346 62.2012V62.2012Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.452 62.168C234.437 62.1701 234.416 62.1743 234.418 62.1785L234.414 62.1848C234.414 62.1848 234.416 62.1932 234.418 62.1953C234.412 62.2016 234.452 62.2079 234.431 62.2142C234.496 62.21 234.486 62.1953 234.452 62.168Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.518 62.1299L234.482 62.1341C234.482 62.1341 234.497 62.1445 234.518 62.1299Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.42 62.1469C234.42 62.1469 234.462 62.1385 234.483 62.1343C234.475 62.1238 234.477 62.1028 234.449 62.1364C234.462 62.1196 234.43 62.1343 234.42 62.1448V62.1469Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.405 62.1385C234.393 62.126 234.366 62.126 234.393 62.0967C234.366 62.1071 234.353 62.128 234.357 62.1364C234.37 62.1427 234.384 62.1448 234.405 62.1364V62.1385Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.216 62.018L234.241 62.0684C234.256 62.0747 234.273 62.081 234.287 62.0831C234.266 62.0789 234.226 62.0012 234.216 62.018Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.861 62.2676C234.867 62.255 234.844 62.2298 234.842 62.2109L234.787 62.2151C234.812 62.2298 234.861 62.2466 234.861 62.2655V62.2676Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.841 62.2119L234.923 62.2056C234.854 62.1909 234.839 62.1972 234.841 62.2119Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.539 62.0654C234.499 62.0758 234.447 62.0841 234.422 62.0987C234.453 62.0862 234.516 62.0779 234.562 62.0696H234.539V62.0654Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.424 62.0575C235.414 62.1137 235.41 62.1365 235.399 62.1698C235.408 62.1428 235.414 62.1178 235.424 62.0762C235.427 62.0471 235.439 62.0471 235.439 61.9369C235.439 61.914 235.429 61.9077 235.427 61.8994H235.422H235.416H235.42H235.422L235.429 61.914C235.439 61.9265 235.433 62.0055 235.431 62.0097C235.427 62.0325 235.424 62.045 235.42 62.0575H235.424Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.407 61.8766C235.443 61.8829 235.458 61.885 235.485 61.8892H235.481C235.47 61.8871 235.441 61.8787 235.407 61.8682C235.426 61.8745 235.428 61.8766 235.416 61.8766H235.407Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.354 61.8457C235.354 61.8457 235.389 61.8603 235.408 61.8687C235.397 61.8645 235.372 61.8583 235.354 61.8457Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.056 62.2337C235.056 62.2337 235.062 62.2462 235.07 62.2545L235.076 62.2608C235.076 62.2608 235.068 62.2608 235.089 62.2628C235.129 62.267 235.176 62.2628 235.214 62.2441C235.237 62.2358 235.266 62.215 235.272 62.2088C235.312 62.1776 235.32 62.1672 235.337 62.1484L235.301 62.1651C235.283 62.1734 235.283 62.1755 235.224 62.2088C235.216 62.2129 235.214 62.215 235.201 62.2212C235.176 62.2316 235.147 62.24 235.118 62.24C235.106 62.24 235.083 62.2379 235.083 62.2379H235.074L235.058 62.2337H235.056Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.212 62.2176L235.224 62.2114C235.254 62.1927 235.258 62.1885 235.266 62.1802L235.283 62.1635L235.302 62.1427C235.31 62.1323 235.316 62.1219 235.323 62.1136C235.333 62.097 235.341 62.0845 235.346 62.0762C235.341 62.0824 235.335 62.0949 235.325 62.1115C235.319 62.1198 235.312 62.1282 235.304 62.1407C235.298 62.1469 235.291 62.1552 235.285 62.1635L235.266 62.1823L235.252 62.1947C235.252 62.1947 235.227 62.2114 235.214 62.2197L235.212 62.2176Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.047 62.2343H235.055C235.055 62.2343 235.051 62.23 235.047 62.2343Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.729 62.1304C234.777 62.1178 234.876 62.1157 234.789 62.0674C234.752 62.0863 234.8 62.1136 234.729 62.1304Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.017 62.1823L234.935 62.1592C234.935 62.1592 234.947 62.1865 234.922 62.1907L235.017 62.1823Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.06 62.1777L235.016 62.1819L235.047 62.1903L235.06 62.1777Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.32 61.852C235.287 61.8394 235.27 61.8289 235.253 61.8184C235.253 61.8247 235.266 61.8352 235.282 61.8478C235.301 61.8541 235.337 61.8625 235.322 61.852H235.32Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.401 61.7585L235.393 61.75L235.397 61.7564L235.401 61.7585Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.274 61.8456C235.274 61.8456 235.274 61.8477 235.276 61.8498C235.282 61.8561 235.301 61.8623 235.318 61.8686C235.309 61.8623 235.301 61.8582 235.291 61.8519L235.282 61.8456C235.282 61.8456 235.268 61.8414 235.276 61.8456H235.274Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.352 61.8178C235.335 61.8136 235.32 61.8136 235.304 61.8115C235.329 61.8157 235.364 61.8241 235.352 61.8178Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.357 61.8828C235.345 61.8786 235.33 61.8744 235.317 61.8682C235.328 61.8744 235.338 61.8807 235.349 61.8849C235.349 61.8849 235.353 61.8849 235.357 61.8828Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.389 61.5205C235.385 61.5559 235.32 61.5746 235.216 61.5455C235.158 61.5808 235.33 61.6848 235.393 61.7493C235.385 61.7348 235.372 61.7181 235.405 61.7015C235.387 61.6786 235.264 61.6578 235.287 61.6245C235.36 61.6058 235.364 61.6391 235.405 61.6578C235.351 61.612 235.497 61.6037 235.483 61.5413C235.449 61.5455 235.418 61.5496 235.389 61.5559C235.383 61.5455 235.416 61.533 235.387 61.5226L235.389 61.5205Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.329 61.758L235.32 61.7664C235.341 61.7664 235.369 61.7748 235.407 61.8C235.407 61.7811 235.404 61.7685 235.398 61.7559C235.375 61.7559 235.352 61.7559 235.331 61.7643V61.758H235.329Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.269 61.7972C235.214 61.7681 235.235 61.7286 235.152 61.7119C235.097 61.7473 235.162 61.7577 235.162 61.7826C235.218 61.7348 235.181 61.8055 235.262 61.793C235.262 61.8034 235.25 61.8097 235.256 61.8159C235.262 61.8118 235.29 61.8118 235.306 61.8118H235.302C235.302 61.8118 235.287 61.8076 235.294 61.8076C235.294 61.8076 235.279 61.7993 235.273 61.7951C235.3 61.791 235.29 61.8014 235.294 61.8055L235.302 61.8097C235.306 61.7951 235.313 61.7806 235.325 61.766C235.306 61.766 235.292 61.7764 235.273 61.7951L235.269 61.7972Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.887 62.0078C234.887 62.0078 234.891 62.0144 234.891 62.0166C234.902 62.0144 234.906 62.0122 234.887 62.0078Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.948 62.0406C234.935 62.0427 234.923 62.0551 234.887 62.0447C234.858 62.0281 234.891 62.0281 234.891 62.0156C234.866 62.0219 234.808 62.026 234.875 62.0572H234.887C234.948 62.078 235.023 62.1383 235.011 62.1404C234.998 62.1051 234.985 62.078 234.948 62.0385V62.0406Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.228 61.8754C235.204 61.8586 235.177 61.8418 235.15 61.825L235.131 61.8145V61.8208C235.131 61.8208 235.129 61.8313 235.131 61.8376H235.154C235.19 61.8775 235.209 61.8712 235.23 61.8754H235.228Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.418 61.7765L235.439 61.8162C235.433 61.7974 235.428 61.7786 235.431 61.7598C235.426 61.7639 235.422 61.7702 235.418 61.7765Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.474 61.7744V61.8079C235.474 61.8079 235.482 61.7953 235.49 61.7891C235.484 61.7828 235.478 61.7786 235.474 61.7744Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.547 68.5659L236.557 68.5488C236.536 68.5595 236.528 68.5638 236.547 68.5659Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.628 64.0333C237.617 64.0916 237.584 64.1498 237.619 64.1332L237.651 64.1082C237.634 64.0812 237.63 64.0562 237.628 64.0312V64.0333Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.065 66.7773L238.08 66.7627C238.069 66.7459 238.061 66.7313 238.053 66.7188C238.057 66.7376 238.061 66.7564 238.065 66.7773Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.205 66.8496L238.163 66.9207C238.176 66.9061 238.188 66.8831 238.205 66.8496Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.066 67.3634L235.01 67.3467C235.047 67.4031 235.047 67.3676 235.066 67.3634Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.438 61.9842C236.461 62.03 236.482 62.0633 236.505 62.0903C236.48 62.0321 236.472 61.9759 236.438 61.9842Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.455 68.1433C236.43 68.1412 236.417 68.1433 236.415 68.1517C236.44 68.1559 236.455 68.1517 236.455 68.1433Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.601 62.1968C236.601 62.1968 236.595 62.1801 236.591 62.1718C236.561 62.1489 236.534 62.1261 236.505 62.0928C236.524 62.1365 236.549 62.1801 236.601 62.1968Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.998 62.6987C232.998 62.6987 233.004 62.6923 233.009 62.6902C233.004 62.6859 233.002 62.6901 232.998 62.6987Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.405 62.7003C234.391 62.694 234.368 62.6815 234.345 62.6689C234.353 62.6773 234.372 62.6878 234.405 62.7003Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.803 61.5703C235.779 61.5791 235.801 61.5747 235.803 61.5703V61.5703Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.609 61.4942C235.609 61.4942 235.618 61.4792 235.614 61.4707C235.614 61.4792 235.614 61.4878 235.609 61.4942Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.771 61.5811C235.771 61.5811 235.754 61.5853 235.745 61.5853C235.745 61.5917 235.749 61.596 235.771 61.5811Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.837 61.5586C235.824 61.5628 235.81 61.5649 235.795 61.567C235.801 61.567 235.803 61.569 235.803 61.5711C235.81 61.569 235.82 61.5649 235.837 61.5607V61.5586Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.563 65.3005C233.563 65.3005 233.563 65.2963 233.56 65.292C233.522 65.277 233.537 65.2856 233.563 65.3005Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.236 64.8329L238.231 64.8281V64.8352L238.236 64.8329Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.294 64.9527C238.236 64.909 238.234 64.8757 238.232 64.832L238.138 64.8986L238.292 64.9527H238.294Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.526 68.0895C235.537 68.1249 235.549 68.1644 235.568 68.2039C235.432 68.1145 235.409 68.025 235.42 68.1374C235.476 68.1145 235.522 68.2039 235.643 68.3079C235.703 68.3599 235.778 68.3932 235.828 68.4036C235.878 68.414 235.907 68.4057 235.92 68.3786L235.976 68.4202C235.959 68.414 235.953 68.4202 235.936 68.414C236.038 68.5014 236.045 68.3558 236.178 68.414C236.222 68.439 236.249 68.466 236.213 68.4681C236.251 68.4702 236.284 68.4743 236.328 68.4806C236.361 68.4951 236.347 68.5118 236.313 68.4951C236.365 68.5138 236.465 68.5471 236.559 68.5409V68.5451C236.599 68.5284 236.68 68.4847 236.709 68.4598C236.77 68.4556 236.686 68.4806 236.703 68.4889C236.74 68.466 236.778 68.439 236.803 68.4182C236.851 68.4244 236.799 68.491 236.695 68.5201C236.776 68.5555 236.805 68.5326 236.832 68.5055C236.859 68.4785 236.894 68.4411 237.005 68.4202L236.924 68.4785C237.011 68.5076 237.069 68.4515 237.19 68.4286C237.155 68.4265 236.94 68.4494 237.028 68.3703C237.059 68.362 237.099 68.3454 237.14 68.2934C237.161 68.3287 237.209 68.2892 237.271 68.2455L237.296 68.2934C237.357 68.2351 237.336 68.2143 237.363 68.1665C237.44 68.1166 237.482 68.1374 237.521 68.1519C237.644 68.0646 237.398 68.1644 237.53 68.0438C237.636 67.9793 237.692 67.9002 237.765 67.765C237.838 67.711 237.78 67.7983 237.813 67.7838C237.819 67.7546 237.823 67.7234 237.828 67.6943C237.84 67.6798 237.846 67.6943 237.85 67.6985C237.875 67.6361 237.813 67.6631 237.857 67.5716C237.821 67.5217 238.044 67.4405 238.036 67.2929C238.063 67.27 238.061 67.3199 238.084 67.3199C238.111 67.1431 238.111 67.1681 238.098 67.0183C238.119 66.985 238.144 66.9497 238.165 66.9143C238.105 66.9871 238.086 66.8685 238.067 66.7708C238.042 66.7957 238.019 66.8145 238.007 66.829C238.009 66.7812 238.007 66.7313 238.007 66.6813C238.019 66.6668 238.034 66.6813 238.052 66.7105C238.05 66.7001 238.046 66.6897 238.044 66.6813C238.073 66.6335 238.1 66.6647 238.121 66.7084C238.107 66.7229 238.092 66.7396 238.077 66.7541C238.102 66.7957 238.13 66.8394 238.163 66.8373C238.159 66.8269 238.159 66.8061 238.159 66.7853C238.165 66.7978 238.171 66.8041 238.177 66.802C238.184 66.7978 238.177 66.7791 238.167 66.7521L238.234 66.7292L238.211 66.7167C238.234 66.6543 238.259 66.5898 238.279 66.5253C238.238 66.3756 238.157 66.2487 238.146 66.0303C238.186 66.0864 238.217 66.0469 238.269 66.0552C238.209 66.101 238.284 66.2237 238.261 66.3361C238.271 66.2757 238.296 66.2924 238.302 66.3069L238.265 66.0989C238.309 66.1052 238.298 66.0615 238.323 66.0199C238.234 66.0386 238.284 65.8888 238.294 65.8036C238.323 65.8056 238.34 65.8431 238.311 65.918C238.392 65.8514 238.269 65.764 238.334 65.6455C238.334 65.6767 238.325 65.6912 238.338 65.7058C238.332 65.6268 238.332 65.4728 238.361 65.5061L238.365 65.5332C238.365 65.4333 238.329 65.3147 238.294 65.2149C238.259 65.113 238.217 65.0319 238.177 65.0277C238.186 65.0235 238.267 65.0277 238.284 65.036L237.975 64.8093C238.042 64.8197 238.161 64.6907 238.229 64.8135C238.229 64.7739 238.227 64.724 238.186 64.6512C238.186 64.6783 238.115 64.7365 238.1 64.7032C238.144 64.5909 238.119 64.6283 238.146 64.4952C238.142 64.5368 238.038 64.5181 238.025 64.4557C238.042 64.4619 238.117 64.4266 238.132 64.4474L238 64.3205C238.027 64.3538 238.08 64.3059 238.098 64.2664C238.084 64.2872 238.067 64.1354 238.048 64.0958L238.044 64.1666C238.015 63.9939 237.873 64.0251 237.811 63.8691C237.838 63.8795 237.944 63.8691 237.915 63.7797C237.853 63.761 237.623 63.7214 237.521 63.5987L237.534 63.5592L237.453 63.4677C237.553 63.501 237.782 63.6195 237.886 63.6923C237.877 63.6237 237.907 63.6611 237.863 63.5758C237.871 63.5342 237.921 63.605 237.936 63.6299L237.853 63.4198C237.805 63.4531 237.723 63.2888 237.686 63.3158L237.848 63.5134C237.8 63.5467 237.64 63.4552 237.578 63.3054C237.58 63.2597 237.682 63.2888 237.698 63.2784C237.671 63.268 237.596 63.1577 237.603 63.1369L237.661 63.1848C237.64 63.0953 237.528 63.0849 237.53 62.9643C237.517 62.9289 237.546 62.8333 237.513 62.8416C237.482 62.9248 237.305 63.0225 237.242 63.0059C237.242 62.9913 237.211 62.8041 237.224 62.748C237.249 62.6773 237.369 62.7792 237.39 62.7147C237.376 62.7209 237.346 62.7022 237.336 62.6918C237.336 62.6523 237.386 62.6918 237.353 62.619C237.294 62.6273 237.299 62.4485 237.294 62.5982C237.249 62.5233 237.28 62.5067 237.224 62.4048C237.217 62.4318 237.176 62.4214 237.13 62.4048C237.084 62.3923 237.032 62.3715 236.999 62.3444C237.013 62.3382 237.015 62.3112 237.015 62.2987C236.907 62.1656 236.865 62.0803 236.757 61.9617C236.757 61.9409 236.717 61.8723 236.757 61.8806C236.734 61.8702 236.705 61.8681 236.672 61.8328C236.645 61.7288 236.751 61.9076 236.747 61.814C236.717 61.8328 236.628 61.7516 236.565 61.7121C236.54 61.762 236.665 61.839 236.728 61.8764C236.676 61.9243 236.536 61.8868 236.401 61.7787C236.299 61.6872 236.399 61.7038 236.376 61.6934C236.224 61.4958 236.155 61.6144 236.059 61.4854C236.026 61.4167 236.097 61.4022 236.101 61.3668C236.203 61.4022 236.216 61.4812 236.263 61.527C236.249 61.4999 236.232 61.4771 236.216 61.4521C236.251 61.4625 236.311 61.5062 236.326 61.5436C236.32 61.5062 236.251 61.4209 236.147 61.3543C236.041 61.2857 235.895 61.2732 235.793 61.2815C235.759 61.3023 235.709 61.3356 235.741 61.346C235.759 61.3398 235.778 61.3294 235.797 61.3252C235.855 61.3481 235.705 61.4001 235.778 61.4001C235.72 61.4396 235.67 61.4979 235.587 61.5353L235.609 61.3252C235.609 61.3252 235.626 61.3419 235.634 61.3523L235.618 61.4063C235.618 61.4063 235.607 61.3731 235.589 61.3523L235.572 61.5041C235.589 61.4979 235.603 61.4895 235.612 61.4771C235.603 61.4875 235.589 61.4937 235.57 61.4979L235.584 61.3585C235.62 61.4063 235.655 61.4895 235.72 61.475L235.682 61.396C235.718 61.4084 235.764 61.4272 235.805 61.4417L236.234 61.604L235.678 61.7308C235.626 61.7433 235.574 61.7496 235.522 61.735C235.562 61.7912 235.545 61.7308 235.607 61.7995C235.584 61.7662 235.626 61.7662 235.674 61.7704L236.328 61.8348L235.828 61.4147C235.776 61.371 235.718 61.3107 235.732 61.3835C235.726 61.3211 235.699 61.2961 235.67 61.2607L235.632 61.6144C235.657 61.6081 235.684 61.6019 235.722 61.6102C235.714 61.5956 235.682 61.5915 235.749 61.5707C235.749 61.5644 235.753 61.5561 235.757 61.552C235.757 61.552 235.759 61.552 235.761 61.552H235.757C235.741 61.5499 235.724 61.5478 235.716 61.5415C235.734 61.4875 235.841 61.4563 235.872 61.4355C235.909 61.4396 235.859 61.4563 235.88 61.4729C235.895 61.4604 235.911 61.45 235.926 61.4417C235.934 61.4792 235.995 61.5145 235.93 61.527C235.949 61.5291 235.966 61.5332 235.982 61.5395C236.005 61.5686 236.036 61.5977 236.076 61.6123C236.097 61.6393 236.176 61.6497 236.13 61.6456C236.168 61.6747 236.199 61.6976 236.245 61.7412L236.238 61.7496C236.345 61.8868 236.515 61.9742 236.592 62.1593C236.636 62.1947 236.684 62.228 236.738 62.3049L236.726 62.3403C236.782 62.386 236.838 62.5192 236.882 62.5192C236.886 62.5982 236.882 62.5857 236.913 62.6544C236.953 62.748 236.994 62.8457 237.022 62.9102L237.063 62.8957C237.099 62.9747 237.146 63.0433 237.211 63.1328L237.242 63.1099C237.311 63.1806 237.323 63.3366 237.392 63.4677C237.376 63.4656 237.361 63.4302 237.359 63.4032C237.359 63.5966 237.58 63.711 237.594 63.8795C237.623 63.9086 237.63 63.9336 237.632 63.9606C237.632 63.9586 237.628 63.9544 237.625 63.9523C237.625 63.9565 237.63 63.9606 237.632 63.9669C237.632 63.9835 237.632 64.0022 237.632 64.0189C237.634 64.0022 237.636 63.9856 237.634 63.9731C237.646 63.9981 237.665 64.0334 237.688 64.0667L237.655 64.0958C237.655 64.0958 237.657 64.1 237.659 64.1042C237.655 64.1416 237.686 64.127 237.709 64.0979C237.721 64.1125 237.734 64.1333 237.746 64.1458C237.692 64.1978 237.796 64.2539 237.74 64.3205C237.782 64.3413 237.821 64.5327 237.896 64.5389C237.888 64.5431 237.886 64.5576 237.88 64.5327C237.884 64.5826 237.888 64.6346 237.919 64.6741L237.873 64.7074L237.969 64.7989C237.955 64.8717 237.944 64.9029 237.888 64.8467C237.988 64.9882 237.942 64.9674 238.036 65.0859H238C238.013 65.1338 238.077 65.2003 238.057 65.2336C238.034 65.2898 238.082 65.4333 238.09 65.5623C238.094 65.6309 238.088 65.6663 238.055 65.7453C238.021 65.8264 237.992 65.9242 237.969 65.9991C238.071 65.9492 237.913 66.1405 237.99 66.1509C237.965 66.1655 237.95 66.2029 237.932 66.1572C237.944 66.2986 237.88 66.361 237.932 66.4629C237.907 66.4754 237.9 66.4296 237.886 66.4421C237.89 66.4525 237.9 66.4879 237.886 66.5004C237.871 66.5128 237.869 66.4775 237.861 66.4546C237.846 66.5919 237.913 66.6169 237.98 66.6377C237.934 66.7021 237.934 66.7375 237.963 66.7978C237.936 66.8165 237.902 66.8519 237.915 66.7645C237.905 66.8145 237.805 67.0391 237.85 67.0599C237.834 67.0703 237.821 67.1202 237.823 67.1348C237.775 67.2325 237.769 67.2388 237.721 67.3345L237.744 67.3137C237.782 67.3844 237.713 67.399 237.671 67.4738L237.667 67.4676C237.511 67.5945 237.634 67.555 237.463 67.661L237.501 67.6818C237.548 67.7588 237.34 67.7692 237.271 67.8607L237.319 67.8524C237.286 67.9169 237.107 67.8628 237.051 67.8857C237.036 67.8857 237.061 67.8649 237.074 67.8482C236.911 67.8919 237.086 67.9044 236.99 67.9793C236.957 67.9668 236.978 67.9023 236.905 67.9398C236.865 67.9398 236.736 68.1394 236.622 68.129C236.647 68.1415 236.676 68.154 236.638 68.1873C236.605 68.2039 236.57 68.1914 236.54 68.1748C236.517 68.1602 236.48 68.1394 236.426 68.154C236.418 68.1436 236.415 68.1374 236.418 68.1311C236.34 68.1186 236.18 68.0812 236.128 68.1062C236.118 68.0292 235.997 68.0188 235.936 68.0063C235.876 67.998 235.811 67.9356 235.864 67.9002C235.828 67.8545 235.793 67.7962 235.759 67.738H235.774C235.716 67.609 235.664 67.5799 235.612 67.5529C235.603 67.5196 235.626 67.5341 235.632 67.5341C235.551 67.3449 235.534 67.3282 235.389 67.2201L235.414 67.1826C235.37 67.1577 235.305 66.8997 235.149 66.7666C235.153 66.7666 235.164 66.7645 235.176 66.7729C235.008 66.6189 234.949 66.2716 234.776 66.3007L234.656 66.2092C234.764 66.3652 234.587 66.2279 234.614 66.3048C234.562 66.2528 234.531 66.126 234.595 66.1925V66.2092C234.683 66.1863 234.474 66.0074 234.52 65.9783C234.289 65.685 234.068 65.3792 233.822 65.1275L233.806 65.2003L233.722 65.1109C233.71 65.0776 233.727 65.0464 233.787 65.1109C233.779 65.0527 233.662 65.0277 233.652 65.036C233.55 64.8987 233.75 65.0319 233.714 64.9944L233.66 64.9466L233.666 64.9632C233.608 64.9403 233.585 64.957 233.514 64.88C233.477 64.8239 233.516 64.8301 233.5 64.8093C233.504 64.8072 233.5 64.7989 233.473 64.7802L233.368 64.6679L233.377 64.7448C233.312 64.7136 233.277 64.6408 233.287 64.7303C233.283 64.697 233.258 64.6533 233.223 64.6075C233.183 64.5555 233.127 64.5035 233.069 64.4578C232.956 64.3683 232.833 64.2955 232.831 64.2726C232.754 64.2581 232.712 64.1978 232.714 64.1187C232.706 64.1374 232.648 64.1624 232.658 64.073C232.714 64.0917 232.727 64.0584 232.748 64.0147C232.769 63.971 232.798 63.9107 232.852 63.8962C232.814 63.9128 232.835 63.8587 232.862 63.7942C232.887 63.7298 232.906 63.6694 232.846 63.7069C232.891 63.6341 232.887 63.7214 232.939 63.6736C232.989 63.4697 233.139 63.2701 233.227 63.0579C233.214 63.0475 233.177 63.0725 233.179 63.0184C233.221 62.9913 233.262 62.9685 233.302 62.9435C233.318 62.9019 233.248 62.8624 233.337 62.8166C233.321 62.8208 233.296 62.8249 233.306 62.7958C233.373 62.7147 233.452 62.6502 233.541 62.5608L233.608 62.4921L233.666 62.4276C233.7 62.3944 233.731 62.3694 233.764 62.359C233.835 62.334 233.906 62.3548 234.006 62.4256C234.11 62.4942 234.208 62.5691 234.297 62.6585C234.254 62.6003 234.293 62.6211 234.339 62.644C234.314 62.6211 234.358 62.6128 234.362 62.592L234.512 62.7417C234.572 62.7105 234.706 62.8478 234.751 62.8104L234.691 62.7875C234.797 62.775 234.656 62.6065 234.708 62.542C234.587 62.5566 234.539 62.3236 234.351 62.3361C234.329 62.3049 234.391 62.3278 234.385 62.3028C234.333 62.3132 234.287 62.2945 234.216 62.2384H234.229C234.17 62.2051 234.131 62.1822 234.079 62.151C234.024 62.1198 233.972 62.0948 233.906 62.0761C233.839 62.0574 233.766 62.0532 233.687 62.0699C233.606 62.0865 233.52 62.1302 233.45 62.1884L233.498 62.2009C233.437 62.2488 233.416 62.255 233.393 62.2654C233.395 62.307 233.416 62.2862 233.454 62.2488C233.491 62.2113 233.539 62.178 233.529 62.23C233.5 62.228 233.452 62.2592 233.42 62.2862C233.389 62.3112 233.352 62.3465 233.314 62.3819C233.237 62.4526 233.158 62.5358 233.102 62.5358C233.033 62.6315 233.158 62.5358 233.091 62.6294L233.056 62.6377L233.071 62.6752C233.033 62.7272 232.989 62.7397 232.971 62.7313C232.981 62.7189 232.987 62.6897 232.996 62.6731C232.925 62.7313 232.889 62.8873 232.869 62.9102L232.925 62.8312C232.816 63.0849 232.683 63.3657 232.625 63.5966L232.65 63.5883C232.604 63.7714 232.554 63.7027 232.492 63.9357V63.9253C232.494 63.9794 232.49 64.0459 232.487 64.1208C232.477 64.0875 232.465 64.1187 232.456 64.152C232.45 64.1853 232.442 64.2206 232.423 64.1686C232.467 64.3246 232.51 64.3434 232.527 64.36C232.548 64.3725 232.569 64.3808 232.652 64.4141C232.652 64.4307 232.656 64.4474 232.658 64.4619C232.721 64.4765 232.729 64.4619 232.819 64.516C232.735 64.489 232.844 64.593 232.746 64.568C232.877 64.7448 233.029 64.6991 233.029 64.8426C233.096 64.8488 233.071 64.8051 233.037 64.7656C233.006 64.7303 232.962 64.6991 232.987 64.7074C232.975 64.6575 233.087 64.7074 233.131 64.7677C233.179 64.8176 233.135 64.9299 233.26 65.0527C233.248 65.0402 233.243 65.0443 233.231 65.0319C233.262 65.0943 233.343 65.1005 233.375 65.1837C233.443 65.1775 233.445 65.2586 233.502 65.2211L233.377 65.1192C233.454 65.1712 233.57 65.1754 233.647 65.3085C233.629 65.3085 233.585 65.2898 233.558 65.2752C233.575 65.321 233.627 65.3251 233.643 65.3709C233.587 65.4083 233.498 65.244 233.391 65.2107C233.404 65.2627 233.556 65.3064 233.468 65.3231C233.583 65.3064 233.581 65.452 233.712 65.4874L233.679 65.5103C233.695 65.5186 233.737 65.5331 233.76 65.5581L233.679 65.5498C233.777 65.5872 233.775 65.7079 233.854 65.7578C233.727 65.6205 233.862 65.6933 233.829 65.6164C234.027 65.7516 233.843 65.7848 234.024 65.9658C233.997 65.9429 233.958 65.8514 234.008 65.8805C234.033 65.9221 234.064 65.9824 234.066 66.0178C234.179 66.1426 234.083 65.972 234.147 66.0116C234.147 66.0864 234.216 66.0656 234.276 66.1156L234.245 66.1405C234.349 66.3132 234.345 66.128 234.433 66.2903L234.341 66.2653L234.41 66.3298L234.362 66.3444C234.451 66.4026 234.464 66.4338 234.516 66.5191C234.524 66.4837 234.583 66.4837 234.637 66.5524C234.653 66.6148 234.585 66.5482 234.666 66.6439C234.628 66.6377 234.585 66.6314 234.581 66.5669C234.566 66.5711 234.543 66.5607 234.528 66.5648C234.545 66.6335 234.622 66.698 234.649 66.7333C234.641 66.7188 234.628 66.7001 234.628 66.6897L234.783 66.7999C234.787 66.8311 234.764 66.8207 234.741 66.8103C234.766 66.8373 234.797 66.8457 234.83 66.8873C234.795 66.8956 234.77 66.9185 234.712 66.8665L234.843 66.9829C234.839 67.0017 234.862 67.0765 234.839 67.0661C234.878 67.1535 235.024 67.218 235.072 67.3365C235.08 67.3365 235.093 67.3449 235.112 67.3657C235.17 67.4676 235.189 67.5758 235.297 67.6714L235.285 67.7692C235.349 67.8566 235.297 67.6402 235.405 67.7858C235.482 67.8898 235.382 67.8524 235.391 67.8982C235.453 67.9439 235.549 68.0167 235.614 68.1706C235.568 68.1353 235.553 68.0978 235.526 68.0625V68.0895ZM237.026 68.3724C237.005 68.3932 236.967 68.4431 236.938 68.4306C236.944 68.3745 236.976 68.3828 237.026 68.3724ZM238.177 66.5898C238.188 66.6127 238.177 66.6418 238.155 66.6751C238.155 66.6501 238.161 66.621 238.177 66.5898ZM236.028 61.5499C236.028 61.5499 236.028 61.5499 236.03 61.5499C236.055 61.5832 236.047 61.5686 236.028 61.5499ZM235.968 61.5083C235.968 61.5083 235.959 61.5166 235.961 61.5249C235.968 61.5166 235.984 61.5166 235.999 61.5291C235.999 61.5166 235.991 61.5062 235.968 61.5103V61.5083ZM233.481 64.8322L233.491 64.8571C233.445 64.828 233.462 64.8301 233.481 64.8322Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.189 66.8418C238.189 66.8418 238.172 66.8482 238.163 66.8482C238.167 66.861 238.176 66.8632 238.189 66.8418Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.392 62.6836C237.394 62.7045 237.392 62.7171 237.388 62.7275C237.398 62.7233 237.4 62.7129 237.392 62.6836Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.804 61.3468L235.736 61.3027C235.768 61.3258 235.772 61.3426 235.783 61.3594C235.787 61.351 235.785 61.33 235.804 61.3468Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.085 61.5794C235.085 61.5794 235.062 61.5899 235.058 61.5983L235.085 61.6151C235.125 61.5941 235.14 61.5668 235.085 61.5794Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.681 61.6961C235.679 61.6604 235.629 61.6667 235.574 61.6688H235.585C235.564 61.7171 235.623 61.7066 235.681 61.6961Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.561 61.6682C235.545 61.6682 235.528 61.6682 235.511 61.6641C235.503 61.6829 235.53 61.6703 235.561 61.6682Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.876 61.5252C235.859 61.5168 235.872 61.5691 235.861 61.5586C235.849 61.6005 235.958 61.498 235.876 61.5252Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.649 61.5787L235.664 61.6228L235.694 61.5955L235.723 61.5703L235.704 61.5724H235.698L235.7 61.5766L235.717 61.5955L235.694 61.5913L235.649 61.5787Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.694 61.3984C235.664 61.4047 235.637 61.4131 235.609 61.4215C235.614 61.4278 235.605 61.4362 235.595 61.4446C235.643 61.4215 235.7 61.4089 235.694 61.3984Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.593 61.4438C235.574 61.4521 235.555 61.4626 235.545 61.4709L235.551 61.4103C235.551 61.4103 235.56 61.4145 235.564 61.4166C235.562 61.4166 235.557 61.4124 235.553 61.4082L235.547 61.4751C235.56 61.4688 235.58 61.4563 235.595 61.4438H235.593Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.631 61.5445L235.616 61.5215L235.57 61.4775L235.631 61.5445Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.442 61.7436L236.516 61.8087C236.533 61.8066 236.522 61.7814 236.495 61.7562C236.472 61.7457 236.444 61.7205 236.442 61.7415V61.7436Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.336 61.4434C236.348 61.4705 236.344 61.4768 236.344 61.4977L236.386 61.4643L236.338 61.4434H236.336Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.534 61.6519C236.551 61.6498 236.658 61.7296 236.576 61.6393C236.559 61.6414 236.488 61.5763 236.534 61.6519Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.322 62.8706L237.309 62.8496L237.231 62.8895L237.322 62.8706Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.071 63.9651C238.044 63.8299 238.011 63.9526 237.99 63.8361C237.961 63.8174 238.007 63.9297 237.979 63.9089C238.028 63.9734 238.028 64.0191 238.071 63.9651Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.979 63.9064C237.979 63.9064 237.963 63.8855 237.952 63.875C237.965 63.8938 237.973 63.9022 237.979 63.9064Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.618 62.873L234.673 62.9253L234.645 62.8772L234.618 62.873Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.772 62.8877L234.76 62.9444L234.823 62.9234C234.806 62.9171 234.777 62.9045 234.77 62.8877H234.772Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.273 68.3583V68.3436C237.251 68.3373 237.237 68.3478 237.203 68.3646L237.273 68.3583Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.117 68.4956L236.132 68.4998L236.117 68.4434V68.4956Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.299 67.9048C235.313 67.936 235.339 67.9589 235.355 67.9963C235.309 67.9318 235.349 67.8694 235.299 67.9048Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.083 69.0114C236.041 68.961 236.03 69.003 236.02 68.9988C236.099 69.0744 236.089 69.003 236.083 69.0114Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.251 68.4957L237.242 68.5186C237.282 68.477 237.32 68.4333 237.357 68.3896C237.324 68.4271 237.288 68.4624 237.251 68.4957Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.999 67.7755C237.892 67.813 237.759 68.0646 237.609 68.1749L237.578 68.1853L237.551 68.2768C237.713 68.1208 237.888 67.8858 237.999 67.7734V67.7755Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.432 67.3827C238.392 67.4015 238.48 67.2642 238.354 67.4971C238.363 67.4888 238.367 67.4847 238.373 67.4784C238.386 67.4576 238.403 67.4306 238.432 67.3827Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.373 67.4787C238.313 67.5791 238.43 67.4244 238.373 67.4787V67.4787Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.602 67.1141C238.582 67.1453 238.561 67.1786 238.544 67.2098C238.567 67.1994 238.636 67.1328 238.619 67.1661C238.69 67.0787 238.667 67.0829 238.602 67.1141Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.657 67.0039L238.615 67.0541C238.628 67.0499 238.64 67.0415 238.657 67.0039Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.54 67.1578C238.561 67.1225 238.588 67.0871 238.615 67.0518C238.596 67.0559 238.58 67.0434 238.578 67.0975C238.573 67.0767 238.565 67.1079 238.54 67.1558V67.1578Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.49 67.208C238.444 67.2517 238.394 67.3203 238.438 67.2101C238.386 67.2995 238.36 67.3765 238.377 67.3682C238.383 67.3682 238.4 67.3474 238.423 67.3141C238.44 67.2891 238.463 67.2538 238.492 67.208H238.49Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.985 67.6973L237.903 67.768L237.859 67.8512C237.882 67.8117 238.006 67.7056 237.985 67.6973Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.152 66.7338C239.152 66.7212 239.14 66.7003 239.131 66.6836C239.121 66.6899 239.115 66.6982 239.108 66.7087C239.125 66.7066 239.15 66.7129 239.152 66.7317V66.7338Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.132 66.6839C239.146 66.6755 239.161 66.665 239.207 66.665C239.151 66.6566 239.146 66.6608 239.136 66.665C239.128 66.6692 239.13 66.6755 239.132 66.6839Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.632 66.9373C238.58 66.9997 238.536 67.0621 238.503 67.1287C238.547 67.0538 238.603 66.981 238.668 66.9082L238.632 66.9373Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.652 66.8545L239.548 66.8586C239.606 66.8586 239.669 66.8587 239.736 66.8545H239.652Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.219 66.8007C240.171 66.8548 240.321 66.7945 240.264 66.8403C240.36 66.7841 240.435 66.7175 240.5 66.6572C240.425 66.7134 240.337 66.7612 240.219 66.7987V66.8007Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.611 66.5566C240.577 66.5878 240.54 66.6211 240.5 66.6586C240.54 66.6274 240.577 66.5962 240.611 66.5566Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.434 66.7256C239.444 66.7361 239.459 66.7634 239.545 66.7949L239.492 66.7424C239.474 66.7361 239.455 66.7319 239.434 66.7256Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.489 66.7402C239.556 66.761 239.602 66.7735 239.623 66.7798C239.604 66.7756 239.563 66.7631 239.487 66.7402H239.489Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.419 66.7216C239.419 66.7216 239.428 66.7238 239.434 66.726C239.43 66.7216 239.425 66.7194 239.419 66.7216Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.971 66.7257C238.992 66.7007 239.031 66.6612 239.044 66.6383C239.063 66.6071 239.084 66.5759 239.015 66.6009C239.015 66.6009 239.008 66.6009 239.004 66.605C238.967 66.6674 239.065 66.6133 238.969 66.7257H238.971Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.364 66.6587C239.316 66.642 239.266 66.6275 239.222 66.6191C239.222 66.6295 239.243 66.6462 239.207 66.6503C239.253 66.6462 239.307 66.6503 239.364 66.6587Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.44 66.6676L239.362 66.6592L239.417 66.6781L239.44 66.6676Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.337 66.6816C240.394 66.6317 240.462 66.5901 240.539 66.5381C240.452 66.5859 240.362 66.6317 240.279 66.6774C240.273 66.6941 240.246 66.7315 240.337 66.6816Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.91 66.8217C239.91 66.8217 239.925 66.8217 239.934 66.8195C239.919 66.8174 239.908 66.8152 239.91 66.8217Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.227 65.8975L241.212 65.9085L241.216 65.9151L241.227 65.8975Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.263 66.6802C240.211 66.703 240.183 66.7218 240.152 66.7446L240.11 66.7696C240.125 66.7634 240.138 66.7571 240.154 66.7488C240.194 66.7259 240.236 66.703 240.28 66.676C240.282 66.6677 240.282 66.6656 240.263 66.676V66.6802Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.813 66.3906C240.775 66.4116 240.735 66.4326 240.693 66.4557C240.731 66.4431 240.807 66.4074 240.813 66.3906Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.97 66.8271C239.97 66.8271 239.959 66.8294 239.952 66.8294C239.989 66.8338 239.987 66.8294 239.97 66.8271Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.969 66.8276C240.026 66.8152 240.074 66.7964 240.111 66.7715C240.051 66.8027 239.98 66.8131 239.934 66.8193C239.944 66.8214 239.959 66.8256 239.969 66.8276Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.154 65.546C241.183 65.5689 241.129 65.7582 240.999 65.8643C240.92 66.0016 241.07 66.0016 241.212 65.908C241.199 65.8934 241.197 65.8892 241.266 65.7228C241.229 65.779 241.016 66.0244 241.079 65.8872C241.191 65.6916 241.187 65.7374 241.256 65.648C241.218 65.6812 241.235 65.6084 241.247 65.5336C241.251 65.494 241.256 65.4545 241.254 65.4275C241.247 65.4087 241.26 65.3859 241.237 65.3838C241.199 65.4545 241.206 65.5086 241.179 65.571C241.168 65.571 241.183 65.5024 241.154 65.546Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.991 66.1699C240.975 66.1886 240.958 66.2053 240.941 66.224C241.006 66.172 241.058 66.1387 241.152 66.0659C241.218 65.9557 241.221 65.9265 241.216 65.9141C241.146 66.016 241.064 66.1075 240.977 66.1928L240.991 66.172V66.1699Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.689 66.4305C240.714 66.3702 240.837 66.2517 240.731 66.2849C240.57 66.4097 240.635 66.3952 240.541 66.4763C240.81 66.2808 240.474 66.5491 240.685 66.4284C240.635 66.4721 240.585 66.5054 240.539 66.5387C240.591 66.5096 240.643 66.4825 240.693 66.4555C240.691 66.4555 240.689 66.4555 240.685 66.4576C240.67 66.4617 240.664 66.4638 240.681 66.4555C240.681 66.4555 240.685 66.4513 240.687 66.4513C240.687 66.4451 240.687 66.4389 240.691 66.4305C240.774 66.3806 240.71 66.4305 240.687 66.4513C240.687 66.4513 240.687 66.4555 240.687 66.4576C240.776 66.3869 240.862 66.3099 240.941 66.2246C240.885 66.2725 240.816 66.3328 240.689 66.4305Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.099 66.4761C239.099 66.4761 239.109 66.4804 239.109 66.4847C239.128 66.4783 239.135 66.474 239.099 66.4761Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.221 66.4991C239.199 66.5011 239.178 66.5115 239.117 66.5115C239.059 66.5074 239.113 66.4949 239.111 66.4824C239.067 66.4949 238.988 66.5427 239.105 66.5282L239.121 66.5219C239.226 66.524 239.371 66.6176 239.348 66.6155C239.321 66.576 239.298 66.5427 239.224 66.4991H239.221Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.956 66.7148C240.01 66.7064 240.062 66.6877 240.11 66.6628L240.231 66.5879L240.096 66.6232L240.11 66.6357C240.11 66.6357 240.102 66.6399 240.1 66.6399C240.023 66.6711 239.99 66.6773 239.975 66.6857C239.96 66.694 239.967 66.7023 239.954 66.7127L239.956 66.7148Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.26 65.8786L241.27 65.9347C241.287 65.8744 241.304 65.8162 241.312 65.7559C241.295 65.7975 241.279 65.8391 241.258 65.8786H241.26Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.427 65.5257L241.454 65.5507L241.462 65.4987V65.4925V65.4883L241.264 65.4259C241.266 65.4259 241.272 65.4301 241.281 65.4363C241.293 65.4467 241.312 65.4675 241.341 65.507C241.316 65.4717 241.301 65.455 241.287 65.4405C241.281 65.4342 241.274 65.4301 241.27 65.428H241.264L241.262 65.4238L241.446 65.4821L241.425 65.5237L241.427 65.5257Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.211 64.0273L232.18 64.0964C232.194 64.065 232.205 64.0441 232.211 64.0273Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.521 63.5824L232.514 63.5615C232.506 63.5866 232.506 63.5992 232.521 63.5824Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.602 61.1885C241.588 61.176 241.575 61.1635 241.575 61.1552C241.565 61.1427 241.525 61.1157 241.506 61.1011C241.46 61.0699 241.425 61.0575 241.427 61.0762L241.456 61.124C241.498 61.1365 241.548 61.1594 241.569 61.1677C241.573 61.1719 241.59 61.1781 241.602 61.1864V61.1885Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.997 61.0413C236.008 61.0413 236.02 61.0434 236.031 61.0455C236.054 61.0266 236.077 61.0098 236.098 60.9951C236.067 61.0098 236.033 61.0245 235.995 61.0413H235.997Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.967 61.2114C235.898 61.2281 235.814 61.2177 235.756 61.2031C235.793 61.2156 235.871 61.2343 235.967 61.2114Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.557 66.415C230.563 66.4422 230.575 66.4673 230.584 66.4924C230.596 66.3816 230.575 66.4276 230.557 66.415Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.822 63.399C243.893 63.3907 243.946 63.3907 243.994 63.3927C243.91 63.3699 243.833 63.3636 243.822 63.399Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.003 63.6303C231.982 63.6742 231.976 63.6972 231.984 63.6993C232.007 63.6533 232.018 63.6261 232.003 63.6303Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.257 63.4227C244.23 63.4185 244.209 63.4123 244.184 63.406C244.103 63.3977 244.061 63.3956 243.992 63.3936C244.023 63.4019 244.057 63.4102 244.094 63.4164C244.113 63.4185 244.132 63.4227 244.15 63.4227C244.182 63.4248 244.219 63.4289 244.255 63.4227H244.257Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.379 70.6927L233.398 70.6777C233.398 70.6777 233.387 70.6799 233.379 70.6927Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.024 69.1592C236.039 69.1717 235.968 69.2777 235.951 69.3048C235.96 69.2923 235.964 69.2881 235.983 69.2569C235.991 69.2424 235.999 69.2278 236.01 69.2091C236.014 69.2008 236.018 69.1904 236.022 69.18C236.031 69.1613 236.018 69.18 236.022 69.1592H236.024Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.377 64.6787C242.329 64.7331 242.373 64.6892 242.377 64.6787V64.6787Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.03 64.8333C242.039 64.8186 242.043 64.8061 242.037 64.7998C242.039 64.8103 242.037 64.8228 242.03 64.8333Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.78 62.7654V62.7588C244.771 62.7808 244.771 62.7764 244.78 62.7654Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.291 64.7474C242.314 64.7306 242.337 64.7096 242.363 64.6865C242.35 64.6949 242.329 64.7138 242.291 64.7474Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.315 64.7471C242.296 64.7638 242.281 64.7784 242.269 64.791C242.269 64.8014 242.275 64.7994 242.315 64.7471Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.446 64.6035C242.419 64.6347 242.389 64.6618 242.362 64.6867C242.375 64.6784 242.379 64.6742 242.377 64.6784C242.392 64.6618 242.412 64.641 242.446 64.6035Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.257 71.4824C230.257 71.4824 230.255 71.4929 230.253 71.4971C230.268 71.5703 230.265 71.5389 230.257 71.4824Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.654 61.3675H239.663C239.663 61.3675 239.656 61.3676 239.654 61.3633V61.3675Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.419 61.2567C239.536 61.2712 239.586 61.3107 239.655 61.3627L239.636 61.2275L239.419 61.2567Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.398 65.1197C231.448 65.0864 231.498 65.0573 231.548 65.0261C231.43 65.2029 231.315 65.2986 231.461 65.2174C231.43 65.1675 231.548 65.0489 231.673 64.9449C231.705 64.92 231.736 64.895 231.767 64.8701C231.786 64.8534 231.807 64.8389 231.823 64.8222C231.844 64.8056 231.863 64.7827 231.88 64.7661C231.946 64.687 231.967 64.6184 231.948 64.5976C231.984 64.556 232.015 64.5102 232.04 64.4665C232.023 64.5061 232.025 64.5165 232.004 64.556C232.098 64.4249 232.084 64.3729 232.077 64.3168C232.073 64.2897 232.067 64.2606 232.069 64.2252C232.073 64.1857 232.077 64.1628 232.121 64.0963C232.182 64.0131 232.234 63.9632 232.209 64.0276C232.24 63.959 232.273 63.8904 232.309 63.8217C232.348 63.7676 232.354 63.7926 232.317 63.8467C232.379 63.7489 232.444 63.6532 232.513 63.5576V63.5617C232.529 63.5097 232.575 63.4036 232.6 63.3516C232.669 63.2913 232.581 63.3953 232.608 63.3849L232.708 63.2123C232.781 63.1686 232.702 63.3142 232.617 63.4182C232.821 63.3454 232.692 63.2726 232.994 63.0022L232.888 63.1561C233.013 63.1041 233.088 62.971 233.25 62.8379C233.204 62.8587 232.906 63.0999 233.019 62.9148C233.062 62.8732 233.117 62.815 233.171 62.7131C233.204 62.738 233.267 62.6465 233.356 62.5425L233.389 62.5862C233.477 62.4676 233.448 62.4572 233.492 62.3782C233.61 62.2659 233.664 62.2762 233.716 62.2783C233.912 62.1202 233.537 62.3428 233.762 62.1369C233.95 62.0079 234.056 61.8914 234.25 61.7084C234.385 61.6356 234.248 61.75 234.302 61.7313L234.389 61.619C234.418 61.6023 234.416 61.619 234.414 61.6273C234.5 61.5503 234.391 61.5753 234.537 61.4692C234.552 61.3881 234.895 61.3673 235.079 61.2508C235.135 61.2508 235.064 61.2903 235.085 61.3049C235.216 61.2425 235.283 61.2237 235.337 61.2029C235.395 61.1842 235.431 61.1572 235.543 61.1385L235.651 61.1697C235.668 61.1738 235.695 61.1801 235.701 61.1842L235.758 61.2009C235.712 61.1842 235.699 61.1717 235.703 61.1613C235.703 61.1509 235.718 61.1426 235.749 61.1364C235.778 61.1301 235.826 61.1239 235.872 61.1093C235.92 61.0989 235.96 61.0594 235.999 61.0407C235.937 61.0386 235.889 61.0449 235.858 61.0345C235.901 61.0303 235.93 60.9991 235.989 60.9825L236.128 60.9367C236.164 60.9367 236.141 60.9617 236.099 60.9949C236.118 60.9866 236.135 60.9783 236.149 60.97C236.255 60.9658 236.209 61.0095 236.143 61.0553L236.032 61.0449C235.999 61.0677 235.98 61.0927 235.962 61.1197C235.941 61.1447 235.928 61.1676 235.941 61.1801C235.966 61.1655 236.005 61.1426 236.026 61.1364C236.016 61.1468 236.012 61.1593 236.018 61.1613C236.022 61.1613 236.026 61.1613 236.035 61.1551C236.047 61.1489 236.066 61.1385 236.089 61.126L236.168 61.1697L236.178 61.1426C236.305 61.126 236.43 61.1093 236.545 61.1052C236.655 61.0594 236.799 61.0137 236.936 60.9617C237.08 60.9117 237.243 60.8597 237.455 60.8223C237.353 60.8785 237.44 60.8972 237.442 60.9492C237.32 60.9076 237.113 61.0157 236.886 61.0303C237.005 61.022 236.982 61.049 236.953 61.0636L237.347 60.9637C237.342 61.0074 237.434 60.9845 237.54 60.9908C237.453 60.9159 237.828 60.8993 237.984 60.866C237.994 60.8951 237.959 60.9242 237.765 60.9346C237.982 60.9804 238.036 60.8119 238.248 60.8639C238.201 60.8639 238.176 60.8597 238.157 60.8743C238.267 60.8431 238.536 60.8785 238.469 60.9013H238.423C238.578 60.9117 238.809 60.9409 239 60.9908C239.186 61.0386 239.346 61.1093 239.384 61.0885C239.384 61.0969 239.307 61.1447 239.284 61.1489C239.481 61.1613 239.692 61.2029 239.896 61.2279C239.821 61.2549 239.917 61.4838 239.665 61.3735C239.696 61.3964 239.731 61.4234 239.779 61.4526C239.802 61.4671 239.831 61.4817 239.861 61.4962C239.892 61.5087 239.952 61.5441 240.008 61.5482C239.925 61.5212 239.881 61.3901 239.963 61.4297C240.06 61.5129 240.121 61.5004 240.173 61.5066C240.215 61.5066 240.26 61.5087 240.392 61.515C240.31 61.515 240.381 61.4047 240.502 61.3839C240.485 61.4026 240.529 61.4754 240.487 61.4942C240.581 61.4442 240.675 61.3943 240.769 61.3486C240.696 61.3756 240.769 61.4297 240.833 61.4505C240.804 61.4297 241.075 61.4338 241.139 61.4442C241.104 61.4338 241.066 61.4214 241.029 61.413C241.181 61.4255 241.256 61.4151 241.343 61.4089C241.389 61.4068 241.425 61.4047 241.487 61.4172C241.548 61.4255 241.614 61.4255 241.7 61.4338C241.654 61.4505 241.589 61.5441 241.756 61.5732C241.795 61.5607 241.852 61.4962 241.962 61.515C242.097 61.5462 242.254 61.5649 242.399 61.5919L242.443 61.6335C242.516 61.6418 242.591 61.646 242.666 61.646C242.597 61.671 242.468 61.7063 242.318 61.7084C242.17 61.7146 241.993 61.6668 241.885 61.619C241.875 61.6148 241.866 61.6148 241.86 61.6148C241.866 61.6231 241.87 61.6294 241.872 61.6356C241.912 61.6834 241.87 61.673 242.033 61.7729C242.091 61.8374 241.902 61.7438 241.85 61.6959C241.987 61.8145 242.156 61.906 242.326 61.9601C242.324 61.9289 242.424 61.9455 242.522 61.9497C242.62 61.9538 242.714 61.9497 242.708 61.9268C242.533 61.9268 242.347 61.9143 242.16 61.8519C242.16 61.8207 242.254 61.8207 242.381 61.8249C242.508 61.829 242.67 61.829 242.833 61.8436C242.914 61.8706 242.764 61.9414 242.768 61.9601C242.816 61.9455 243.085 61.9393 243.114 61.9538L242.974 61.9788C243.066 61.9934 243.139 61.9767 243.207 61.9663C243.278 61.9601 243.357 61.958 243.447 62.0079C243.514 62.0266 243.618 62.1348 243.639 62.1078C243.559 62.0121 243.589 61.8103 243.686 61.7916C243.699 61.7978 243.793 61.8457 243.882 61.9102C243.974 61.9726 244.061 62.0474 244.091 62.0849C244.168 62.1889 243.874 62.0994 243.941 62.1889C243.951 62.1764 244.018 62.191 244.045 62.2014C244.101 62.2534 243.995 62.2242 244.134 62.3074C244.19 62.2721 244.401 62.5051 244.226 62.3116C244.365 62.3927 244.361 62.4239 244.503 62.5404C244.48 62.4759 244.724 62.5404 244.822 62.7235C244.803 62.7151 244.799 62.7547 244.786 62.7734C244.78 62.8067 244.757 62.8337 244.747 62.8566C244.607 63.0937 244.436 63.231 244.168 63.154C244.143 63.1311 243.978 63.1062 244.049 63.0854C243.997 63.0958 243.945 63.1083 243.847 63.1291C243.741 63.1291 243.797 63.1103 243.864 63.0958C243.93 63.0812 244.005 63.0771 243.92 63.05C243.914 63.0687 243.841 63.0833 243.759 63.1207C243.676 63.1561 243.589 63.2143 243.532 63.2643C243.566 63.2726 243.634 63.2268 243.724 63.1852C243.811 63.1415 243.924 63.1103 244.001 63.102C244.001 63.1395 243.934 63.1707 243.847 63.2227C243.803 63.2476 243.753 63.2809 243.703 63.3204C243.678 63.3412 243.653 63.362 243.626 63.387C243.599 63.4099 243.58 63.4348 243.534 63.4702C243.399 63.5576 243.366 63.543 243.362 63.5347C243.355 63.5243 243.378 63.5014 243.355 63.5139C243.289 63.5347 243.247 63.5472 243.218 63.5596C243.185 63.5721 243.16 63.5846 243.141 63.5992C243.12 63.6179 243.139 63.6491 243.141 63.6699C243.149 63.6928 243.151 63.7094 243.155 63.726C243.17 63.8113 243.132 63.9964 242.922 64.1212C242.749 64.1899 242.862 64.0526 242.81 64.0505C242.893 63.9798 242.958 63.9257 243.005 63.8612C243.053 63.8009 243.085 63.7219 243.087 63.6657C243.076 63.7094 243.057 63.778 243.02 63.83C243.028 63.7947 243.043 63.7406 243.045 63.6865C243.06 63.6345 243.028 63.5721 243.068 63.5492C243.047 63.5555 243.045 63.5804 243.043 63.6116C243.043 63.6428 243.035 63.6844 243.024 63.7281C243.001 63.8155 242.941 63.9112 242.847 63.984C242.756 64.0588 242.643 64.1192 242.541 64.1857C242.435 64.2502 242.356 64.3397 242.283 64.4021C242.247 64.4624 242.179 64.5581 242.229 64.531L242.308 64.4395C242.41 64.3854 242.187 64.6413 242.306 64.5414C242.212 64.6766 242.116 64.8368 241.945 64.9886L241.879 64.9824C241.893 64.9886 242.004 64.895 242.037 64.8389C241.989 64.9241 241.745 65.0427 241.722 65.1675L241.858 65.076C241.837 65.1093 241.812 65.1467 241.787 65.1841C241.762 65.2216 241.741 65.2611 241.697 65.309C241.616 65.3963 241.529 65.4546 241.454 65.5003L241.439 65.5086C241.439 65.5086 241.454 65.5066 241.458 65.5045C241.541 65.4962 241.479 65.4795 241.633 65.4462C241.552 65.4504 241.679 65.3859 241.789 65.2715C241.872 65.1841 241.947 65.1051 241.85 65.1488C242.002 65.0905 242.045 64.9845 242.22 64.8867C242.204 64.8784 242.149 64.9137 242.272 64.7952C242.272 64.7869 242.283 64.7681 242.287 64.7577C242.291 64.7536 242.293 64.7536 242.295 64.7494L242.287 64.7557C242.287 64.7557 242.291 64.7473 242.285 64.7557C242.251 64.7806 242.222 64.7973 242.208 64.7993C242.237 64.7099 242.424 64.5165 242.472 64.4353C242.547 64.3688 242.458 64.479 242.508 64.452C242.535 64.4083 242.549 64.3792 242.574 64.348C242.603 64.3688 242.803 64.2648 242.645 64.4C242.691 64.3667 242.747 64.3313 242.81 64.2939C242.87 64.2689 242.945 64.2294 243.018 64.1712C243.091 64.1129 243.16 64.0318 243.193 63.9548C243.214 63.9216 243.232 63.88 243.241 63.8404C243.249 63.8051 243.257 63.7489 243.251 63.7552C243.245 63.7406 243.241 63.7323 243.253 63.751C243.257 63.7344 243.237 63.7052 243.253 63.6928C243.268 63.6824 243.287 63.674 243.305 63.6636L243.309 63.672L243.359 63.6553L243.428 63.6304C243.474 63.6116 243.524 63.5867 243.576 63.5513C243.636 63.5097 243.655 63.4868 243.682 63.466C243.709 63.4432 243.739 63.4244 243.768 63.4099C243.886 63.3454 244.016 63.3371 244.186 63.4099C244.336 63.4307 244.559 63.3932 244.742 63.2143L244.799 63.2019C244.824 63.1686 244.853 63.1311 244.882 63.0916C244.915 63.0438 244.957 62.9772 244.992 62.9148C245.015 62.8711 245.028 62.8275 245.036 62.7859C245.04 62.7422 245.034 62.6985 245.021 62.6631C244.999 62.5903 244.959 62.5383 244.934 62.5175C244.926 62.4863 244.907 62.4447 244.878 62.399C244.849 62.3553 244.832 62.3303 244.799 62.2929C244.73 62.2159 244.659 62.1618 244.578 62.1015C244.418 61.983 244.228 61.8769 244.109 61.8062L244.08 61.8394C243.914 61.75 243.739 61.6855 243.501 61.6502L243.507 61.6897C243.405 61.6814 243.28 61.6522 243.135 61.6377C243.005 61.6231 242.866 61.6086 242.726 61.5919C242.745 61.5794 242.814 61.5919 242.864 61.6023C242.581 61.5129 242.289 61.5524 242.087 61.361C242.039 61.3194 241.985 61.2861 241.929 61.2633C241.808 61.2466 241.758 61.2466 241.702 61.23C241.708 61.23 241.714 61.23 241.72 61.23C241.712 61.23 241.702 61.2279 241.689 61.2258C241.658 61.2154 241.629 61.205 241.606 61.1946C241.625 61.2071 241.65 61.2196 241.675 61.2258C241.652 61.2237 241.622 61.2196 241.591 61.2175C241.581 61.2175 241.57 61.2133 241.56 61.2113C241.55 61.2092 241.514 61.1946 241.491 61.1884C241.483 61.1697 241.475 61.1509 241.464 61.1322C241.456 61.1301 241.45 61.1281 241.439 61.126C241.339 61.0781 241.352 61.1177 241.395 61.1634C241.343 61.153 241.293 61.1509 241.256 61.153C241.183 61.0677 240.989 61.1447 240.881 61.0844C240.808 61.1156 240.406 61.178 240.377 61.2591C240.373 61.2508 240.346 61.2508 240.394 61.2404C240.298 61.2508 240.183 61.2633 240.123 61.2903C240.113 61.2737 240.104 61.257 240.1 61.2383C240.079 61.2508 240.054 61.255 240.029 61.2529C240.002 61.2529 239.958 61.2404 239.923 61.2342C239.825 61.1405 239.788 61.0969 239.921 61.1281C239.617 61.0178 239.69 61.0095 239.415 60.9263L239.442 60.9034C239.352 60.8535 239.184 60.8306 239.134 60.7849C239.034 60.7162 238.755 60.6372 238.426 60.6226C238.099 60.6039 237.734 60.6393 237.451 60.6434C237.572 60.7287 237.184 60.6309 237.174 60.7121C237.138 60.6933 237.059 60.6892 237.147 60.658C236.861 60.7183 236.732 60.6684 236.524 60.7557C236.484 60.737 236.586 60.7141 236.553 60.7037C236.528 60.7121 236.455 60.737 236.422 60.7308C236.389 60.7225 236.464 60.7037 236.514 60.6871C236.193 60.7453 236.197 60.8306 236.187 60.8993C236.11 60.8993 236.055 60.9055 236.01 60.9201C235.991 60.9242 235.947 60.9388 235.928 60.9533C235.903 60.9679 235.897 60.9825 235.876 60.997C235.83 60.9762 235.789 60.9637 235.893 60.9367C235.878 60.9429 235.849 60.945 235.81 60.9388C235.789 60.9367 235.751 60.9263 235.708 60.9221C235.672 60.918 235.637 60.9117 235.601 60.9076C235.526 60.8951 235.426 60.8993 235.372 60.9138C235.316 60.9263 235.283 60.9429 235.283 60.9554C235.247 60.9471 235.137 60.9825 235.112 60.9949C234.879 61.0553 234.856 61.0615 234.643 61.1613L234.706 61.1426C234.65 61.2404 234.537 61.2383 234.381 61.3423V61.334C234 61.5295 234.237 61.4484 233.873 61.6564L233.916 61.6751C233.939 61.7687 233.6 61.8582 233.435 62.0516L233.517 62.01C233.437 62.1161 233.162 62.1826 233.063 62.2783C233.038 62.295 233.083 62.2347 233.108 62.2014C232.833 62.4323 233.115 62.27 232.954 62.4759C232.902 62.4947 232.938 62.3803 232.821 62.5134C232.746 62.5675 232.579 62.9606 232.39 63.1124C232.44 63.0854 232.488 63.0583 232.427 63.1623C232.321 63.31 232.059 63.5097 232.023 63.6907C232.004 63.7073 231.996 63.7115 231.99 63.7094C231.959 63.7739 231.9 63.8758 231.855 63.9736C231.796 64.0838 231.78 64.2003 231.786 64.2419C231.742 64.2627 231.711 64.323 231.68 64.3833C231.646 64.4437 231.615 64.4998 231.546 64.5581C231.388 64.6953 231.265 64.8389 231.221 64.7889C231.113 64.8909 231.013 64.9969 230.915 65.1051V65.0885C230.717 65.2861 230.68 65.388 230.642 65.4837C230.597 65.5294 230.615 65.4837 230.613 65.4754C230.476 65.6314 230.411 65.7312 230.363 65.829C230.32 65.9288 230.286 66.0286 230.265 66.2096L230.215 66.2346C230.215 66.2845 230.157 66.4363 230.151 66.6402C230.147 66.7421 230.153 66.8544 230.178 66.9647C230.201 67.0666 230.217 67.1415 230.234 67.2351C230.23 67.2309 230.22 67.2247 230.213 67.1976C230.255 67.3932 230.197 67.6407 230.134 67.8508C230.072 68.0692 230.03 68.2626 230.09 68.3562C230.084 68.454 230.08 68.5538 230.078 68.6537C230.151 68.2813 230.134 68.7202 230.184 68.5705C230.168 68.7161 230.086 68.9449 230.101 68.7618L230.111 68.7348C230.078 68.6953 230.051 68.8117 230.036 68.9386C230.02 69.0634 230.015 69.1986 229.988 69.1924C229.982 69.3838 229.988 69.5772 230.015 69.7686L230.038 69.91C230.045 69.9495 230.049 69.9911 230.053 70.0306C230.059 70.1138 230.057 70.1971 230.053 70.2823C230.045 70.4529 230.018 70.6255 229.999 70.8044C229.976 70.9833 229.97 71.1726 229.972 71.3411L230.034 71.262L230.03 71.5033C230.015 71.5678 229.982 71.5886 229.984 71.416C229.949 71.5075 230.013 71.7051 230.028 71.7113C230.003 72.0504 229.955 71.5782 229.955 71.6822L229.959 71.8236L229.966 71.7924C229.99 71.9068 230.018 71.9172 230.015 72.1252C230.003 72.2563 229.978 72.1939 229.976 72.2438C229.972 72.2438 229.97 72.2605 229.976 72.3229L229.972 72.6286L230.02 72.5059C230.045 72.6411 230.018 72.7929 230.072 72.6515C230.061 72.6765 230.053 72.7139 230.047 72.7597C230.043 72.8096 230.028 72.847 230.038 72.9365C230.045 73.0176 230.086 73.1029 230.149 73.1715C230.211 73.2381 230.286 73.2859 230.37 73.3171C230.449 73.3483 230.544 73.3629 230.636 73.3483C230.726 73.3358 230.805 73.2963 230.859 73.2422C230.919 73.1861 230.942 73.1466 230.967 73.1195C230.992 73.0904 231.011 73.0675 231.024 73.0571C231.113 72.8845 231.223 72.7326 231.361 72.5454C231.319 72.587 231.255 72.5829 231.376 72.4248C231.425 72.5496 231.625 72.1544 231.788 72.0774C231.723 72.1169 231.805 72.0046 231.88 71.8985C231.898 71.8715 231.917 71.8465 231.932 71.8236C231.944 71.8049 231.954 71.7883 231.963 71.7758C231.977 71.7508 231.969 71.7404 231.921 71.7633C232.032 71.6676 231.957 71.7841 232.054 71.7342C232.113 71.6739 232.192 71.6219 232.267 71.599C232.286 71.5928 232.304 71.5907 232.321 71.5886H232.39C232.45 71.5886 232.515 71.5844 232.577 71.5803C232.831 71.5553 233.102 71.4555 233.31 71.287C233.308 71.2704 233.225 71.3036 233.3 71.2184C233.387 71.183 233.473 71.1414 233.556 71.0956C233.625 71.0187 233.564 70.9708 233.725 70.8731C233.698 70.8835 233.658 70.898 233.7 70.846L233.783 70.767C233.854 70.7025 234.023 70.6609 234.158 70.6547C234.183 70.6547 234.202 70.6567 234.233 70.6692C234.264 70.6796 234.302 70.6963 234.343 70.715C234.437 70.7587 234.581 70.7961 234.693 70.742C234.795 70.6983 234.856 70.6484 234.914 70.6068L234.997 70.5465L235.037 70.5215L235.106 70.4862L235.503 69.9807C235.633 69.8143 235.749 69.6417 235.872 69.4794L235.687 69.3609C235.705 69.3713 235.712 69.3983 235.724 69.3921C235.73 69.3983 235.774 69.4129 235.797 69.4274L235.876 69.4711L235.885 69.4607L235.905 69.4358L235.951 69.3817C235.858 69.4753 235.899 69.4025 235.955 69.3151C235.914 69.3671 235.924 69.2943 235.901 69.2943C235.918 69.2756 235.935 69.2548 235.96 69.2236C235.97 69.209 235.98 69.1945 235.991 69.1778C235.991 69.1737 235.995 69.1695 235.997 69.1653C235.993 69.1737 235.995 69.1695 235.997 69.1653L236.005 69.1383C236.022 69.0822 236.032 69.053 236.047 69.0218C236.051 69.0135 236.053 69.0114 236.055 69.0052H236.057L236.014 68.9802C235.964 68.949 235.987 68.9345 235.991 68.9969C235.991 69.0093 235.993 69.0218 235.991 69.0385C235.991 69.053 235.991 69.0385 235.993 69.0426C235.993 69.0385 236.005 69.0385 236.016 69.0385C236.039 69.0385 236.074 69.0447 236.112 69.053C236.251 69.078 236.357 69.053 236.405 69.0468L236.545 69.026L236.528 68.922C236.524 68.8991 236.52 68.8845 236.511 68.8762L236.422 68.7681L236.503 68.7764L236.509 68.8741V68.9199L236.518 69.0135L236.403 69.0281L236.33 69.0385C236.393 69.0093 236.37 68.9823 236.316 68.9573C236.262 68.9345 236.176 68.9033 236.153 68.8637C236.132 68.8429 236.124 68.8242 236.132 68.8076C236.105 68.8117 236.076 68.8076 236.043 68.8055C236.012 68.8055 235.96 68.7826 235.883 68.8325C235.818 68.8866 235.812 68.9345 235.795 68.9698C235.78 69.0031 235.766 69.053 235.755 69.0717C235.749 69.0946 235.718 69.1113 235.685 69.1653C235.668 69.1882 235.651 69.2132 235.637 69.2381L235.616 69.2798L235.606 69.3026L235.599 69.3172L235.591 69.3338C235.585 69.3463 235.583 69.3609 235.581 69.3754V69.3858C235.581 69.3858 235.578 69.3796 235.581 69.4108C235.583 69.4233 235.589 69.4441 235.608 69.469C235.624 69.494 235.664 69.5169 235.695 69.519C235.758 69.5252 235.785 69.4961 235.785 69.4982C235.793 69.4919 235.803 69.4836 235.81 69.4774L235.599 69.3193C235.589 69.3484 235.578 69.3775 235.572 69.4087C235.522 69.4586 235.581 69.3442 235.545 69.3671C235.535 69.4524 235.493 69.5398 235.385 69.677L235.389 69.6562C235.304 69.7935 235.222 69.8954 235.141 69.9932C235.099 70.041 235.06 70.0868 235.018 70.1346C234.979 70.1804 234.927 70.2387 234.91 70.2532L234.887 70.2615C234.887 70.2615 234.856 70.2782 234.841 70.2844C234.81 70.3031 234.779 70.3219 234.745 70.3427C234.689 70.3801 234.614 70.4259 234.589 70.43C234.585 70.43 234.579 70.4321 234.575 70.4342C234.583 70.4446 234.591 70.455 234.6 70.4633L234.604 70.4675H234.602C234.539 70.4841 234.525 70.4529 234.504 70.4404C234.439 70.4591 234.554 70.5028 234.606 70.4779C234.627 70.4737 234.641 70.4779 234.625 70.5049C234.62 70.5049 234.618 70.5049 234.612 70.5049C234.579 70.5049 234.529 70.4945 234.483 70.4695C234.454 70.455 234.406 70.4321 234.352 70.4092C234.3 70.3863 234.216 70.3635 234.143 70.3676C233.912 70.3759 233.721 70.455 233.629 70.4716C233.439 70.6359 233.641 70.4987 233.569 70.5819C233.562 70.5902 233.552 70.6047 233.533 70.6235L233.481 70.6422L233.473 70.6983C233.387 70.7815 233.323 70.7982 233.304 70.7878C233.327 70.7711 233.356 70.7275 233.377 70.7046C233.254 70.7961 233.079 70.9916 233.031 71.0083C233.077 70.9833 233.123 70.9542 233.169 70.923C232.998 71.0831 232.777 71.2038 232.536 71.2412C232.475 71.2516 232.415 71.2558 232.352 71.2579L232.29 71.262C232.263 71.2641 232.238 71.2683 232.215 71.2745C232.167 71.2849 232.127 71.3016 232.088 71.3182C231.936 71.3889 231.819 71.4846 231.727 71.6011L231.771 71.5824C231.696 71.6718 231.669 71.7217 231.634 71.7654C231.6 71.807 231.575 71.8361 231.548 71.8673C231.494 71.9276 231.434 71.99 231.319 72.1627L231.323 72.1481C231.29 72.2272 231.234 72.3229 231.167 72.4123C231.209 72.3145 231.019 72.5475 231.078 72.4206C230.871 72.7701 230.986 72.5995 230.884 72.8553L230.821 72.8845C230.805 72.9281 230.799 72.9552 230.78 72.9905C230.771 73.0072 230.759 73.028 230.742 73.0529C230.728 73.0737 230.713 73.1029 230.676 73.1237C230.724 73.0737 230.69 73.08 230.669 73.0821C230.642 73.0821 230.63 73.0779 230.659 73.0321C230.603 73.0592 230.557 73.055 230.515 73.0488C230.463 73.0425 230.415 73.0259 230.376 73.0072C230.301 72.9697 230.267 72.9115 230.322 72.8408C230.301 72.7929 230.286 72.7909 230.278 72.8158C230.274 72.8262 230.27 72.8491 230.267 72.8657C230.265 72.8824 230.267 72.8969 230.267 72.9136C230.28 72.9822 230.349 73.0259 230.313 73.0072C230.328 73.0384 230.292 73.0363 230.251 72.9968C230.203 72.9573 230.19 72.8803 230.197 72.8075C230.197 72.6702 230.307 72.5704 230.305 72.2251C230.305 72.2605 230.311 72.2625 230.311 72.2958C230.334 72.1669 230.28 72.042 230.317 71.884C230.265 71.7945 230.32 71.678 230.253 71.6531L230.27 71.9713C230.253 71.7924 230.174 71.6219 230.211 71.3244C230.226 71.3473 230.243 71.4368 230.253 71.4971C230.272 71.4097 230.24 71.3307 230.259 71.2392C230.326 71.2662 230.274 71.626 230.326 71.8174C230.355 71.7238 230.276 71.4534 230.349 71.5491C230.259 71.4118 230.353 71.2017 230.297 70.9812L230.336 70.9979C230.332 70.9625 230.317 70.8855 230.326 70.819L230.367 70.9438C230.336 70.7566 230.44 70.5881 230.426 70.3926C230.399 70.7899 230.372 70.4779 230.33 70.6401C230.324 70.4009 230.351 70.3302 230.384 70.2511C230.399 70.2116 230.415 70.1679 230.424 70.0993C230.432 70.0327 230.428 69.9183 230.397 69.7873C230.403 69.8122 230.415 69.8975 230.411 69.9474C230.409 69.9994 230.399 70.0244 230.382 69.962C230.374 69.8372 230.361 69.7207 230.378 69.6625C230.336 69.3442 230.34 69.7166 230.301 69.5834C230.34 69.469 230.267 69.4254 230.253 69.2777H230.295C230.338 68.9012 230.207 69.1716 230.274 68.8284L230.313 68.9802C230.313 68.9199 230.315 68.8596 230.32 68.7993L230.361 68.8429C230.353 68.6453 230.374 68.5829 230.422 68.3937C230.384 68.4332 230.353 68.3541 230.386 68.1815C230.434 68.0692 230.411 68.2564 230.455 68.0088C230.47 68.0692 230.486 68.1357 230.428 68.2356C230.438 68.2501 230.442 68.2938 230.453 68.3084C230.505 68.1898 230.524 67.9922 230.542 67.9028C230.534 67.936 230.524 67.9776 230.513 67.9964C230.52 67.8778 230.528 67.7426 230.524 67.6136C230.547 67.5554 230.553 67.6032 230.559 67.6532C230.565 67.5741 230.553 67.518 230.555 67.4015C230.586 67.4327 230.624 67.4285 230.624 67.597C230.624 67.4701 230.619 67.3412 230.601 67.2122C230.617 67.1872 230.619 67.0042 230.638 67.0541C230.638 67.0021 230.617 66.9231 230.601 66.8752C230.586 66.8295 230.567 66.7816 230.555 66.7317C230.528 66.6319 230.515 66.5175 230.547 66.4155C230.542 66.4031 230.54 66.3802 230.547 66.3344C230.607 66.1389 230.724 65.9974 230.838 65.7603C230.884 65.7333 230.93 65.7042 230.978 65.6792C231.101 65.5086 230.788 65.7915 230.994 65.5066C231.148 65.3027 231.096 65.4691 231.167 65.413C231.23 65.3006 231.338 65.0947 231.542 64.9824C231.492 65.0406 231.444 65.0739 231.394 65.1259L231.398 65.1197ZM233.015 62.9211C232.988 62.9689 232.942 63.0667 232.9 63.0812C232.9 63.0043 232.948 62.9835 233.015 62.9211ZM236.403 61.0282C236.368 61.049 236.309 61.0553 236.239 61.0553C236.287 61.0407 236.341 61.0303 236.403 61.0282ZM242.941 64.1691L242.945 64.1628C243.068 64.0817 243.024 64.1108 242.941 64.1691ZM242.714 64.3001C242.697 64.3168 242.701 64.3209 242.714 64.3209C242.722 64.3043 242.766 64.2752 242.824 64.2419C242.803 64.2419 242.77 64.2544 242.716 64.3001H242.714ZM229.98 72.2605L229.99 72.2126C230.003 72.3208 229.99 72.2896 229.98 72.2605Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.974 61.1882C235.953 61.1882 235.945 61.184 235.939 61.1777C235.914 61.1945 235.914 61.2028 235.974 61.1882Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.553 66.4014V66.408C230.553 66.408 230.553 66.4146 230.557 66.4168L230.553 66.4014Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.006 62.2477C243.968 62.2162 243.947 62.1994 243.937 62.1826C243.928 62.191 243.945 62.2078 244.006 62.2477Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.874 65.2359L241.975 65.1152C241.925 65.1714 241.9 65.186 241.868 65.2088C241.877 65.213 241.908 65.2005 241.874 65.238V65.2359Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M240.821 66.064C240.808 66.0827 240.785 66.0973 240.772 66.116L240.789 66.1264C240.862 66.0578 240.898 65.9975 240.821 66.064Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.671 65.2508C241.637 65.2363 241.556 65.3132 241.466 65.3756L241.483 65.3652C241.48 65.4214 241.574 65.3548 241.671 65.2508Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.449 65.3896L241.4 65.4233C241.386 65.4338 241.369 65.4422 241.354 65.4506C241.35 65.4653 241.371 65.4569 241.405 65.4296C241.417 65.417 241.432 65.4044 241.449 65.3918V65.3896Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.52 64.4872C242.478 64.5184 242.529 64.5413 242.499 64.5538C242.495 64.5912 242.545 64.5184 242.574 64.4643C242.587 64.4414 242.591 64.4269 242.585 64.4248C242.579 64.4248 242.568 64.429 242.52 64.4872Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.524 65.2217L241.583 65.2322C241.594 65.2091 241.602 65.1881 241.611 65.165C241.583 65.186 241.554 65.2049 241.524 65.2217Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.156 64.6222L242.027 64.7408C242.027 64.7408 242.021 64.7636 242.004 64.7844C242.079 64.7075 242.167 64.6264 242.156 64.6201V64.6222Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.004 64.7871C241.964 64.8266 241.929 64.8682 241.912 64.8953C241.933 64.8724 241.977 64.8246 242.004 64.7871Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.691 65.0492L241.735 65.018L241.823 64.9307L241.691 65.0492Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.472 63.4224C243.533 63.3808 243.573 63.3371 243.625 63.3017C243.633 63.2788 243.583 63.2976 243.531 63.3454C243.504 63.3828 243.439 63.4265 243.472 63.4224Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.959 63.6654C242.974 63.603 242.984 63.6051 242.999 63.5802L242.953 63.5469C242.953 63.5843 242.957 63.6238 242.959 63.6654Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.393 63.3183C243.393 63.3183 243.574 63.1353 243.397 63.2705C243.399 63.2913 243.246 63.3703 243.393 63.3183Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.819 61.9872L243.863 62.0059L243.895 61.9248L243.819 61.9872Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.313 61.5466C241.331 61.5591 241.346 61.5653 241.358 61.5716C241.365 61.5737 241.4 61.5882 241.413 61.5924C241.444 61.6007 241.454 61.5965 241.465 61.5924C241.481 61.582 241.504 61.582 241.623 61.609C241.654 61.6007 241.608 61.5924 241.558 61.5799C241.508 61.5674 241.45 61.5445 241.49 61.5466C241.377 61.5217 241.354 61.505 241.327 61.5029C241.304 61.5029 241.298 61.5113 241.313 61.5466Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.489 61.5459C241.519 61.5501 241.55 61.5522 241.58 61.5501C241.531 61.548 241.506 61.5459 241.489 61.5459Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.247 69.1297C236.31 69.1338 236.36 69.1338 236.395 69.1401C236.372 69.1317 236.343 69.1234 236.308 69.1172C236.289 69.1213 236.27 69.1276 236.247 69.1317V69.1297Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.346 68.7142L236.32 68.6533L236.224 68.689C236.257 68.6911 236.322 68.6974 236.346 68.7142Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.354 62.6856V62.6689C233.327 62.6752 233.304 62.7001 233.258 62.7501L233.354 62.6856Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.17 64.2007L232.182 64.1797C232.157 64.1902 232.14 64.186 232.117 64.1944C232.134 64.1944 232.153 64.1965 232.17 64.2007Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M231.14 65.5458C231.186 65.4979 231.228 65.4335 231.276 65.3877C231.186 65.4979 231.082 65.5187 231.14 65.5458Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.625 67.8875C237.494 66.9307 237.238 66.4086 236.773 65.6182C237.173 66.4065 237.421 67.1428 237.344 68.0206",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.55 68.0338C237.55 68.0338 237.582 68.0421 237.588 68.0442C237.582 68.0296 237.54 68.0338 237.55 68.0338Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.478 67.9026L237.493 67.9047L237.457 67.8838L237.478 67.9026Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.482 67.7861C237.422 67.7966 237.491 67.828 237.47 67.8489H237.455L237.503 67.8635C237.497 67.8384 237.463 67.8029 237.482 67.7861Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.616 67.7239C237.592 67.7281 237.594 67.7089 237.607 67.7388C237.609 67.7388 237.611 67.7388 237.613 67.7367C237.613 67.7346 237.613 67.7303 237.613 67.7239H237.616Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.613 67.7355C237.613 67.7483 237.635 67.7269 237.613 67.7355V67.7355Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.601 67.6772L237.622 67.694C237.636 67.6898 237.638 67.6752 237.649 67.6814C237.636 67.6647 237.624 67.6689 237.601 67.6772Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.555 67.6611L237.563 67.6697C237.563 67.6697 237.572 67.6654 237.555 67.6611Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.585 67.6888L237.566 67.6689C237.566 67.6689 237.535 67.6712 237.572 67.6778C237.552 67.6778 237.572 67.68 237.585 67.6888Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.576 67.6982C237.563 67.7087 237.555 67.7192 237.534 67.7024C237.543 67.7338 237.584 67.7296 237.576 67.6982Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.42 67.7773L237.4 67.7906L237.422 67.8016C237.422 67.8016 237.44 67.7773 237.42 67.7773Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.63 67.5713C237.618 67.5713 237.597 67.5776 237.58 67.5797L237.595 67.5922C237.595 67.5922 237.611 67.5734 237.63 67.5713Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.578 67.5806L237.555 67.5635C237.553 67.5806 237.563 67.5827 237.578 67.5806Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.488 67.6585L237.536 67.6878L237.488 67.6543V67.6585Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.627 67.5005L237.656 67.5089L237.61 67.4922L237.627 67.5005Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.619 67.4537C237.644 67.4599 237.661 67.439 237.676 67.4474C237.669 67.4348 237.649 67.4244 237.628 67.416C237.638 67.4265 237.636 67.4369 237.617 67.4537H237.619Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.601 67.4033C237.601 67.4033 237.618 67.4121 237.631 67.4188C237.625 67.4143 237.616 67.4077 237.601 67.4033Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.561 67.5324C237.561 67.5324 237.588 67.5261 237.596 67.5156L237.561 67.524V67.5303V67.5324Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.561 67.5245C237.561 67.5245 237.561 67.5112 237.561 67.5068C237.561 67.5068 237.561 67.5135 237.559 67.5245H237.561Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.52 67.6116C237.499 67.6011 237.476 67.5801 237.446 67.6032C237.472 67.6095 237.488 67.5969 237.52 67.6116Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.515 67.5449L237.507 67.5637C237.507 67.5637 237.53 67.5596 237.54 67.5637L237.515 67.5449Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.505 67.5361L237.516 67.545L237.52 67.5361H237.505Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.569 67.4383C237.553 67.43 237.55 67.4216 237.548 67.4111C237.542 67.4237 237.54 67.4341 237.54 67.4446C237.553 67.4446 237.571 67.4488 237.569 67.4362V67.4383Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.538 67.3115L237.531 67.3139H237.538V67.3115Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.532 67.4485C237.532 67.4485 237.534 67.4617 237.547 67.4661C237.543 67.4595 237.541 67.4529 237.538 67.4463C237.534 67.4463 237.53 67.4463 237.532 67.4485Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.582 67.376C237.582 67.376 237.569 67.3867 237.562 67.3931C237.573 67.3867 237.592 67.3781 237.582 67.376Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.569 67.4765C237.569 67.4765 237.554 67.4701 237.546 67.4658C237.55 67.4701 237.554 67.4744 237.559 67.4786C237.561 67.4786 237.565 67.4765 237.569 67.4744V67.4765Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.303 67.3072C237.336 67.3051 237.37 67.3217 237.336 67.3446C237.363 67.3592 237.472 67.3384 237.533 67.3155C237.518 67.3155 237.503 67.3176 237.483 67.3009C237.466 67.3092 237.445 67.3467 237.412 67.3342C237.391 67.3113 237.422 67.3134 237.437 67.2988C237.397 67.3134 237.372 67.2739 237.311 67.2884L237.334 67.3072C237.334 67.3072 237.309 67.303 237.301 67.3092L237.303 67.3072Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.531 67.349L237.536 67.3574C237.536 67.3574 237.552 67.3407 237.577 67.326C237.559 67.3135 237.546 67.3135 237.536 67.3135V67.3532L237.529 67.3511L237.531 67.349Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.541 67.3933C237.503 67.3891 237.486 67.3723 237.448 67.387C237.452 67.4101 237.48 67.3996 237.497 67.4122C237.484 67.3765 237.518 67.4206 237.537 67.3933C237.543 67.3996 237.545 67.4059 237.547 67.4122C237.551 67.4059 237.555 67.3975 237.562 67.3912H237.56C237.56 67.3912 237.553 67.3933 237.555 67.3912C237.555 67.3912 237.545 67.3912 237.541 67.3912C237.547 67.3807 237.549 67.3891 237.555 67.3912H237.562L237.539 67.3555C237.534 67.3639 237.537 67.3744 237.541 67.3912V67.3933Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.367 67.5866C237.367 67.5866 237.374 67.5866 237.376 67.5866C237.371 67.5844 237.367 67.5844 237.367 67.5866Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.388 67.5701C237.388 67.5701 237.409 67.5743 237.404 67.5827C237.394 67.5911 237.388 67.5827 237.375 67.5827C237.386 67.5869 237.402 67.5995 237.419 67.5827H237.415C237.428 67.5659 237.474 67.5449 237.478 67.547C237.444 67.5533 237.421 67.5575 237.39 67.568L237.388 67.5701Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.457 67.4824L237.436 67.4531L237.404 67.4699H237.423C237.417 67.4845 237.44 67.4803 237.454 67.4824H237.457Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.555 67.3055H237.595L237.538 67.293L237.555 67.3055Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.546 67.2663L237.579 67.2642L237.558 67.2559L237.546 67.2663Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.143 65.8594L237.156 65.8638C237.156 65.8638 237.147 65.8616 237.143 65.8594Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.114 65.8037L237.099 65.8103C237.099 65.8103 237.116 65.8059 237.114 65.8037Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.307 66.3072C237.332 66.2842 237.374 66.2528 237.338 66.2674L237.305 66.2842C237.305 66.2842 237.313 66.2988 237.307 66.3072Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.848 65.7891L236.84 65.7974C236.852 65.7953 236.865 65.7912 236.875 65.7891C236.867 65.7891 236.859 65.7891 236.848 65.7891Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.707 65.8479L236.722 65.8223C236.722 65.8223 236.711 65.8372 236.707 65.8479Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.342 66.1533L237.379 66.1449C237.371 66.1303 237.359 66.1449 237.342 66.1533Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.463 66.8606C237.474 66.846 237.478 66.8355 237.478 66.8271C237.461 66.846 237.432 66.8627 237.463 66.8606Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.79 66.0287C236.79 66.0287 236.807 66.0287 236.813 66.0244C236.805 66.0244 236.796 66.0244 236.79 66.0287Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.469 66.7939C237.469 66.7939 237.465 66.7981 237.463 66.8023C237.471 66.8086 237.478 66.8169 237.478 66.8274C237.49 66.8128 237.496 66.8002 237.469 66.7939Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.754 67.3848C237.754 67.3848 237.75 67.3885 237.746 67.3922C237.754 67.3922 237.754 67.3885 237.754 67.3848Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.449 67.8094C237.449 67.8094 237.444 67.8006 237.444 67.7939C237.442 67.7961 237.444 67.8006 237.449 67.8094Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.525 67.1167C237.525 67.1167 237.532 67.1079 237.534 67.1035C237.532 67.1057 237.528 67.1101 237.525 67.1167Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.542 67.1123C237.542 67.1123 237.542 67.1187 237.54 67.1208C237.546 67.1208 237.551 67.1208 237.542 67.1123Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.536 67.0889C237.536 67.0889 237.536 67.0999 237.536 67.1043C237.538 67.1021 237.54 67.0999 237.543 67.1021C237.543 67.0999 237.543 67.0955 237.538 67.0889H237.536Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.465 66.75H237.463C237.48 66.7566 237.478 66.7522 237.465 66.75Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.874 66.2478H236.878L236.881 66.2441L236.874 66.2478Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.838 66.2297C236.886 66.2235 236.882 66.2318 236.878 66.2443L236.972 66.1943L236.838 66.2297Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.226 65.9907L237.244 65.9574C237.305 65.9533 237.296 65.9803 237.328 65.9408C237.226 65.9928 237.278 65.8742 237.176 65.9262L237.19 65.9034C237.19 65.9034 237.196 65.9034 237.198 65.9096C237.234 65.8597 237.115 65.9325 237.113 65.895C237.113 65.8805 237.126 65.8638 237.142 65.8659L237.105 65.8555C237.105 65.8555 237.121 65.8389 237.123 65.8472L237.096 65.816H237.098C237.08 65.8181 237.049 65.8202 237.036 65.8202C237.044 65.8035 237.048 65.8202 237.061 65.8098L237.026 65.8035C237.046 65.7806 237.082 65.7827 237.086 65.7994C237.176 65.7245 237.051 65.7994 237.086 65.7245L237.109 65.7349C237.159 65.6912 237.13 65.687 237.153 65.6475C237.138 65.6642 237.088 65.7411 237.051 65.7328C237.055 65.7224 237.055 65.712 237.028 65.712C237.063 65.6912 237.049 65.685 237.038 65.6725L237.086 65.6454C237.063 65.6371 237.04 65.6538 237.015 65.6558C237.011 65.6371 237.044 65.6122 237.074 65.5914C237.065 65.5602 237.026 65.6434 236.999 65.6163C237.003 65.583 236.976 65.5789 236.932 65.5685C236.938 65.5435 236.963 65.5539 236.971 65.5414L236.926 65.5498C236.926 65.5498 236.936 65.5394 236.942 65.5373C236.926 65.5352 236.905 65.5539 236.884 65.556L236.655 65.6808C236.655 65.6808 236.663 65.6808 236.667 65.6829C236.724 65.6621 236.609 65.7598 236.68 65.7515C236.669 65.764 236.649 65.764 236.63 65.7744C236.686 65.7869 236.672 65.7869 236.738 65.7869L236.717 65.8243C236.746 65.791 236.801 65.789 236.844 65.791C236.859 65.7765 236.871 65.764 236.878 65.7578L236.917 65.7744C236.917 65.7744 236.892 65.7869 236.869 65.791H236.884C236.871 65.8098 236.84 65.8181 236.809 65.8243L236.834 65.7994C236.801 65.8056 236.765 65.816 236.736 65.8306C236.742 65.8306 236.749 65.8306 236.755 65.8347C236.747 65.8347 236.738 65.8389 236.734 65.843C236.73 65.8472 236.742 65.843 236.757 65.843L236.705 65.8763L236.728 65.868L236.711 65.9221C236.778 65.9221 236.871 65.9096 236.915 65.9429C236.869 65.9512 236.849 65.9699 236.801 65.9928C236.846 65.9574 236.763 65.9699 236.763 65.9429C236.763 65.9574 236.74 65.9658 236.73 65.9658L236.794 65.9845C236.755 66.0011 236.769 66.0074 236.757 66.024C236.83 65.9803 236.821 66.0302 236.853 66.0365C236.828 66.049 236.799 66.0573 236.796 66.0344C236.749 66.0822 236.901 66.0219 236.861 66.0656C236.859 66.0614 236.861 66.0573 236.846 66.0614C236.876 66.0614 236.869 66.0989 236.842 66.101V66.0968C236.844 66.1322 236.882 66.1966 236.951 66.1738C236.942 66.1779 236.869 66.2029 236.855 66.207L237.105 66.1738C237.044 66.1925 236.917 66.2674 236.874 66.2528C236.869 66.2632 236.863 66.2778 236.89 66.2861C236.896 66.2778 236.967 66.2403 236.976 66.2445C236.919 66.2903 236.946 66.2715 236.903 66.3194C236.911 66.3069 237.007 66.2798 237.009 66.2944C236.994 66.2986 236.919 66.3298 236.909 66.3298H237.011C236.992 66.3256 236.936 66.3547 236.913 66.3714C236.93 66.361 236.921 66.3984 236.934 66.4047L236.949 66.3838C236.949 66.4234 237.088 66.3714 237.096 66.4109C237.076 66.413 236.978 66.4421 236.974 66.4629C237.021 66.4546 237.209 66.4213 237.255 66.4421L237.23 66.4567L237.269 66.4712C237.194 66.4775 237.032 66.4858 236.967 66.4837C236.951 66.5045 236.938 66.4983 236.946 66.517C236.924 66.5315 236.905 66.5191 236.901 66.5149V66.5669C236.955 66.5461 236.967 66.5835 237.011 66.5669L236.938 66.5357C236.99 66.5149 237.103 66.5128 237.103 66.5503C237.084 66.5669 237.005 66.5752 236.986 66.5815C237.007 66.5815 237.032 66.6023 237.019 66.6085L236.986 66.6043C236.971 66.6293 237.067 66.6106 237.024 66.6501C237.024 66.6584 236.961 66.6938 236.992 66.6855C237.051 66.6543 237.242 66.5919 237.292 66.5856C237.288 66.5898 237.246 66.6459 237.217 66.6647C237.171 66.6917 237.094 66.6792 237.057 66.7021C237.071 66.6979 237.092 66.7 237.098 66.7021C237.088 66.7146 237.051 66.7125 237.063 66.7271C237.119 66.7146 237.069 66.7645 237.113 66.7229C237.134 66.7354 237.107 66.7437 237.113 66.7645C237.146 66.7479 237.24 66.7499 237.263 66.7645C237.248 66.7666 237.232 66.777 237.223 66.7811C237.228 66.8186 237.207 66.8456 237.215 66.8789C237.203 66.8851 237.19 66.9059 237.163 66.9039C237.173 66.9059 237.194 66.9059 237.198 66.9163C237.155 66.9475 237.186 66.8955 237.13 66.9247C237.163 66.9184 237.182 66.9413 237.205 66.9517C237.255 66.9351 237.205 66.9143 237.182 66.9039C237.251 66.8872 237.332 66.8976 237.371 66.9267C237.394 66.9538 237.328 66.9496 237.34 66.9517C237.34 67.0099 237.471 66.9746 237.432 67.0307C237.39 67.0578 237.342 67.0474 237.311 67.0578C237.29 67.037 237.332 67.0162 237.328 66.9995L237.311 67.0245C237.294 67.0203 237.28 67.0058 237.292 66.9954C237.255 67.0183 237.305 67.089 237.271 67.1368C237.288 67.141 237.305 67.1514 237.323 67.1431L237.315 67.1306C237.348 67.1119 237.369 67.1472 237.384 67.1285C237.413 67.1431 237.455 67.1576 237.44 67.1867L237.39 67.1992C237.405 67.1971 237.417 67.1784 237.4 67.1722C237.425 67.1805 237.336 67.2221 237.407 67.2242L237.44 67.2013C237.469 67.2159 237.528 67.2325 237.513 67.2575C237.563 67.2408 237.507 67.2533 237.565 67.2283C237.494 67.2533 237.561 67.1659 237.486 67.2013C237.553 67.1743 237.511 67.168 237.565 67.1368C237.548 67.141 237.534 67.1493 237.54 67.1285C237.536 67.1285 237.528 67.1285 237.525 67.1285C237.521 67.1285 237.523 67.1285 237.525 67.1285C237.519 67.1347 237.511 67.1389 237.5 67.1431C237.461 67.1389 237.457 67.1077 237.434 67.1015C237.44 67.089 237.455 67.1015 237.471 67.0931L237.438 67.0827C237.475 67.0744 237.494 67.0411 237.521 67.064V67.0391C237.536 67.0203 237.54 66.9995 237.521 66.9891C237.528 66.9767 237.473 66.9683 237.505 66.9725L237.473 66.9392H237.482C237.48 66.8976 237.403 66.8727 237.459 66.8144C237.446 66.804 237.432 66.7936 237.438 66.7687L237.469 66.7562C237.455 66.7416 237.488 66.6979 237.453 66.7C237.534 66.6584 237.448 66.6147 237.457 66.5815L237.415 66.5919C237.411 66.5711 237.394 66.5565 237.369 66.5378L237.334 66.5503C237.298 66.5399 237.342 66.4899 237.33 66.4587C237.344 66.4567 237.344 66.465 237.336 66.4754C237.405 66.4088 237.248 66.4151 237.296 66.3589C237.28 66.3547 237.282 66.3464 237.29 66.3381C237.29 66.3381 237.29 66.3381 237.292 66.3381C237.292 66.3381 237.292 66.336 237.292 66.3339C237.296 66.3277 237.303 66.3215 237.307 66.3152C237.298 66.3215 237.294 66.3277 237.292 66.3318C237.29 66.3256 237.282 66.3173 237.269 66.311L237.307 66.2923C237.317 66.2778 237.286 66.2923 237.259 66.3069C237.251 66.3048 237.242 66.3027 237.232 66.3027C237.29 66.2715 237.201 66.2861 237.263 66.2486C237.228 66.2549 237.219 66.2091 237.151 66.2299C237.159 66.2258 237.163 66.2216 237.165 66.2258C237.169 66.2112 237.171 66.1987 237.148 66.1966L237.194 66.1738H237.119C237.142 66.1509 237.157 66.1384 237.201 66.1363C237.13 66.1259 237.167 66.1176 237.098 66.1114L237.13 66.0989C237.13 66.0989 237.076 66.0906 237.098 66.0739C237.148 66.0261 237.057 65.9574 237.086 65.8742C237.001 65.9262 237.113 65.8285 237.042 65.8576C237.061 65.8451 237.069 65.8306 237.092 65.8326C237.057 65.8118 237.105 65.7723 237.036 65.7786C237.055 65.7661 237.069 65.7702 237.082 65.7619C237.076 65.7619 237.059 65.7619 237.069 65.7515C237.08 65.7432 237.088 65.7474 237.101 65.7474C237.082 65.7182 237.015 65.7474 236.955 65.7744C236.976 65.7453 236.969 65.739 236.924 65.7474C236.94 65.7328 236.957 65.7141 236.974 65.7286C236.974 65.7162 236.971 65.6496 236.921 65.6725C236.932 65.6642 236.917 65.6558 236.911 65.6558C236.903 65.6309 236.905 65.6267 236.89 65.6059L236.886 65.6163C236.824 65.6371 236.863 65.6038 236.846 65.5893H236.853V65.5851L236.697 65.6704V65.6787C236.697 65.6829 236.697 65.685 236.697 65.687C236.697 65.6912 236.697 65.6954 236.697 65.6974C236.697 65.7016 236.701 65.7037 236.705 65.7037C236.711 65.7037 236.717 65.7078 236.705 65.7411L236.738 65.7182C236.815 65.6787 236.713 65.7786 236.757 65.7848L236.771 65.764C236.805 65.7619 236.688 65.8576 236.686 65.8763C236.682 65.8826 236.674 65.8763 236.665 65.8763C236.64 65.9346 236.713 65.8534 236.738 65.8722C236.715 65.8909 236.672 65.9034 236.676 65.9221C236.661 65.9408 236.784 65.9221 236.749 65.9741C236.765 65.9574 236.782 65.9429 236.803 65.945C236.819 65.9595 236.757 66.0323 236.826 66.0157C236.821 66.0198 236.817 66.024 236.813 66.0282C236.836 66.0323 236.863 66.0573 236.901 66.0469C236.784 66.1259 237.007 66.0989 236.892 66.1592L236.921 66.1966L236.909 66.2008C236.915 66.232 236.949 66.2258 236.98 66.2216C236.976 66.232 236.963 66.232 236.957 66.2362C236.953 66.2882 236.961 66.2882 237.034 66.2923L236.999 66.3152C237.026 66.3152 236.969 66.4005 237.03 66.4171C237.026 66.4171 237.017 66.4213 237.011 66.4213C237.078 66.4442 236.955 66.5731 237.101 66.5253L237.148 66.5378C237.142 66.4941 237.211 66.517 237.228 66.4899C237.242 66.5024 237.203 66.5482 237.188 66.5315L237.194 66.5253C237.119 66.5503 237.19 66.5835 237.14 66.6043C237.176 66.6771 237.165 66.7666 237.186 66.8373L237.24 66.8082L237.246 66.8331C237.236 66.8456 237.205 66.8581 237.201 66.8394C237.171 66.8602 237.24 66.8581 237.253 66.8539C237.242 66.8976 237.18 66.8643 237.182 66.8768L237.192 66.8893L237.198 66.8831C237.226 66.8851 237.253 66.8789 237.257 66.8997C237.251 66.9163 237.223 66.9184 237.223 66.9247C237.219 66.9247 237.217 66.9288 237.223 66.933L237.23 66.9663L237.271 66.9371C237.298 66.9434 237.28 66.9683 237.328 66.9371C237.255 66.985 237.336 67.064 237.315 67.0848C237.355 67.0952 237.361 67.1139 237.363 67.1389C237.371 67.1306 237.423 67.1119 237.423 67.1347C237.311 67.1576 237.386 67.1867 237.313 67.2242C237.361 67.1951 237.342 67.2803 237.411 67.2367C237.407 67.2575 237.369 67.2491 237.348 67.2679C237.403 67.2991 237.342 67.3656 237.369 67.4135C237.384 67.4114 237.405 67.3968 237.428 67.4031L237.361 67.4468C237.361 67.4468 237.446 67.4384 237.4 67.4675C237.413 67.4613 237.43 67.4551 237.436 67.4613C237.386 67.5778 237.536 67.6631 237.417 67.79C237.444 67.7712 237.448 67.7796 237.45 67.79C237.457 67.7816 237.488 67.7837 237.507 67.7796L237.459 67.8316C237.515 67.8316 237.469 67.8794 237.523 67.8752L237.511 67.8628C237.575 67.8732 237.646 67.817 237.727 67.8066C237.653 67.7962 237.825 67.7338 237.717 67.713C237.732 67.7026 237.744 67.7151 237.763 67.7088C237.727 67.7047 237.719 67.6964 237.73 67.6735H237.738C237.719 67.6194 237.748 67.5882 237.761 67.5216L237.721 67.5341C237.723 67.5196 237.736 67.5133 237.744 67.505C237.682 67.5008 237.748 67.5445 237.68 67.5424C237.757 67.5092 237.661 67.4467 237.75 67.4155C237.746 67.3947 237.707 67.4322 237.702 67.4093L237.725 67.3989H237.692C237.694 67.3864 237.723 67.3719 237.744 67.3677C237.744 67.3719 237.752 67.376 237.755 67.3802C237.78 67.3552 237.734 67.3324 237.742 67.324L237.732 67.3469C237.694 67.2949 237.711 67.2159 237.646 67.1743L237.63 67.1826C237.584 67.1493 237.64 67.1431 237.613 67.1015H237.617C237.596 67.0973 237.584 67.089 237.582 67.0744C237.607 67.0807 237.617 67.0411 237.644 67.0495C237.594 67.0141 237.609 67.0349 237.532 67.0266L237.559 67.0099C237.528 67.0099 237.513 67.0099 237.498 66.9912C237.53 67.0016 237.54 66.9621 237.58 66.9725C237.63 66.9039 237.492 66.9226 237.58 66.8706C237.49 66.8768 237.548 66.9267 237.525 66.9205C237.503 66.9392 237.457 66.9226 237.461 66.9059C237.457 66.8914 237.559 66.8456 237.542 66.8082C237.542 66.8123 237.548 66.8082 237.55 66.8144C237.567 66.7936 237.513 66.7957 237.54 66.7666C237.488 66.7749 237.534 66.7437 237.471 66.7624L237.498 66.7915C237.475 66.777 237.394 66.7874 237.417 66.7416C237.432 66.7395 237.45 66.7416 237.463 66.7458C237.478 66.7291 237.444 66.7333 237.459 66.7146C237.523 66.6938 237.488 66.752 237.544 66.7541C237.567 66.7333 237.484 66.7312 237.557 66.7167C237.465 66.7333 237.553 66.6751 237.478 66.6751L237.515 66.6626C237.515 66.6626 237.486 66.6584 237.484 66.6522L237.538 66.6459C237.488 66.6418 237.559 66.5919 237.528 66.5794C237.546 66.621 237.486 66.6064 237.465 66.6355C237.394 66.6043 237.55 66.5669 237.509 66.517C237.517 66.5232 237.498 66.5544 237.475 66.5503C237.48 66.5357 237.488 66.517 237.505 66.5003C237.482 66.465 237.469 66.5232 237.44 66.5149C237.48 66.4837 237.415 66.5045 237.392 66.4941L237.43 66.4775C237.434 66.4255 237.346 66.5003 237.359 66.4504L237.417 66.4442L237.394 66.4296L237.438 66.415C237.396 66.4067 237.403 66.3963 237.405 66.3714C237.38 66.388 237.336 66.3984 237.326 66.3818C237.342 66.3589 237.365 66.3714 237.346 66.3485C237.373 66.3443 237.405 66.336 237.375 66.363C237.388 66.3589 237.4 66.3589 237.413 66.3547C237.432 66.3298 237.403 66.3173 237.398 66.309C237.398 66.3131 237.398 66.3194 237.394 66.3235L237.326 66.309C237.336 66.2965 237.351 66.2965 237.363 66.2944C237.355 66.2882 237.336 66.2923 237.328 66.2819C237.359 66.2694 237.39 66.2549 237.411 66.2653L237.361 66.2445C237.373 66.2362 237.388 66.2091 237.4 66.207C237.409 66.1779 237.319 66.1862 237.328 66.1488C237.321 66.1488 237.315 66.1488 237.307 66.1488C237.301 66.1218 237.326 66.0802 237.271 66.0718L237.315 66.0282C237.29 66.0115 237.261 66.0843 237.221 66.0573C237.19 66.0406 237.261 66.024 237.271 66.0074C237.238 66.0074 237.171 66.0136 237.201 65.9678C237.215 65.9699 237.211 65.9803 237.217 65.9866L237.226 65.9907ZM237.051 65.7307C237.061 65.7307 237.09 65.7307 237.071 65.7453C237.028 65.7619 237.044 65.7453 237.051 65.7307ZM236.794 65.8638C236.78 65.8638 236.784 65.8576 236.794 65.843C236.801 65.8472 236.801 65.8534 236.794 65.8638ZM237.488 67.0141H237.486C237.498 66.9975 237.494 67.0037 237.488 67.0141ZM237.475 67.0453C237.475 67.0453 237.488 67.0453 237.492 67.0453C237.482 67.0453 237.48 67.0391 237.482 67.0307C237.471 67.0349 237.465 67.0391 237.475 67.0474V67.0453ZM237.232 66.9247L237.24 66.9163C237.255 66.9226 237.244 66.9247 237.232 66.9247Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.724 65.8409C236.724 65.8409 236.736 65.8324 236.743 65.8281C236.736 65.8281 236.728 65.8324 236.724 65.8409Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.336 66.1533V66.1557L237.343 66.1533H237.336Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.042 66.711C237.042 66.711 237.053 66.6978 237.059 66.6934C237.049 66.6956 237.042 66.7022 237.042 66.711Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.572 67.187L237.559 67.1699C237.559 67.1699 237.555 67.1827 237.549 67.1891C237.559 67.1891 237.572 67.1827 237.574 67.1891L237.572 67.187Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.338 67.3745C237.338 67.3745 237.338 67.3809 237.344 67.3831H237.363C237.361 67.3703 237.344 67.3639 237.338 67.3745Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.438 67.2217C237.405 67.228 237.417 67.2384 237.425 67.2489C237.474 67.2447 237.457 67.2321 237.44 67.2217H237.438Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.428 67.2529C237.428 67.2529 237.432 67.2618 237.43 67.2662C237.45 67.2662 237.434 67.2595 237.428 67.2529Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.507 67.0789C237.507 67.0789 237.551 67.0747 237.538 67.081C237.582 67.081 237.479 67.0496 237.507 67.0789Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.327 67.2469L237.369 67.2365L237.333 67.2344L237.327 67.2469Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.344 67.1449L237.336 67.1663C237.336 67.1663 237.349 67.1663 237.351 67.1684C237.351 67.1556 237.357 67.1406 237.344 67.1428V67.1449Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.351 67.1699C237.351 67.1699 237.351 67.1831 237.361 67.1854C237.361 67.1809 237.357 67.1743 237.351 67.1699Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.311 67.2225L237.319 67.2161V67.2012L237.311 67.2225Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.313 66.9329L237.296 66.9141C237.282 66.9141 237.273 66.9224 237.282 66.9287C237.292 66.9308 237.3 66.9392 237.313 66.9329Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.211 67.0205C237.211 67.0205 237.228 67.01 237.241 67.0059L237.188 67.0163L237.211 67.0226V67.0205Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.189 66.9642C237.174 66.9642 237.14 66.9433 237.149 66.9684C237.163 66.9684 237.18 66.9851 237.189 66.9642Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.171 66.6382L237.173 66.6424L237.257 66.6172L237.171 66.6382Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.888 66.4397C236.877 66.4691 236.94 66.4271 236.924 66.4565C236.945 66.4565 236.938 66.4313 236.957 66.4313C236.932 66.425 236.94 66.4124 236.89 66.4397H236.888Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.955 66.4316C236.955 66.4316 236.964 66.4316 236.97 66.4338C236.964 66.4316 236.959 66.4316 236.955 66.4316Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.414 67.873L237.396 67.8929L237.425 67.8775L237.414 67.873Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.48 67.8936L237.426 67.904H237.476C237.476 67.904 237.468 67.8977 237.48 67.8936Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.126 65.6348L237.113 65.641C237.103 65.6515 237.103 65.6536 237.105 65.662L237.126 65.6348Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.201 65.8538V65.8496L237.159 65.8789L237.201 65.8538Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.349 65.9905C237.349 65.9905 237.332 65.98 237.33 65.9717C237.347 65.9821 237.294 66.0219 237.349 65.9905Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.316 68.0695C236.974 67.069 236.589 66.5614 235.925 65.8105C236.52 66.5739 236.939 67.3123 237.041 68.2712",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.247 68.2418C237.247 68.2418 237.281 68.2418 237.287 68.2439C237.277 68.2314 237.239 68.2439 237.247 68.2418Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.149 68.1172H237.164L237.126 68.1025L237.149 68.1172Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.13 67.9902C237.072 68.0132 237.147 68.0342 237.13 68.0592L237.118 68.0655H237.168C237.155 68.0425 237.118 68.0111 237.13 67.9902Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.248 67.8994C237.224 67.908 237.224 67.8887 237.243 67.9165C237.245 67.9165 237.248 67.9144 237.25 67.9122C237.25 67.9101 237.25 67.9058 237.25 67.8994H237.248Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.247 67.9139C237.251 67.9267 237.266 67.901 237.247 67.9139V67.9139Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.222 67.8529L237.247 67.8675C237.259 67.8613 237.259 67.8445 237.27 67.8487C237.255 67.832 237.243 67.8383 237.222 67.855V67.8529Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.177 67.8447L237.188 67.8535C237.188 67.8535 237.194 67.8469 237.177 67.8447Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.21 67.8683L237.187 67.8516C237.187 67.8516 237.157 67.8599 237.195 67.8599C237.176 67.8599 237.195 67.862 237.21 67.8683Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.204 67.8799C237.193 67.8924 237.187 67.9071 237.162 67.8924C237.177 67.9238 237.216 67.9113 237.204 67.8799Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.069 67.9951L237.054 68.0122L237.077 68.0207C237.067 68.0165 237.09 67.993 237.071 67.9972L237.069 67.9951Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.229 67.7344C237.216 67.7344 237.197 67.749 237.181 67.7532L237.197 67.7636C237.197 67.7636 237.21 67.7406 237.229 67.7344Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.181 67.7542L237.155 67.7393C237.155 67.7585 237.168 67.7585 237.181 67.7542Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.11 67.8559L237.162 67.8789L237.107 67.8496L237.11 67.8559Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.212 67.6596L237.246 67.6638L237.195 67.6533L237.212 67.6596Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.195 67.6121C237.222 67.6121 237.233 67.5891 237.25 67.5954C237.241 67.5829 237.218 67.5766 237.197 67.5703C237.21 67.5787 237.212 67.5912 237.197 67.6121H237.195Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.164 67.5596C237.164 67.5596 237.183 67.5658 237.195 67.57C237.189 67.5658 237.179 67.5617 237.164 67.5596Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.153 67.7038C237.153 67.7038 237.181 67.6933 237.185 67.6787L237.151 67.6954V67.7038H237.153Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.152 67.6983C237.152 67.6983 237.152 67.6829 237.149 67.6807C237.149 67.6829 237.149 67.6873 237.149 67.6983H237.152Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.131 67.7989C237.108 67.7926 237.083 67.7737 237.058 67.8031C237.083 67.8052 237.098 67.7884 237.131 67.7989Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.112 67.7266L237.107 67.7496C237.107 67.7496 237.13 67.7391 237.141 67.7433L237.112 67.7266Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.1 67.72L237.113 67.7266L237.115 67.7178L237.1 67.72Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.141 67.6042C237.124 67.6 237.12 67.5896 237.113 67.5791C237.109 67.5937 237.109 67.6063 237.113 67.6167C237.124 67.6167 237.147 67.6167 237.141 67.6021V67.6042Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.083 67.4727L237.076 67.4774L237.083 67.475V67.4727Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.107 67.6223C237.103 67.6329 237.114 67.6351 237.124 67.6393C237.118 67.6329 237.114 67.6265 237.111 67.6201C237.107 67.6201 237.103 67.6201 237.105 67.6244L237.107 67.6223Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.141 67.5352C237.141 67.5352 237.13 67.5501 237.126 67.5565C237.137 67.548 237.152 67.5352 237.141 67.5352Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.15 67.6431C237.15 67.6431 237.133 67.6389 237.124 67.6367C237.128 67.641 237.133 67.6453 237.139 67.6495C237.141 67.6495 237.145 67.6453 237.147 67.6431H237.15Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.852 67.5123C236.885 67.504 236.921 67.5165 236.891 67.5456C236.921 67.556 237.023 67.5123 237.077 67.4769C237.063 67.4811 237.05 67.4853 237.025 67.4707C237.011 67.4832 236.998 67.5269 236.962 67.5185C236.937 67.4977 236.967 67.4936 236.981 67.4769C236.944 67.4998 236.912 67.4624 236.856 67.4873L236.883 67.5019C236.883 67.5019 236.856 67.5019 236.85 67.5102L236.852 67.5123Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.087 67.5166L237.093 67.5229C237.095 67.5124 237.106 67.502 237.129 67.4811C237.108 67.4727 237.095 67.4727 237.085 67.4748L237.093 67.5166H237.087Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.104 67.5604C237.066 67.5646 237.047 67.5478 237.012 67.5709C237.02 67.594 237.045 67.5793 237.064 67.5898C237.045 67.552 237.087 67.5961 237.1 67.5604C237.108 67.5667 237.113 67.573 237.115 67.5793C237.117 67.5709 237.121 67.5625 237.125 67.5541C237.125 67.5541 237.119 67.5583 237.121 67.5541C237.121 67.5541 237.111 67.5541 237.106 67.5541C237.111 67.5415 237.115 67.5499 237.121 67.5541H237.127L237.096 67.5205C237.096 67.5205 237.096 67.5394 237.106 67.5583L237.104 67.5604Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.975 67.799C236.975 67.799 236.981 67.7969 236.983 67.7969C236.979 67.7969 236.975 67.7969 236.975 67.799Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.993 67.7783C236.993 67.7783 237.014 67.7783 237.012 67.7888C237.003 67.7993 236.995 67.793 236.982 67.7951C236.993 67.7993 237.012 67.8077 237.027 67.7867H237.02C237.029 67.7657 237.069 67.7363 237.075 67.7363C237.043 67.7489 237.022 67.7573 236.993 67.7762V67.7783Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.042 67.6727L237.016 67.6455L236.989 67.6706L237.008 67.6643C237.006 67.6852 237.027 67.6748 237.042 67.6727Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.099 67.4646L237.137 67.4583L237.08 67.4541L237.099 67.4646Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.083 67.4227L237.114 67.4143L237.091 67.4102L237.083 67.4227Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.317 65.9502L236.302 65.9612C236.302 65.9612 236.317 65.9546 236.317 65.9502Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.627 66.4474C236.645 66.4181 236.679 66.3784 236.647 66.4014L236.618 66.4244C236.629 66.4307 236.629 66.439 236.627 66.4474Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.041 65.9768L236.035 65.9873C236.048 65.9831 236.058 65.9789 236.068 65.9727C236.06 65.9727 236.052 65.9747 236.041 65.9768Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.914 66.0605L235.922 66.0312C235.922 66.0312 235.916 66.048 235.914 66.0605Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.631 66.2788L236.668 66.2642C236.658 66.2495 236.648 66.2683 236.631 66.2788Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.908 67.0074C236.916 66.9906 236.916 66.9781 236.914 66.9697C236.901 66.9927 236.876 67.0157 236.908 67.0074Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.043 66.2351C236.043 66.2351 236.06 66.233 236.066 66.2266C236.058 66.2266 236.049 66.2266 236.043 66.2351Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.902 66.9355C236.902 66.9355 236.897 66.9418 236.897 66.946C236.908 66.9523 236.916 66.9586 236.918 66.969C236.929 66.9523 236.931 66.9355 236.904 66.9355H236.902Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.328 67.5098C237.328 67.5098 237.328 67.5135 237.324 67.5172C237.332 67.5172 237.332 67.5135 237.328 67.5098Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.125 68.0164C237.125 68.0164 237.118 68.0076 237.116 68.001C237.116 68.0054 237.116 68.0098 237.125 68.0164Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.919 67.3418C236.919 67.3418 236.908 67.3418 236.899 67.3439C236.908 67.3418 236.914 67.3418 236.919 67.3418Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.028 67.2693C237.028 67.2693 237.033 67.2583 237.035 67.2539C237.035 67.2561 237.03 67.2627 237.028 67.2693Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.043 67.2607C237.043 67.2607 237.043 67.2672 237.043 67.2693C237.049 67.2693 237.054 67.265 237.043 67.2607Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.032 67.2373C237.032 67.2373 237.035 67.2483 237.032 67.2549C237.032 67.2527 237.037 67.2505 237.037 67.2505C237.037 67.2483 237.032 67.2439 237.03 67.2373H237.032Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.897 66.8857C236.897 66.8857 236.897 66.8857 236.897 66.8901C236.917 66.8901 236.913 66.8879 236.897 66.8857Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.179 66.4565H236.184V66.4512L236.179 66.4565Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.139 66.443C236.185 66.4284 236.185 66.4388 236.18 66.4513L236.264 66.3848L236.139 66.443Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.474 66.1269L236.485 66.0873C236.545 66.0749 236.543 66.1019 236.566 66.0561C236.474 66.1269 236.499 65.9937 236.41 66.0645L236.418 66.0374C236.418 66.0374 236.427 66.0374 236.429 66.0416C236.451 65.9833 236.352 66.079 236.339 66.0395C236.339 66.0229 236.345 66.0062 236.36 66.0041L236.32 66C236.32 66 236.333 65.9813 236.337 65.9896L236.302 65.9605H236.304C236.285 65.9646 236.256 65.9729 236.241 65.975C236.245 65.9563 236.254 65.9709 236.264 65.9605H236.227C236.243 65.9334 236.279 65.9293 236.285 65.9459C236.358 65.8544 236.249 65.9501 236.268 65.8689L236.295 65.8773C236.335 65.8232 236.306 65.8253 236.318 65.7774C236.306 65.7961 236.274 65.8835 236.235 65.8835C236.235 65.8731 236.235 65.8627 236.206 65.8669C236.237 65.8398 236.22 65.8357 236.206 65.8232L236.247 65.7878C236.222 65.7837 236.204 65.8024 236.177 65.8107C236.166 65.792 236.195 65.7608 236.218 65.7337C236.202 65.7025 236.183 65.7961 236.15 65.7712C236.147 65.7358 236.116 65.7358 236.07 65.7317C236.07 65.7046 236.097 65.7129 236.104 65.6963L236.06 65.7109C236.06 65.7109 236.068 65.6984 236.075 65.6963C236.056 65.6963 236.039 65.7192 236.02 65.7233L235.82 65.8897C235.82 65.8897 235.829 65.8897 235.833 65.8897C235.883 65.8585 235.791 65.9792 235.862 65.9605C235.854 65.975 235.833 65.9771 235.818 65.9917C235.877 65.9958 235.864 65.9979 235.931 65.9875L235.918 66.0312C235.939 65.9917 235.993 65.9813 236.037 65.9771C236.05 65.9605 236.058 65.9438 236.062 65.9355L236.106 65.948C236.106 65.948 236.085 65.9646 236.062 65.9729H236.077C236.068 65.9937 236.039 66.0062 236.01 66.0166C236.016 66.0062 236.022 65.9958 236.029 65.9854C235.997 65.9979 235.962 66.0125 235.939 66.0333C235.945 66.0333 235.952 66.0333 235.958 66.0333C235.95 66.0374 235.941 66.0395 235.939 66.0437C235.935 66.0478 235.947 66.0437 235.962 66.0395L235.918 66.0811L235.939 66.0686L235.935 66.1289C236.004 66.1185 236.093 66.0894 236.145 66.1185C236.102 66.1331 236.085 66.1581 236.041 66.1893C236.079 66.1456 235.997 66.1705 235.991 66.1414C235.995 66.156 235.972 66.1685 235.964 66.1705L236.033 66.1789C235.997 66.2038 236.012 66.2059 236.006 66.2267C236.07 66.1705 236.072 66.2225 236.106 66.2246C236.083 66.2413 236.056 66.2558 236.047 66.2309C236.01 66.2891 236.15 66.2017 236.118 66.2537C236.114 66.2496 236.116 66.2433 236.104 66.2496C236.133 66.2454 236.135 66.2849 236.11 66.2933L236.106 66.2891C236.12 66.3265 236.17 66.3869 236.235 66.3515C236.227 66.3577 236.16 66.3952 236.145 66.4014L236.387 66.3265C236.331 66.3557 236.22 66.4555 236.174 66.4472C236.172 66.4597 236.17 66.4742 236.199 66.4784C236.204 66.468 236.266 66.416 236.277 66.4201C236.231 66.4784 236.254 66.4534 236.22 66.5096C236.227 66.495 236.314 66.4513 236.32 66.4659C236.306 66.4721 236.239 66.5179 236.229 66.52L236.329 66.5013C236.31 66.5013 236.26 66.5429 236.241 66.5637C236.256 66.5512 236.256 66.5907 236.27 66.5949L236.281 66.5699C236.291 66.6115 236.416 66.5345 236.435 66.5741C236.416 66.5803 236.324 66.6261 236.324 66.649C236.37 66.6323 236.549 66.5657 236.601 66.5803L236.581 66.6011L236.622 66.6115C236.549 66.6302 236.389 66.6656 236.324 66.6739C236.314 66.6989 236.297 66.6947 236.312 66.7134C236.293 66.7342 236.27 66.7218 236.266 66.7176L236.279 66.7717C236.327 66.7405 236.349 66.7779 236.389 66.753L236.308 66.7322C236.356 66.701 236.466 66.6802 236.477 66.7197C236.462 66.7384 236.385 66.7633 236.368 66.7737C236.387 66.7675 236.418 66.7883 236.408 66.7966H236.372C236.364 66.8258 236.456 66.7904 236.42 66.8403C236.42 66.8507 236.368 66.8986 236.399 66.884C236.449 66.8403 236.626 66.7426 236.674 66.7301C236.672 66.7342 236.643 66.8029 236.618 66.8258C236.579 66.8632 236.499 66.8611 236.466 66.8923C236.481 66.8861 236.501 66.884 236.508 66.884C236.499 66.8986 236.464 66.9027 236.479 66.9173C236.531 66.8944 236.493 66.9568 236.526 66.9027C236.549 66.9131 236.526 66.9277 236.539 66.9464C236.568 66.9235 236.662 66.909 236.687 66.9194C236.672 66.9256 236.658 66.9381 236.651 66.9422C236.666 66.9818 236.651 67.013 236.666 67.0483C236.656 67.0566 236.647 67.0816 236.62 67.0837C236.633 67.0837 236.651 67.0816 236.658 67.092C236.622 67.1336 236.639 67.0712 236.593 67.1107C236.624 67.0982 236.647 67.119 236.674 67.1274C236.72 67.1024 236.668 67.0878 236.641 67.0816C236.706 67.0525 236.787 67.0483 236.835 67.0733C236.864 67.0962 236.797 67.1045 236.81 67.1066C236.822 67.169 236.945 67.1066 236.918 67.1752C236.883 67.2106 236.835 67.2085 236.806 67.2251C236.778 67.2064 236.816 67.1773 236.808 67.1606L236.795 67.1898C236.778 67.1877 236.76 67.1752 236.77 67.1627C236.739 67.1939 236.803 67.2605 236.783 67.3187C236.799 67.3208 236.82 67.3291 236.835 67.3166L236.824 67.3042C236.853 67.2792 236.883 67.3125 236.891 67.2896C236.922 67.3 236.968 67.3083 236.958 67.3416L236.91 67.3645C236.924 67.3582 236.933 67.3374 236.914 67.3354C236.939 67.3395 236.862 67.3998 236.931 67.3894L236.958 67.3582C236.989 67.3686 237.049 67.377 237.043 67.4061C237.089 67.379 237.035 67.4019 237.087 67.3666C237.022 67.4061 237.068 67.3021 237.001 67.352C237.062 67.3104 237.018 67.3125 237.066 67.2688C237.049 67.275 237.039 67.2875 237.039 67.2646C237.035 67.2646 237.026 67.2646 237.022 67.2646C237.018 67.2646 237.02 67.2646 237.022 67.2646C237.016 67.273 237.01 67.2792 237.001 67.2834C236.96 67.2875 236.949 67.2542 236.926 67.2501C236.931 67.2355 236.947 67.2501 236.962 67.2355L236.926 67.2293C236.962 67.2147 236.974 67.1752 237.006 67.196L236.997 67.169C237.012 67.1461 237.01 67.1211 236.991 67.1149C236.993 67.1003 236.939 67.1003 236.972 67.1003L236.935 67.0691L236.943 67.065C236.933 67.0234 236.849 67.0109 236.893 66.9381C236.878 66.9298 236.862 66.9214 236.862 66.8944L236.889 66.8757C236.872 66.8632 236.895 66.8112 236.86 66.8195C236.931 66.7633 236.837 66.7301 236.837 66.6947L236.797 66.7134C236.789 66.6926 236.768 66.6801 236.739 66.6635L236.706 66.6822C236.666 66.676 236.699 66.6157 236.679 66.5845C236.693 66.5803 236.693 66.5907 236.689 66.599C236.743 66.5179 236.587 66.5491 236.622 66.4825C236.606 66.4825 236.606 66.4721 236.61 66.4617C236.61 66.4617 236.61 66.4617 236.612 66.4617C236.612 66.4617 236.612 66.4597 236.612 66.4576C236.616 66.4513 236.618 66.443 236.622 66.4347C236.616 66.443 236.612 66.4513 236.61 66.4555C236.606 66.4493 236.595 66.4409 236.581 66.4368L236.614 66.4118C236.614 66.4118 236.614 66.4118 236.612 66.4118C236.618 66.3952 236.591 66.4139 236.568 66.4347C236.56 66.4347 236.549 66.4347 236.539 66.4347C236.591 66.3931 236.504 66.4201 236.558 66.3744C236.524 66.3869 236.506 66.339 236.441 66.3744C236.449 66.3681 236.452 66.364 236.454 66.3681C236.454 66.3536 236.454 66.3369 236.431 66.339L236.472 66.3057L236.399 66.3203C236.416 66.2891 236.429 66.2725 236.47 66.2662C236.397 66.2662 236.433 66.2517 236.362 66.2579L236.391 66.2413C236.391 66.2413 236.335 66.2413 236.354 66.2184C236.391 66.1601 236.285 66.1019 236.293 66.0104C236.22 66.079 236.31 65.9584 236.247 66C236.264 65.9833 236.268 65.9667 236.291 65.9646C236.252 65.9501 236.289 65.9001 236.222 65.9168C236.239 65.9001 236.254 65.9022 236.264 65.8918C236.258 65.8918 236.241 65.8939 236.249 65.8835C236.258 65.8731 236.268 65.8752 236.281 65.8752C236.256 65.8481 236.195 65.8877 236.139 65.9251C236.154 65.8918 236.145 65.8856 236.102 65.9022C236.116 65.8835 236.127 65.8606 236.147 65.8752C236.143 65.8627 236.127 65.7941 236.083 65.8253C236.091 65.8128 236.075 65.8086 236.068 65.8107C236.054 65.7857 236.056 65.7816 236.035 65.7629V65.7753C235.975 65.8065 236.008 65.7649 235.987 65.7524L235.993 65.7483L235.856 65.8606C235.856 65.9272 235.887 65.8606 235.881 65.9334L235.91 65.9043C235.979 65.8502 235.9 65.9709 235.945 65.9709L235.956 65.948C235.989 65.9397 235.895 66.0603 235.898 66.079C235.893 66.0873 235.885 66.0832 235.877 66.0832C235.864 66.1477 235.92 66.052 235.95 66.0686C235.931 66.0915 235.889 66.1102 235.9 66.131C235.889 66.1539 236.01 66.1165 235.987 66.1726C236 66.1539 236.012 66.1352 236.035 66.1352C236.056 66.1477 236.01 66.235 236.077 66.2038C236.075 66.2101 236.07 66.2142 236.066 66.2184C236.091 66.2184 236.125 66.2413 236.16 66.2246C236.062 66.3265 236.281 66.2621 236.179 66.3432L236.216 66.3785L236.206 66.3848C236.22 66.416 236.252 66.4056 236.283 66.3952C236.281 66.4077 236.268 66.4097 236.262 66.4139C236.27 66.468 236.279 66.468 236.354 66.4597L236.322 66.4888C236.349 66.4825 236.314 66.5824 236.379 66.5907C236.374 66.5928 236.368 66.597 236.36 66.597C236.431 66.6094 236.341 66.7654 236.474 66.6926L236.524 66.6989C236.508 66.6552 236.583 66.6656 236.593 66.6365C236.612 66.6469 236.583 66.7009 236.564 66.6885L236.568 66.6822C236.497 66.7217 236.576 66.7446 236.533 66.7737C236.585 66.8445 236.595 66.9402 236.635 67.013L236.683 66.9734L236.695 67.0005C236.687 67.015 236.66 67.0338 236.651 67.015C236.626 67.0421 236.695 67.0296 236.708 67.0234C236.708 67.0712 236.637 67.0462 236.643 67.0587L236.656 67.0712L236.66 67.065C236.689 67.065 236.712 67.0504 236.722 67.0733C236.72 67.0941 236.693 67.1003 236.693 67.1066C236.689 67.1086 236.689 67.1107 236.697 67.1149L236.71 67.1482L236.745 67.1107C236.774 67.1107 236.76 67.1419 236.799 67.1003C236.739 67.1627 236.839 67.2334 236.822 67.2605C236.864 67.2646 236.874 67.2834 236.883 67.3104C236.889 67.3 236.937 67.2709 236.941 67.2958C236.835 67.3395 236.916 67.3582 236.851 67.4102C236.893 67.3707 236.893 67.4643 236.951 67.4082C236.951 67.431 236.914 67.4269 236.895 67.4518C236.956 67.4768 236.912 67.5579 236.949 67.6037C236.964 67.5995 236.981 67.5808 237.006 67.5829L236.949 67.6411C236.96 67.6494 237.033 67.6162 236.993 67.6578C237.003 67.6494 237.02 67.6391 237.026 67.6432C237.003 67.7763 237.17 67.8408 237.083 67.9989C237.105 67.9739 237.112 67.9823 237.116 67.9947C237.12 67.9843 237.151 67.9823 237.17 67.9739L237.135 68.0384C237.191 68.028 237.155 68.0863 237.208 68.0738L237.193 68.0613C237.26 68.0613 237.316 67.9885 237.393 67.9635C237.318 67.9635 237.472 67.8679 237.362 67.8658C237.374 67.8512 237.389 67.8658 237.405 67.8533C237.37 67.8554 237.36 67.8471 237.366 67.82H237.374C237.343 67.7638 237.366 67.7264 237.362 67.6515L237.326 67.6702C237.326 67.6536 237.337 67.6474 237.343 67.637C237.28 67.6432 237.355 67.6786 237.287 67.689C237.355 67.6391 237.247 67.5891 237.328 67.5413C237.32 67.5184 237.289 67.5662 237.28 67.5434L237.301 67.5288L237.27 67.535C237.27 67.5184 237.295 67.4997 237.314 67.4893C237.314 67.4934 237.324 67.4976 237.326 67.4997C237.345 67.4685 237.295 67.4518 237.301 67.4414L237.297 67.4685C237.249 67.4186 237.247 67.3333 237.174 67.3L237.16 67.3125C237.108 67.2854 237.16 67.2688 237.124 67.2293H237.128C237.108 67.2293 237.093 67.221 237.089 67.2064C237.114 67.2064 237.116 67.1648 237.145 67.169C237.089 67.1398 237.108 67.1606 237.028 67.1627L237.053 67.1419C237.022 67.144 237.01 67.1502 236.991 67.1315C237.024 67.1378 237.026 67.0941 237.068 67.0982C237.103 67.0171 236.97 67.0608 237.045 66.9901C236.958 67.0109 237.026 67.0546 237.003 67.0525C236.985 67.0754 236.937 67.067 236.935 67.0483C236.928 67.0317 237.018 66.9672 236.993 66.9298C236.993 66.9339 237.001 66.9298 237.003 66.9339C237.014 66.909 236.962 66.9214 236.983 66.8861C236.933 66.9027 236.972 66.8611 236.912 66.8944L236.945 66.9214C236.918 66.911 236.841 66.9339 236.853 66.8819C236.866 66.8778 236.887 66.8778 236.899 66.8778C236.91 66.859 236.876 66.8674 236.889 66.8466C236.947 66.8133 236.926 66.8798 236.985 66.8757C237.003 66.8507 236.918 66.8611 236.987 66.8341C236.899 66.8674 236.974 66.7904 236.897 66.8029L236.933 66.7842C236.933 66.7842 236.903 66.7842 236.899 66.7779L236.951 66.7634C236.901 66.7675 236.96 66.703 236.926 66.6968C236.953 66.7363 236.891 66.7322 236.878 66.7654C236.801 66.7446 236.947 66.6802 236.895 66.6344C236.906 66.6386 236.895 66.676 236.87 66.6739C236.87 66.6594 236.874 66.6365 236.887 66.6177C236.856 66.5845 236.856 66.6469 236.824 66.6448C236.856 66.6053 236.795 66.6385 236.772 66.6302L236.806 66.6073C236.797 66.5512 236.729 66.6448 236.729 66.5907L236.787 66.5741L236.762 66.5637L236.803 66.5408C236.76 66.5408 236.764 66.5283 236.76 66.4992C236.739 66.52 236.697 66.5387 236.683 66.5221C236.693 66.495 236.72 66.5054 236.695 66.4846C236.72 66.4742 236.751 66.4617 236.729 66.4971C236.741 66.4909 236.754 66.4888 236.766 66.4805C236.779 66.4513 236.747 66.443 236.739 66.4347C236.739 66.4389 236.741 66.4451 236.739 66.4513L236.666 66.4472C236.674 66.4326 236.687 66.4305 236.701 66.4264C236.693 66.4222 236.674 66.4264 236.662 66.4181C236.691 66.4014 236.718 66.3806 236.741 66.3869L236.685 66.3744C236.695 66.364 236.704 66.3328 236.716 66.3286C236.716 66.2974 236.629 66.3203 236.629 66.2787C236.622 66.2808 236.616 66.2829 236.608 66.2787C236.595 66.2496 236.61 66.2038 236.554 66.2038L236.587 66.1518C236.558 66.1393 236.545 66.2205 236.499 66.1976C236.464 66.1851 236.531 66.156 236.537 66.1373C236.504 66.1435 236.437 66.1601 236.456 66.1061C236.47 66.1061 236.468 66.1185 236.479 66.1227L236.474 66.1269ZM236.235 65.8835C236.245 65.8835 236.274 65.8752 236.26 65.8939C236.22 65.9189 236.233 65.9001 236.235 65.8835ZM236.008 66.0645C235.993 66.0686 235.995 66.0582 236.002 66.0437C236.008 66.0457 236.01 66.052 236.008 66.0645ZM236.97 67.1669H236.968C236.976 67.1461 236.974 67.1544 236.97 67.1669ZM236.966 67.2022C236.966 67.2022 236.978 67.2022 236.983 67.1981C236.972 67.1981 236.968 67.1939 236.968 67.1856C236.96 67.1918 236.953 67.1981 236.966 67.2043V67.2022ZM236.708 67.1086L236.714 67.0982C236.731 67.1045 236.72 67.1066 236.708 67.1086Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.929 66.0525C235.929 66.0525 235.94 66.0415 235.946 66.0371C235.94 66.0393 235.933 66.0437 235.929 66.0525Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.624 66.2807V66.283L236.631 66.2783L236.624 66.2807Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.458 66.9198C236.458 66.9198 236.467 66.9048 236.473 66.8984C236.464 66.9027 236.458 66.9091 236.458 66.9198Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.089 67.3354L237.072 67.3184C237.072 67.3184 237.072 67.3333 237.065 67.3397C237.074 67.3354 237.087 67.3269 237.089 67.3333V67.3354Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.901 67.5774C236.901 67.5774 236.904 67.584 236.91 67.584L236.93 67.5774C236.925 67.5663 236.906 67.5619 236.904 67.5774H236.901Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.966 67.3955C236.935 67.4081 236.95 67.4164 236.96 67.4269C237.008 67.4143 236.987 67.4039 236.968 67.3955H236.966Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.962 67.4307C236.962 67.4307 236.966 67.4395 236.966 67.4439C236.986 67.4395 236.968 67.4373 236.962 67.4307Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.002 67.2318C237.002 67.2318 237.043 67.2192 237.033 67.2297C237.077 67.2213 236.968 67.2067 237.002 67.2318Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.861 67.4436L236.901 67.4248L236.866 67.429L236.861 67.4436Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.856 67.3307L236.852 67.3564C236.852 67.3564 236.864 67.3564 236.869 67.3564C236.864 67.3436 236.869 67.3265 236.856 67.3307Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.868 67.3564C236.868 67.3564 236.873 67.3697 236.881 67.3719C236.881 67.3675 236.875 67.3609 236.868 67.3564Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.841 67.419L236.847 67.4105L236.845 67.3955L236.841 67.419Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.779 67.1105L236.758 67.0938C236.743 67.0979 236.737 67.1063 236.747 67.1126C236.76 67.1126 236.768 67.1188 236.779 67.1126V67.1105Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.697 67.2231C236.697 67.2231 236.712 67.2105 236.722 67.2021L236.672 67.221H236.695L236.697 67.2231Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.66 67.165C236.645 67.1692 236.608 67.1504 236.622 67.1754C236.637 67.1713 236.656 67.188 236.66 67.165Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.57 66.8199L236.572 66.8262L236.65 66.7842L236.57 66.8199Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.239 66.6575C236.235 66.6911 236.288 66.6344 236.279 66.6701C236.3 66.6659 236.288 66.6428 236.307 66.6386C236.279 66.6365 236.286 66.6218 236.242 66.6575H236.239Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.104 68.0908L237.091 68.1143L237.116 68.0951L237.104 68.0908Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.174 68.1025L237.124 68.1235L237.174 68.1172C237.174 68.1172 237.164 68.1088 237.174 68.1025Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.285 65.7715L236.275 65.7798C236.266 65.7924 236.268 65.7945 236.27 65.8029L236.285 65.7715Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.416 65.9876L236.414 65.9834L236.381 66.021L236.416 65.9876Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.598 66.1105C236.598 66.1105 236.579 66.1021 236.575 66.0938C236.594 66.1021 236.55 66.1523 236.598 66.1105Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M248.829 66.145C248.821 66.2615 248.971 66.2199 248.999 66.2386C248.955 66.039 248.79 66.1513 248.829 66.145Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M248.32 64.2668L248.387 64.2917L248.194 64.04L248.32 64.2668Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.932 62.5439C247.732 62.7769 248.134 63.1513 248.123 63.48L248.08 63.5424L248.317 63.636C248.188 63.2657 247.934 62.8227 247.932 62.5439Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M248.123 61.4523C248.05 61.5459 247.969 61.2838 248.174 61.679C248.176 61.654 248.18 61.6457 248.182 61.6311C248.167 61.5937 248.149 61.5417 248.123 61.4523Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M248.184 61.631C248.219 61.4812 248.259 61.8119 248.184 61.631V61.631Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.779 60.8306L247.972 61.0241C248.003 60.9513 247.915 60.7391 247.99 60.7974C247.83 60.579 247.802 60.6538 247.777 60.8306H247.779Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.507 60.6934L247.599 60.7953C247.611 60.7641 247.603 60.7287 247.507 60.6934Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.791 61.0112L247.596 60.7949C247.575 60.8448 247.5 60.8844 247.678 60.8968C247.598 60.9093 247.688 60.926 247.791 61.0112Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.824 61.1699C247.839 61.3197 247.864 61.5027 247.688 61.3051C247.797 61.5173 247.877 61.5963 247.914 61.5631C247.946 61.5319 247.946 61.3821 247.824 61.1699Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.647 62.5405C247.642 62.6049 247.64 62.6673 247.63 62.7339L247.751 62.8587C247.72 62.8275 247.716 62.7381 247.709 62.6611C247.699 62.5841 247.682 62.5217 247.647 62.5405Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.134 59.3643C247.08 59.3788 247.055 59.5161 247.005 59.5681L247.157 59.695C247.139 59.5931 247.074 59.4183 247.134 59.3643Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.008 59.5681L246.782 59.3809C246.903 59.5993 246.964 59.6138 247.008 59.5681Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.232 60.7801L247.605 61.1004L247.19 60.7031L247.232 60.7801Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.524 58.4657L246.723 58.5198L246.396 58.4033L246.524 58.4657Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.066 57.9098C246.226 57.9327 246.091 57.6727 246.226 57.7268C246.078 57.5916 245.897 57.525 245.734 57.4668C245.876 57.5542 245.984 57.6914 246.066 57.9098Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.479 57.3613C245.549 57.4029 245.639 57.4321 245.735 57.4674C245.66 57.4217 245.576 57.3821 245.479 57.3613Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.541 58.9705C246.556 58.9351 246.602 58.8519 246.537 58.7021L246.479 58.881C246.497 58.9081 246.52 58.9393 246.543 58.9705H246.541Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.477 58.8873V58.8811C246.41 58.7833 246.364 58.7147 246.343 58.6855C246.359 58.7105 246.399 58.7708 246.477 58.8852V58.8873Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.558 58.9942C246.558 58.9942 246.547 58.9792 246.541 58.9707C246.534 58.9878 246.534 58.9963 246.558 58.9942Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.023 60.0814C246.865 59.9837 246.615 59.7507 246.667 60.0897C246.817 60.1334 246.786 59.9379 247.023 60.0814Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.479 59.21C246.526 59.2952 246.562 59.3868 246.606 59.4762C246.637 59.4492 246.66 59.3722 246.737 59.418C246.649 59.3493 246.57 59.2765 246.479 59.212V59.21Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.354 59.1245L246.479 59.2098L246.425 59.1162L246.354 59.1245Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.716 57.8352C245.579 57.7853 245.483 57.6854 245.368 57.5752C245.46 57.7208 245.564 57.8602 245.676 57.9829C245.728 57.9683 245.843 57.9662 245.718 57.8352H245.716Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.091 58.3452C246.091 58.3452 246.074 58.3324 246.067 58.3281C246.067 58.3516 246.074 58.3644 246.091 58.3452Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.245 56.5059C244.245 56.5184 244.245 56.531 244.245 56.5435L244.266 56.5268L244.245 56.5059Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.672 58.024C245.734 58.1363 245.814 58.1675 245.899 58.1904C245.824 58.1301 245.749 58.0615 245.676 57.9824C245.653 57.9887 245.64 57.997 245.674 58.0219L245.672 58.024Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.122 57.0945C245.149 57.1611 245.187 57.2318 245.22 57.3108C245.214 57.2256 245.17 57.082 245.122 57.0945Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.074 58.2654C246.074 58.2654 246.085 58.2717 246.091 58.2759C246.091 58.2215 246.083 58.2361 246.074 58.2654Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.075 58.2653C246.019 58.2279 245.958 58.2092 245.899 58.1904C245.956 58.2445 246.012 58.2903 246.067 58.3256C246.067 58.3069 246.069 58.284 246.075 58.2653Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.269 57.0013C243.321 56.9513 243.429 56.9472 243.542 56.9909C243.598 57.0137 243.654 57.0449 243.702 57.0928C243.748 57.1427 243.787 57.2072 243.81 57.28C244.075 57.3757 244.262 56.9118 244.245 56.5436C244.198 56.5873 244.168 56.6206 243.883 56.5166C243.927 56.6268 244.245 57.0657 243.985 57.0033C243.827 56.9035 243.773 56.8536 243.75 56.7974C243.727 56.7412 243.735 56.6851 243.687 56.6019C243.698 56.8328 243.152 56.5249 243.062 56.7849L243.371 56.8993C243.35 56.9347 243.219 56.9181 243.267 56.9992L243.269 57.0013Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.648 56.9286L244.748 56.9952C244.664 56.885 244.629 56.7768 244.569 56.5709C244.373 56.4877 244.308 56.5002 244.267 56.5272L244.691 56.939L244.648 56.9266V56.9286Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.141 57.3633C244.972 57.3966 244.71 57.2634 244.722 57.4964C244.974 57.7252 244.98 57.5775 245.172 57.6794C244.766 57.2926 245.343 57.7398 245.132 57.3778C245.226 57.4423 245.301 57.511 245.368 57.5754C245.312 57.486 245.264 57.3986 245.22 57.3092C245.22 57.3154 245.22 57.3196 245.22 57.3258H245.222L245.22 57.3279C245.222 57.3591 245.22 57.3737 245.209 57.3446C245.207 57.3446 245.201 57.3404 245.199 57.3383C245.18 57.3508 245.159 57.357 245.141 57.3612C245.053 57.2177 245.151 57.3134 245.199 57.3383C245.205 57.3342 245.214 57.3321 245.22 57.3279V57.3258C245.074 57.2031 244.903 57.1054 244.747 56.9951C244.818 57.095 244.941 57.1844 245.141 57.3633Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.23 60.0148C246.232 59.9939 246.242 59.9876 246.251 59.9814C246.217 59.9625 246.199 59.9584 246.23 60.0148Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.194 59.7755C246.232 59.7963 246.303 59.7921 246.355 59.9086C246.374 60.0271 246.29 59.9481 246.251 59.9793C246.326 60.023 246.487 60.1519 246.424 59.9044L246.387 59.8836C246.32 59.6694 246.332 59.3199 246.37 59.3407C246.288 59.4739 246.234 59.5779 246.194 59.7755Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.701 58.5691C245.595 58.4588 245.467 58.3652 245.347 58.2695L245.399 58.5275L245.453 58.4671C245.595 58.6855 245.63 58.5836 245.701 58.5691Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.253 56.4103L244.405 56.3271C244.289 56.3209 244.162 56.3313 244.041 56.3355L244.253 56.4103Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.745 56.0549L243.85 55.953L243.666 55.9238L243.745 56.0549Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.702 71.8135L226.8 71.8946C226.761 71.853 226.729 71.828 226.702 71.8135Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.297 71.041L226.224 71.0536C226.276 71.0725 226.31 71.0746 226.297 71.041Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M229.443 55.4411C229.2 55.4328 228.885 55.3829 228.995 55.5035L229.135 55.6013C229.241 55.5035 229.345 55.4619 229.441 55.4411H229.443Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.572 63.9214C224.591 63.9068 224.61 63.8922 224.627 63.8756C224.585 63.8194 224.547 63.7674 224.512 63.7217C224.531 63.782 224.543 63.8486 224.572 63.9214Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.189 64.1729L225.053 64.3892C225.097 64.3413 225.141 64.2727 225.189 64.1729Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.024 75.1347C230.091 75.118 230.158 75.1035 230.227 75.0806C230.05 74.962 230.083 75.0785 230.024 75.1347Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.935 53.7128C237.77 53.6254 237.633 53.5796 237.512 53.5547C237.714 53.6753 237.862 53.8334 237.935 53.7128Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.069 72.321C225.138 72.3792 225.184 72.3959 225.214 72.3751C225.145 72.3147 225.092 72.2856 225.069 72.321Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.004 53.5212C237.033 53.5378 237.064 53.5483 237.093 53.5628C237.223 53.5462 237.356 53.5233 237.512 53.5545C237.364 53.465 237.183 53.4255 237.004 53.5212Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.195 72.3433C245.208 72.3371 245.218 72.3245 245.231 72.3203C245.214 72.3057 245.206 72.3203 245.195 72.3433Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M248.519 67.9004C248.519 67.9586 248.507 68.0481 248.496 68.1354C248.513 68.0959 248.523 68.0252 248.519 67.9004Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.646 54.7046C241.674 54.6983 241.772 54.7533 241.646 54.7046V54.7046Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.933 55.5283C241.899 55.5325 241.872 55.543 241.851 55.5745C241.878 55.5451 241.905 55.5325 241.933 55.5283Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.726 54.4717C235.726 54.4717 235.719 54.4717 235.715 54.4717C235.754 54.5025 235.748 54.4959 235.726 54.4717Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.795 54.8546C241.759 54.8151 241.713 54.7777 241.663 54.7402C241.682 54.7631 241.722 54.7985 241.795 54.8546Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.803 54.7773C241.841 54.8025 241.872 54.8235 241.902 54.8425C241.929 54.8256 241.923 54.8046 241.803 54.7773Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.478 54.6338C241.547 54.665 241.607 54.7024 241.664 54.7419C241.645 54.7211 241.638 54.7087 241.647 54.7066C241.611 54.692 241.561 54.6691 241.478 54.6338Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M237.62 77.4649C237.62 77.4649 237.637 77.4712 237.647 77.4754C237.757 77.3935 237.706 77.4103 237.62 77.4649Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M228.005 58.7078C228.005 58.7078 228.005 58.6968 228.009 58.6924C228.005 58.6946 227.998 58.699 227.994 58.7012L228.007 58.7078H228.005Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M227.817 59.0877C227.788 58.8318 227.876 58.7715 227.994 58.7008L227.567 58.499C227.647 58.6987 227.73 58.8942 227.817 59.0877Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M227.967 73.4667L227.881 73.1671C228.285 73.267 228.383 73.4916 228.358 73.1713C228.26 73.2462 228.165 73.2358 228.067 73.1817C227.971 73.1276 227.869 73.0361 227.788 72.9279C227.617 72.7178 227.444 72.5098 227.234 72.6367L227.205 72.4266C227.234 72.4724 227.261 72.462 227.29 72.5078C227.263 72.0897 226.84 72.4911 226.644 72.0418C226.59 71.8796 226.592 71.7465 226.7 71.813L226.403 71.5593C226.357 71.4615 226.444 71.4449 226.49 71.5405C226.384 71.3866 226.303 71.2181 226.207 71.0559H226.221C226.117 71.0164 225.93 70.8999 225.844 70.8396C225.844 70.6794 225.924 70.8833 225.963 70.825C225.884 70.746 225.795 70.669 225.72 70.5858C225.757 70.5005 225.826 70.5088 225.892 70.5629C225.967 70.6149 226.042 70.7085 226.08 70.8104C226.24 70.5796 226.184 70.538 226.088 70.4652C226.001 70.3903 225.874 70.278 225.901 69.9368L226.059 70.1864C226.255 69.914 226.086 69.7413 226.14 69.3919C226.078 69.4813 225.951 70.1365 225.722 69.8661C225.726 69.7642 225.695 69.6435 225.545 69.5C225.711 69.4459 225.626 69.2899 225.561 69.0778L225.788 69.032C225.665 68.8219 225.557 68.8677 225.42 68.7574C225.374 68.4933 225.534 68.4038 225.676 68.3144C225.651 67.8942 225.438 68.6576 225.322 68.1709C225.338 67.9878 225.315 67.8402 225.261 67.6862C225.209 67.5323 225.116 67.3721 225.045 67.1621C225.111 66.9041 225.188 67.1953 225.249 67.0997L225.055 66.8917C225.055 66.8376 225.113 66.8521 225.143 66.8584C225.061 66.6753 224.911 66.8563 224.834 66.5588C224.709 66.5214 224.782 66.3633 224.876 66.174C224.974 65.9848 225.07 65.7684 224.934 65.575C225.005 65.4876 225.074 65.627 225.163 65.6041C225.082 65.3503 225.053 65.238 225.013 65.1382C224.978 65.0363 224.947 64.9489 224.851 64.7243L225.055 64.3935C224.845 64.6244 224.693 64.2646 224.574 63.9276C224.478 64.0066 224.393 64.0774 224.349 64.1273C224.332 63.9567 224.316 63.7841 224.322 63.6135C224.374 63.5636 224.439 63.6301 224.514 63.7279C224.503 63.6905 224.493 63.6572 224.482 63.6281C224.609 63.4762 224.716 63.5969 224.811 63.7425C224.751 63.7882 224.689 63.8361 224.628 63.8818C224.747 64.0295 224.884 64.1647 225.02 64.1647C224.999 64.1294 224.984 64.067 224.982 64.0004C225.016 64.0378 225.045 64.0628 225.07 64.0545C225.099 64.0441 225.049 63.9838 225.013 63.8985L225.29 63.8506L225.197 63.8049L225.503 63.2599C225.468 63.1393 225.422 63.0165 225.38 62.8917C225.347 62.769 225.313 62.64 225.288 62.5048C225.243 62.2344 225.211 61.9224 225.305 61.5688C225.401 61.8039 225.572 61.7227 225.772 61.8205C225.478 61.9058 225.678 62.3634 225.509 62.6775C225.597 62.5111 225.684 62.5839 225.703 62.64L225.72 61.9682C225.882 62.0514 225.89 61.8933 226.036 61.7768C225.651 61.7456 226.024 61.2485 226.04 60.9615C226.155 61.0031 226.238 61.1175 226.074 61.3879C226.469 61.2027 225.88 60.7763 226.274 60.5912C226.236 60.6598 226.196 60.6869 226.234 60.743C226.234 60.533 226.542 60.1939 226.578 60.3395L226.54 60.4061C226.615 60.3021 226.705 60.1669 226.792 60.0171C226.884 59.8715 226.992 59.7259 227.073 59.5761C227.242 59.2829 227.34 58.9937 227.255 58.871C227.288 58.8918 227.492 59.1581 227.525 59.2225C227.457 58.7753 227.417 58.3177 227.39 57.8331C227.525 58.0744 228.185 58.2803 228.008 58.6984C228.063 58.6672 228.123 58.6297 228.183 58.5715C228.244 58.5132 228.298 58.4259 228.365 58.3094C228.277 58.3364 227.942 58.1825 228.011 58.0848C228.452 58.0806 228.288 58.0473 228.742 57.9724C228.61 58.014 228.437 57.6147 228.6 57.4857C228.617 57.5543 228.877 57.7831 228.852 57.8643L228.902 57.5439C228.921 57.4358 228.948 57.338 228.973 57.234C228.917 57.3671 229.171 57.5148 229.327 57.5398C229.237 57.5065 229.668 57.2943 229.748 57.1841L229.527 57.2319C229.997 56.9449 229.656 56.4457 230.162 56.1566C230.143 56.2668 230.285 56.6849 230.549 56.583C230.554 56.4644 230.545 56.1607 230.608 55.8612C230.67 55.5617 230.791 55.2393 231.001 55.05L231.143 55.1145C231.247 55.0146 231.351 54.9106 231.466 54.8253C231.401 55.0063 231.282 55.3412 231.158 55.6594C231.035 55.9818 230.908 56.2918 230.812 56.4831C231.041 56.4727 230.928 56.5809 231.199 56.4394C231.345 56.4935 231.126 56.662 231.051 56.7036L231.712 56.4665C231.647 56.3625 231.743 56.2502 231.845 56.1378C231.951 56.038 232.061 55.9444 232.011 55.8549C231.791 56.011 231.599 56.2169 231.403 56.3999C231.337 56.298 231.362 56.0942 231.472 55.8903C231.528 55.7905 231.601 55.6802 231.699 55.6033C231.797 55.5263 231.914 55.4618 232.043 55.4265C232.201 55.4701 232.101 55.8633 232.143 55.934C232.174 55.8341 232.545 55.6178 232.607 55.6573L232.447 55.8549C232.595 55.8487 232.676 55.7343 232.772 55.6324C232.87 55.5325 232.988 55.4639 233.184 55.5305C233.305 55.5159 233.598 55.7468 233.584 55.6012C233.338 55.3786 233.076 54.5632 233.165 54.3261C233.19 54.3303 233.371 54.3511 233.563 54.3844C233.755 54.4114 233.965 54.4946 234.046 54.5445C234.284 54.7276 233.838 55.0978 234.044 55.2559C234.038 55.1893 234.132 55.0937 234.173 55.0604C234.307 55.0978 234.157 55.2705 234.419 55.1997C234.427 54.9501 234.971 55.1373 234.517 54.9751C234.646 54.921 234.719 54.921 234.798 54.9293C234.877 54.9376 234.961 54.946 235.119 54.9377C235 54.7858 235.36 54.3844 235.646 54.3012C235.631 54.3636 235.698 54.4426 235.729 54.478C235.873 54.478 235.998 54.4821 236.114 54.4884C236.231 54.5029 236.339 54.5279 236.446 54.5487C236.658 54.5903 236.864 54.6298 237.127 54.6444C237.17 54.7047 237.414 54.7941 237.297 54.8898C237.374 54.8565 237.452 54.7858 237.612 54.8045C237.891 55.0625 237.256 54.7837 237.458 55.0729C237.493 54.9335 237.887 54.9397 238.128 54.8856C238.095 54.6589 237.606 54.7629 237.372 54.817C237.399 54.5154 237.841 54.2596 238.445 54.2096C238.68 54.2034 238.716 54.2783 238.707 54.3261C238.699 54.3781 238.643 54.4239 238.687 54.4114C239.093 54.5424 239.301 54.4592 239.495 54.3927C239.59 54.3594 239.682 54.3303 239.79 54.3344C239.899 54.3386 240.017 54.3948 240.169 54.505C240.376 54.7858 240.055 54.8732 240.067 55.0271C239.884 55 239.765 54.921 239.657 54.8441C239.547 54.7754 239.453 54.7026 239.33 54.6756L239.601 54.8399C239.47 54.8732 239.224 54.8607 239.109 54.7733C239.155 54.8295 239.261 54.8815 239.405 54.9335C239.476 54.9605 239.559 54.9834 239.645 55.0105C239.73 55.0437 239.82 55.0791 239.913 55.1165C240.286 55.2663 240.719 55.4036 240.965 55.6324C241.094 55.622 241.3 55.6469 241.25 55.5367L241.055 55.4722C240.948 55.2476 241.496 55.4452 241.29 55.2663C241.44 55.2767 241.607 55.2788 241.775 55.31C241.861 55.3266 241.946 55.3474 242.029 55.3828C242.111 55.4244 242.188 55.4785 242.263 55.5513L242.217 55.7801C242.242 55.7197 242.061 55.5305 241.931 55.5346C242.125 55.5346 242.296 56.1046 242.6 55.9506L242.442 55.6761C242.737 55.7322 243.189 55.7031 243.435 55.9922C243.427 55.7156 243.356 55.961 243.289 55.5991C243.306 55.9797 242.496 55.0999 242.627 55.5721C242.592 55.3765 242.508 55.2892 242.413 55.2018C242.317 55.1145 242.215 55.0229 242.111 54.8378C242.086 54.9065 242.158 55.0146 241.896 54.8482C241.873 54.8607 241.831 54.8711 241.806 54.8753C241.798 54.869 241.796 54.8669 241.79 54.8607C241.794 54.8669 241.796 54.8711 241.8 54.8753C241.784 54.8794 241.781 54.8815 241.804 54.8815C241.856 54.9418 241.892 55.0021 241.894 55.0479C241.682 55.1311 241.252 54.9189 241.073 54.9293C240.928 54.8212 241.173 54.8857 241.117 54.7712C241.028 54.7733 240.938 54.7816 240.844 54.7962C240.886 54.6402 240.492 54.3802 240.932 54.4405L240.569 54.2991C240.386 54.1368 240.099 53.9871 239.892 53.9954C239.724 53.9143 239.395 54.0516 239.584 53.9704L238.972 53.9163L238.976 53.8748C238.691 53.7791 238.37 53.8123 238.053 53.7936C237.735 53.7811 237.418 53.7146 237.087 53.5669C236.883 53.5981 236.675 53.6355 236.339 53.5752L236.275 53.4317C236.144 53.4421 235.95 53.4234 235.771 53.4067C235.594 53.3922 235.433 53.3901 235.381 53.465C235.306 53.3755 235.188 53.3277 235.044 53.309C234.973 53.2986 234.896 53.2965 234.815 53.2986C234.734 53.3048 234.65 53.3215 234.567 53.3381C234.23 53.4067 233.878 53.5191 233.642 53.5211L233.659 53.7042C233.346 53.7499 233.067 53.8914 232.711 54.0536L232.778 54.2034C232.493 54.3948 231.936 54.349 231.443 54.5466C231.453 54.4759 231.584 54.4447 231.687 54.4488C231.507 54.4176 231.343 54.4488 231.189 54.5071C231.039 54.5757 230.908 54.6839 230.776 54.79C230.647 54.8961 230.522 55.0042 230.389 55.0853C230.258 55.1665 230.116 55.2185 229.964 55.2393C229.872 55.3641 229.775 55.3994 229.668 55.4161C229.679 55.4098 229.687 55.3994 229.693 55.3911C229.681 55.3973 229.662 55.4077 229.643 55.4202C229.575 55.4285 229.504 55.4348 229.429 55.4493C229.502 55.4514 229.566 55.4493 229.616 55.4369C229.525 55.4972 229.393 55.5991 229.277 55.7177L229.123 55.6095C229.123 55.6095 229.104 55.6241 229.094 55.6345C228.921 55.6657 229.029 55.7697 229.175 55.8341C229.119 55.8986 229.083 55.9756 229.06 56.0422C228.796 55.8903 228.779 56.3687 228.46 56.2356C228.46 56.3271 228.315 56.4706 228.185 56.6266C228.067 56.7972 227.967 56.9782 228.038 57.1217C228.006 57.0947 227.961 57.1134 228.021 57.0531C227.867 57.1446 227.713 57.2403 227.654 57.4087L227.446 57.3006L227.407 57.5377L227.382 57.7831C227.13 57.8601 227.002 57.883 227.038 57.5918C226.846 58.1908 226.794 58.0016 226.675 58.5257L226.58 58.4176C226.48 58.559 226.467 58.8939 226.313 58.9043C226.203 58.9397 226.072 59.052 225.93 59.2101C225.855 59.287 225.786 59.3827 225.72 59.4888C225.653 59.5949 225.58 59.7072 225.507 59.8237C225.193 60.2813 224.936 60.8533 224.601 61.2527C224.836 61.2506 224.739 61.3338 224.63 61.444C224.526 61.5563 224.399 61.6957 224.545 61.7727C224.432 61.7914 224.33 61.9037 224.307 61.7186C224.228 62.2344 223.874 62.3967 224.062 62.821C223.951 62.8501 223.949 62.6733 223.878 62.7087C223.889 62.7545 223.92 62.8917 223.849 62.9271C223.778 62.9625 223.789 62.8314 223.766 62.7399C223.647 63.2641 223.933 63.3847 224.205 63.4845C224.108 63.5948 224.053 63.6821 224.043 63.7716C224.041 63.861 224.08 63.9505 224.157 64.0586C224.051 64.1294 223.93 64.2646 223.947 63.9422C223.91 64.1148 223.637 65.0155 223.876 65.0571C223.816 65.107 223.847 65.3046 223.87 65.3545C223.837 65.7539 223.814 65.7892 223.816 66.1824L223.86 66.0742C224.122 66.2302 223.92 66.3966 223.97 66.7128L223.941 66.7044C223.86 67.0705 223.887 67.1496 223.912 67.2245C223.924 67.2619 223.935 67.2993 223.93 67.3721C223.93 67.4096 223.922 67.4553 223.914 67.5157C223.908 67.576 223.899 67.6488 223.885 67.7403L224.051 67.6821C224.241 67.6925 224.21 67.8505 224.157 68.0606C224.105 68.2686 224.03 68.5349 224.135 68.7262C224.157 68.6701 224.182 68.6139 224.207 68.5598C224.28 68.6597 224.199 68.8344 224.095 69.0237C223.991 69.2109 223.866 69.4127 223.874 69.5333C223.856 69.5915 223.803 69.4688 223.762 69.4043C223.706 70.0637 224.001 69.4251 224.166 69.8495C224.074 69.966 223.833 69.8349 223.905 70.1386C223.885 70.228 224.058 70.4111 224.224 70.6253C224.307 70.7314 224.389 70.8479 224.445 70.9644C224.474 71.0226 224.495 71.0829 224.507 71.1433C224.524 71.2015 224.532 71.2597 224.528 71.3201C224.574 71.1973 224.622 71.0809 224.778 71.241C224.864 71.3783 224.876 71.6092 224.92 71.8297C224.966 72.046 225.028 72.2561 225.24 72.3039C225.24 72.3518 225.226 72.3767 225.207 72.3892C225.403 72.5639 225.732 73.0091 225.942 73.0423C225.753 73.3023 226.051 73.5707 226.321 73.8036C226.461 73.918 226.586 74.0324 226.665 74.126C226.744 74.2196 226.763 74.3091 226.657 74.3985L227.19 74.9393L227.136 74.9643C227.282 75.1619 227.434 75.243 227.552 75.2992C227.675 75.3512 227.783 75.3595 227.89 75.3657C227.946 75.4677 227.852 75.4531 227.825 75.4677C228.265 76.0314 228.373 76.0376 228.996 76.1728L228.942 76.3538C228.989 76.3558 229.052 76.4099 229.133 76.4931C229.214 76.5763 229.323 76.672 229.446 76.7823C229.568 76.8904 229.708 77.0048 229.862 77.1026C230.014 77.2024 230.181 77.2877 230.364 77.3106C230.349 77.3251 230.32 77.3501 230.258 77.348C230.46 77.3875 230.649 77.4853 230.835 77.6018C231.02 77.7162 231.195 77.868 231.378 77.9637C231.739 78.1696 232.07 78.3048 232.303 78.0428C232.478 78.0573 232.661 78.0344 232.838 78.0303C232.222 77.8181 233.009 77.7828 232.782 77.6122C233.03 77.6371 233.361 77.9637 233.051 77.918L233.011 77.8743C232.813 78.1696 233.763 78.1988 233.705 78.4047C234.028 78.4504 234.346 78.5087 234.665 78.5711C234.823 78.6085 234.983 78.6252 235.142 78.6418C235.302 78.6605 235.46 78.6813 235.619 78.7C235.777 78.7188 235.937 78.7396 236.094 78.7583C236.252 78.7687 236.41 78.7666 236.568 78.7708C236.883 78.7708 237.2 78.7812 237.508 78.75C237.452 78.6689 237.395 78.5919 237.341 78.5045C237.483 78.4983 237.622 78.4754 237.762 78.4608C237.881 78.5045 237.939 78.6418 237.633 78.6772C237.814 78.802 238.126 78.4754 238.122 78.4192C238.732 78.4338 237.941 78.7583 238.122 78.7354L238.37 78.6772L238.308 78.6564C238.399 78.5877 238.443 78.5253 238.512 78.4733C238.545 78.4484 238.585 78.4255 238.639 78.4047C238.691 78.3797 238.757 78.3589 238.847 78.3402C239.082 78.334 238.999 78.4692 239.091 78.4567C239.095 78.4754 239.126 78.4754 239.23 78.4296L239.765 78.3152L239.497 78.1696C239.701 78.0157 239.986 78.049 239.68 77.8909C239.905 78.0178 240.386 77.866 240.84 77.7037C241.286 77.5165 241.686 77.2731 241.813 77.2794C241.871 77.2087 241.931 77.1483 241.998 77.0943C242.061 77.0339 242.125 76.9778 242.196 76.9258C242.336 76.8218 242.494 76.7323 242.673 76.6346C242.563 76.6512 242.392 76.4806 242.698 76.3288C242.773 76.5597 242.946 76.5326 243.135 76.4349C243.325 76.3371 243.548 76.1957 243.768 76.2456C243.596 76.231 243.789 76.0688 243.958 75.9086C244.127 75.7464 244.25 75.5654 244 75.5758C244.239 75.4115 244.129 75.7027 244.368 75.6382C244.468 75.4843 244.593 75.3491 244.735 75.2222C244.806 75.1577 244.883 75.0974 244.958 75.0329C245.031 74.9664 245.106 74.8998 245.183 74.8312C245.485 74.5566 245.845 74.2945 246.068 73.9118C246.026 73.8619 245.862 73.918 245.899 73.7142C246.074 73.658 246.249 73.5977 246.428 73.5353C246.468 73.4563 246.416 73.3731 246.401 73.2919C246.388 73.2129 246.405 73.138 246.576 73.0631C246.507 73.0715 246.407 73.0839 246.449 72.9758C247.032 72.3497 247.394 71.5426 247.671 70.7252C247.805 70.3133 247.965 69.9098 248.088 69.4938C248.159 69.2879 248.238 69.0861 248.332 68.8823C248.427 68.6805 248.498 68.4725 248.609 68.2686C248.452 68.4829 248.463 68.3248 248.486 68.1459C248.44 68.2562 248.332 68.1189 248.242 68.1293C248.352 67.9067 248.48 67.68 248.58 67.4491C248.348 67.2973 248.602 66.6732 248.38 66.5921L248.409 66.8188C248.155 66.5152 247.79 67.1995 247.449 67.1225C247.521 67.2057 247.526 67.2973 247.501 67.395C247.469 67.4928 247.397 67.5926 247.332 67.7008C247.201 67.915 247.084 68.1438 247.263 68.435C247.178 68.5328 247.167 68.3206 247.08 68.3643C247.213 68.5182 247.197 68.6763 247.061 68.9384L247.034 68.8989C246.947 69.2899 246.87 69.5687 246.711 69.8287C246.638 69.9597 246.563 70.0928 246.478 70.2447C246.395 70.3944 246.311 70.5629 246.186 70.7481L246.372 70.7584C246.268 70.9228 246.201 70.9373 246.124 70.9997C246.261 71.3097 246.372 70.5192 246.545 70.8167C246.328 70.8645 246.18 71.1682 246.03 71.4636C245.964 71.6154 245.859 71.7423 245.77 71.8442C245.676 71.942 245.578 72.0002 245.472 71.9857C245.318 72.2353 245.685 72.0148 245.53 72.2665L245.399 72.2748L245.476 72.4142C245.358 72.5702 245.176 72.5639 245.103 72.5202C245.141 72.489 245.162 72.4017 245.185 72.358C244.933 72.4828 244.801 72.9383 244.718 72.9841L244.937 72.8011C244.835 72.9737 244.724 73.1547 244.587 73.3211C244.443 73.4812 244.295 73.6455 244.147 73.8099C244.075 73.8931 244.004 73.9763 243.931 74.0595C243.852 74.1364 243.777 74.2134 243.704 74.2904C243.558 74.4464 243.427 74.6107 243.319 74.7833L243.414 74.8041C243.371 74.8686 243.333 74.9227 243.296 74.9643C243.256 75.0038 243.221 75.035 243.185 75.06C243.119 75.1099 243.06 75.1369 242.998 75.1619C242.875 75.2139 242.744 75.2597 242.5 75.4843L242.508 75.4552C242.452 75.607 242.319 75.7256 242.158 75.813C242.25 75.6486 241.794 75.8192 241.925 75.6174C241.454 76.0854 241.727 75.8982 241.488 76.3683L241.336 76.2934C241.257 76.464 241.275 76.5264 240.984 76.7053C241.182 76.4827 240.707 76.6138 240.917 76.3434C240.732 76.3517 240.59 76.3995 240.474 76.464C240.355 76.5222 240.257 76.5867 240.169 76.6512C239.995 76.776 239.851 76.8696 239.636 76.7219C239.455 77.1816 240.265 76.7095 240.126 76.8467C240.313 76.9071 239.972 77.1983 239.747 77.2399C239.53 77.321 239.238 76.8967 238.714 77.0443C238.768 77.0319 238.764 77.0048 238.818 76.9923C238.707 76.9715 238.618 77.0277 238.52 77.0797C238.472 77.1047 238.42 77.1296 238.364 77.1421C238.308 77.1483 238.245 77.1421 238.176 77.1151C238.076 77.3563 237.851 77.1504 237.856 77.4395L238.351 77.2981C238.085 77.4125 237.856 77.7848 237.349 77.6995C237.381 77.6371 237.514 77.5394 237.606 77.4832C237.456 77.4167 237.345 77.5893 237.191 77.5061C237.204 77.2336 237.799 77.3543 238.068 77.0984C237.906 77.0007 237.529 77.3896 237.637 77.061C237.556 77.2731 237.418 77.2815 237.264 77.2815C237.108 77.2669 236.935 77.2378 236.758 77.3979L236.773 77.2253C236.716 77.2544 236.598 77.3418 236.489 77.3439L236.675 77.113C236.383 77.3147 236.102 76.9882 235.825 77.0631C236.119 77.0776 236.152 77.1275 236.144 77.1941C236.135 77.2627 236.081 77.3501 236.208 77.4042C235.833 77.5165 235.723 77.3875 235.612 77.2544C235.5 77.1171 235.385 76.9674 234.977 76.9819C235.088 76.9715 235.383 77.1067 235.202 77.1775C235.125 77.1546 235.036 77.1317 234.956 77.0859C234.877 77.0423 234.809 76.9903 234.767 76.9403C234.23 76.8925 234.825 77.1275 234.584 77.1962C234.429 76.9611 234.307 77.2399 234.048 77.269L234.08 77.0984C234.005 77.0735 233.944 77.0589 233.896 77.0547C233.848 77.0443 233.813 77.0443 233.784 77.0506C233.726 77.0631 233.698 77.1026 233.671 77.14C233.619 77.217 233.573 77.2919 233.311 77.1546L233.603 76.9799L233.303 76.9674L233.411 76.7906C233.24 76.8218 233.13 76.8218 233.03 76.7989C232.928 76.776 232.834 76.7303 232.699 76.645C232.73 76.7864 232.563 76.9299 232.293 76.8384C232.147 76.6762 232.449 76.7198 232.068 76.6075C232.193 76.5368 232.328 76.4411 232.434 76.6512C232.47 76.6034 232.553 76.5784 232.586 76.5306C232.438 76.3496 232.124 76.333 231.991 76.2851C232.039 76.3101 232.097 76.3392 232.118 76.3746C232.016 76.3787 231.909 76.387 231.807 76.387L231.501 76.3725C231.447 76.2747 231.534 76.2581 231.618 76.2414C231.507 76.2082 231.401 76.2456 231.241 76.1853C231.343 76.0771 231.399 75.9419 231.637 75.9835L231.089 75.8941C231.083 75.8254 230.924 75.6257 231.01 75.6091C230.906 75.4968 230.72 75.4635 230.522 75.4198C230.327 75.372 230.108 75.3283 229.981 75.1661C229.95 75.1765 229.902 75.1723 229.822 75.139C229.683 75.0142 229.575 74.8686 229.443 74.7438C229.379 74.6793 229.304 74.6232 229.223 74.5712C229.144 74.5129 229.052 74.4651 228.939 74.4276L228.927 74.074C228.635 73.8868 228.962 74.5358 228.469 74.2196C228.108 74.0012 228.506 73.9659 228.456 73.814C228.235 73.76 227.8 73.6663 227.702 73.2545C227.823 73.3148 227.858 73.4105 227.95 73.4833L227.967 73.4667ZM225.722 69.8703C225.784 69.9368 225.947 70.0512 225.872 70.1448C225.653 70.1261 225.715 70.0221 225.722 69.8703ZM225.057 63.3493C225.097 63.4263 225.045 63.5137 224.953 63.6073C224.959 63.5261 224.988 63.4367 225.057 63.3493ZM240.259 54.2866C240.259 54.2866 240.251 54.2887 240.247 54.2908C240.067 54.1535 240.13 54.2055 240.259 54.2866ZM240.646 54.5092C240.696 54.5008 240.703 54.478 240.694 54.4488C240.649 54.48 240.555 54.4488 240.455 54.3968C240.469 54.4509 240.511 54.4988 240.648 54.5071L240.646 54.5092ZM239.124 78.3672L239.03 78.3444C239.203 78.2487 239.164 78.3048 239.124 78.3672Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.118 64.1416C225.085 64.1605 225.053 64.1605 225.02 64.1605C225.043 64.1983 225.076 64.2067 225.118 64.1416Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M229.989 75.1431C229.989 75.1431 229.996 75.1494 229.998 75.1536C230.01 75.1494 230.019 75.1431 230.027 75.1348L229.989 75.1431Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.211 55.3145C234.128 55.302 234.078 55.277 234.042 55.25C234.046 55.2916 234.088 55.3228 234.211 55.3145Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.888 55.2929L242.619 55.1826C242.742 55.2471 242.765 55.3053 242.811 55.3657C242.827 55.3282 242.811 55.2492 242.888 55.2929Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M244.144 57.5894C244.187 57.5998 244.206 57.6435 244.25 57.6518L244.298 57.5852C244.171 57.4771 244.041 57.4479 244.146 57.5873L244.144 57.5894Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.802 55.9152C242.738 56.0545 242.921 56.0857 243.086 56.1835C243.075 56.1772 243.067 56.171 243.059 56.1627C243.14 56.0961 243.129 56.0441 243.073 56.0025C243.017 55.9609 242.906 55.938 242.802 55.9131V55.9152Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M243.125 56.209C243.177 56.2381 243.227 56.2714 243.269 56.3109C243.336 56.2568 243.221 56.2547 243.125 56.209Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.207 54.6273C241.275 54.7022 241.336 54.4817 241.361 54.5587C241.446 54.4963 241.28 54.4797 241.157 54.4963C241.096 54.5025 241.044 54.5233 241.04 54.5462C241.038 54.567 241.082 54.5941 241.207 54.6273Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.669 56.398L242.711 56.2129L242.542 56.2815L242.669 56.398Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.459 55.5554L241.705 55.7301C241.715 55.701 241.757 55.701 241.807 55.7114C241.644 55.6261 241.478 55.5055 241.459 55.5575V55.5554Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.807 55.709C241.89 55.7568 241.968 55.8047 242.03 55.8047C241.984 55.7797 241.886 55.7235 241.807 55.709Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M242.294 56.2336L242.24 56.1566L242.066 56.0381L242.294 56.2336Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.43 54.4844H238.097C238.053 54.5426 238.134 54.5925 238.259 54.5863C238.343 54.5551 238.468 54.5509 238.43 54.4844Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M239.258 55.1957C239.185 55.1395 239.191 55.0979 239.16 55.0293L239.093 55.2435L239.26 55.1957H239.258Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.36 55.0254C238.316 55.0816 237.883 55.1335 238.272 55.1772C238.314 55.1169 238.633 55.1252 238.36 55.0254Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.62 54.7985L233.697 54.7756L233.609 54.4199L233.62 54.7985Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.198 57.1692C230.546 57.061 230.148 56.9341 230.481 56.8613C230.508 56.7428 230.208 56.9216 230.242 56.8135C230.104 57.0028 229.981 57.0173 230.198 57.1692Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.243 56.816C230.266 56.7848 230.287 56.7516 230.31 56.71C230.268 56.762 230.252 56.7932 230.243 56.816Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M248.804 66.9642L248.894 66.7021L248.763 66.8686L248.804 66.9642Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M248.557 66.4527L248.795 66.3944L248.59 66.2363C248.598 66.2946 248.613 66.409 248.557 66.4527Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.982 69.1357H225.924C225.874 69.1836 225.882 69.2356 225.899 69.3396L225.982 69.1357Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M227.047 71.9355L227.024 71.8877L226.895 72.0853L227.047 71.9355Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M228.826 73.7179C228.753 73.6472 228.64 73.591 228.579 73.5078C228.748 73.6493 228.665 73.9217 228.826 73.7179Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.243 61.7785C224.293 61.6725 224.139 61.6579 224.118 61.6309C224.086 61.8326 224.281 61.7869 224.243 61.7785Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.045 63.7136L223.993 63.6699L224.081 63.9715L224.045 63.7136Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.791 65.4623C224.063 65.3167 223.82 64.8237 223.948 64.52L224.013 64.4764L223.824 64.3037C223.812 64.6948 223.889 65.2002 223.791 65.4623Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.218 66.4114C223.32 66.349 223.301 66.6236 223.253 66.1826C223.243 66.2055 223.235 66.2117 223.228 66.2242C223.228 66.2637 223.228 66.3199 223.22 66.4114H223.218Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.227 66.2238C223.141 66.3507 223.222 66.0283 223.227 66.2238V66.2238Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.317 67.1158L223.206 66.8662C223.151 66.9224 223.156 67.1533 223.105 67.0701C223.177 67.3321 223.231 67.2697 223.314 67.1158H223.317Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.522 67.3407L223.474 67.2139C223.451 67.2388 223.445 67.2742 223.522 67.3407Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.372 66.9434L223.474 67.2158C223.512 67.1763 223.596 67.1659 223.435 67.091C223.512 67.1077 223.435 67.0598 223.372 66.9434Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.397 66.7832C223.439 66.6397 223.479 66.4588 223.573 66.7063C223.548 66.4692 223.502 66.3672 223.456 66.386C223.416 66.4047 223.36 66.544 223.399 66.7853L223.397 66.7832Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.056 65.5663C224.056 65.5663 224.075 65.5227 224.095 65.479C224.116 65.4353 224.141 65.3916 224.141 65.3916L224.072 65.2314C224.089 65.271 224.062 65.3563 224.041 65.4311C224.022 65.506 224.016 65.5705 224.056 65.5663Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.393 68.7156C223.449 68.7197 223.52 68.6033 223.587 68.5721L223.491 68.3994C223.472 68.5013 223.47 68.6885 223.393 68.7177V68.7156Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.585 68.572L223.727 68.8278C223.694 68.5824 223.641 68.5449 223.585 68.572Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.81 67.3594L223.576 66.9268L223.821 67.4447L223.81 67.3594Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.638 69.773L223.474 69.6523L223.736 69.877L223.638 69.773Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.868 70.4571C223.726 70.3781 223.76 70.6693 223.653 70.5715C223.743 70.7525 223.889 70.8794 224.02 70.9896C223.92 70.8565 223.868 70.6901 223.87 70.4571H223.868Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.22 71.1806C224.168 71.1161 224.095 71.0558 224.018 70.9893C224.072 71.06 224.135 71.1245 224.22 71.1806Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.805 69.2959C223.778 69.325 223.705 69.3853 223.714 69.5476L223.833 69.402C223.824 69.3687 223.814 69.3333 223.805 69.2959Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.836 69.3965L223.832 69.4006C223.861 69.5171 223.88 69.5962 223.888 69.6315C223.882 69.6024 223.865 69.5317 223.836 69.3965Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.799 69.2695C223.799 69.2695 223.803 69.2863 223.805 69.2967C223.818 69.2821 223.82 69.2758 223.799 69.2695Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.753 68.0879C223.867 68.2356 224.017 68.5434 224.088 68.2065C223.963 68.1108 223.924 68.3063 223.753 68.0879Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.949 69.0941L223.926 68.8008C223.887 68.8153 223.839 68.8798 223.782 68.8091L223.864 68.9526C223.885 68.988 223.903 69.0233 223.92 69.0504L223.949 69.0941Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.037 69.2195L223.949 69.0947L223.966 69.2008L224.037 69.2195Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.168 70.6504C224.276 70.7461 224.332 70.875 224.401 71.0165C224.368 70.848 224.32 70.6795 224.259 70.5256C224.205 70.5214 224.097 70.4819 224.168 70.6483V70.6504Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.001 70.0425C224.001 70.0425 224.011 70.0593 224.018 70.0676C224.026 70.0467 224.026 70.0321 224.001 70.0425Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.065 72.4184C225.069 72.4058 225.074 72.3954 225.078 72.3828L225.053 72.3912L225.065 72.4205V72.4184Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.277 70.4901C224.26 70.3632 224.195 70.3049 224.124 70.2529C224.172 70.3361 224.218 70.4256 224.26 70.5254C224.285 70.5275 224.3 70.5254 224.277 70.4901Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.458 71.5555C224.458 71.4827 224.447 71.4036 224.445 71.3184C224.42 71.3995 224.409 71.5513 224.458 71.5555Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.989 70.1202C223.989 70.1202 223.98 70.1098 223.976 70.1035C223.955 70.1537 223.97 70.1432 223.989 70.1202Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.988 70.1195C224.028 70.1757 224.078 70.2131 224.124 70.2526C224.091 70.1819 224.055 70.1195 224.018 70.0654C224.011 70.0842 224.001 70.1049 223.988 70.1195Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.155 72.306C226.088 72.3352 225.986 72.2998 225.897 72.2187C225.853 72.1771 225.811 72.1272 225.784 72.0648C225.759 72.0003 225.747 71.9275 225.749 71.8505C225.536 71.6654 225.195 72.0315 225.078 72.383C225.139 72.358 225.178 72.3393 225.407 72.5369C225.407 72.4184 225.266 71.8942 225.486 72.046C225.599 72.1958 225.632 72.2624 225.632 72.3227C225.632 72.383 225.605 72.4308 225.622 72.5286C225.695 72.3102 226.095 72.7928 226.269 72.5806L226.024 72.3622C226.055 72.3372 226.172 72.3996 226.157 72.306H226.155Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.84 71.8821L224.771 71.7822C224.811 71.9153 224.803 72.0277 224.786 72.2419C224.938 72.3896 225.005 72.4 225.053 72.3896L224.803 71.8529L224.84 71.88V71.8821Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.537 71.2971C224.707 71.3262 224.903 71.5446 224.976 71.3221C224.822 71.0184 224.766 71.1536 224.624 70.9893C224.864 71.4947 224.485 70.8728 224.553 71.2846C224.489 71.191 224.445 71.1016 224.403 71.0142C224.422 71.1161 224.437 71.2181 224.445 71.3158C224.445 71.3096 224.447 71.3054 224.449 71.2992L224.451 71.2971C224.46 71.2659 224.468 71.2534 224.468 71.2846C224.47 71.2846 224.474 71.2909 224.474 71.295C224.495 71.2909 224.516 71.2929 224.537 71.295C224.568 71.4614 224.51 71.3345 224.474 71.295C224.466 71.295 224.457 71.295 224.451 71.2971V71.2992C224.437 71.3075 224.774 71.7776 224.774 71.7776C224.743 71.659 224.662 71.5321 224.539 71.2929L224.537 71.2971Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.47 68.4307C224.46 68.4495 224.449 68.4516 224.437 68.4537C224.462 68.485 224.476 68.4955 224.47 68.4307Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.417 68.6657C224.39 68.6325 224.322 68.6117 224.315 68.4827C224.342 68.3641 224.388 68.4702 224.438 68.4536C224.384 68.387 224.28 68.2081 224.249 68.4619L224.276 68.4952C224.261 68.7177 224.124 69.0422 224.097 69.0089C224.222 68.9133 224.307 68.8363 224.417 68.6657Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.446 69.9722C224.446 69.9722 224.459 69.9993 224.478 70.0367C224.496 70.0762 224.519 70.1282 224.55 70.1782L224.669 70.3778L224.713 70.1178L224.64 70.1553C224.586 69.9015 224.517 69.9826 224.446 69.9722Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.022 72.5039L224.849 72.5268L225.19 72.6495L225.019 72.5039H225.022Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.368 73.0195L225.234 73.0757L225.395 73.1693L225.368 73.0195Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.934 64.4082L246.873 64.2959C246.896 64.35 246.915 64.3833 246.934 64.4082Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M247.036 65.2731L247.108 65.2878C247.066 65.25 247.036 65.2374 247.036 65.2731Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.501 78.7104C238.726 78.804 239.001 78.9642 238.94 78.8123L238.845 78.6709C238.709 78.725 238.599 78.7271 238.501 78.7104Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.09 72.5371C246.069 72.5433 246.046 72.5517 246.023 72.56C246.042 72.6265 246.059 72.689 246.076 72.7451C246.08 72.6827 246.092 72.6141 246.092 72.5371H246.09Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.604 72.0871L245.804 71.9395C245.748 71.9665 245.681 72.0143 245.604 72.0871Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.024 60.1165C245.024 60.1165 244.974 60.1103 244.922 60.104L244.815 60.0957C244.939 60.2704 244.949 60.1498 245.024 60.1186V60.1165Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M229.977 77.2961C230.106 77.4396 230.224 77.5332 230.333 77.6039C230.177 77.4146 230.087 77.2087 229.977 77.2961Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M248.642 64.5183C248.598 64.4392 248.561 64.408 248.527 64.4163C248.569 64.4975 248.607 64.5432 248.642 64.5183Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.77 77.8032C230.75 77.7782 230.727 77.7595 230.706 77.7346C230.583 77.7054 230.473 77.6909 230.333 77.6035C230.448 77.7429 230.577 77.8344 230.77 77.8032Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M229.86 57.292C229.846 57.292 229.833 57.3004 229.818 57.3004C229.827 57.3213 229.841 57.3108 229.86 57.292Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.15 60.271C225.171 60.2169 225.217 60.1337 225.259 60.0547C225.228 60.088 225.192 60.1525 225.15 60.271Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.844 75.0292C226.746 74.9393 226.817 75.025 226.844 75.0292V75.0292Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.875 74.1591C226.907 74.1675 226.938 74.1675 226.968 74.1465C226.932 74.1633 226.9 74.1675 226.875 74.1591Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M232.288 77.3666C232.288 77.3666 232.295 77.3687 232.299 77.3707C232.274 77.331 232.278 77.3373 232.288 77.3666Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.761 74.8379C226.78 74.8857 226.809 74.9398 226.842 74.9918C226.832 74.9627 226.809 74.9169 226.761 74.8379Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.724 74.9061C226.697 74.8687 226.676 74.8395 226.655 74.8125C226.623 74.8187 226.621 74.8395 226.724 74.9061Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.978 75.1576C226.923 75.1035 226.882 75.0474 226.842 74.9912C226.852 75.0183 226.852 75.0307 226.844 75.0307C226.871 75.0578 226.911 75.0952 226.978 75.1597V75.1576Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.77 55.223C238.77 55.223 238.756 55.2125 238.749 55.2041C238.617 55.2419 238.672 55.244 238.77 55.223Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.016 76.1768C241.016 76.1768 241.011 76.1856 241.007 76.19C241.013 76.19 241.02 76.19 241.024 76.1878L241.016 76.1768Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M241.328 75.8896C241.263 76.1393 241.161 76.1642 241.023 76.1871L241.348 76.5282C241.348 76.5282 241.344 76.3681 241.34 76.2079C241.334 76.0498 241.325 75.8896 241.325 75.8896H241.328Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.347 62.4112L246.318 62.7212C245.976 62.484 245.966 62.2386 245.874 62.5464C245.993 62.5111 246.078 62.5568 246.149 62.64C246.218 62.7253 246.282 62.846 246.318 62.977C246.403 63.2329 246.489 63.4908 246.73 63.4471L246.682 63.653C246.672 63.601 246.643 63.5989 246.632 63.5469C246.507 63.9463 247.047 63.7237 247.068 64.2126C247.061 64.3831 247.011 64.5079 246.934 64.4081L247.12 64.7513C247.126 64.8594 247.04 64.8428 247.03 64.7367C247.03 64.7367 247.04 64.77 247.051 64.822C247.059 64.874 247.07 64.9426 247.08 65.0134C247.101 65.1527 247.122 65.29 247.122 65.29H247.107C247.19 65.3587 247.324 65.5334 247.382 65.6228C247.324 65.7705 247.324 65.5521 247.265 65.5937L247.338 65.7476C247.357 65.7871 247.374 65.8246 247.388 65.8537C247.401 65.8828 247.407 65.9036 247.407 65.9036C247.342 65.9702 247.282 65.9369 247.236 65.8641C247.186 65.7892 247.149 65.6727 247.149 65.5667C246.916 65.7247 246.953 65.783 247.018 65.887C247.072 65.9889 247.151 66.1387 247.003 66.4465L246.945 66.1574C246.664 66.3425 246.761 66.563 246.584 66.8708C246.674 66.8084 247.03 66.2427 247.147 66.5776C247.107 66.6712 247.093 66.7939 247.182 66.9832C247.009 66.9728 247.03 67.1496 247.013 67.3701L246.786 67.3305C246.826 67.5697 246.945 67.5656 247.032 67.7195C246.98 67.9816 246.799 68.0086 246.634 68.0419C246.507 68.4434 246.98 67.8069 246.913 68.304C246.832 68.4683 246.801 68.616 246.797 68.7782C246.791 68.9405 246.82 69.1235 246.811 69.344C246.657 69.5603 246.691 69.2629 246.599 69.3295L246.705 69.5936C246.684 69.6435 246.636 69.6103 246.611 69.5936C246.622 69.7933 246.826 69.6789 246.793 69.9847C246.847 70.0242 246.838 70.0741 246.801 70.1324C246.782 70.1615 246.755 70.1927 246.724 70.226C246.707 70.2426 246.693 70.2592 246.674 70.278C246.678 70.2676 246.664 70.3029 246.684 70.253V70.2551L246.68 70.2592L246.672 70.2655L246.657 70.278L246.628 70.305C246.466 70.4506 246.293 70.6336 246.347 70.8708C246.249 70.9311 246.237 70.7709 246.143 70.7626C246.122 71.0455 246.105 71.1641 246.103 71.2743C246.099 71.3825 246.101 71.4677 246.114 71.7049L245.805 71.9378C246.084 71.7985 246.103 72.1791 246.093 72.5369C246.212 72.4974 246.316 72.462 246.374 72.4287C246.374 72.4287 246.339 72.5535 246.303 72.6783C246.287 72.7428 246.259 72.799 246.243 72.8447L246.214 72.9196C246.147 72.9487 246.112 72.8634 246.076 72.7449C246.072 72.7823 246.07 72.8198 246.07 72.8489C245.897 72.9467 245.841 72.7948 245.803 72.6242C245.876 72.6034 245.951 72.5806 246.024 72.5598C245.966 72.3809 245.885 72.2062 245.758 72.1583C245.766 72.1978 245.758 72.2602 245.737 72.3226C245.72 72.2769 245.699 72.2415 245.674 72.2415C245.645 72.2415 245.67 72.3122 245.674 72.4058L245.397 72.3518L245.468 72.4287L244.987 72.8281C244.976 72.9529 244.974 73.0839 244.968 73.2171C244.956 73.3439 244.939 73.475 244.914 73.6102C244.86 73.8785 244.777 74.1801 244.562 74.4776C244.558 74.2238 244.368 74.2384 244.216 74.074C244.52 74.099 244.497 73.6019 244.768 73.3689C244.627 73.4937 244.572 73.3939 244.575 73.3335L244.318 73.9555C244.195 73.8203 244.133 73.9659 243.954 74.0199C244.302 74.1884 243.775 74.5171 243.658 74.7792C243.566 74.7001 243.531 74.5628 243.779 74.3694C243.344 74.4006 243.739 75.01 243.306 75.0412C243.367 74.9913 243.412 74.9788 243.398 74.9144C243.321 75.1099 242.913 75.3179 242.933 75.1681L242.994 75.1182C242.885 75.1889 242.754 75.2825 242.619 75.3907C242.481 75.4926 242.327 75.5925 242.198 75.7027C241.936 75.917 241.74 76.1499 241.775 76.2976C241.752 76.2664 241.657 75.9461 241.65 75.8733C241.65 75.8733 241.636 75.9606 241.605 76.0813C241.573 76.204 241.532 76.3704 241.484 76.5389C241.392 76.8738 241.278 77.2191 241.278 77.2191C241.238 76.9445 240.696 76.516 241.011 76.1915C240.948 76.2019 240.88 76.2144 240.803 76.2477C240.726 76.281 240.642 76.3434 240.54 76.4266C240.632 76.4328 240.888 76.697 240.79 76.7635C240.376 76.6096 240.519 76.7011 240.068 76.6075C240.205 76.6158 240.224 77.0506 240.026 77.113C240.034 77.0443 239.874 76.7365 239.926 76.6699L239.763 76.9507C239.678 77.088 239.586 77.2149 239.586 77.2149C239.686 77.1109 239.501 76.8821 239.366 76.801C239.436 76.8634 238.96 76.907 238.845 76.9819L239.068 77.0152C238.526 77.113 238.664 77.7037 238.089 77.7911C238.145 77.6954 238.164 77.2544 237.881 77.2544C237.833 77.3647 237.733 77.6496 237.566 77.9075C237.402 78.1655 237.17 78.4234 236.908 78.5253L236.8 78.4151C236.8 78.4151 236.7 78.4567 236.6 78.4983C236.55 78.5212 236.498 78.5357 236.46 78.5482C236.423 78.5607 236.396 78.569 236.396 78.569C236.521 78.4234 236.752 78.153 236.983 77.8992C237.214 77.6434 237.441 77.3979 237.602 77.2544C237.385 77.1816 237.527 77.1213 237.225 77.1567C237.108 77.0547 237.372 76.9757 237.458 76.9632L236.756 76.9487C236.779 77.0672 236.648 77.14 236.514 77.2066C236.381 77.2627 236.242 77.3085 236.256 77.4104C236.256 77.4104 236.304 77.3959 236.379 77.373C236.414 77.3626 236.458 77.348 236.504 77.3355C236.55 77.3168 236.598 77.2981 236.646 77.2773C236.835 77.1983 237.023 77.1192 237.023 77.1192C237.048 77.2378 236.952 77.4187 236.775 77.5706C236.687 77.6434 236.579 77.7203 236.46 77.7578C236.342 77.7952 236.208 77.8139 236.077 77.7994C235.944 77.7016 236.179 77.3709 236.167 77.2898C236.102 77.373 235.679 77.4416 235.633 77.3813L235.854 77.2544C235.715 77.2066 235.598 77.2856 235.471 77.3459C235.344 77.4042 235.209 77.4271 235.05 77.2939C234.932 77.2648 234.74 76.9445 234.702 77.0839C234.852 77.3792 234.804 78.2341 234.638 78.4234C234.617 78.4109 234.455 78.3256 234.286 78.2258C234.117 78.1322 233.948 77.9804 233.892 77.9034C233.736 77.6475 234.284 77.4603 234.15 77.2419C234.132 77.3064 234.011 77.3626 233.961 77.3792C233.848 77.296 234.051 77.1899 233.782 77.1608C233.684 77.3917 233.245 77.0235 233.611 77.3355C233.472 77.3418 233.403 77.3127 233.334 77.2773C233.263 77.2399 233.188 77.2024 233.038 77.1546C233.095 77.3397 232.616 77.5831 232.318 77.5602C232.353 77.5061 232.318 77.4104 232.303 77.3647C232.17 77.3147 232.053 77.2648 231.947 77.217C231.849 77.1629 231.753 77.1005 231.662 77.0443C231.478 76.9299 231.297 76.8176 231.053 76.7094C231.031 76.6366 230.829 76.4619 230.97 76.4141C230.889 76.4182 230.795 76.4598 230.654 76.385C230.485 76.0438 230.972 76.5306 230.881 76.1832C230.804 76.3038 230.447 76.1603 230.206 76.125C230.158 76.3496 230.647 76.4245 230.876 76.4536C230.758 76.7323 230.264 76.8197 229.673 76.645C229.446 76.5638 229.441 76.4827 229.466 76.439C229.494 76.3933 229.562 76.3704 229.516 76.3662C229.183 76.0979 228.96 76.1021 228.756 76.0938C228.654 76.0896 228.558 76.0854 228.461 76.0417C228.361 76.0001 228.271 75.9045 228.167 75.7464C228.075 75.4115 228.406 75.4448 228.448 75.295C228.608 75.3845 228.692 75.503 228.767 75.6112C228.844 75.7152 228.906 75.8171 229.01 75.8857L228.817 75.6361C228.95 75.6528 229.175 75.7526 229.25 75.8753C229.229 75.8067 229.148 75.7193 229.031 75.6195C228.973 75.5696 228.906 75.5176 228.835 75.4614C228.769 75.399 228.696 75.3345 228.623 75.2659C228.329 74.9934 227.973 74.7084 227.825 74.4068C227.702 74.3715 227.517 74.2737 227.525 74.3944L227.686 74.5233C227.704 74.7708 227.263 74.3902 227.39 74.6315C227.255 74.567 227.1 74.5067 226.953 74.4172C226.88 74.3715 226.807 74.3216 226.74 74.2571C226.68 74.1884 226.626 74.1094 226.582 74.0158L226.709 73.8182C226.663 73.864 226.765 74.1073 226.886 74.1489C226.705 74.0782 226.751 73.4875 226.411 73.5207L226.461 73.8348C226.207 73.6767 225.772 73.5415 225.647 73.1859C225.555 73.4479 225.709 73.242 225.643 73.6039C225.763 73.242 226.205 74.3548 226.251 73.866C226.213 74.0595 226.261 74.1718 226.317 74.2883C226.376 74.4048 226.438 74.5275 226.467 74.7355C226.515 74.6793 226.486 74.5524 226.671 74.802C226.696 74.7979 226.74 74.802 226.765 74.8083C226.769 74.8166 226.771 74.8208 226.776 74.827C226.776 74.8208 226.771 74.8145 226.769 74.8083C226.786 74.8104 226.788 74.8083 226.767 74.802C226.74 74.7272 226.73 74.6585 226.742 74.6148C226.971 74.6148 227.294 74.9643 227.465 75.0184C227.563 75.1723 227.355 75.0246 227.367 75.1494C227.367 75.1494 227.432 75.1702 227.496 75.191C227.563 75.2077 227.632 75.2243 227.632 75.2243C227.536 75.3553 227.811 75.7381 227.423 75.5238L227.711 75.7838C227.823 76.0001 228.038 76.2435 228.233 76.3101C228.363 76.4453 228.719 76.4349 228.513 76.4453L229.064 76.7157L229.046 76.7531C229.275 76.9424 229.6 77.0339 229.895 77.1671C230.193 77.2939 230.493 77.4811 230.718 77.7245C230.906 77.7619 231.103 77.7952 231.37 77.9637V78.1156C231.399 78.1218 231.43 78.1343 231.464 78.1488L231.489 78.1613L231.495 78.1655L231.549 78.1884L231.564 78.1946C231.582 78.2029 231.603 78.2112 231.622 78.2196C231.701 78.2549 231.785 78.2986 231.866 78.336C232.026 78.413 232.176 78.4733 232.251 78.4213C232.289 78.5336 232.384 78.6189 232.509 78.6876C232.572 78.7208 232.645 78.752 232.72 78.7791C232.797 78.802 232.88 78.8165 232.965 78.8311C233.307 78.8872 233.674 78.9101 233.894 78.9913L233.942 78.8144C234.25 78.8831 234.561 78.8519 234.952 78.8269L234.944 78.6626C235.279 78.5877 235.781 78.8269 236.312 78.8207C236.277 78.881 236.144 78.8644 236.048 78.8248C236.204 78.9184 236.369 78.9496 236.533 78.9476C236.698 78.9372 236.86 78.8831 237.018 78.8311C237.179 78.7791 237.333 78.7229 237.485 78.6938C237.637 78.6647 237.787 78.6668 237.937 78.7021C238.068 78.6189 238.17 78.621 238.276 78.6439C238.264 78.646 238.251 78.6522 238.243 78.6584C238.258 78.6584 238.278 78.6543 238.301 78.6501C238.368 78.6668 238.437 78.6855 238.512 78.7C238.445 78.673 238.383 78.6501 238.333 78.6439C238.439 78.621 238.599 78.5711 238.751 78.5024L238.855 78.6584C238.868 78.6543 238.878 78.6522 238.891 78.646C239.064 78.6792 238.999 78.542 238.887 78.4317C238.962 78.3922 239.024 78.334 239.07 78.2778C239.264 78.5149 239.449 78.074 239.701 78.3132C239.732 78.2279 239.922 78.1468 240.097 78.0469C240.267 77.9304 240.426 77.7952 240.411 77.6371C240.43 77.6725 240.48 77.6725 240.401 77.7058C240.578 77.6746 240.757 77.6434 240.871 77.5061L241.028 77.6808C241.028 77.6808 241.088 77.5768 241.151 77.4749C241.207 77.3647 241.261 77.2544 241.261 77.2544C241.525 77.2731 241.65 77.296 241.513 77.556C241.907 77.0651 241.888 77.2607 242.186 76.8134L242.236 76.9507C242.379 76.855 242.511 76.5472 242.658 76.593C242.775 76.5992 242.935 76.541 243.127 76.4453C243.225 76.3995 243.323 76.335 243.423 76.2602C243.523 76.1853 243.631 76.1062 243.741 76.023C244.2 75.7089 244.643 75.2659 245.099 75.0142C244.879 74.931 244.999 74.8894 245.141 74.827C245.278 74.7584 245.447 74.6752 245.339 74.5504C245.449 74.5732 245.585 74.5046 245.543 74.6856C245.801 74.2321 246.191 74.2092 246.17 73.7454C246.284 73.7579 246.222 73.9222 246.299 73.9159C246.305 73.8681 246.326 73.7308 246.405 73.7225C246.484 73.7142 246.428 73.8327 246.416 73.9263C246.713 73.4791 246.491 73.2649 246.274 73.0735C246.405 73.007 246.486 72.9425 246.528 72.8634C246.564 72.7802 246.559 72.6804 246.526 72.5514C246.651 72.5223 246.816 72.435 246.68 72.7366C246.78 72.5889 247.37 71.8109 247.153 71.7049C247.228 71.6799 247.265 71.4927 247.259 71.4407C247.428 71.0933 247.461 71.0705 247.594 70.7168L247.517 70.798C247.47 70.7356 247.449 70.6856 247.449 70.6399C247.449 70.6295 247.449 70.617 247.451 70.6066L247.455 70.59V70.5858L247.461 70.5712V70.5629C247.47 70.54 247.478 70.5192 247.49 70.4964C247.536 70.4069 247.617 70.3071 247.651 70.1511L247.676 70.1698C247.884 69.8578 247.886 69.7746 247.89 69.6955C247.892 69.656 247.894 69.6165 247.926 69.5499C247.94 69.5167 247.963 69.4751 247.992 69.4231C248.019 69.369 248.055 69.3045 248.101 69.2234L247.924 69.2192C247.751 69.1402 247.836 69.005 247.961 68.8282C248.084 68.6514 248.248 68.4309 248.221 68.2146L248.094 68.3435C248.061 68.225 248.201 68.0898 248.365 67.9525C248.53 67.8152 248.717 67.6717 248.755 67.5573C248.792 67.5094 248.796 67.6425 248.813 67.7174C249.102 67.1225 248.596 67.6134 248.596 67.1558C248.723 67.0809 248.902 67.2889 248.944 66.979C248.994 66.9041 248.9 66.6712 248.821 66.4112C248.782 66.2822 248.746 66.1449 248.738 66.0139C248.734 65.9494 248.734 65.8849 248.744 65.8246C248.75 65.7643 248.763 65.706 248.788 65.6519C248.7 65.7497 248.615 65.8412 248.528 65.6374C248.498 65.4793 248.569 65.2588 248.607 65.0383C248.642 64.8199 248.659 64.6015 248.478 64.4809C248.496 64.4372 248.517 64.4185 248.54 64.4122C248.421 64.1793 248.271 63.6447 248.088 63.5386C248.359 63.3639 248.176 63.0082 248.007 62.692C247.919 62.536 247.842 62.3842 247.801 62.2677C247.759 62.1512 247.776 62.0618 247.905 62.016L247.603 61.3213L247.661 61.3171C247.597 61.08 247.484 60.949 247.392 60.8554C247.297 60.7638 247.199 60.716 247.101 60.6723C247.084 60.5558 247.168 60.6058 247.197 60.5995C246.988 59.9152 246.891 59.8715 246.357 59.5221L246.474 59.3723C246.43 59.3536 246.391 59.2808 246.345 59.1747C246.301 59.0686 246.23 58.9396 246.157 58.794C246.082 58.6484 245.993 58.4924 245.885 58.3448C245.778 58.1971 245.653 58.0598 245.491 57.9703C245.512 57.962 245.547 57.9495 245.603 57.9724C245.428 57.8643 245.287 57.7041 245.156 57.5273C245.022 57.3526 244.916 57.1487 244.777 56.9948C244.514 56.6745 244.254 56.429 243.941 56.5892C243.941 56.5892 243.823 56.531 243.691 56.4935C243.564 56.4519 243.435 56.4103 243.435 56.4103C243.935 56.8284 243.187 56.5788 243.337 56.8201C243.115 56.7078 242.923 56.2855 243.196 56.4374L243.217 56.4914C243.508 56.2855 242.631 55.9194 242.758 55.7468C242.467 55.5845 242.181 55.414 241.9 55.2372C241.759 55.1415 241.623 55.0749 241.488 55.0042C241.353 54.9314 241.219 54.8607 241.086 54.79C240.953 54.7172 240.819 54.6464 240.688 54.5757L240.663 54.5632L240.603 54.5383L240.549 54.5154L240.438 54.4696L240.217 54.3823C239.924 54.27 239.632 54.1472 239.334 54.0661C239.334 54.0661 239.353 54.1368 239.37 54.2096C239.389 54.2804 239.403 54.3552 239.403 54.3552C239.403 54.3552 239.378 54.3448 239.341 54.3344C239.303 54.324 239.251 54.3115 239.199 54.2991C239.097 54.272 238.993 54.2471 238.993 54.2471C238.899 54.1639 238.893 54.0141 239.191 54.0911C239.066 53.9101 238.658 54.1015 238.641 54.1576C238.076 53.9267 238.93 53.9059 238.755 53.8623L238.503 53.8269L238.553 53.8685C238.443 53.8997 238.378 53.9434 238.297 53.9663C238.258 53.9787 238.212 53.985 238.156 53.985C238.097 53.9891 238.029 53.985 237.937 53.9725C237.714 53.8935 237.841 53.7978 237.752 53.777C237.754 53.7583 237.724 53.7458 237.612 53.7541L237.073 53.6709L237.27 53.9018C237.025 53.9746 236.771 53.8394 237 54.0973C236.835 53.8997 236.333 53.8685 235.85 53.856C235.367 53.8706 234.907 53.9559 234.79 53.9039C234.711 53.9475 234.632 53.9829 234.55 54.012C234.471 54.0453 234.39 54.0744 234.305 54.0973C234.136 54.1431 233.957 54.1701 233.755 54.1971C233.863 54.2221 233.963 54.4405 233.621 54.4738C233.634 54.2304 233.463 54.193 233.251 54.218C233.038 54.2408 232.78 54.2949 232.593 54.168C232.749 54.2429 232.509 54.3261 232.295 54.4135C232.078 54.5029 231.899 54.6298 232.136 54.7088C231.853 54.7775 232.062 54.5445 231.814 54.5196C231.666 54.6277 231.501 54.7088 231.322 54.7754C231.233 54.8108 231.139 54.8378 231.045 54.8711C230.954 54.9064 230.858 54.9418 230.762 54.9792C230.381 55.1269 229.952 55.2434 229.606 55.5201C229.629 55.5804 229.8 55.5866 229.693 55.7655C229.693 55.7655 229.556 55.7593 229.416 55.753L229.135 55.7426C229.071 55.8029 229.087 55.8986 229.075 55.9797C229.058 56.0588 229.014 56.1233 228.829 56.1316C228.896 56.1482 228.994 56.1732 228.917 56.2585C228.148 56.635 227.519 57.259 226.967 57.9225C226.694 58.2595 226.401 58.5777 226.136 58.923C225.997 59.0894 225.849 59.2517 225.688 59.4056C225.526 59.5574 225.38 59.7363 225.201 59.8944C225.43 59.7425 225.359 59.8902 225.272 60.0525C225.357 59.963 225.409 60.1294 225.495 60.1502C225.495 60.1502 225.351 60.2813 225.209 60.4123C225.136 60.481 225.066 60.5475 225.012 60.5995C224.982 60.6266 224.966 60.6453 224.951 60.6598C224.937 60.6744 224.93 60.6827 224.93 60.6827C225.097 60.8928 224.647 61.3608 224.826 61.5189L224.876 61.3047C225.005 61.677 225.586 61.1778 225.886 61.3567C225.849 61.2527 225.878 61.1632 225.938 61.0758C226.003 60.9947 226.107 60.9282 226.205 60.8512C226.405 60.6994 226.59 60.535 226.526 60.2064C226.64 60.1482 226.574 60.3458 226.671 60.3374C226.599 60.1502 226.671 60.0067 226.892 59.8112L226.903 59.859C227.125 59.5262 227.296 59.2933 227.538 59.106C227.652 59.0104 227.771 58.9126 227.904 58.8024C228.036 58.6921 228.173 58.5652 228.358 58.4363L228.19 58.3614C228.346 58.2449 228.413 58.2553 228.508 58.2262C228.492 57.8871 228.104 58.586 228.05 58.2449C228.269 58.2782 228.517 58.0473 228.762 57.8268C228.879 57.7103 229.023 57.6271 229.142 57.5647C229.264 57.5065 229.377 57.4857 229.469 57.5398C229.702 57.363 229.281 57.4358 229.516 57.2569L229.641 57.2943L229.621 57.1362C229.787 57.0322 229.954 57.105 230.008 57.1716C229.962 57.1882 229.91 57.2631 229.873 57.2943C230.152 57.2694 230.437 56.8887 230.533 56.8783L230.262 56.9719C230.418 56.8471 230.587 56.7161 230.774 56.61C230.966 56.5122 231.164 56.4103 231.36 56.3105C231.458 56.2585 231.553 56.2065 231.651 56.1545C231.751 56.1108 231.849 56.0671 231.945 56.0193C232.137 55.9257 232.318 55.8196 232.482 55.6969L232.401 55.6428C232.466 55.5991 232.52 55.5617 232.57 55.5367C232.622 55.5138 232.666 55.4993 232.707 55.4868C232.788 55.4639 232.853 55.4597 232.918 55.4577C233.051 55.4535 233.19 55.4577 233.499 55.3349L233.48 55.3599C233.586 55.2392 233.755 55.1748 233.934 55.1498C233.79 55.2725 234.275 55.2746 234.082 55.4161C234.688 55.1477 234.367 55.2247 234.759 54.8711L234.875 54.9959C235.011 54.8648 235.017 54.8004 235.35 54.738C235.086 54.8752 235.575 54.9231 235.283 55.0999C235.461 55.1581 235.608 55.1644 235.74 55.1456C235.871 55.1332 235.985 55.1082 236.09 55.0791C236.298 55.025 236.466 54.9876 236.612 55.2039C236.948 54.8399 236.021 54.9896 236.2 54.9127C236.048 54.79 236.471 54.6402 236.696 54.6818C236.927 54.6818 237.048 55.1831 237.589 55.2351C237.535 55.2268 237.529 55.2538 237.475 55.2476C237.57 55.3058 237.674 55.285 237.783 55.2725C237.837 55.2663 237.893 55.2621 237.949 55.2725C238.006 55.2871 238.062 55.3141 238.116 55.3661C238.295 55.1768 238.433 55.4493 238.533 55.1789L238.018 55.1332C238.31 55.1207 238.655 54.8544 239.097 55.1165C239.045 55.1644 238.885 55.206 238.78 55.2268C238.895 55.3412 239.062 55.2226 239.176 55.3537C239.066 55.6033 238.553 55.2788 238.212 55.4202C238.328 55.57 238.82 55.3412 238.601 55.6095C238.753 55.441 238.885 55.4826 239.028 55.5388C239.17 55.6074 239.32 55.6969 239.543 55.6116L239.468 55.7676C239.53 55.7593 239.672 55.7218 239.774 55.7593L239.518 55.909C239.688 55.8653 239.813 55.9485 239.928 56.0421L240.015 56.1108L240.026 56.1191H240.028V56.1212C240.028 56.1212 239.943 56.0858 239.982 56.1025L239.988 56.1066L240.011 56.1253L240.057 56.1607C240.12 56.2065 240.188 56.2398 240.27 56.246C240.122 56.1815 240.045 56.1357 240.009 56.0962C240.005 56.0921 240.001 56.0858 239.999 56.0817L239.995 56.0754C239.984 56.0713 240.078 56.1108 240.038 56.0941V56.09C240.034 56.0817 240.032 56.0733 240.032 56.0671C240.032 56.0525 240.036 56.0359 240.045 56.0213C240.078 55.961 240.159 55.8986 240.059 55.8009C240.084 55.8009 240.107 55.8029 240.13 55.8029H240.147H240.151C240.178 55.8133 240.115 55.7884 240.122 55.7905H240.13L240.161 55.7988C240.203 55.8092 240.238 55.8196 240.27 55.8321C240.334 55.857 240.382 55.8861 240.417 55.9173C240.49 55.9818 240.522 56.0629 240.553 56.1461C240.613 56.3167 240.688 56.506 241.096 56.6516C240.99 56.6225 240.728 56.375 240.936 56.377C241.003 56.429 241.092 56.4873 241.148 56.558C241.205 56.6266 241.248 56.6994 241.269 56.7618C241.73 56.9886 241.28 56.5642 241.517 56.5809C241.577 56.8554 241.782 56.635 242.025 56.6953L241.938 56.845C241.996 56.895 242.046 56.9262 242.088 56.949C242.129 56.974 242.163 56.9886 242.192 56.9927C242.25 57.001 242.29 56.9761 242.329 56.949C242.404 56.895 242.475 56.8409 242.671 57.0634L242.338 57.1217L242.613 57.2423L242.448 57.3692C242.619 57.4004 242.721 57.4399 242.806 57.4982C242.894 57.5564 242.965 57.6313 243.06 57.7603C243.083 57.6167 243.289 57.5419 243.508 57.7249C243.585 57.9287 243.319 57.779 243.635 58.0203C243.494 58.0411 243.333 58.0827 243.308 57.8476C243.258 57.8788 243.173 57.8726 243.123 57.9038C243.196 58.1263 243.483 58.2532 243.591 58.3448C243.556 58.3052 243.512 58.2553 243.504 58.2158C243.504 58.2158 243.652 58.2615 243.8 58.3156C243.939 58.378 244.081 58.4384 244.081 58.4384C244.096 58.5507 244.01 58.534 243.925 58.5195C244.016 58.5902 244.129 58.5923 244.256 58.7067C244.123 58.7712 244.023 58.8772 243.814 58.7524L244.293 59.0332C244.275 59.0998 244.352 59.3432 244.264 59.3265C244.32 59.468 244.481 59.5657 244.652 59.6781C244.816 59.7925 245.006 59.911 245.066 60.1086C245.099 60.1086 245.143 60.1294 245.203 60.1897C245.289 60.3562 245.339 60.5309 245.416 60.6952C245.453 60.7784 245.503 60.8574 245.56 60.9365C245.612 61.0176 245.68 61.0967 245.772 61.1736L245.658 61.5085C245.864 61.7872 245.791 61.0654 246.137 61.5376C246.395 61.8725 246.012 61.7623 246.003 61.9203C246.191 62.0514 246.564 62.2927 246.507 62.7128C246.418 62.613 246.418 62.5111 246.357 62.4092L246.347 62.4112ZM247.153 66.5713C247.118 66.486 247.007 66.3217 247.111 66.2614C247.309 66.3571 247.213 66.432 247.153 66.5713ZM245.433 72.8967C245.422 72.8114 245.503 72.747 245.622 72.6929C245.587 72.7678 245.528 72.8385 245.433 72.8967ZM227.988 75.917C227.988 75.917 227.996 75.917 228 75.917C228.117 76.1083 228.077 76.0397 227.988 75.917ZM227.704 75.5696C227.654 75.5592 227.64 75.5779 227.638 75.6091C227.69 75.5966 227.767 75.659 227.844 75.7422C227.85 75.6881 227.829 75.6257 227.704 75.5696ZM237.687 53.8415L237.766 53.8955C237.57 53.9226 237.629 53.8851 237.687 53.8415Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.659 72.1394C245.697 72.1352 245.726 72.1457 245.758 72.1583C245.75 72.1142 245.72 72.0974 245.659 72.1394Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.062 60.1209C245.062 60.1209 245.058 60.1126 245.058 60.1084C245.045 60.1084 245.035 60.1105 245.024 60.1147L245.062 60.1189V60.1209Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.004 77.123C234.077 77.1646 234.115 77.2062 234.14 77.2437C234.152 77.2021 234.123 77.1605 234.004 77.123Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.896 74.0366L226.11 74.2363C226.018 74.1323 226.018 74.0699 225.997 73.9971C225.968 74.0262 225.955 74.1052 225.899 74.0366H225.896Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.549 71.4424C225.512 71.4174 225.51 71.3696 225.474 71.3467L225.405 71.3904C225.485 71.536 225.595 71.6088 225.549 71.4424Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.2 73.4854C226.311 73.3794 226.15 73.2837 226.032 73.1318C226.038 73.1422 226.044 73.1506 226.05 73.161C225.95 73.1942 225.942 73.2462 225.98 73.3045C226.019 73.3627 226.111 73.423 226.2 73.4854Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.005 73.0989C225.968 73.0531 225.932 73.0032 225.907 72.9512C225.826 72.9761 225.932 73.0219 226.005 73.0989Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M227.227 75.2597C227.19 75.164 227.054 75.3491 227.058 75.268C226.956 75.295 227.106 75.372 227.225 75.399C227.283 75.4157 227.342 75.4136 227.352 75.3949C227.362 75.3761 227.331 75.3366 227.225 75.2597H227.227Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.498 73.084L226.392 73.2421L226.573 73.2379L226.498 73.084Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M227.325 74.3025L227.159 74.0529C227.14 74.0758 227.1 74.0612 227.057 74.0342C227.18 74.1715 227.292 74.3441 227.325 74.3025Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M227.057 74.0347C226.997 73.9598 226.94 73.887 226.884 73.8662C226.919 73.9057 226.988 73.9931 227.057 74.0347Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.788 73.3711L226.813 73.4626L226.93 73.6353L226.788 73.3711Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M229.768 76.3873L230.081 76.5058C230.139 76.4684 230.081 76.3914 229.964 76.354C229.875 76.354 229.756 76.3124 229.768 76.3894V76.3873Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M229.249 75.4277C229.297 75.5068 229.276 75.5421 229.28 75.6191L229.42 75.4444L229.249 75.4277Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.026 75.9063C230.088 75.8689 230.501 75.9708 230.161 75.794C230.103 75.8356 229.811 75.7149 230.026 75.9063Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M234.374 77.8158L234.292 77.8096L234.246 78.1715L234.374 77.8158Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.416 76.8259C238.053 76.8009 238.378 77.063 238.041 77.011C237.974 77.1109 238.316 77.0526 238.247 77.1421C238.443 77.0131 238.564 77.0443 238.416 76.8259Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M238.25 77.1426C238.219 77.1636 238.185 77.1867 238.149 77.2182C238.208 77.1846 238.234 77.1615 238.25 77.1426Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.56 61.0283L224.389 61.2218L224.566 61.1261L224.56 61.0283Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.616 61.5709L224.378 61.5293L224.512 61.7498C224.524 61.6957 224.549 61.5875 224.616 61.5709Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.646 67.1642L246.701 67.185C246.766 67.1559 246.776 67.106 246.799 67.002L246.646 67.1621V67.1642Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M246.659 64.1693L246.663 64.2213L246.854 64.084L246.659 64.1693Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M245.637 61.8685C245.679 61.96 245.764 62.0536 245.793 62.1514C245.685 61.9579 245.862 61.7354 245.637 61.8685Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M0.753633 42.4431C2.2886 41.7297 3.88605 41.1389 5.55015 40.6668C7.21216 40.1967 8.87209 39.7786 10.532 39.4146L12.2065 36.8998C13.6769 34.8822 15.1682 32.929 16.6802 31.0424C18.1902 29.1558 19.7689 27.2713 21.4122 25.3847C23.0096 23.5855 24.6612 21.8216 26.367 20.0889C28.0706 18.3562 29.8722 16.7484 31.7695 15.257C32.6964 14.5331 33.6419 13.855 34.6125 13.2185C35.5788 12.582 36.5681 12.0121 37.5803 11.5087C37.8428 11.3819 38.2718 11.1946 38.8633 10.943C39.4548 10.6913 40.0567 10.4958 40.669 10.3543C41.2813 10.2129 41.8478 10.1692 42.3685 10.2191C42.8892 10.2711 43.2329 10.5394 43.3995 11.0199C43.4807 11.3257 43.4432 11.6398 43.2849 11.9643C43.1266 12.2888 43.0017 12.5779 42.91 12.8379L41.3563 15.8768L40.0734 18.3978C39.1736 20.0785 38.3072 21.7592 37.4741 23.4399C36.639 25.1205 35.8163 26.847 35.004 28.615C34.2813 30.1667 33.5794 31.7205 32.9005 33.2743C32.2215 34.8281 31.5842 36.4256 30.9906 38.0667C31.3384 38.073 31.6758 38.1 32.0007 38.1478C32.3256 38.1978 32.6193 38.2664 32.8796 38.3579C33.3982 38.5846 33.6419 38.9695 33.6107 39.5123C33.5794 40.0552 33.3024 40.4088 32.7776 40.5732C32.384 40.6543 31.9695 40.6688 31.5363 40.6168C31.101 40.5669 30.6449 40.4941 30.1679 40.3984L29.8826 41.7629C29.6056 42.6719 29.339 43.635 29.0828 44.6521C28.8267 45.6693 28.6121 46.6864 28.4434 47.7056C28.2727 48.7228 28.1581 49.7316 28.0977 50.7321C28.0373 51.7305 28.4893 50.2786 28.6475 51.1939C29.8868 49.9978 30.4095 50.5407 31.6258 49.8127C32.9713 49.0057 34.5417 48.0093 35.9308 47.2043C37.1305 46.416 38.8571 45.7857 40.5149 44.9933C42.7205 43.9387 45.678 42.1956 47.8732 41.0599C48.0919 40.933 48.2897 40.9039 48.4626 40.9725C48.6354 41.0412 48.775 41.1639 48.8812 41.3386C48.9874 41.5154 49.027 41.7005 49.002 41.8961C48.977 42.0916 48.8541 42.2518 48.6354 42.3786L45.1011 44.4108C43.7931 44.8934 42.8996 45.22 41.777 45.8752C40.6565 46.5304 40.3441 46.5866 39.1341 47.2979C36.2078 48.6978 33.5399 49.7212 30.5262 52.0737C30.3033 52.4169 30.068 52.7185 29.8264 52.9744C29.5827 53.2302 29.2203 53.3987 28.7413 53.4777C28.1289 53.5547 27.6541 53.459 27.3104 53.1928C26.9668 52.9265 26.7002 52.5729 26.5128 52.1361C26.3253 51.6972 26.2128 51.2188 26.1795 50.6967C26.1441 50.1746 26.1524 49.6962 26.2045 49.2615C26.2795 47.3499 26.1941 47.8304 26.7502 45.8835C27.3042 43.9366 27.9019 42.0562 28.5434 40.2404C27.804 40.1842 27.0647 40.1405 26.3253 40.1052C25.5859 40.0719 24.8466 40.0469 24.1072 40.0344C22.5431 39.9221 20.9748 39.8951 19.4086 39.9554C17.8403 40.0157 16.2928 40.1426 14.7662 40.334L11.7567 40.7396L10.8132 42.4182C10.2738 43.4103 9.71143 44.442 9.12826 45.5195C8.54302 46.5949 8.17646 47.6973 8.0265 48.8268C7.97652 49.1741 7.89529 49.5194 7.78074 49.8668C7.66619 50.2121 7.36836 50.4034 6.88934 50.4388C6.49778 50.4326 6.18329 50.2953 5.95003 50.0311C5.71468 49.7669 5.62304 49.4612 5.67094 49.1138C5.73134 48.028 6.04375 46.9693 6.60609 45.9355C7.16842 44.9017 7.69535 43.9324 8.18896 43.0276C8.36807 42.6823 8.54718 42.3807 8.7263 42.1228C8.90541 41.8649 9.10535 41.5653 9.33029 41.2201C8.71797 41.3407 8.13897 41.4717 7.5933 41.6153C7.04554 41.7588 6.46654 41.9335 5.85422 42.1394C5.06695 42.3454 4.31301 42.5929 3.5903 42.8841C2.8676 43.1774 2.1324 43.4894 1.38678 43.8243C1.16601 43.9512 0.959823 43.9699 0.76613 43.8783C0.572436 43.7889 0.443307 43.6558 0.380826 43.4811C0.318344 43.3063 0.310013 43.1212 0.357916 42.9257C0.403736 42.7302 0.53703 42.57 0.757799 42.4431H0.753633ZM29.4265 37.9086C30.6074 34.93 31.8445 32.0159 33.1337 29.1683C34.4229 26.3207 35.7226 23.4523 37.0347 20.5632C37.6657 19.2694 38.276 17.9652 38.8633 16.6485C39.4506 15.3339 40.0192 13.984 40.5649 12.6028C39.561 12.7609 38.5551 13.0812 37.5449 13.5617C36.5348 14.0443 35.5684 14.6038 34.6437 15.2403C33.719 15.8768 32.8484 16.5362 32.032 17.2184C31.2155 17.9007 30.4533 18.5393 29.7472 19.1362C26.0358 22.4206 22.5785 26.0565 19.3773 30.0461C17.1072 32.9644 14.9453 35.9263 12.8938 38.9341L18.3256 38.2435C19.9376 38.1395 21.5496 38.0709 23.1596 38.0314C24.7695 37.9939 26.4024 38.0313 28.054 38.1478L29.3598 38.1707C29.3619 38.0397 29.3848 37.9544 29.4306 37.9107L29.4265 37.9086Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M0.753633 42.4431C2.2886 41.7297 3.88605 41.1389 5.55015 40.6668C7.21216 40.1967 8.87209 39.7786 10.532 39.4146L12.2065 36.8998C13.6769 34.8822 15.1682 32.929 16.6802 31.0424C18.1902 29.1558 19.7689 27.2713 21.4122 25.3847C23.0096 23.5855 24.6612 21.8216 26.367 20.0889C28.0706 18.3562 29.8722 16.7484 31.7695 15.257C32.6964 14.5331 33.6419 13.855 34.6125 13.2185C35.5788 12.582 36.5681 12.0121 37.5803 11.5087C37.8428 11.3819 38.2718 11.1946 38.8633 10.943C39.4548 10.6913 40.0567 10.4958 40.669 10.3543C41.2813 10.2129 41.8478 10.1692 42.3685 10.2191C42.8892 10.2711 43.2329 10.5394 43.3995 11.0199C43.4807 11.3257 43.4432 11.6398 43.2849 11.9643C43.1266 12.2888 43.0017 12.5779 42.91 12.8379L41.3563 15.8768L40.0734 18.3978C39.1736 20.0785 38.3072 21.7592 37.4741 23.4399C36.639 25.1205 35.8163 26.847 35.004 28.615C34.2813 30.1667 33.5794 31.7205 32.9005 33.2743C32.2215 34.8281 31.5842 36.4256 30.9906 38.0667C31.3384 38.073 31.6758 38.1 32.0007 38.1478C32.3256 38.1978 32.6193 38.2664 32.8796 38.3579C33.3982 38.5846 33.6419 38.9695 33.6107 39.5123C33.5794 40.0552 33.3024 40.4088 32.7776 40.5732C32.384 40.6543 31.9695 40.6688 31.5363 40.6168C31.101 40.5669 30.6449 40.4941 30.1679 40.3984L29.8826 41.7629C29.6056 42.6719 29.339 43.635 29.0828 44.6521C28.8267 45.6693 28.6121 46.6864 28.4434 47.7056C28.2727 48.7228 28.1581 49.7316 28.0977 50.7321C28.0373 51.7305 28.4893 50.2786 28.6475 51.1939C29.8868 49.9978 30.4095 50.5407 31.6258 49.8127C32.9713 49.0057 34.5417 48.0093 35.9308 47.2043C37.1305 46.416 38.8571 45.7857 40.5149 44.9933C42.7205 43.9387 45.678 42.1956 47.8732 41.0599C48.0919 40.933 48.2897 40.9039 48.4626 40.9725C48.6354 41.0412 48.775 41.1639 48.8812 41.3386C48.9874 41.5154 49.027 41.7005 49.002 41.8961C48.977 42.0916 48.8541 42.2518 48.6354 42.3786L45.1011 44.4108C43.7931 44.8934 42.8996 45.22 41.777 45.8752C40.6565 46.5304 40.3441 46.5866 39.1341 47.2979C36.2078 48.6978 33.5399 49.7212 30.5262 52.0737C30.3033 52.4169 30.068 52.7185 29.8264 52.9744C29.5827 53.2302 29.2203 53.3987 28.7413 53.4777C28.1289 53.5547 27.6541 53.459 27.3104 53.1928C26.9668 52.9265 26.7002 52.5729 26.5128 52.1361C26.3253 51.6972 26.2128 51.2188 26.1795 50.6967C26.1441 50.1746 26.1524 49.6962 26.2045 49.2615C26.2795 47.3499 26.1941 47.8304 26.7502 45.8835C27.3042 43.9366 27.9019 42.0562 28.5434 40.2404C27.804 40.1842 27.0647 40.1405 26.3253 40.1052C25.5859 40.0719 24.8466 40.0469 24.1072 40.0344C22.5431 39.9221 20.9748 39.8951 19.4086 39.9554C17.8403 40.0157 16.2928 40.1426 14.7662 40.334L11.7567 40.7396L10.8132 42.4182C10.2738 43.4103 9.71143 44.442 9.12826 45.5195C8.54302 46.5949 8.17646 47.6973 8.0265 48.8268C7.97652 49.1741 7.89529 49.5194 7.78074 49.8668C7.66619 50.2121 7.36836 50.4034 6.88934 50.4388C6.49778 50.4326 6.18329 50.2953 5.95003 50.0311C5.71468 49.7669 5.62304 49.4612 5.67094 49.1138C5.73134 48.028 6.04375 46.9693 6.60609 45.9355C7.16842 44.9017 7.69535 43.9324 8.18896 43.0276C8.36807 42.6823 8.54718 42.3807 8.7263 42.1228C8.90541 41.8649 9.10535 41.5653 9.33029 41.2201C8.71797 41.3407 8.13897 41.4717 7.5933 41.6153C7.04554 41.7588 6.46654 41.9335 5.85422 42.1394C5.06695 42.3454 4.31301 42.5929 3.5903 42.8841C2.8676 43.1774 2.1324 43.4894 1.38678 43.8243C1.16601 43.9512 0.959823 43.9699 0.76613 43.8783C0.572436 43.7889 0.443307 43.6558 0.380826 43.4811C0.318344 43.3063 0.310013 43.1212 0.357916 42.9257C0.403736 42.7302 0.53703 42.57 0.757799 42.4431H0.753633ZM29.4265 37.9086C30.6074 34.93 31.8445 32.0159 33.1337 29.1683C34.4229 26.3207 35.7226 23.4523 37.0347 20.5632C37.6657 19.2694 38.276 17.9652 38.8633 16.6485C39.4506 15.3339 40.0192 13.984 40.5649 12.6028C39.561 12.7609 38.5551 13.0812 37.5449 13.5617C36.5348 14.0443 35.5684 14.6038 34.6437 15.2403C33.719 15.8768 32.8484 16.5362 32.032 17.2184C31.2155 17.9007 30.4533 18.5393 29.7472 19.1362C26.0358 22.4206 22.5785 26.0565 19.3773 30.0461C17.1072 32.9644 14.9453 35.9263 12.8938 38.9341L18.3256 38.2435C19.9376 38.1395 21.5496 38.0709 23.1596 38.0314C24.7695 37.9939 26.4024 38.0313 28.054 38.1478L29.3598 38.1707C29.3619 38.0397 29.3848 37.9544 29.4306 37.9107L29.4265 37.9086Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M28.7878 37.8106C28.8443 37.6379 28.9237 37.5131 28.9258 37.4695C28.9341 37.4195 28.8819 37.4279 28.9174 37.3779C28.7941 37.5048 28.7565 37.6005 28.7314 37.6629C28.7105 37.7253 28.7042 37.7669 28.7021 37.796C28.7021 37.8543 28.7147 37.8667 28.7293 37.8688C28.7586 37.8709 28.8004 37.8085 28.7857 37.8106H28.7878Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M27.5275 37.7359L27.5649 37.6943L27.2588 37.7838L27.5275 37.7359Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M25.6152 37.6529C25.7902 37.838 26.3088 37.6425 26.6483 37.7236L26.7024 37.7673L26.8628 37.6279C26.4462 37.63 25.9068 37.7111 25.6152 37.6529Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M24.5971 37.2451C24.6596 37.3158 24.3742 37.3034 24.8366 37.2701C24.8137 37.2618 24.8074 37.2576 24.7929 37.2514C24.7512 37.2514 24.695 37.2514 24.5971 37.2451Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M24.7932 37.2517C24.6586 37.1908 24.9993 37.2475 24.7932 37.2517V37.2517Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23.8551 37.2929L24.1217 37.2285C24.0655 37.1869 23.828 37.1806 23.9155 37.1494C23.6406 37.1869 23.6989 37.2264 23.8551 37.295V37.2929Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23.6035 37.4278L23.7414 37.3986C23.7164 37.382 23.6808 37.3758 23.6035 37.4278Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M24.0349 37.3408L23.7412 37.3991C23.7808 37.4282 23.7849 37.4864 23.8766 37.3783C23.8537 37.4323 23.9099 37.3783 24.0349 37.3408Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M24.2012 37.3675C24.3511 37.407 24.5448 37.432 24.2762 37.4944C24.7864 37.4694 24.7114 37.3425 24.2012 37.3675Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M25.513 37.8381L25.7108 37.8963L25.8837 37.8402C25.7962 37.8672 25.5026 37.7819 25.513 37.8402V37.8381Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M22.1908 37.251C22.1762 37.2905 22.2845 37.3508 22.3053 37.3987L22.5011 37.3467C22.3991 37.3238 22.2075 37.3092 22.1908 37.2531V37.251Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M22.3062 37.3984L22.0146 37.4775C22.2771 37.4733 22.325 37.44 22.3062 37.3984Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23.5595 37.6299L24.0407 37.4863L23.4658 37.634L23.5595 37.6299Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21.0666 37.2949L21.2291 37.1992L20.9375 37.3469L21.0666 37.2949Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.3208 37.3443C20.4395 37.2652 20.1438 37.2278 20.2708 37.1758C20.0688 37.1987 19.9001 37.2694 19.748 37.3318C19.9105 37.2923 20.0896 37.2923 20.3208 37.3443Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19.4922 37.4276C19.5734 37.4068 19.6567 37.3714 19.7484 37.334C19.6609 37.3548 19.5776 37.3839 19.4922 37.4276Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21.5156 37.4797C21.4926 37.4568 21.4445 37.3986 21.2773 37.3799L21.3986 37.4839C21.4341 37.4839 21.4738 37.4818 21.5156 37.4797Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21.4016 37.4885L21.3974 37.4844C21.2724 37.4865 21.1849 37.4885 21.1475 37.4885C21.1787 37.4885 21.2558 37.4885 21.4016 37.4885Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21.5452 37.4795C21.5343 37.4795 21.5255 37.4795 21.5146 37.4795C21.5277 37.4905 21.5343 37.4949 21.5452 37.4795Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M22.7893 37.5547C22.6185 37.6233 22.2624 37.7044 22.6123 37.7814C22.7331 37.7024 22.5331 37.6587 22.7893 37.5547Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21.6914 37.6091L22.0038 37.6195C21.9976 37.5904 21.9392 37.5509 22.0226 37.5176L21.6914 37.607V37.6091Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21.541 37.6503L21.6915 37.6087L21.5765 37.6045L21.541 37.6503Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.0354 37.5045C19.9042 37.5586 19.7563 37.569 19.5918 37.5836C19.7709 37.596 19.9563 37.6002 20.1312 37.5919C20.1541 37.5565 20.227 37.492 20.0354 37.5045Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.7014 37.5049C20.7014 37.5049 20.6796 37.5115 20.6709 37.5137C20.6905 37.5225 20.7058 37.5247 20.7014 37.5049Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.9551 37.6798L17.9822 37.6966L17.9863 37.6777L17.9551 37.6798Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.163 37.6106C20.2984 37.6252 20.3775 37.596 20.4504 37.5586C20.3504 37.5732 20.2442 37.5856 20.1318 37.5919C20.1213 37.6085 20.1213 37.6189 20.163 37.6106Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19.0381 37.4983C19.1091 37.517 19.1906 37.5337 19.2763 37.5482C19.2053 37.517 19.0611 37.4692 19.0381 37.4983Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.6233 37.4867C20.6233 37.4867 20.6358 37.4825 20.642 37.4804C20.5962 37.4595 20.6024 37.4699 20.6233 37.4867Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.6237 37.4863C20.5547 37.505 20.5024 37.5342 20.4502 37.5612C20.5317 37.5487 20.6069 37.5342 20.6717 37.5154C20.655 37.5092 20.6362 37.4967 20.6237 37.4884V37.4863Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.5346 38.4368C17.5471 38.3328 17.8845 38.1976 18.1948 38.2662C18.4822 38.156 18.2594 37.8481 17.9824 37.6963C17.9782 37.742 17.9824 37.7816 17.6824 37.8793C17.7949 37.9209 18.3697 37.9209 18.1219 38.0457C17.7241 38.1477 17.7887 38.052 17.5866 38.0249C17.7657 38.1289 17.093 38.2725 17.2013 38.443L17.5471 38.3328C17.5575 38.3598 17.4346 38.4222 17.5346 38.4368Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.5674 37.6586L18.6924 37.6399C18.5466 37.6295 18.4383 37.5921 18.2404 37.5234C18.0363 37.5983 17.9967 37.642 17.9863 37.6774C18.0905 37.667 18.1925 37.6524 18.2967 37.6482L18.6091 37.642L18.5674 37.6586Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19.2628 37.6154C19.1732 37.7298 18.8733 37.788 19.0691 37.8983C19.4398 37.8754 19.3211 37.7964 19.5398 37.7381C18.9421 37.7922 19.7064 37.6695 19.269 37.6279C19.3857 37.605 19.4919 37.5946 19.5919 37.5842C19.4836 37.5759 19.3773 37.5634 19.2774 37.5488C19.2836 37.5509 19.2878 37.553 19.2919 37.5551H19.294C19.3211 37.5675 19.3294 37.5759 19.3003 37.5696C19.3003 37.5696 19.2919 37.5717 19.2878 37.5717C19.2857 37.5863 19.2753 37.6008 19.2649 37.6133C19.0899 37.5987 19.2357 37.5863 19.2878 37.5717C19.2878 37.5655 19.294 37.5613 19.294 37.5551H19.2919L18.6963 37.6404C18.8254 37.6508 18.9837 37.6403 19.2649 37.6154H19.2628Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M22.3001 38.031C22.2813 38.0226 22.2813 38.0142 22.2792 38.0059C22.2415 38.0205 22.2269 38.031 22.3001 38.031Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M22.0519 37.9754C22.0957 37.9588 22.129 37.913 22.2706 37.9172C22.3935 37.9442 22.2706 37.9692 22.279 38.0046C22.3623 37.9713 22.5747 37.913 22.306 37.8714L22.2644 37.8881C22.0228 37.861 21.7062 37.7383 21.7479 37.7217C21.8228 37.8174 21.8874 37.8839 22.0519 37.9734V37.9754Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.6461 37.8232L20.1504 37.8981L20.4107 37.9813L20.3941 37.9252C20.6794 37.9356 20.6128 37.8669 20.6461 37.8232Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.8924 37.6336L17.9465 37.5088L17.6758 37.7085L17.8924 37.6336Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.2491 37.73L17.2616 37.626L17.0986 37.7092L17.2491 37.73Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M33.9902 14.9597L34.0947 14.8516C34.0425 14.8994 34.0111 14.9327 33.9902 14.9597Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M33.1152 15.5834L33.1236 15.6399C33.1466 15.5876 33.1508 15.5604 33.1152 15.5834Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.1152 30.1392C20.3214 30.0352 20.5818 29.9457 20.4776 29.8937L20.3506 29.875C20.2735 30.0019 20.1923 30.0809 20.1152 30.1412V30.1392Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M26.9195 21.7178C26.8965 21.724 26.8735 21.7303 26.8505 21.7365C26.8401 21.7989 26.8296 21.8592 26.8213 21.9133C26.8505 21.8551 26.884 21.7885 26.9195 21.7178Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M26.7109 21.2851L26.965 21.1416C26.9025 21.1666 26.8192 21.2123 26.7109 21.2851Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M39.8447 12.0102C39.953 11.9499 40.0676 11.8875 40.1863 11.8271C39.7468 11.9124 39.9114 11.9395 39.8447 12.0102Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.6285 37.4815C14.641 37.4753 14.6431 37.4795 14.6597 37.4628C14.6764 37.4483 14.691 37.4337 14.7076 37.4191C14.7368 37.39 14.7659 37.3609 14.7909 37.3339C14.843 37.2777 14.8867 37.2257 14.9263 37.1758C14.8367 37.2486 14.7472 37.3068 14.6847 37.3588C14.6535 37.3859 14.6285 37.4108 14.616 37.4358C14.6056 37.4566 14.6139 37.4649 14.6285 37.4836V37.4815Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M34.3291 16.1532C34.3897 16.0867 34.4064 16.0451 34.3897 16.0264C34.327 16.095 34.2977 16.1408 34.3291 16.1532Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15.2308 36.7432C15.2038 36.764 15.1809 36.7848 15.1538 36.8076C15.0913 36.9283 15.0267 37.0448 14.9268 37.1758C15.058 37.0697 15.1913 36.9345 15.2308 36.7452V36.7432Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M33.0441 30.9092C33.0336 30.9217 33.0232 30.9364 33.0127 30.9468C33.0252 30.9573 33.0336 30.9385 33.0441 30.9092Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M29.6387 36.0817C29.6554 36.0235 29.693 35.932 29.7264 35.8467C29.7014 35.8862 29.6742 35.9548 29.6387 36.0817Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.8896 37.9813C14.8982 37.9685 14.9322 37.9685 14.8896 37.9813V37.9813Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15.3684 38.3594C15.3412 38.3761 15.3203 38.3949 15.3203 38.42C15.3287 38.3928 15.3454 38.3719 15.3684 38.3594Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15.4651 35.2386C15.4651 35.2386 15.4695 35.2319 15.4717 35.2275C15.4281 35.2496 15.4368 35.2452 15.4651 35.2386Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.9479 38.0233C14.9312 38.0128 14.9124 38.0024 14.8936 37.9961C14.8998 38.0045 14.9166 38.0128 14.9479 38.0233Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.9414 37.9731C14.954 37.9773 14.9665 37.9773 14.977 37.9794C14.9791 37.9606 14.977 37.9501 14.9414 37.9731Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.8311 37.994C14.8542 37.9898 14.8752 37.994 14.8962 37.9982C14.8899 37.9919 14.8878 37.9856 14.8899 37.9814C14.8773 37.9835 14.8605 37.9877 14.8311 37.994Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M37.391 20.5859C37.391 20.5859 37.3785 20.6005 37.3701 20.6088C37.3534 20.7544 37.3701 20.6962 37.391 20.5859Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21.527 26.6826C21.527 26.6826 21.5227 26.6936 21.5205 26.698C21.5249 26.6936 21.5336 26.6892 21.5379 26.6848H21.527V26.6826Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21.7913 26.2559C21.7559 26.5055 21.6643 26.5824 21.5352 26.6843L21.883 26.7717L21.7913 26.2559Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M36.173 13.5511L35.8127 13.6385C36.1063 13.2828 36.4166 13.1851 36.0501 13.2246C36.1105 13.3889 35.8085 13.5636 35.5148 13.7467C35.2191 13.9297 34.9296 14.1252 35.0025 14.2833L34.765 14.3478C34.8234 14.3145 34.8213 14.2916 34.8796 14.2584C34.4068 14.3686 34.7296 14.6515 34.2235 14.9365C34.0423 15.0301 33.8986 15.0696 33.9882 14.9573L33.6716 15.288C33.5612 15.3587 33.5529 15.2921 33.6612 15.2214L33.1239 15.6499V15.6395C33.076 15.7414 32.9489 15.9411 32.8864 16.0347C32.7177 16.1013 32.9322 15.9536 32.8718 15.9453L32.624 16.2427C32.447 16.2677 32.6407 16.0056 32.8573 15.8558C32.3657 15.8018 32.6594 16.1117 31.9346 16.4362L32.1887 16.1762C31.8846 16.1678 31.7055 16.4029 31.3181 16.5693C31.4306 16.5568 32.145 16.2864 31.8784 16.6171C31.7722 16.6712 31.6451 16.7607 31.5222 16.9541C31.441 16.8605 31.2973 17.0227 31.0953 17.1995L31.0036 17.0643C30.812 17.2869 30.8828 17.3347 30.7995 17.5011C30.5413 17.6967 30.408 17.6447 30.2809 17.6114C29.8665 17.9255 30.6871 17.5344 30.2372 17.9525C29.8665 18.1834 29.677 18.4247 29.3479 18.8345C29.0834 18.9946 29.3229 18.7242 29.2104 18.7617L29.0938 19.0383C29.0417 19.0799 29.0313 19.0362 29.0271 19.0133C28.8918 19.2026 29.1209 19.1485 28.8855 19.4189C28.9334 19.6145 28.1691 19.7164 27.9858 20.1636C27.8754 20.2031 27.9566 20.0554 27.89 20.0305C27.5401 20.5401 27.5776 20.4527 27.3422 20.9249L26.9632 21.1391C27.2714 21.0143 27.084 21.3908 26.9194 21.7153C27.0381 21.682 27.1423 21.655 27.2048 21.628L26.8715 22.0731C26.8049 22.1001 26.807 22.0211 26.8236 21.9108C26.807 21.9462 26.7903 21.9816 26.7778 22.0086C26.5945 22.1022 26.6029 21.9649 26.6403 21.8006C26.7112 21.7777 26.782 21.7548 26.8528 21.734C26.8799 21.5676 26.8965 21.4012 26.8111 21.3513C26.7986 21.3887 26.7591 21.4491 26.7112 21.5094C26.7174 21.4657 26.7174 21.4324 26.6945 21.4324C26.6695 21.4324 26.6528 21.499 26.6174 21.5926L26.4008 21.551L26.43 21.6238L25.8343 22.0502C25.5948 22.5453 25.4678 23.0507 24.9533 23.6893C24.9992 23.4501 24.8284 23.5062 24.7222 23.3897C24.9992 23.3461 25.1158 22.8864 25.4407 22.6077C25.272 22.7533 25.2532 22.6659 25.2741 22.6077L24.8513 23.2566C24.7701 23.1547 24.668 23.3045 24.4931 23.4105C24.7805 23.4792 24.2223 23.9347 24.0682 24.2134C23.9932 24.1698 23.9786 24.0533 24.2556 23.7974C23.8266 23.9638 24.1036 24.3923 23.7058 24.5775C23.7683 24.5088 23.8099 24.4818 23.8037 24.4256C23.712 24.6336 23.3101 24.9768 23.3392 24.8354L23.3996 24.7667C22.9602 25.1931 22.1437 26.1396 22.2479 26.3517C22.2229 26.3372 22.1063 26.1188 22.0979 26.0626L21.9271 27.3585C21.8501 27.165 21.2732 27.1525 21.5273 26.7012C21.4106 26.7927 21.2711 26.9092 21.119 27.1837C21.2044 27.1255 21.4835 27.1733 21.4085 27.2857C21.0087 27.4313 21.1544 27.4063 20.7233 27.6414C20.8504 27.554 20.9649 27.8681 20.8066 28.0407C20.7962 27.9846 20.5734 27.8702 20.6067 27.7849L20.4484 28.4151C20.5026 28.2716 20.2776 28.2383 20.1339 28.2882C20.2151 28.2778 19.8069 28.6751 19.7299 28.8124L19.9402 28.6627C19.4841 29.1431 19.8382 29.4219 19.4154 29.9169C19.4195 29.8192 19.2529 29.5384 19.0155 29.7755C19.0363 29.9897 19.1571 30.7427 18.8968 31.2669L18.7635 31.3043L18.5719 31.7141C18.5635 31.3626 18.6635 30.4681 18.7822 30.0188C18.5781 30.1748 18.6614 30.0126 18.4407 30.3121C18.299 30.3683 18.4698 30.0792 18.5344 29.9897L17.9679 30.6429C18.1262 30.7157 17.7055 31.271 17.8388 31.3293L18.2657 30.4806C18.424 30.5555 18.3219 31.2024 17.9304 31.6683C17.7825 31.7515 17.7575 31.3917 17.7055 31.3688C17.7055 31.4666 17.4472 31.8971 17.3785 31.9179L17.4618 31.6558C17.2056 31.8867 17.3097 32.2341 16.9348 32.4629C16.8411 32.569 16.5079 32.6688 16.5745 32.7479C16.8682 32.6792 17.3785 33.0058 17.4055 33.2138C17.366 33.245 16.8161 33.6922 16.6454 33.765C16.385 33.8607 16.5579 33.2699 16.335 33.349C16.3683 33.3844 16.3371 33.5196 16.3204 33.5736C16.2017 33.6693 16.2392 33.4384 16.0664 33.7088C16.1747 33.8544 15.6686 34.2268 16.0955 33.9168C15.9497 34.1997 15.8685 34.1644 15.6581 34.466C15.8185 34.4369 15.7727 34.9569 15.629 35.2397C15.604 35.1981 15.5165 35.2231 15.4749 35.2356C15.0875 35.7473 14.823 35.9823 14.4752 36.4691C14.4085 36.4899 14.2002 36.6958 14.2106 36.5523C14.1857 36.6396 14.1877 36.7395 14.0857 36.8934C13.7566 37.0993 14.3044 36.5419 14.0003 36.6625C14.0357 36.702 13.994 36.8185 13.9336 36.9579C13.8483 37.1305 13.7462 37.3219 13.692 37.4571C13.9107 37.4134 14.1169 36.8996 14.2148 36.6521C14.4043 36.754 14.2544 37.3572 14.1607 37.6692C14.0419 37.9334 13.8878 37.819 13.8941 37.8627C13.6525 38.1788 13.717 38.2517 13.8066 38.2641C13.9232 38.2662 13.8566 38.3328 13.9982 38.3557C13.967 38.4285 13.8712 38.5096 13.7483 38.5886C13.6275 38.6677 13.4775 38.7467 13.4255 38.8029C13.3088 38.8299 13.2214 38.8424 13.1547 38.8465C13.1214 38.8465 13.0943 38.8465 13.0714 38.8445H13.0547C13.0547 38.8445 13.0672 38.8278 13.0714 38.8195L13.1193 38.7675C13.2484 38.6281 13.3713 38.5096 13.4317 38.416L13.138 38.7301C13.111 38.6885 13.2047 38.4888 13.3546 38.3432C13.2672 38.416 13.163 38.5387 13.0464 38.6926C12.9902 38.7696 12.9277 38.8528 12.861 38.9443C12.8569 38.9526 12.834 38.9734 12.8465 38.9713L12.886 38.9672C12.9131 38.9651 12.9402 38.9609 12.9673 38.9589C13.0214 38.9526 13.0776 38.9464 13.1339 38.9401C13.5942 38.8861 14.1003 38.8257 14.4647 38.8361C14.6314 38.7696 14.8563 38.6926 14.7647 38.6489L14.5397 38.6968C14.4668 38.651 14.5897 38.5969 14.6793 38.5533C14.773 38.5096 14.8396 38.4784 14.7376 38.4659C14.8021 38.4389 14.8625 38.4077 14.9209 38.3785C14.9479 38.364 14.9771 38.3515 15.0062 38.3369L15.0479 38.3182L15.1125 38.2974C15.2853 38.2433 15.4769 38.2038 15.6956 38.208L15.7956 38.3515C15.781 38.3078 15.504 38.2953 15.3895 38.3577C15.5603 38.2662 16.0705 38.4846 16.2434 38.2558L15.931 38.1872C16.2267 38.0707 16.587 37.8585 16.9744 37.8585C16.7849 37.7275 16.889 37.8876 16.5974 37.742C16.8578 37.9355 15.6207 37.8564 16.0247 38.0416C15.7227 37.8689 15.5332 38.0145 15.1479 37.8835C15.1562 37.9084 15.1916 37.9292 15.1854 37.9438C15.1812 37.9521 15.1666 37.9584 15.1333 37.9646C15.1166 37.9667 15.0958 37.9708 15.0666 37.9729C15.0417 37.975 14.9958 37.9792 14.9938 37.975C14.9917 37.9896 14.9813 38.0104 14.9729 38.0228C14.9688 38.0228 14.9688 38.0228 14.9646 38.0208L14.9708 38.027C14.9708 38.027 14.9646 38.0374 14.9729 38.027C14.9854 38.0374 15 38.0478 15.0125 38.0582C15.0333 38.0686 15.0625 38.079 15.075 38.0915C15.0625 38.1081 15.0229 38.1268 15.0146 38.1372C15.0021 38.1497 14.9854 38.1622 14.9688 38.1726C14.9334 38.1955 14.8875 38.2121 14.8396 38.2309C14.7438 38.2641 14.6376 38.2932 14.5647 38.3328C14.471 38.3203 14.6501 38.262 14.6293 38.21C14.5668 38.2496 14.4939 38.2891 14.4148 38.3286C14.4606 38.2662 14.4439 38.2204 14.4647 38.1747C14.4835 38.131 14.5335 38.0873 14.6418 38.0416L14.5189 38.052C14.5251 38.0187 14.5251 37.9958 14.5064 37.9896C14.496 37.9875 14.4814 37.9896 14.4585 37.9937C14.4502 37.9937 14.4293 38.0041 14.4231 38.0041C14.4189 38.0041 14.4127 38.0041 14.4043 38.0041C14.4439 37.9688 14.4002 37.9771 14.3689 37.9771C14.3398 37.9771 14.3169 37.9833 14.3835 37.9646C14.3773 37.9313 14.3793 37.8856 14.3918 37.8273L14.4356 37.8148C14.5064 37.7233 14.5126 37.6339 14.5751 37.5028L14.6001 37.455L14.6147 37.43L14.6459 37.3822C14.6938 37.3115 14.7438 37.2428 14.7959 37.1763C14.9021 37.0411 15.025 36.9142 15.1687 36.7998C15.2666 36.6126 15.3624 36.415 15.5915 36.1508H15.7123C15.8393 35.9137 16.2642 35.5559 16.2476 35.402C16.6329 35.323 17.0598 34.3828 17.3806 34.0312L17.2868 33.9397C17.4847 33.6818 17.643 33.4114 17.8429 33.0557L17.7367 33.0079C17.87 32.673 18.3386 32.3402 18.6635 31.895C18.676 31.9512 18.5823 32.0552 18.5011 32.1176C19.103 31.7515 19.1946 30.8987 19.707 30.5451C19.7653 30.4016 19.8423 30.3267 19.9298 30.2643C19.9215 30.2747 19.9152 30.2851 19.9111 30.2955C19.9215 30.2851 19.9361 30.2664 19.9506 30.2497C20.0069 30.2123 20.0673 30.1728 20.1277 30.1291C20.0673 30.1603 20.011 30.1915 19.9715 30.2248C20.0423 30.1353 20.1381 29.9918 20.2235 29.842L20.3651 29.8628C20.3734 29.8504 20.3797 29.842 20.3859 29.8296C20.5255 29.7297 20.4255 29.6902 20.2984 29.7006C20.3359 29.6216 20.3672 29.5446 20.3838 29.4801C20.6234 29.5009 20.6171 29.0932 20.8983 29.0849C20.8899 28.9289 21.3898 28.3818 21.2836 28.1718C21.3086 28.1863 21.3523 28.1551 21.294 28.2279C21.4356 28.099 21.5772 27.97 21.6439 27.8015L21.8147 27.841L21.9271 27.3897C22.1625 27.2607 22.275 27.2212 22.2 27.4854C22.4603 26.9113 22.4707 27.0735 22.6748 26.566L22.7332 26.6513C22.8519 26.5119 22.9498 26.204 23.0851 26.177C23.4996 25.9981 24.4764 24.6939 25.3407 24.0637C24.9846 24.0034 25.7781 23.8058 25.6427 23.6165C25.7364 23.6206 25.8677 23.5457 25.7906 23.7101C26.1155 23.2774 26.4362 23.2171 26.5612 22.8177C26.6549 22.824 26.5529 22.9717 26.6195 22.9633C26.6383 22.9217 26.6966 22.799 26.7653 22.7907C26.834 22.7824 26.7507 22.8885 26.7132 22.9696C27.0923 22.5765 26.984 22.3851 26.8694 22.2124C27.136 22.0876 27.2256 21.9795 27.2777 21.7444C27.3943 21.7257 27.5588 21.6633 27.3297 21.9171C27.4755 21.7902 28.244 21.1787 28.1503 21.0476C28.2232 21.0372 28.3544 20.8729 28.3794 20.8251C28.7002 20.538 28.7397 20.5255 29.0417 20.226L28.9376 20.2863C28.9293 20.0305 29.1667 20.0138 29.4062 19.7705L29.4124 19.7913C30.0914 19.3794 29.6103 19.5084 30.308 19.1319L30.1955 19.0674C30.0789 18.822 30.8225 18.7429 31.0995 18.3789L30.9307 18.4309C31.0599 18.2042 31.6868 18.2624 31.8971 18.1293C31.9534 18.1127 31.8555 18.2125 31.8097 18.2728C32.4032 17.9775 31.7701 18.0981 32.1137 17.7612C32.2366 17.7695 32.1679 18.0024 32.4241 17.8069C32.5886 17.757 32.9593 17.0019 33.4092 16.8667C33.2926 16.873 33.1759 16.8792 33.3196 16.7045C33.5737 16.4757 34.1985 16.355 34.3256 16.0098C34.3714 15.9994 34.3943 16.0035 34.4047 16.016C34.5838 15.8205 35.042 15.4606 35.1087 15.2817C35.3253 15.3899 35.6273 15.132 35.9168 14.8928C36.2042 14.6536 36.4729 14.4352 36.5645 14.6078C36.7894 14.4726 37.0186 14.3436 37.2497 14.2168V14.2604C37.71 14.0545 37.8287 13.8985 37.9516 13.7404C38.0682 13.7175 38.0058 13.7841 38.0058 13.807C38.3536 13.6947 38.5452 13.6385 38.7097 13.5553C38.8118 13.4971 38.8722 13.4201 39.1096 13.2433C39.1117 13.287 39.1096 13.3327 39.1096 13.3785C39.17 13.3223 39.3158 13.3327 39.4449 13.3494C39.5116 13.3556 39.5761 13.3639 39.6615 13.3535C39.7323 13.3265 39.6865 13.391 39.6844 13.4201C39.6782 13.4534 39.6782 13.4825 39.6865 13.5095C39.6657 13.5199 39.6324 13.5387 39.6157 13.5324C39.6345 13.5823 39.5803 13.7009 39.5137 13.8112C39.4449 13.9235 39.3658 14.0254 39.3075 14.1024C39.2929 14.1211 39.2804 14.1398 39.2679 14.1564C39.2554 14.1731 39.2491 14.1814 39.2242 14.2376C39.1825 14.3249 39.1492 14.4081 39.1263 14.4872C39.0825 14.6452 39.0825 14.7846 39.1596 14.9011L39.0513 15.4481C39.3574 14.8096 39.1929 15.6249 39.3762 15.3857C39.2929 15.6541 38.9701 15.9952 39.0804 15.6686L39.1221 15.6291C38.9513 15.419 38.7035 16.405 38.5618 16.3218C37.9953 17.5927 37.2914 18.7637 36.7332 19.941L36.9644 19.8828L36.7624 20.2905C36.6728 20.3799 36.5624 20.3737 36.7061 20.0825C36.5374 20.1906 36.5583 20.615 36.5916 20.6399C36.2604 21.1891 36.4979 20.3217 36.4125 20.4964L36.3146 20.7439L36.3583 20.6982C36.3375 20.927 36.4041 20.9769 36.2334 21.3305C36.098 21.5406 36.0772 21.3971 36.0293 21.4823C36.0168 21.4761 35.998 21.5031 35.9626 21.6155L35.7106 22.1313L35.9376 21.9836C35.898 22.2457 35.7085 22.4724 35.9689 22.3019C35.5752 22.5473 35.0004 24.2155 34.8296 24.3986C34.7796 24.7688 34.6318 25.0871 34.4401 25.4802C34.513 25.3949 34.6901 25.4032 34.5151 25.7381C34.261 25.4719 34.0965 26.3039 33.7487 26.4786C34.009 26.2997 33.3446 27.4687 33.7299 27.1775C33.5758 27.4521 33.605 27.1421 33.4342 27.3252C33.2467 28.0615 32.6761 28.7875 32.3366 29.6507C32.372 29.6819 32.497 29.5696 32.4761 29.7776L32.0721 30.1332C32.0179 30.31 32.2408 30.3912 31.9638 30.6345C32.0179 30.6075 32.0971 30.5659 32.0617 30.6824C31.1286 32.2528 30.7558 34.1456 29.6811 35.6932C29.8561 35.4956 29.8019 35.6516 29.7311 35.8305C29.7977 35.7244 29.8332 35.8742 29.8977 35.8742L29.452 36.5252C29.5562 36.7187 29.1542 37.2948 29.275 37.43L29.3375 37.1929C29.3937 37.5632 29.8977 36.9287 30.1081 37.0639C30.0435 36.6479 30.7621 36.3006 30.7017 35.635C30.7975 35.533 30.7308 35.7681 30.8099 35.7244C30.7704 35.5455 30.8183 35.3687 30.9911 35.0754L30.9995 35.1212C31.339 34.2393 31.591 33.9044 32.0721 32.9559L31.9305 32.9808C32.0346 32.777 32.0887 32.7479 32.1596 32.6626C32.095 32.3506 31.8971 33.2471 31.8055 32.9496C32.1491 32.7666 32.447 31.4728 32.7865 31.3979C32.9302 31.0776 32.6178 31.4354 32.7594 31.115L32.8656 31.0609L32.8114 30.9403C32.9198 30.7365 33.053 30.6678 33.1155 30.6865C33.0864 30.7344 33.0676 30.8384 33.0489 30.8966C33.2509 30.6595 33.3634 30.1166 33.4321 30.0334L33.253 30.3225C33.5779 29.4198 34.1548 28.3943 34.3985 27.4854L34.3173 27.5249C34.513 26.8364 34.6088 27.034 34.8858 26.306V26.3372C34.8983 26.1728 34.9587 25.9711 35.0525 25.7797C35.0316 25.9856 35.3232 25.4968 35.2836 25.7631C35.4982 25.0163 35.3607 25.3803 35.3774 24.8291L35.5107 24.7626C35.5044 24.5691 35.469 24.5379 35.6085 24.1739C35.5502 24.4984 35.8418 24.0075 35.7918 24.3778C36.3146 23.7226 36.1022 23.188 36.5312 22.9758C36.4479 22.5244 36.1084 23.5562 36.1438 23.3419C35.9938 23.4667 36.0938 22.9779 36.2229 22.7553C36.3354 22.5203 36.7082 22.4932 36.9748 21.8942C36.9477 21.9524 36.9623 21.9649 36.9352 22.0232C37.0977 21.8276 37.0519 21.5468 37.2747 21.3201C37.2018 21.0996 37.4434 20.9686 37.281 20.8396L37.0748 21.4075C37.1685 21.0747 37.0831 20.6836 37.4268 20.2239C37.4455 20.2801 37.4226 20.4548 37.4018 20.5713C37.5247 20.4486 37.4997 20.2676 37.6267 20.1386C37.7892 20.2676 37.356 20.8209 37.3455 21.2182C37.4955 21.0934 37.4997 20.5276 37.6205 20.7876C37.4809 20.4298 37.9266 20.2156 37.9225 19.7226L38.0203 19.7996C38.0328 19.7289 38.0433 19.5708 38.1016 19.4564L38.1453 19.7351C38.1765 19.3524 38.5452 19.1548 38.6264 18.8116C38.3244 19.4689 38.4244 18.8989 38.2161 19.1381C38.4473 18.2624 38.7201 18.8053 39.0909 17.8756C39.0492 18.0045 38.8097 18.3061 38.8493 18.0919C38.9534 17.9296 39.1013 17.7216 39.2075 17.6426C39.4657 17.0331 39.0513 17.6842 39.1034 17.3971C39.3325 17.2536 39.1867 17.0789 39.2658 16.796L39.3783 16.8439C39.7428 16.1782 39.2221 16.5547 39.572 15.9682L39.6157 16.301L39.7136 15.9557L39.8136 16.0784C39.8677 15.6811 39.9385 15.5813 40.1218 15.2464C40.0073 15.2942 39.9364 15.1133 40.0614 14.8033C40.1385 14.7118 40.153 14.7534 40.1697 14.7617C40.178 14.7659 40.1864 14.7617 40.203 14.7285C40.2114 14.7118 40.2218 14.6889 40.2364 14.6556C40.253 14.612 40.2759 14.5537 40.3051 14.483C40.3072 14.5246 40.3113 14.5704 40.3113 14.6182C40.3113 14.6619 40.3176 14.6889 40.3113 14.7264C40.303 14.7971 40.2676 14.8699 40.176 14.9427C40.2051 14.9781 40.2051 15.0696 40.2343 15.1049C40.3197 15.0072 40.3842 14.8678 40.4363 14.7305C40.4759 14.6244 40.5134 14.5225 40.5467 14.431C40.5821 14.3312 40.6154 14.2459 40.6425 14.1793C40.5946 14.2812 40.5363 14.4019 40.4925 14.4601C40.5842 14.0961 40.6612 13.7675 40.7216 13.4763C40.8424 13.3078 40.8404 13.4076 40.832 13.522C40.9028 13.3203 40.8966 13.1996 40.9674 12.9521C41.0215 12.9521 41.0861 12.9313 41.1257 12.9583C41.1653 12.9854 41.1923 13.0519 41.1153 13.287C41.1382 13.2038 41.1715 13.1123 41.1861 13.0395L41.2277 12.8231L41.3069 12.4092C41.386 12.3156 41.6339 11.8102 41.6464 11.8913C41.6797 11.8164 41.7068 11.7394 41.7297 11.6666C41.7401 11.6313 41.7547 11.5897 41.7588 11.5605C41.7109 11.5709 41.663 11.5834 41.613 11.5938C41.411 11.6417 41.1965 11.702 40.9861 11.7602C40.5592 11.8809 40.1718 11.9911 39.8219 12.0244C39.774 12.0556 39.6865 12.0951 39.5241 12.1471C39.1825 12.2199 38.8472 12.2844 38.4785 12.3946L38.339 12.4404L38.2411 12.4737C38.1849 12.4945 38.1266 12.5174 38.0682 12.5444C37.9537 12.5985 37.8371 12.665 37.7225 12.7524L37.356 12.7212C36.9748 12.9459 37.8391 12.742 37.2102 13.1143C36.7811 13.3889 36.9727 13.0603 36.7895 13.0977C36.602 13.2932 36.3042 13.6551 35.8293 13.7612C35.9459 13.6551 36.0647 13.6198 36.1855 13.5387L36.173 13.5511ZM31.8888 16.613C31.9513 16.5277 32.0596 16.3384 32.1616 16.3488C32.1616 16.5318 32.0471 16.5339 31.8888 16.613ZM26.2092 22.0793C26.2342 21.9982 26.33 21.9316 26.4571 21.8734C26.3967 21.9462 26.3175 22.0169 26.2092 22.0793ZM14.2773 38.158C14.2773 38.158 14.2669 38.1622 14.2627 38.1664C14.2627 38.1185 14.2586 38.1372 14.2773 38.158ZM14.3918 38.1976C14.4335 38.1747 14.4522 38.156 14.4668 38.1372C14.4168 38.1747 14.3669 38.183 14.3294 38.1789C14.294 38.2163 14.294 38.2371 14.3918 38.1976ZM36.0397 21.5655L36.1063 21.4969C36.0542 21.6966 36.048 21.6321 36.0397 21.5655Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M26.7314 21.3371C26.7672 21.3329 26.7882 21.3434 26.8092 21.356C26.824 21.314 26.8092 21.2951 26.7314 21.3371Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M39.7843 12.0453L39.8073 12.0411C39.8241 12.0307 39.8366 12.0202 39.8429 12.0098L39.7822 12.0432L39.7843 12.0453Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.1621 33.4591C16.2332 33.3925 16.2833 33.3634 16.323 33.3488C16.3021 33.326 16.2562 33.3488 16.1621 33.4591Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.0573 37.7754L15.7637 37.844C15.9074 37.8191 15.9615 37.8399 16.0344 37.8503C16.024 37.8232 15.9636 37.7879 16.0553 37.7754H16.0573Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.7051 38.2372C18.7469 38.2206 18.7971 38.231 18.8389 38.2144L18.8221 38.1582C18.6362 38.1707 18.5108 38.2206 18.7051 38.2372Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.38 38.1459C16.4154 38.2458 16.5966 38.1875 16.8007 38.1418C16.7882 38.1418 16.7757 38.1459 16.7632 38.1459C16.8091 37.9941 16.5925 38.0711 16.3779 38.1459H16.38Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.8486 38.1334C16.9113 38.121 16.9761 38.1085 17.0409 38.1064C17.0597 38.0461 16.9615 38.1043 16.8486 38.1334Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.6997 38.0891C14.7227 38.112 14.8021 37.9435 14.7938 37.9872C14.8419 37.9144 14.7854 37.9622 14.7144 38.0184C14.6412 38.0745 14.5681 38.1411 14.6997 38.0891Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.5848 38.4622L16.4971 38.3457L16.3926 38.4622H16.5848Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.9561 38.5759L15.2789 38.5697C15.2706 38.5489 15.3123 38.5323 15.3623 38.5156C15.2602 38.5239 15.154 38.5343 15.0728 38.5406C14.9999 38.5468 14.954 38.5572 14.9561 38.5759Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15.3623 38.516C15.4685 38.5056 15.5685 38.489 15.6247 38.4619C15.5685 38.4702 15.4456 38.491 15.3623 38.516Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.139 38.5575L16.0391 38.543L15.8037 38.5638L16.139 38.5575Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.8833 37.7041L14.0275 37.4337C14.0024 37.3921 13.9209 37.4649 13.8624 37.5752C13.8478 37.648 13.7997 37.7478 13.8812 37.7041H13.8833Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12.6857 38.8232C12.8023 38.7005 12.8585 38.6693 12.9668 38.584L12.6961 38.6984C12.6898 38.7421 12.6857 38.7837 12.6836 38.8232H12.6857Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.3776 37.7545C13.363 37.7379 13.4215 37.5985 13.4487 37.5153C13.4738 37.4342 13.4612 37.4217 13.2857 37.6838C13.3045 37.7316 13.0871 38.1102 13.3797 37.7524L13.3776 37.7545Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.8454 33.2656L16.791 33.3405L17.0084 33.484L16.8454 33.2656Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19.2925 29.0557C18.9697 29.3552 19.3529 29.2366 19.0447 29.4925C19.028 29.609 19.2967 29.2824 19.2717 29.3968C19.3863 29.1534 19.5008 29.0681 19.2925 29.0557Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19.2711 29.3965C19.2523 29.436 19.2335 29.4776 19.2168 29.5254C19.2523 29.4568 19.2649 29.4214 19.2711 29.3965Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M29.1291 36.9707L28.9766 37.2078L29.1249 37.0747L29.1291 36.9707Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M29.1132 37.5361H28.9355L29.0129 37.7462C29.0296 37.6859 29.0609 37.5673 29.1132 37.5361Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M31.0801 16.8538L31.0905 16.8975C31.1511 16.9037 31.2034 16.8642 31.3079 16.7852L31.0822 16.8538H31.0801Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M34.1883 14.624L34.1318 14.6594L34.3199 14.7114L34.1883 14.624Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M36.9098 12.8086C36.7869 12.8627 36.6619 12.9625 36.5391 13.0187C36.7869 12.8606 37.0243 12.9604 36.9098 12.8086Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M0.120601 42.1458C0.32679 41.9669 0.380941 41.9274 0.389272 41.8837C0.397603 41.8463 0.360114 41.8317 0.389272 41.8047C0.210158 41.9149 0.103939 42.0252 0.0518706 42.098C-0.000197442 42.1708 -0.00436289 42.2041 0.0102162 42.2082C0.0393743 42.2165 0.141428 42.1458 0.124766 42.1458H0.120601Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M4.38136 42.9834L4.31055 43.0562C4.53756 42.9356 4.76666 42.8212 4.99993 42.7109C4.79166 42.7983 4.58547 42.8898 4.38136 42.9855V42.9834Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.31776 41.854C8.34484 41.75 7.99077 41.8395 7.65129 41.9393C7.47634 41.9851 7.31181 42.0558 7.15352 42.112C7.11395 42.1244 7.07438 42.139 7.03689 42.1515C6.97857 42.1702 6.92025 42.1868 6.86402 42.2056C6.74947 42.2388 6.637 42.27 6.53078 42.2929H6.38083L6.05176 42.5467C6.30168 42.4614 6.56827 42.372 6.84111 42.2804L7.04522 42.2097L7.17226 42.1619C7.25765 42.1307 7.34305 42.0995 7.42636 42.0683C7.77209 41.9643 8.13865 41.8707 8.31984 41.8561L8.31776 41.854Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.40639 42.8443C7.42729 42.8422 7.43773 42.8505 7.44191 42.8609C7.44191 42.8672 7.444 42.8734 7.44191 42.8776C7.43773 42.89 7.43355 42.9004 7.43146 42.9046C7.43146 42.9088 7.43147 42.9046 7.43982 42.888C7.44818 42.8692 7.44609 42.8692 7.45236 42.8526C7.46072 42.8256 7.47326 42.784 7.49625 42.7236C7.47953 42.7361 7.47326 42.7403 7.46281 42.7465C7.45236 42.7673 7.43773 42.7923 7.4043 42.8443H7.40639Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.46462 42.7471C7.36215 42.8077 7.51063 42.6551 7.46462 42.7471V42.7471Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.55392 44.5004L6.82467 43.8701C6.72054 43.9762 6.42062 44.5066 6.50185 44.2924C6.19569 44.9247 6.30191 44.8186 6.55392 44.5004Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.36035 45.1321L6.50664 44.8076C6.46066 44.8534 6.41051 44.9324 6.36035 45.1321Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.81619 44.1211L6.50586 44.8075C6.57875 44.7347 6.63499 44.7534 6.65373 44.4955C6.67248 44.5745 6.69747 44.4206 6.81619 44.1211Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.0459 43.7614C7.26458 43.4432 7.52284 43.0189 7.25001 43.6512C7.40204 43.36 7.50201 43.1499 7.55825 43.0147C7.59365 42.9357 7.58741 42.9294 7.58741 42.9107C7.58741 42.8962 7.57907 42.8899 7.57074 42.892C7.56033 42.892 7.54783 42.9024 7.53117 42.917C7.50826 42.944 7.46244 43.0147 7.41871 43.0896C7.32498 43.2456 7.19794 43.4702 7.04798 43.7594L7.0459 43.7614Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.85993 41.5322L8.53919 41.5489L8.09766 41.7132C8.20179 41.6737 8.38299 41.6446 8.53503 41.6217C8.68707 41.5967 8.81203 41.5738 8.85993 41.5322Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M4.87514 48.7185C4.90648 48.7684 5.0068 48.4752 5.06322 48.4273C5.07576 48.2422 5.09248 48.0571 5.11756 47.874C5.0256 48.1465 4.92947 48.6852 4.87305 48.7185H4.87514Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.06248 48.4276C5.05412 48.567 5.04994 48.7043 5.04785 48.8415V49.2659C5.06457 49.0787 5.07502 48.9289 5.08338 48.8103C5.08965 48.6959 5.09592 48.6107 5.09801 48.5503C5.10219 48.4297 5.08547 48.4047 5.06248 48.4255V48.4276Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.47868 45.3363L6.95146 44.1777L6.36621 45.5464L6.47868 45.3363Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.82915 51.0128C7.72293 51.0898 7.6063 51.1543 7.48342 51.2083C7.3647 51.2603 7.21683 51.3061 7.10645 51.3352C7.20225 51.3123 7.33555 51.2749 7.44385 51.2312C7.55631 51.1875 7.66462 51.1335 7.76459 51.0731C7.96453 50.9483 8.13531 50.7861 8.25819 50.5947C8.14572 50.759 7.99993 50.9026 7.82915 51.0149V51.0128Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.85938 48.7062C8.88645 49.0016 9.0489 48.3401 9.04265 48.6459C9.1093 48.1883 9.15304 47.7869 9.21344 47.4229C9.12388 47.8014 9.00517 48.1904 8.85938 48.7062Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M9.3518 46.8154C9.29328 47.0047 9.25148 47.2044 9.21387 47.4228C9.26402 47.2231 9.31209 47.0234 9.3518 46.8154Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.03724 50.8672C6.07265 50.8963 6.12471 50.9462 6.24759 51.0107C6.31008 51.0419 6.38922 51.0773 6.49336 51.1064C6.59957 51.1355 6.71204 51.1605 6.90782 51.1709C6.72245 51.1314 6.59749 51.0814 6.46003 51.0149C6.3309 50.9857 6.18095 50.94 6.03516 50.8672H6.03724Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.44629 51.0066L6.46087 51.0128C6.57958 51.0378 6.67331 51.0503 6.78369 51.0565C6.89407 51.0669 7.00029 51.0565 7.07944 51.044C7.23981 51.0253 7.37935 50.9858 7.45016 50.9629C7.38768 50.9837 7.27313 51.017 7.10651 51.0399C7.03778 51.0482 6.92323 51.0669 6.80868 51.0565C6.6858 51.0503 6.58583 51.0378 6.44837 51.0066H6.44629Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.93555 50.8135C5.9734 50.8345 6.00073 50.8513 6.03858 50.8681C6.00283 50.8387 5.98181 50.8219 5.93555 50.8135Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.53441 47.1748C5.4341 47.647 5.31916 48.61 5.60756 47.7156C5.62427 47.3745 5.42156 47.8841 5.53441 47.1748Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.59862 50.3676C5.3591 50.1035 5.18832 49.7062 5.19665 49.3255C5.17166 49.3463 5.13209 49.5647 5.09668 49.2402C5.10085 49.4503 5.15083 49.6729 5.24247 49.8684C5.33203 50.066 5.46116 50.2324 5.6007 50.3676H5.59862Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.04765 50.6802C5.88104 50.6032 5.72483 50.493 5.5957 50.3682C5.68526 50.4701 5.79148 50.5678 5.90811 50.649C5.95393 50.6615 5.99975 50.6739 6.04765 50.6802Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.85523 47.9926C8.88647 47.6681 8.98853 47.3249 9.12599 46.9463C8.95104 47.3415 8.80941 47.7658 8.71777 48.1798C8.74068 48.2463 8.75526 48.4377 8.85732 47.9905L8.85523 47.9926Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.4955 49.6691C8.49968 49.6421 8.50595 49.6088 8.51013 49.5859C8.48923 49.6338 8.4746 49.6733 8.4955 49.6691Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M11.0346 43.2686C11.0178 43.2853 11.0032 43.302 10.9844 43.3187C10.9865 43.3271 10.9906 43.3334 10.9927 43.3417L11.0346 43.2686Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.683 48.2459C8.59314 48.562 8.59732 48.7493 8.59941 48.9552C8.62449 48.6931 8.65792 48.4518 8.71853 48.1793C8.71017 48.1502 8.69972 48.1419 8.683 48.2459Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M9.78214 45.8018C9.678 45.9453 9.57386 46.1013 9.46973 46.2781C9.57178 46.1408 9.7738 45.8746 9.78214 45.8018Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.56988 49.4673C8.56779 49.486 8.56361 49.5026 8.56152 49.5234C8.61377 49.407 8.59914 49.4194 8.56988 49.4673Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.57023 49.4677C8.59949 49.2722 8.60158 49.1141 8.60158 48.9561C8.57441 49.189 8.54098 49.4012 8.51172 49.5863C8.53053 49.5426 8.55352 49.4989 8.57232 49.4677H8.57023Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M11.0405 41.8126C11.0697 41.8646 10.9926 42.0997 10.8489 42.3992C10.7094 42.7029 10.5032 43.0732 10.2699 43.3914C9.96792 44.1069 10.499 43.822 10.9843 43.3186C10.9572 43.277 10.9197 43.2562 11.2488 42.5303C11.0655 42.7466 10.2949 44.0154 10.5323 43.3831C10.9905 42.4325 10.9739 42.6405 11.2717 42.2224C10.9489 42.5386 11.7653 40.9702 11.4966 41.0722L11.0988 41.9125C11.0655 41.9125 11.1884 41.5984 11.0405 41.8106V41.8126Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10.2532 44.6439L10.1074 44.9372C10.3011 44.6189 10.4636 44.4026 10.7676 44.0095C10.9842 43.5082 11.0051 43.3917 10.9926 43.3418L10.2116 44.7479L10.2511 44.6418L10.2532 44.6439Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M9.43048 46.2083C9.43257 46.0752 9.51171 45.8401 9.55545 45.6737C9.60127 45.5073 9.60127 45.4199 9.43257 45.603C9.20972 46.019 9.17014 46.1771 9.14515 46.2936C9.12432 46.41 9.12224 46.4849 9.04102 46.7491C9.61585 45.3887 8.91397 47.1547 9.41382 46.2145C9.30552 46.4808 9.20972 46.72 9.12641 46.9488C9.23263 46.7096 9.34926 46.4849 9.47214 46.279C9.46381 46.2894 9.45756 46.2977 9.45131 46.306V46.3123H9.44715C9.40758 46.3622 9.39091 46.3788 9.4284 46.3185C9.4284 46.3144 9.43673 46.2977 9.43882 46.2894C9.4284 46.2748 9.4284 46.2436 9.43048 46.2124C9.64084 45.8443 9.48464 46.1646 9.43882 46.2894C9.4409 46.2956 9.4409 46.3081 9.44506 46.3123L9.44923 46.3081C9.63459 45.8713 9.88244 45.4054 10.1074 44.9395C10.022 45.0809 9.93242 45.2411 9.81995 45.447C9.7658 45.551 9.70332 45.6654 9.63459 45.7944C9.57003 45.9171 9.5013 46.0544 9.4284 46.2104L9.43048 46.2083Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.67978 48.5898C5.66307 48.6356 5.6568 48.6335 5.64844 48.6356C5.64844 48.7375 5.65262 48.777 5.67978 48.5898Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.5525 49.2235C5.54832 49.1673 5.54205 49.1132 5.53578 49.0279C5.52951 48.9427 5.52951 48.8241 5.55877 48.639C5.634 48.3207 5.61102 48.6473 5.64863 48.6348C5.64654 48.4123 5.69461 47.8444 5.52742 48.5371V48.6515C5.51279 48.7305 5.49816 48.8116 5.48354 48.8948C5.46891 48.9718 5.45637 49.0737 5.43965 49.1299C5.39994 49.315 5.39785 49.5126 5.42711 49.6811C5.4919 50.0201 5.63191 50.2094 5.57549 50.1595C5.54623 50.0347 5.52324 49.9203 5.5107 49.7726C5.49816 49.627 5.49399 49.446 5.5525 49.2235Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.23762 49.3986C8.25851 49.2863 8.27732 49.1761 8.29195 49.0637C8.30658 48.9514 8.31912 48.8349 8.32957 48.7351C8.35256 48.5271 8.37972 48.3212 8.41734 48.1152C8.33793 48.317 8.26896 48.5208 8.20627 48.7288L8.26687 48.7039C8.20627 49.0637 8.18119 49.2239 8.18746 49.2884C8.19373 49.357 8.22508 49.3466 8.23553 49.3986H8.23762Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M11.1523 43.167L11.1712 43.3729L11.3864 42.6387L11.1523 43.167Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M11.9551 41.6967L12.0136 41.8007L12.0951 41.5927L12.116 41.5407C12.1244 41.522 12.1306 41.5053 12.1285 41.5033L12.1327 41.4658L12.1097 41.4866C12.1097 41.4866 12.1055 41.4866 12.0951 41.5012L12.0679 41.5407L11.9572 41.6967H11.9551Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M32.8652 39.8528C32.8945 39.8112 32.9133 39.7696 32.9258 39.7197C32.9028 39.7863 32.884 39.8216 32.8652 39.8528Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M30.4395 39.8242L30.3496 39.8596C30.5377 39.8617 30.6192 39.8554 30.4395 39.8242Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M36.0869 49.4258C36.6201 49.2719 37.2387 49.145 37.1304 49.0701L36.9304 49.041C36.5909 49.222 36.3202 49.3364 36.0869 49.4237V49.4258Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M37.6681 46.3056C37.7202 46.2931 37.7743 46.2806 37.8285 46.2682C37.9347 46.1787 38.0347 46.0934 38.1242 46.0186C37.9868 46.1059 37.8306 46.2037 37.666 46.3056H37.6681Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M37.5141 46.8818C37.2892 46.963 37.0684 47.0503 36.8477 47.1398C36.9997 47.0878 37.2121 47.0025 37.5141 46.8818Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M34.5609 27.8682L34.6508 27.4189C34.3498 28.0471 34.5337 27.7954 34.5609 27.8682Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M27.569 40.7874C27.6087 40.8019 27.6442 40.8123 27.6651 40.8248C27.5983 40.9517 27.5586 41.0307 27.5293 41.1035C27.6004 41.0058 27.6965 40.8685 27.7508 40.7666C27.7007 40.7478 27.6338 40.7499 27.569 40.7853V40.7874Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M32.3238 41.2058C32.5904 41.1663 32.6987 41.1205 32.6862 41.0977C32.4196 41.158 32.2655 41.1809 32.3238 41.2058Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M27.1914 42.1227C27.2268 42.0458 27.2601 41.9688 27.2955 41.8898C27.3414 41.7192 27.3893 41.5507 27.4434 41.3718C27.4601 41.3157 27.4788 41.2554 27.4976 41.195C27.5059 41.1659 27.5184 41.1347 27.5309 41.1035C27.508 41.1368 27.4851 41.168 27.4663 41.195L27.4538 41.2158L27.4476 41.2262L27.4309 41.2658C27.4101 41.3198 27.3913 41.3739 27.3705 41.4301C27.2935 41.6526 27.2289 41.8835 27.1914 42.1186V42.1227Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.0702 31.5664C17.0409 31.5934 17.0096 31.6288 16.9824 31.6538C16.9866 31.6725 17.0221 31.6309 17.0702 31.5664Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M4.92578 40.3466C5.07574 40.2946 5.32566 40.2218 5.55685 40.1553C5.4423 40.1802 5.2486 40.2343 4.92578 40.3466Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.7831 40.7373C17.432 40.7685 17.7288 40.7539 17.7831 40.7373V40.7373Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.0322 40.4484C16.1054 40.4276 16.1618 40.4068 16.1681 40.3818C16.1409 40.411 16.0928 40.4338 16.0322 40.4484Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M26.8062 45.7259C26.8062 45.7259 26.7999 45.7447 26.7979 45.7552C26.848 45.659 26.8397 45.6757 26.8062 45.7259Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.251 40.727C17.3843 40.7291 17.5363 40.7291 17.7029 40.727C17.63 40.7249 17.4926 40.7229 17.251 40.727Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.3259 40.7725C17.2051 40.7787 17.1093 40.7829 17.0177 40.787C16.976 40.8099 17.0156 40.8161 17.3259 40.7725Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.2717 40.7002C18.0718 40.7148 17.8822 40.721 17.7031 40.7252C17.7719 40.7272 17.801 40.7314 17.7844 40.7376C17.8864 40.7293 18.0322 40.7189 18.2738 40.7002H18.2717Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M37.9147 11.7266C37.8917 11.7328 37.8666 11.7411 37.8415 11.7474C37.5406 11.9366 37.6743 11.8618 37.9147 11.7266Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M43.9478 44.292C43.9332 44.3004 43.9248 44.3045 43.9102 44.3129C43.9269 44.3087 43.9478 44.3024 43.9624 44.2962L43.9478 44.292Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M45.0159 43.7725C44.9909 43.7974 44.9659 43.8203 44.9409 43.8432C44.918 43.8661 44.8868 43.891 44.8847 43.8993C44.8764 43.9118 44.8659 43.9243 44.8555 43.9326L44.8389 43.9472L44.8014 43.968C44.7014 44.0221 44.6077 44.0678 44.5181 44.1073C44.3348 44.1843 44.1599 44.2384 43.96 44.2987L44.4723 44.4464L44.7972 44.1073C44.8222 44.0803 44.8555 44.0491 44.8743 44.0241C44.8868 44.0013 44.8972 43.9805 44.9034 43.9555C44.9076 43.943 44.9097 43.9326 44.9138 43.9201L44.9472 43.8723L45.0138 43.7745L45.0159 43.7725Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M31.222 35.6516L30.8013 36.4608C31.0408 35.3812 31.3949 34.6657 30.9471 35.4062C31.0346 35.4852 30.9367 35.8492 30.7763 36.3193C30.7263 36.4753 30.5264 37.0099 30.3639 37.4675C30.2806 37.7026 30.1952 37.9376 30.1119 38.1685C30.0703 38.2829 30.0307 38.3973 29.9911 38.5096C29.9557 38.6178 29.9016 38.7405 29.8932 38.8237C30.4618 38.8299 31.0013 38.8258 31.3699 38.8195C31.7406 38.8175 31.9593 38.8154 32.0072 38.7592L32.0634 38.7738L32.0968 38.7842L32.1593 38.805L32.2821 38.8507C32.3634 38.8819 32.4425 38.9152 32.5175 38.9506C32.38 38.9069 32.3529 38.9215 32.2134 38.8861C32.3279 38.9298 32.4238 38.9672 32.5091 39.0005C32.5425 39.0109 32.5716 39.0213 32.6008 39.0317C32.607 39.0317 32.6112 39.0359 32.6154 39.0359C32.6195 39.0359 32.6362 39.0421 32.6466 39.0442C32.732 39.0733 32.7924 39.0754 32.859 39.0858C32.9236 39.0983 32.9965 39.1128 33.0569 39.196C33.0861 39.2376 33.1131 39.3 33.1215 39.3874C33.1298 39.4748 33.1236 39.5996 33.084 39.7015C33.0257 39.845 32.9403 39.8991 32.884 39.9178C32.8257 39.9365 32.8216 39.9136 32.8611 39.8512C32.8382 39.8824 32.807 39.9157 32.7653 39.9469C32.7258 39.976 32.6612 40.0114 32.632 40.028C32.6112 40.0405 32.505 40.0655 32.4321 40.0821C32.3509 40.0988 32.2696 40.1133 32.1884 40.1237C31.8968 40.1216 31.9718 40.0655 32.253 40.0592C32.001 40.078 31.7635 40.078 31.4865 40.0364L30.3306 39.8658L30.3473 39.8575C30.2577 39.8554 30.139 39.8512 30.0057 39.8492C29.9412 39.8471 29.8745 39.845 29.8037 39.8408C29.7974 39.8408 29.7829 39.8367 29.7808 39.845L29.7766 39.8762L29.7704 39.9386L29.7558 40.0634C29.7204 40.3775 29.685 40.6957 29.6621 40.9058C29.4871 41.507 29.6933 40.5793 29.6204 40.7124C29.535 41.2407 29.5121 41.5465 29.4684 41.8106C29.4205 41.9001 29.3934 41.9167 29.3809 41.8814C29.3746 41.8647 29.3726 41.8335 29.3746 41.7919C29.3746 41.7711 29.3788 41.7482 29.3809 41.7233C29.3809 41.7108 29.383 41.6962 29.3851 41.6838V41.663L29.3892 41.6526C29.3871 41.6609 29.3851 41.6609 29.3871 41.6588V41.6359C29.3871 41.6214 29.3892 41.6068 29.3913 41.5902C29.3955 41.5569 29.3996 41.5215 29.4038 41.4862C29.4142 41.4133 29.4246 41.3364 29.4371 41.2532C29.4475 41.1991 29.4559 41.145 29.4663 41.0889C29.4788 41.0244 29.4913 40.9599 29.5038 40.8933C29.5309 40.7623 29.5579 40.6313 29.585 40.5044C29.51 40.65 29.4496 40.7914 29.3996 40.9266C29.3497 41.0597 29.3059 41.2074 29.2913 41.2553C29.2705 41.326 29.258 41.3967 29.2476 41.4695C29.2434 41.5049 29.2393 41.5423 29.2351 41.5818C29.2309 41.6068 29.2351 41.6068 29.2351 41.6151V41.6193C29.2351 41.6193 29.2434 41.5964 29.2393 41.613L29.2351 41.6442C29.183 41.9812 29.1143 42.4471 28.7519 43.3748L28.9581 42.4679C28.6124 42.9942 28.477 43.7076 28.0917 44.7019C28.2083 44.4648 28.9477 42.7487 28.7436 43.7971C28.6415 44.08 28.5124 44.4544 28.4499 45.0347C28.3291 45.0118 28.225 45.5672 28.0917 46.2619L27.9417 46.1829C27.8376 46.9442 27.9334 46.9005 27.9272 47.356C27.7689 48.1922 27.6272 48.3545 27.4919 48.5396C27.294 49.9041 27.8084 47.6244 27.6397 49.2405C27.6002 49.4756 27.571 49.6961 27.5502 49.9103C27.5273 50.1807 27.4898 50.5551 27.5023 50.8609C27.5106 50.9358 27.5169 51.0127 27.5273 51.0855C27.5419 51.1542 27.5606 51.2207 27.5856 51.2811C27.6106 51.3414 27.6377 51.3996 27.6772 51.4558C27.696 51.4828 27.7314 51.5182 27.7522 51.5203C27.773 51.5244 27.7834 51.5161 27.7939 51.5099C27.8147 51.4953 27.8314 51.4745 27.8563 51.462C27.8834 51.4496 27.9147 51.4412 28.0125 51.4849L28.0209 51.4891L28.0521 51.4579L28.1167 51.3934L28.1812 51.3289C28.7373 50.6529 28.3354 51.1417 28.4583 50.9919V50.9961L28.4541 51.0003L28.4458 51.0086C28.4353 51.0211 28.4249 51.0294 28.4103 51.0377C28.3937 51.0523 28.3749 51.0668 28.3541 51.0793C28.3208 51.0959 28.2625 51.1313 28.2062 51.1563C28.1771 51.1687 28.1521 51.1771 28.1167 51.1916L28.0896 51.2041C28.0959 51.2062 28.1104 51.2499 28.1229 51.2873L28.4145 52.2316L29.0206 51.5806C29.081 51.5161 29.1414 51.4496 29.2059 51.3809C29.2726 51.3206 29.3392 51.2478 29.4142 51.1875C29.987 50.8838 29.3746 51.3268 29.5954 51.2395C29.7245 51.1043 29.862 50.9878 30.0265 50.8879C30.1619 50.8484 30.1286 50.9004 30.114 50.9275C30.3431 50.838 30.3639 50.7985 30.3993 50.7486C30.4452 50.6924 30.5201 50.6571 30.9992 50.4948C31.0512 50.4324 31.2033 50.3783 31.4136 50.293C31.5199 50.2535 31.6386 50.2015 31.7656 50.1454C31.8843 50.0913 32.0114 50.031 32.1468 49.9686C32.6778 49.719 33.3027 49.4111 33.738 49.0284C34.0025 48.9223 33.6734 49.1844 33.7796 49.1927C35.0459 48.2692 34.8751 48.4169 35.8769 47.5994C36.0435 47.5204 36.206 47.4392 36.3664 47.3602C36.5246 47.2853 36.6871 47.2146 36.8495 47.1459C36.1123 47.4205 36.8933 46.7903 37.6681 46.3098C37.3848 46.3763 37.1432 46.4366 36.9849 46.4887C37.4015 46.2474 37.8263 46.0227 38.2512 45.8002C38.4199 45.7544 38.3116 45.8646 38.1242 46.0227C38.2075 45.9686 38.2866 45.9187 38.3491 45.8792C38.8427 45.7274 38.6365 45.9208 38.3387 46.1517C38.1658 46.1933 37.995 46.2328 37.8284 46.2723C37.5473 46.5095 37.3036 46.7507 37.4098 46.8048C37.4848 46.7487 37.6368 46.6571 37.8097 46.5677C37.7389 46.6301 37.6951 46.6779 37.7409 46.6738C37.7909 46.6696 37.9096 46.5739 38.1033 46.4408L38.472 46.4741L38.5136 46.3763C39.0968 46.1579 39.6862 45.9458 40.2777 45.7149C41.4419 44.9765 42.3417 44.1902 44.1703 43.1023C43.7725 43.4726 44.1745 43.3478 44.2265 43.4996C43.6371 43.6328 42.8145 44.3566 41.8106 44.8371C42.3334 44.5875 42.2542 44.7102 42.1355 44.8017C42.6978 44.4502 43.2539 44.0945 43.8058 43.7347C43.8287 43.8699 44.2203 43.6182 44.6952 43.4164C44.2328 43.3811 45.8969 42.5574 46.5592 42.1081C46.6446 42.1601 46.5175 42.3265 45.6532 42.7779C46.6883 42.4284 46.7237 41.846 47.738 41.4945C47.5256 41.6068 47.409 41.6567 47.3465 41.7378C47.4589 41.6567 47.6214 41.559 47.8005 41.4612C47.888 41.4154 47.9775 41.3676 48.0671 41.3197C48.1337 41.2865 48.1941 41.2698 48.2379 41.2677C48.2837 41.2677 48.3087 41.2761 48.3316 41.2906C48.3628 41.3073 48.3941 41.3343 48.4087 41.353C48.442 41.3946 48.4378 41.4154 48.3941 41.405C48.367 41.3842 48.317 41.3613 48.3024 41.3572C48.3712 41.3821 48.4711 41.4591 48.5336 41.5881C48.5649 41.6505 48.5815 41.7066 48.5836 41.769C48.5836 41.7961 48.5815 41.846 48.5794 41.8543C48.5753 41.8689 48.5711 41.8814 48.5628 41.898C48.544 41.9292 48.4982 41.975 48.4149 42.0249L48.065 42.2308C47.8338 42.3702 47.6026 42.5095 47.3798 42.6447C46.4967 43.1876 45.7761 43.6723 45.7261 43.8262C45.699 43.8096 45.7761 43.4976 45.8365 43.4123L45.3158 43.9219L45.0555 44.1756C45.0242 44.2152 44.9909 44.2443 44.9472 44.2755L44.7972 44.3795C44.3973 44.6561 43.9974 44.9349 43.6142 45.224C43.6934 45.0909 43.4705 45.0118 43.3726 44.8953C43.2747 44.7789 43.3039 44.6104 43.9079 44.3192C43.5434 44.4336 43.079 44.5729 42.3646 44.9952C42.6187 44.8995 43.0748 44.9577 42.7561 45.1221C42.2688 45.2385 42.1043 45.303 41.9168 45.3758C41.8231 45.4153 41.7231 45.457 41.5773 45.5194C41.4357 45.5797 41.2503 45.6566 40.9754 45.7565C41.3232 45.6088 41.1045 46.0726 40.5547 46.3368C40.6193 46.2557 40.3818 46.1018 40.563 45.977C40.1632 46.2848 39.7341 46.6031 39.3426 46.94C39.6508 46.7091 39.2822 46.6925 38.9406 46.7986C38.9864 46.7861 38.9135 46.8423 38.8615 46.8672C38.7532 46.9213 38.5886 46.9962 38.4095 47.0794C38.0492 47.2437 37.6222 47.433 37.4452 47.5308L38.0554 47.3207C36.4892 48.005 36.685 48.3857 35.1563 49.122C35.3125 48.9764 35.452 48.5666 34.6544 48.9265C34.5106 49.0845 34.1982 49.4444 33.7775 49.875C33.3589 50.3097 32.8382 50.8151 32.2551 51.2728L31.9718 51.3622C31.6761 51.6035 31.3866 51.8489 31.1033 52.1027C31.3157 51.799 31.7656 51.2665 32.2884 50.7257C32.8091 50.1849 33.413 49.6482 33.8608 49.305C33.2589 49.563 33.6505 49.3009 32.8091 49.8022C32.6404 49.8583 32.7403 49.7647 32.9111 49.6358C33.0861 49.511 33.3339 49.3549 33.4589 49.2821C32.7861 49.642 32.1238 50.0289 31.4803 50.4449C31.5698 50.4865 31.2304 50.7652 30.8992 51.0564C30.566 51.3435 30.2494 51.6409 30.2973 51.6888L30.7847 51.2623L31.2616 50.8651C31.5844 50.6051 31.9093 50.3492 32.2446 50.1038C32.3259 50.1474 32.1363 50.3846 31.7948 50.7236C31.624 50.8921 31.4136 51.0855 31.1804 51.2956C31.0617 51.3976 30.9388 51.5057 30.8117 51.616C30.6805 51.7283 30.5618 51.8281 30.3931 51.9612C30.291 52.1235 30.214 52.2337 30.1182 52.3565C29.9724 52.4917 29.9578 52.3856 29.9682 52.2504C29.9786 52.1131 30.0057 51.9446 29.9745 51.9404C29.9453 52.0361 29.7662 52.3398 29.5496 52.5977C29.4892 52.6705 29.4559 52.708 29.4121 52.7475C29.3684 52.787 29.3205 52.8182 29.2747 52.8453C29.183 52.8973 29.0997 52.9243 29.0706 52.9243C29.2226 52.8349 29.3413 52.7246 29.408 52.6123C29.3101 52.6893 29.2039 52.76 29.081 52.8286C28.9623 52.8952 28.8081 52.9597 28.6686 53.0075C28.3791 53.0886 27.9646 53.124 27.6981 52.8806C27.6127 52.8307 27.4648 52.6331 27.3857 52.4729C27.3003 52.3107 27.2482 52.1672 27.192 52.1713C27.2253 52.4189 27.1753 52.6581 27.067 52.8286C26.9608 52.9971 26.7733 53.0803 26.5734 52.9451C26.5546 52.9139 26.4713 52.7829 26.3818 52.5894C26.2922 52.3939 26.2068 52.136 26.1506 51.8697C26.0298 51.3331 26.0569 50.7569 26.0985 50.5489C26.1631 50.2431 26.261 50.4699 26.363 50.6945C26.4672 50.9191 26.5859 51.1251 26.6213 50.8859C26.5692 50.8755 26.488 50.5676 26.4651 50.4303C26.4776 50.2452 26.5172 50.2826 26.5442 50.266C26.5755 50.2494 26.5859 50.1786 26.588 49.7876C26.5463 49.7543 26.5296 49.6358 26.5317 49.4985C26.5317 49.4652 26.5359 49.4298 26.5359 49.3924L26.5401 49.3383C26.5421 49.3113 26.5463 49.2863 26.5463 49.2613C26.5505 49.1844 26.5526 49.1116 26.5567 49.0492C26.563 48.9265 26.5692 48.8495 26.5609 48.8849C26.5567 48.9015 26.5484 48.9473 26.5338 49.0284C26.5276 49.07 26.5192 49.1199 26.5088 49.1781C26.5026 49.2239 26.4838 49.3425 26.4651 49.4049C26.4651 49.3799 26.4672 49.357 26.4692 49.3341C26.4713 49.3029 26.4734 49.2717 26.4734 49.2447C26.4734 49.1989 26.4734 49.1553 26.4734 49.1137C26.4734 49.0325 26.4776 48.9597 26.4797 48.8932C26.4859 48.758 26.4942 48.6457 26.5067 48.5292C26.5338 48.3004 26.5442 48.0362 26.6025 47.6098C26.5276 47.7388 26.4505 47.5349 26.4547 47.1688C26.4588 46.8048 26.5255 46.3056 26.613 45.9083C26.6421 45.9666 26.7483 45.8064 26.7983 45.7274C27.2773 44.1278 27.6189 43.2958 28.1084 41.819C28.1292 41.7878 28.1625 41.7212 28.2021 41.6442C28.2437 41.561 28.2896 41.4654 28.3291 41.3842C28.4187 41.2053 28.4999 41.0701 28.4707 41.2657C28.5332 40.9869 28.5478 40.7623 28.7311 40.2319C28.7686 40.157 28.7977 40.0988 28.8206 40.0509C28.6665 40.0031 28.7311 39.9948 28.8977 39.9989C28.8519 40.157 28.7519 40.4461 28.704 40.625C28.6582 40.7997 28.6582 40.8767 28.8331 40.5522C28.7957 40.5356 28.8498 40.2922 28.9331 39.976C28.654 39.974 28.3145 39.9719 27.9751 39.9698C27.8168 39.9698 27.6564 39.9677 27.5044 39.9656C27.4315 39.9656 27.3586 39.9656 27.2898 39.9656C27.2315 39.9656 27.1732 39.9677 27.1191 39.9698C27.1774 40.026 27.4023 40.0592 27.6918 40.08C27.9792 40.1008 28.3499 40.1029 28.7332 40.1092C28.6436 40.4461 28.5561 40.7748 28.4916 41.0202C28.3729 41.0285 28.3666 40.6957 28.3895 40.338C28.1521 40.3588 27.8668 40.3816 27.5481 40.4087C27.4815 40.4128 27.4148 40.4191 27.344 40.4232C27.2773 40.4274 27.2169 40.4316 27.1149 40.4336C26.9316 40.4357 26.74 40.4378 26.5421 40.4399C25.2488 40.4378 25.9881 40.2797 25.7632 40.3005C24.5511 40.2423 24.0241 40.3255 23.5514 40.3671C23.0848 40.4212 22.6745 40.4586 21.6769 40.3629C20.8834 40.2173 21.6436 40.0904 21.4686 39.9885C22.5246 39.9511 23.0827 40.1196 23.793 40.1591L22.9203 40.0468C23.089 40.0322 23.3493 40.0239 23.6159 40.0322C23.8825 40.0384 24.1533 40.0613 24.3449 40.0842C24.0116 40.0197 22.989 39.9199 21.8081 39.9012C20.6293 39.87 19.2984 39.9095 18.3591 39.9095C18.028 39.974 17.4573 40.0613 17.7322 40.0967L18.3237 40.0405C18.8736 40.1154 17.2199 40.2631 17.9717 40.2672C17.1845 40.3962 16.3139 40.5897 15.2017 40.6562L14.9747 40.5273C15.0039 40.5689 15.7099 40.5335 16.0161 40.4565C15.789 40.5148 15.3579 40.5065 14.9226 40.5252C14.4873 40.5439 14.0479 40.5876 13.8084 40.7207H14.6019C14.2124 40.8205 13.7751 40.9287 13.3148 41.0431C13.0836 41.0972 12.8482 41.1471 12.6066 41.1908L12.4254 41.222L12.2776 41.2449C12.2255 41.2511 12.1734 41.2553 12.1151 41.2573C12.2505 41.3177 12.2547 41.3114 12.2901 41.3052C12.3026 41.3052 12.2984 41.3052 12.3255 41.301C12.3546 41.2989 12.39 41.2969 12.4317 41.2969C12.5171 41.2969 12.6379 41.3031 12.8191 41.326C12.1839 41.1866 15.3371 40.9953 14.3332 40.8933C14.7081 40.9474 15.0143 40.9287 15.3517 40.91C15.6891 40.8892 16.0536 40.8642 16.5263 40.91C16.493 40.8621 16.1868 40.8413 17.0095 40.7935C17.0449 40.7748 17.1303 40.7498 17.1866 40.7332C17.2115 40.7332 17.2199 40.7332 17.2428 40.7332C17.2261 40.7332 17.2136 40.7332 17.197 40.7311C17.2324 40.7207 17.2345 40.7186 17.1803 40.7311C16.9824 40.7249 16.8221 40.7103 16.7554 40.6874C17.1532 40.5293 18.4674 40.442 18.909 40.365C19.4005 40.365 18.7069 40.4336 18.9777 40.4753L19.6379 40.3567C19.7087 40.4669 20.9396 40.5148 19.792 40.6084C20.1357 40.6001 20.4814 40.5959 20.8251 40.5959C21.4332 40.6562 22.2663 40.6978 22.7828 40.6749C23.2681 40.7186 24.0179 40.6167 23.5888 40.6791C24.1533 40.702 24.6969 40.6791 25.2467 40.6791L25.2613 40.7082C26.0652 40.7249 26.8983 40.7394 27.771 40.7561C27.6668 41.0639 27.6189 41.1263 27.2878 41.8959C27.1441 42.4284 27.0024 42.9775 26.7025 43.847L26.5567 43.9905C26.3797 44.6749 25.8653 45.9978 25.8819 46.3118C25.7674 46.4803 25.6424 46.7507 25.5258 47.1667C25.4675 47.3747 25.4237 47.6431 25.405 47.8844C25.3862 48.1256 25.3821 48.3524 25.3758 48.5812C25.3717 48.7892 25.3696 49.0013 25.3654 49.2114C25.3425 49.4527 25.3342 49.719 25.3342 49.954C25.3383 50.4345 25.3633 50.8463 25.4071 51.2207L25.5424 51.254C25.5799 51.4953 25.6341 51.7324 25.7132 51.9675C25.7903 52.2025 25.8861 52.4334 26.0194 52.6705C26.1527 52.9056 26.3193 53.1385 26.5296 53.3528C26.6338 53.4589 26.7504 53.5608 26.8775 53.6544C27.0087 53.7542 27.1836 53.8582 27.3565 53.9227C27.344 53.877 27.3315 53.827 27.3232 53.7813C27.5981 53.8915 27.9084 53.9518 28.2291 53.9664C28.3916 53.9726 28.5478 53.9706 28.7207 53.9581C28.904 53.9435 29.0706 53.9102 29.2518 53.8645C29.4309 53.8166 29.6183 53.748 29.8058 53.644C29.8995 53.592 29.9911 53.5296 30.0786 53.4589C30.1223 53.4235 30.1661 53.384 30.2077 53.3424L30.3056 53.2446C30.4327 53.1136 30.5535 52.9742 30.668 52.8307C30.7263 52.7579 30.7805 52.6851 30.8346 52.6102L30.9367 52.4646L31.0179 52.4022C31.0117 52.4126 31.0013 52.4272 30.9908 52.4459C30.9804 52.4584 30.97 52.4709 30.9575 52.4833C30.9513 52.4979 30.9409 52.5104 30.9325 52.5249C30.9096 52.5561 30.8846 52.5915 30.8596 52.6248C30.7992 52.7038 30.7326 52.7829 30.6722 52.8494C30.7388 52.7829 30.8055 52.7121 30.868 52.6393L30.9138 52.5853C30.9263 52.5707 30.9492 52.5416 30.9513 52.5416L30.9867 52.5083L31.0387 52.4813C31.0617 52.4667 31.1137 52.4313 31.1491 52.4064L31.3845 52.2358C31.5407 52.1193 31.699 52.007 31.8531 51.8864C32.1655 51.6492 32.4737 51.408 32.7882 51.1791C33.413 50.7195 34.0524 50.3034 34.7002 50.0538C35.0188 49.8375 35.2729 49.7252 35.5249 49.6295C35.4937 49.6462 35.4666 49.6628 35.4437 49.6774C35.4791 49.6607 35.5312 49.6337 35.5853 49.6087C35.7457 49.5505 35.9123 49.4922 36.0914 49.4278C35.9352 49.4735 35.7874 49.5214 35.6624 49.5692C35.9269 49.4361 36.3247 49.2281 36.7121 49.0138L36.9349 49.045C36.9662 49.0284 36.9932 49.0159 37.0266 48.9993C37.439 48.8557 37.3182 48.7996 37.0703 48.8141C37.264 48.7018 37.441 48.5937 37.5722 48.5001C37.9763 48.5292 38.6053 47.9509 39.1364 47.9301C39.1655 47.9031 39.2176 47.8656 39.2884 47.822C39.3092 47.8095 39.3176 47.8032 39.3509 47.7845C39.3801 47.77 39.4134 47.7471 39.4425 47.7263C39.4821 47.6992 39.5258 47.668 39.5717 47.6368C39.757 47.512 39.9861 47.3685 40.2173 47.2291C40.6755 46.9546 41.1587 46.6655 41.2108 46.5095C41.2378 46.5261 41.3628 46.4762 41.1462 46.5927C41.3753 46.4866 41.6044 46.3742 41.8168 46.2536C42.0334 46.1309 42.2188 46.0123 42.4 45.8834L42.6541 45.927C42.9332 45.7066 43.2227 45.4944 43.5247 45.2926C44.162 45.1325 44.4307 45.0929 43.8787 45.4382C44.5619 45.068 44.8639 44.9453 45.1284 44.8267L45.2533 44.7726C45.2971 44.7518 45.345 44.7165 45.3804 44.6957C45.4429 44.652 45.5095 44.6062 45.5866 44.5521C45.7386 44.444 45.9281 44.3046 46.1947 44.0987L46.1885 44.2193C46.6029 43.976 47.2007 43.4767 47.4923 43.406C47.7484 43.3145 48.165 43.1044 48.6857 42.8215C48.719 42.8028 48.7502 42.7862 48.7835 42.7675C48.8148 42.7508 48.8502 42.7321 48.8981 42.703C48.9877 42.6468 49.0814 42.5761 49.1688 42.4804C49.2563 42.3847 49.3355 42.2578 49.3792 42.1164C49.425 41.9646 49.4292 41.8439 49.425 41.7129C49.4104 41.4466 49.3042 41.1929 49.1439 40.989C49.0647 40.885 48.9606 40.7852 48.8398 40.7061C48.7794 40.6666 48.7148 40.6313 48.6482 40.6042C48.5815 40.5751 48.4878 40.546 48.4024 40.5356C48.2275 40.5106 48.0608 40.5397 47.9234 40.5855C47.8547 40.6084 47.7901 40.6375 47.7297 40.6687L47.5901 40.7415C47.4152 40.833 47.2402 40.9245 47.0632 41.0161C46.7071 41.2033 46.3468 41.3946 45.9906 41.5818C45.2783 41.9562 44.5848 42.3161 43.96 42.6073C44.5702 42.6115 42.7749 43.1065 42.7895 43.3561C42.6145 43.3707 42.2605 43.5163 42.6228 43.2521C41.4211 43.976 40.7213 44.1299 39.9424 44.7102C39.7695 44.7123 40.1673 44.4918 40.0215 44.5126C39.9278 44.5729 39.6487 44.7518 39.4988 44.7747C39.353 44.7955 39.6612 44.6374 39.8445 44.5189C38.5615 45.1137 38.5011 45.3654 38.4907 45.5942C37.7847 45.8022 37.4514 45.9666 37.0328 46.3202C36.7746 46.3784 36.3539 46.5074 37.1599 46.081C37.0432 46.135 36.8058 46.239 36.5205 46.3847C36.2331 46.5261 35.8936 46.7237 35.5957 46.9109C34.9876 47.277 34.4377 47.6306 34.4586 47.7138C34.3024 47.7596 33.8525 48.0674 33.7484 48.1506C32.7799 48.7247 32.6883 48.7642 31.751 49.3508L32.026 49.2156C31.8906 49.4111 31.6969 49.5463 31.4511 49.6753C31.2074 49.8022 30.9138 49.902 30.5014 50.0081L30.5201 49.9831C30.1078 50.0414 29.7766 50.1038 29.5642 50.1932C29.3476 50.2785 29.2309 50.3554 29.1372 50.4179C28.9602 50.5531 28.8519 50.6279 28.4333 50.9836L28.9539 51.1521C28.9477 51.1022 28.9394 51.0502 28.9248 50.9836C28.9019 50.9129 28.9019 50.8463 28.8019 50.7111C28.7873 50.6924 28.7707 50.6758 28.7519 50.6591C28.7353 50.6446 28.7353 50.6467 28.7269 50.6404C28.7123 50.6321 28.7082 50.63 28.6978 50.6279C28.679 50.6279 28.6603 50.6363 28.6457 50.6446C28.6145 50.6654 28.5874 50.6966 28.5582 50.7236L28.5062 50.7819C28.4645 50.8214 28.4228 50.8692 28.3687 50.9171C28.3458 50.9379 28.3 50.9711 28.2771 50.9358C28.2583 50.9087 28.2541 50.8692 28.2521 50.8297C28.25 50.6633 28.2958 50.4303 28.3416 50.2036C28.3666 50.0746 28.3937 49.9394 28.4228 49.8022C28.452 49.6524 28.4812 49.4964 28.5103 49.3425C28.5666 49.0325 28.6145 48.7205 28.629 48.4314L28.5041 48.837C28.4916 48.1901 29.1247 47.1418 29.2851 46.5365C29.3351 46.4054 29.2768 46.757 29.258 46.9483C29.4934 46.1538 29.4725 46.0955 29.408 46.081C29.3476 46.0664 29.2455 46.0976 29.3663 45.4923C29.5038 45.2906 29.51 45.8251 29.7204 45.0243C29.7995 44.8329 29.8995 44.2339 30.0265 43.5475C30.0911 43.2043 30.1661 42.8403 30.2515 42.495C30.2952 42.3223 30.341 42.1559 30.391 41.9978L30.4181 41.9084L30.4389 41.8314C30.4493 41.7919 30.4618 41.7545 30.4722 41.717C30.4952 41.6422 30.5181 41.5694 30.5431 41.5007C30.4264 41.7378 30.3119 41.9604 30.3785 41.3967C30.3993 41.2677 30.4431 41.118 30.491 40.9828L30.5097 40.9329C30.5097 40.9329 30.5118 40.9121 30.5222 40.9141L30.5535 40.9225C30.5951 40.9349 30.6368 40.9474 30.6784 40.9599C30.7576 40.9828 30.8367 41.0077 30.9159 41.0306L31.0304 41.0618C31.1054 41.0764 31.1783 41.093 31.2512 41.1076C31.3241 41.1221 31.397 41.1346 31.4678 41.1471C31.5428 41.1575 31.6219 41.1658 31.6969 41.17C31.9989 41.1887 32.2821 41.1554 32.5008 41.0785C32.6299 41.0826 32.6799 41.0909 32.6883 41.1055C32.7674 41.0868 32.9319 41.0535 33.0694 40.9869C33.1985 40.9287 33.3402 40.8497 33.4755 40.7394C33.6109 40.6292 33.738 40.4815 33.8275 40.3151C33.9192 40.1508 33.9733 39.9719 33.9983 39.8034C34.0441 39.4768 34.0108 39.1503 33.8879 38.8819C33.7671 38.6136 33.5817 38.4555 33.4693 38.3931C33.4318 38.287 33.3235 38.1581 33.161 38.0478C33.1236 38.025 33.0694 37.9896 33.0132 37.9646C32.9653 37.9459 32.9153 37.9251 32.8611 37.9022C32.7653 37.8669 32.6591 37.8336 32.5487 37.8045C32.4925 37.7899 32.4363 37.7774 32.3779 37.765C32.3217 37.7546 32.2488 37.74 32.228 37.7379C32.1655 37.7296 32.1009 37.7234 32.0343 37.7192C31.8989 37.713 31.7469 37.713 31.5844 37.7213C31.5219 37.7379 31.5594 37.6859 31.5615 37.6589L31.5865 37.5632C31.6052 37.4966 31.6219 37.4301 31.6386 37.3677C31.674 37.2387 31.7156 37.1077 31.7594 36.9953C31.876 36.6917 31.9968 36.4753 32.0843 36.519C32.3279 35.868 32.582 35.2211 32.8424 34.5783L32.857 34.6428C33.3943 33.426 33.5172 32.9621 33.6213 32.4941C33.7734 32.2237 33.713 32.4442 33.7213 32.4754C34.596 30.7261 34.6606 30.543 35.1605 28.9685L35.3458 28.8665C35.4687 28.4318 36.7412 26.4017 37.4327 24.6087C37.4369 24.6316 37.4431 24.6794 37.3931 24.8229C37.4931 24.5712 37.6077 24.3133 37.7305 24.0512C37.793 23.9202 37.8576 23.7892 37.9221 23.656C37.993 23.5271 38.0638 23.396 38.1367 23.265C38.4282 22.7429 38.7344 22.2229 39.0114 21.7361C39.5675 20.7627 40.0111 19.9244 39.9882 19.4689L40.538 18.1502C39.6654 19.7767 40.4881 17.8153 40.0736 18.4538C40.3798 17.7945 41.0483 16.846 40.6651 17.6509L40.5818 17.7653C40.6463 18.1668 41.6981 15.7602 41.821 15.8787C42.2313 15.0696 42.6478 14.2688 43.0644 13.4784L43.2206 13.1809L43.2602 13.1061C43.2747 13.0769 43.2977 13.0374 43.3122 13.0021L43.3768 12.8336C43.4539 12.6401 43.5434 12.4488 43.6392 12.2574C43.6809 12.1742 43.7538 12.0328 43.7975 11.9017C43.8454 11.7665 43.8767 11.6209 43.8912 11.4711C43.9037 11.3172 43.8996 11.1716 43.8683 11.0115C43.8558 10.9303 43.8308 10.8534 43.8017 10.7785C43.7725 10.7036 43.7434 10.6412 43.7059 10.5726C43.5663 10.3063 43.3206 10.0567 43.0352 9.91943C42.8936 9.84871 42.7478 9.80295 42.6062 9.77383C42.5354 9.75719 42.4625 9.74887 42.3979 9.74055C42.3375 9.73431 42.275 9.72807 42.2146 9.72391C41.7273 9.68854 41.2483 9.72807 40.788 9.81127C40.3277 9.89863 39.8986 10.013 39.4675 10.1524C39.0385 10.2897 38.6199 10.4644 38.2283 10.6391L38.6678 10.6495L37.5618 11.1259C37.4077 11.1675 37.2952 11.1862 37.3182 11.1404C37.3411 11.0905 37.5035 10.9969 37.9013 10.8263C37.6722 10.8721 37.3452 11.0281 37.0891 11.2132C36.8329 11.39 36.6392 11.5606 36.6371 11.5855C35.8832 11.9558 35.9998 11.8351 36.2497 11.6417C36.4996 11.4503 36.8891 11.2049 36.6579 11.3235C36.4517 11.4379 36.2476 11.5543 36.0456 11.6729L36.1956 11.6147C35.7374 11.9641 35.729 12.0494 34.848 12.586C34.2774 12.9064 34.5044 12.6713 34.2836 12.8044C34.2774 12.792 34.2024 12.8336 33.9525 13.0187C33.5297 13.2953 33.1131 13.5803 32.7008 13.8715L33.2777 13.6406C32.7716 14.0837 32.1259 14.4664 32.7841 14.1898C32.2946 14.3811 31.1554 15.2152 30.1203 16.0868C29.0789 16.9541 28.1333 17.8548 27.8793 18.0399C27.269 18.7534 26.6067 19.3961 25.8028 20.2011C26.0235 20.0222 26.2568 20.0139 25.5591 20.7024C25.5612 20.2073 24.2032 21.8901 23.4868 22.3061C23.7888 22.1022 23.3181 22.6181 22.8932 23.1069C22.4683 23.5957 22.0872 24.0554 22.5475 23.7226C21.9768 24.3092 22.4204 23.6727 21.9414 24.0783C21.3333 24.8417 20.6064 25.6425 19.8504 26.4807C19.0922 27.319 18.2946 28.203 17.5469 29.1473C17.5573 29.2056 17.8655 28.9373 17.5906 29.3782L16.6138 30.2248C16.3326 30.6096 16.5409 30.7261 15.8765 31.3106C15.9827 31.2378 16.141 31.1296 15.9536 31.3875C15.1788 32.2778 14.4353 33.2097 13.7105 34.1665C13.3481 34.6449 12.9899 35.1295 12.6358 35.6163L12.1047 36.3505C12.0172 36.4753 11.9235 36.6001 11.8381 36.727L11.5903 37.1077L10.5906 38.624L10.3698 38.9527L10.2948 39.0629C10.2636 39.0899 10.2094 39.0858 10.1678 39.0983L9.35551 39.2709C8.16836 39.5226 6.98329 39.7722 5.79822 39.9968C6.45011 39.9074 6.03357 40.0301 5.55454 40.1674C5.87112 40.0988 5.57745 40.2756 5.65451 40.3172C4.99221 40.444 4.32782 40.5897 3.66968 40.7561C3.52181 40.8954 3.00946 41.0764 2.52418 41.2698C2.03682 41.4591 1.57238 41.6588 1.50781 41.7732L2.08889 41.5007C1.73066 41.7503 2.04724 41.7316 2.44712 41.6942C2.847 41.6567 3.3302 41.6047 3.31562 41.742C3.71758 41.4799 4.3299 41.3509 5.00887 41.2157C5.68784 41.0805 6.44595 40.9329 7.14991 40.5855C7.49148 40.546 6.88957 40.7353 7.0791 40.7436C7.429 40.5439 7.88095 40.4004 8.74319 40.2381L8.65364 40.286C9.24929 40.1341 9.76164 40.0176 10.2386 39.9178C10.4094 39.8824 10.5781 39.8471 10.7426 39.8117C10.7926 39.8138 10.8072 39.768 10.8322 39.7348L10.903 39.6328C10.9509 39.5642 10.9967 39.4956 11.0446 39.4269C11.1841 39.2293 11.3216 39.0359 11.4611 38.8403C11.7277 38.468 12.0027 38.0894 12.3088 37.663C12.6108 37.2262 12.9649 36.7915 13.3918 36.2403L13.1731 36.3339C13.5397 35.8659 13.6438 35.7889 13.8355 35.583C14.0958 34.9257 12.8316 36.9142 13.0399 36.2985C13.3731 36.0531 13.9979 35.2127 14.6165 34.4098C15.235 33.6049 15.8474 32.8353 16.1223 32.7125C16.6867 31.9949 15.8453 32.8373 16.4118 32.1197L16.6221 31.9762L16.6888 31.7349C17.0741 31.2773 17.3386 31.1005 17.4011 31.1234C17.3053 31.2315 17.1553 31.4562 17.0637 31.581C17.6156 31.0298 18.4154 29.8608 18.6091 29.6736L18.0176 30.3226C18.7778 29.3345 19.6692 28.2758 20.5564 27.2275C21 26.7033 21.4416 26.1833 21.8685 25.6778C22.2955 25.1765 22.7099 24.6836 23.089 24.2135L22.9245 24.3092C24.0929 22.8843 23.9637 23.265 25.3196 21.7674L25.2779 21.8298C25.5174 21.499 25.8715 21.0893 26.2631 20.7003C25.9548 21.1101 27.0274 20.1054 26.6109 20.6358C27.2669 19.887 27.4315 19.706 27.521 19.5667C27.6127 19.4294 27.6335 19.342 28.0375 18.8116L28.3229 18.6722C28.5936 18.3062 28.5874 18.2438 29.3226 17.5532C28.7582 18.1606 29.8974 17.2349 29.2788 17.9276C30.1328 17.3036 30.6972 16.7648 31.1658 16.328C31.6365 15.8933 32.0093 15.5605 32.4821 15.3899C32.7882 14.9947 32.4008 15.2381 31.9947 15.5418C31.5886 15.8476 31.1595 16.2157 31.3532 16.0223C30.945 16.2428 31.851 15.3629 32.4008 14.9864C32.9486 14.5891 33.5109 14.5558 34.9084 13.6219C34.7689 13.7134 34.7689 13.7363 34.6294 13.8278C35.1896 13.5345 35.6145 13.079 36.3372 12.7857C36.6329 12.4321 37.214 12.3094 37.2307 12.0744C36.7808 12.3281 36.3393 12.5923 35.904 12.8689C36.2664 12.6235 36.5996 12.3489 37.0141 12.0702C37.2224 11.9329 37.4494 11.7873 37.7118 11.6563C37.9784 11.5315 38.2783 11.4067 38.6219 11.286C38.5345 11.3692 38.1637 11.5918 37.9055 11.7374C38.3158 11.623 38.6344 11.3713 39.0572 11.2548C39.0406 11.3692 38.6178 11.571 38.0992 11.8019C37.8368 11.9142 37.566 12.0515 37.3077 12.1992C37.0495 12.3448 36.8079 12.4987 36.6246 12.6464C36.8412 12.5736 37.2099 12.3302 37.491 12.1638C37.7701 11.9953 37.9555 11.9079 37.7972 12.1056C38.0388 11.8414 38.4241 11.6854 38.8594 11.5107C39.2947 11.3339 39.7695 11.1799 40.2756 10.9262L40.2381 11.0614C40.3964 10.9948 40.738 10.843 41.0421 10.791C40.8692 10.8762 40.6984 10.9699 40.5235 11.0697C40.9358 10.8908 41.3399 10.8471 41.7314 10.8658C41.9251 10.8742 42.1167 10.8991 42.2938 10.9283C42.4271 10.9553 42.5083 10.9886 42.5729 11.0156C42.4562 10.9262 42.2605 10.9116 42.1292 10.8887C42.0126 10.8679 41.9959 10.8492 42.0084 10.8242C42.0334 10.7785 42.1876 10.7182 41.8293 10.6724C42.0834 10.6474 42.325 10.6537 42.45 10.6786C42.5874 10.7078 42.6708 10.7598 42.727 10.8138C42.8332 10.922 42.8499 11.0531 42.8457 11.1591C42.827 11.2423 42.7957 11.3401 42.7291 11.4815C42.6916 11.5668 42.6583 11.6043 42.5312 11.8539C42.4771 11.962 42.4208 12.0827 42.3625 12.22C42.3334 12.2886 42.3042 12.3614 42.275 12.4384C42.2625 12.4737 42.25 12.5091 42.2375 12.5465C42.2334 12.5611 42.2355 12.559 42.223 12.584C42.2375 12.5486 42.2271 12.5736 42.248 12.5195C42.2709 12.4571 42.3 12.3905 42.3292 12.326C42.3896 12.195 42.4583 12.064 42.5187 11.9641C42.6416 11.7644 42.7207 11.6833 42.6228 11.9558C42.5625 12.0723 42.4979 12.1992 42.4354 12.3323L42.3417 12.534C42.3042 12.6214 42.3209 12.5673 42.2771 12.6422C42.1376 12.8648 42.0043 13.0665 41.9064 13.1872C41.1462 14.7285 42.1376 13.0083 41.871 13.6926C41.4732 14.1461 41.5398 14.4706 41.2399 15.1632L41.1275 15.1133C40.1673 16.8189 41.1191 15.6915 40.236 17.2162L40.4214 16.4757L40.0444 17.314L40.007 17.081C39.6487 18.017 39.4821 18.2812 38.9968 19.1361C39.178 18.9739 39.1364 19.3524 38.7427 20.1262C38.4074 20.6192 38.7906 19.7788 38.2429 20.8813C38.3012 20.6004 38.3554 20.2843 38.7011 19.86C38.6907 19.7934 38.7573 19.5812 38.749 19.5126C38.3824 20.0409 37.9971 20.9291 37.793 21.3264C37.8763 21.1766 37.9763 20.9957 38.0388 20.9104L37.3723 22.5744C37.2015 22.8032 37.2703 22.589 37.339 22.3768C37.1869 22.7054 37.114 22.9488 36.8933 23.4314C36.8641 23.2629 36.7517 23.2442 37.0557 22.5557C36.8225 23.0736 36.6163 23.604 36.4038 24.1324C36.3164 24.2156 35.9206 24.8687 35.9831 24.6524C35.5228 25.4802 35.1605 26.826 34.5502 27.9222C34.5398 27.9888 34.5002 28.1136 34.3982 28.3611C33.8942 29.4219 33.3547 30.3226 32.9049 31.6476L32.4154 32.2965C32.003 33.3074 33.0611 31.4125 32.3759 33.0953C31.9156 34.3038 32.0447 33.478 31.8198 33.8753C31.7365 34.1894 31.6302 34.622 31.4761 35.1087C31.3991 35.3521 31.3095 35.608 31.2054 35.87C31.1533 36.0011 31.0971 36.1321 31.0367 36.2652C31.0054 36.3318 30.9742 36.3984 30.9429 36.4649C30.9075 36.5357 30.8721 36.6085 30.8346 36.6813C30.8513 36.6272 30.868 36.5773 30.8825 36.5253C30.8971 36.4816 30.9117 36.4379 30.9263 36.3942C30.9554 36.3089 30.9867 36.2278 31.0179 36.1488C31.0804 35.9886 31.145 35.8326 31.2074 35.66L31.222 35.6516ZM28.7477 43.7721C28.7936 43.5121 28.8561 42.9859 28.9768 42.8215C29.0331 43.1481 28.906 43.3519 28.7477 43.7721ZM39.5675 45.7149C39.4071 45.8314 39.1239 45.9333 38.7969 46.0269C39.0177 45.9187 39.2738 45.8126 39.5675 45.7149ZM21.629 40.5231C21.6394 40.5231 21.6477 40.5189 21.6561 40.5168C22.2267 40.5751 22.0247 40.5522 21.629 40.5231ZM20.4398 40.469C20.3211 40.4877 20.3294 40.5044 20.3794 40.521C20.4627 40.4877 20.7293 40.4815 21.0333 40.4919C20.948 40.4607 20.7938 40.4378 20.4398 40.469ZM34.1962 12.9043L34.4128 12.8003C33.9858 13.1248 34.0941 13.0166 34.1962 12.9043Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M37.5372 46.8133C37.462 46.8257 37.4348 46.8133 37.4097 46.8008C37.3282 46.8632 37.3366 46.8861 37.5372 46.8133Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M34.5439 27.9512L34.5628 27.9159C34.5648 27.893 34.5628 27.8784 34.5607 27.8701L34.5439 27.9533V27.9512Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M26.6632 50.4307C26.6569 50.6699 26.6444 50.7947 26.6318 50.88C26.6653 50.8841 26.6715 50.7968 26.6632 50.4307Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.1621 41.1702L14.9202 41.0371C14.5537 41.0912 14.4162 41.0829 14.2288 41.0891C14.2496 41.1162 14.4016 41.137 14.1621 41.1702Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M9.63446 44.5564C9.59489 44.6625 9.52199 44.7665 9.48242 44.8726H9.54699C9.774 44.4482 9.89272 44.1321 9.63446 44.5564Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.4024 40.8599C13.3274 40.7663 12.8525 40.8661 12.3193 40.9556C12.3506 40.9514 12.3818 40.9472 12.4151 40.9431C12.2756 41.1074 12.8421 40.9826 13.4044 40.8599H13.4024Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12.2187 40.9747C12.1249 40.9914 12.0312 41.0059 11.9396 41.0163C11.9292 41.0351 11.9187 41.0517 11.9062 41.0704C11.9146 41.1099 11.9312 41.0912 11.9542 41.0392C12.0125 41.0267 12.1062 40.9955 12.2187 40.9727V40.9747Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.9335 40.586C18.6794 40.5714 18.7815 40.7253 18.6357 40.692C18.3587 40.8335 20.3164 40.457 18.9335 40.586Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12.9229 40.5816L13.1311 40.6836L13.4185 40.54L12.9229 40.5816Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.1741 40.1816L16.3118 40.2212C16.3264 40.242 16.2181 40.2648 16.0869 40.2877C16.6159 40.2378 17.1991 40.217 17.1762 40.1816H17.1741Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.0848 40.2881C15.8098 40.313 15.5474 40.3442 15.3975 40.3817C15.5453 40.363 15.8661 40.3234 16.0848 40.2881Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.0898 40.3856L14.346 40.3772L14.9521 40.3086L14.0898 40.3856Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M26.4458 40.2323L27.3768 40.2531C27.4789 40.2157 27.2373 40.1741 26.8811 40.1699C26.6541 40.1866 26.3042 40.1824 26.4458 40.2323Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23.6162 39.7725C23.8724 39.8141 23.8849 39.8453 24.0244 39.8953L24.0598 39.7393L23.6162 39.7705V39.7725Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M26.3625 39.8405C26.4584 39.803 27.7413 39.7989 26.5417 39.7344C26.4417 39.7635 25.4961 39.776 26.3625 39.8405Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M26.4755 51.8594C26.4505 51.7845 26.4234 51.7117 26.4026 51.6348L26.1631 51.7408C26.2672 51.7845 26.3714 51.824 26.4755 51.8594Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M36.293 47.8652C35.2475 48.2937 36.1202 48.119 35.1663 48.4976C34.9559 48.6681 35.9452 48.1876 35.7224 48.3561C36.3076 48.0046 36.6471 47.8881 36.2909 47.8673L36.293 47.8652Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M35.7225 48.3545C35.6288 48.4107 35.5309 48.4731 35.4268 48.5417C35.5975 48.4398 35.6746 48.3878 35.7225 48.3545Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M2.34921 41.0869C2.11594 41.1597 1.8806 41.2346 1.64941 41.3116L2.12011 41.2138L2.34921 41.0869Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M1.12679 41.8028L0.901854 41.7217L0.564453 42.0399C0.710244 41.963 0.995577 41.8194 1.12679 41.8028Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M27.9316 45.659L27.9588 45.7214C28.0257 45.6195 28.0654 45.4531 28.149 45.1182L27.9316 45.6569V45.659Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M32.8444 39.4453C32.8444 39.4723 32.8382 39.5056 32.834 39.5305C32.8904 39.4869 32.9447 39.4245 32.9907 39.3662C32.9427 39.3974 32.8967 39.4224 32.8444 39.4453Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M31.8901 33.1956C31.7506 33.5034 31.6256 33.882 31.4902 34.1919C31.7485 33.5013 32.0984 33.1852 31.8901 33.1956Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M43.0784 43.6955C43.6428 43.369 44.6176 42.8115 46.0026 42.0211C47.3876 41.2328 48.8122 40.4819 50.2784 39.7684C51.7446 39.0549 53.0963 38.5537 54.3397 38.2604C55.581 37.9692 56.3662 38.1584 56.6953 38.8241C56.916 39.3378 56.864 39.8474 56.5391 40.3487C56.2142 40.8521 55.9788 41.3118 55.833 41.732L54.952 43.9389C55.6164 43.5062 56.285 43.1256 56.9535 42.7969C57.6221 42.4683 58.2906 42.1397 58.9592 41.811C60.6004 40.8854 62.2936 39.9057 64.0369 38.874C65.7801 37.8423 67.5546 37.0435 69.3624 36.4757C70.0351 36.3031 70.6329 36.276 71.1556 36.3904C71.6784 36.5069 72.0887 36.7315 72.3823 37.0602C72.676 37.3909 72.8322 37.8277 72.8447 38.3748C72.8593 38.9197 72.6656 39.5105 72.2657 40.1449C71.8158 40.8854 71.3243 41.5468 70.7932 42.1313C70.2621 42.7179 69.7185 43.3565 69.1645 44.045C69.0646 44.2031 68.8875 44.4173 68.6334 44.6835C68.3794 44.9498 68.1148 45.2556 67.8378 45.6008C67.5608 45.9461 67.3088 46.2914 67.0839 46.6346C66.859 46.9799 66.7215 47.2815 66.6778 47.5415C67.0443 47.6372 67.5004 47.6247 68.044 47.5062C68.5876 47.3876 69.1312 47.2316 69.6727 47.0361C70.2142 46.8405 70.7287 46.6325 71.2181 46.4121C71.7055 46.1916 72.0783 46.0273 72.3365 45.9149L75.5002 44.4298C75.7043 44.3216 75.973 44.1573 76.3083 43.941C76.6394 43.7246 76.9872 43.5208 77.3455 43.3294C77.7037 43.1381 78.0515 42.9613 78.3868 42.7969C78.7201 42.6326 78.9908 42.5473 79.1991 42.5432C79.6677 42.5307 79.9072 42.7595 79.9197 43.2275C79.9322 43.6955 79.7323 44.0637 79.3241 44.3341C78.8617 44.6066 78.3743 44.8645 77.8599 45.112C77.3455 45.3596 76.806 45.6196 76.2395 45.8941C75.521 46.3289 74.8275 46.7095 74.161 47.0382C73.4924 47.3668 72.7989 47.7246 72.0803 48.1052C71.668 48.3236 71.0119 48.6398 70.1143 49.0516C69.2124 49.4656 68.3106 49.7734 67.4046 49.9793C66.4987 50.1832 65.7051 50.179 65.0241 49.9627C64.3409 49.7464 63.9869 49.1203 63.9598 48.0803C63.9473 47.5623 64.0639 47.0902 64.3139 46.6679C64.5638 46.2457 64.8512 45.8359 65.1803 45.4365C65.5073 45.0392 65.8634 44.6523 66.2425 44.2779C66.6236 43.9056 66.9652 43.5582 67.2713 43.2379C67.5775 42.9717 68.0815 42.4121 68.7896 41.5614C69.4957 40.7127 69.9435 39.9202 70.1351 39.1881C68.7355 39.3794 67.3255 39.7809 65.9113 40.3883C64.4951 40.9977 63.1975 41.628 62.0166 42.2811C60.5254 43.0486 58.9863 43.9056 57.3971 44.8562C55.808 45.8068 54.4313 46.9196 53.2671 48.1988C53.0109 48.4131 52.7402 48.5379 52.4569 48.5711C52.1716 48.6044 51.8967 48.5607 51.6343 48.4359C51.3697 48.3132 51.1698 48.1239 51.0344 47.866C50.897 47.6102 50.8761 47.2732 50.9699 46.853C51.1136 46.3809 51.4926 45.9565 52.1091 45.5759C52.359 45.1536 52.6048 44.6669 52.8526 44.1136C53.0984 43.5624 53.2713 43.2338 53.3733 43.1256C53.467 42.7595 53.5629 42.3809 53.6566 41.9878C53.7503 41.5947 53.819 41.1912 53.8607 40.7731C53.2921 40.9436 52.7256 41.1412 52.157 41.3617C51.5884 41.5843 51.1511 41.7528 50.8428 41.863C50.1222 42.1937 49.4016 42.512 48.681 42.8157C47.9603 43.1214 47.2397 43.4646 46.5212 43.8453C46.1088 44.0637 45.7381 44.2821 45.4048 44.4984C45.0716 44.7147 44.6988 44.9061 44.2885 45.0725C43.9802 45.2368 43.6824 45.2826 43.3929 45.2119C43.1055 45.1412 42.8806 45.0309 42.7202 44.877C42.5598 44.7251 42.4911 44.5317 42.5098 44.2987C42.5307 44.0637 42.7202 43.864 43.0805 43.6997L43.0784 43.6955Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M43.0784 43.6955C43.6428 43.369 44.6176 42.8115 46.0026 42.0211C47.3876 41.2328 48.8122 40.4819 50.2784 39.7684C51.7446 39.0549 53.0963 38.5537 54.3397 38.2604C55.581 37.9692 56.3662 38.1584 56.6953 38.8241C56.916 39.3378 56.864 39.8474 56.5391 40.3487C56.2142 40.8521 55.9788 41.3118 55.833 41.732L54.952 43.9389C55.6164 43.5062 56.285 43.1256 56.9535 42.7969C57.6221 42.4683 58.2906 42.1397 58.9592 41.811C60.6004 40.8854 62.2936 39.9057 64.0369 38.874C65.7801 37.8423 67.5546 37.0435 69.3624 36.4757C70.0351 36.3031 70.6329 36.276 71.1556 36.3904C71.6784 36.5069 72.0887 36.7315 72.3823 37.0602C72.676 37.3909 72.8322 37.8277 72.8447 38.3748C72.8593 38.9197 72.6656 39.5105 72.2657 40.1449C71.8158 40.8854 71.3243 41.5468 70.7932 42.1313C70.2621 42.7179 69.7185 43.3565 69.1645 44.045C69.0646 44.2031 68.8875 44.4173 68.6334 44.6835C68.3794 44.9498 68.1148 45.2556 67.8378 45.6008C67.5608 45.9461 67.3088 46.2914 67.0839 46.6346C66.859 46.9799 66.7215 47.2815 66.6778 47.5415C67.0443 47.6372 67.5004 47.6247 68.044 47.5062C68.5876 47.3876 69.1312 47.2316 69.6727 47.0361C70.2142 46.8405 70.7287 46.6325 71.2181 46.4121C71.7055 46.1916 72.0783 46.0273 72.3365 45.9149L75.5002 44.4298C75.7043 44.3216 75.973 44.1573 76.3083 43.941C76.6394 43.7246 76.9872 43.5208 77.3455 43.3294C77.7037 43.1381 78.0515 42.9613 78.3868 42.7969C78.7201 42.6326 78.9908 42.5473 79.1991 42.5432C79.6677 42.5307 79.9072 42.7595 79.9197 43.2275C79.9322 43.6955 79.7323 44.0637 79.3241 44.3341C78.8617 44.6066 78.3743 44.8645 77.8599 45.112C77.3455 45.3596 76.806 45.6196 76.2395 45.8941C75.521 46.3289 74.8275 46.7095 74.161 47.0382C73.4924 47.3668 72.7989 47.7246 72.0803 48.1052C71.668 48.3236 71.0119 48.6398 70.1143 49.0516C69.2124 49.4656 68.3106 49.7734 67.4046 49.9793C66.4987 50.1832 65.7051 50.179 65.0241 49.9627C64.3409 49.7464 63.9869 49.1203 63.9598 48.0803C63.9473 47.5623 64.0639 47.0902 64.3139 46.6679C64.5638 46.2457 64.8512 45.8359 65.1803 45.4365C65.5073 45.0392 65.8634 44.6523 66.2425 44.2779C66.6236 43.9056 66.9652 43.5582 67.2713 43.2379C67.5775 42.9717 68.0815 42.4121 68.7896 41.5614C69.4957 40.7127 69.9435 39.9202 70.1351 39.1881C68.7355 39.3794 67.3255 39.7809 65.9113 40.3883C64.4951 40.9977 63.1975 41.628 62.0166 42.2811C60.5254 43.0486 58.9863 43.9056 57.3971 44.8562C55.808 45.8068 54.4313 46.9196 53.2671 48.1988C53.0109 48.4131 52.7402 48.5379 52.4569 48.5711C52.1716 48.6044 51.8967 48.5607 51.6343 48.4359C51.3697 48.3132 51.1698 48.1239 51.0344 47.866C50.897 47.6102 50.8761 47.2732 50.9699 46.853C51.1136 46.3809 51.4926 45.9565 52.1091 45.5759C52.359 45.1536 52.6048 44.6669 52.8526 44.1136C53.0984 43.5624 53.2713 43.2338 53.3733 43.1256C53.467 42.7595 53.5629 42.3809 53.6566 41.9878C53.7503 41.5947 53.819 41.1912 53.8607 40.7731C53.2921 40.9436 52.7256 41.1412 52.157 41.3617C51.5884 41.5843 51.1511 41.7528 50.8428 41.863C50.1222 42.1937 49.4016 42.512 48.681 42.8157C47.9603 43.1214 47.2397 43.4646 46.5212 43.8453C46.1088 44.0637 45.7381 44.2821 45.4048 44.4984C45.0716 44.7147 44.6988 44.9061 44.2885 45.0725C43.9802 45.2368 43.6824 45.2826 43.3929 45.2119C43.1055 45.1412 42.8806 45.0309 42.7202 44.877C42.5598 44.7251 42.4911 44.5317 42.5098 44.2987C42.5307 44.0637 42.7202 43.864 43.0805 43.6997L43.0784 43.6955Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M42.6764 43.3227C42.9167 43.2041 42.7934 43.1729 42.8226 43.1396C42.622 43.2457 42.5907 43.3081 42.6074 43.3248C42.6241 43.3435 42.6868 43.3289 42.6764 43.3248V43.3227Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M44.8063 45.1829L44.7646 45.2432C44.9146 45.1413 45.0583 45.0352 45.1979 44.9229C45.0708 45.0144 44.9396 45.1017 44.8063 45.1829Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M47.6353 43.631C47.2959 43.6227 46.6065 44.1656 46.1066 44.4152L46.0087 44.4318L45.8525 44.6627C46.142 44.4859 46.4628 44.2592 46.7794 44.0657C47.1001 43.8785 47.4063 43.7142 47.6333 43.6289L47.6353 43.631Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M49.3203 43.2321C49.1995 43.2217 49.6432 43.0345 48.9434 43.3777C48.9808 43.3673 48.9933 43.3673 49.0163 43.3611C49.0808 43.332 49.1683 43.2924 49.3203 43.23V43.2321Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M49.0162 43.3623C48.7048 43.5038 49.2398 43.3186 49.0162 43.3623V43.3623Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M50.4492 42.693L50.0576 42.9218C50.1576 42.9156 50.5283 42.7617 50.4033 42.8449C50.8157 42.6327 50.7137 42.6389 50.4492 42.693Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M50.7956 42.4209L50.5908 42.5353C50.6347 42.5311 50.6932 42.5124 50.7956 42.4209Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M50.1574 42.7781L50.5906 42.5348C50.5197 42.5389 50.4948 42.4973 50.3885 42.6409C50.4073 42.5847 50.3344 42.6617 50.1553 42.7761L50.1574 42.7781Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M49.8907 42.87C49.6471 42.9428 49.3388 43.0551 49.7324 42.8242C48.9535 43.1903 49.1097 43.2361 49.8907 42.87Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M47.7143 43.4189L47.3936 43.525L47.1582 43.6997C47.2748 43.6103 47.7539 43.4543 47.7143 43.421V43.4189Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.6214 41.9193C52.6423 41.8777 52.588 41.8403 52.5733 41.8008L52.4375 41.8861C52.5127 41.884 52.6298 41.8653 52.6214 41.9173V41.9193Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.5757 41.8007C52.6488 41.755 52.7303 41.7071 52.8223 41.6572C52.607 41.7238 52.5652 41.7675 52.5757 41.8007Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M50.7984 42.2354L50.0986 42.6701L50.9421 42.1709L50.7984 42.2354Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.9572 41.9229C52.9319 41.9229 52.9025 41.9313 52.873 41.946C52.9172 41.9229 52.9572 41.9229 52.9929 41.946C52.9824 41.9355 52.9698 41.9271 52.9572 41.9229Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.8088 42.5847C52.7984 42.3704 52.6401 42.8322 52.6547 42.6117C52.6464 42.6512 52.638 42.6907 52.6318 42.7303L52.6276 42.7594C52.6276 42.7594 52.6276 42.7615 52.6276 42.7635L52.6318 42.7698C52.6318 42.7698 52.638 42.7739 52.6401 42.776C52.6422 42.7781 52.6464 42.7823 52.6484 42.7864C52.6193 42.8343 52.613 42.8509 52.6005 42.8759L52.5693 42.9445C52.5506 42.9882 52.5339 43.0319 52.5193 43.0714C52.4902 43.1525 52.4672 43.2274 52.4443 43.3002C52.4714 43.2295 52.5027 43.1567 52.5401 43.0818C52.5589 43.0444 52.5797 43.0048 52.6026 42.9632L52.6401 42.9008L52.6943 42.8176C52.6943 42.8176 52.7005 42.8114 52.7047 42.8093C52.7109 42.8093 52.7109 42.8031 52.7151 42.7989L52.7234 42.7864C52.7234 42.7864 52.738 42.7448 52.7463 42.7261C52.7651 42.6783 52.7838 42.6304 52.8026 42.5805L52.8088 42.5847Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.3125 43.7499C52.3585 43.6127 52.3961 43.4671 52.4463 43.3027C52.3877 43.4525 52.3438 43.5981 52.3125 43.7499Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.1901 41.5596C53.1629 41.6012 53.0961 41.7031 53.0605 41.7925C53.1003 41.7468 53.14 41.6927 53.1818 41.6324C53.1838 41.6095 53.188 41.5845 53.1922 41.5596H53.1901Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.1858 41.626L53.1816 41.6322C53.1691 41.7113 53.1586 41.7653 53.1523 41.7882C53.1565 41.7674 53.167 41.7196 53.1837 41.6281L53.1858 41.626Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.1855 41.5495C53.1983 41.5431 53.1898 41.556 53.1898 41.5602C53.2004 41.5431 53.2132 41.5239 53.1855 41.5495Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.0176 41.8483C52.0821 41.8108 52.1634 41.7651 52.2425 41.7214C52.2883 41.6964 52.3071 41.6819 52.33 41.6673C52.3529 41.6527 52.3737 41.6382 52.3904 41.6236C52.457 41.5695 52.4695 41.53 52.2425 41.5675C52.0717 41.6985 52.4008 41.6195 52.0176 41.8483Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.1893 41.4258L52.8998 41.5048C52.8935 41.5319 52.9206 41.5589 52.8311 41.6171L53.1893 41.4258Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.3754 41.333L53.1895 41.4266L53.2939 41.3996L53.3754 41.333Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.8418 42.9054L52.8377 42.9179L52.8189 42.9533L52.8085 42.9782L52.7856 43.0261L52.7439 43.1176C52.7169 43.1758 52.6898 43.2362 52.6627 43.2986C52.6106 43.415 52.5544 43.5398 52.4961 43.6709C52.5565 43.5586 52.619 43.4442 52.6794 43.3298C52.746 43.2091 52.8002 43.1072 52.8981 42.9574C52.9064 42.945 52.9147 42.9325 52.9251 42.9221C52.9335 42.9158 52.9355 42.9075 52.9355 42.8992C52.9293 42.8909 52.9231 42.8805 52.9147 42.8742C52.9043 42.8617 52.8918 42.8534 52.8793 42.8617C52.871 42.8638 52.8689 42.8763 52.8564 42.8888C52.8522 42.8909 52.8418 42.9054 52.8418 42.9054Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.0938 42.0527C53.0938 42.0527 53.0938 42.0677 53.0938 42.0741C53.1044 42.0591 53.1087 42.0527 53.0938 42.0527Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M51.0635 45.7549C51.0802 45.7444 51.0948 45.7381 51.1116 45.7298C51.1116 45.7235 51.1095 45.7172 51.1095 45.7109L51.0635 45.7569V45.7549Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.9566 42.8824C52.9629 42.8699 52.9649 42.8595 52.9712 42.8449C52.9775 42.82 52.9837 42.7971 52.99 42.7742C53.0005 42.7285 53.0088 42.6889 53.0151 42.6494C53.0276 42.5724 53.0318 42.5059 53.0318 42.4414C53.0172 42.5184 53.0005 42.5953 52.9837 42.6765C52.9691 42.743 52.9545 42.8096 52.9378 42.8803C52.9378 42.8845 52.9357 42.8907 52.9336 42.8969C52.944 42.9094 52.9503 42.9136 52.9545 42.8865C52.9545 42.8865 52.9545 42.8845 52.9545 42.8824H52.9566Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.0362 44.4463C52.103 44.3527 52.1741 44.2445 52.2451 44.126C52.172 44.2154 52.0341 44.4005 52.0362 44.4463Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.0503 42.1419C53.0503 42.1314 53.0523 42.1209 53.0544 42.1084C53.0168 42.1753 53.0293 42.169 53.0503 42.1419Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.0501 42.1418C53.0354 42.2562 53.0354 42.3498 53.0312 42.4434C53.0563 42.3102 53.0793 42.1834 53.0919 42.0752C53.0793 42.1002 53.0626 42.1251 53.0501 42.1418Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M51.0567 46.8281C51.0213 46.7989 51.0317 46.6325 51.1338 46.4349C51.2337 46.2373 51.4316 46.0252 51.6586 45.8983C51.8336 45.7152 51.8294 45.6258 51.7065 45.5904C51.5878 45.5592 51.3524 45.5967 51.1129 45.7277C51.1192 45.7485 51.1275 45.761 51.0879 45.8317C51.0504 45.9024 50.9546 46.0231 50.8109 46.3018C50.8817 46.2145 51.1046 45.9586 51.2962 45.8255C51.4857 45.6882 51.619 45.6341 51.4649 45.8088C51.2087 46.0688 51.1213 46.1957 51.0421 46.2685C50.9671 46.3455 50.9088 46.3788 50.8047 46.5431C50.9276 46.4225 50.8255 46.6513 50.8234 46.9237C50.8172 47.1775 50.8817 47.4354 50.9567 47.3543C50.938 47.1609 50.9401 46.957 50.988 46.7594C51.0109 46.7594 50.988 46.9653 51.0546 46.8239L51.0567 46.8281Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M51.784 45.1723L51.8653 45.0059C51.834 45.0558 51.8028 45.0995 51.7716 45.1431C51.7528 45.1619 51.7382 45.1723 51.7216 45.1847C51.707 45.1993 51.6757 45.1951 51.6528 45.1972C51.6508 45.1972 51.6466 45.1972 51.6445 45.1972C51.6445 45.1972 51.6403 45.1972 51.6278 45.2014C51.6091 45.2097 51.5924 45.218 51.5716 45.2263C51.5341 45.2451 51.4945 45.2638 51.4508 45.2846C51.1467 45.5696 51.1134 45.6694 51.1113 45.7068C51.2613 45.5612 51.4196 45.4343 51.5799 45.322L51.6862 45.2513L51.7299 45.2243C51.7445 45.2159 51.7507 45.1972 51.7611 45.1827L51.7986 45.1203L51.7882 45.1535V45.1702L51.784 45.1723Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.2798 44.1786C52.2965 44.3637 52.107 44.8317 52.3319 44.5987C52.5943 44.0371 52.4444 44.1806 52.5652 43.8208C52.1736 44.7422 52.636 43.5462 52.2923 44.1744C52.359 43.9955 52.4256 43.8312 52.4964 43.6689C52.4069 43.8374 52.3256 43.9893 52.2423 44.1266C52.2486 44.1203 52.2528 44.1141 52.2569 44.1078V44.1037H52.259C52.2882 44.0704 52.2986 44.06 52.2736 44.1016C52.2736 44.1058 52.2694 44.1162 52.2673 44.1203C52.2757 44.1307 52.2777 44.1536 52.2798 44.1744C52.1424 44.424 52.2403 44.2056 52.2673 44.1203C52.2652 44.1162 52.2632 44.1058 52.259 44.1037H52.2569C52.134 44.4115 52.0049 44.711 51.8633 45.0043C51.9716 44.8296 52.0924 44.5987 52.2798 44.1765V44.1786Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.667 41.214C52.6943 41.214 52.6922 41.2203 52.6943 41.2266C52.7553 41.193 52.7805 41.1762 52.667 41.214Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.0212 41.1494C52.9504 41.1869 52.8838 41.2493 52.6901 41.3054C52.5193 41.3345 52.6963 41.2576 52.6942 41.2264C52.6276 41.2617 52.5151 41.3179 52.4735 41.3533C52.4297 41.3886 52.4568 41.4011 52.6338 41.3637L52.6921 41.3304C52.8546 41.2909 53.0212 41.2721 53.1212 41.2721C53.2232 41.2721 53.2628 41.2929 53.2337 41.3096C53.2316 41.2243 53.2087 41.1702 53.0191 41.1494H53.0212Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.3272 42.2021L53.1809 42.9676L53.1768 42.9967L53.1914 42.9697L53.2269 42.901L53.2687 42.8116L53.3502 42.6327L53.298 42.6431C53.4317 42.1834 53.3502 42.2708 53.3293 42.2042L53.3272 42.2021Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M50.951 45.809L50.976 45.6426C50.8656 45.8194 50.7719 46.0107 50.7031 46.2104C50.7739 46.0669 50.8593 45.9338 50.9531 45.809H50.951Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M50.3821 47.1043L50.3027 47.0439C50.3048 47.1708 50.3174 47.2998 50.3404 47.4329C50.3445 47.3164 50.3592 47.2083 50.3801 47.1043H50.3821Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M72.4761 46.4014L72.2588 46.5241C72.3633 46.47 72.4302 46.4326 72.4761 46.4014Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M74.1126 45.6407L74.1358 45.584C74.0685 45.6407 74.0453 45.6701 74.1126 45.6407Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M67.4206 42.333C67.2748 42.4349 67.1124 42.5327 67.002 42.5993C66.8916 42.6679 66.8354 42.7074 66.8791 42.7303C66.9208 42.7345 66.9666 42.7324 67.0103 42.7345C67.1624 42.566 67.2978 42.4349 67.4186 42.333H67.4206Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M73.7373 47.2295C73.7019 47.2378 73.6665 47.2441 73.6311 47.2524C73.5666 47.321 73.5083 47.3855 73.4541 47.4417C73.5395 47.3772 73.6374 47.3044 73.7373 47.2295Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M73.7939 46.7715L74.2417 46.6113C74.1376 46.6404 73.996 46.6883 73.7939 46.7715Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M68.458 43.9808C68.4893 43.8955 68.5186 43.8123 68.5332 43.7354C68.4287 43.8726 68.3932 43.9288 68.4016 43.9475C68.4078 43.9662 68.4496 43.9538 68.458 43.9808Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M59.873 43.9994C60.1605 43.8788 60.3833 43.7748 60.5749 43.6729C60.2229 43.806 59.9209 43.8829 59.873 43.9994Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M72.7116 45.2139C72.582 45.2929 72.5297 45.3366 72.5444 45.3532C72.6781 45.2721 72.7513 45.2201 72.7116 45.2139Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M61.3623 43.248C61.3103 43.2668 61.2603 43.2855 61.2082 43.3063C61.0166 43.4269 60.8208 43.5455 60.5771 43.6724C60.8375 43.5746 61.1249 43.4457 61.3644 43.248H61.3623Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M55.1854 38.6577C55.1623 38.6556 55.135 38.6556 55.116 38.6514C55.1097 38.664 55.1413 38.6619 55.1854 38.6577Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M45.4922 41.8502C45.5776 41.7941 45.7213 41.7109 45.8587 41.6318C45.7879 41.6651 45.6775 41.7296 45.4922 41.8502Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M54.4299 47.8242C54.2701 47.9859 54.411 47.8557 54.4299 47.8242V47.8242Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.375 48.3799C53.4189 48.3341 53.4377 48.2863 53.4272 48.2676C53.4272 48.3009 53.4126 48.3425 53.375 48.3799Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M63.1416 41.6636C63.1416 41.6636 63.152 41.6574 63.1604 41.6553C63.0893 41.6699 63.1018 41.6678 63.1416 41.6636Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M54.1582 48.0327C54.2272 47.9807 54.3003 47.9183 54.3818 47.8496C54.3421 47.8766 54.2752 47.9328 54.1582 48.0327Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M54.2229 48.0322C54.1664 48.0842 54.1205 48.1258 54.0787 48.1653C54.0703 48.1965 54.0933 48.1841 54.2229 48.0322Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M54.6536 47.6064C54.5598 47.6938 54.4703 47.7749 54.3828 47.8498C54.4182 47.8228 54.437 47.8145 54.4286 47.8249C54.4765 47.7791 54.539 47.7104 54.6536 47.6064Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M65.3055 38.4805C65.2909 38.4846 65.2742 38.4909 65.2575 38.495C65.0694 38.6365 65.1572 38.5845 65.3055 38.4805Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M64.4509 47.4478C64.4509 47.4478 64.4509 47.4332 64.4509 47.4248C64.4467 47.4332 64.4446 47.4436 64.4404 47.452L64.4488 47.4478H64.4509Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M64.4615 48.151C64.3324 47.8453 64.3699 47.6643 64.4428 47.4521C64.3386 47.5062 64.2366 47.5707 64.1387 47.6456C64.2282 47.8349 64.3386 47.993 64.4636 48.151H64.4615Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M68.3662 47.9741C68.587 47.9513 68.7807 47.9284 68.989 47.8972C68.8203 47.9804 68.6578 48.0469 68.5183 48.0969C68.4808 48.1094 68.4474 48.1218 68.4141 48.1343C68.3579 48.151 68.3058 48.1655 68.2558 48.1801C68.1559 48.2071 68.0705 48.23 68.0038 48.2466C67.8684 48.2799 67.8018 48.2986 67.8351 48.309C67.8684 48.3174 67.9955 48.3215 68.2683 48.2924C68.2767 48.2716 68.2996 48.2508 68.3371 48.2279C68.3558 48.2175 68.3766 48.205 68.4016 48.1926C68.4308 48.1801 68.4495 48.1697 68.462 48.1614C68.5266 48.1239 68.6203 48.0865 68.7286 48.047C68.9473 47.9679 69.2347 47.8826 69.518 47.7849C69.8054 47.6913 70.0741 47.5748 70.2761 47.4708C70.4781 47.3668 70.6093 47.2732 70.601 47.1983L70.9904 47.1068C70.8842 47.1463 70.8738 47.1692 70.7676 47.2087C71.5382 47.0444 71.2216 46.8093 72.1214 46.4516C72.44 46.3351 72.6712 46.2768 72.4754 46.4016L73.1315 46.0168C73.3335 45.9295 73.3044 45.996 73.1044 46.0855L74.1395 45.5738L74.1354 45.5842C74.2645 45.4739 74.5727 45.2514 74.7248 45.1474C75.008 45.06 74.6061 45.2368 74.6894 45.2368L75.2371 44.904C75.5058 44.8603 75.058 45.1495 74.654 45.3283C74.9872 45.3304 75.0997 45.2576 75.2829 45.1349C75.3746 45.0725 75.485 44.9997 75.6495 44.9165C75.814 44.8333 76.0306 44.6981 76.3451 44.5629L75.814 44.9248C76.2389 44.8624 76.6867 44.515 77.2657 44.2987C77.1866 44.3154 76.8783 44.4214 76.6471 44.4797C76.3972 44.5546 76.2493 44.5629 76.5409 44.3445C76.72 44.2634 76.9325 44.151 77.2157 43.9181C77.2719 44.0075 77.5469 43.7974 77.9509 43.5936L77.9863 43.7288C78.3987 43.4729 78.3321 43.4293 78.5591 43.2441C78.7903 43.1339 78.9298 43.1193 79.0152 43.1318C79.0652 43.1568 79.0818 43.2046 79.0922 43.2483C79.1568 43.2566 79.1589 43.2171 79.1318 43.1651C79.1193 43.1401 79.1006 43.1152 79.1089 43.0944C79.1152 43.0756 79.1568 43.0445 79.263 43.0611C79.3276 43.0944 79.3672 43.1505 79.3859 43.2109C79.4047 43.2691 79.4109 43.3273 79.4151 43.3918C79.4192 43.4438 79.4067 43.5541 79.3651 43.6539C79.3255 43.7537 79.2464 43.8702 79.1276 43.9742C78.684 44.1635 79.1651 43.8619 78.9923 43.9118L78.6611 44.2093C78.5653 44.2571 78.5799 44.2114 78.5861 44.1906C78.28 44.4006 78.6278 44.3216 78.1259 44.6294C78.0634 44.8458 76.9387 44.981 76.343 45.4552C76.1619 45.501 76.3868 45.3429 76.3139 45.32C76.1952 45.3949 76.0931 45.4573 76.0036 45.5135C75.9244 45.5717 75.8578 45.6216 75.7995 45.6674C75.687 45.7527 75.6037 45.8151 75.5266 45.8733C75.3725 45.9919 75.2392 46.1021 74.9122 46.3663C74.6915 46.4516 74.4707 46.5348 74.2478 46.6138C74.756 46.4703 74.2228 46.8738 73.7417 47.2316C73.9292 47.19 74.0895 47.1567 74.1937 47.1276L73.396 47.6185C73.2856 47.6497 73.3481 47.5665 73.4585 47.4458C73.4085 47.4853 73.3585 47.5228 73.321 47.5519C73.0003 47.6601 73.119 47.5103 73.2981 47.3335C73.4127 47.3065 73.5251 47.2794 73.6355 47.2545C73.8042 47.0756 73.9562 46.8946 73.8771 46.8468C73.8292 46.8884 73.7313 46.9549 73.6189 47.0194C73.6626 46.9716 73.6876 46.9362 73.6563 46.9362C73.6209 46.9362 73.548 47.009 73.4272 47.1109L73.169 47.0735L73.1502 47.1505L72.0131 47.6268C71.659 47.8909 71.3383 48.1426 70.9488 48.4234C70.5593 48.6959 70.1157 49.0163 69.4846 49.3033C69.7596 49.0703 69.4846 49.1078 69.4513 48.9788C69.8512 48.9726 70.3885 48.4858 71.0425 48.203C70.7009 48.3506 70.7468 48.2591 70.8217 48.1988C70.4594 48.4151 70.097 48.6502 69.7325 48.8561C69.7158 48.7458 69.4576 48.8894 69.1389 48.9663C69.2909 49.0183 69.0889 49.1411 68.7848 49.2659C68.4808 49.3927 68.0746 49.5134 67.8351 49.6111C67.7851 49.5467 67.8872 49.4572 68.4829 49.2867C68.133 49.3158 67.9413 49.4343 67.7456 49.5529C67.5498 49.6694 67.3478 49.7942 67.0104 49.7859C67.1562 49.7588 67.2374 49.7526 67.2874 49.7047C67.1249 49.7734 66.8271 49.8295 66.598 49.8358C66.3689 49.8441 66.2085 49.815 66.3064 49.7817C66.3543 49.7796 66.4022 49.7775 66.4501 49.7734C66.2106 49.7838 65.9086 49.7796 65.5983 49.7339C65.4442 49.711 65.288 49.6777 65.1359 49.6319C65.0026 49.5924 64.8839 49.5363 64.7839 49.4614C64.5819 49.3158 64.4507 49.087 64.3611 48.8998C64.2737 48.7105 64.2174 48.5649 64.1675 48.5358C64.1883 48.5254 64.4028 48.6252 64.4486 48.6647C64.1487 48.1822 63.9196 47.5623 63.9988 46.8717C64.0362 46.9799 64.2049 46.9196 64.3257 46.9487C64.4549 46.9778 64.5069 47.0735 64.4528 47.4229C64.4882 47.3273 64.534 47.2233 64.5944 47.0943C64.6256 47.0298 64.6611 46.9612 64.6985 46.8821C64.7444 46.7927 64.7944 46.6928 64.8506 46.5826C64.7464 46.7032 64.4486 46.8093 64.5507 46.6117C64.786 46.3954 64.8672 46.3247 64.9526 46.2332C65.0401 46.1437 65.1338 46.0356 65.4233 45.7901C65.2484 45.9586 65.2192 45.5967 65.4837 45.2992C65.4712 45.3699 65.6858 45.4303 65.6149 45.5551C65.7607 45.2597 65.919 44.9664 66.0877 44.6773C65.9503 44.8832 66.2044 44.8458 66.4022 44.7418C66.3522 44.7584 66.4939 44.619 66.6834 44.4339C66.8708 44.2509 67.0916 44.0366 67.177 43.9326L66.8396 44.1947C67.0437 44.0013 67.1791 43.839 67.2811 43.6955C67.3311 43.6227 67.3728 43.5561 67.4103 43.4896L67.4373 43.4397C67.4457 43.4251 67.4436 43.4189 67.4519 43.4043L67.5081 43.3086C67.656 43.0486 67.7768 42.7907 68.1496 42.3788C68.0975 42.512 68.1559 42.8323 68.5537 42.4204C68.5932 42.2811 68.6682 41.967 68.7994 41.5884C68.864 41.3971 68.939 41.1911 69.0244 40.979C69.066 40.8729 69.1097 40.7647 69.1556 40.6586L69.1889 40.5817L69.2097 40.5255L69.2514 40.4174C69.2951 40.3903 69.3409 40.357 69.3909 40.3196C69.4492 40.1615 69.4867 40.0201 69.5034 39.8953C69.5492 39.9265 69.5888 39.9972 69.5971 40.1303C69.6054 40.2614 69.5784 40.4569 69.4992 40.7044C69.3534 41.1911 69.1243 41.6841 68.9473 42.0065C69.2576 41.7153 69.091 41.9774 69.4867 41.4574C69.6804 41.3097 69.3493 41.8068 69.2243 41.9524C69.3909 41.7631 69.5575 41.5635 69.7137 41.3575C69.7533 41.3055 69.7929 41.2535 69.8304 41.2015L69.8887 41.1225L69.9595 41.0206C70.022 40.929 70.0761 40.8417 70.1324 40.7502C70.1907 40.6586 70.2428 40.5671 70.2927 40.4756C70.1949 40.511 70.376 40.0991 70.4635 39.7413C70.551 39.3857 70.6176 39.0549 70.5323 39.136C70.4614 39.446 70.3948 39.7497 70.2698 40.0949C70.2053 40.2676 70.1282 40.4465 70.0366 40.6295C69.9887 40.721 69.9449 40.8126 69.8929 40.9062L69.7679 41.1267C69.7283 41.1183 69.7221 41.058 69.745 40.9394C69.7887 40.8063 69.8512 40.615 69.9262 40.3841C69.9949 40.1719 70.0636 39.9452 70.1303 39.7122C70.1636 39.5937 70.199 39.4709 70.2365 39.3441C70.2552 39.2775 70.274 39.213 70.2907 39.1444L70.3198 39.0404C70.3052 39.0279 70.274 39.0279 70.2532 39.0216H70.2448C70.1324 39.0092 70.2823 38.9197 70.4927 38.824C70.5239 38.8157 70.5552 38.8095 70.5822 38.8053C70.5947 38.8053 70.6093 38.8012 70.6218 38.8012C70.6301 38.8032 70.6322 38.8116 70.6385 38.8157C70.6593 38.8344 70.676 38.8469 70.6926 38.8282C70.6926 38.8136 70.6926 38.7887 70.6968 38.7575C70.6968 38.7263 70.6718 38.718 70.6572 38.6909C70.1844 38.7928 69.443 38.9364 69.3472 38.928C69.5659 38.8636 69.7929 38.8012 70.0324 38.7388C69.6325 38.772 69.2389 38.8885 68.8807 39.0008C68.7911 39.03 68.7015 39.0591 68.6078 39.0882C68.5266 39.1111 68.4454 39.1361 68.3579 39.161C68.2204 39.1985 68.0663 39.2297 67.8872 39.2442C67.6498 39.3004 67.1332 39.2858 67.1187 39.3794C67.5519 39.4065 67.7664 39.8703 67.5623 40.0617C67.5206 40.07 67.2166 40.1262 66.8875 40.1969C66.5584 40.2676 66.2064 40.3487 66.0648 40.3654C65.6483 40.3986 66.4959 39.8578 66.144 39.8849C66.144 39.9265 65.9586 40.0533 65.8815 40.1053C65.6358 40.174 65.9294 39.9535 65.4337 40.1865C65.4067 40.3529 64.4132 40.6295 65.2463 40.4028C64.7756 40.6586 64.7152 40.6066 64.1487 40.8812C64.3695 40.8812 63.7759 41.4075 63.3219 41.6862C63.3323 41.6383 63.2052 41.6508 63.1427 41.6571C62.6533 41.8963 62.2763 42.0814 61.9077 42.2624C61.537 42.4329 61.1725 42.6056 60.7247 42.8468C60.6247 42.8593 60.1728 43.059 60.3269 42.903C60.2103 42.9945 60.1166 43.1027 59.8416 43.2587C59.2481 43.4438 60.4456 42.903 59.9666 42.9966C59.9708 43.0881 59.3105 43.4917 58.9481 43.76C59.1314 43.8037 59.8604 43.2733 60.229 43.0132C60.3165 43.1693 59.7229 43.7038 58.8461 44.305C58.14 44.7646 58.4712 44.3882 58.3587 44.4838C57.6673 44.8707 57.4173 45.112 57.1987 45.3263C56.98 45.5426 56.7863 45.7256 56.2219 46.048C55.7387 46.2602 56.0698 45.8775 55.9282 45.8795C56.4593 45.4407 56.8363 45.3408 57.2257 45.0912C57.0549 45.1765 56.8842 45.2618 56.7155 45.3533C56.8758 45.1994 57.2507 44.9331 57.484 44.8333C57.2716 44.9019 56.6905 45.241 56.0615 45.6861C55.4304 46.1271 54.7577 46.6762 54.2766 47.061C54.1391 47.2357 53.8996 47.5269 54.0579 47.4354C54.1475 47.3418 54.237 47.2503 54.3287 47.1588C54.6473 46.984 53.8871 47.7474 54.2724 47.4437C54.1079 47.6434 53.9434 47.8639 53.758 48.0969C53.7122 48.1551 53.6643 48.2134 53.6143 48.2737L53.5372 48.3652C53.4997 48.411 53.4581 48.4484 53.4144 48.4838C53.2644 48.6065 53.0832 48.7126 52.8666 48.777C52.7999 48.7542 52.7354 48.7292 52.675 48.7001C52.6875 48.7167 52.827 48.7022 52.9811 48.6418C53.1373 48.5815 53.2915 48.4754 53.3727 48.3818C53.2561 48.517 52.9603 48.6626 52.6375 48.7022C52.3168 48.7458 52.0148 48.6897 51.8107 48.7146C51.9898 48.7978 52.1897 48.8498 52.3959 48.8665C52.0877 48.9226 51.7044 48.906 51.3441 48.75C51.1588 48.671 50.9755 48.5441 50.8297 48.3798C50.7568 48.2986 50.6922 48.2092 50.6402 48.1156C50.586 48.022 50.536 47.8993 50.511 47.789C50.511 48.0116 50.5589 48.0782 50.5943 48.1426C50.6402 48.2092 50.6693 48.309 50.8526 48.6044C50.7839 48.465 50.8526 48.5129 50.9942 48.6252C51.1359 48.7375 51.3774 48.8852 51.6107 48.9642C51.8502 49.0537 52.1043 49.0787 52.2334 49.0682C52.3626 49.0558 52.3667 49.035 52.1647 48.9788C52.3147 49.0308 52.4584 49.0495 52.6063 49.0433C52.7562 49.0371 52.902 49.0017 53.0457 48.9497C53.1894 48.8977 53.3269 48.827 53.4706 48.7438C53.506 48.7209 53.5435 48.698 53.581 48.6751C53.6289 48.6439 53.6768 48.6127 53.7205 48.569C53.7497 48.542 53.7559 48.5399 53.7726 48.5274L53.8163 48.4962C53.8455 48.4754 53.8767 48.4546 53.908 48.4338C53.8663 48.4193 53.6997 48.5295 54.0808 48.1655C54.0892 48.1406 54.1162 48.0885 54.135 48.0573C54.1475 48.0469 54.1516 48.0428 54.162 48.0345C54.1537 48.0407 54.1475 48.0449 54.1371 48.0511C54.1496 48.0303 54.1496 48.0282 54.1287 48.0573C54.0267 48.1322 53.9413 48.1926 53.8934 48.205C53.9996 47.9429 54.6119 47.3564 54.7994 47.1338C55.0493 46.9383 54.7327 47.2586 54.8931 47.1775L55.168 46.8405C55.2617 46.8842 55.9157 46.4349 55.3784 46.9445C55.5491 46.8052 55.7241 46.6679 55.9011 46.5348C56.2427 46.3372 56.6926 46.048 56.9487 45.8317C57.2195 45.6736 57.5611 45.3179 57.3674 45.5239C57.6506 45.3263 57.9484 45.1266 58.2463 44.929L58.2671 44.9435C59.1793 44.4214 60.0687 43.7225 61.2121 43.3045C61.5161 43.1131 61.8161 42.9259 62.3701 42.6638L62.5138 42.6784C62.8949 42.4329 63.7509 42.123 63.8863 41.9628C64.1529 41.9545 64.6506 41.7257 65.1797 41.474C65.7087 41.2223 66.271 40.9394 66.6355 40.8167L66.623 40.7065C67.1249 40.5172 67.5998 40.3154 68.2288 40.0929L68.1642 40.0117C68.2787 39.9639 68.41 39.9202 68.5537 39.8828C68.6411 39.8599 68.6578 39.8578 68.7057 39.8495C68.7474 39.8412 68.7911 39.837 68.8328 39.8329C69.0056 39.8141 69.1535 39.8183 69.3014 39.81C69.3118 39.81 69.3347 39.8017 69.3347 39.8141L69.3201 39.8599L69.291 39.9473C69.268 39.9514 69.266 39.9348 69.2743 39.9057C69.2785 39.8911 69.2847 39.8724 69.293 39.8537L69.2993 39.8391C69.2993 39.8391 69.293 39.8391 69.291 39.837C69.2847 39.837 69.2805 39.8349 69.2764 39.8329C69.2722 39.8329 69.268 39.8308 69.266 39.8287L69.2722 39.837C69.2722 39.837 69.2868 39.8433 69.2805 39.8578L69.2472 39.914L69.1931 40.0076C69.1618 40.0637 69.1389 40.1095 69.1223 40.1532C69.0868 40.2385 69.066 40.3238 69.0244 40.4319L69.0098 40.4694L68.9619 40.5567C68.9286 40.615 68.8952 40.6732 68.8598 40.7294C68.7911 40.8438 68.7182 40.954 68.6411 41.058C68.4891 41.266 68.31 41.4636 68.1225 41.6279C67.9872 41.8422 67.858 41.9711 67.7247 42.0856C67.7393 42.0689 67.7518 42.0523 67.7622 42.0356C67.7456 42.0543 67.7206 42.0835 67.6935 42.1105C67.6081 42.1812 67.5206 42.254 67.4269 42.331C67.5144 42.2707 67.5935 42.2104 67.6581 42.15C67.5373 42.2936 67.3519 42.512 67.1707 42.7262L67.0187 42.7324C67.0041 42.747 66.9937 42.7595 66.977 42.774C66.952 42.7907 66.9354 42.8011 66.8958 42.8364C66.8812 42.851 66.8667 42.8656 66.8542 42.878C66.8479 42.8864 66.8417 42.8926 66.8354 42.8988C66.8167 42.9238 66.8125 42.9425 66.8208 42.9508C66.8292 42.9612 66.85 42.9633 66.8792 42.9612C66.8937 42.9612 66.9104 42.9571 66.9271 42.9529L66.9416 42.9488C66.9416 42.9488 66.9625 42.9342 66.9645 42.9363C66.977 42.93 66.9916 42.9238 67.0041 42.9176C66.9937 42.928 66.9854 42.9384 66.977 42.9488C66.9625 42.9654 66.9562 42.9737 66.9521 42.9779L66.9208 43.0195C66.9 43.0465 66.8812 43.0736 66.8604 43.1006C66.8229 43.1526 66.7896 43.2025 66.7625 43.2483C66.4834 43.2961 66.271 43.8245 65.9273 43.9222C65.8857 44.0241 65.6295 44.2987 65.4025 44.5899C65.1734 44.8811 64.9714 45.1869 64.9922 45.3034C64.9672 45.2971 64.9027 45.3575 65.0047 45.2327C64.7777 45.4739 64.559 45.7298 64.434 46.0064L64.2466 46.0522C64.1633 46.2914 64.08 46.5202 64.0196 46.7823C63.8842 46.9757 63.8113 47.1317 63.7634 47.1713C63.7197 47.2108 63.6926 47.1338 63.7322 46.8821C63.6614 47.1796 63.6489 47.3876 63.6405 47.5477C63.6343 47.7079 63.6364 47.8181 63.6405 47.9242C63.6447 48.0303 63.6572 48.1281 63.678 48.255C63.703 48.3839 63.7363 48.5441 63.8217 48.7687L63.7301 48.7396C63.7634 48.9102 63.8509 49.1244 63.9613 49.3116C64.0696 49.5009 64.1987 49.6527 64.2508 49.7567C64.3049 49.8483 64.4049 49.9606 64.5507 50.0667C64.6923 50.1728 64.9068 50.2643 65.1005 50.3184C65.5087 50.4411 66.0232 50.4931 66.5584 50.4515C67.0958 50.4161 67.6456 50.2851 68.16 50.152C68.6807 50.0168 69.1806 49.8607 69.6242 49.7214C69.4117 49.6715 69.6221 49.6215 69.8824 49.5487C70.1449 49.478 70.451 49.3761 70.4427 49.2742C70.5635 49.2804 70.8051 49.2014 70.5614 49.374C71.3716 48.9185 71.8652 48.8519 72.363 48.4276C72.4838 48.4318 72.2276 48.5919 72.3276 48.5794C72.388 48.5358 72.5608 48.4026 72.6629 48.3902C72.7608 48.3777 72.5671 48.4942 72.4504 48.5836C73.2731 48.151 73.2752 47.9471 73.2585 47.7661C73.7167 47.6205 73.9208 47.5041 74.1749 47.2482C74.3478 47.2233 74.6206 47.1505 74.1083 47.4313C74.2499 47.3605 74.7206 47.1546 75.133 46.932C75.5474 46.7116 75.914 46.4807 75.8932 46.4141C75.9994 46.3933 76.2993 46.1853 76.3597 46.1312C76.6825 45.9794 76.8596 45.8983 77.0324 45.8171C77.2115 45.7339 77.3886 45.6466 77.7114 45.4843L77.5219 45.5509C77.6156 45.4157 77.7468 45.3429 77.9176 45.268C78.0884 45.189 78.3008 45.1058 78.557 44.9581L78.5507 44.981C79.1776 44.7147 79.3005 44.6315 79.4213 44.5546C79.4505 44.5379 79.4838 44.5109 79.5275 44.4797C79.5692 44.4464 79.615 44.4131 79.6754 44.3611C79.7358 44.3112 79.8108 44.2446 79.8962 44.1448C79.9816 44.0449 80.0795 43.9097 80.1565 43.7163C80.1149 43.735 80.0732 43.7517 80.0316 43.7662C79.9503 43.6664 80.1086 43.3669 80.0482 42.9092C80.0295 42.799 79.9899 42.6804 79.917 42.5806C79.8441 42.4808 79.74 42.3996 79.6213 42.3476C79.3838 42.2457 79.0922 42.2499 78.8569 42.3372C78.9756 42.3248 79.0922 42.3248 79.2026 42.3435C78.6632 42.4329 77.8947 42.5161 77.4885 42.67C77.3969 42.695 77.6052 42.5764 77.7135 42.5036C77.1886 42.7012 77.1699 42.747 77.1949 42.7948C77.2199 42.8468 77.2824 42.8801 76.9283 43.1089C76.7575 43.1256 77.0137 42.8468 76.5138 43.1256C76.3805 43.1713 76.0286 43.4438 75.7016 43.6997C75.6141 43.7662 75.5245 43.8328 75.435 43.9014L75.2975 43.9992C75.2455 44.0262 75.1934 44.0533 75.1413 44.0803C74.933 44.1864 74.7289 44.2738 74.5457 44.3216C74.7185 44.3008 74.8914 44.2821 74.5665 44.4797C74.05 44.7438 73.0586 44.956 72.6587 45.3367C72.5858 45.3533 72.5546 45.3533 72.5462 45.3408C72.1693 45.5759 71.257 46.0023 71.055 46.1957C70.7947 46.1125 70.1844 46.4037 69.6159 46.6824C69.0473 46.9466 68.5016 47.1338 68.4662 46.9778L68.1621 47.0589L67.9893 47.1005C67.8726 47.1255 67.7497 47.1421 67.6248 47.1463L67.6768 47.1089C67.5727 47.1026 67.4831 47.0943 67.3978 47.0797C67.3915 46.984 67.4061 46.9112 67.404 46.8509C67.404 46.7906 67.3998 46.7365 67.4019 46.6741C67.4998 46.5639 67.4831 46.6471 67.5019 46.6512C67.5623 46.5764 67.6185 46.516 67.6643 46.4599C67.6873 46.4328 67.7102 46.4079 67.731 46.3829C67.7643 46.3392 67.7976 46.2976 67.8289 46.2581C67.9518 46.098 68.0476 45.9648 68.135 45.8317C68.3287 45.5821 68.487 45.3346 68.7744 44.8811L68.9244 44.8707C68.964 44.8042 69.0743 44.6939 69.2243 44.5317C69.2618 44.4901 69.3014 44.4443 69.343 44.3965C69.3638 44.3715 69.3847 44.3445 69.4076 44.3195C69.4263 44.2966 69.4451 44.2738 69.4638 44.2488C69.5492 44.1614 69.6408 44.0678 69.7367 43.968C70.1365 43.5499 70.6072 43.0382 70.9634 42.5244C70.9634 42.5411 70.9634 42.5744 70.9092 42.6596C71.105 42.3768 71.3882 42.0793 71.6486 41.7715C71.9131 41.4657 72.1734 41.1495 72.3984 40.8438C72.5108 40.6919 72.6171 40.5401 72.7045 40.4007C72.7983 40.2572 72.8836 40.1033 72.9461 39.9618C73.0732 39.6769 73.1148 39.4189 73.0648 39.2546C73.1357 38.9176 73.1565 38.5557 73.0961 38.2188C73.1086 38.5474 73.0628 38.7034 73.0399 38.7492C73.0149 38.797 73.0003 38.7471 72.9857 38.6743C72.9565 38.5266 72.9086 38.302 72.8691 38.5516C72.8753 38.3124 72.8691 38.0066 72.8587 37.8215C72.8441 37.6405 72.8753 37.5781 72.9565 37.8797C72.9565 37.913 72.9565 37.9463 72.9565 37.9775C73.0669 38.0815 73.0607 37.6613 72.8524 37.2474C72.7524 37.0414 72.5983 36.8542 72.4796 36.7274C72.3609 36.5984 72.2734 36.5214 72.3005 36.4986C72.0193 36.2926 71.7027 36.1574 71.3882 36.0721C71.0717 35.9827 70.7405 35.9453 70.4198 35.9473C70.099 35.9473 69.7846 35.9869 69.4805 36.0493C69.4076 36.0638 69.3201 36.0826 69.2451 36.1034L69.0285 36.1678L68.6057 36.2989C67.4915 36.6566 66.4168 37.0851 65.4067 37.5927L65.7087 37.6155C65.4733 37.7279 65.2401 37.8443 65.0068 37.965C64.8089 38.0295 64.7048 37.9879 65.2046 37.732C64.9006 37.7903 64.4111 38.2416 64.4153 38.2812C63.4323 38.77 64.6985 37.9109 64.4049 38.0752L64.0112 38.3124L64.1091 38.277C63.8196 38.5204 63.828 38.5911 63.2511 38.9176C62.872 39.1007 63.0178 38.9426 62.872 39.0196C62.8678 39.0092 62.8158 39.032 62.6512 39.1423L61.8036 39.6165L62.2014 39.5292C61.8577 39.7975 61.4058 39.9826 61.864 39.8765C61.5266 39.9493 60.731 40.3862 59.9728 40.823C59.5938 41.0434 59.2231 41.2598 58.9252 41.4345C58.6232 41.603 58.3816 41.7028 58.2858 41.7361C58.0359 41.9087 57.7777 42.0606 57.4965 42.2083C57.3569 42.2832 57.2112 42.356 57.0591 42.4308C56.9342 42.4912 56.8029 42.5536 56.6655 42.6201C56.7717 42.5972 56.9196 42.67 56.4301 42.9072C56.4843 42.8052 56.4635 42.7678 56.4197 42.7616C56.3739 42.7553 56.301 42.7782 56.2177 42.8136C56.0573 42.8822 55.8303 43.0132 55.8449 42.9321C55.8449 42.9176 55.8449 42.9113 55.874 42.8697C55.8491 42.9113 55.8386 42.9238 55.8095 42.9571C55.797 42.9696 55.7782 42.9883 55.7637 42.9987C55.7595 42.9987 55.7595 42.9904 55.7595 42.98C55.7616 42.9404 55.7949 42.8385 55.8261 42.7408C55.8574 42.643 55.8845 42.5473 55.8803 42.5078C55.874 42.4704 55.8386 42.4808 55.7178 42.6513C55.8074 42.46 55.8428 42.4392 55.8865 42.4184C55.9282 42.3996 55.9782 42.3768 56.0615 42.2582C56.074 42.1896 56.0948 42.1105 56.124 42.0252C56.1552 41.9316 56.174 41.8838 56.2427 41.6987C56.3593 41.4012 56.5259 41.1038 56.7175 40.8105C56.7675 40.7377 56.8175 40.6649 56.8675 40.59C56.9196 40.5172 56.9883 40.4111 57.0404 40.3134C57.1487 40.1116 57.232 39.8807 57.2653 39.6332C57.2986 39.3857 57.2757 39.1277 57.2091 38.8906C57.1716 38.7762 57.1383 38.6535 57.0612 38.5287C56.9925 38.4039 56.9112 38.302 56.8154 38.2042C56.7904 38.2042 56.83 38.2812 56.8279 38.3186C56.8238 38.3581 56.7925 38.3456 56.6176 38.2229C56.3968 37.9421 56.0573 37.7611 55.7345 37.6592C55.545 37.6447 55.4596 37.7008 55.343 37.7341C55.2263 37.7736 55.0805 37.7882 54.7681 37.7674C54.8598 37.7882 54.991 37.8173 54.7723 37.8589C54.362 37.8984 53.9767 37.9879 53.5935 38.0856C53.2102 38.1855 52.8312 38.3061 52.4563 38.4413C51.7065 38.7117 50.9796 39.0404 50.2632 39.3919C48.8428 40.097 47.4411 40.8313 45.9894 41.4532C46.3956 41.3076 46.1519 41.4532 45.8707 41.6155C46.0623 41.526 45.9124 41.6987 45.9728 41.7215L44.769 42.2478C44.6315 42.487 43.5568 42.9529 43.5068 43.136L43.8547 42.9092C43.4569 43.319 44.6982 42.8323 44.7294 43.0465C45.1751 42.5868 46.2664 42.4662 47.0204 41.7569C47.2349 41.6862 46.8871 41.9046 47.0121 41.89C47.1933 41.6903 47.4536 41.526 47.9764 41.291L47.9305 41.3409C48.6324 40.954 49.151 40.7086 49.6967 40.4631C50.2444 40.2198 50.8109 39.9701 51.6378 39.6477L51.4774 39.6082C51.8336 39.4689 51.921 39.4709 52.096 39.4273C52.2709 39.2775 52.021 39.3711 51.7669 39.473C51.5128 39.5749 51.2546 39.6831 51.4045 39.525C51.6794 39.5167 52.3001 39.2546 52.9187 39.0466C53.5351 38.8344 54.1475 38.6826 54.337 38.7575C54.8868 38.6327 54.1516 38.6743 54.7015 38.5599L54.8556 38.5973L54.9806 38.4996C55.343 38.4684 55.4992 38.5765 55.5054 38.6244C55.4304 38.6119 55.2846 38.6327 55.1992 38.6431C55.4179 38.6639 55.7012 38.6764 55.8803 38.7388C56.0636 38.7949 56.1615 38.8948 56.1823 38.9468C56.1323 38.8532 56.0636 38.7762 55.9636 38.7117C56.0802 38.7616 56.1719 38.8324 56.2469 38.9405C56.3093 39.0216 56.3635 39.2026 56.3781 39.3441C56.3926 39.4938 56.3697 39.6436 56.3156 39.7975C56.2864 39.8745 56.2489 39.9514 56.2031 40.0263L56.0282 40.3071C55.7824 40.7106 55.5679 41.1391 55.4179 41.5988C55.1826 42.2187 54.9681 42.8052 54.8035 43.3045L54.9368 43.0985C54.7765 43.5749 54.6702 43.8577 54.564 44.1094C54.5057 44.2405 54.4557 44.3549 54.4057 44.4693C54.3787 44.5296 54.3516 44.5899 54.3224 44.6523L54.312 44.6752C54.312 44.6752 54.312 44.6814 54.312 44.6856V44.7043C54.3162 44.7168 54.3183 44.7293 54.3203 44.7418C54.5474 44.6107 54.9035 44.3923 55.5366 43.9805L55.4617 44.0408C55.8678 43.7309 56.2927 43.448 56.728 43.2275C56.528 43.3669 56.7155 43.2941 56.9112 43.2254C57.1008 43.1609 57.2945 43.0965 57.0112 43.2712C57.0654 43.24 57.1154 43.2129 57.1653 43.1838C57.1987 43.1651 57.2299 43.1464 57.2591 43.1297C57.3174 43.0944 57.3694 43.0652 57.4173 43.0361C57.5111 42.98 57.584 42.9342 57.6423 42.8988C57.7589 42.826 57.8131 42.7865 57.8547 42.7491C57.938 42.6763 57.9651 42.6201 58.3129 42.3497L58.5274 42.331C58.6441 42.2353 58.7024 42.175 58.8065 42.1001C58.9107 42.0273 59.0585 41.942 59.3376 41.7631C58.9002 42.0939 59.7604 41.6571 59.2751 42.0398C60.5602 41.4948 60.9788 40.8542 61.6515 40.7564C62.0972 40.2468 60.5518 41.2535 60.8393 41.033C60.5456 41.1204 61.2162 40.6274 61.6036 40.4278C61.9889 40.2094 62.393 40.2926 63.3594 39.7289C63.2635 39.7829 63.2635 39.8017 63.1677 39.8557C63.5572 39.6935 63.8405 39.3794 64.3278 39.2026C64.5049 38.9447 64.8985 38.8844 64.8881 38.6992C64.5986 38.874 64.3195 39.0549 64.0279 39.238C64.5028 38.9114 64.8693 38.4621 65.7628 38.1168C65.7128 38.1813 65.4816 38.3477 65.3234 38.46C65.5899 38.3748 65.7795 38.1855 66.0586 38.1044C66.0586 38.2853 64.9797 38.6888 64.5173 39.1153C64.8048 39.0258 65.4692 38.4496 65.2859 38.7554C65.567 38.3415 66.2523 38.2832 66.8521 37.8173V37.9296C66.95 37.8672 67.152 37.7237 67.3519 37.6426L67.0458 37.9171C67.5498 37.5739 68.1434 37.5594 68.6578 37.3098C67.5373 37.732 68.3641 37.289 67.8622 37.4034C68.5308 37.0706 68.7599 37.0664 69.0077 37.0622C69.1327 37.0602 69.2618 37.0622 69.4472 37.031C69.5492 37.0102 69.6263 37.0061 69.7616 36.9811C69.8908 36.9603 70.0407 36.9354 70.2219 36.9125C70.0345 36.9333 69.4638 36.9832 69.77 36.8709C70.0616 36.8293 70.4364 36.8418 70.5947 36.9062C70.8238 36.9083 70.9259 36.925 70.9634 36.9166C71.0009 36.9104 70.9696 36.8917 70.9217 36.8688C70.828 36.823 70.6551 36.771 70.8613 36.7606C71.0134 36.8418 71.1217 36.8542 71.255 36.8605C71.3862 36.8667 71.5382 36.8605 71.7298 36.9458L71.6819 37.0352C71.8923 37.1746 71.9839 37.2723 72.0526 37.3202C72.1193 37.368 72.1547 37.3763 72.1922 37.3826C72.2276 37.3888 72.2651 37.393 72.3151 37.4512C72.365 37.5095 72.4379 37.6218 72.4817 37.8631C72.4005 37.7424 72.3088 37.6384 72.2088 37.5594C72.2922 37.68 72.3546 37.8235 72.3984 37.9795C72.3546 37.9546 72.3088 37.9317 72.263 37.913C72.363 38.1356 72.388 38.3394 72.3817 38.4954C72.3734 38.6618 72.3338 38.8303 72.2338 39.0799C72.288 39.032 72.3276 39.0612 72.3317 39.1652C72.3317 39.2692 72.2963 39.4501 72.1714 39.6831C72.0568 39.8245 72.061 39.7684 72.0485 39.7601C72.036 39.7538 72.0151 39.7809 71.811 40.1241C71.8298 40.0346 71.8506 39.9306 71.8944 39.8287C71.9402 39.7268 72.0006 39.6249 72.1151 39.5063C72.1005 39.4626 72.1255 39.3357 72.1068 39.2941C72.0027 39.446 71.8964 39.6332 71.7756 39.8349C71.6528 40.045 71.5465 40.2322 71.4695 40.3508C71.532 40.2634 71.6069 40.1594 71.6548 40.1116C71.4945 40.4506 71.3195 40.7855 71.1279 41.11C70.9884 41.2265 71.0508 41.0975 71.1112 40.9686C70.9821 41.1558 70.9238 41.3076 70.7134 41.5676C70.7051 41.447 70.6322 41.4116 70.8905 41.0226C70.7947 41.1703 70.6968 41.3159 70.5927 41.4595L70.274 41.8963C70.199 41.9295 69.8262 42.2686 69.897 42.1376C69.6763 42.358 69.4576 42.6763 69.2243 43.0112C69.1077 43.1797 68.9848 43.3502 68.8557 43.5166L68.7515 43.6477C68.7307 43.6685 68.6932 43.7309 68.687 43.7413L68.6516 43.7912C68.6037 43.8557 68.5433 43.9243 68.4766 43.9888C68.4641 44.0283 68.4266 44.097 68.3225 44.2238C68.0496 44.5088 67.7914 44.7771 67.5206 45.06C67.3811 45.1994 67.2665 45.3679 67.1437 45.5426C67.0833 45.6299 67.0229 45.7215 66.9645 45.8151C66.8667 45.9648 66.7646 46.1188 66.673 46.2748C66.4668 46.4932 66.2731 46.7407 66.1252 47.0028C66.0502 47.2565 66.069 47.3044 66.0919 47.2794C66.119 47.2545 66.171 47.1484 66.2293 47.0652C66.2856 46.982 66.3397 46.9216 66.3418 46.9757C66.3439 47.0319 66.3085 47.1879 66.2377 47.5415C66.2169 47.6601 66.1898 47.7703 66.1856 47.8493C66.8125 47.9887 66.1752 47.9908 66.4897 48.0969C66.6501 48.1094 66.8292 48.126 67.0437 48.1177C67.2582 48.1094 67.4998 48.0844 67.7581 48.0324C67.8872 48.0074 68.0184 47.9783 68.1538 47.945C68.2683 47.9159 68.385 47.8889 68.5058 47.8597C68.6911 47.8161 68.8827 47.7786 69.0848 47.7495C68.8348 47.8514 68.6391 47.8805 68.3829 47.9533L68.3662 47.9741ZM76.5201 44.3528C76.3805 44.463 76.1035 44.7064 75.9619 44.723C76.0806 44.515 76.2389 44.4838 76.5201 44.3528ZM72.4983 47.6434C72.5962 47.5561 72.7774 47.4812 72.9919 47.4146C72.8524 47.4957 72.69 47.5748 72.4983 47.6434ZM56.2739 46.1791C56.2739 46.1791 56.2823 46.1708 56.2843 46.1645C56.6092 45.9835 56.4926 46.0459 56.2739 46.1791ZM55.6345 46.6055C55.5825 46.6637 55.597 46.672 55.6304 46.6637C55.6554 46.6096 55.7907 46.5015 55.9511 46.3892C55.8928 46.4016 55.8012 46.4453 55.6345 46.6055ZM62.8095 39.1069L62.9553 39.0528C62.6721 39.2505 62.7429 39.1797 62.8095 39.1069Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M73.7832 46.8261C73.8337 46.8198 73.8547 46.8303 73.8736 46.8429C73.9262 46.7967 73.9178 46.7778 73.7832 46.8261Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M68.4415 44.0286L68.4583 44.0118C68.4625 43.9972 68.4625 43.9888 68.4583 43.9805L68.4395 44.0286H68.4415Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M65.8281 39.9662C65.9864 39.9142 66.078 39.8976 66.1426 39.8934C66.1426 39.8664 66.0635 39.8747 65.8281 39.9662Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M51.9503 49.172C52.1919 49.2011 52.4231 49.1866 52.6585 49.1346C52.319 49.1928 52.1961 49.1512 52.0274 49.1221C52.0399 49.147 52.1732 49.199 51.9482 49.172H51.9503Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.2692 45.3059C52.2943 45.2352 52.3424 45.1686 52.3654 45.0979L52.3131 45.0938C52.1689 45.3704 52.0895 45.5763 52.2672 45.3059H52.2692Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M51.4778 48.669C51.4757 48.6191 51.3882 48.5629 51.2674 48.4735C51.1466 48.384 50.9946 48.2509 50.878 48.0762C50.8925 48.097 50.905 48.1178 50.9196 48.1386C50.8363 48.1199 50.8592 48.2031 50.9654 48.3258C51.0696 48.4485 51.2695 48.5899 51.482 48.669H51.4778Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M50.8268 47.9946C50.7578 47.8802 50.7076 47.7429 50.6888 47.616C50.6345 47.5723 50.6951 47.7887 50.8268 47.9946Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M54.9249 47.2708C54.7895 47.3623 54.9228 47.4205 54.8312 47.4559C54.7645 47.6556 55.558 46.6447 54.9249 47.2708Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M51.3633 48.2637C51.3737 48.3178 51.3883 48.3718 51.4091 48.4259C51.4841 48.4405 51.5591 48.4488 51.632 48.4509C51.5361 48.3989 51.4445 48.3365 51.3654 48.2637H51.3633Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.8185 47.7266C53.6811 47.8534 53.5415 47.9803 53.4082 48.1114C53.4249 48.1197 53.3916 48.1717 53.3291 48.2507C53.5728 47.9886 53.8477 47.7411 53.8185 47.7266Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M53.3292 48.251C53.1771 48.3779 53.0272 48.4673 52.9355 48.5297C53.0334 48.486 53.2167 48.3675 53.3292 48.251Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M52.0693 48.5293C52.1214 48.5439 52.1756 48.5563 52.2318 48.5647C52.363 48.5709 52.4963 48.5605 52.6254 48.5314C52.4401 48.5667 52.2505 48.5647 52.0693 48.5293Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M58.6959 44.201L59.2145 43.8682C59.252 43.8058 59.0937 43.8682 58.9021 43.9951C58.7876 44.0908 58.596 44.2156 58.6959 44.1989V44.201Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M56.9453 44.9017C57.0994 44.831 57.1223 44.8476 57.2202 44.8268L57.1682 44.7041L56.9453 44.9017Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M58.4773 43.9556C58.5127 43.8932 59.2021 43.4189 58.5273 43.8162C58.4898 43.8786 57.9712 44.2156 58.4773 43.9556Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M66.8572 39.9473L66.7109 40.0034L66.8071 40.1969L66.8572 39.9473Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M67.8225 43.5037C68.1225 43.2437 68.1183 43.1876 68.1225 43.1397C68.1225 43.0919 68.1225 43.0524 68.3703 42.8236C68.4515 42.6592 67.96 43.198 68.0475 43.0336C67.7809 43.4018 67.558 43.5557 67.8205 43.5037H67.8225Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M68.0479 43.0341C68.0917 42.9759 68.1356 42.9114 68.1795 42.8428C68.1022 42.9489 68.0667 43.0009 68.0479 43.0341Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M43.9408 42.6035L43.5117 42.799L43.8116 42.7096L43.9408 42.6035Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M43.2384 43.1905L43.0739 43.126L42.8906 43.3735C42.9802 43.3153 43.153 43.2029 43.2384 43.1905Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M77.7408 43.9579L77.7575 43.9121C77.6742 43.9121 77.5846 43.9641 77.4014 44.064C77.5159 44.0286 77.6242 43.9891 77.7408 43.9558V43.9579Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M71.9905 46.7632L72.0929 46.7216L71.8525 46.6904L71.9905 46.7632Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M65.7696 48.0491C65.7633 48.0762 65.7592 48.1053 65.7529 48.1344C66.0945 48.2134 66.4319 48.2779 66.7339 48.3383C66.257 48.2571 65.9966 48.1198 65.8342 48.0824C65.8487 47.9992 65.8383 47.9784 65.7696 48.047V48.0491Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M78.66 42.7861C79.995 42.0768 81.305 41.3925 82.5901 40.7373C83.873 40.08 85.1851 39.4747 86.5264 38.9214C87.9697 38.366 89.4026 37.9396 90.8272 37.6422C92.2518 37.3468 93.743 37.1783 95.3051 37.1388C95.8758 37.1242 96.3235 37.2553 96.6422 37.534C96.9629 37.8127 97.0004 38.2932 96.7567 38.9734C96.4589 39.5017 95.9966 39.7721 95.3717 39.7888C94.0159 39.7201 92.6496 39.7555 91.275 39.8928C89.8983 40.0321 88.5925 40.3774 87.3574 40.9286C86.945 41.095 86.5097 41.3405 86.0495 41.665C85.5892 41.9874 85.1705 42.3493 84.7894 42.7507C84.4104 43.1501 84.1479 43.5848 84.0042 44.057C83.8605 44.5292 83.923 45.0221 84.1979 45.5338C84.6374 46.4075 85.4434 46.9046 86.618 47.0315C87.7927 47.1563 88.7924 47.1063 89.6213 46.8775C90.292 46.7049 90.8855 46.4823 91.4 46.2078C91.9123 45.9353 92.3747 45.6898 92.7871 45.4714C93.1974 45.253 93.5702 45.1012 93.9076 45.0138C94.2429 44.9265 94.597 45.0346 94.9698 45.3383C95.3467 45.85 95.3759 46.447 95.0552 47.1292C94.7323 47.8136 94.4741 48.3918 94.2804 48.864L93.2536 51.464C94.6199 49.9726 96.0674 48.5457 97.594 47.1812C99.1206 45.8167 100.756 44.5937 102.497 43.5079C102.651 43.3997 102.986 43.2479 103.242 43.0336C103.496 42.8194 103.778 42.6176 104.086 42.4263C104.394 42.237 104.569 42.0893 104.879 42.004C105.19 41.9187 105.45 41.9499 105.662 42.1018C105.81 42.2848 105.692 42.2557 105.594 42.5178C105.496 42.7819 105.127 43.0191 104.884 43.2396C104.323 43.6077 102.786 44.8495 101.63 45.825C100.485 46.7943 99.2768 47.9321 98.1063 49.0013C96.7817 50.1786 95.5259 51.4328 94.3366 52.762C93.1474 54.0911 92.0498 55.4723 91.0459 56.9013L89.1361 61.6292C88.5529 63.2038 87.9677 64.8033 87.3845 66.4299C86.8013 68.0565 86.1661 69.6582 85.4767 71.2348C85.3288 71.551 85.1435 71.9317 84.9206 72.3789C84.6978 72.8261 84.4478 73.2483 84.1729 73.6456C83.8959 74.0429 83.5669 74.3632 83.1816 74.6066C82.7983 74.85 82.3714 74.9519 81.9007 74.9124C81.2738 74.8229 80.8635 74.5483 80.6698 74.0866C80.474 73.6227 80.4115 73.1048 80.474 72.5328C80.5365 71.9587 80.6531 71.3846 80.8197 70.8084C80.9864 70.2323 81.1446 69.7601 81.2904 69.3919C82.2173 67.029 83.3961 64.7243 84.8227 62.4779C86.2494 60.2314 87.7677 58.0994 89.3839 56.0838L91.8436 48.4563C90.9147 48.7413 89.9171 48.9617 88.8549 49.1178C87.7906 49.2738 86.7909 49.3133 85.8516 49.2342C84.9123 49.1552 84.0605 48.916 83.2961 48.5187C82.5317 48.1235 81.9548 47.462 81.5654 46.5364C81.0676 45.355 81.0655 44.2629 81.5591 43.2624C81.1488 43.5328 80.726 43.8178 80.2928 44.1132C79.8575 44.4106 79.4826 44.5125 79.1681 44.4148C78.6495 44.4273 78.3309 44.2151 78.2143 43.7762C78.0997 43.3373 78.2476 43.0087 78.6579 42.7903L78.66 42.7861Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M78.66 42.7861C79.995 42.0768 81.305 41.3925 82.5901 40.7373C83.873 40.08 85.1851 39.4747 86.5264 38.9214C87.9697 38.366 89.4026 37.9396 90.8272 37.6422C92.2518 37.3468 93.743 37.1783 95.3051 37.1388C95.8758 37.1242 96.3235 37.2553 96.6422 37.534C96.9629 37.8127 97.0004 38.2932 96.7567 38.9734C96.4589 39.5017 95.9966 39.7721 95.3717 39.7888C94.0159 39.7201 92.6496 39.7555 91.275 39.8928C89.8983 40.0321 88.5925 40.3774 87.3574 40.9286C86.945 41.095 86.5097 41.3405 86.0495 41.665C85.5892 41.9874 85.1705 42.3493 84.7894 42.7507C84.4104 43.1501 84.1479 43.5848 84.0042 44.057C83.8605 44.5292 83.923 45.0221 84.1979 45.5338C84.6374 46.4075 85.4434 46.9046 86.618 47.0315C87.7927 47.1563 88.7924 47.1063 89.6213 46.8775C90.292 46.7049 90.8855 46.4823 91.4 46.2078C91.9123 45.9353 92.3747 45.6898 92.7871 45.4714C93.1974 45.253 93.5702 45.1012 93.9076 45.0138C94.2429 44.9265 94.597 45.0346 94.9698 45.3383C95.3467 45.85 95.3759 46.447 95.0552 47.1292C94.7323 47.8136 94.4741 48.3918 94.2804 48.864L93.2536 51.464C94.6199 49.9726 96.0674 48.5457 97.594 47.1812C99.1206 45.8167 100.756 44.5937 102.497 43.5079C102.651 43.3997 102.986 43.2479 103.242 43.0336C103.496 42.8194 103.778 42.6176 104.086 42.4263C104.394 42.237 104.569 42.0893 104.879 42.004C105.19 41.9187 105.45 41.9499 105.662 42.1018C105.81 42.2848 105.692 42.2557 105.594 42.5178C105.496 42.7819 105.127 43.0191 104.884 43.2396C104.323 43.6077 102.786 44.8495 101.63 45.825C100.485 46.7943 99.2768 47.9321 98.1063 49.0013C96.7817 50.1786 95.5259 51.4328 94.3366 52.762C93.1474 54.0911 92.0498 55.4723 91.0459 56.9013L89.1361 61.6292C88.5529 63.2038 87.9677 64.8033 87.3845 66.4299C86.8013 68.0565 86.1661 69.6582 85.4767 71.2348C85.3288 71.551 85.1435 71.9317 84.9206 72.3789C84.6978 72.8261 84.4478 73.2483 84.1729 73.6456C83.8959 74.0429 83.5669 74.3632 83.1816 74.6066C82.7983 74.85 82.3714 74.9519 81.9007 74.9124C81.2738 74.8229 80.8635 74.5483 80.6698 74.0866C80.474 73.6227 80.4115 73.1048 80.474 72.5328C80.5365 71.9587 80.6531 71.3846 80.8197 70.8084C80.9864 70.2323 81.1446 69.7601 81.2904 69.3919C82.2173 67.029 83.3961 64.7243 84.8227 62.4779C86.2494 60.2314 87.7677 58.0994 89.3839 56.0838L91.8436 48.4563C90.9147 48.7413 89.9171 48.9617 88.8549 49.1178C87.7906 49.2738 86.7909 49.3133 85.8516 49.2342C84.9123 49.1552 84.0605 48.916 83.2961 48.5187C82.5317 48.1235 81.9548 47.462 81.5654 46.5364C81.0676 45.355 81.0655 44.2629 81.5591 43.2624C81.1488 43.5328 80.726 43.8178 80.2928 44.1132C79.8575 44.4106 79.4826 44.5125 79.1681 44.4148C78.6495 44.4273 78.3309 44.2151 78.2143 43.7762C78.0997 43.3373 78.2476 43.0087 78.6579 42.7903L78.66 42.7861Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M78.1834 42.4802C78.3396 42.372 78.3708 42.3408 78.3771 42.3075C78.3812 42.2784 78.3542 42.2638 78.3729 42.2451C78.25 42.3179 78.173 42.3845 78.1313 42.4323C78.0897 42.4802 78.0855 42.501 78.098 42.5072C78.1188 42.5218 78.2 42.4822 78.1855 42.4781L78.1834 42.4802Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M80.5928 44.2774L80.5449 44.3522C80.647 44.2482 80.7678 44.1318 80.9073 44.0049L80.5949 44.2774H80.5928Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M81.0413 45.9791C81.0664 45.7794 80.9744 45.4341 80.9347 45.0389C80.9013 44.7352 80.8992 44.5438 80.987 44.2963L81.0476 44.1777C81.0476 44.1777 81.033 44.1777 81.0267 44.1777C81.0037 44.1777 80.9828 44.1881 80.9577 44.2048C80.9452 44.2381 80.9326 44.2713 80.9243 44.3088C80.872 44.4897 80.8574 44.6998 80.8783 44.9578C80.8825 44.9952 80.8846 45.0326 80.8867 45.0701C80.8929 45.12 80.8971 45.172 80.9034 45.2198C80.9138 45.3197 80.9326 45.4133 80.9452 45.5027C80.9807 45.6816 81.0121 45.8418 81.0392 45.9791H81.0413Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M81.7346 48.0612C81.7117 47.9884 81.8013 48.0758 81.8096 48.0841C81.8242 48.0903 81.7304 48.0342 81.4326 47.6182C81.4534 47.666 81.4597 47.6785 81.4722 47.7076C81.5263 47.7825 81.5972 47.8907 81.7325 48.0612H81.7346Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M81.4745 47.7054C81.3491 47.5182 81.3805 47.5847 81.4243 47.6679C81.4724 47.7491 81.5393 47.8406 81.4745 47.7054Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M83.0634 49.0759C82.8822 49.0031 82.6927 48.9137 82.5156 48.8076C82.5573 48.8596 82.6947 48.9636 82.801 49.0364C82.9072 49.1071 82.9822 49.155 82.8843 49.1175C83.1633 49.2507 83.2696 49.2756 83.2821 49.2611C83.2925 49.2423 83.1967 49.1779 83.0634 49.0759Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M83.5922 49.1992C83.5005 49.1701 83.4089 49.1368 83.3193 49.1035C83.3589 49.1389 83.4276 49.1763 83.5922 49.1992Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M82.7363 48.8428C82.8342 48.8948 82.9321 48.9426 83.0321 48.9863C83.1279 49.0279 83.2216 49.0653 83.3195 49.1028C83.257 49.0466 83.2716 49.0009 83.0591 48.9946C83.1258 48.9759 82.9925 48.9655 82.7363 48.8449V48.8428Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M82.443 48.6103C82.3201 48.4938 82.1889 48.3565 82.1472 48.292C82.1077 48.2255 82.1431 48.2504 82.3805 48.4231C81.9556 48.0632 81.8057 47.876 81.8057 47.9301C81.814 47.9717 81.9848 48.2608 82.443 48.6103Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M81.2479 46.1244C81.2229 45.9933 81.1999 45.8623 81.1853 45.7292C81.1435 45.621 81.1037 45.5128 81.0703 45.3984C81.0933 45.4837 81.1184 45.6751 81.1539 45.8394C81.1873 46.0037 81.2291 46.1431 81.2459 46.1244H81.2479Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M86.4185 49.9477C86.4539 49.9165 86.2394 49.8562 86.1998 49.8125C86.0665 49.8187 85.9311 49.8208 85.7979 49.8229C86.002 49.8645 86.3914 49.9019 86.4185 49.9498V49.9477Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M86.1995 49.8127C86.3994 49.8044 86.5994 49.7898 86.7972 49.7732C86.2682 49.7607 86.1683 49.7732 86.1995 49.8127Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M83.746 49.0806C83.4253 48.9912 83.1149 48.8934 82.79 48.7354C82.9796 48.8331 83.1733 48.908 83.3565 48.9746C83.544 49.0411 83.7335 49.0994 83.923 49.1472L83.746 49.0806Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M88.701 49.8316L88.374 49.946C88.5698 49.8878 88.7635 49.8233 88.9572 49.7588L88.701 49.8316Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.1695 49.5712C89.9383 49.6815 90.5236 49.6045 90.2736 49.694C90.3736 49.6711 90.4673 49.644 90.559 49.617C90.5735 49.6128 90.5777 49.6107 90.5777 49.6107L90.584 49.6066L90.5944 49.5983C90.5944 49.5983 90.611 49.5858 90.611 49.5795C90.6194 49.5567 90.6423 49.5255 90.6777 49.4922C90.6485 49.513 90.6319 49.5234 90.611 49.5234H90.5798H90.561C90.5548 49.5234 90.5173 49.5296 90.4944 49.5317C90.3923 49.5463 90.2861 49.5587 90.1716 49.5691L90.1695 49.5712Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.8282 49.3799C90.776 49.409 90.7174 49.4527 90.6777 49.4922C90.7279 49.4548 90.778 49.4173 90.8282 49.3799Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M87.8057 49.7521C87.8536 49.7667 87.9452 49.8145 88.2784 49.802L88.0389 49.7334C87.9681 49.7396 87.889 49.7438 87.8077 49.75L87.8057 49.7521Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M88.0283 49.7313H88.0367C88.2887 49.7126 88.4615 49.6939 88.5365 49.6855C88.4719 49.6918 88.3199 49.7105 88.0283 49.7313Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M87.7471 49.7562C87.768 49.7562 87.7847 49.7541 87.8056 49.7521C87.7826 49.7458 87.768 49.7437 87.7471 49.7562Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M85.2441 49.5685C85.6045 49.5789 86.323 49.5748 85.6378 49.4375C85.3837 49.4666 85.7794 49.5665 85.2441 49.5685Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M87.4538 49.6586C87.2456 49.6627 87.0373 49.6586 86.829 49.6523C86.8415 49.6752 86.954 49.7106 86.7832 49.7355C87.0081 49.7147 87.2331 49.6898 87.4538 49.6565V49.6586Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M87.7551 49.6123L87.4531 49.6581L87.6843 49.6539L87.7551 49.6123Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.605 49.3528C90.6904 49.2925 90.8049 49.2613 90.9299 49.2197C90.8757 49.226 90.8112 49.2364 90.7424 49.2488C90.6716 49.2613 90.6112 49.2738 90.5175 49.2946C90.5175 49.3092 90.4613 49.3424 90.4696 49.357C90.4696 49.3653 90.4946 49.3674 90.5237 49.3653C90.5404 49.3653 90.5675 49.3632 90.605 49.3528Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.4194 49.5586C89.4382 49.5544 89.4612 49.5481 89.478 49.5439C89.4403 49.5439 89.411 49.5439 89.4194 49.5586Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.5215 50.921C90.5319 50.9064 90.5424 50.8917 90.5529 50.8771C90.5487 50.8708 90.5445 50.8666 90.5424 50.8604L90.5215 50.921Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.4673 49.2859C90.2028 49.3254 90.0529 49.3774 89.9092 49.4336C90.0987 49.3899 90.3007 49.3421 90.5173 49.2922C90.5215 49.2838 90.5236 49.2776 90.5194 49.2755C90.5111 49.2755 90.5153 49.2734 90.4673 49.2859Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.8941 49.467C90.9296 49.4191 90.9651 49.3588 91.0048 49.2881C90.9484 49.3713 90.8669 49.4732 90.8941 49.467Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.5722 49.5527C89.5596 49.5569 89.5469 49.559 89.5322 49.5632C89.6226 49.5674 89.61 49.559 89.5722 49.5527Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.5713 49.5522C89.7046 49.5147 89.8066 49.4731 89.9087 49.4336C89.7504 49.471 89.6046 49.5064 89.4775 49.5418C89.5109 49.5418 89.5463 49.5459 89.5713 49.5522Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.7795 52.0155C90.7129 51.9468 90.8503 51.2708 91.1169 50.7383C91.2356 50.1663 90.8566 50.4429 90.5525 50.8777C90.5817 50.9068 90.615 50.9172 90.4775 51.4996C90.5858 51.3145 90.9857 50.2703 90.9045 50.7737C90.7025 51.5412 90.6775 51.381 90.5171 51.7347C90.717 51.4559 90.3526 52.7393 90.5525 52.6228L90.7129 51.9447C90.74 51.9406 90.6983 52.1902 90.7795 52.0134V52.0155Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.9109 49.7956L90.9276 49.7353L90.9338 49.7041L90.9442 49.6562C90.938 49.6687 90.9318 49.6812 90.9255 49.6937L90.9151 49.7103L90.9109 49.7187L90.9005 49.7415C90.8755 49.7998 90.8484 49.858 90.8193 49.9183C90.761 50.0369 90.6943 50.1659 90.6068 50.3323C90.5194 50.7337 90.5235 50.8252 90.5423 50.8606L90.9234 49.7187C90.9234 49.7332 90.9151 49.7707 90.9109 49.7956Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M91.0796 49.2341C91.1338 49.2154 91.1484 49.2737 91.1713 49.3173C91.1942 49.3569 91.2213 49.386 91.3212 49.2383C91.3691 49.0823 91.3858 49.0032 91.3837 48.9637C91.3837 48.9429 91.3796 48.9325 91.3733 48.9263C91.3671 48.918 91.365 48.9096 91.3275 48.9346C91.2713 48.9679 91.2088 49.0012 91.1213 49.0407C91.1838 49.0199 91.2338 49.0053 91.2671 48.9928L91.2838 48.9887L91.2796 49.0053C91.2796 49.0053 91.2733 49.0241 91.2713 49.0324C91.265 49.0469 91.2608 49.0594 91.2567 49.0677C91.2483 49.0844 91.2442 49.0865 91.24 49.0844C91.2358 49.0802 91.2338 49.0719 91.2296 49.0636C91.2296 49.0594 91.2254 49.0553 91.2234 49.0532C91.2234 49.0469 91.2025 49.0636 91.1942 49.0677C91.163 49.0865 91.1442 49.1031 91.1484 49.1114C91.1484 49.1135 91.1484 49.1156 91.1525 49.1177C91.1484 49.126 91.1442 49.1343 91.138 49.1468C91.1275 49.1676 91.115 49.1925 91.0984 49.2258C91.0984 49.2113 91.1005 49.1988 91.1026 49.1863C91.1026 49.1759 91.115 49.153 91.0901 49.1676C91.0276 49.1925 90.9776 49.2092 90.9297 49.2237C90.9734 49.2196 91.0109 49.2154 91.038 49.2175C91.0546 49.2092 91.0338 49.2383 91.0297 49.2508C91.0213 49.2653 91.013 49.2799 91.0067 49.2945C91.0109 49.2882 91.0151 49.2841 91.0172 49.2778V49.2757C91.0401 49.2445 91.0505 49.23 91.0359 49.257C91.0359 49.257 91.0359 49.2612 91.0359 49.2633C91.0526 49.2508 91.0671 49.2445 91.0796 49.2404C91.013 49.3881 91.0401 49.2841 91.0359 49.2633C91.0297 49.2674 91.0255 49.2695 91.0172 49.2757C91.0172 49.2757 91.0172 49.2757 91.0172 49.2778C91.0005 49.3839 90.9776 49.5108 90.9464 49.6626C90.9901 49.569 91.0297 49.438 91.0817 49.2404L91.0796 49.2341Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M86.2812 49.2881C86.317 49.2986 86.3149 49.3049 86.3191 49.3112C86.3969 49.3028 86.4242 49.2965 86.2812 49.2881Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M86.7624 49.3573C86.677 49.3677 86.6041 49.4072 86.325 49.3864C86.0855 49.349 86.3292 49.3427 86.3167 49.3115C86.1501 49.3282 85.7252 49.3427 86.25 49.4197L86.3334 49.4114C86.8061 49.4654 87.4268 49.5528 87.3435 49.5674C87.1998 49.4904 87.0748 49.4384 86.7603 49.3573H86.7624Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.5158 49.2759C89.8344 49.2052 90.1614 49.1262 90.4655 49.043L89.9656 49.0679L89.9989 49.1095C89.447 49.1969 89.5762 49.2281 89.5137 49.278L89.5158 49.2759Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.4448 51.0122L90.3904 50.8604L90.3486 51.4344L90.4448 51.0122Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.0675 52.2172L90.0006 52.1465L89.9463 52.4793L90.0675 52.2172Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M102.886 43.8535C102.848 43.8806 102.823 43.8993 102.794 43.9222L102.679 44.0095C102.733 43.97 102.787 43.9326 102.81 43.9118C102.84 43.8889 102.865 43.8702 102.884 43.8535H102.886Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M104.617 42.6843L104.634 42.624C104.571 42.6906 104.546 42.728 104.617 42.6843Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M85.7939 71.7939C86.0564 71.4528 86.3479 71.0493 86.2417 71.0659L86.1064 71.147C86.0064 71.432 85.896 71.6296 85.7939 71.7939Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M94.4482 52.6035C94.4148 52.6264 94.3793 52.6514 94.3458 52.6763C94.3019 52.772 94.2601 52.8635 94.2246 52.9446C94.2915 52.8427 94.3688 52.7262 94.4482 52.6056V52.6035Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M94.3623 52.1298L94.7809 51.7637C94.681 51.8406 94.5456 51.9571 94.3623 52.1298Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M92.629 53.0215L91.9375 53.9076C92.6852 53.0964 92.4623 53.269 92.629 53.0215Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M83.7716 63.2285C83.555 63.5218 83.3967 63.7652 83.2676 63.9836C83.53 63.6279 83.7778 63.3658 83.7716 63.2285Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M103.012 42.6026C102.937 42.6754 102.914 42.7066 102.895 42.7316C102.876 42.7586 102.87 42.7732 102.876 42.7815C102.97 42.692 103.06 42.5901 103.012 42.6026Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M82.7588 64.9029C82.7963 64.8488 82.8317 64.7968 82.8692 64.7427C82.9837 64.5015 83.1004 64.2623 83.267 63.9814C83.0733 64.2435 82.8713 64.5555 82.7588 64.9008V64.9029Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M93.0092 37.8213C92.9798 37.8213 92.944 37.8213 92.9167 37.8213C92.9104 37.8339 92.9503 37.8297 93.0092 37.8213Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M81.5537 40.8228C81.6558 40.7625 81.8265 40.6751 81.9848 40.5898C81.9036 40.6252 81.7724 40.6938 81.5537 40.8228Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M88.1904 56.666C88.2092 56.6265 88.3513 56.4476 88.1904 56.666V56.666Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.2193 55.9004C89.2151 55.9441 89.2193 55.9815 89.236 55.9961C89.2214 55.969 89.2172 55.9358 89.2193 55.9004Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M82.0827 67.5636C82.0827 67.5636 82.0764 67.5762 82.0723 67.5845C82.1225 67.5197 82.1141 67.5302 82.0827 67.5636Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M88.4753 56.3711C88.4042 56.4439 88.3248 56.5292 88.2412 56.6269C88.2809 56.5874 88.352 56.5084 88.4753 56.3711Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M88.4053 56.3871C88.4659 56.3164 88.5139 56.2602 88.5578 56.2061C88.5662 56.1708 88.5411 56.1874 88.4053 56.3871Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M87.9658 56.9681C88.0575 56.8433 88.1512 56.733 88.2407 56.627C88.2033 56.6644 88.1866 56.679 88.1928 56.6665C88.1449 56.7289 88.0783 56.8183 87.9679 56.9681H87.9658Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M84.257 46.1431C84.2465 46.1265 84.2361 46.1057 84.2256 46.087C84.0229 45.8623 84.1002 45.9705 84.257 46.1431Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M87.4721 64.9446C87.47 64.9572 87.4679 64.9634 87.4658 64.976C87.4721 64.9634 87.4784 64.9509 87.4826 64.9404L87.4721 64.9467V64.9446Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M87.7366 64.0146C87.7033 64.4411 87.6096 64.6532 87.4805 64.9382L87.8387 64.7302L87.7366 64.0146Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M98.9502 46.7069L99.5188 46.3512C98.9773 46.9565 98.5149 47.2997 99.0627 46.9877C99.0064 46.8483 99.4959 46.4302 100.004 46.0309C100.51 45.6315 101.031 45.2529 100.985 45.1094L101.379 44.9077C101.275 44.9763 101.266 45.0013 101.164 45.072C101.945 44.7017 101.56 44.5374 102.52 43.9675C102.605 43.9217 102.687 43.878 102.753 43.8427C102.803 43.8198 102.859 43.7969 102.899 43.7844C102.98 43.7595 102.989 43.7761 102.887 43.8531C102.997 43.7761 103.13 43.6887 103.264 43.591C103.393 43.4995 103.545 43.3559 103.626 43.2727C103.815 43.1313 103.799 43.2062 103.613 43.3476C103.77 43.2166 103.932 43.0897 104.103 42.9711C104.188 42.9108 104.272 42.8567 104.365 42.7964L104.642 42.6134V42.6258C104.703 42.5593 104.79 42.4719 104.886 42.4074C104.986 42.3409 105.103 42.293 105.171 42.2764C105.282 42.2972 105.248 42.3076 105.207 42.3118C105.161 42.318 105.092 42.3346 105.121 42.3492C105.257 42.3138 105.361 42.3138 105.473 42.3679L105.407 42.3055C105.407 42.3055 105.425 42.3242 105.427 42.3263H105.432C105.432 42.3263 105.432 42.3305 105.436 42.3263L105.467 42.3055C105.511 42.2806 105.561 42.2577 105.58 42.2494C105.592 42.2431 105.611 42.239 105.619 42.2369C105.625 42.2348 105.632 42.2327 105.638 42.2327C105.642 42.2327 105.646 42.2327 105.65 42.2327C105.654 42.2327 105.638 42.2327 105.636 42.2306C105.627 42.2286 105.619 42.2244 105.613 42.2223C105.573 42.2057 105.58 42.2098 105.623 42.2265C105.644 42.241 105.682 42.2202 105.592 42.2494C105.571 42.2577 105.548 42.2702 105.5 42.293C105.48 42.3034 105.459 42.3159 105.44 42.3305C105.432 42.3388 105.369 42.3742 105.361 42.3783C105.361 42.3825 105.348 42.3742 105.34 42.3658L105.423 42.4449C105.338 42.4158 105.248 42.4012 105.082 42.4262C105.196 42.474 105.236 42.5135 105.263 42.5302C105.29 42.5468 105.307 42.5447 105.346 42.553L105.236 42.449C105.236 42.449 105.246 42.4574 105.248 42.4553C105.236 42.4636 105.28 42.4303 105.303 42.4158L105.384 42.3638L105.425 42.3388L105.45 42.3222C105.467 42.3118 105.486 42.2993 105.505 42.291C105.55 42.2702 105.569 42.2577 105.594 42.2494C105.625 42.241 105.629 42.2369 105.646 42.2348C105.654 42.2348 105.648 42.2348 105.652 42.2348C105.652 42.2348 105.654 42.2348 105.646 42.2348C105.638 42.2348 105.636 42.2327 105.625 42.2286C105.609 42.2244 105.592 42.2182 105.575 42.2098L105.475 42.1599L105.413 42.1246L105.382 42.1058L105.367 42.0954L105.292 42.0518L105.261 42.033V42.0351C105.261 42.0351 105.261 42.0372 105.257 42.0434C105.244 42.0663 105.234 42.0892 105.221 42.1121C105.192 42.1682 105.159 42.239 105.136 42.3076C105.13 42.3284 105.123 42.3492 105.109 42.37C105.096 42.3866 105.071 42.4158 105.028 42.4553C104.942 42.5322 104.809 42.6196 104.615 42.7506L104.867 42.5177C104.938 42.449 105.003 42.3804 105.028 42.3388C104.907 42.3617 104.713 42.4802 104.463 42.6674C104.457 42.6695 104.449 42.6778 104.446 42.6778C104.446 42.6778 104.442 42.6778 104.444 42.6778L104.43 42.6862C104.394 42.709 104.357 42.7298 104.322 42.7548C104.253 42.7985 104.18 42.8463 104.105 42.8942C103.957 42.9899 103.801 43.0897 103.626 43.1916C103.718 43.1542 104.072 42.9607 104.344 42.8484C104.407 42.8235 104.486 42.7902 104.519 42.7881C104.534 42.7985 104.563 42.7943 104.576 42.8026C104.59 42.811 104.594 42.8255 104.586 42.8484C104.586 42.8526 104.582 42.8588 104.58 42.8651C104.58 42.8692 104.58 42.8734 104.561 42.8879C104.534 42.9129 104.501 42.942 104.459 42.9774C104.255 43.0959 104.007 43.2686 103.701 43.5806C103.634 43.5015 103.316 43.7824 102.909 44.1172L102.851 43.9883C102.433 44.3772 102.512 44.4022 102.291 44.6622C101.793 45.0553 101.626 45.0595 101.454 45.0886C100.66 45.7272 102.099 44.7641 101.195 45.5608C100.514 46.0746 100.11 46.5134 99.4209 47.2539C98.9544 47.6179 99.4396 47.1229 99.2584 47.2373L98.946 47.6699C98.8502 47.7552 98.8586 47.7032 98.8627 47.6762C98.567 48.0048 98.9273 47.801 98.4441 48.296C98.4254 48.4146 98.1296 48.6143 97.7714 48.8681C97.409 49.1218 96.9862 49.4442 96.7342 49.802C96.553 49.9206 96.7508 49.6709 96.6675 49.6772C95.8928 50.5778 95.9927 50.4406 95.42 51.2372L94.7868 51.7739C95.2784 51.4015 94.8285 52.0464 94.4536 52.6142C94.6327 52.4873 94.7889 52.3833 94.8868 52.3064C94.6619 52.5872 94.4411 52.868 94.2224 53.1529C94.1204 53.2361 94.1558 53.1238 94.2307 52.9553C94.1912 53.0177 94.1516 53.076 94.1245 53.1238C93.8329 53.3797 93.9058 53.18 94.0308 52.9221C94.1391 52.843 94.2474 52.764 94.3515 52.687C94.4682 52.4332 94.5702 52.1878 94.4723 52.1753C94.4369 52.2377 94.3557 52.3459 94.262 52.4624C94.2911 52.3958 94.3078 52.348 94.2745 52.3646C94.2391 52.3833 94.1849 52.4852 94.0933 52.6413L93.8163 52.7245L93.8225 52.8097C93.4872 53.1446 93.154 53.4837 92.8291 53.829C92.3001 54.7151 91.9273 55.5346 91.0525 56.8783C91.1941 56.4873 90.9546 56.7036 90.8588 56.61C91.2254 56.3312 91.5378 55.5616 92.0751 54.9189C91.796 55.2538 91.8065 55.1415 91.8564 55.0395C91.5857 55.4597 91.3233 55.884 91.0671 56.3104C91.04 56.273 90.9921 56.3021 90.9296 56.3687C90.8984 56.402 90.863 56.4436 90.8234 56.4935C90.7755 56.5538 90.7214 56.6225 90.6651 56.6953C90.6443 56.741 90.6235 56.7868 90.6006 56.8346C90.5839 56.8658 90.5672 56.897 90.5506 56.9282C90.8567 56.7369 90.2694 58.0036 90.1049 58.586C90.0236 58.5943 90.0111 58.4342 90.3027 57.7582C89.8508 58.4508 90.1424 58.8211 89.7196 59.5075C89.7841 59.3411 89.832 59.2558 89.8237 59.1767C89.7258 59.5886 89.2968 60.5184 89.328 60.2729L89.3926 60.1065C88.8969 61.1902 88.1034 63.4949 88.2096 63.7237C88.1846 63.7279 88.0596 63.5012 88.0492 63.42L87.8909 65.6249C87.8097 65.3961 87.2161 65.9452 87.4723 64.9884C87.3536 65.2463 87.2099 65.5687 87.0558 66.149C87.1432 65.9743 87.4327 65.7726 87.3536 66.0242C86.9412 66.6462 87.0974 66.4673 86.6496 67.2494C86.7808 66.9915 86.8975 67.3763 86.7288 67.8006C86.7204 67.7216 86.4913 67.7507 86.5268 67.5864L86.3393 68.7304C86.4039 68.4517 86.1706 68.6097 86.0144 68.8198C86.104 68.7283 85.6458 69.7267 85.5479 70.0117L85.7832 69.5894C85.5229 70.1739 85.475 70.4963 85.4312 70.8208C85.3917 71.1432 85.3334 71.4636 85.048 72.0335C85.0709 71.8733 84.9397 71.5634 84.6315 72.1271C84.6231 72.2873 84.6148 72.6346 84.5148 73.0818C84.4649 73.3044 84.394 73.5478 84.2878 73.7994C84.1795 74.0532 84.0171 74.3091 83.8025 74.5316C83.7276 74.5649 83.6526 74.5982 83.5776 74.6273C83.3548 74.8332 83.0819 75.0308 82.7654 75.1494C82.9028 75.062 83.0903 74.9268 83.2631 74.7396C83.4318 74.5566 83.6005 74.334 83.7401 74.0927C83.8817 73.8494 83.9837 73.5998 84.0775 73.346C84.1712 73.0964 84.2503 72.8634 84.3149 72.6721C84.0316 73.0402 84.1899 72.7469 83.8192 73.3252C83.6297 73.4874 83.9483 72.9653 84.04 72.7885C83.9692 72.8988 83.8963 73.009 83.8213 73.1172C83.7463 73.2253 83.6672 73.3335 83.5964 73.4209C83.4485 73.6039 83.284 73.7662 83.1028 73.9034C83.1361 73.9222 83.109 73.9804 83.0444 74.0553C83.0111 74.0927 82.9695 74.1343 82.9216 74.1759C82.8757 74.2154 82.8299 74.2529 82.7779 74.2862C82.5758 74.4297 82.3259 74.49 82.3592 74.5441C82.6029 74.4817 82.8112 74.3694 83.0069 74.2071C83.2111 74.0407 83.3902 73.8473 83.5422 73.6351C83.6151 73.6538 83.5568 73.9055 83.3027 74.2134C83.1736 74.3652 83.0007 74.5295 82.7799 74.6398C82.5571 74.7542 82.2801 74.8124 82.001 74.7916C81.8677 74.7542 81.9323 74.6959 82.0052 74.6377C82.0885 74.5795 82.1884 74.515 82.1759 74.49C82.1489 74.5046 82.0676 74.5171 81.9843 74.5233C81.9073 74.5275 81.7865 74.5129 81.6761 74.4879C81.4512 74.4401 81.2908 74.3236 81.2762 74.2841C81.3824 74.3382 81.5011 74.3694 81.6282 74.3902C81.4074 74.2799 81.2575 74.2238 81.1179 74.0802C81.0825 74.0449 81.0534 74.0033 81.0242 73.9554C80.993 73.8993 80.9638 73.8369 80.943 73.7724C80.8972 73.6414 80.8722 73.4874 80.8826 73.3127C80.8722 73.1941 80.9076 73.0111 80.9471 72.8613C80.9867 72.7095 81.0242 72.5868 80.9846 72.5556C80.8805 72.7449 80.7139 72.8572 80.5514 72.8967C80.3911 72.9341 80.2307 72.8821 80.1786 72.7157C80.1849 72.6596 80.2578 72.2893 80.3744 71.9108C80.4869 71.528 80.6451 71.137 80.7264 70.9955C80.8492 70.7938 80.8742 70.9789 80.9013 71.1682C80.9284 71.3575 80.9596 71.5468 81.0554 71.3804C81.02 71.3554 81.0325 71.1099 81.0471 71.008C81.1575 70.7459 81.1283 71.1536 81.2866 70.5587C81.1721 70.4131 81.6927 69.3773 81.2575 70.2446C81.4074 69.656 81.4928 69.656 81.7531 68.9883C81.5803 69.1651 81.7011 68.2707 81.9177 67.6924C81.9364 67.7403 82.0364 67.6342 82.0843 67.5822C82.6216 66.4465 82.984 65.8745 83.5443 64.849C83.6255 64.77 83.94 64.302 83.8754 64.5412C83.9358 64.3831 83.9692 64.225 84.1462 63.9109C84.6044 63.3743 83.7588 64.614 84.1566 64.2312C84.1045 64.1501 84.5232 63.3701 84.7523 62.9083C84.5565 62.9728 84.1108 63.9068 83.9088 64.381C83.7505 64.2957 84.0254 63.418 84.6169 62.3322C85.1063 61.4856 84.9439 62.0389 85.0126 61.8829C85.525 61.1237 85.6791 60.7576 85.8207 60.4289C85.9644 60.1003 86.0956 59.8112 86.5892 59.2246C87.0308 58.7961 86.7892 59.3327 86.935 59.2724C86.5122 59.9443 86.1769 60.2292 85.879 60.6765L86.2977 60.1606C86.1852 60.3894 85.9123 60.8429 85.7249 61.0654C85.9082 60.8845 86.3414 60.2459 86.8537 59.5241C87.3661 58.8023 87.9617 58.0015 88.4262 57.4711C88.547 57.2485 88.7803 56.8825 88.6199 57.0177L88.3616 57.3817C88.0388 57.6521 88.7719 56.637 88.3929 57.0593C88.5012 56.8825 88.6136 56.6994 88.7324 56.5039C88.7928 56.4082 88.8573 56.3084 88.924 56.2085C88.9823 56.1253 89.0427 56.038 89.1031 55.9485C89.1135 55.9111 89.1239 55.8716 89.1364 55.8341C89.1552 55.778 89.1739 55.7197 89.1926 55.6594C89.2322 55.5408 89.2759 55.4202 89.3238 55.2975L89.4967 55.1872C89.4571 55.1872 89.251 55.6947 89.2218 55.9173C89.2697 55.5824 89.7841 54.7463 89.7383 54.3323L89.4717 54.8669C89.5946 54.2762 89.6904 53.5253 89.9591 52.8285C89.7321 53.1134 89.9195 52.9969 89.6154 53.4566C89.9341 53.076 89.0219 55.2725 89.4363 54.6298C89.2884 54.8357 89.201 55.0291 89.1197 55.2371C89.0781 55.3411 89.0364 55.4472 88.9927 55.5616C88.9698 55.6178 88.9448 55.676 88.9177 55.7364L88.8969 55.7821C88.8906 55.7946 88.8886 55.7925 88.8844 55.7988C88.8781 55.8071 88.8698 55.8154 88.8615 55.8216C88.8365 55.8362 88.8302 55.8216 88.7469 55.8965C88.7948 55.9069 88.9677 55.7488 88.5595 56.2314C88.5512 56.2626 88.522 56.325 88.5033 56.3645C88.4908 56.3791 88.4866 56.3832 88.4741 56.3957C88.4824 56.3874 88.4908 56.3812 88.4991 56.3708C88.4866 56.3957 88.4866 56.3999 88.5074 56.3624C88.6157 56.2564 88.7074 56.1732 88.7573 56.1503C88.6386 56.4561 88.0242 57.2465 87.8618 57.5501C87.6202 57.8372 87.9159 57.3962 87.7576 57.5314L87.516 57.9828C87.4098 57.9662 86.7996 58.69 87.2765 57.9454L86.8038 58.5839C86.4851 58.9313 86.0977 59.4472 85.9061 59.7966C85.6749 60.094 85.4604 60.639 85.5812 60.327C85.3646 60.6806 85.1522 61.0384 84.9397 61.3962L84.9126 61.392C84.2295 62.4133 83.6859 63.6114 82.8632 64.7679C82.6883 65.1465 82.5113 65.5375 82.178 66.149L82.0447 66.2343C81.8302 66.7231 81.2866 67.6571 81.2762 67.9025C81.17 68.0128 81.045 68.2166 80.9221 68.4745C80.8597 68.6035 80.7972 68.747 80.7347 68.8968C80.6743 69.0465 80.6097 69.2046 80.5473 69.3814C80.3077 70.072 80.1349 70.7813 80.0016 71.2701L80.0974 71.3304C80.0203 71.6591 79.9683 71.9856 79.937 72.3351C79.9016 72.6866 79.8954 73.1089 79.9912 73.5602L80.0766 73.4895C80.1245 73.6788 80.1786 73.893 80.2598 74.1239C80.2994 74.2321 80.3515 74.3694 80.4285 74.5004C80.5056 74.6315 80.6056 74.7604 80.7243 74.8707C80.9638 75.0953 81.27 75.243 81.574 75.3241C81.649 75.3428 81.7261 75.3616 81.8135 75.3761C81.901 75.3907 81.9906 75.3948 82.0676 75.3969C82.2301 75.4011 82.3946 75.3886 82.5592 75.3574C82.4738 75.4156 82.1385 75.4448 81.8948 75.399C82.2905 75.4822 82.7237 75.4385 83.1173 75.2617C83.5172 75.0787 83.7984 74.827 84.0608 74.5441C84.317 74.2654 84.5211 73.9367 84.6877 73.6622C84.8627 73.3772 85.0293 73.1026 85.2063 72.8509C85.3209 72.5639 85.4167 72.3788 85.5312 72.202C85.5187 72.2269 85.5104 72.2498 85.5041 72.2706C85.5166 72.2436 85.5375 72.204 85.5583 72.1624C85.6291 72.0522 85.7041 71.9378 85.7832 71.8151C85.7082 71.917 85.6395 72.0148 85.5854 72.1042C85.6812 71.8962 85.829 71.5863 85.9436 71.2618L86.0956 71.1682C86.106 71.1432 86.1144 71.1224 86.1227 71.0954C86.2872 70.8063 86.1831 70.8333 86.0436 70.9643C86.0956 70.8021 86.1373 70.6523 86.1602 70.5317C86.4164 70.3487 86.4476 69.6976 86.7475 69.423C86.7579 69.1818 87.3057 67.8256 87.1974 67.5926C87.2224 67.5905 87.2682 67.5011 87.2057 67.6716C87.3578 67.3284 87.5056 66.9852 87.5702 66.6503L87.7472 66.5443L87.8618 65.7206C88.1055 65.2837 88.2179 65.1069 88.145 65.602C88.4054 64.4372 88.4199 64.6805 88.622 63.68L88.6845 63.7549C88.8053 63.4159 88.8969 62.8355 89.0364 62.6546C89.1427 62.4799 89.2822 62.1574 89.4467 61.7456C89.6238 61.3379 89.8279 60.8408 90.0466 60.3062C90.2652 59.7716 90.4964 59.1996 90.7318 58.6463C90.8484 58.3697 90.9671 58.0972 91.0837 57.8351C91.1441 57.7041 91.2025 57.5772 91.2587 57.4524C91.2879 57.39 91.317 57.3297 91.3462 57.2693L91.3899 57.1799C91.4066 57.1466 91.4087 57.1466 91.417 57.13C91.3337 57.1508 91.3149 57.1362 91.3399 57.078C91.3524 57.0613 91.3628 57.053 91.3878 57.0218C91.417 56.9885 91.4482 56.9532 91.4836 56.9137C91.5524 56.8367 91.6294 56.7514 91.7023 56.6703C91.8439 56.506 91.9606 56.352 91.9231 56.2896C92.0418 56.2272 92.2376 56.0192 92.0814 56.3146C92.6604 55.441 93.1082 55.1248 93.4393 54.4654C93.5601 54.4114 93.3623 54.6922 93.4581 54.6318C93.5018 54.559 93.6288 54.3427 93.7267 54.2824C93.8225 54.2242 93.6663 54.4301 93.5809 54.5757C94.2537 53.7499 94.1974 53.5565 94.1183 53.3859C94.5369 53.0281 94.7098 52.8201 94.893 52.4561C95.0638 52.3542 95.3179 52.1608 94.8826 52.6662C95.0139 52.5331 95.4137 52.1233 95.7845 51.7427C96.1531 51.362 96.4884 51.0084 96.4551 50.946C96.5613 50.8878 96.8362 50.5862 96.8966 50.505C97.511 49.9289 97.5714 49.8873 98.1796 49.3236L97.9942 49.4609C98.1296 49.1218 98.4837 48.9679 98.9648 48.4999V48.5248C100.173 47.5722 99.4105 48.0298 100.623 47.1125L100.493 47.0917C100.452 46.8317 101.577 46.293 102.197 45.6752L101.916 45.8333C102.235 45.4651 103.136 45.2051 103.528 44.9264C103.622 44.8765 103.418 45.0533 103.313 45.1573C104.372 44.4708 103.355 44.9493 104.067 44.3419C104.247 44.292 104.007 44.6206 104.507 44.2462C104.611 44.1942 104.819 43.9987 105.071 43.7761C105.103 43.7491 105.121 43.7303 105.196 43.6742C105.221 43.6513 105.246 43.6243 105.267 43.6035L105.311 43.5577C105.38 43.4891 105.452 43.4183 105.525 43.3455C105.604 43.2665 105.69 43.1833 105.777 43.0772C105.869 42.967 105.967 42.8214 106.015 42.6758C106.021 42.655 106.027 42.6425 106.036 42.6258C106.046 42.6071 106.05 42.603 106.094 42.5322C106.113 42.4969 106.156 42.4262 106.171 42.3097C106.186 42.187 106.154 42.0788 106.127 42.0206C106.073 41.902 106.04 41.8708 106.009 41.823L105.986 41.7897L105.917 41.7377C105.777 41.6316 105.619 41.5546 105.469 41.5089C105.617 41.5671 105.742 41.6607 105.75 41.6961C105.754 41.7127 105.734 41.7148 105.673 41.7002C105.613 41.6877 105.511 41.6545 105.357 41.6441C105.119 41.6149 104.865 41.6441 104.619 41.7189C104.361 41.7959 104.132 41.9332 103.949 42.0289C103.553 42.2286 103.143 42.5114 102.972 42.7756C102.909 42.8068 102.878 42.8089 102.868 42.8006C102.789 42.8713 102.668 42.9587 102.512 43.0564C102.47 43.0835 102.428 43.1105 102.387 43.1375C102.341 43.1667 102.287 43.2083 102.253 43.2311C102.174 43.2873 102.095 43.3455 102.018 43.4017C101.701 43.6326 101.408 43.8635 101.306 43.9904C101.008 43.9758 100.366 44.4688 99.7999 44.9513C99.2314 45.4318 98.7357 45.8998 98.6378 45.7709C98.2275 46.1099 97.8276 46.4594 97.434 46.8151L97.4423 46.7631C96.6696 47.4224 96.4634 47.7282 96.2552 48.0277C96.0698 48.1733 96.1739 48.034 96.176 48.0069C95.974 48.1796 95.8199 48.3127 95.6887 48.425C95.5949 48.5061 95.5262 48.5768 95.4512 48.66C95.2992 48.8327 95.1576 49.0324 94.741 49.569C94.7723 49.49 94.8056 49.4068 94.8452 49.3194C94.7368 49.4692 94.5848 49.5815 94.4515 49.6876C94.4328 49.7022 94.414 49.7188 94.3932 49.7334C94.3828 49.7458 94.3953 49.7209 94.4015 49.7063L94.4224 49.6605L94.464 49.5711C94.5182 49.4525 94.5681 49.3444 94.6098 49.2466C94.6931 49.0511 94.741 48.9055 94.7514 48.7849C94.7723 48.7682 94.8056 48.7412 94.816 48.7578C94.8264 48.6496 94.9139 48.4104 95.0284 48.2045C95.0847 48.0984 95.1409 47.9986 95.193 47.9092C95.218 47.8655 95.243 47.8239 95.2679 47.7823C95.3138 47.6908 95.3617 47.6013 95.4054 47.5139C95.4908 47.3434 95.6158 47.1083 95.6762 46.8879C95.7428 46.6632 95.774 46.4323 95.7615 46.2202C95.7386 45.7896 95.547 45.4776 95.3762 45.3694C95.3471 45.3299 95.3096 45.2675 95.27 45.2217C95.2304 45.1739 95.1992 45.1177 95.1409 45.0886C95.0888 45.0533 95.0368 45.0179 94.9847 44.9867C94.9389 44.9617 94.8931 44.9368 94.8452 44.9139C94.6556 44.8224 94.4411 44.7537 94.212 44.7496C94.4307 44.7745 94.5723 44.8411 94.6639 44.8889C94.7577 44.9389 94.8035 44.9784 94.8264 45.0013C94.8701 45.0491 94.8097 45.0345 94.7243 45.0158C94.5515 44.9701 94.2849 44.943 94.5494 45.072C94.4203 45.0221 94.2682 44.9742 94.1141 44.9659C93.96 44.9534 93.8163 44.9867 93.7142 44.9971C93.5101 45.0283 93.4435 45.0033 93.7767 44.8931L93.8913 44.8848C93.9537 44.8203 93.8475 44.8099 93.6934 44.8369C93.5351 44.864 93.3102 44.9368 93.0915 45.0304C92.6479 45.2217 92.2355 45.4589 92.2167 45.3861C91.9148 45.5462 91.6148 45.7043 91.3149 45.8645C91.0213 46.0226 90.7359 46.1474 90.4298 46.2576C90.1257 46.3678 89.8195 46.4552 89.4988 46.5322C89.1926 46.6091 88.8865 46.6549 88.572 46.6819C87.9451 46.7318 87.3119 46.6965 86.685 46.6216C86.0873 46.5509 85.5375 46.3699 85.1334 46.0371C85.1626 46.1286 85.2001 46.2181 85.248 46.3096C85.0293 46.164 84.8335 45.9872 84.6794 45.775C84.6315 45.6814 84.6211 45.6086 84.6565 45.6149C84.6919 45.6232 84.7668 45.7147 84.946 45.9061C84.8793 45.7792 84.7314 45.6253 84.6065 45.4693C84.4774 45.3091 84.3691 45.176 84.3503 45.176C84.267 44.9181 84.2816 44.8141 84.2962 44.7953C84.3128 44.7766 84.3441 44.8432 84.3857 44.9264C84.4649 45.0928 84.619 45.3237 84.5544 45.1843C84.4919 45.0595 84.4482 44.9326 84.419 44.8078C84.419 44.8369 84.419 44.8681 84.419 44.8973C84.3503 44.7496 84.3128 44.6643 84.2878 44.5416C84.2774 44.4812 84.2712 44.4084 84.2837 44.3169C84.2899 44.2712 84.3003 44.2192 84.317 44.1588C84.3357 44.0944 84.3586 44.0236 84.392 43.9467C84.4899 43.7553 84.5419 43.722 84.569 43.7116C84.5981 43.7033 84.6065 43.7179 84.6523 43.6492C84.6627 43.6555 84.6898 43.6097 84.7918 43.4391C84.8876 43.306 84.996 43.1833 85.1126 43.0627C85.2375 42.9358 85.3646 42.8131 85.4958 42.6966C85.3646 42.7611 85.2334 42.8318 85.1022 42.9046C85.3937 42.5198 85.8624 42.2265 85.3875 42.449C85.5604 42.3658 85.8436 42.1641 86.1977 41.9374C86.5538 41.7085 86.9745 41.4548 87.4119 41.2717C88.3241 40.8578 89.2301 40.5957 89.4613 40.5749C90.1007 40.3232 90.7672 40.2068 91.6086 40.1464C91.3982 40.1423 91.2566 40.0112 91.9897 39.9696C91.8669 40.1215 92.2022 40.1236 92.6437 40.1236C93.0832 40.1215 93.6309 40.1215 93.9246 40.2234C93.6622 40.1568 94.1787 40.1423 94.6577 40.1402C94.8972 40.1381 95.1284 40.1402 95.2471 40.1256C95.3013 40.1173 95.3617 40.109 95.345 40.0924C95.3408 40.084 95.3138 40.0736 95.2867 40.0632C95.2617 40.0528 95.2221 40.0404 95.1721 40.0258C95.2554 40.0341 95.3179 40.0404 95.3637 40.0445C95.42 40.0445 95.4491 40.0508 95.4741 40.0549C95.52 40.0632 95.522 40.0778 95.5179 40.0944C95.5116 40.1236 95.4762 40.1776 95.7636 40.1631C95.9802 40.1048 96.2052 40.0154 96.4072 39.8802C96.6113 39.7471 96.7862 39.5703 96.9279 39.3747C96.9883 39.2853 97.0882 39.1501 97.1216 39.0107C97.157 38.9047 97.1903 38.7944 97.2174 38.68C97.2694 38.4491 97.3111 38.1933 97.2549 37.8937C97.2236 37.7398 97.1674 37.588 97.0778 37.4549C96.9945 37.3238 96.8571 37.2011 96.7529 37.1241C96.528 36.9557 96.2656 36.8454 96.0052 36.783C95.747 36.7206 95.4804 36.704 95.2367 36.7102C95.0097 36.7164 94.7806 36.7248 94.5515 36.7414C94.5244 36.7809 94.8327 36.8204 94.4453 36.8974C94.1204 36.8537 93.7934 36.8142 93.4664 36.783C93.1061 36.8371 93.1561 37.0264 92.4833 36.9785C92.5812 36.9973 92.7249 37.0264 92.4833 37.0701C90.6901 37.2115 88.9011 37.7024 87.1786 38.3306C86.7517 38.4866 86.3101 38.655 85.8915 38.8381L84.6315 39.3768C83.7942 39.7367 82.9507 40.0965 82.1114 40.4376C82.5758 40.2754 82.2926 40.4335 81.9635 40.6082C82.1864 40.5125 82.001 40.6935 82.0656 40.7164L80.666 41.2884C80.4869 41.5401 79.2372 42.0434 79.1602 42.2348L79.5725 41.9935C79.0852 42.4262 80.5223 41.8937 80.5348 42.1162C81.0825 41.6316 82.3134 41.4797 83.2298 40.7288C83.4776 40.6519 83.0632 40.8849 83.2069 40.8661C83.4297 40.6581 83.7401 40.4834 84.3524 40.238L84.2941 40.29C85.1251 39.8885 85.7353 39.6389 86.3789 39.3955C87.0079 39.1626 87.6952 38.9525 88.6824 38.68L88.5074 38.628C88.9344 38.5115 89.0323 38.5198 89.2385 38.4866C89.4613 38.3451 89.1635 38.4242 88.8573 38.5094C88.5532 38.5947 88.2429 38.6862 88.4408 38.5365C88.7511 38.5448 89.4988 38.3243 90.2361 38.1579C90.9713 37.9853 91.694 37.8709 91.9064 37.9562C92.575 37.8542 91.6919 37.8688 92.3625 37.771L92.55 37.8085L92.7104 37.7065C93.154 37.6649 93.3852 37.7232 93.4081 37.7752C93.2998 37.7793 93.1061 37.8209 92.9915 37.8397C93.5684 37.8397 94.6015 37.6753 94.8014 37.6961C94.5848 37.692 94.3682 37.692 94.1495 37.6941C94.3786 37.6712 94.6161 37.6525 94.8576 37.64C94.9784 37.6337 95.1013 37.6275 95.2242 37.6233C95.3512 37.6171 95.4471 37.6171 95.5554 37.6233C95.7657 37.6379 95.9615 37.6837 96.1219 37.7648C96.1635 37.7835 96.201 37.8085 96.2364 37.8314C96.2718 37.8584 96.3093 37.8834 96.3239 37.9C96.3655 37.9395 96.3968 37.9874 96.4134 38.0435C96.4509 38.1454 96.4447 38.3555 96.3947 38.5573C96.3718 38.6571 96.3343 38.7882 96.3176 38.8152C96.3093 38.8339 96.2801 38.8776 96.2531 38.9171C96.226 38.9546 96.1968 38.992 96.1677 39.0253C95.9365 39.2915 95.5949 39.4143 95.1992 39.4163L95.3346 39.4704C94.6348 39.4829 94.3515 39.4704 94.0537 39.4496C93.7559 39.4309 93.4372 39.4039 92.6687 39.4579L92.7249 39.4434C92.4188 39.5037 92.0106 39.5536 91.5899 39.5848C91.9731 39.4933 90.8484 39.5453 91.3524 39.4371C90.5881 39.5619 90.4006 39.6264 90.2819 39.6743C90.1632 39.7263 90.109 39.7679 89.6321 39.9613L89.3863 39.9384C89.0698 40.0965 89.0468 40.1256 88.3221 40.3856C88.9031 40.1194 87.8118 40.4314 88.4616 40.1194C88.0576 40.2047 87.716 40.3253 87.4244 40.4522C87.2786 40.5167 87.1578 40.5749 87.0224 40.6415C86.8912 40.708 86.7725 40.7767 86.6621 40.8453C86.2227 41.1199 85.9228 41.357 85.5395 41.486C85.3021 41.8084 85.602 41.6025 85.9353 41.3841C86.2664 41.1636 86.6496 40.9369 86.4768 41.0637C86.6496 41.0076 86.5309 41.1157 86.3226 41.2801C86.1144 41.4423 85.8249 41.6669 85.6166 41.8167C85.4104 41.9748 85.198 42.0622 84.9147 42.2327C84.7731 42.3201 84.6169 42.422 84.4357 42.5822C84.2545 42.7444 84.0546 42.9649 83.8775 43.2811C83.9504 43.1563 83.9421 43.1396 84.0212 43.0211C83.8463 43.2311 83.7359 43.4807 83.6484 43.7511C83.6276 43.8198 83.6068 43.8884 83.588 43.9592C83.5672 44.0361 83.5485 44.1131 83.5339 44.1963C83.5026 44.3585 83.4818 44.5312 83.4714 44.7163C83.5505 44.9181 83.5964 45.1365 83.663 45.3153C83.7276 45.4921 83.8025 45.6273 83.9004 45.6315C83.6942 45.2613 83.5568 44.8016 83.6026 44.3315C83.5755 44.7329 83.7109 45.1053 83.9109 45.4547C84.117 45.7958 84.3628 46.1848 84.8023 46.58C84.7065 46.5592 84.4045 46.3533 84.2358 46.1661C84.4253 46.4802 84.7314 46.6466 85.0209 46.8712C84.9376 46.9211 84.5607 46.7215 84.2274 46.3366C84.0608 46.1474 83.9108 45.9123 83.7942 45.6939C83.6693 45.4734 83.5672 45.2301 83.4922 45.02C83.4922 45.2405 83.6734 45.6294 83.8255 45.8499C83.9775 46.0891 84.1025 46.243 83.9025 46.1203C84.167 46.3138 84.4024 46.5925 84.7398 46.8483C85.073 47.1 85.5125 47.3143 85.9977 47.3288L85.9123 47.412C86.0644 47.437 86.3872 47.4432 86.6496 47.4703C86.4913 47.4994 86.3122 47.5202 86.1373 47.5306C86.5434 47.5472 86.8767 47.593 87.2286 47.645C87.5785 47.6928 87.9326 47.7324 88.2929 47.6824C87.5369 47.7157 87.4577 47.6554 87.4827 47.6242C87.5077 47.5847 87.6368 47.541 87.3286 47.4931C88.2325 47.4557 88.4949 47.4703 88.7969 47.5181C89.0906 47.5555 89.4717 47.6055 90.4423 47.2706C90.3111 47.3226 90.0528 47.385 89.882 47.4079C89.7154 47.4287 89.63 47.4203 89.8279 47.3434C90.2069 47.2664 90.713 47.1312 90.9609 47.0855C92.2292 46.4885 90.7255 47.0855 91.242 46.7839C91.7315 46.684 91.7981 46.4386 92.2855 46.139L92.3376 46.2264C92.6708 46.0683 92.852 45.9664 92.9561 45.8915C93.0561 45.8208 93.0811 45.7792 93.1019 45.7397C93.1248 45.7001 93.1436 45.6627 93.229 45.6065C93.3164 45.5525 93.4726 45.4713 93.7705 45.3944C93.6226 45.4921 93.4789 45.6003 93.3414 45.7147C93.531 45.6149 93.7226 45.5275 93.9142 45.4609C93.885 45.5088 93.8559 45.5587 93.8288 45.6086C93.8975 45.5753 93.9829 45.5421 94.0225 45.5254C94.0558 45.5109 94.087 45.5005 94.1183 45.4963C94.1828 45.4901 94.2495 45.5005 94.3224 45.5296C94.3578 45.5441 94.3953 45.5629 94.4328 45.5857C94.4515 45.5982 94.4703 45.6086 94.4911 45.6232C94.5119 45.6377 94.5327 45.6523 94.539 45.6606C94.5598 45.6793 94.5827 45.6981 94.5931 45.7272C94.6035 45.7438 94.5994 45.748 94.616 45.775C94.6306 45.8 94.639 45.8291 94.6515 45.8582C94.6556 45.7917 94.7077 45.7813 94.7785 45.8541C94.8472 45.9248 94.9389 46.0891 94.9222 46.3533C94.8743 46.5301 94.8514 46.4739 94.8389 46.4698C94.8326 46.4677 94.8243 46.4781 94.8118 46.5322C94.7972 46.5883 94.7785 46.6882 94.7077 46.8733C94.7119 46.6799 94.7014 46.503 94.7931 46.2264C94.7618 46.1973 94.716 46.0933 94.6785 46.0746C94.6744 46.2243 94.6619 46.4094 94.6056 46.6133C94.5786 46.7152 94.5411 46.8151 94.5036 46.9087C94.4557 47.0231 94.414 47.125 94.3807 47.204C94.4369 47.0896 94.5098 46.9378 94.5494 46.8858L94.4473 47.204L94.3932 47.3663L94.3057 47.6055C94.187 47.932 94.0662 48.2482 93.9746 48.5311C93.81 48.8285 93.8538 48.6351 93.9183 48.4063C93.7705 48.7953 93.7309 49.0095 93.5268 49.5441C93.4914 49.5233 93.4372 49.5441 93.4268 49.4692C93.4185 49.3964 93.4539 49.2237 93.6038 48.7953L93.2769 49.7375L92.9686 50.6444C92.9103 50.7422 92.7645 51.0438 92.6354 51.3079C92.5062 51.5721 92.3917 51.7968 92.4125 51.699C92.2147 52.1524 92.0543 52.6017 91.9106 53.0281C91.8439 53.232 91.7752 53.4441 91.7044 53.6584L91.6523 53.8144C91.6378 53.8622 91.6107 53.933 91.6128 53.9496L91.5919 54.116C91.996 53.6542 92.3688 53.2465 92.6874 52.9283C92.7874 52.7952 92.9499 52.5996 93.2269 52.2835C93.7684 51.7156 94.2724 51.2123 94.8202 50.661C95.093 50.3844 95.3721 50.1036 95.6657 49.8062C95.8094 49.6585 95.9552 49.5066 96.1073 49.3506C96.251 49.2009 96.4009 49.0428 96.5405 48.8889L97.0716 48.5956C97.6422 48.0194 96.3593 48.9991 97.3132 48.0402C97.9901 47.36 97.6631 47.8946 97.9401 47.6991C98.24 47.3288 98.7648 46.6694 99.5292 46.2222C99.3188 46.424 99.1293 46.5488 98.9294 46.7298L98.9502 46.7069ZM104.469 42.9545C104.49 42.9379 104.511 42.9171 104.536 42.8963C104.549 42.8859 104.559 42.8755 104.571 42.8651C104.571 42.8609 104.578 42.8547 104.582 42.8505C104.592 42.8297 104.669 42.7548 104.715 42.707C104.821 42.605 104.909 42.5302 104.973 42.5135C104.944 42.6196 104.88 42.6903 104.788 42.761C104.746 42.7923 104.684 42.838 104.634 42.8692C104.613 42.8817 104.599 42.8879 104.58 42.8942C104.544 42.9129 104.507 42.9337 104.467 42.9566L104.469 42.9545ZM93.3185 53.5981C93.3872 53.4649 93.5455 53.3027 93.7434 53.1363C93.6288 53.2819 93.4893 53.4379 93.3185 53.5981ZM86.4997 59.0935C86.4997 59.0935 86.4934 59.106 86.4913 59.1143C86.2039 59.4492 86.3081 59.3327 86.4997 59.0935ZM87.0683 58.378C87.1099 58.2948 87.0953 58.2927 87.062 58.3156C87.0453 58.3822 86.9266 58.5486 86.785 58.7337C86.8454 58.6963 86.9266 58.611 87.0703 58.378H87.0683ZM84.6877 43.5411C84.6523 43.5806 84.619 43.6201 84.5857 43.6617C84.7398 43.3435 84.7169 43.4454 84.6877 43.5411Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M94.3682 52.1909C94.4186 52.1615 94.4439 52.1636 94.467 52.1657C94.5069 52.0964 94.4922 52.0817 94.3682 52.1909Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M92.7501 52.8662L92.7125 52.9057C92.677 52.9536 92.6498 52.991 92.6289 53.0222L92.7501 52.8662Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M81.1897 71.043C81.127 71.2115 81.0852 71.3051 81.0518 71.3654C81.0747 71.3799 81.1103 71.3051 81.1897 71.043Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.2766 54.3867L89.124 54.9463C89.2055 54.6779 89.2578 54.5885 89.3163 54.4595C89.2891 54.4637 89.2222 54.5594 89.2766 54.3867Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M91.4256 49.7878C91.4381 49.7046 91.4799 49.6152 91.4924 49.5361L91.4339 49.5611C91.3357 49.8752 91.2897 50.1414 91.4256 49.7878Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.7656 53.9813C89.8614 53.9646 89.9447 53.6089 90.0551 53.2158C90.0468 53.2387 90.0405 53.2616 90.0322 53.2845C89.9552 53.1326 89.8593 53.5569 89.7656 53.9813Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.082 53.1254C90.1176 53.0048 90.1531 52.8821 90.1949 52.7677C90.1635 52.7073 90.1385 52.9091 90.082 53.1254Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M87.7095 57.415C87.8428 57.2735 87.695 57.2507 87.7887 57.1841C87.8303 56.9449 87.1181 58.299 87.7095 57.415Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M90.1365 53.7539L89.9902 53.86L90.0028 54.1034L90.1365 53.7539Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M88.8507 56.633L89.2756 56.1421C89.261 56.14 89.2797 56.0984 89.3151 56.0422C89.3172 56.0298 89.3214 56.011 89.3256 55.9902L89.3089 56.0402C89.1902 56.1837 89.0694 56.3293 88.9798 56.4395C88.8882 56.5539 88.832 56.6309 88.8486 56.633H88.8507Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.3262 55.99C89.3868 55.8112 89.4495 55.6073 89.4683 55.4971C89.4369 55.6011 89.3596 55.8465 89.3262 55.99Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M89.8949 54.6094L89.8134 54.7841L89.665 55.2188L89.8949 54.6094Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M84.8024 62.3303L84.4504 62.9481C84.4442 63.0292 84.5629 62.8753 84.692 62.6444C84.7608 62.4863 84.8899 62.2575 84.8024 62.3303Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M86.2219 60.6992C86.0965 60.8448 86.0694 60.8427 85.9795 60.9135L86.0777 61.005L86.2219 60.7013V60.6992Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M85.1145 62.4384C85.1041 62.5175 84.6584 63.3599 85.127 62.6007C85.1354 62.5216 85.4915 61.908 85.1145 62.4384Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M80.6061 72.0086L80.6353 71.8318L80.418 71.8193L80.6061 72.0086Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M85.0602 70.7586C84.677 71.4825 85.1019 70.9916 84.7228 71.6364C84.6832 71.834 85.0373 71.1081 84.9915 71.3057C85.1623 70.8335 85.2768 70.6047 85.0623 70.7565L85.0602 70.7586Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M84.9897 71.3076C84.9625 71.3825 84.9354 71.4636 84.9082 71.551C84.9604 71.4137 84.9793 71.3492 84.9897 71.3076Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M79.7412 41.6377L79.2393 41.8478L79.5829 41.75L79.7412 41.6377Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M78.8934 42.2597L78.7164 42.1973L78.4873 42.4573C78.5935 42.3949 78.7976 42.2742 78.8955 42.2597H78.8934Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M103.083 43.6677L103.07 43.7197C103.16 43.6948 103.26 43.6178 103.466 43.4639L103.083 43.6698V43.6677Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M102.403 44.3145L102.508 44.25L102.245 44.2708L102.403 44.3145Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M97.73 48.1236C97.9174 47.9613 98.1153 47.745 98.3027 47.5869C97.9174 47.9572 97.5738 48.0549 97.73 48.1236Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M104.082 41.948C105.267 41.2242 106.387 40.6064 107.674 39.9762C108.96 39.3459 109.959 38.8509 111.244 38.2456C111.553 38.0812 112.286 37.7755 112.958 37.3678C113.614 36.9705 114.635 36.4588 115.381 36.2695C116.126 36.0802 116.959 35.7391 117.555 35.5935C118.149 35.45 118.609 35.606 118.934 36.0657C119.204 36.4755 119.098 36.7417 118.925 37.1369C118.753 37.53 118.49 37.9273 118.136 38.3267C117.782 38.7261 117.401 39.1005 116.993 39.4478C116.584 39.7973 116.095 40.3485 115.893 40.5607C115.133 41.3594 114.585 42.0604 114.035 43.0546C113.462 44.0926 112.992 45.0057 113.019 46.0436C113.408 46.3993 115.291 46.1768 116.32 45.6838C117.347 45.1888 118.248 44.7769 119.021 44.4441C121.489 43.2377 123.78 41.8399 126.19 40.3215C127.521 39.4562 128.683 38.335 129.585 37.3532C130.045 37.0287 130.524 37.0163 131.028 37.3158C131.53 37.6153 131.736 38.0771 131.649 38.7032C131.555 39.1733 131.347 39.635 131.02 40.0843C130.693 40.5357 130.405 40.9975 130.157 41.4717C129.908 41.894 129.674 42.4722 129.46 43.2044C129.243 43.9386 129.247 44.5876 129.47 45.1534C130.049 45.4508 130.664 45.8128 131.49 45.5569C132.315 45.3011 132.969 45.1035 133.486 44.935C135.702 44.0988 137.868 42.8071 139.769 41.7712C140.127 41.6069 140.579 41.374 141.119 41.0744C141.658 40.7749 142.062 40.8831 142.337 41.3948C142.608 41.8565 142.475 41.9834 142.141 42.2268C141.808 42.4701 141.402 42.649 141.042 42.8133L136.114 45.4862C135.033 45.9812 133.856 46.6697 132.571 47.2979C131.286 47.9282 129.989 48.105 128.681 47.8262C127.737 47.5912 127.19 47.0733 127.04 46.2704C126.89 45.4696 126.933 44.702 127.177 43.9657L128.283 41.0016C127.035 42.0125 126.167 42.545 124.888 43.3313C123.659 44.0884 122.593 44.8455 121.243 45.5777C120.679 45.9043 119.815 46.3536 118.923 46.7696C118.111 47.1482 117.27 47.5454 116.422 47.9573C115.574 48.3691 114.677 48.5002 113.852 48.7019C113.023 48.9037 111.996 48.7456 111.365 48.5023C110.736 48.3109 110.401 47.9157 110.359 47.3187C110.317 46.7238 110.445 46.0291 110.736 45.2428C111.028 44.4566 111.448 43.6142 111.998 42.7156C112.548 41.8191 114.133 39.6766 114.737 38.8301C114.737 38.8301 112.713 39.633 111.503 40.259C110.201 40.933 107.983 42.0708 107.056 42.5097C106.131 42.9506 105.671 43.6308 105.154 43.7473C104.844 43.8596 104.596 43.8388 104.411 43.689C104.226 43.5372 104.09 43.3604 104.007 43.1545C103.924 42.9485 103.919 42.7405 103.99 42.5305C104.063 42.3225 103.855 42.1768 104.082 41.9501V41.948Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M104.082 41.948C105.267 41.2242 106.387 40.6064 107.674 39.9762C108.96 39.3459 109.959 38.8509 111.244 38.2456C111.553 38.0812 112.286 37.7755 112.958 37.3678C113.614 36.9705 114.635 36.4588 115.381 36.2695C116.126 36.0802 116.959 35.7391 117.555 35.5935C118.149 35.45 118.609 35.606 118.934 36.0657C119.204 36.4755 119.098 36.7417 118.925 37.1369C118.753 37.53 118.49 37.9273 118.136 38.3267C117.782 38.7261 117.401 39.1005 116.993 39.4478C116.584 39.7973 116.095 40.3485 115.893 40.5607C115.133 41.3594 114.585 42.0604 114.035 43.0546C113.462 44.0926 112.992 45.0057 113.019 46.0436C113.408 46.3993 115.291 46.1768 116.32 45.6838C117.347 45.1888 118.248 44.7769 119.021 44.4441C121.489 43.2377 123.78 41.8399 126.19 40.3215C127.521 39.4562 128.683 38.335 129.585 37.3532C130.045 37.0287 130.524 37.0163 131.028 37.3158C131.53 37.6153 131.736 38.0771 131.649 38.7032C131.555 39.1733 131.347 39.635 131.02 40.0843C130.693 40.5357 130.405 40.9975 130.157 41.4717C129.908 41.894 129.674 42.4722 129.46 43.2044C129.243 43.9386 129.247 44.5876 129.47 45.1534C130.049 45.4508 130.664 45.8128 131.49 45.5569C132.315 45.3011 132.969 45.1035 133.486 44.935C135.702 44.0988 137.868 42.8071 139.769 41.7712C140.127 41.6069 140.579 41.374 141.119 41.0744C141.658 40.7749 142.062 40.8831 142.337 41.3948C142.608 41.8565 142.475 41.9834 142.141 42.2268C141.808 42.4701 141.402 42.649 141.042 42.8133L136.114 45.4862C135.033 45.9812 133.856 46.6697 132.571 47.2979C131.286 47.9282 129.989 48.105 128.681 47.8262C127.737 47.5912 127.19 47.0733 127.04 46.2704C126.89 45.4696 126.933 44.702 127.177 43.9657L128.283 41.0016C127.035 42.0125 126.167 42.545 124.888 43.3313C123.659 44.0884 122.593 44.8455 121.243 45.5777C120.679 45.9043 119.815 46.3536 118.923 46.7696C118.111 47.1482 117.27 47.5454 116.422 47.9573C115.574 48.3691 114.677 48.5002 113.852 48.7019C113.023 48.9037 111.996 48.7456 111.365 48.5023C110.736 48.3109 110.401 47.9157 110.359 47.3187C110.317 46.7238 110.445 46.0291 110.736 45.2428C111.028 44.4566 111.448 43.6142 111.998 42.7156C112.548 41.8191 114.133 39.6766 114.737 38.8301C114.737 38.8301 112.713 39.633 111.503 40.259C110.201 40.933 107.983 42.0708 107.056 42.5097C106.131 42.9506 105.671 43.6308 105.154 43.7473C104.844 43.8596 104.596 43.8388 104.411 43.689C104.226 43.5372 104.09 43.3604 104.007 43.1545C103.924 42.9485 103.919 42.7405 103.99 42.5305C104.063 42.3225 103.855 42.1768 104.082 41.9501V41.948Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M103.51 41.8964C103.568 41.7591 103.614 41.703 103.639 41.6572C103.662 41.6177 103.671 41.5948 103.669 41.5782C103.669 41.5449 103.633 41.5428 103.65 41.5137C103.528 41.6364 103.453 41.7945 103.434 41.8902C103.414 41.9858 103.428 42.0191 103.439 42.015C103.462 42.0066 103.52 41.8881 103.508 41.8964H103.51Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M106.078 43.5533L106.053 43.6199L106.384 43.2393L106.078 43.5533Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M108.764 41.998C108.429 41.998 107.744 42.543 107.213 42.751L107.117 42.7614C107.063 42.8321 107.013 42.9049 106.967 42.9798C107.033 42.9382 107.102 42.8966 107.175 42.8571C107.254 42.8134 107.333 42.7677 107.415 42.7198C107.579 42.6262 107.746 42.5305 107.908 42.4369C108.233 42.2539 108.537 42.0875 108.764 41.998Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.431 41.5213C110.31 41.5171 110.737 41.3091 110.068 41.6835C110.106 41.6711 110.116 41.6711 110.139 41.6648C110.2 41.6336 110.285 41.5899 110.431 41.5213Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.139 41.665C109.841 41.821 110.359 41.6088 110.139 41.665V41.665Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.511 40.933L111.139 41.1806C111.237 41.1702 111.593 40.9975 111.474 41.087C111.868 40.8561 111.768 40.8665 111.511 40.933Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.833 40.6455L111.641 40.7662C111.682 40.762 111.741 40.737 111.833 40.6455Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.228 41.0306L111.642 40.7686C111.573 40.7769 111.544 40.7353 111.45 40.885C111.465 40.8268 111.398 40.91 111.23 41.0306H111.228Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.972 41.1351C110.734 41.2183 110.438 41.3452 110.811 41.0977C110.064 41.4991 110.224 41.5386 110.972 41.1351Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M108.841 41.7832L108.526 41.8934L108.293 42.0682C108.41 41.9808 108.882 41.8165 108.843 41.7832H108.841Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.569 40.5061C112.632 40.4437 112.684 40.3605 112.732 40.2939L112.594 40.3938C112.613 40.4104 112.651 40.4167 112.569 40.5061Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.731 40.2946C112.806 40.2426 112.892 40.1843 112.988 40.124C112.842 40.1781 112.773 40.2363 112.731 40.2946Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.825 40.4602L111.165 40.9262L111.961 40.3916L111.825 40.4602Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.649 40.5504C112.598 40.5774 112.542 40.6128 112.481 40.6523C112.571 40.592 112.649 40.5504 112.711 40.5254C112.693 40.5316 112.67 40.5379 112.647 40.5504H112.649Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.553 40.7042C112.517 40.7022 112.467 40.725 112.432 40.7354C112.394 40.7479 112.367 40.75 112.34 40.7562C112.357 40.7521 112.417 40.7562 112.428 40.827C112.436 40.7708 112.438 40.777 112.553 40.7063V40.7042Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.234 41.2196C112.301 41.0989 112.364 40.9658 112.431 40.8223C112.358 40.9491 112.291 41.0802 112.234 41.2196Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M113.209 40.0635C113.209 40.0635 113.194 40.076 113.184 40.0864C113.109 40.1508 112.971 40.2694 112.886 40.3547L113.163 40.1238L113.204 40.0697L113.209 40.0635Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M113.173 40.1152L113.163 40.1236C113.113 40.1901 113.077 40.2359 113.062 40.2546C113.077 40.238 113.111 40.1943 113.173 40.1152Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M113.22 40.0492C113.22 40.0492 113.211 40.0597 113.207 40.0638C113.236 40.0388 113.249 40.0262 113.22 40.0492Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.59 40.1905C112.669 40.1261 112.805 40.0387 112.9 39.9638C112.994 39.891 113.055 39.8265 112.9 39.8494C112.805 39.9264 112.805 39.9555 112.78 39.9971C112.759 40.0387 112.711 40.0928 112.586 40.1885L112.59 40.1905Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M113.442 39.8242L113.242 39.8825C113.201 39.9282 113.161 39.9823 113.053 40.0572C113.169 39.9844 113.298 39.9074 113.442 39.8242Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M113.63 39.7228C113.63 39.7228 113.61 39.7311 113.595 39.7394L113.543 39.7685L113.442 39.8247L113.511 39.806L113.63 39.7207V39.7228Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.644 40.7898C112.644 40.8231 112.632 40.8605 112.611 40.9022L112.594 40.9333C112.578 40.9604 112.559 40.9874 112.54 41.0145C112.503 41.0686 112.465 41.1247 112.428 41.183C112.661 40.8834 112.684 40.8689 112.767 40.7503C112.744 40.7337 112.701 40.7087 112.644 40.7919V40.7898Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.9 40.4735C112.9 40.4735 112.9 40.482 112.9 40.4842C112.922 40.4671 112.932 40.4564 112.9 40.4735Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.949 43.5453C110.962 43.5349 110.972 43.5244 110.985 43.5118C110.981 43.5056 110.978 43.5014 110.976 43.4951L110.949 43.5453Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.801 40.7311C112.883 40.6479 112.889 40.6021 112.872 40.5771C112.847 40.625 112.814 40.6853 112.768 40.7498C112.778 40.756 112.788 40.7581 112.801 40.7311Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.832 41.8814C111.913 41.792 112.003 41.6921 112.094 41.584C112.005 41.663 111.836 41.8315 111.832 41.8814Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.838 40.5279C112.838 40.5279 112.838 40.5258 112.838 40.5215C112.787 40.5578 112.806 40.5471 112.838 40.5279Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.838 40.527C112.838 40.5457 112.859 40.5582 112.869 40.5769C112.89 40.5374 112.901 40.5041 112.899 40.4854C112.88 40.4999 112.857 40.5166 112.836 40.529L112.838 40.527Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.105 44.5498C111.042 44.4812 111.219 43.9092 111.544 43.5098C111.732 43.046 111.332 43.1853 110.984 43.5098C111.011 43.541 111.034 43.5556 110.846 44.0485C110.961 43.8967 111.477 43.0709 111.336 43.4932C111.055 44.1214 111.053 43.9799 110.865 44.2628C110.973 44.1546 110.913 44.371 110.859 44.6039C110.805 44.8369 110.761 45.0886 110.859 45.047C110.915 44.8577 110.976 44.6663 111.04 44.4791C111.067 44.4791 111.013 44.6913 111.101 44.5498H111.105Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.482 42.6424L111.587 42.4531C111.445 42.657 111.326 42.7901 111.108 43.0418C110.966 43.3787 110.962 43.4619 110.974 43.4952C111.145 43.1811 111.322 42.8733 111.51 42.5717L111.482 42.6403V42.6424Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.121 41.6404C112.1 41.8276 111.848 42.2768 112.105 42.0709C112.45 41.5509 112.288 41.6674 112.469 41.3387C111.913 42.177 112.592 41.0725 112.134 41.6404C112.234 41.4677 112.332 41.32 112.425 41.1807C112.311 41.3221 112.2 41.4573 112.092 41.5842C112.098 41.578 112.105 41.5738 112.111 41.5676V41.5634H112.113C112.146 41.5343 112.161 41.526 112.127 41.5634C112.127 41.5676 112.119 41.578 112.117 41.5821C112.123 41.5946 112.121 41.6175 112.119 41.6404C111.938 41.8712 112.073 41.6653 112.117 41.5821C112.117 41.5759 112.117 41.5676 112.113 41.5634H112.111C111.932 41.8546 111.757 42.1416 111.586 42.4495C111.715 42.2644 111.861 42.0356 112.121 41.6383V41.6404Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M113.561 39.3477C113.576 39.3498 113.565 39.3624 113.557 39.375C113.63 39.3309 113.666 39.3078 113.561 39.3477Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M113.814 39.3047C113.727 39.3546 113.612 39.444 113.446 39.5044C113.325 39.5231 113.512 39.4253 113.556 39.3754C113.475 39.4232 113.346 39.496 113.281 39.546C113.214 39.5959 113.212 39.6209 113.344 39.5897L113.416 39.546C113.543 39.5085 113.641 39.5106 113.675 39.5356C113.71 39.5605 113.689 39.6063 113.654 39.6271C113.791 39.4752 113.87 39.3754 113.816 39.3047H113.814Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M113.359 40.2882L113.084 40.7438C113.178 40.6585 113.278 40.5628 113.388 40.4567L113.305 40.49C113.551 40.1801 113.403 40.2882 113.359 40.2862V40.2882Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.861 43.6124L110.828 43.4668C110.79 43.6353 110.757 43.8058 110.726 43.9743L110.861 43.6124Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.397 44.6352L110.336 44.5645L110.27 44.8619L110.397 44.6352Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M129.163 45.5587L129.067 45.5171C129.023 45.4339 128.988 45.3424 128.948 45.2529C129 45.3819 129.038 45.4776 129.065 45.5171C129.115 45.54 129.138 45.5504 129.161 45.5587H129.163Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M131.305 46.1207L131.352 46.0703C131.255 46.1123 131.213 46.1354 131.305 46.1207Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M126.609 44.0264C126.422 44.3862 126.251 44.8355 126.353 44.796C126.388 44.7585 126.424 44.7211 126.459 44.6837C126.482 44.4049 126.54 44.1949 126.609 44.0264Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M141.126 42.751C141.09 42.7572 141.055 42.7635 141.018 42.7697C140.955 42.8383 140.897 42.9049 140.845 42.9631C140.928 42.8987 141.02 42.8175 141.126 42.751Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M141.19 42.302C141.336 42.2541 141.478 42.2063 141.615 42.1543C141.52 42.1834 141.386 42.2313 141.19 42.302Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M130.229 37.709C130.192 37.7485 130.158 37.7922 130.129 37.8379C130.225 37.8005 130.242 37.7901 130.244 37.7714C130.244 37.7527 130.225 37.7319 130.227 37.709H130.229Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M118.137 47.6996C118.43 47.5998 118.657 47.5103 118.853 47.4209C118.497 47.5311 118.193 47.5873 118.137 47.6996Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M130.342 45.0453C130.216 45.0141 130.154 45.0037 130.149 45.0245C130.283 45.0682 130.358 45.0744 130.342 45.0453Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M119.661 47.0361C119.609 47.0528 119.557 47.0715 119.502 47.0881C119.303 47.2005 119.098 47.3086 118.851 47.4209C119.111 47.3398 119.413 47.2275 119.661 47.0361Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M116.061 36.6191C116.034 36.6233 116.002 36.6317 115.979 36.6338C115.975 36.6485 116.01 36.638 116.061 36.6191Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M106.483 40.1255C106.571 40.0735 106.719 39.9965 106.856 39.9258C106.785 39.9549 106.671 40.0131 106.483 40.1255Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.304 49.091C111.045 49.0049 111.26 49.0868 111.304 49.091V49.091Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.389 48.0801C110.429 48.1242 110.469 48.1473 110.49 48.141C110.46 48.1368 110.422 48.1179 110.389 48.0801Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M121.436 45.4567C121.436 45.4567 121.446 45.4505 121.452 45.4463C121.383 45.463 121.396 45.4609 121.436 45.4567Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.957 48.9201C111.005 48.945 111.059 48.9741 111.117 48.997L111.161 49.0157L111.184 49.0241C111.184 49.0241 111.184 49.0241 111.18 49.0241C111.172 49.022 111.172 49.022 111.18 49.0241L111.19 49.0282L111.211 49.0365L111.255 49.0553C111.242 49.049 111.228 49.0407 111.209 49.0324C111.201 49.0282 111.19 49.0241 111.178 49.0178C111.172 49.0157 111.182 49.0178 111.184 49.0178H111.186C111.186 49.0178 111.186 49.0178 111.178 49.0137C111.122 48.9908 111.051 48.9616 110.959 48.918L110.957 48.9201Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.997 48.9849C110.903 48.9454 110.828 48.9058 110.759 48.8663C110.717 48.858 110.745 48.8975 110.997 48.9849Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.655 49.1907C111.511 49.1554 111.38 49.1117 111.251 49.0576C111.299 49.0826 111.318 49.093 111.303 49.0909C111.378 49.1138 111.482 49.1471 111.653 49.1887L111.655 49.1907Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M116.494 45.9102C116.479 45.9143 116.463 45.9185 116.446 45.9226C116.231 46.0578 116.335 46.0079 116.494 45.9102Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M130.106 47.5206C130.106 47.5206 130.091 47.5248 130.081 47.5248C130.091 47.5248 130.104 47.5248 130.112 47.5269L130.104 47.5186L130.106 47.5206Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M130.85 47.3643C130.554 47.5348 130.358 47.5369 130.112 47.5286C130.2 47.6118 130.291 47.6929 130.389 47.7761C130.554 47.6451 130.708 47.5099 130.85 47.3663V47.3643Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M129.843 40.9433L129.669 41.1804C129.614 41.2491 129.546 41.3427 129.483 41.4321C129.698 40.7332 130.035 40.2777 129.635 40.727C129.66 40.754 129.662 40.8081 129.646 40.8809C129.631 40.9516 129.591 41.0556 129.56 41.1367C129.51 41.2449 129.452 41.3676 129.389 41.4987C129.327 41.6339 129.267 41.7774 129.21 41.9188C128.983 42.4888 128.838 43.0483 128.962 43.1377C128.904 43.2688 128.854 43.404 128.806 43.5433C128.833 43.4206 128.819 43.3977 128.85 43.2792C128.688 43.6765 128.731 43.8595 128.783 44.0529C128.81 44.1507 128.844 44.2547 128.875 44.4003C128.892 44.4731 128.908 44.5584 128.927 44.6582C128.938 44.7082 128.948 44.7622 128.96 44.8205C128.973 44.8912 128.996 44.9765 129.017 45.0618C129.056 45.2157 129.098 45.3592 129.133 45.4632C129.331 45.5901 129.402 45.6567 129.165 45.5589L129.439 45.6816L129.571 45.7378C129.614 45.7565 129.637 45.7627 129.671 45.7773C129.796 45.8251 129.927 45.8709 130.064 45.9083C130.302 45.9936 130.225 46.0269 129.989 45.9333C130.393 46.0893 130.899 46.1642 131.362 46.0602L131.353 46.0706C131.445 46.0352 131.612 45.9562 131.72 45.8938C131.841 45.8293 131.966 45.7648 132.047 45.7232C132.337 45.6754 131.918 45.796 131.999 45.8085L132.58 45.5547C132.849 45.5485 132.372 45.7731 131.951 45.8938C132.605 45.9895 132.428 45.6712 133.703 45.4445L133.143 45.6608C133.355 45.6775 133.563 45.6483 133.813 45.5755C133.94 45.536 134.074 45.4923 134.221 45.4445C134.363 45.3987 134.517 45.353 134.686 45.3072C134.521 45.328 133.286 45.5922 133.93 45.2635C134.128 45.2095 134.367 45.1242 134.688 44.9203C134.732 45.0139 135.059 44.8434 135.469 44.6437L135.498 44.7789C135.929 44.5314 135.86 44.4835 136.094 44.3005C136.589 44.0675 136.737 44.105 136.891 44.1237C137.679 43.7347 136.279 44.2568 137.183 43.7513C137.849 43.456 138.268 43.1585 138.98 42.6697C139.443 42.4659 138.943 42.7841 139.12 42.73L139.457 42.4201C139.553 42.3702 139.539 42.416 139.532 42.4388C139.838 42.2225 139.489 42.3057 139.986 41.9958C140.024 41.8918 140.32 41.8003 140.682 41.6713C140.863 41.6068 141.059 41.534 141.246 41.4467C141.44 41.3531 141.494 41.3198 141.605 41.2657C141.698 41.3011 141.557 41.3531 141.59 41.4051C141.694 41.3635 141.786 41.3926 141.844 41.4238C141.873 41.4404 141.898 41.4591 141.921 41.4779C141.942 41.4966 141.961 41.5132 141.986 41.5465C142.013 41.5798 142.038 41.611 142.065 41.6443C142.086 41.6713 142.109 41.7025 142.134 41.7358C142.154 41.7628 142.169 41.7878 142.182 41.7919C142.196 41.7919 142.217 41.8044 142.182 41.871C142.115 41.9147 142.007 41.9771 141.915 42.0228C141.819 42.0707 141.719 42.1123 141.617 42.1518C141.848 42.0769 141.852 42.1372 141.738 42.2704C141.623 42.4014 141.371 42.5865 141.128 42.7508C141.315 42.7196 141.476 42.6905 141.58 42.6614C141.446 42.7404 141.309 42.8174 141.176 42.8923C141.049 42.963 140.917 43.0566 140.788 43.1377C140.68 43.171 140.74 43.0857 140.849 42.963C140.799 43.0046 140.751 43.0421 140.715 43.0733C140.403 43.1856 140.517 43.0337 140.692 42.8548C140.803 42.8257 140.915 42.7987 141.021 42.7716C141.198 42.599 141.346 42.4284 141.271 42.3764C141.226 42.416 141.128 42.4763 141.015 42.5345C141.061 42.4888 141.086 42.4555 141.055 42.4555C141.036 42.4555 141.013 42.4721 140.969 42.5012C140.921 42.5324 140.876 42.5761 140.817 42.6281L140.565 42.5928L140.547 42.6697L139.443 43.1606C138.751 43.7077 138.191 44.2672 137.014 44.9765C137.264 44.7144 136.998 44.7789 136.956 44.6541C137.348 44.6 137.864 44.0946 138.501 43.7805C138.168 43.9448 138.212 43.8491 138.285 43.7846L137.227 44.5022C137.204 44.392 136.954 44.5584 136.644 44.677C136.802 44.7123 136.61 44.8558 136.325 45.0306C136.044 45.2136 135.661 45.38 135.438 45.5298C135.406 45.5048 135.413 45.4632 135.496 45.3925C135.581 45.3197 135.752 45.2303 136.027 45.1013C135.694 45.1803 135.504 45.3322 135.336 45.4923C135.163 45.6525 134.998 45.8127 134.663 45.9125C134.798 45.8397 134.877 45.8106 134.915 45.7503C134.623 45.9728 133.826 46.3389 133.978 46.1871L134.113 46.1143C133.657 46.341 132.974 46.705 132.393 47.0149C131.83 47.3207 131.326 47.4996 131.276 47.6057C131.262 47.5869 131.345 47.3623 131.389 47.3103C130.904 47.6639 130.337 47.953 129.704 48.134C129.789 48.057 129.675 47.926 129.654 47.8012C129.631 47.6743 129.696 47.5745 130.085 47.5225C129.858 47.5079 129.587 47.4892 129.11 47.4746C129.256 47.5225 129.473 47.7409 129.254 47.7346C128.965 47.6119 128.875 47.5641 128.765 47.5245C128.667 47.4746 128.529 47.4351 128.267 47.2313C128.352 47.2895 128.323 47.3519 128.225 47.3769C128.127 47.4039 127.959 47.381 127.815 47.2687C127.879 47.2708 127.938 47.0628 128.046 47.1085C127.79 47.0295 127.54 46.8839 127.348 46.6468C127.484 46.8236 127.534 46.5844 127.544 46.4117C127.534 46.4512 127.482 46.314 127.448 46.081C127.411 45.848 127.4 45.5735 127.388 45.457C127.371 45.5818 127.363 45.7107 127.359 45.8397C127.325 45.3322 127.271 45.0847 127.213 44.8163C127.186 44.6832 127.165 44.5459 127.169 44.3774C127.176 44.2048 127.205 44.0155 127.317 43.743C127.317 43.8075 127.361 43.9115 127.434 43.9261C127.507 43.9406 127.617 43.847 127.771 43.4768C127.767 43.3166 127.73 42.9942 127.661 42.7654C127.627 42.6489 127.588 42.5532 127.557 42.468C127.525 42.3827 127.503 42.312 127.517 42.208L127.696 41.9251L127.709 41.8044C127.709 41.7878 127.715 41.7607 127.709 41.7566L127.607 41.8543L127.482 41.975C127.525 41.9251 127.573 41.8689 127.661 41.7815C127.7 41.7358 127.744 41.6879 127.792 41.6359C127.813 41.6131 127.846 41.5756 127.861 41.5631L127.888 41.5486C127.923 41.5319 127.959 41.5257 127.99 41.5299C128.052 41.5361 128.102 41.5923 128.129 41.6963C128.188 41.9001 128.154 42.3348 128.079 42.73C128.363 42.131 128.25 42.5075 128.565 41.6484C128.675 41.4487 128.671 41.5299 128.623 41.7087C128.575 41.8855 128.486 42.1539 128.436 42.2912L129.327 40.0239C129.24 40.1446 129.229 40.0842 129.25 39.9594C129.26 39.897 129.279 39.818 129.3 39.7348L129.317 39.6703L129.325 39.6391L129.321 39.6245C129.314 39.6079 129.306 39.5913 129.296 39.5767C128.921 39.9137 128.602 40.2028 128.542 40.3172L129.133 39.7951C129.148 39.8076 129.16 39.8201 129.173 39.8367L129.129 39.9948L129.035 40.3234L128.831 41.0265C128.727 41.1534 128.673 41.1035 128.652 40.9745C128.642 40.91 128.64 40.8247 128.648 40.7249C128.652 40.675 128.658 40.6188 128.669 40.5606L128.677 40.5148C128.677 40.5023 128.692 40.4711 128.669 40.4919C128.638 40.5106 128.608 40.5314 128.577 40.5502C128.284 40.8185 128.015 41.0473 127.765 41.2303C127.68 41.2595 127.798 41.0847 127.979 40.8642C128.156 40.6458 128.398 40.3775 128.423 40.3255C128.294 40.4607 127.942 40.7665 127.63 41.0265C127.315 41.2886 127.034 41.5007 126.982 41.5174L127.59 40.9599C127.217 41.2199 126.88 41.5278 126.578 41.7836C126.286 42.0332 125.93 42.2932 125.653 42.3868C125.451 42.5033 124.964 42.6011 124.974 42.6926C125.384 42.6302 125.716 43.0171 125.561 43.2563C125.482 43.2917 124.428 43.7701 124.162 43.8533C123.766 43.9552 124.489 43.2833 124.151 43.3686C124.16 43.4081 124.004 43.5641 123.937 43.6265C123.71 43.7326 123.958 43.4705 123.514 43.7763C123.516 43.9469 122.589 44.3546 123.366 44.0155C122.948 44.3338 122.881 44.2922 122.364 44.6208C122.581 44.5979 122.062 45.1845 121.619 45.4778C121.627 45.4299 121.502 45.4466 121.44 45.4549C120.494 45.9728 119.951 46.1767 119.047 46.6093C118.949 46.6156 118.493 46.7861 118.653 46.6405C118.532 46.7258 118.434 46.8277 118.155 46.9629C117.56 47.1085 118.772 46.6488 118.295 46.7092C118.295 46.8028 117.62 47.1585 117.243 47.3956C117.422 47.4538 118.176 46.9796 118.553 46.7424C118.63 46.9026 118.016 47.4018 117.103 47.926C116.37 48.3233 116.726 47.978 116.608 48.0612C116.247 48.2297 115.977 48.3441 115.773 48.4377C115.566 48.5313 115.419 48.6103 115.277 48.679C114.996 48.8204 114.733 48.9286 114.094 49.0076C113.555 49.0139 114.025 48.7913 113.89 48.7393C114.54 48.5417 114.925 48.5895 115.375 48.4606C115.185 48.4938 114.996 48.5209 114.808 48.5458C115.012 48.4626 115.444 48.3233 115.689 48.2754C115.579 48.2838 115.364 48.3358 115.083 48.3961C114.802 48.4564 114.454 48.5313 114.084 48.6103C113.352 48.8287 112.478 48.758 111.913 48.5708C111.699 48.5646 111.336 48.4772 111.486 48.577C111.611 48.6124 111.734 48.6436 111.861 48.6686C112.024 48.7538 111.84 48.7476 111.67 48.7247C111.501 48.7039 111.347 48.6706 111.582 48.7684C111.516 48.7559 111.447 48.7455 111.378 48.7289L111.326 48.7164L111.299 48.7102C111.299 48.7102 111.293 48.7102 111.286 48.7102L111.176 48.6873C111.026 48.6498 110.868 48.5958 110.71 48.5042C110.553 48.4127 110.399 48.2775 110.285 48.1007C110.166 47.926 110.097 47.7117 110.076 47.4954C110.11 47.4351 110.149 47.3789 110.187 47.3269C110.17 47.3373 110.156 47.4705 110.187 47.6327C110.214 47.7949 110.301 47.9801 110.389 48.0695C110.255 47.9385 110.17 47.5953 110.193 47.2937C110.203 46.9962 110.247 46.7092 110.187 46.5282C110.133 46.6988 110.089 46.8756 110.058 47.0586C109.991 46.5032 110.008 45.7815 110.278 45.1575C110.058 45.4091 110.235 45.301 109.956 45.7315C110.106 45.5506 109.972 45.9707 109.908 46.3868C109.841 46.8028 109.849 47.2042 109.956 46.8506C109.858 47.1085 109.835 47.3269 109.876 47.6348C109.926 47.9301 110.049 48.2838 110.349 48.6498C110.351 48.6249 110.308 48.5542 110.333 48.5604C110.36 48.5604 110.445 48.6727 110.764 48.8599C110.799 48.8662 110.874 48.8828 110.922 48.8953C110.941 48.9057 110.947 48.9078 110.964 48.9161C110.951 48.9098 110.943 48.9036 110.93 48.8974C110.959 48.9036 110.964 48.9036 110.918 48.889C110.774 48.8058 110.666 48.7081 110.635 48.6582C110.722 48.6894 110.847 48.7393 110.989 48.7871C111.059 48.8079 111.136 48.8329 111.214 48.8516L111.243 48.8578C111.243 48.8578 111.236 48.8537 111.245 48.8578L111.301 48.8745L111.413 48.9057C111.713 48.9868 112.015 49.0326 112.172 49.0326C112.505 49.1033 112.022 49.0596 112.199 49.1324C112.357 49.1324 112.513 49.122 112.667 49.1095C112.696 49.2177 113.598 49.2863 112.759 49.3279C113.011 49.3425 113.265 49.3383 113.525 49.3113C113.642 49.3113 113.769 49.3051 113.904 49.2843C113.965 49.2739 114.025 49.2655 114.086 49.2551L114.25 49.2239C114.469 49.1803 114.685 49.1303 114.85 49.0721C115.173 49.0243 115.639 48.7663 115.375 48.914C115.729 48.8017 116.089 48.6665 116.437 48.4938L116.456 48.5105C116.522 48.4834 116.587 48.4502 116.654 48.421L116.831 48.3337C116.947 48.2734 117.066 48.211 117.187 48.1486C117.424 48.0217 117.666 47.8948 117.912 47.7637C118.409 47.5058 118.918 47.2645 119.507 47.0815C119.819 46.9047 120.136 46.7175 120.68 46.4637L120.821 46.4824C121.015 46.3639 121.342 46.2079 121.606 46.0727C121.879 45.9395 122.133 45.7981 122.196 45.7128C122.466 45.6837 122.958 45.4029 123.452 45.0743C123.947 44.7456 124.449 44.3774 124.793 44.1861L124.76 44.08C125.218 43.7971 125.655 43.5017 126.213 43.0961L126.126 43.0379C126.184 42.99 126.247 42.9422 126.315 42.8944C126.338 42.8798 126.359 42.8632 126.384 42.8465C126.403 42.834 126.424 42.8216 126.444 42.807C126.528 42.7571 126.615 42.7092 126.696 42.6676C126.865 42.5803 126.988 42.5324 127.148 42.4014C127.067 42.5054 127.015 42.5345 126.984 42.5324C127.013 42.5699 127.048 42.5616 127.121 42.5012L127.144 42.4825L127.157 42.4721C127.157 42.4721 127.165 42.4638 127.163 42.4721L127.151 42.5241C127.144 42.5574 127.14 42.5865 127.136 42.6177C127.13 42.678 127.128 42.7404 127.115 42.8216C127.092 42.9755 127.021 43.2126 126.878 43.4269C126.874 43.535 126.824 43.639 126.767 43.7181C126.771 43.7077 126.774 43.6973 126.774 43.6869C126.767 43.6993 126.761 43.716 126.755 43.7347L126.728 43.7701C126.719 43.7805 126.711 43.7888 126.694 43.8283C126.665 43.8907 126.636 43.9552 126.611 44.0197C126.638 43.9656 126.665 43.9115 126.69 43.8595C126.703 43.8366 126.717 43.7992 126.724 43.7909C126.73 43.7805 126.736 43.7701 126.744 43.7617C126.74 43.7742 126.736 43.7846 126.732 43.7992C126.724 43.8283 126.713 43.8595 126.705 43.8928C126.684 43.9614 126.669 44.028 126.653 44.0987C126.622 44.2422 126.594 44.4003 126.582 44.5584C126.54 44.5979 126.501 44.6374 126.461 44.677C126.459 44.704 126.455 44.7248 126.455 44.7518C126.386 45.0639 126.48 45.0056 126.569 44.8496C126.569 45.0077 126.584 45.1533 126.607 45.2635C126.522 45.3863 126.538 45.5943 126.569 45.8064C126.603 46.0248 126.642 46.2287 126.597 46.4284C126.659 46.5303 126.788 46.9671 127.088 47.2957C127.38 47.6327 127.771 47.797 127.882 47.7554C127.882 47.7804 127.957 47.8365 127.805 47.7554C128.102 47.9509 128.44 48.0841 128.754 48.0903L128.873 48.2442C129.127 48.2255 129.377 48.1964 129.623 48.1486C129.841 48.1964 130 48.2255 130.048 48.2567C130.095 48.2879 130.033 48.3316 129.806 48.3794C130.354 48.3066 130.564 48.2484 130.76 48.2089C130.952 48.1631 131.131 48.1236 131.543 47.9301L131.524 48.0238C131.843 47.9364 132.276 47.6431 132.478 47.6244C132.843 47.5474 133.609 47.1605 134.488 46.6967C134.927 46.4658 135.394 46.2224 135.854 46.0082C136.331 45.8064 136.779 45.5651 137.185 45.3904C136.771 45.3343 137.96 45.0951 137.937 44.8912C138.054 44.8933 138.287 44.8059 138.056 44.989C138.826 44.5064 139.295 44.4232 139.772 43.9802C139.888 43.9822 139.641 44.1486 139.736 44.1362C139.795 44.0904 139.968 43.9531 140.065 43.9406C140.161 43.9281 139.972 44.0467 139.855 44.1382C140.665 43.6889 140.667 43.483 140.651 43.3C140.876 43.223 141.038 43.1544 141.174 43.0733C141.296 43.0088 141.43 42.9152 141.557 42.7924C141.73 42.7675 142.013 42.6947 141.486 42.9734C141.632 42.9048 142.121 42.7176 142.531 42.3785C142.588 42.3307 142.646 42.2787 142.706 42.1976C142.767 42.1185 142.819 42.0062 142.836 41.8918C142.861 41.6609 142.792 41.5195 142.748 41.4238C142.698 41.3239 142.654 41.2678 142.617 41.2241C142.577 41.1783 142.548 41.1555 142.531 41.1617C142.515 41.0993 142.427 40.9641 142.313 40.8663C142.2 40.7644 142.063 40.7082 142.009 40.6937C141.784 40.6042 141.588 40.6167 141.434 40.6458C141.276 40.677 141.151 40.7311 141.053 40.779C140.859 40.8767 140.703 40.9578 140.386 41.1284L140.572 41.0577C140.399 41.3323 140.065 41.3572 139.566 41.6443L139.572 41.6214C138.349 42.1601 139.097 41.9479 137.893 42.4617L138.004 42.5158C138.004 42.7675 136.935 42.9588 136.308 43.3769L136.575 43.3021C136.246 43.5621 135.419 43.5621 135.042 43.7077C134.954 43.7285 135.154 43.6203 135.261 43.5537C134.244 43.8907 135.194 43.7368 134.484 44.0946C134.321 44.0883 134.582 43.8533 134.09 44.0529C134.024 44.0654 133.907 44.1216 133.759 44.2006C133.609 44.2776 133.442 44.3795 133.238 44.4731C132.826 44.652 132.353 44.8392 131.98 44.8829C132.151 44.887 132.324 44.8912 131.98 45.0431C131.845 45.0909 131.683 45.1304 131.505 45.1679C131.462 45.1762 131.414 45.1887 131.374 45.1949C131.337 45.2011 131.299 45.2053 131.26 45.2115C131.183 45.2178 131.108 45.2199 131.035 45.2178C130.741 45.2074 130.472 45.1075 130.22 45.0951C130.166 45.0576 130.15 45.0306 130.152 45.0181C130.12 45.0077 130.087 44.9973 130.052 44.9827C130.021 44.9702 129.989 44.9598 129.954 44.9453C129.904 44.9266 129.852 44.9078 129.796 44.887C129.76 44.8434 129.737 44.781 129.714 44.7227L129.698 44.679C129.691 44.6582 129.683 44.6333 129.679 44.6104C129.666 44.5646 129.656 44.5189 129.646 44.4731C129.606 44.2942 129.587 44.1362 129.56 44.0529C129.654 43.9635 129.704 43.7742 129.764 43.5309C129.829 43.2771 129.908 42.9734 129.983 42.6801C130.062 42.3848 130.154 42.1081 130.248 41.9188C130.341 41.7316 130.437 41.6276 130.508 41.6651C130.714 41.2595 130.927 40.8975 131.172 40.5314L131.181 40.5772C131.241 40.4919 131.297 40.415 131.349 40.3442C131.403 40.2694 131.458 40.1882 131.501 40.1175C131.589 39.9719 131.651 39.8429 131.695 39.7265C131.783 39.4956 131.807 39.3229 131.824 39.1545C131.912 38.9527 131.893 39.1129 131.903 39.1378C131.962 38.9735 132.012 38.8258 132.035 38.6615C132.055 38.5055 132.062 38.3744 132.051 38.2434C132.03 37.9855 131.957 37.765 131.843 37.584C131.728 37.4031 131.578 37.2554 131.387 37.1431C131.195 37.0307 130.976 36.933 130.658 36.8934C130.625 36.8477 130.585 36.8082 130.543 36.7645C130.452 36.7686 130.254 36.7374 129.991 36.7894C129.862 36.8144 129.719 36.8602 129.577 36.9267C129.51 36.96 129.417 37.0099 129.337 37.0661C129.279 37.1222 129.219 37.1805 129.158 37.2408C128.746 37.6319 128.25 38.0957 127.84 38.545C127.84 38.5284 127.846 38.4951 127.907 38.4202C127.446 38.9277 126.765 39.3895 126.167 39.7473C125.568 40.0946 125.026 40.4129 124.916 40.7082L124.185 41.2699C125.212 40.6729 124.122 41.5049 124.57 41.3011C124.183 41.5673 123.479 41.8315 123.958 41.5174L124.045 41.4862C124.122 41.2095 122.746 42.1892 122.702 42.0499C121.7 42.6468 120.684 43.1835 119.667 43.6744C119.411 43.7971 119.161 43.9157 118.913 44.0301C118.655 44.1424 118.397 44.2547 118.141 44.365C117.626 44.5875 117.118 44.8122 116.618 45.0389L116.916 45.0722L116.216 45.3842C116.12 45.4071 116.056 45.4029 116.066 45.3696C116.073 45.353 116.098 45.3301 116.147 45.2989C116.204 45.2635 116.293 45.2199 116.418 45.1637C116.343 45.1741 116.256 45.2074 116.166 45.2511C116.079 45.2927 116.008 45.3405 115.929 45.3883C115.777 45.484 115.646 45.5735 115.643 45.5943C115.398 45.6525 115.291 45.6567 115.273 45.64C115.252 45.6234 115.319 45.5901 115.402 45.5443C115.573 45.4611 115.808 45.3447 115.666 45.3925C115.539 45.4403 115.408 45.4799 115.277 45.5173L115.371 45.5111C115.06 45.6504 115.044 45.7399 114.423 45.8168C114.029 45.8231 114.215 45.7419 114.065 45.744C114.065 45.7378 114.052 45.7357 114.017 45.7357C114 45.7357 113.977 45.7378 113.946 45.7399C113.931 45.7399 113.917 45.7399 113.9 45.7419C113.892 45.7419 113.884 45.744 113.873 45.7461C113.804 45.7461 113.736 45.7378 113.669 45.7232C113.636 45.7149 113.604 45.7066 113.573 45.692C113.557 45.6879 113.544 45.6733 113.532 45.665C113.515 45.6567 113.527 45.6338 113.525 45.6171V45.6047L113.517 45.6213L113.486 45.6837C113.486 45.7003 113.49 45.7149 113.492 45.7315C113.5 45.7627 113.515 45.7898 113.532 45.8168C113.49 45.8147 113.448 45.8085 113.413 45.7939C113.398 45.7835 113.373 45.7794 113.367 45.7648C113.367 45.7482 113.365 45.7315 113.363 45.717C113.357 45.6379 113.363 45.5735 113.35 45.5568C113.338 45.5423 113.313 45.5693 113.253 45.7107C113.286 45.6359 113.311 45.5464 113.342 45.4487C113.375 45.3405 113.415 45.2157 113.459 45.0763C113.563 44.7456 113.729 44.3629 113.917 43.9864C114.104 43.612 114.308 43.2334 114.473 42.9484C114.64 42.6614 114.783 42.4534 114.85 42.3827C115.098 41.8523 115.46 41.3988 115.958 40.8809C115.821 40.9953 115.639 40.9828 116.083 40.5335C116.108 40.7166 116.329 40.521 116.602 40.2631C116.739 40.1362 116.891 39.9906 117.041 39.8762C117.116 39.818 117.189 39.7681 117.26 39.7285C117.337 39.6828 117.412 39.6453 117.478 39.6204C117.256 39.7244 117.603 39.4165 117.895 39.1025C118.189 38.7884 118.43 38.4784 118.114 38.6844C118.495 38.2996 118.214 38.7384 118.541 38.466C118.734 38.1935 118.936 37.9023 119.117 37.5757C119.163 37.4946 119.205 37.4093 119.247 37.3219C119.288 37.2325 119.324 37.1576 119.363 37.0619C119.44 36.8893 119.528 36.5939 119.48 36.3339C119.461 36.2029 119.411 36.0677 119.353 35.9533C119.294 35.8389 119.226 35.7349 119.147 35.6454C118.995 35.4603 118.782 35.2897 118.532 35.192C118.284 35.0921 118.014 35.0693 117.772 35.0921C117.651 35.1025 117.53 35.1275 117.424 35.1545C117.322 35.1816 117.222 35.2107 117.126 35.2419C117.114 35.2856 117.387 35.2627 117.074 35.4145L116.233 35.4977C115.954 35.608 116.033 35.7973 115.477 35.8264C115.558 35.8368 115.681 35.8493 115.494 35.9158C115.323 35.9512 115.11 35.9949 114.921 36.0531C114.729 36.1114 114.54 36.1779 114.356 36.2507C113.988 36.3984 113.632 36.569 113.284 36.7582C113.111 36.8518 112.936 36.9517 112.767 37.0557C112.611 37.1534 112.449 37.245 112.282 37.3344C111.949 37.5154 111.609 37.6776 111.251 37.8544C109.854 38.5596 108.454 39.221 106.988 39.7556C107.398 39.6308 107.148 39.7618 106.863 39.9116C107.056 39.8325 106.9 39.9969 106.961 40.0218C106.554 40.1758 106.148 40.3359 105.744 40.5044C105.601 40.7353 104.532 41.1971 104.486 41.3863L104.828 41.1575C104.436 41.5673 105.665 41.0806 105.694 41.3011C106.138 40.8455 107.215 40.7748 107.994 40.1154C108.21 40.0572 107.854 40.2569 107.981 40.2465C108.171 40.0572 108.437 39.9074 108.964 39.6973L108.916 39.7452C109.629 39.3895 110.147 39.1545 110.693 38.9194C110.966 38.8029 111.243 38.6823 111.555 38.5492C111.855 38.4202 112.217 38.2767 112.632 38.0749L112.465 38.0479C112.821 37.8794 112.909 37.8607 113.086 37.7899C113.244 37.6048 113.003 37.7525 112.753 37.8835C112.501 38.0146 112.242 38.1352 112.388 37.9688C112.528 37.9563 112.751 37.869 113.013 37.7338C113.136 37.6651 113.269 37.5923 113.409 37.5154C113.546 37.4426 113.688 37.3677 113.827 37.2928C114.396 36.9974 114.973 36.779 115.158 36.8435C115.673 36.6813 114.971 36.7749 115.489 36.623L115.664 36.6418L115.791 36.5211C116.179 36.4192 116.387 36.4275 116.418 36.4754C116.327 36.5003 116.164 36.5752 116.066 36.6106C116.327 36.569 116.666 36.4462 116.954 36.336C117.243 36.2258 117.483 36.1342 117.56 36.1259C117.389 36.1592 117.212 36.2029 117.031 36.2486C117.216 36.18 117.405 36.1134 117.591 36.0593C117.772 36.0053 117.918 35.9845 118.057 35.999C118.195 36.0115 118.303 36.0593 118.407 36.1467C118.457 36.1883 118.513 36.2486 118.553 36.3048C118.593 36.363 118.616 36.4109 118.63 36.4546C118.655 36.5606 118.649 36.6126 118.572 36.8102L118.513 36.9517L118.455 37.0807C118.414 37.1659 118.37 37.2512 118.322 37.3344C118.13 37.6714 117.903 37.973 117.664 38.2725L117.776 38.2205C117.416 38.674 117.231 38.8196 117.037 38.9735C116.937 39.0525 116.843 39.117 116.693 39.2397C116.545 39.3625 116.372 39.5289 116.15 39.7743L116.175 39.7306C116.02 39.9553 115.806 40.2298 115.556 40.4857C115.743 40.2007 115.048 40.8788 115.302 40.5127C114.892 41.0369 114.81 41.1867 114.765 41.2865C114.721 41.3884 114.715 41.4529 114.531 41.8564L114.352 41.9771C114.248 42.2662 114.256 42.3016 113.946 42.884C114.156 42.3785 113.632 43.1939 113.856 42.6177C113.436 43.1814 113.234 43.6598 113.088 44.0758C112.942 44.4918 112.861 44.8122 112.663 45.1346C112.674 45.3759 112.713 45.3759 112.751 45.2719C112.792 45.1512 112.838 45.0077 112.89 44.835C112.996 44.4981 113.138 44.1466 113.09 44.3254C113.182 44.1965 113.165 44.3358 113.113 44.5584C113.088 44.6707 113.057 44.8038 113.025 44.937C112.994 45.0701 112.967 45.197 112.94 45.3259C112.896 45.5547 112.826 45.7586 112.761 46.1018C112.771 46.1392 112.765 46.1871 112.794 46.2204C112.828 46.2516 112.861 46.2911 112.901 46.3202C112.976 46.3847 113.071 46.4429 113.192 46.4949C113.257 46.5157 113.325 46.5365 113.396 46.5594C113.473 46.574 113.557 46.5844 113.644 46.5968C113.729 46.6093 113.836 46.6114 113.929 46.6114C114.004 46.6135 114.079 46.6072 114.161 46.6052C114.042 46.6093 114.036 46.6301 113.915 46.6301C114.373 46.6759 114.767 46.4928 115.304 46.47C115.564 46.2828 115.981 46.2911 116.01 46.1039C115.679 46.2349 115.341 46.3327 115 46.4096C115.289 46.3327 115.556 46.2058 115.86 46.0644C116.012 45.9936 116.175 45.9125 116.354 45.8251C116.529 45.7399 116.72 45.6567 116.945 45.5797C116.893 45.64 116.658 45.7981 116.493 45.9C116.764 45.8293 116.96 45.6504 117.241 45.5776C117.241 45.6712 116.966 45.8064 116.629 45.9645C116.539 46.0061 116.447 46.0498 116.354 46.0914C116.254 46.1392 116.154 46.1746 116.056 46.2183C115.86 46.2952 115.675 46.366 115.523 46.4388C115.685 46.4325 115.977 46.3202 116.191 46.2162C116.404 46.1164 116.547 46.0415 116.425 46.1975C116.522 46.0914 116.614 46.0186 116.733 45.952C116.849 45.8855 116.983 45.8314 117.126 45.7731C117.412 45.6567 117.735 45.5319 118.034 45.2968V45.4091C118.132 45.3467 118.334 45.2011 118.532 45.1138L118.232 45.3946C118.73 45.041 119.324 45.0098 119.838 44.677C119.28 44.9578 119.201 44.9598 119.203 44.9141C119.203 44.8704 119.28 44.781 119.032 44.8538C119.688 44.4669 119.907 44.417 120.157 44.3795C120.402 44.3358 120.68 44.2963 121.411 43.8699C121.217 43.9947 120.625 44.2235 120.919 44.0155C121.213 43.8824 121.602 43.7118 121.8 43.6598C122.764 43.0941 121.6 43.6557 121.985 43.3665C122.377 43.2854 122.437 43.0525 122.839 42.7737L122.893 42.8611C124.02 42.2704 123.077 42.5096 124.093 41.9895L123.754 42.3598L124.243 42.0208L124.199 42.183C124.707 41.7732 124.891 41.6859 125.447 41.3801C125.284 41.3967 125.42 41.1804 125.893 40.8788C126.251 40.7249 125.761 41.0764 126.43 40.6375C126.311 40.7894 126.186 40.962 125.843 41.066C125.83 41.1138 125.726 41.2137 125.713 41.2615C126.097 41.1034 126.603 40.727 126.855 40.546C126.759 40.6105 126.638 40.6812 126.572 40.7103C126.884 40.4482 127.171 40.1778 127.453 39.897C127.621 39.8117 127.525 39.9282 127.43 40.0426C127.613 39.8866 127.713 39.7473 127.975 39.5122C127.959 39.6329 128.036 39.689 127.667 40.0343C127.946 39.7743 128.213 39.506 128.471 39.2314C128.552 39.2085 128.962 38.9111 128.877 39.0338C129.123 38.8362 129.369 38.5388 129.623 38.2184C129.687 38.1394 129.75 38.0583 129.816 37.9751C129.877 37.9002 129.971 37.7879 129.964 37.7879C129.977 37.7775 129.983 37.7691 130.004 37.7567C130.031 37.7379 130.058 37.7255 130.085 37.713C130.139 37.6901 130.191 37.6797 130.239 37.6797C130.256 37.661 130.293 37.6381 130.387 37.6339C130.577 37.6589 130.845 37.8419 130.943 37.9917C130.997 38.0687 131.033 38.1436 131.062 38.2496C131.074 38.3037 131.089 38.362 131.095 38.4327C131.099 38.466 131.101 38.5076 131.104 38.5408C131.104 38.5741 131.11 38.6074 131.108 38.6448C131.031 38.7613 130.941 38.882 130.845 38.986C130.749 39.2481 130.845 39.1461 130.931 39.0775C130.97 39.0442 131.008 39.0192 131.016 39.0629C131.022 39.1066 131.004 39.221 130.891 39.4519C130.724 39.7805 130.643 39.8117 130.604 39.7993C130.562 39.7826 130.554 39.7015 130.447 39.8138C130.352 40.0114 130.233 40.2881 130.085 40.5959C130.01 40.7498 129.929 40.91 129.837 41.0764C129.789 41.1638 129.754 41.2262 129.698 41.3073C129.641 41.3926 129.583 41.4799 129.525 41.5673C129.571 41.4404 129.635 41.3177 129.687 41.2262C129.735 41.1409 129.789 41.041 129.846 40.9308L129.843 40.9433ZM133.911 45.2677C133.834 45.3072 133.717 45.3821 133.605 45.4299C133.492 45.4778 133.384 45.5131 133.315 45.5027C133.461 45.3343 133.619 45.3509 133.911 45.2677ZM139.913 43.1773C140.007 43.0878 140.184 43.0108 140.395 42.9422C140.259 43.0254 140.101 43.1065 139.913 43.1773ZM114.086 49.1532C114.086 49.1532 114.096 49.147 114.102 49.1449C114.469 49.1012 114.338 49.1158 114.086 49.1532ZM113.225 49.2385C113.14 49.2551 113.146 49.2697 113.184 49.2822C113.244 49.2551 113.438 49.2447 113.663 49.2177C113.596 49.2011 113.482 49.2011 113.225 49.2385ZM113.981 45.8043L114.123 45.8231C113.809 45.8688 113.898 45.8335 113.981 45.8043Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M141.18 42.3556C141.23 42.3514 141.249 42.364 141.268 42.3766C141.318 42.3325 141.312 42.3157 141.18 42.3556Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M130.25 37.6885H130.237C130.237 37.6885 130.229 37.7034 130.229 37.7098L130.252 37.6885H130.25Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M123.854 43.4913C123.997 43.4164 124.083 43.3852 124.143 43.3686C124.137 43.3436 124.064 43.3644 123.854 43.4913Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M109.747 46.6837C109.739 46.8751 109.741 47.0685 109.757 47.2641C109.743 46.9791 109.776 46.8813 109.801 46.744C109.776 46.7544 109.732 46.8605 109.745 46.6816L109.747 46.6837Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.976 42.7715C112.003 42.7028 112.057 42.6404 112.084 42.5718L112.034 42.5635C111.871 42.8297 111.794 43.0356 111.978 42.7715H111.976Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.157 46.2329C110.249 46.208 110.285 45.8856 110.379 45.5361C110.372 45.5569 110.366 45.5757 110.36 45.5965C110.278 45.4571 110.191 45.8398 110.157 46.2309V46.2329Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.401 45.4544C110.433 45.3484 110.468 45.2402 110.51 45.1404C110.479 45.0842 110.452 45.2631 110.401 45.4544Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M112.141 49.2263C111.966 49.1722 112.007 49.3157 111.912 49.2596C111.799 49.2928 112.109 49.324 112.32 49.3095C112.53 49.2908 112.636 49.2658 112.141 49.2263Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.497 46.0107L110.363 46.1085C110.376 46.1792 110.39 46.2499 110.407 46.3186C110.434 46.2146 110.464 46.1106 110.497 46.0107Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M111.113 48.492C110.94 48.4046 110.776 48.2923 110.651 48.1446C110.644 48.1634 110.584 48.1176 110.521 48.0469C110.63 48.1966 110.778 48.3277 110.901 48.4026C111.023 48.4774 111.115 48.5086 111.113 48.4941V48.492Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.523 48.0467C110.41 47.8907 110.348 47.7159 110.304 47.6182C110.327 47.718 110.414 47.9323 110.523 48.0467Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M110.4 46.7637C110.387 46.8178 110.377 46.8718 110.366 46.9259C110.358 47.057 110.356 47.188 110.362 47.319C110.36 47.1339 110.372 46.9488 110.4 46.7658V46.7637Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M116.958 47.8115L117.493 47.5245C117.533 47.4642 117.375 47.5162 117.177 47.6264C117.056 47.7117 116.858 47.8219 116.958 47.8136V47.8115Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M115.156 48.2008C115.319 48.1821 115.335 48.2008 115.433 48.2092L115.415 48.0781L115.158 48.2008H115.156Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M116.76 47.5491C116.799 47.4908 117.513 47.0748 116.818 47.4139C116.778 47.4721 116.241 47.7613 116.76 47.5491Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M124.846 43.2939L124.714 43.3771L124.848 43.5477L124.846 43.2939Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M127.572 44.7912C127.647 44.4875 127.634 44.448 127.607 44.4085C127.595 44.3898 127.582 44.3731 127.588 44.3274C127.59 44.3045 127.597 44.2733 127.611 44.2338C127.618 44.2151 127.626 44.1943 127.636 44.1693C127.651 44.1339 127.668 44.0944 127.689 44.0507C127.714 43.9155 127.609 44.1443 127.58 44.2151C127.534 44.3232 127.494 44.4376 127.492 44.3565C127.45 44.7517 127.413 44.9472 127.574 44.7933L127.572 44.7912Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M127.49 44.355C127.497 44.2926 127.505 44.226 127.513 44.1553C127.494 44.2634 127.49 44.3238 127.49 44.355Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M104.923 40.8477L104.494 41.0432L104.792 40.9537L104.923 40.8477Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M104.23 41.4402L104.066 41.3799L103.891 41.6316C103.978 41.5712 104.147 41.4548 104.232 41.4402H104.23Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M135.238 45.0019L135.257 44.9561C135.173 44.954 135.073 44.9998 134.867 45.083L135.238 44.9998V45.0019Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M128.71 44.7687C128.716 44.8187 128.72 44.8478 128.735 44.9143C128.754 44.7999 128.785 44.7271 128.814 44.6377C128.777 44.6793 128.745 44.723 128.71 44.7687Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M130.508 39.4248C130.458 39.5018 130.404 39.587 130.349 39.6723C130.281 39.7763 130.214 39.8824 130.147 39.9781C130.277 39.7659 130.433 39.6141 130.493 39.5579C130.564 39.4851 130.587 39.4477 130.51 39.4269L130.508 39.4248Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M141.005 41.1927C141.363 40.9764 142.077 40.6914 143.027 40.1215C143.975 39.5516 144.966 38.8569 146.122 38.2557C147.278 37.6546 148.446 37.093 149.631 36.5667C150.814 36.0426 151.847 35.743 152.732 35.6681C153.041 35.5558 153.366 35.5621 153.709 35.6827C154.051 35.8054 154.303 35.9677 154.463 36.1694C154.788 36.6811 154.824 37.0847 154.572 37.3759C154.317 37.6691 153.986 37.925 153.576 38.1413C153.164 38.3597 152.714 38.5407 152.224 38.6821C151.733 38.8257 151.412 39.0025 151.262 39.2146C151.008 39.5329 151.083 39.8178 151.479 40.0674C151.874 40.3191 152.362 40.5126 152.939 40.654C153.514 40.7955 154.09 40.9244 154.667 41.0388C155.242 41.1553 155.611 41.2614 155.769 41.3612C156.825 41.9062 157.45 42.5011 157.65 43.1459C157.848 43.7907 157.748 44.4563 157.35 45.1427L159.428 43.9987L165.587 40.5666C165.945 40.3503 166.27 40.3295 166.562 40.5022C166.851 40.6769 167.003 40.9723 167.014 41.3883C167.024 41.8043 166.81 42.108 166.374 42.3014C165.937 42.4948 165.537 42.6737 165.179 42.8381C163.944 43.4413 162.698 44.084 161.44 44.7663C160.182 45.4485 158.937 46.1432 157.706 46.8505C156.215 47.6159 154.788 48.3023 153.426 48.9097C152.062 49.5171 150.652 49.8395 149.196 49.8748C148.155 49.9019 147.222 49.5607 146.399 48.8535C145.572 48.1463 145.149 47.3268 145.124 46.3908C145.06 45.9248 145.153 45.5463 145.408 45.253C145.66 44.9618 145.968 44.7704 146.33 44.6831C146.691 44.5957 147.02 44.6539 147.311 44.8536C147.601 45.0554 147.78 45.3882 147.844 45.8541C147.973 46.8921 148.444 47.489 149.256 47.6513C150.067 47.8114 151.016 47.749 152.101 47.462C152.822 47.1833 153.478 46.8421 154.065 46.4365C154.653 46.0309 155.073 45.644 155.323 45.2738C155.982 44.5291 156.148 43.953 155.825 43.5453C155.503 43.1376 154.959 42.8152 154.201 42.5739C153.439 42.3347 152.641 42.1329 151.804 41.9728C150.966 41.8126 150.389 41.6067 150.071 41.355C149.592 40.9515 149.308 40.5438 149.219 40.1298C149.129 39.7159 149.131 39.302 149.225 38.8818C148.452 39.2125 147.692 39.5578 146.949 39.9156C146.203 40.2734 145.522 40.5895 144.904 40.8641C144.441 41.1366 143.891 41.5276 143.254 42.0372C142.617 42.5489 142.038 42.8089 141.517 42.8214C141.259 42.8797 141.038 42.8464 140.851 42.7216C140.665 42.5968 140.559 42.4428 140.528 42.2619C140.496 42.0809 140.517 41.8854 140.59 41.6753C140.663 41.4673 140.803 41.3071 141.007 41.1969L141.005 41.1927Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M141.005 41.1927C141.363 40.9764 142.077 40.6914 143.027 40.1215C143.975 39.5516 144.966 38.8569 146.122 38.2557C147.278 37.6546 148.446 37.093 149.631 36.5667C150.814 36.0426 151.847 35.743 152.732 35.6681C153.041 35.5558 153.366 35.5621 153.709 35.6827C154.051 35.8054 154.303 35.9677 154.463 36.1694C154.788 36.6811 154.824 37.0847 154.572 37.3759C154.317 37.6691 153.986 37.925 153.576 38.1413C153.164 38.3597 152.714 38.5407 152.224 38.6821C151.733 38.8257 151.412 39.0025 151.262 39.2146C151.008 39.5329 151.083 39.8178 151.479 40.0674C151.874 40.3191 152.362 40.5126 152.939 40.654C153.514 40.7955 154.09 40.9244 154.667 41.0388C155.242 41.1553 155.611 41.2614 155.769 41.3612C156.825 41.9062 157.45 42.5011 157.65 43.1459C157.848 43.7907 157.748 44.4563 157.35 45.1427L159.428 43.9987L165.587 40.5666C165.945 40.3503 166.27 40.3295 166.562 40.5022C166.851 40.6769 167.003 40.9723 167.014 41.3883C167.024 41.8043 166.81 42.108 166.374 42.3014C165.937 42.4948 165.537 42.6737 165.179 42.8381C163.944 43.4413 162.698 44.084 161.44 44.7663C160.182 45.4485 158.937 46.1432 157.706 46.8505C156.215 47.6159 154.788 48.3023 153.426 48.9097C152.062 49.5171 150.652 49.8395 149.196 49.8748C148.155 49.9019 147.222 49.5607 146.399 48.8535C145.572 48.1463 145.149 47.3268 145.124 46.3908C145.06 45.9248 145.153 45.5463 145.408 45.253C145.66 44.9618 145.968 44.7704 146.33 44.6831C146.691 44.5957 147.02 44.6539 147.311 44.8536C147.601 45.0554 147.78 45.3882 147.844 45.8541C147.973 46.8921 148.444 47.489 149.256 47.6513C150.067 47.8114 151.016 47.749 152.101 47.462C152.822 47.1833 153.478 46.8421 154.065 46.4365C154.653 46.0309 155.073 45.644 155.323 45.2738C155.982 44.5291 156.148 43.953 155.825 43.5453C155.503 43.1376 154.959 42.8152 154.201 42.5739C153.439 42.3347 152.641 42.1329 151.804 41.9728C150.966 41.8126 150.389 41.6067 150.071 41.355C149.592 40.9515 149.308 40.5438 149.219 40.1298C149.129 39.7159 149.131 39.302 149.225 38.8818C148.452 39.2125 147.692 39.5578 146.949 39.9156C146.203 40.2734 145.522 40.5895 144.904 40.8641C144.441 41.1366 143.891 41.5276 143.254 42.0372C142.617 42.5489 142.038 42.8089 141.517 42.8214C141.259 42.8797 141.038 42.8464 140.851 42.7216C140.665 42.5968 140.559 42.4428 140.528 42.2619C140.496 42.0809 140.517 41.8854 140.59 41.6753C140.663 41.4673 140.803 41.3071 141.007 41.1969L141.005 41.1927Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M140.606 40.8353C140.806 40.7146 140.693 40.6876 140.716 40.6543C140.543 40.7625 140.526 40.8269 140.545 40.8415C140.564 40.8581 140.616 40.8415 140.606 40.8373V40.8353Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M141.682 43.1217L141.632 43.1633C141.78 43.1217 141.915 43.0656 142.042 42.999C141.93 43.0489 141.809 43.0905 141.682 43.1217Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M143.888 41.9375C143.754 41.9437 143.59 42.0789 143.415 42.2412C143.234 42.4097 143.019 42.599 142.809 42.6905L142.728 42.6967C142.69 42.7654 142.646 42.8319 142.601 42.9006C142.855 42.7654 143.107 42.5698 143.327 42.3806C143.546 42.1871 143.727 42.029 143.886 41.9375H143.888Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M145.073 41.5095C144.982 41.4991 145.262 41.3264 144.831 41.6426C144.856 41.6322 144.867 41.6322 144.881 41.628C144.921 41.601 144.977 41.5656 145.073 41.5095Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M144.882 41.6283C144.686 41.7627 145.04 41.5842 144.882 41.6283V41.6283Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M145.8 41.1118L145.521 41.299C145.598 41.3011 145.868 41.1846 145.779 41.2533C146.075 41.0848 145.997 41.0827 145.798 41.1118H145.8Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M146.038 40.8789L145.892 40.9704C145.925 40.9704 145.969 40.9559 146.038 40.8789Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M145.581 41.1665L145.891 40.971C145.837 40.971 145.812 40.9273 145.748 41.0563C145.756 41.0022 145.708 41.0729 145.581 41.1665Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M145.385 41.233C145.201 41.2809 144.979 41.362 145.258 41.1748C145.193 41.2081 145.11 41.2497 145.11 41.2559C145.103 41.2622 145.085 41.2767 145.066 41.2913C145.049 41.3058 145.035 41.3183 145.022 41.3287C144.972 41.3745 144.958 41.4015 144.974 41.4057C144.991 41.4119 145.037 41.3953 145.112 41.3599C145.168 41.3308 145.141 41.3474 145.195 41.3225C145.251 41.2975 145.316 41.2663 145.387 41.231L145.385 41.233Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M143.889 41.7402L143.669 41.8526L143.533 42.0231C143.6 41.9378 143.931 41.7694 143.891 41.7402H143.889Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M147.695 40.322C147.699 40.2846 147.56 40.2888 147.52 40.2617L147.318 40.3948C147.441 40.3636 147.662 40.2846 147.697 40.322H147.695Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M147.519 40.2611L147.824 40.0635C147.528 40.1904 147.486 40.2382 147.519 40.2611Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M146.02 40.7023L145.524 41.06L146.124 40.6523L146.02 40.7023Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.432 39.991C148.413 40.0263 148.401 40.0596 148.395 40.0908C148.405 40.0451 148.432 39.991 148.476 39.9307C148.459 39.9515 148.445 39.9723 148.432 39.991Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.527 39.9844C148.499 40.0093 148.472 40.053 148.449 40.0821C148.426 40.1133 148.407 40.1341 148.389 40.1549C148.399 40.1383 148.447 40.105 148.497 40.1175C148.468 40.0967 148.474 40.0925 148.527 39.9844Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.62 40.3628C148.597 40.3004 148.572 40.2338 148.547 40.1672C148.543 40.1548 148.535 40.1277 148.53 40.1277C148.526 40.1256 148.522 40.1236 148.52 40.1215C148.514 40.1194 148.505 40.1173 148.499 40.1152L148.512 40.1236C148.512 40.1236 148.52 40.1194 148.535 40.1631L148.572 40.2546C148.587 40.2879 148.604 40.3253 148.622 40.3607L148.62 40.3628Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.312 39.8597C148.326 39.8742 148.358 39.9158 148.401 39.92C148.393 39.8909 148.378 39.8638 148.36 39.8389C148.345 39.8451 148.328 39.8513 148.312 39.8597Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.357 39.8376C148.408 39.8187 148.444 39.8061 148.46 39.7998C148.448 39.804 148.416 39.8166 148.357 39.8376Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.299 39.8671C148.299 39.8671 148.308 39.8627 148.312 39.8627C148.305 39.8561 148.301 39.8539 148.299 39.8671Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M146.922 40.3732C147.095 40.2359 147.474 40.0071 147.051 40.1132C146.939 40.2338 147.182 40.1693 146.922 40.3732Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.149 39.8076L147.791 39.947C147.808 39.9657 147.885 39.9678 147.801 40.0343L148.149 39.8076Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.261 39.7266L148.219 39.7598C148.209 39.7702 148.171 39.7931 148.148 39.8077L148.215 39.7827L148.251 39.7702L148.261 39.7266Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.636 39.9556C148.655 39.968 148.665 39.993 148.676 40.0242C148.68 40.0408 148.684 40.0575 148.69 40.0741C148.699 40.1136 148.707 40.1532 148.717 40.1948L148.705 40.0991V39.993C148.705 39.9452 148.705 39.8973 148.707 39.8516C148.682 39.862 148.634 39.8828 148.636 39.9556Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.639 39.7219C148.639 39.7219 148.652 39.713 148.656 39.7086C148.656 39.6998 148.652 39.6998 148.639 39.7219Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M150.269 42.048C150.269 42.048 150.251 42.0271 150.242 42.0166C150.238 42.0208 150.234 42.025 150.228 42.0271L150.269 42.048Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.724 39.8223C148.742 39.7391 148.732 39.712 148.713 39.71H148.709V39.7162C148.709 39.7599 148.709 39.8036 148.709 39.8535C148.722 39.8472 148.728 39.841 148.726 39.8223H148.724Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.978 41.0368C148.932 40.9349 148.882 40.8184 148.838 40.6895C148.857 40.8039 148.934 41.0202 148.978 41.0368Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.649 39.7373L148.638 39.748C148.636 39.7715 148.642 39.7565 148.649 39.7373Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.648 39.738C148.648 39.738 148.672 39.7168 148.676 39.7147C148.678 39.7147 148.682 39.7147 148.687 39.7147C148.693 39.7147 148.702 39.7105 148.71 39.7105C148.71 39.6956 148.71 39.6829 148.71 39.6723C148.714 39.6618 148.697 39.6787 148.687 39.6851L148.657 39.7084C148.657 39.7084 148.657 39.7274 148.651 39.738H148.648Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M151.077 41.7213C151.033 41.7941 150.569 41.7525 150.277 41.4821C150.104 41.4176 150.023 41.453 150.019 41.5695C150.013 41.6839 150.102 41.869 150.244 42.0167C150.271 41.9834 150.29 41.973 150.696 42.0666C150.635 42.0229 150.429 41.921 150.288 41.817C150.146 41.713 150.073 41.6277 150.244 41.6797C150.496 41.7837 150.594 41.8191 150.656 41.8648C150.721 41.9064 150.748 41.948 150.864 42.0083C150.777 41.9251 150.948 41.9418 151.129 41.9439C151.31 41.948 151.502 41.9376 151.466 41.8503C151.318 41.8357 151.173 41.817 151.025 41.792C151.025 41.7671 151.187 41.7733 151.077 41.7192V41.7213Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M149.524 41.5054C149.478 41.468 149.434 41.4264 149.391 41.3848C149.457 41.4638 149.509 41.5345 149.568 41.6115C149.628 41.6905 149.674 41.7737 149.809 41.9089C150.13 42.0649 150.195 42.0379 150.226 42.0296C150.088 41.963 149.953 41.8881 149.807 41.78C149.666 41.6677 149.576 41.5803 149.47 41.4721L149.522 41.5054H149.524Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.901 40.6915C149.047 40.8059 149.328 41.1241 149.259 40.8537C149.115 40.6395 149.068 40.5563 149.018 40.5043C148.972 40.4502 148.926 40.4231 148.863 40.2609C148.928 40.4855 148.978 40.5687 148.982 40.5979C148.99 40.6249 148.965 40.5937 148.936 40.5521C148.907 40.5126 148.874 40.4606 148.861 40.4627C148.849 40.4627 148.847 40.5209 148.909 40.6811C148.813 40.523 148.753 40.3462 148.72 40.1943C148.741 40.3628 148.786 40.5396 148.841 40.6894C148.841 40.6811 148.838 40.6748 148.836 40.6665V40.6623C148.83 40.6187 148.83 40.6041 148.843 40.6499C148.845 40.6519 148.851 40.6623 148.853 40.6665C148.868 40.6665 148.884 40.679 148.903 40.6915C149.013 40.9411 148.899 40.7435 148.853 40.6665C148.847 40.6665 148.841 40.6603 148.836 40.6623V40.6665C148.988 40.9556 149.188 41.1865 149.395 41.3841C149.284 41.2385 149.115 41.0825 148.903 40.6915H148.901Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M147.326 39.7731C147.352 39.771 147.354 39.7773 147.358 39.7816C147.398 39.7519 147.411 39.7371 147.326 39.7731Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M147.628 39.6953C147.584 39.7286 147.559 39.7806 147.395 39.8451C147.245 39.8825 147.376 39.8055 147.357 39.7806C147.272 39.8471 147.049 39.9927 147.37 39.895L147.411 39.8617C147.697 39.766 148.095 39.7119 148.051 39.7452C147.938 39.7057 147.843 39.6849 147.628 39.6932V39.6953Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.92 39.3068C148.932 39.3005 148.951 39.286 148.96 39.2881L148.955 39.3213L148.949 39.3921C148.945 39.4669 148.943 39.5439 148.949 39.6271C148.976 39.5273 149.008 39.417 149.045 39.2985L148.997 39.3713C149.001 39.3484 149.006 39.3255 149.008 39.3109C149.018 39.2589 149.022 39.2257 149.022 39.209C149.022 39.2007 149.022 39.1945 149.02 39.1924C149.018 39.1924 149.004 39.2069 148.997 39.2132C148.966 39.2465 148.947 39.2777 148.92 39.3089V39.3068Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M150.327 42.123L150.198 42.1709C150.35 42.1896 150.494 42.1958 150.634 42.1958C150.534 42.1771 150.432 42.1501 150.327 42.123Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M151.179 42.3848L151.127 42.4576L151.361 42.4617L151.179 42.3848Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M166.123 41.8585C166.152 41.8418 166.175 41.8252 166.19 41.8148C166.209 41.8023 166.225 41.7898 166.24 41.7773C166.186 41.8169 166.15 41.8397 166.123 41.8585Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M164.909 42.4019L164.898 42.4541C164.944 42.406 164.959 42.3789 164.909 42.4019Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M144.746 45.3057C144.627 45.4617 144.527 45.651 144.48 45.7945C144.43 45.938 144.423 46.0316 144.471 46.0108C144.505 45.9734 144.536 45.9401 144.571 45.9068C144.58 45.6551 144.655 45.4533 144.748 45.3057H144.746Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M155.575 47.8867C155.548 47.8888 155.521 47.893 155.493 47.895C155.45 47.9512 155.408 48.0032 155.37 48.051C155.433 48.0011 155.502 47.945 155.577 47.8867H155.575Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M155.576 47.4621L155.916 47.3623C155.837 47.3789 155.726 47.4101 155.576 47.4621Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M162.491 42.9775L162.351 43.1627C162.643 43.0004 162.491 43.0295 162.491 42.9775Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M154.03 45.8379C153.837 45.9377 153.687 46.0209 153.56 46.0979C153.803 46.0022 154.022 45.9398 154.03 45.8379Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M166.05 42.9611C166.144 42.9008 166.18 42.8633 166.167 42.8467C166.069 42.907 166.019 42.9507 166.05 42.9611Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M153.028 46.4158C153.066 46.4054 153.101 46.3929 153.139 46.3804C153.268 46.2889 153.397 46.1974 153.559 46.0996C153.378 46.1703 153.18 46.2598 153.028 46.4179V46.4158Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M149.859 37.041C149.841 37.0452 149.82 37.0515 149.801 37.0557C149.801 37.0703 149.826 37.0598 149.859 37.041Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M142.755 39.8157C142.815 39.7741 142.917 39.7117 143.013 39.6514C142.963 39.6742 142.884 39.7242 142.755 39.8157Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M154.248 43.1983C154.101 43.1521 154.22 43.1983 154.248 43.1983V43.1983Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M153.595 42.6141C153.633 42.6141 153.662 42.6099 153.673 42.5889C153.654 42.6057 153.626 42.6141 153.595 42.6141Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M151.733 47.5625C151.733 47.5625 151.725 47.5625 151.719 47.5646C151.773 47.5709 151.763 47.5688 151.733 47.5625Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M154.041 43.084C154.093 43.1131 154.154 43.1422 154.221 43.1734C154.194 43.1547 154.139 43.1277 154.041 43.084Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M154.058 43.134C154.01 43.1132 153.964 43.0987 153.924 43.082C153.899 43.0904 153.918 43.1049 154.058 43.134Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M154.448 43.2716C154.368 43.2404 154.293 43.2071 154.22 43.1738C154.247 43.1905 154.257 43.1988 154.247 43.1988C154.289 43.2133 154.349 43.2321 154.445 43.2716H154.448Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M153.943 41.1621C153.933 41.158 153.92 41.1517 153.91 41.1455C153.732 41.1455 153.808 41.1559 153.943 41.1621Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M147.185 48.906C147.185 48.906 147.175 48.9038 147.168 48.8994C147.175 48.9038 147.181 48.9104 147.185 48.9148V48.906Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M147.697 49.0991C147.441 49.1115 147.322 49.0283 147.185 48.916C147.189 49.0242 147.199 49.1303 147.212 49.2405C147.38 49.2051 147.543 49.1573 147.697 49.0991Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M165.952 40.9685C165.998 40.9623 166.039 40.9623 166.073 40.9685C166.106 40.9727 166.121 40.9872 166.141 40.9997C166.098 41.0642 166.014 41.1266 165.948 41.1911C165.906 41.2264 165.887 41.2472 165.906 41.2514C165.923 41.2597 165.994 41.241 166.052 41.241C166.023 41.1744 166.062 41.1099 166.106 41.0787C166.135 41.0496 166.173 41.0455 166.212 41.0621C166.229 41.0683 166.258 41.0871 166.275 41.0995C166.294 41.1141 166.31 41.1287 166.331 41.1474C166.373 41.1848 166.423 41.2431 166.496 41.2389C166.485 41.2951 166.473 41.3741 166.45 41.422C166.454 41.3824 166.435 41.3616 166.433 41.3159C166.408 41.4157 166.4 41.4469 166.408 41.476C166.416 41.5052 166.439 41.528 166.462 41.5613C166.5 41.6196 166.56 41.7381 166.339 41.8588C166.26 41.8941 166.179 41.9087 166.117 41.9191C166.06 41.9253 166.052 41.9087 166.123 41.8567L165.644 42.15C165.494 42.2103 165.508 42.15 165.658 42.0876C165.404 42.2124 165.146 42.3289 164.894 42.462V42.4516C164.809 42.5473 164.594 42.7365 164.49 42.8239C164.282 42.8863 164.573 42.7469 164.509 42.7407L164.123 43.0173C163.921 43.0381 164.234 42.7948 164.527 42.6554C164.011 42.5972 164.213 42.8988 163.299 43.1817L163.676 42.9445C163.349 42.93 163.067 43.1421 162.574 43.2815C162.705 43.2732 163.584 43.0485 163.163 43.346C163.026 43.3918 162.853 43.4708 162.636 43.6476C162.586 43.5582 162.359 43.7038 162.064 43.8618L162.02 43.7308C161.716 43.9326 161.772 43.9804 161.612 44.1322C161.245 44.3049 161.12 44.2529 160.997 44.2217C160.424 44.5171 161.466 44.1531 160.812 44.5462C160.32 44.7625 160.018 44.9934 159.498 45.3761C159.148 45.5176 159.514 45.2721 159.379 45.3033L159.139 45.5592C159.066 45.5966 159.075 45.555 159.077 45.5342C158.852 45.7068 159.121 45.6652 158.754 45.9107C158.723 46.0979 157.861 46.1624 157.467 46.5701C157.334 46.595 157.484 46.4681 157.423 46.4411C156.828 46.8696 156.896 46.8009 156.419 47.2066L155.913 47.3563C156.301 47.2794 155.917 47.6038 155.572 47.8784C155.715 47.8638 155.84 47.8514 155.919 47.8347L155.332 48.1987C155.247 48.2154 155.29 48.1426 155.368 48.0427C155.33 48.0739 155.297 48.103 155.268 48.1259C155.024 48.1863 155.105 48.0614 155.232 47.9179C155.32 47.9075 155.407 47.8971 155.49 47.8867C155.607 47.739 155.709 47.5872 155.642 47.5331C155.609 47.5664 155.538 47.6163 155.457 47.6642C155.486 47.6246 155.503 47.5955 155.48 47.5914C155.453 47.5893 155.401 47.6475 155.315 47.7266L155.109 47.6579L155.101 47.7286L154.253 48.024C153.995 48.2279 153.764 48.4359 153.481 48.6543C153.199 48.8706 152.868 49.0911 152.396 49.2845C152.598 49.0973 152.387 49.0952 152.358 48.9663C152.508 48.9891 152.687 48.9101 152.883 48.7999C153.081 48.6917 153.291 48.5503 153.539 48.4567C153.283 48.5544 153.312 48.4733 153.366 48.4255C153.099 48.5898 152.843 48.7458 152.568 48.8893C152.552 48.7811 152.36 48.881 152.121 48.9101C152.36 49.0599 151.515 49.2512 151.16 49.3802C151.123 49.3136 151.196 49.2325 151.637 49.1348C151.121 49.1015 151.063 49.532 150.548 49.48C150.659 49.4613 150.719 49.4613 150.756 49.4197C150.511 49.5341 149.871 49.5528 150.013 49.4738L150.123 49.4592C149.761 49.4863 149.188 49.5383 148.742 49.5237C148.286 49.5112 147.905 49.4301 147.822 49.4967C147.824 49.4717 147.98 49.322 148.028 49.2991C147.584 49.374 147.093 49.3552 146.593 49.245C146.689 49.218 146.693 49.0619 146.751 48.9517C146.81 48.8394 146.908 48.7811 147.17 48.8976C147.045 48.7895 146.895 48.6626 146.597 48.4712C146.662 48.5627 146.674 48.8269 146.539 48.7375C146.426 48.5274 146.393 48.4587 146.343 48.3839C146.297 48.309 146.235 48.2258 146.133 47.9803C146.17 48.0552 146.114 48.0968 146.029 48.0885C145.941 48.0822 145.82 48.0219 145.747 47.9034C145.802 47.9179 145.935 47.7557 146.01 47.8181C145.825 47.687 145.647 47.5331 145.491 47.3501C145.6 47.4894 145.683 47.2981 145.706 47.1483C145.693 47.1858 145.647 47.0589 145.616 46.8987C145.583 46.7385 145.568 46.5472 145.554 46.464C145.539 46.5534 145.531 46.6449 145.527 46.7365C145.506 46.5555 145.495 46.4369 145.445 46.2789C145.406 46.1749 145.362 46.0917 145.327 46.0022C145.291 45.9128 145.26 45.815 145.266 45.6944C145.273 45.5758 145.314 45.426 145.445 45.2804C145.433 45.3345 145.46 45.424 145.523 45.4635C145.587 45.503 145.662 45.5072 145.793 45.399C145.806 45.3054 145.829 45.0703 146.016 44.8228C146.11 44.7022 146.239 44.5795 146.412 44.4921C146.583 44.4027 146.808 44.3548 147.037 44.3943C147.087 44.4318 147.132 44.4734 147.176 44.515C147.387 44.5732 147.597 44.6835 147.768 44.8519C147.664 44.7958 147.507 44.7271 147.334 44.698C147.162 44.6668 146.966 44.6668 146.793 44.7147C146.447 44.8103 146.195 45.0662 146.066 45.2263C146.181 45.1931 146.204 45.2097 146.235 45.2076C146.268 45.2076 146.306 45.191 146.466 45.1494C146.587 45.1868 146.32 45.2804 146.249 45.3304C146.351 45.2888 146.485 45.2576 146.578 45.2555C146.676 45.2513 146.751 45.268 146.824 45.3012C146.83 45.2659 146.86 45.2472 146.905 45.243C146.947 45.2388 147.018 45.2576 147.068 45.2784C147.176 45.3179 147.27 45.4198 147.316 45.3803C147.141 45.1806 146.87 45.1099 146.66 45.1598C146.645 45.0932 146.745 44.9705 146.97 44.9663C147.08 44.9663 147.222 45.0017 147.341 45.087C147.462 45.1723 147.564 45.3116 147.618 45.478C147.62 45.5716 147.549 45.5571 147.474 45.5342C147.399 45.5092 147.32 45.4843 147.301 45.5009C147.339 45.5196 147.412 45.632 147.453 45.7734C147.491 45.894 147.52 46.1104 147.512 46.1436C147.466 46.0396 147.424 45.9003 147.387 45.8379C147.387 45.9065 147.407 46.0334 147.437 46.127C147.47 46.2269 147.507 46.3205 147.555 46.4161C147.647 46.6075 147.734 46.8009 147.83 47.1005C147.878 47.1941 147.934 47.3542 148.009 47.4874C148.082 47.6205 148.17 47.7224 148.211 47.7016C148.116 47.5144 148.174 47.323 148.28 47.1982C148.386 47.0713 148.528 47.0027 148.624 47.0131C148.636 47.0339 148.74 47.1962 148.915 47.3334C149.086 47.4749 149.33 47.5726 149.423 47.6288C149.555 47.7099 149.44 47.7744 149.311 47.8243C149.186 47.8784 149.026 47.9075 149.155 47.997C149.18 47.9658 149.353 47.947 149.426 47.9429C149.615 47.999 149.328 48.0594 149.757 48.0843C149.838 47.9554 150.615 48.1197 149.965 47.9741C150.373 47.9408 150.4 48.0136 150.875 47.9637C150.721 47.8867 151.258 47.608 151.621 47.4811C151.606 47.5206 151.702 47.5518 151.748 47.5622C152.144 47.4957 152.435 47.3709 152.718 47.2669C153.002 47.1566 153.274 47.0381 153.601 46.8488C153.681 46.8467 154.014 46.6865 153.914 46.8217C153.993 46.7406 154.051 46.647 154.241 46.5097C154.687 46.3496 153.82 46.8259 154.191 46.751C154.172 46.6678 154.63 46.308 154.847 46.0396C154.766 46.0251 154.616 46.1457 154.451 46.2934C154.287 46.4432 154.099 46.6137 153.974 46.7261C153.87 46.5721 154.278 46.1228 154.751 45.555C154.939 45.3345 154.991 45.3012 155.018 45.32C155.045 45.3366 155.034 45.4032 155.055 45.3553C155.099 45.3033 155.138 45.2534 155.172 45.2056C155.193 45.1744 155.218 45.1432 155.236 45.1182C155.253 45.0953 155.27 45.0745 155.286 45.0537C155.349 44.9684 155.397 44.8935 155.43 44.8228C155.501 44.6835 155.526 44.5711 155.545 44.4713C155.557 44.3798 155.57 44.2924 155.586 44.1822C155.593 44.1406 155.599 44.0969 155.607 44.0428C155.613 43.995 155.617 43.9409 155.611 43.8702C155.624 43.7495 155.651 43.7079 155.715 43.7017C155.776 43.6934 155.847 43.7308 155.867 43.6767C156.001 43.8826 155.957 44.0948 155.894 44.2383C155.83 44.3902 155.738 44.5067 155.657 44.6481C155.742 44.5441 155.817 44.4297 155.878 44.3091C155.874 44.3881 155.838 44.5067 155.784 44.6211C155.728 44.7355 155.657 44.8436 155.588 44.906C155.657 44.8582 155.763 44.7313 155.867 44.542C155.967 44.359 156.072 44.0823 156.001 43.7932C155.967 43.6497 155.874 43.5207 155.774 43.4126C155.674 43.3023 155.563 43.2025 155.449 43.113C155.22 42.9341 154.978 42.7989 154.778 42.6866C154.614 42.6554 154.341 42.6013 154.447 42.6866C154.537 42.7137 154.626 42.7449 154.716 42.7761C154.816 42.8697 154.682 42.8447 154.564 42.8239C154.443 42.8052 154.339 42.7865 154.493 42.8676C154.13 42.7969 153.693 42.7781 153.197 42.5909L153.133 42.4391C153.133 42.4786 153.449 42.6013 153.603 42.6055C153.379 42.5993 152.858 42.2248 152.581 42.3372L152.922 42.5119C152.535 42.4828 152.064 42.5202 151.6 42.3892C151.796 42.5597 151.714 42.3954 152.01 42.6097C151.889 42.489 152.181 42.5493 152.45 42.6117C152.718 42.6741 152.964 42.7365 152.764 42.5847C153.052 42.8343 153.318 42.7989 153.699 43.0652C153.699 43.0215 153.574 42.9404 153.939 43.0735C153.96 43.0673 154.003 43.0631 154.03 43.0631C154.041 43.0673 154.045 43.0693 154.053 43.0735C154.047 43.0693 154.041 43.0673 154.035 43.0631C154.053 43.0631 154.053 43.0631 154.028 43.0589C153.947 43.0132 153.88 42.9695 153.858 42.9383C153.966 42.9196 154.166 42.9549 154.355 43.0049C154.547 43.0569 154.728 43.1276 154.828 43.1484C155.009 43.267 154.726 43.1484 154.809 43.2462C154.905 43.267 155.001 43.294 155.095 43.3231C155.082 43.4188 155.418 43.7578 155.026 43.5353C155.136 43.6122 155.238 43.6954 155.32 43.7849C155.332 43.8078 155.347 43.8327 155.361 43.8577C155.368 43.8722 155.368 43.8826 155.372 43.8951C155.378 43.918 155.38 43.943 155.382 43.9658C155.386 43.9866 155.382 44.0095 155.386 44.0282C155.386 44.0386 155.386 44.049 155.388 44.0594C155.388 44.074 155.388 44.0927 155.388 44.1073C155.343 44.2175 155.293 44.5358 155.311 44.3569C155.27 44.4484 155.218 44.5462 155.157 44.6419C155.128 44.6897 155.095 44.7375 155.061 44.7875L155.009 44.8603L154.982 44.8956L154.934 44.958L154.909 44.9539L154.826 45.0683L154.751 45.164C154.701 45.2284 154.645 45.295 154.587 45.3616C154.47 45.4947 154.339 45.6278 154.193 45.7547C153.901 46.0084 153.556 46.2393 153.149 46.3704C152.947 46.5118 152.733 46.6595 152.341 46.803L152.235 46.7593C152.164 46.7968 152.073 46.8342 151.973 46.8675C151.906 46.8904 151.95 46.8737 151.877 46.8883C151.823 46.8987 151.769 46.907 151.717 46.9174C151.506 46.9549 151.319 46.9819 151.26 47.036C151.075 46.9569 150.709 47.0027 150.325 47.0235C150.134 47.0339 149.938 47.0381 149.759 47.0277C149.669 47.0235 149.586 47.0131 149.509 47.0027C149.471 46.9965 149.434 46.9881 149.401 46.9819C149.373 46.9736 149.348 46.9653 149.326 46.959L149.284 47.0589C149.013 46.9736 148.811 46.8841 148.586 46.5825L148.515 46.6491C148.395 46.5201 148.326 46.283 148.299 46.0105C148.29 45.944 148.29 45.8691 148.284 45.7963C148.278 45.7027 148.268 45.6008 148.247 45.5009C148.207 45.2992 148.134 45.0828 147.999 44.8831C148.07 44.9164 148.18 45.1369 148.207 45.295C148.174 45.0287 148.028 44.7375 147.786 44.5254C147.661 44.4172 147.53 44.3403 147.391 44.2799C147.249 44.2196 147.095 44.1822 146.943 44.1676C146.637 44.1385 146.347 44.2051 146.114 44.2883C145.872 44.3715 145.65 44.4796 145.437 44.5899C145.268 44.7625 145.156 44.8644 145.027 44.983C145.041 44.9643 145.054 44.9455 145.064 44.931C145.048 44.9497 145.023 44.9809 144.998 45.0121C144.916 45.0932 144.835 45.1848 144.764 45.2992C144.833 45.2076 144.904 45.1265 144.964 45.0599C144.846 45.2201 144.721 45.5134 144.706 45.7942C144.664 45.8275 144.627 45.8628 144.589 45.9003C144.589 45.9232 144.587 45.9419 144.587 45.9668C144.542 46.2456 144.633 46.1832 144.708 46.0459C144.721 46.1811 144.75 46.2955 144.785 46.3808L144.773 46.4016C144.773 46.4016 144.764 46.4057 144.762 46.412C144.756 46.4161 144.75 46.4328 144.746 46.4265C144.737 46.4577 144.733 46.491 144.733 46.5285C144.729 46.6013 144.748 46.6824 144.762 46.7635C144.798 46.9278 144.844 47.0942 144.796 47.2461C144.856 47.3147 144.964 47.6059 145.125 47.8576C145.281 48.1135 145.487 48.3173 145.595 48.3111C145.581 48.3319 145.614 48.3922 145.537 48.2944C145.67 48.5128 145.831 48.7167 146.029 48.8373L146.018 49.0058C146.197 49.089 146.372 49.1639 146.553 49.2221C146.774 49.478 146.878 49.5944 146.537 49.4884C146.922 49.6589 147.078 49.713 147.22 49.7692C147.362 49.8191 147.493 49.8711 147.841 49.9044L147.784 49.973C148.026 50.0521 148.43 50.0167 148.565 50.0978C148.697 50.154 148.936 50.1997 149.24 50.2018C149.532 50.206 149.886 50.1873 150.265 50.1436C151.023 50.0625 151.867 49.869 152.537 49.7172C152.373 49.6402 152.531 49.6194 152.731 49.5861C152.929 49.5528 153.168 49.505 153.158 49.4052C153.254 49.4301 153.443 49.3885 153.256 49.5196C153.572 49.3594 153.814 49.2741 154.024 49.1888C154.237 49.1035 154.42 49.0162 154.597 48.8456C154.693 48.8664 154.501 48.985 154.578 48.9871C154.622 48.9538 154.753 48.8498 154.83 48.8519C154.907 48.8539 154.761 48.9392 154.674 49.0058C155.299 48.7042 155.284 48.5107 155.257 48.336C155.607 48.2591 155.761 48.1717 155.938 47.9616C156.072 47.9574 156.28 47.9221 155.903 48.1259C156.126 48.0302 157.263 47.5456 157.223 47.4125C157.307 47.4083 157.529 47.269 157.577 47.2253C157.827 47.1046 157.958 47.0381 158.086 46.9673C158.215 46.8987 158.34 46.828 158.569 46.6928L158.429 46.7448C158.533 46.4993 158.796 46.4973 159.16 46.2726V46.2934C160.07 45.919 159.5 46.0376 160.408 45.684L160.314 45.6195C160.289 45.3844 161.124 45.3158 161.574 44.9684L161.37 45.0163C161.601 44.7979 162.268 44.8831 162.551 44.7646C162.62 44.75 162.472 44.8395 162.395 44.8956C163.165 44.6439 162.424 44.7313 162.94 44.4297C163.072 44.4422 162.899 44.6564 163.261 44.4838C163.463 44.4443 164.19 43.7412 164.74 43.6143C164.609 43.6206 164.477 43.6247 164.706 43.4604C164.892 43.3564 165.169 43.2649 165.435 43.1733C165.706 43.0881 165.962 42.9882 166.102 42.8301C166.158 42.8218 166.181 42.826 166.189 42.8385C166.258 42.7948 166.352 42.7428 166.454 42.6845C166.543 42.6325 166.704 42.5535 166.825 42.4516C166.95 42.3517 167.06 42.2249 167.127 42.1021C167.195 41.9794 167.218 41.865 167.216 41.7984C167.272 41.7672 167.329 41.6944 167.362 41.5946C167.397 41.4948 167.408 41.3658 167.399 41.2451C167.389 40.9976 167.274 40.6586 167.029 40.4298C166.793 40.203 166.483 40.1053 166.262 40.0886C166.039 40.0699 165.892 40.0928 165.875 40.0096C165.648 40.0637 165.448 40.1906 165.317 40.2675L164.884 40.5192L164.89 40.4776C164.319 40.7709 164.159 40.9498 164 41.1266C163.859 41.1807 163.94 41.1016 163.942 41.0808C163.09 41.4802 163.015 41.5384 162.409 42.0605L162.286 42.0085C162.13 42.1645 161.022 42.5244 160.279 43.0797C160.281 43.0652 160.287 43.0381 160.343 42.9903C160.133 43.1421 159.883 43.2794 159.625 43.4042C159.496 43.4646 159.364 43.527 159.235 43.5873C159.162 43.6143 159.089 43.6414 159.019 43.6684C158.754 43.7682 158.615 43.8348 158.34 44.2051C158.179 44.3299 158 44.463 157.804 44.6086C158.079 44.4755 158.023 44.5524 157.896 44.6751C157.773 44.7958 157.567 44.9663 157.684 44.9372C157.602 44.9892 157.521 45.0287 157.454 45.0537L157.432 45.062C157.432 45.062 157.419 45.0683 157.425 45.062L157.436 45.0433C157.45 45.0183 157.467 44.9934 157.482 44.9705C157.513 44.9206 157.54 44.8748 157.563 44.8353C157.661 44.671 157.719 44.594 157.656 44.7292L157.602 44.8124C157.721 44.6689 157.852 44.4588 157.929 44.2591C158.008 44.0678 158.033 43.8702 158.098 43.841C158.108 43.7537 158.111 43.6663 158.102 43.5748C158.088 43.4001 158.056 43.2253 158.008 43.0589C157.906 42.7074 157.715 42.3954 157.496 42.1416C157.05 41.63 156.517 41.2784 155.984 40.9789L156.015 40.9976C155.832 40.8853 155.707 40.8479 155.574 40.8C155.443 40.7563 155.315 40.721 155.191 40.6877C154.939 40.6232 154.695 40.5733 154.464 40.5171L154.614 40.7085L154.064 40.5775C153.926 40.5109 153.897 40.4152 154.287 40.5088C154.099 40.3778 153.614 40.4339 153.593 40.4651C152.839 40.2322 153.935 40.3549 153.699 40.3008L153.379 40.2405L153.447 40.2738C153.177 40.2738 153.124 40.3487 152.685 40.2114C152.418 40.0928 152.575 40.0741 152.47 40.0325C152.475 40.0221 152.441 40.0054 152.314 39.968L152.166 39.9014L152.094 39.8661L152.054 39.8453C152.008 39.8203 151.964 39.7933 151.923 39.7642C151.923 39.812 151.931 39.8661 151.956 39.9264C151.748 39.891 151.614 39.6872 151.658 39.9056C151.642 39.8411 151.579 39.7642 151.556 39.6456C151.529 39.5208 151.619 39.3794 151.725 39.2837C151.812 39.2067 151.919 39.1526 152.025 39.1089C152.064 39.0923 152.168 39.0528 152.243 39.0299C152.333 39.0029 152.418 38.9758 152.5 38.9509C152.841 38.8427 153.102 38.7366 153.197 38.7179C153.587 38.4517 154.005 38.2582 154.468 37.8838C154.403 37.9212 154.332 37.9254 154.328 37.8838C154.322 37.8401 154.387 37.759 154.566 37.5926C154.584 37.6737 154.639 37.682 154.718 37.6384C154.803 37.5884 154.941 37.4636 155.018 37.2827C155.101 37.1017 155.118 36.8729 155.088 36.6628C155.061 36.4507 155.02 36.3009 155.014 36.1719C155.028 36.2801 154.991 36.2406 154.924 36.1407C154.886 36.0866 154.841 36.018 154.789 35.941C154.718 35.8599 154.637 35.7809 154.562 35.7226C154.405 35.5999 154.243 35.523 154.155 35.5022C154.066 35.4814 154.053 35.5042 154.162 35.6166C153.972 35.5063 153.974 35.4876 153.993 35.4585C154.012 35.4335 154.047 35.4023 153.899 35.3108C153.628 35.2401 153.318 35.1881 152.993 35.2297C152.914 35.2401 152.829 35.2567 152.754 35.2754L152.677 35.2962C152.658 35.2983 152.643 35.2962 152.623 35.3004C152.483 35.3087 152.341 35.3233 152.2 35.3399C151.631 35.4065 151.046 35.5354 150.492 35.7538C150.488 35.7954 150.692 35.7809 150.473 35.9202C150.257 35.9327 150.04 35.9514 149.823 35.9743C149.615 36.0804 149.707 36.2551 149.274 36.3071C149.34 36.3113 149.44 36.3196 149.305 36.3924C148.232 36.7731 147.201 37.3097 146.176 37.8568C145.135 38.3997 144.148 39.0569 143.098 39.5104C143.396 39.4085 143.227 39.525 143.03 39.6498C143.167 39.5853 143.075 39.7309 143.127 39.7579C142.834 39.8848 142.542 40.0013 142.244 40.1074C142.165 40.3175 141.351 40.5733 141.315 40.7397L141.578 40.5837C141.286 40.904 142.238 40.6503 142.28 40.852C142.442 40.6669 142.738 40.5837 143.061 40.461C143.384 40.3362 143.727 40.1781 143.971 39.8702C144.131 39.8182 143.888 40.0013 143.988 39.993C144.1 39.8182 144.281 39.681 144.658 39.4917L144.629 39.5354C145.616 38.8905 146.079 38.7345 147.289 38.1937L147.155 38.148C147.416 38.0336 147.482 38.0356 147.614 37.9982C147.839 37.7174 146.895 38.3435 147.087 38.0627C147.512 38.071 148.89 37.1911 149.221 37.3014C149.619 37.1225 149.057 37.2473 149.455 37.0705L149.586 37.0809L149.653 36.9623C149.919 36.8583 150.077 36.8771 150.109 36.9207C150.044 36.9415 149.938 37.0102 149.873 37.0435C150.232 36.9603 150.804 36.6358 150.931 36.6233C150.8 36.6545 150.669 36.6899 150.538 36.7273C151.067 36.4923 151.681 36.303 152.289 36.1948L152.516 36.1574L152.629 36.1407L152.766 36.1262C152.797 36.122 152.831 36.122 152.86 36.1116L152.943 36.0825C152.977 36.0721 153.004 36.0638 153.029 36.0575C153.081 36.045 153.133 36.0367 153.187 36.0326C153.293 36.0242 153.406 36.0326 153.52 36.0575C153.633 36.0804 153.764 36.122 153.87 36.1615C153.858 36.1366 153.843 36.1116 153.828 36.0866C154.005 36.149 154.108 36.2198 154.174 36.2842C154.237 36.3446 154.247 36.382 154.285 36.4694C154.316 36.5443 154.343 36.6233 154.37 36.7211C154.382 36.7731 154.393 36.8084 154.399 36.8604C154.405 36.9103 154.407 36.9707 154.391 37.0393C154.391 37.031 154.387 37.0247 154.385 37.0164C154.395 37.0747 154.38 37.1475 154.337 37.2119C154.32 37.239 154.278 37.2889 154.241 37.3305C154.201 37.3721 154.158 37.4137 154.112 37.4532C154.176 37.3596 154.08 37.4096 153.991 37.447C153.899 37.4844 153.816 37.5115 153.908 37.4012C153.603 37.6904 153.499 37.7465 153.456 37.8089C153.406 37.8672 153.395 37.9212 153.156 38.1313L152.995 38.1168C152.831 38.2603 152.831 38.3102 152.387 38.4787C152.733 38.2957 152.069 38.4579 152.448 38.2395C152.306 38.2624 152.193 38.279 152.06 38.3123C151.925 38.3477 151.821 38.3809 151.656 38.4579C151.36 38.5973 151.163 38.7741 151.038 38.9509C150.846 39.2233 150.752 39.4771 150.717 39.7683C150.819 39.9139 150.863 39.8973 150.854 39.8307C150.848 39.7621 150.815 39.6102 150.852 39.4563C150.919 39.1485 151.179 38.8947 151.083 39.0299C151.11 39.0091 151.131 38.9987 151.142 39.0008C151.148 38.9987 151.15 39.0008 151.148 39.0049C151.179 39.0174 151.108 39.1381 151.05 39.2962C151.023 39.3752 151 39.4688 151.002 39.5645C151.002 39.6581 151.031 39.7475 151.063 39.8141C151.148 39.9722 151.192 40.1011 151.346 40.2966C151.425 40.3903 151.546 40.5005 151.714 40.6128C151.854 40.7085 152.008 40.7917 152.218 40.8666C152.137 40.8354 152.125 40.8499 152.044 40.8167C152.333 40.9893 152.683 40.9602 153.031 41.1266C153.268 41.0455 153.51 41.241 153.608 41.0912L152.86 40.9643C153.291 41.0163 153.724 40.9103 154.389 41.1578C154.328 41.1786 154.114 41.1765 153.968 41.1703C154.16 41.2639 154.362 41.2243 154.562 41.32C154.468 41.4719 153.658 41.1557 153.179 41.1807C153.381 41.2972 154.055 41.2514 153.791 41.3783C154.162 41.2285 154.593 41.58 155.136 41.528L155.078 41.6175C155.159 41.6216 155.34 41.6196 155.461 41.6674C155.374 41.682 155.28 41.6965 155.184 41.7152C155.263 41.7152 155.336 41.7277 155.399 41.7464C155.43 41.7568 155.457 41.7672 155.48 41.7797C155.488 41.786 155.501 41.7922 155.505 41.7964C155.507 41.7984 155.513 41.8026 155.513 41.8026C155.513 41.8026 155.505 41.8213 155.528 41.786L155.553 41.8296C155.763 41.9711 155.936 42.1479 156.155 42.2498C155.813 42.0314 155.778 41.9898 155.811 41.9586C155.842 41.9295 155.932 41.9253 155.795 41.8047C156.288 42.0064 156.369 42.1604 156.448 42.3143C156.488 42.3933 156.528 42.4745 156.601 42.5785C156.673 42.6825 156.786 42.8093 156.928 42.9882C156.859 42.8967 156.646 42.5743 156.83 42.697C156.953 42.8551 157.05 43.0777 157.038 43.1858C157.067 43.2462 157.088 43.2898 157.102 43.321C157.117 43.3564 157.127 43.3793 157.138 43.3876C157.157 43.4084 157.163 43.3834 157.169 43.346C157.182 43.2711 157.177 43.163 157.248 43.269C157.221 43.3918 157.25 43.4625 157.296 43.5457C157.309 43.5665 157.321 43.5873 157.332 43.6102L157.35 43.6455C157.35 43.6455 157.357 43.6559 157.361 43.6663L157.369 43.7121C157.377 43.762 157.388 43.8119 157.394 43.866C157.394 43.9242 157.394 43.9846 157.386 44.0511L157.273 44.1031C157.238 44.1946 157.217 44.2716 157.18 44.3548C157.136 44.4443 157.096 44.5275 157.061 44.6023C156.982 44.7667 156.919 44.8977 156.867 45.0059C156.763 45.2284 156.738 45.3179 156.736 45.3595C156.742 45.4344 156.865 45.3096 156.732 45.607C156.786 45.5883 156.809 45.5924 156.85 45.5966C156.875 45.5966 156.871 45.6153 156.882 45.6278C156.892 45.6403 156.898 45.6569 156.894 45.6819L156.684 45.8275L156.303 46.0833V46.0729L156.299 46.0875C156.565 45.9689 156.673 45.9377 156.728 45.9356L156.482 46.1977C156.507 46.1832 156.53 46.1707 156.553 46.1582C156.567 46.1499 156.582 46.1436 156.594 46.1374C156.605 46.1332 156.617 46.1291 156.628 46.1249C156.661 46.1041 156.692 46.0833 156.723 46.0646C156.85 45.9835 156.957 45.9211 157.057 45.8649C157.257 45.7526 157.438 45.6694 157.729 45.528C157.686 45.5113 157.748 45.424 157.871 45.3116C157.996 45.1993 158.181 45.0641 158.419 44.931C158.729 44.8291 158.194 45.166 158.908 44.7563C158.754 44.9143 158.525 45.1327 158.238 45.1827C158.19 45.2472 158.038 45.3657 157.981 45.4344C158.165 45.374 158.429 45.2326 158.675 45.0911C158.919 44.9476 159.146 44.8145 159.291 44.7313C159.181 44.7875 159.048 44.854 158.981 44.8748L159.521 44.4983L159.648 44.4089C159.691 44.3777 159.708 44.3611 159.741 44.3361L159.91 44.2009C160.045 44.1697 159.968 44.2487 159.891 44.3257C160.037 44.2321 160.118 44.1322 160.337 44.0012C160.32 44.1052 160.377 44.1738 160.079 44.3819L160.745 43.9055C160.81 43.9097 161.16 43.789 161.083 43.866C161.501 43.6892 161.972 43.1858 162.526 42.9508C162.545 42.9217 162.593 42.878 162.697 42.8052C163.199 42.5473 163.684 42.3933 164.211 41.969L164.617 41.9128C165.056 41.63 164.075 42.0002 164.806 41.528C165.321 41.1869 165.071 41.528 165.281 41.4573C165.396 41.3512 165.55 41.1994 165.746 41.0538C165.794 41.0205 165.842 40.9851 165.892 40.9498C165.933 40.9227 165.969 40.9019 166.008 40.8874C166.089 40.8583 166.148 40.8645 166.198 40.8978C166.162 40.9103 166.135 40.9144 166.104 40.9207C166.069 40.9269 166.027 40.9394 165.979 40.9664L165.952 40.9685ZM163.172 43.3481C163.274 43.2711 163.465 43.0985 163.573 43.1089C163.499 43.2794 163.376 43.2794 163.172 43.3481ZM154.632 48.1155C154.701 48.0448 154.839 48.0011 155.001 47.9658C154.899 48.024 154.776 48.076 154.632 48.1155ZM155.463 43.9076C155.463 43.9076 155.468 43.9097 155.47 43.9118C155.459 44.0262 155.465 43.9846 155.463 43.9076ZM155.272 43.6185C155.228 43.5977 155.222 43.6122 155.226 43.6351C155.266 43.6351 155.347 43.7038 155.413 43.7911C155.413 43.7516 155.39 43.6934 155.272 43.6164V43.6185ZM152.379 40.0554L152.466 40.1157C152.235 40.0616 152.308 40.0574 152.379 40.0554Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M155.571 47.5144C155.611 47.5144 155.628 47.527 155.645 47.5417C155.681 47.5039 155.674 47.4871 155.571 47.5144Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M162.517 42.9424L162.499 42.9507C162.492 42.9612 162.49 42.9696 162.49 42.9758L162.515 42.9424H162.517Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M149.383 48.0948C149.255 48.0595 149.19 48.0304 149.142 47.9971C149.13 48.02 149.188 48.0574 149.383 48.0948Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M152.604 42.7804L152.96 42.8407C152.789 42.8033 152.735 42.7658 152.653 42.7305C152.656 42.7554 152.714 42.8054 152.606 42.7804H152.604Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M149.79 41.0812C149.742 41.0521 149.711 40.998 149.665 40.9668L149.64 41.0084C149.801 41.181 149.947 41.2601 149.79 41.0791V41.0812Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M152.352 42.3722C152.342 42.2827 152.111 42.2598 151.856 42.2266C151.871 42.2286 151.886 42.2307 151.9 42.2349C151.802 42.3389 152.077 42.3514 152.352 42.3722Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M151.799 42.2206C151.721 42.2081 151.636 42.1956 151.558 42.1748C151.516 42.2164 151.657 42.206 151.799 42.2206Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M154.73 43.3294C154.643 43.2629 154.622 43.3981 154.582 43.3419C154.505 43.3669 154.68 43.4085 154.799 43.4314C154.918 43.4563 154.999 43.4438 154.73 43.3294Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M152.208 42.0518L152.277 42.1745L152.436 42.1225L152.208 42.0518Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M154.164 42.6428L153.777 42.4951C153.777 42.5138 153.725 42.5097 153.66 42.4993C153.904 42.5721 154.162 42.6761 154.162 42.6428H154.164Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M153.662 42.4994C153.535 42.4599 153.414 42.4308 153.337 42.4287C153.406 42.4454 153.556 42.4828 153.662 42.4994Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M152.769 42.1455L152.881 42.1954L153.164 42.2745L152.769 42.1455Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M154.891 45.6336C154.795 45.7459 154.691 45.852 154.585 45.956C154.572 46.0121 154.683 45.9539 154.797 45.8291C154.86 45.7376 154.966 45.6107 154.893 45.6336H154.891Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M155.962 44.7168C155.876 44.8187 155.853 44.8146 155.782 44.8562L155.885 44.9394C155.914 44.8666 155.937 44.7896 155.962 44.7168Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M155.156 45.823C155.156 45.8854 154.722 46.3784 155.162 45.9541C155.176 45.8958 155.476 45.5173 155.156 45.823Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M148.753 47.5328C148.788 47.5516 148.824 47.5682 148.862 47.5827L148.935 47.3789C148.876 47.4351 148.818 47.485 148.753 47.5328Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M145.683 45.9918C145.733 45.8399 145.717 45.8275 145.689 45.7983C145.667 45.7775 145.635 45.7443 145.74 45.6423C145.74 45.5966 145.694 45.6361 145.654 45.6839C145.614 45.7318 145.581 45.7879 145.577 45.7401C145.554 45.9585 145.537 46.0729 145.683 45.9897V45.9918Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M145.577 45.7423C145.581 45.707 145.588 45.6695 145.596 45.6279C145.575 45.6903 145.575 45.7215 145.577 45.7423Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M141.62 40.2988L141.293 40.4091L141.524 40.3758L141.62 40.2988Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M141.095 40.7355L140.955 40.6523L140.813 40.8749C140.888 40.8208 141.026 40.7355 141.095 40.7355Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M162.189 43.5435L162.181 43.5851C162.245 43.5913 162.318 43.558 162.466 43.4873L162.189 43.5435Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M166.287 41.6133C166.287 41.6133 166.27 41.6258 166.258 41.632C166.302 41.6528 166.346 41.6694 166.389 41.684C166.352 41.6632 166.321 41.6403 166.285 41.6133H166.287Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M165.078 41.7612C165.219 41.6884 165.371 41.572 165.515 41.4971C165.221 41.6864 164.963 41.6468 165.078 41.7612Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.285 3.34908C235.737 3.07659 235.138 2.99547 234.481 3.10363C233.825 3.21387 233.169 3.41772 232.515 3.71724C231.859 4.01885 231.23 4.34542 230.631 4.69902C230.029 5.05471 229.51 5.3688 229.073 5.64128C228.254 6.18833 227.446 6.76034 226.655 7.3594C225.861 7.96053 225.084 8.55958 224.318 9.16071C225.901 8.94231 227.515 8.79255 229.154 8.70934C230.793 8.62822 232.459 8.58662 234.154 8.58662C235.629 8.58662 237.118 8.62822 238.622 8.70934C240.124 8.79047 241.613 8.96935 243.089 9.24183C243.581 9.35208 244.058 9.5164 244.524 9.73272C244.989 9.95113 245.166 10.3879 245.058 11.0432C245.003 11.48 244.797 11.8086 244.443 12.0249C244.087 12.2433 243.691 12.2995 243.254 12.1893C242.05 12.1893 240.836 12.0395 239.607 11.74C238.378 11.4404 237.133 11.2366 235.877 11.1264C234.346 11.0182 232.83 10.962 231.328 10.962C229.827 10.962 228.308 11.0161 226.78 11.1264C225.851 11.1804 224.976 11.2491 224.157 11.3302C223.339 11.4113 222.489 11.5091 221.616 11.6172C219.321 13.7451 217.191 15.9437 215.223 18.2068C213.256 20.472 211.315 22.8307 209.403 25.2873C207.546 27.7438 205.782 30.2544 204.115 32.8191C202.447 35.3859 200.987 38.0858 199.731 40.923C199.075 42.1793 198.502 43.4876 198.009 44.8522C197.517 46.2167 197.134 47.5812 196.861 48.9457C196.751 49.6009 196.682 50.2561 196.657 50.9092C196.63 51.5644 196.726 52.1905 196.945 52.7917C197.163 53.3366 197.49 53.8275 197.928 54.2643C198.365 54.7012 198.473 55.192 198.257 55.737C197.982 56.3922 197.655 56.7313 197.272 56.7604C196.888 56.7874 196.507 56.6502 196.124 56.3506C195.741 56.049 195.399 55.6684 195.099 55.2045C194.797 54.7407 194.593 54.3725 194.485 54.1C193.993 52.7355 193.898 51.3024 194.197 49.8027C194.497 48.3009 194.866 46.8968 195.303 45.5864C196.341 42.7492 197.611 40.0077 199.115 37.3598C200.616 34.714 202.241 32.1618 203.99 29.7053C205.794 27.0844 207.664 24.5489 209.605 22.0923C211.544 19.6358 213.552 17.2625 215.631 14.9703L218.417 12.0229C216.614 12.2974 214.852 12.6094 213.129 12.9651C211.409 13.3208 209.674 13.689 207.925 14.0696C204.919 14.7789 201.953 15.5568 199.031 16.4034C196.107 17.25 193.171 18.1361 190.219 19.0638C188.743 19.5547 187.281 20.0456 185.833 20.5365C184.384 21.0274 182.951 21.5744 181.53 22.1735C181.039 22.3378 180.533 22.4189 180.014 22.4189C179.495 22.4189 179.098 22.1194 178.825 21.5182C178.714 21.1376 178.756 20.7549 178.948 20.3721C179.139 19.9915 179.425 19.7169 179.808 19.5526C185.764 17.9156 191.719 16.2661 197.678 14.6C203.632 12.936 209.672 11.559 215.791 10.467C216.61 10.3027 217.43 10.1529 218.251 10.0156C219.071 9.88041 219.89 9.75768 220.71 9.64744C222.075 8.33702 223.483 7.08275 224.932 5.88257C226.38 4.68238 227.896 3.59036 229.481 2.60858C230.574 1.89929 231.776 1.28567 233.088 0.767743C234.398 0.249812 235.737 0.208212 237.104 0.64502C237.649 0.809344 238.005 1.08183 238.17 1.46456C238.335 1.84728 238.362 2.21545 238.251 2.56906C238.141 2.92475 237.91 3.21179 237.556 3.42812C237.199 3.64652 236.777 3.61948 236.285 3.347V3.34908Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.285 3.34908C235.737 3.07659 235.138 2.99547 234.481 3.10363C233.825 3.21387 233.169 3.41772 232.515 3.71724C231.859 4.01885 231.23 4.34542 230.631 4.69902C230.029 5.05471 229.51 5.3688 229.073 5.64128C228.254 6.18833 227.446 6.76034 226.655 7.3594C225.861 7.96053 225.084 8.55958 224.318 9.16071C225.901 8.94231 227.515 8.79255 229.154 8.70934C230.793 8.62822 232.459 8.58662 234.154 8.58662C235.629 8.58662 237.118 8.62822 238.622 8.70934C240.124 8.79047 241.613 8.96935 243.089 9.24183C243.581 9.35208 244.058 9.5164 244.524 9.73272C244.989 9.95113 245.166 10.3879 245.058 11.0432C245.003 11.48 244.797 11.8086 244.443 12.0249C244.087 12.2433 243.691 12.2995 243.254 12.1893C242.05 12.1893 240.836 12.0395 239.607 11.74C238.378 11.4404 237.133 11.2366 235.877 11.1264C234.346 11.0182 232.83 10.962 231.328 10.962C229.827 10.962 228.308 11.0161 226.78 11.1264C225.851 11.1804 224.976 11.2491 224.157 11.3302C223.339 11.4113 222.489 11.5091 221.616 11.6172C219.321 13.7451 217.191 15.9437 215.223 18.2068C213.256 20.472 211.315 22.8307 209.403 25.2873C207.546 27.7438 205.782 30.2544 204.115 32.8191C202.447 35.3859 200.987 38.0858 199.731 40.923C199.075 42.1793 198.502 43.4876 198.009 44.8522C197.517 46.2167 197.134 47.5812 196.861 48.9457C196.751 49.6009 196.682 50.2561 196.657 50.9092C196.63 51.5644 196.726 52.1905 196.945 52.7917C197.163 53.3366 197.49 53.8275 197.928 54.2643C198.365 54.7012 198.473 55.192 198.257 55.737C197.982 56.3922 197.655 56.7313 197.272 56.7604C196.888 56.7874 196.507 56.6502 196.124 56.3506C195.741 56.049 195.399 55.6684 195.099 55.2045C194.797 54.7407 194.593 54.3725 194.485 54.1C193.993 52.7355 193.898 51.3024 194.197 49.8027C194.497 48.3009 194.866 46.8968 195.303 45.5864C196.341 42.7492 197.611 40.0077 199.115 37.3598C200.616 34.714 202.241 32.1618 203.99 29.7053C205.794 27.0844 207.664 24.5489 209.605 22.0923C211.544 19.6358 213.552 17.2625 215.631 14.9703L218.417 12.0229C216.614 12.2974 214.852 12.6094 213.129 12.9651C211.409 13.3208 209.674 13.689 207.925 14.0696C204.919 14.7789 201.953 15.5568 199.031 16.4034C196.107 17.25 193.171 18.1361 190.219 19.0638C188.743 19.5547 187.281 20.0456 185.833 20.5365C184.384 21.0274 182.951 21.5744 181.53 22.1735C181.039 22.3378 180.533 22.4189 180.014 22.4189C179.495 22.4189 179.098 22.1194 178.825 21.5182C178.714 21.1376 178.756 20.7549 178.948 20.3721C179.139 19.9915 179.425 19.7169 179.808 19.5526C185.764 17.9156 191.719 16.2661 197.678 14.6C203.632 12.936 209.672 11.559 215.791 10.467C216.61 10.3027 217.43 10.1529 218.251 10.0156C219.071 9.88041 219.89 9.75768 220.71 9.64744C222.075 8.33702 223.483 7.08275 224.932 5.88257C226.38 4.68238 227.896 3.59036 229.481 2.60858C230.574 1.89929 231.776 1.28567 233.088 0.767743C234.398 0.249812 235.737 0.208212 237.104 0.64502C237.649 0.809344 238.005 1.08183 238.17 1.46456C238.335 1.84728 238.362 2.21545 238.251 2.56906C238.141 2.92475 237.91 3.21179 237.556 3.42812C237.199 3.64652 236.777 3.61948 236.285 3.347V3.34908Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.4 3.96906C236.156 3.8713 236.087 3.84218 236.048 3.85258C236.012 3.8609 236.023 3.89626 235.985 3.88378C236.175 3.98154 236.31 4.02522 236.391 4.04186C236.473 4.0585 236.5 4.05226 236.5 4.0377C236.496 4.01274 236.394 3.9545 236.4 3.96906Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.013 0.0395208C235.054 0.0249605 235.096 0.0124803 235.138 0C234.784 0.0353607 234.436 0.104002 234.101 0.199684C234.398 0.122722 234.702 0.0665613 235.011 0.0395208H235.013Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M229.062 2.50037C229.355 2.41092 229.836 2.08228 230.395 1.75155C230.951 1.41666 231.584 1.07346 232.117 0.865453L232.302 0.821772L232.731 0.509766C232.088 0.780171 231.369 1.14002 230.717 1.51027C230.063 1.87427 229.476 2.26532 229.06 2.50245L229.062 2.50037Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.062 4.17258C226.269 4.09562 225.496 4.65307 226.716 3.71289C226.65 3.75241 226.629 3.76281 226.589 3.78569C226.477 3.86681 226.323 3.98122 226.06 4.17258H226.062Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M226.592 3.78587C226.205 4.00636 227.138 3.38442 226.592 3.78587V3.78587Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.155 5.74507L224.805 5.1377C224.637 5.22922 224.024 5.72843 224.235 5.52042C223.556 6.1278 223.722 6.03419 224.155 5.74507Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.589 6.37073L223.924 6.05664C223.853 6.09824 223.758 6.17312 223.589 6.37073Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M224.638 5.39551L223.922 6.05696C224.036 5.99248 224.078 6.0216 224.253 5.75536C224.222 5.84064 224.338 5.68463 224.638 5.39551Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M225.082 5.06495C225.492 4.7779 226.015 4.39933 225.344 4.99215C226.005 4.4555 226.282 4.22045 226.213 4.23501C226.148 4.25165 225.74 4.52414 225.082 5.06703V5.06495Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M228.873 2.80806L229.454 2.4919C229.604 2.37542 229.758 2.25893 229.914 2.14453C229.679 2.31509 228.815 2.78726 228.873 2.80598V2.80806Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M220.3 9.02287C220.287 9.03119 220.3 9.03951 220.321 9.04575C220.331 9.04783 220.346 9.05199 220.362 9.05407C220.373 9.05823 220.371 9.06239 220.377 9.06655C220.392 9.08527 220.427 9.10191 220.448 9.11855C220.456 9.11855 220.458 9.11855 220.462 9.11855C220.458 9.10607 220.662 8.8939 220.802 8.74414C220.729 8.80654 220.635 8.8835 220.542 8.96462L220.471 9.02495L220.45 9.03743C220.437 9.04367 220.425 9.04991 220.414 9.05407C220.392 9.05199 220.375 9.04575 220.367 9.03951L220.36 9.03327C220.35 9.03327 220.339 9.03327 220.331 9.03119C220.312 9.03119 220.302 9.02703 220.296 9.02287H220.3Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M220.463 9.11914L220.454 9.12954L220.388 9.15242L220.377 9.15658L220.348 9.16282L220.29 9.1753L220.175 9.19818L219.715 9.29386C220.013 9.25226 220.225 9.21898 220.373 9.19194C220.433 9.17738 220.454 9.16698 220.465 9.15658C220.475 9.13578 220.469 9.12538 220.46 9.11914H220.463Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M223.578 6.60174C223.957 6.22317 224.34 5.84876 224.73 5.47852C224.261 5.91532 223.801 6.35837 223.345 6.80558L223.578 6.60174Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M216.607 9.62186L217.138 9.44922L216.187 9.73626L216.607 9.62186Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M214.183 10.0803C214.575 9.94515 213.613 10.0803 214.031 9.96387C213.373 10.097 212.819 10.2592 212.321 10.4048C212.854 10.2738 213.429 10.1677 214.183 10.0803Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M211.483 10.6414C211.75 10.5728 212.023 10.4917 212.321 10.4043C212.037 10.475 211.76 10.552 211.483 10.6414Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M218.066 9.52855C217.989 9.52231 217.837 9.49943 217.293 9.57639L217.687 9.59719C217.801 9.57639 217.932 9.55351 218.066 9.52855Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M217.701 9.59766H217.687C217.276 9.67046 216.991 9.72038 216.87 9.74118C216.974 9.72246 217.224 9.67878 217.701 9.59766Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M218.162 9.50977C218.126 9.51607 218.101 9.52027 218.065 9.52657C218.103 9.52867 218.126 9.52657 218.162 9.50977Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M221.612 8.24316C221.223 8.66749 220.394 9.52863 221.287 8.7923C221.546 8.46781 221.031 8.8859 221.612 8.24316Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M218.652 9.55192L219.681 9.4188C219.658 9.398 219.467 9.39176 219.746 9.3252L218.652 9.55192Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M218.154 9.65576L218.652 9.55176L218.269 9.60168L218.154 9.65576Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M213.242 10.3819C212.811 10.5067 212.329 10.6003 211.79 10.7168C212.373 10.6169 212.977 10.5109 213.548 10.4006C213.623 10.3569 213.864 10.2592 213.242 10.3819Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M215.408 10.0049C215.379 10.0112 215.339 10.0217 215.312 10.028C215.373 10.0238 215.423 10.0175 215.408 10.0049Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M206.471 11.8543C206.502 11.8543 206.53 11.8522 206.561 11.8501C206.567 11.8438 206.57 11.8375 206.578 11.8291L206.473 11.8522L206.471 11.8543Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M213.65 10.4005C214.092 10.336 214.348 10.2653 214.592 10.1904C214.267 10.2612 213.921 10.3319 213.548 10.4026C213.515 10.4213 213.509 10.4317 213.648 10.4026L213.65 10.4005Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M210.005 10.9869C210.236 10.9578 210.496 10.9204 210.771 10.8809C210.544 10.8996 210.082 10.9474 210.005 10.9869Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M215.161 10.0305C215.182 10.0242 215.203 10.02 215.226 10.0137C215.079 10.02 215.097 10.0263 215.161 10.0305Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M215.159 10.0304C214.937 10.0845 214.766 10.1386 214.591 10.1906C214.855 10.1344 215.099 10.0803 215.309 10.0283C215.255 10.0325 215.199 10.0325 215.157 10.0283L215.159 10.0304Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M205.001 12.7942C205.057 12.6943 206.175 12.349 207.179 12.2159C208.133 11.9372 207.442 11.8103 206.561 11.8498C206.54 11.8914 206.546 11.9247 205.561 12.2034C205.919 12.1639 207.796 11.802 206.971 12.0662C205.661 12.4094 205.884 12.2846 205.232 12.3927C205.798 12.3636 203.593 12.9398 203.918 13.023L205.057 12.6923C205.084 12.711 204.676 12.8462 205.001 12.7921V12.7942Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M208.464 11.4358L208.872 11.3359C208.4 11.4254 208.058 11.4628 207.425 11.5377C206.75 11.7311 206.615 11.7935 206.575 11.831L208.602 11.3921L208.464 11.4358Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M210.722 10.9476C210.417 11.1015 209.436 11.3469 210.063 11.3178C211.271 11.062 210.894 11.0661 211.611 10.8831C209.664 11.3012 212.161 10.7167 210.74 10.9559C211.121 10.8602 211.465 10.7874 211.79 10.7188C211.436 10.7749 211.092 10.8311 210.772 10.8831C210.79 10.8831 210.803 10.881 210.817 10.8789H210.826C210.913 10.8727 210.94 10.8748 210.844 10.8872C210.838 10.8893 210.815 10.8956 210.805 10.8976C210.794 10.9122 210.761 10.9309 210.724 10.9496C210.155 11.0474 210.63 10.9455 210.805 10.8976C210.811 10.8914 210.826 10.8852 210.826 10.8789C210.826 10.8789 210.821 10.8789 210.817 10.8789L208.872 11.3386C209.289 11.2637 209.805 11.1472 210.722 10.9496V10.9476Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M220.646 9.63052C220.584 9.63052 220.586 9.62428 220.579 9.62012C220.464 9.64924 220.416 9.6638 220.646 9.63052Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M219.835 9.69524C219.906 9.67652 219.971 9.6578 220.075 9.63076C220.127 9.61828 220.189 9.60372 220.268 9.59124C220.348 9.57668 220.448 9.56212 220.539 9.54964C220.608 9.54548 220.652 9.5434 220.66 9.54756C220.706 9.51636 220.695 9.53716 220.67 9.57044C220.633 9.58708 220.566 9.60788 220.579 9.61828C220.608 9.61204 220.643 9.60164 220.683 9.59332C220.731 9.53924 220.783 9.47892 220.829 9.42484C220.874 9.37076 220.916 9.32083 220.931 9.29587C220.945 9.27091 220.935 9.26675 220.885 9.30211C220.862 9.31876 220.822 9.34996 220.781 9.38116C220.743 9.41236 220.695 9.4498 220.637 9.49972C220.637 9.49972 220.631 9.49972 220.627 9.49972L220.518 9.52884C220.425 9.53716 220.329 9.54756 220.231 9.55588C220.127 9.5642 220.021 9.57252 219.916 9.58084C219.708 9.59748 219.508 9.60788 219.337 9.6162C218.994 9.63284 218.769 9.63492 218.838 9.61828C219.083 9.66404 219.296 9.69108 219.837 9.69316L219.835 9.69524Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M215.22 10.3066L213.598 10.654L214.443 10.575L214.393 10.5354C215.324 10.3836 215.114 10.3628 215.222 10.3066H215.22Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M206.275 11.8525L206.468 11.709L205.562 12.0584L206.275 11.8525Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M204.174 12.3597L204.232 12.2578L203.688 12.4429L204.174 12.3597Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M196.312 55.8594C196.428 55.9488 196.536 56.0216 196.645 56.0757C196.495 55.9946 196.391 55.9155 196.312 55.8594Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M194.725 53.1302L194.666 53.0615C194.722 53.205 194.752 53.2633 194.725 53.1302Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M202.628 15.9514C203.332 15.8432 204.127 15.7621 204.021 15.6934L203.788 15.6602C203.313 15.8016 202.945 15.889 202.628 15.9534V15.9514Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M205.675 27.3485C205.721 27.2986 205.771 27.2466 205.819 27.1967C205.893 27.0386 205.964 26.8889 206.027 26.7578C205.921 26.9367 205.8 27.1385 205.675 27.3506V27.3485Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M205.694 27.9766L205.106 28.7046C205.244 28.5444 205.433 28.3114 205.694 27.9766Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M199.385 40.2177L199.54 39.6582C199.35 40.068 199.31 40.1845 199.318 40.2094C199.325 40.2365 199.379 40.1741 199.385 40.2157V40.2177Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M182.863 18.1875C182.263 18.3165 181.79 18.4329 181.376 18.5432C182.101 18.3976 182.696 18.3144 182.863 18.1875Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M194.686 55.4452C194.874 55.7052 194.98 55.8009 194.988 55.7822C194.776 55.5243 194.67 55.3745 194.686 55.4452Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M179.635 19.0265C179.753 19.0016 179.868 18.9766 179.989 18.9516C180.416 18.8164 180.847 18.6854 181.376 18.5439C181.107 18.598 180.822 18.6604 180.532 18.7374C180.389 18.7769 180.243 18.8185 180.099 18.8643L179.885 18.9371L179.778 18.9766L179.726 18.9974L179.639 19.0286L179.635 19.0265Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M236.774 9.15629C236.724 9.15213 236.664 9.14589 236.618 9.13965C236.601 9.15213 236.672 9.15421 236.774 9.15629Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M230.938 4.9834C230.77 5.0874 230.493 5.25588 230.234 5.41605C230.366 5.34533 230.578 5.2122 230.938 4.9834Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M195.759 14.5371C195.826 14.508 196.2 14.4102 195.759 14.5371V14.5371Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M198.001 14.2939C197.909 14.3293 197.842 14.3626 197.836 14.3855C197.867 14.3543 197.924 14.3231 198.001 14.2939Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M180.572 22.3771C180.585 22.3771 180.596 22.375 180.612 22.3729C180.474 22.3708 180.499 22.3729 180.572 22.3771Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M196.432 14.3936C196.263 14.4289 196.07 14.4726 195.861 14.5225C195.955 14.5038 196.128 14.4643 196.432 14.3936Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M196.332 14.3773C196.484 14.3378 196.605 14.3087 196.719 14.2795C196.771 14.2483 196.719 14.2546 196.332 14.3773Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M195.146 14.7117C195.398 14.641 195.634 14.5786 195.863 14.5225C195.775 14.5412 195.738 14.5453 195.759 14.537C195.63 14.5745 195.448 14.6265 195.146 14.7117Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M218.64 14.1086C218.663 14.0899 218.69 14.067 218.715 14.0442C219.014 13.6885 218.876 13.8382 218.64 14.1086Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M214.003 12.3574C213.982 12.3637 213.971 12.3658 213.952 12.3721C213.973 12.3679 214 12.3658 214.019 12.3616L214.003 12.3574Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M215.61 11.9873C214.939 12.2244 214.546 12.2848 214.017 12.3617L214.602 12.5198L215.61 11.9873Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M196.134 50.6674C196.109 50.8587 196.086 51.073 196.08 51.2872C196.072 51.5015 196.078 51.7178 196.095 51.9341C196.003 51.5514 195.972 51.1811 195.968 50.8754C195.963 50.5925 195.968 50.3574 195.972 50.2056C195.98 49.9019 195.955 49.9185 195.855 50.4802C195.928 50.5322 195.93 50.8254 195.963 51.3267C195.999 51.8197 196.097 52.4396 196.336 53.0573C196.586 53.673 196.965 54.1972 197.313 54.5404C197.513 54.7359 197.582 54.7796 197.648 54.8441C197.711 54.9002 197.757 54.9314 197.794 54.9273C197.84 55.075 197.832 55.2039 197.784 55.3495C197.807 55.2247 197.788 55.2081 197.775 55.0999C197.773 55.283 197.721 55.4182 197.675 55.5596C197.619 55.7177 197.586 55.8404 197.546 55.9611C197.525 56.0193 197.503 56.0817 197.471 56.1379C197.438 56.1961 197.403 56.2481 197.361 56.2856C197.311 56.3272 197.255 56.3563 197.144 56.3563C197.024 56.3563 196.878 56.3313 196.713 56.2481C196.486 56.1296 196.307 55.9465 196.222 55.8487C196.14 55.7489 196.151 55.7364 196.311 55.855C195.965 55.5887 195.668 55.2622 195.399 54.8774C195.184 54.5217 195.278 54.582 195.495 54.9356C195.295 54.6319 195.101 54.322 194.96 54.0245C194.941 53.985 194.928 53.9559 194.916 53.9226L194.874 53.802C194.845 53.7229 194.818 53.6377 194.793 53.5545C194.739 53.386 194.693 53.2154 194.653 53.0428L194.666 53.0552C194.61 52.9138 194.535 52.6746 194.476 52.4271C194.416 52.1795 194.376 51.9216 194.353 51.7531C194.381 51.204 194.391 52.0256 194.426 51.8842C194.383 51.4911 194.368 51.0917 194.385 50.6902C194.52 50.216 194.439 51.204 194.501 52.0111C194.612 51.4578 194.608 51.2269 194.603 50.8234C194.603 50.6237 194.612 50.3803 194.666 50.0454C194.724 49.7085 194.826 49.2508 195.007 48.6601C194.93 49.0387 194.862 49.4193 194.795 49.8021C195.105 49.1032 195.237 48.2067 195.697 46.9836C195.628 47.123 195.389 47.7345 195.218 48.1547C195.045 48.5748 194.92 48.7995 195.045 48.1422C195.157 47.7823 195.291 47.306 195.443 46.5988C195.493 46.6092 195.561 46.4449 195.653 46.1745C195.697 46.0413 195.751 45.8812 195.809 45.7044C195.874 45.5276 195.945 45.332 196.02 45.1261L196.126 45.2301C196.432 44.3253 196.342 44.3711 196.497 43.8261C196.917 42.8464 197.109 42.6883 197.29 42.4949C198.009 40.9515 196.651 43.4995 197.459 41.6504C198.109 40.3878 198.5 39.4705 199.252 37.9417C199.779 37.0972 199.24 38.133 199.448 37.8418L199.791 37.0202C199.902 36.8351 199.896 36.912 199.894 36.9495C200.233 36.2839 199.804 36.8268 200.37 35.7992C200.402 35.4456 201.801 33.8523 202.464 32.5543C202.693 32.2777 202.439 32.7436 202.543 32.6812C203.045 31.8201 203.27 31.4582 203.465 31.1274C203.659 30.7946 203.828 30.5013 204.242 29.79L205.115 28.6938C204.444 29.4759 205.092 28.3319 205.683 27.3397C205.431 27.608 205.215 27.8368 205.077 27.9949C205.411 27.4811 205.75 26.9694 206.09 26.4598C206.237 26.2934 206.167 26.4702 206.035 26.7469C206.1 26.6387 206.16 26.5368 206.206 26.4557C206.633 25.9544 206.496 26.2768 206.281 26.7011C206.127 26.8654 205.975 27.0298 205.825 27.1878C205.627 27.6038 205.456 28.0011 205.575 27.9699C205.631 27.8639 205.754 27.6704 205.894 27.4603C205.844 27.5706 205.815 27.6434 205.858 27.6059C205.906 27.5643 205.994 27.3917 206.14 27.1275L206.506 26.8779L206.517 26.7614C207.012 26.1353 207.512 25.5113 208.018 24.8936C208.93 23.4375 209.661 22.1146 211.342 19.9639C210.999 20.5567 211.39 20.1906 211.469 20.3029C210.89 20.7896 210.184 21.9753 209.297 23.0694C209.761 22.4973 209.711 22.6658 209.614 22.826C210.097 22.1417 210.586 21.4594 211.082 20.7813C211.13 20.8936 211.48 20.4173 211.934 19.9389C211.451 20.1843 213.021 18.4059 213.646 17.5926C213.742 17.5926 213.633 17.8214 212.813 18.7637C213.825 17.8193 213.779 17.2473 214.777 16.3196C214.575 16.5484 214.46 16.6649 214.406 16.7793C214.827 16.199 216.028 14.9405 215.799 15.2879L215.597 15.5126C215.933 15.1402 216.385 14.6847 216.847 14.1876C217.153 13.861 217.47 13.524 217.784 13.1892C218.122 12.8293 218.44 12.4799 218.74 12.1512C218.888 11.989 219.032 11.8288 219.171 11.6749C219.202 11.6374 219.246 11.5958 219.265 11.5646C219.209 11.575 219.155 11.5834 219.1 11.5938C218.992 11.6125 218.884 11.6312 218.78 11.6499C218.363 11.7248 217.986 11.7934 217.667 11.8579C217.026 11.9869 216.616 12.093 216.512 12.1554C216.503 12.145 216.599 12.0743 216.741 11.9931C216.88 11.912 217.07 11.8226 217.178 11.7872L216.484 11.9786L216.168 12.0722C216.068 12.1013 215.958 12.1346 215.897 12.1575L215.031 12.4674C214.454 12.6775 213.881 12.8917 213.312 13.1101C213.596 12.8959 212.315 12.7773 213.956 12.3592C213.475 12.4299 212.881 12.5256 211.894 12.7939C212.221 12.7461 212.746 12.8418 212.307 12.9499C211.059 13.0394 211.446 13.0373 209.922 13.212C210.413 13.1413 209.926 13.4928 209.162 13.6468C209.274 13.5864 209.045 13.4263 209.32 13.3431C208.703 13.5594 208.085 13.757 207.468 13.99C207.933 13.836 207.506 13.7736 207.064 13.809C207.271 13.8048 205.425 14.2021 204.93 14.3561L205.744 14.2084C203.601 14.7117 203.722 15.0633 201.616 15.6186C201.858 15.5022 202.166 15.1548 201.087 15.419C200.627 15.6706 199.077 16.5838 197.267 17.2411L196.894 17.2806L195.503 17.784C195.915 17.5635 196.713 17.1745 197.571 16.771C198.429 16.3654 199.348 15.9494 200.01 15.6894C199.204 15.8641 199.764 15.6686 198.583 16.0222C198.148 16.0846 199.2 15.733 199.55 15.6332C198.623 15.8786 197.709 16.1532 196.786 16.4132C196.949 16.5131 194.726 17.1849 194.866 17.266L197.807 16.2239C197.967 16.3238 196.197 17.1329 194.247 17.6945C193.735 17.7902 194.543 17.3409 194.489 17.3076C194.251 17.4304 192.671 17.9545 192.481 17.9753L193.283 17.6529C192.183 17.9296 191.573 18.3664 190.23 18.6305C189.78 18.7637 188.845 18.901 188.793 19.005C189.569 18.9155 189.865 19.3461 189.422 19.6248C189.263 19.6664 187.043 20.2613 186.51 20.3549C185.737 20.4797 187.512 19.6976 186.854 19.8037C186.839 19.8494 186.45 20.0304 186.287 20.1032C185.81 20.2301 186.443 19.9222 185.431 20.2842C185.306 20.4735 183.369 21.008 184.992 20.5671C184.017 20.9602 183.932 20.9165 182.784 21.37C182.984 21.3408 182.755 21.5156 182.359 21.7548C182.161 21.8733 181.922 22.0106 181.674 22.1458C181.422 22.2873 181.139 22.3725 180.878 22.4308C180.932 22.385 180.691 22.3788 180.576 22.3684C180.312 22.3933 180.056 22.4121 179.822 22.3767C179.589 22.3372 179.387 22.2186 179.237 22.0647C179.085 21.9108 178.977 21.7277 178.895 21.5447C178.825 21.3658 178.814 21.1578 178.835 20.9685C178.883 20.5858 179.073 20.2218 179.36 19.9451C179.504 19.8099 179.689 19.6893 179.879 19.6248C180.097 19.5645 180.324 19.5042 180.564 19.4376C180.751 19.423 181.693 19.2046 181.311 19.3752C181.582 19.2733 181.824 19.1568 182.417 18.9883C183.6 18.7907 181.097 19.3752 182.013 19.2754C182.065 19.1734 183.519 18.7387 184.352 18.4517C184.056 18.3997 182.39 18.9696 181.555 19.2546C181.503 19.084 182.93 18.4933 184.921 17.8568C186.51 17.37 185.646 17.7756 185.916 17.6737C188.93 16.8708 188.395 16.6628 190.925 16.095C191.946 15.9306 191.032 16.3009 191.273 16.3196C189.982 16.7231 189.253 16.8043 188.37 17.0539L189.472 16.8043C189.067 16.9561 188.205 17.2244 187.722 17.3243C188.58 17.1932 192.806 15.9348 195.151 15.3836C195.553 15.2318 196.253 14.9967 195.905 15.0466L195.176 15.265C194.476 15.3628 196.524 14.7596 195.582 14.9759C196.549 14.641 197.623 14.2354 199.029 13.9047L199.325 13.9588C199.285 13.9296 198.396 14.1293 198.017 14.277C198.579 14.0586 200.191 13.8672 200.785 13.5386L199.785 13.7092C200.76 13.3826 201.957 12.9291 203.207 12.6629C202.611 12.6795 202.926 12.7482 202.007 12.8231C202.412 12.8168 201.62 13.0165 200.885 13.2058C200.152 13.3972 199.477 13.576 200.114 13.5095C199.169 13.5802 198.538 13.8568 197.326 14.0378C197.373 14.069 197.763 14.0024 196.726 14.2666C196.682 14.2916 196.578 14.3373 196.509 14.3665C196.478 14.3748 196.465 14.3769 196.438 14.3831C196.459 14.3789 196.476 14.3769 196.497 14.3727C196.453 14.3914 196.451 14.3935 196.517 14.3685C196.767 14.3186 196.974 14.2853 197.061 14.2853C196.576 14.5225 194.935 14.9738 194.395 15.1756C193.779 15.3254 194.639 15.057 194.291 15.1049L193.483 15.4086C193.375 15.3399 191.815 15.706 193.241 15.2546L191.944 15.6103C191.165 15.7705 190.109 16.0409 189.474 16.2593C188.857 16.4091 187.957 16.7897 188.47 16.5692L186.452 17.1891L186.427 17.1704C184.417 17.7153 182.336 18.4683 179.997 18.9384C179.914 18.9654 179.829 18.9904 179.745 19.0174L179.643 19.0486L179.543 19.0965C179.479 19.1277 179.435 19.1526 179.381 19.1859C179.175 19.3086 178.975 19.475 178.804 19.6851C178.631 19.8994 178.496 20.1344 178.389 20.4298C178.285 20.7251 178.231 21.0954 178.304 21.4823C178.3 21.5343 178.304 21.6071 178.308 21.6695C178.308 21.7298 178.337 21.8068 178.348 21.8608C178.479 22.1001 178.668 22.4329 179.048 22.7033C179.233 22.8364 179.466 22.9362 179.701 22.982C179.816 23.0049 179.941 23.0153 180.043 23.0153C180.131 23.0153 180.218 23.0153 180.303 23.0153C180.649 23.0049 180.974 22.957 181.236 22.8946C181.368 22.8634 181.482 22.8301 181.576 22.7948C181.624 22.7781 181.661 22.7615 181.703 22.7449C181.753 22.7261 181.813 22.6929 181.824 22.6825C182.309 22.5972 183.313 22.1957 184.392 21.7839C184.931 21.578 185.489 21.3679 186.01 21.1828C186.533 20.9997 187.014 20.8333 187.391 20.7168L187.414 20.5962C188.449 20.2592 189.424 19.8848 190.696 19.4334L190.588 19.3669C191.679 18.955 193.475 18.5661 195.237 18.0232C195.126 18.0939 194.676 18.2208 194.353 18.2957C195.439 18.0793 196.538 17.707 197.611 17.3347C198.148 17.1496 198.677 16.9623 199.196 16.7959C199.714 16.6358 200.225 16.4985 200.714 16.4007C201.183 16.2343 201.535 16.1491 201.876 16.0804C201.833 16.0929 201.793 16.1054 201.76 16.1179C201.81 16.1054 201.882 16.0846 201.957 16.0659C202.174 16.0243 202.397 15.9806 202.636 15.9348C202.43 15.966 202.232 15.9993 202.062 16.0367C202.43 15.9348 202.988 15.7726 203.534 15.6041L203.794 15.6415C203.838 15.629 203.876 15.6186 203.921 15.6062C204.471 15.5022 204.344 15.446 204.036 15.4481C204.309 15.3607 204.559 15.2754 204.75 15.2006C205.232 15.2463 206.187 14.7804 206.833 14.8053C207.012 14.7221 207.697 14.5266 208.383 14.354C209.068 14.1793 209.741 13.9962 209.87 13.8776C209.895 13.8964 210.061 13.8735 209.759 13.938C210.386 13.8256 211.011 13.7133 211.559 13.5448L211.85 13.6156L213.173 13.1559C214.014 13.0644 214.364 13.0456 213.567 13.3056C214.539 13.0311 214.941 12.9458 215.304 12.8647C215.485 12.8231 215.658 12.7835 215.889 12.7295C215.947 12.7149 216.008 12.7003 216.074 12.6837C216.118 12.6712 216.166 12.6567 216.218 12.6421C216.332 12.6088 216.464 12.5714 216.62 12.5256C216.578 12.561 216.541 12.5963 216.503 12.6296C216.691 12.5963 216.972 12.5215 217.266 12.4549C217.409 12.4216 217.553 12.3925 217.663 12.3738C217.711 12.3675 217.797 12.3426 217.72 12.3987C217.68 12.4362 217.636 12.4715 217.592 12.5069C217.328 12.7295 217.036 13.0061 216.714 13.3285C216.624 13.418 216.532 13.5136 216.434 13.6135C216.291 13.7632 216.141 13.9213 215.985 14.0815C215.674 14.406 215.345 14.7471 215.014 15.1215C213.687 16.5879 212.223 18.2936 211.042 19.6165C211.667 19.24 209.913 20.8208 209.978 21.0538C209.803 21.1786 209.47 21.5447 209.789 21.0642C208.706 22.514 208.035 23.1442 207.408 24.2383C207.235 24.3673 207.572 23.8785 207.435 24.0033C207.358 24.126 207.129 24.4921 206.989 24.6231C206.852 24.75 207.108 24.3819 207.262 24.1385C206.158 25.6236 206.202 25.8857 206.256 26.0917C205.64 26.7989 205.377 27.1858 205.077 27.7994C204.844 28.0323 204.482 28.4421 205.129 27.4957C204.94 27.7557 204.351 28.5503 203.832 29.297C203.307 30.0375 202.838 30.7406 202.878 30.8071C202.734 30.9548 202.362 31.5476 202.282 31.6994C201.476 32.9038 201.397 33.0057 200.652 34.2163L200.879 33.8939C200.72 34.4555 200.283 34.9152 199.716 35.9115V35.8741C199.002 36.9786 198.879 37.2344 198.752 37.4841C198.627 37.7357 198.494 37.9749 197.832 39.0961L197.988 39.017C198.029 39.1751 197.736 39.6681 197.369 40.3046C197.003 40.9411 196.567 41.7232 196.307 42.4325L196.58 41.9582C196.445 42.3493 196.149 42.8464 195.847 43.3456C195.547 43.8448 195.241 44.3482 195.08 44.7309C194.999 44.8932 195.153 44.4522 195.232 44.213C194.778 45.2031 194.791 45.2967 194.839 45.3112C194.893 45.3279 194.968 45.2904 194.739 46.0725C194.585 46.3388 194.672 45.6461 194.347 46.6966C194.243 46.9524 194.083 47.7366 193.929 48.6372C193.891 48.8619 193.852 49.0948 193.812 49.3278C193.772 49.5649 193.733 49.8041 193.695 50.0371C193.625 50.5155 193.581 50.9752 193.543 51.3642C193.572 51.1915 193.61 51.023 193.637 50.996C193.666 50.969 193.677 51.0813 193.693 51.4682C193.699 52.061 193.731 52.8764 193.918 53.6564C193.964 53.8498 194.02 54.0433 194.083 54.2346C194.164 54.451 194.249 54.6132 194.341 54.7775C194.526 55.0978 194.708 55.3516 194.903 55.5596C194.98 55.6948 195.005 55.751 194.999 55.7655C195.151 55.9465 195.359 56.1795 195.62 56.4062C195.874 56.6267 196.197 56.87 196.588 56.9948C196.782 57.0572 196.988 57.0885 197.184 57.0801C197.4 57.078 197.607 57.0094 197.759 56.9033C198.071 56.6808 198.171 56.4499 198.236 56.3167C198.334 56.2439 198.446 56.1046 198.552 55.907C198.665 55.7011 198.767 55.3911 198.731 55.0271C198.7 54.661 198.494 54.297 198.236 54.0433C198.182 53.9892 198.125 53.9351 198.071 53.881C198.019 53.829 197.969 53.777 197.921 53.7229C197.823 53.6148 197.73 53.5004 197.644 53.3839C197.473 53.153 197.33 52.8972 197.228 52.6642C197.132 52.425 197.063 52.1816 197.026 51.9778C196.951 51.5659 196.982 51.2934 197.061 51.2976C197.044 50.8962 197.08 50.4406 197.117 50.0101C197.161 49.5753 197.211 49.1406 197.301 48.7225L197.319 48.7953C197.507 47.9695 197.634 47.4121 197.732 46.9878C197.825 46.5614 197.875 46.2639 197.929 45.9665C198.071 45.5983 198.013 45.8812 198.019 45.9186C198.436 44.7496 198.708 44.1235 198.933 43.5328C199.165 42.9442 199.354 42.3929 199.748 41.4216L199.939 41.2739C200 41.1366 200.127 40.862 200.302 40.4939C200.481 40.1319 200.71 39.6764 200.974 39.173C201.499 38.1642 202.16 36.964 202.711 35.872C202.711 35.8991 202.703 35.9531 202.62 36.1299C203.842 33.6547 206.385 30.7197 206.646 29.6714L207.62 28.1259C206.227 30.0333 207.687 27.7432 207.073 28.4983C207.591 27.7245 208.574 26.6158 207.918 27.5518L207.797 27.685C207.756 27.9138 208.199 27.3272 208.668 26.7073C209.137 26.0854 209.634 25.4323 209.668 25.5009C211.088 23.6684 212.554 21.8983 214.031 20.1927C215.508 18.4829 216.991 16.8417 218.505 15.2879L218.047 15.5417C218.399 15.1777 218.753 14.8178 219.111 14.4601C219.417 14.2042 219.571 14.1647 218.809 14.9301C219.265 14.5828 220.036 13.5948 220.036 13.549C221.595 12.1179 219.569 14.2541 220.038 13.8048L220.66 13.1829L220.506 13.3077C220.737 13.0331 220.862 12.8834 221.035 12.6775C221.125 12.5776 221.229 12.4653 221.368 12.3239C221.439 12.2531 221.521 12.1762 221.612 12.0867C221.645 12.0555 221.681 12.0222 221.718 11.9869C221.733 11.9723 221.75 11.9578 221.766 11.9432C221.783 11.9266 221.81 11.9349 221.831 11.9286C221.906 11.9245 221.966 11.9224 222.016 11.9203C222.085 11.9182 222.139 11.9162 222.181 11.9162C222.264 11.9162 222.304 11.9245 222.327 11.9328C222.372 11.9494 222.356 11.9682 222.516 11.9536C222.516 11.964 222.624 11.9578 223.01 11.9016C223.643 11.835 224.276 11.7602 224.909 11.7248L224.136 11.6645C224.974 11.5355 225.928 11.5293 225.036 11.4606C225.69 11.521 227.469 11.3754 229.185 11.3234C230.901 11.261 232.557 11.2776 232.953 11.3234C233.546 11.2942 234.136 11.2963 234.756 11.3192C235.381 11.3442 236.027 11.3837 236.741 11.4814C236.566 11.4461 236.427 11.3899 236.487 11.3629C236.547 11.3358 236.808 11.3296 237.426 11.4294C237.18 11.5376 237.741 11.6416 238.472 11.808C238.838 11.8912 239.242 11.989 239.621 12.0992C240.009 12.2095 240.367 12.3093 240.617 12.4029C240.171 12.2511 241.071 12.4258 241.919 12.4819C242.766 12.5423 243.545 12.5048 242.823 12.4008C242.956 12.4071 243.056 12.4133 243.133 12.4175C243.208 12.4237 243.225 12.4237 243.254 12.4403C243.295 12.4632 243.308 12.4778 243.291 12.4923C243.279 12.5069 243.258 12.5194 243.295 12.5443C243.335 12.5672 243.433 12.6151 243.683 12.6338C244.081 12.6234 244.485 12.4757 244.803 12.2219C244.966 12.0909 245.114 11.9245 245.22 11.7352C245.326 11.5459 245.391 11.3338 245.42 11.1362C245.476 10.7825 245.524 10.3145 245.257 9.86941C245.126 9.65308 244.922 9.48252 244.71 9.37852C244.533 9.29115 244.366 9.21627 244.187 9.14555C243.829 9.00411 243.466 8.88347 243.07 8.80026C242.693 8.72538 242.327 8.65882 241.948 8.59642C241.194 8.4737 240.423 8.3801 239.644 8.32393C239.594 8.35721 240.107 8.45706 239.438 8.45706C238.897 8.35305 238.353 8.26361 237.812 8.17625C237.199 8.17001 237.241 8.36345 236.129 8.20329C236.285 8.23865 236.52 8.29273 236.11 8.29273C234.183 8.18873 232.228 8.20537 230.262 8.28649C229.281 8.32809 228.291 8.38634 227.304 8.4737L226.815 8.52154L226.375 8.56938L225.496 8.67962C225.421 8.69834 225.494 8.65674 225.521 8.63386L225.623 8.55482L225.83 8.39882L226.242 8.08889L226.648 7.78936L226.846 7.64584L227.169 7.42536C227.631 7.11335 228.094 6.80342 228.556 6.49974L229.252 6.04837C229.489 5.90484 229.737 5.78212 229.981 5.65108C229.239 6.01509 229.704 5.72596 230.241 5.39731C229.883 5.59492 230.201 5.31411 230.105 5.31203C230.857 4.90226 231.605 4.52578 232.386 4.20961C232.567 4.04529 233.163 3.75616 233.775 3.5856C234.077 3.49824 234.388 3.43167 234.623 3.39007C234.854 3.34847 235.029 3.33599 235.092 3.30271C234.842 3.30687 234.602 3.34223 234.346 3.40255C234.84 3.24031 234.477 3.19455 233.973 3.21743C233.473 3.23615 232.857 3.37343 232.894 3.25071C232.617 3.40463 232.297 3.56064 231.94 3.71872C231.584 3.87888 231.188 4.04945 230.78 4.24913C230.368 4.44882 229.958 4.6797 229.535 4.92722C229.324 5.05203 229.116 5.18307 228.91 5.32243C228.712 5.47428 228.521 5.6386 228.335 5.80916C227.952 6.03173 228.606 5.53668 228.387 5.63444C228.021 6.00053 227.533 6.37077 226.586 6.99687L226.677 6.90535C226.611 6.95319 226.544 7.00103 226.477 7.04887C226.392 7.11543 226.307 7.17991 226.221 7.24439C226.048 7.3796 225.878 7.50856 225.713 7.63752C225.382 7.89129 225.067 8.13257 224.765 8.36554C224.457 8.60058 224.159 8.82522 223.872 9.04571C223.724 9.15803 223.578 9.26827 223.435 9.37644L223.216 9.54076L223.105 9.62396C223.105 9.62396 223.083 9.63852 223.083 9.64268L223.078 9.65308L223.07 9.67388C224.032 9.55948 225.059 9.43468 226.198 9.32859C226.486 9.30571 226.779 9.28075 227.086 9.25579C227.304 9.24331 227.529 9.22875 227.764 9.21419C228.198 9.19131 228.666 9.17051 229.179 9.15179L228.912 9.06443C229.672 9.03739 229.835 9.06443 230.191 9.07483C230.624 8.98331 230.091 8.99995 229.545 9.02075C229.002 9.04155 228.45 9.06859 228.841 8.96251C229.349 9.03531 230.693 8.97291 231.992 8.95211C233.294 8.92715 234.556 8.94171 234.894 9.06027C236.062 9.07691 234.552 8.93755 235.721 8.95835L236.029 9.02699L236.327 8.95419C237.093 8.98955 237.476 9.08523 237.503 9.13931C237.318 9.12475 236.974 9.13307 236.776 9.13099C237.272 9.18299 237.972 9.20587 238.588 9.22875C239.201 9.24955 239.734 9.27867 239.901 9.30571C239.532 9.25787 239.163 9.21835 238.793 9.18299C239.584 9.21627 240.417 9.28699 241.265 9.39724C241.69 9.45132 242.117 9.5158 242.546 9.5886C242.76 9.62812 242.973 9.65724 243.16 9.70716C243.36 9.75708 243.558 9.8174 243.751 9.88605C243.945 9.95469 244.139 10.0337 244.324 10.1211C244.451 10.1835 244.522 10.2501 244.57 10.3478C244.62 10.4456 244.641 10.5953 244.63 10.7617C244.626 10.8408 244.61 10.9489 244.599 11.0321C244.587 11.1091 244.566 11.1798 244.541 11.2464C244.489 11.3774 244.41 11.4814 244.299 11.573C244.187 11.6624 244.045 11.7373 243.91 11.7726C243.772 11.8101 243.624 11.8184 243.47 11.7997L243.41 11.7914L243.306 11.7706C243.235 11.7685 243.15 11.7706 243.112 11.7706C243.016 11.7706 242.92 11.7747 242.827 11.7768L243.056 11.8288C242.477 11.8413 242.071 11.8142 241.75 11.781C241.429 11.7477 241.192 11.7061 240.95 11.6582C240.709 11.6104 240.461 11.5563 240.119 11.4752C239.784 11.3982 239.332 11.2755 238.684 11.157L238.78 11.1653C238.253 11.105 237.557 11.0072 236.845 10.9115C237.178 10.9281 236.872 10.8574 236.589 10.7971C236.306 10.7368 236.047 10.6827 236.487 10.6993C235.831 10.6494 235.423 10.6515 235.156 10.6473C234.887 10.6473 234.756 10.6494 234.65 10.6598C234.44 10.6785 234.338 10.7077 233.484 10.7659L233.094 10.6744C232.513 10.7326 232.463 10.7597 231.161 10.7784C232.23 10.7097 230.328 10.6577 231.528 10.5704C230.158 10.4809 229.139 10.5621 228.31 10.6328C227.479 10.7056 226.842 10.7721 226.207 10.6993C225.588 10.8574 226.182 10.8408 226.84 10.7992C227.498 10.7617 228.227 10.7139 227.877 10.7534C228.466 10.7929 226.852 10.9677 225.998 11.0238C225.13 11.0946 224.493 10.8325 222.308 11.0987C222.524 11.0758 222.539 11.0571 222.756 11.0342C222.549 11.0425 222.347 11.0633 222.143 11.0904C222.041 11.105 221.939 11.1195 221.837 11.132C221.762 11.1424 221.685 11.1528 221.608 11.1632L221.489 11.1798L221.431 11.1882C221.414 11.1965 221.402 11.2152 221.387 11.2277C221.283 11.3296 221.177 11.4315 221.069 11.5376C220.989 11.6125 220.908 11.6915 220.825 11.7706C220.658 11.9266 220.477 12.0847 220.281 12.2427C219.963 12.7274 219.336 13.1496 219.338 13.3847C219.806 12.9042 220.279 12.4279 220.758 11.9578C219.961 12.7773 219.327 13.6572 217.955 14.9385C218.032 14.8095 218.388 14.3769 218.642 14.0857C218.219 14.4413 217.926 14.8636 217.495 15.2422C217.49 15.1257 217.905 14.6743 218.423 14.1397C218.942 13.6052 219.567 12.9895 219.965 12.5173C219.486 12.873 218.403 14.2333 218.709 13.6696C218.251 14.458 217.168 15.1964 216.293 16.4174L216.285 16.278C216.137 16.4631 215.843 16.8563 215.553 17.1787L215.98 16.5068C215.252 17.474 214.364 18.1854 213.662 19.1027C215.233 17.266 214.106 18.7699 214.829 18.044C213.906 19.213 213.583 19.5 213.219 19.812C212.856 20.1261 212.452 20.4631 211.415 21.7693C211.69 21.4095 212.54 20.4984 212.125 21.0725C211.705 21.5488 211.144 22.1749 210.859 22.4453C209.491 24.1822 211.151 22.2457 210.611 23.0174C210.045 23.529 209.974 23.8951 209.405 24.6814L209.32 24.6231C208.518 25.6049 208.472 25.7776 208.431 25.9149C208.393 26.0542 208.366 26.1665 207.666 27.0568L208.118 26.1998L207.45 27.1754L207.5 26.9091C206.814 28.0032 206.564 28.3152 205.817 29.3324C206.044 29.1327 205.873 29.5716 205.248 30.4951C204.771 31.0921 205.404 30.0853 204.536 31.4082C204.68 31.0754 204.832 30.7052 205.296 30.1893C205.309 30.1124 205.442 29.8628 205.456 29.7837C204.934 30.4202 204.288 31.4831 203.976 31.9636C204.101 31.7806 204.251 31.5642 204.338 31.4602C203.955 32.1238 203.574 32.7894 203.209 33.4654C202.984 33.7525 203.109 33.4924 203.236 33.2345C202.997 33.636 202.868 33.9355 202.524 34.5283C202.547 34.3349 202.443 34.3245 202.922 33.4737C202.561 34.1144 202.214 34.7592 201.878 35.4123C201.772 35.5205 201.241 36.3504 201.353 36.0863C200.718 37.1325 200.098 38.8111 199.383 40.2484C199.362 40.3254 199.317 40.4918 199.181 40.7872C198.477 42.1246 197.825 43.3456 197.336 45.0949C197.178 45.4028 197.024 45.7148 196.876 46.0309C196.505 47.4058 197.444 44.7476 196.84 47.0335C196.649 47.8468 196.594 47.9945 196.544 48.0049C196.499 48.0153 196.472 47.8905 196.386 48.1734C196.359 48.3814 196.328 48.6248 196.299 48.9222C196.276 49.2092 196.255 49.5171 196.236 49.852C196.22 50.1848 196.203 50.5405 196.186 50.9107C196.172 51.2997 196.184 51.7095 196.234 52.1275C196.105 51.593 196.118 51.1291 196.136 50.6486L196.134 50.6674ZM195.035 48.1796C194.974 48.5041 194.893 49.1572 194.785 49.3798C194.749 48.9888 194.866 48.7142 195.035 48.1796ZM207.329 25.4198C207.208 25.6382 206.966 25.9357 206.679 26.2622C206.858 26.0043 207.073 25.7214 207.329 25.4198ZM190.954 15.9556C190.942 15.9618 190.932 15.966 190.921 15.9702C190.192 16.1303 190.453 16.0742 190.954 15.9556ZM192.456 15.5854C192.602 15.5292 192.587 15.5188 192.521 15.523C192.423 15.577 192.09 15.6706 191.706 15.7705C191.819 15.7663 192.017 15.731 192.456 15.5854ZM222.672 11.9078L222.37 11.9141C223.041 11.808 222.853 11.8558 222.672 11.9078Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M205.696 27.8955C205.628 27.9621 205.596 27.9725 205.569 27.9787C205.506 28.0952 205.521 28.1098 205.696 27.8955Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M199.358 40.3176L199.381 40.2719C199.388 40.2427 199.388 40.2282 199.386 40.2178L199.358 40.3197V40.3176Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M186.25 19.9597C186.556 19.8723 186.731 19.8328 186.85 19.8141C186.858 19.785 186.714 19.812 186.25 19.9597Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M200.32 13.2432L199.366 13.524C199.829 13.3929 200.001 13.3721 200.239 13.3264C200.212 13.3097 200.018 13.3243 200.32 13.2432Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M208.843 11.8517C208.982 11.808 209.143 11.7872 209.28 11.7435L209.232 11.7061C208.63 11.8371 208.216 11.9702 208.845 11.8517H208.843Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M201.295 13.339C201.393 13.4035 201.986 13.2163 202.657 13.0353C202.617 13.0457 202.578 13.0562 202.538 13.0645C202.707 12.8981 201.999 13.1165 201.295 13.339Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M202.813 12.9937C203.02 12.9375 203.232 12.8814 203.436 12.8377C203.503 12.7711 203.18 12.8897 202.813 12.9937Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M194.331 15.0077C194.653 14.9411 194.499 14.8475 194.689 14.8309C195.014 14.6271 192.61 15.5444 194.331 15.0077Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M201.91 13.4742L201.643 13.4326L201.287 13.6115L201.91 13.4742Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M196.599 14.8222L197.676 14.5539C197.655 14.5414 197.788 14.4935 197.953 14.4395C197.292 14.6183 196.565 14.7972 196.599 14.8222Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M197.95 14.4413C198.294 14.3477 198.621 14.2561 198.806 14.1875C198.621 14.2395 198.223 14.3539 197.95 14.4413Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M200.452 13.8867L200.129 13.947L199.371 14.1426L200.452 13.8867Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M185.106 17.9865L183.948 18.3401C183.84 18.4087 184.162 18.3401 184.593 18.2069C184.866 18.105 185.295 17.9719 185.106 17.9865Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M188.709 17.2891C188.388 17.3556 188.359 17.339 188.174 17.3535V17.4908L188.709 17.2891Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M185.317 18.2626C185.21 18.3292 183.653 18.8326 185.127 18.4145C185.235 18.3458 186.395 17.9943 185.317 18.2626Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M188.138 19.7061L187.847 19.8059L187.957 19.9952L188.138 19.7061Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M203.409 14.6064C202.006 14.9247 203.114 14.8207 201.841 15.0953C201.529 15.2325 202.88 14.8706 202.558 15.0037C203.382 14.7292 203.832 14.6439 203.409 14.6064Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M202.557 15.0029C202.426 15.0466 202.287 15.0945 202.139 15.1485C202.378 15.0695 202.489 15.03 202.557 15.0029Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M233.939 3.75027C234.079 3.72115 234.221 3.69619 234.362 3.67539L234.573 3.64835C234.637 3.64211 234.702 3.63795 234.766 3.63379C234.604 3.62547 234.416 3.63587 234.229 3.65251C234.131 3.68371 234.035 3.71699 233.939 3.75235V3.75027Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M235.489 3.45703C235.544 3.51319 235.591 3.57143 235.637 3.63175C235.793 3.63175 235.954 3.6484 236.116 3.68168C235.952 3.59847 235.619 3.50695 235.487 3.45703H235.489Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M195.994 45.8522C195.99 45.8273 195.988 45.8023 195.986 45.7773C195.907 45.8917 195.842 46.0831 195.709 46.4887C195.803 46.2724 195.901 46.0519 195.994 45.8501V45.8522Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M197.084 56.1218C197.046 56.1155 197.007 56.1072 196.967 56.0947C197.029 56.155 197.101 56.2071 197.182 56.2487C197.147 56.2071 197.111 56.1675 197.084 56.1218Z",
                        fill: "#231F20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M196.407 47.3421C196.293 47.7706 196.205 48.2698 196.109 48.7191C196.284 47.756 196.588 47.2693 196.407 47.3421Z",
                        fill: "#231F20"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_35_3251",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "249",
                        height: "79",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $4bdf025898ed5789$var$InsLogo = ({ width: width = 24, height: height = 24 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.0729 1H6.92709C3.65334 1 1 3.65381 1 6.92709V17.0729C1 20.3467 3.65381 23 6.92756 23H17.0724C20.3462 23 23 20.3462 23 17.0724V6.92709C23 3.65334 20.3467 1 17.0729 1Z",
                stroke: "black",
                strokeWidth: "1.2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
                stroke: "black",
                strokeWidth: "1.2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 7C18.5523 7 19 6.55229 19 6C19 5.44772 18.5523 5 18 5C17.4477 5 17 5.44772 17 6C17 6.55229 17.4477 7 18 7Z",
                fill: "black"
            })
        ]
    });
const $4bdf025898ed5789$export$baafb546dd70f2d3 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
        onClick: ()=>window.open("https://instagram.com/angustbakery?igsh=YW1rdGdzdmNlcjY5"),
        className: props.className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4bdf025898ed5789$var$InsLogo, {
            ...props
        })
    });
const $4bdf025898ed5789$var$MetaLogo = ({ width: width = 24, height: height = 24 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_0_1)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "1920",
                        height: "14041",
                        transform: "translate(-259 -13888)",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "1920",
                        height: "600",
                        transform: "translate(-259 -447)",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                        id: "path-1-inside-1_0_1",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M20.4832 3.51161C18.8046 1.83436 16.6662 0.692357 14.3384 0.230001C12.0106 -0.232356 9.59792 0.00570495 7.40545 0.914079C5.21298 1.82245 3.33919 3.36034 2.02103 5.33328C0.70288 7.30621 -0.000444302 9.62559 2.10574e-07 11.9981C-1.92539e-07 15.1802 1.26408 18.232 3.51432 20.4826C5.76456 22.7332 8.81676 23.9984 11.9999 24C13.5751 24.0007 15.1352 23.6929 16.592 23.094C18.0442 22.4812 19.3651 21.5954 20.4832 20.4846C21.5981 19.3702 22.4826 18.0472 23.086 16.591C23.6894 15.1349 24 13.5742 24 11.9981C24 10.422 23.6894 8.86129 23.086 7.40517C22.4826 5.94904 21.5981 4.62601 20.4832 3.51161ZM19.6373 19.6269C17.9093 21.3617 15.6419 22.4567 13.2083 22.7316V14.8068H15.4802C15.8007 14.8068 16.1081 14.6795 16.3347 14.453C16.5613 14.2264 16.6887 13.9192 16.6887 13.5988C16.6887 13.2784 16.5613 12.9711 16.3347 12.7445C16.1081 12.518 15.8007 12.3907 15.4802 12.3907H13.2083V9.08069C13.2083 8.76029 13.3356 8.45302 13.5623 8.22647C13.7889 7.99992 14.0963 7.87264 14.4168 7.87264H15.8669C16.1874 7.87264 16.4948 7.74537 16.7214 7.51882C16.948 7.29226 17.0754 6.98499 17.0754 6.6646C17.0754 6.34421 16.948 6.03694 16.7214 5.81039C16.4948 5.58384 16.1874 5.45656 15.8669 5.45656H13.8125C13.0113 5.45656 12.2429 5.77475 11.6763 6.34113C11.1097 6.90751 10.7914 7.67568 10.7914 8.47666V12.3907H8.53164C8.21113 12.3907 7.90376 12.518 7.67713 12.7445C7.45051 12.9711 7.32319 13.2784 7.32319 13.5988C7.32319 13.9192 7.45051 14.2264 7.67713 14.453C7.90376 14.6795 8.21113 14.8068 8.53164 14.8068H10.7914V22.7316C8.54721 22.4756 6.44015 21.5213 4.76787 20.0034C3.09558 18.4855 1.94259 16.4808 1.47177 14.2724C1.00094 12.0639 1.23607 9.76345 2.14394 7.69585C3.05182 5.62826 4.58655 3.89804 6.53135 2.7496C8.47616 1.60117 10.7327 1.09255 12.9824 1.2956C15.232 1.49865 17.361 2.40311 19.0685 3.88121C20.7761 5.35931 21.976 7.33635 22.4987 9.53307C23.0214 11.7298 22.8406 14.0352 21.9816 16.1236C21.4346 17.4321 20.6384 18.622 19.6373 19.6269Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.4832 3.51161C18.8046 1.83436 16.6662 0.692357 14.3384 0.230001C12.0106 -0.232356 9.59792 0.00570495 7.40545 0.914079C5.21298 1.82245 3.33919 3.36034 2.02103 5.33328C0.70288 7.30621 -0.000444302 9.62559 2.10574e-07 11.9981C-1.92539e-07 15.1802 1.26408 18.232 3.51432 20.4826C5.76456 22.7332 8.81676 23.9984 11.9999 24C13.5751 24.0007 15.1352 23.6929 16.592 23.094C18.0442 22.4812 19.3651 21.5954 20.4832 20.4846C21.5981 19.3702 22.4826 18.0472 23.086 16.591C23.6894 15.1349 24 13.5742 24 11.9981C24 10.422 23.6894 8.86129 23.086 7.40517C22.4826 5.94904 21.5981 4.62601 20.4832 3.51161ZM19.6373 19.6269C17.9093 21.3617 15.6419 22.4567 13.2083 22.7316V14.8068H15.4802C15.8007 14.8068 16.1081 14.6795 16.3347 14.453C16.5613 14.2264 16.6887 13.9192 16.6887 13.5988C16.6887 13.2784 16.5613 12.9711 16.3347 12.7445C16.1081 12.518 15.8007 12.3907 15.4802 12.3907H13.2083V9.08069C13.2083 8.76029 13.3356 8.45302 13.5623 8.22647C13.7889 7.99992 14.0963 7.87264 14.4168 7.87264H15.8669C16.1874 7.87264 16.4948 7.74537 16.7214 7.51882C16.948 7.29226 17.0754 6.98499 17.0754 6.6646C17.0754 6.34421 16.948 6.03694 16.7214 5.81039C16.4948 5.58384 16.1874 5.45656 15.8669 5.45656H13.8125C13.0113 5.45656 12.2429 5.77475 11.6763 6.34113C11.1097 6.90751 10.7914 7.67568 10.7914 8.47666V12.3907H8.53164C8.21113 12.3907 7.90376 12.518 7.67713 12.7445C7.45051 12.9711 7.32319 13.2784 7.32319 13.5988C7.32319 13.9192 7.45051 14.2264 7.67713 14.453C7.90376 14.6795 8.21113 14.8068 8.53164 14.8068H10.7914V22.7316C8.54721 22.4756 6.44015 21.5213 4.76787 20.0034C3.09558 18.4855 1.94259 16.4808 1.47177 14.2724C1.00094 12.0639 1.23607 9.76345 2.14394 7.69585C3.05182 5.62826 4.58655 3.89804 6.53135 2.7496C8.47616 1.60117 10.7327 1.09255 12.9824 1.2956C15.232 1.49865 17.361 2.40311 19.0685 3.88121C20.7761 5.35931 21.976 7.33635 22.4987 9.53307C23.0214 11.7298 22.8406 14.0352 21.9816 16.1236C21.4346 17.4321 20.6384 18.622 19.6373 19.6269Z",
                        fill: "black",
                        stroke: "black",
                        strokeWidth: "2",
                        mask: "url(#path-1-inside-1_0_1)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_0_1",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "1920",
                        height: "14041",
                        fill: "white",
                        transform: "translate(-259 -13888)"
                    })
                })
            })
        ]
    });
const $4bdf025898ed5789$export$ee5d15dadfca9a99 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
        onClick: ()=>window.open("https://www.facebook.com/angustvancouver?mibextid=LQQJ4d"),
        className: props.className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4bdf025898ed5789$var$MetaLogo, {
            ...props
        })
    });
const $4bdf025898ed5789$var$InsImages = ({ feeds: feeds })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: feeds?.map(({ src: src, href: href })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                onClick: ()=>window.open(href),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: src
                })
            }))
    });
};


var $07c37747e79fb7be$exports = {};
$07c37747e79fb7be$exports = import.meta.resolve("jKuNj");


function $77c0aa3d8c49c357$var$Header({}) {
    const [hamburgerOpen, setHamburgerOpen] = (0, $acw62.useState)(false);
    const [hover, setHover] = (0, $acw62.useState)(false);
    const isMobile = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>s.isMobile);
    const close = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>s.shouldHeaderHide) && !isMobile && !hover;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).header, {
        className: "z-header",
        initial: {
            opacity: 1,
            y: 0
        },
        animate: {
            opacity: close ? 0 : 1,
            y: close ? "-50%" : 0
        },
        exit: {
            opacity: 1,
            y: 0
        },
        transition: {
            type: "tween"
        },
        onMouseEnter: ()=>{
            setHover(true);
        },
        onMouseLeave: ()=>{
            setHover(false);
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($07c37747e79fb7be$exports))),
                alt: "Angus T",
                className: "h-[80px] md:h-[100px] lg:h-[108px] w-auto"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "nav-span",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e91257f7345c1a13$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex items-center space-x-[24px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4bdf025898ed5789$export$baafb546dd70f2d3), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4bdf025898ed5789$export$ee5d15dadfca9a99), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "nav-hamburger",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                    onClick: ()=>setHamburgerOpen(!hamburgerOpen),
                    children: hamburgerOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($77c0aa3d8c49c357$var$HamburgerCloseIcon, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($77c0aa3d8c49c357$var$HamburgerIcon, {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1a40c751dd310c2b$export$2e2bcd8739ae039), {
                isOpen: hamburgerOpen,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e91257f7345c1a13$export$2e2bcd8739ae039), {
                        onClick: ()=>setHamburgerOpen(false)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mx-auto flex items-center justify-around space-x-[24px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4bdf025898ed5789$export$baafb546dd70f2d3), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4bdf025898ed5789$export$ee5d15dadfca9a99), {})
                        ]
                    })
                ]
            })
        ]
    });
}
var $77c0aa3d8c49c357$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($77c0aa3d8c49c357$var$Header);
const $77c0aa3d8c49c357$var$HamburgerIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "35",
        height: "35",
        viewBox: "0 0 35 35",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.46875 6.5625H29.5312V8.75H5.46875V6.5625ZM5.46875 16.4062H29.5312V18.5938H5.46875V16.4062ZM5.46875 26.25H29.5312V28.4375H5.46875V26.25Z",
            fill: "black"
        })
    });
const $77c0aa3d8c49c357$var$HamburgerCloseIcon = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M24 9.4L22.6 8L16 14.6L9.4 8L8 9.4L14.6 16L8 22.6L9.4 24L16 17.4L22.6 24L24 22.6L17.4 16L24 9.4Z",
            fill: "black"
        })
    });





var $acw62 = parcelRequire("acw62");

function $4fc6d834ebdbffc4$var$Main({ children: children }) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        checkWidth();
        function checkWidth() {
            if (!ref.current) return;
            (0, $7f1ca03e50a4c851$export$16fe725363162b27).getState().updateIsMobile(ref.current.getBoundingClientRect().width <= 1024);
        }
        window.addEventListener("resize", checkWidth);
        return ()=>window.removeEventListener("resize", checkWidth);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        ref: ref,
        children: children
    });
}
var $4fc6d834ebdbffc4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($4fc6d834ebdbffc4$var$Main);


var $40a52f5c80cca17e$exports = {};
$40a52f5c80cca17e$exports = import.meta.resolve("RkBhW");



function $ebca63daf69a6024$var$App() {
    (0, $e5577d74aee99e62$export$2e2bcd8739ae039)();
    (0, $7f1ca03e50a4c851$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fc6d834ebdbffc4$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ebca63daf69a6024$var$LoadingWrapper, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77c0aa3d8c49c357$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4bdf025898ed5789$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $ebca63daf69a6024$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($ebca63daf69a6024$var$App);
function $ebca63daf69a6024$var$LoadingWrapper({ children: children }) {
    const loading = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>!s.careers);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-white p-10",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($40a52f5c80cca17e$exports)))
        })
    });
    return children;
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $acw62.createElement($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $acw62.cloneElement(children, {
        ref: ref
    }));
}


const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $acw62.createElement((0, $6f8c626e496e1918$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $acw62.createElement((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}





var $acw62 = parcelRequire("acw62");
function $7bbbf777b15ef7cf$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(()=>()=>callback(), []);
}



const $06516233abcfeeff$var$getChildKey = (child)=>child.key || "";
function $06516233abcfeeff$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $06516233abcfeeff$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $06516233abcfeeff$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).forceRender || (0, $0316e1262c81ebb4$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $06516233abcfeeff$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $acw62.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $acw62.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $acw62.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $acw62.useRef)(true);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $06516233abcfeeff$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $acw62.createElement($acw62.Fragment, null, childrenToRender.map((child)=>$acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($06516233abcfeeff$var$getChildKey);
    const targetKeys = filteredChildren.map($06516233abcfeeff$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $06516233abcfeeff$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
                key: $06516233abcfeeff$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $acw62.createElement($acw62.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $acw62.cloneElement)(child)));
};



var $acw62 = parcelRequire("acw62");
var $faa88de4f0afd1d0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == 'symbol' || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, '');
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
$faa88de4f0afd1d0$exports = $faa88de4f0afd1d0$var$debounce;


// src/useBoolean/useBoolean.ts
function $25236fb00e125bfb$export$c32275ecbd12948f(defaultValue) {
    const [value, setValue] = (0, $acw62.useState)(!!defaultValue);
    const setTrue = (0, $acw62.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $acw62.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $acw62.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $25236fb00e125bfb$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// src/useEventListener/useEventListener.ts
function $25236fb00e125bfb$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $acw62.useRef)(handler);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $acw62.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $25236fb00e125bfb$export$5139c081cbc6c8bb(handler) {
    $25236fb00e125bfb$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $25236fb00e125bfb$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $acw62.useState)(null);
    const copy = (0, $acw62.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $25236fb00e125bfb$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $acw62.useState)(initialValue ?? 0);
    const increment = ()=>{
        setCount((x)=>x + 1);
    };
    const decrement = ()=>{
        setCount((x)=>x - 1);
    };
    const reset = ()=>{
        setCount(initialValue ?? 0);
    };
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $25236fb00e125bfb$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $acw62.useRef)(callback);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $25236fb00e125bfb$export$8103f7eb37e19f7b(countdownOptions) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ("seconds" in countdownOptions) {
        console.warn("[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.");
        isDeprecated = true;
        countStart = countdownOptions.seconds;
        intervalMs = countdownOptions.interval;
        isIncrement = countdownOptions.isIncrement;
    } else ({ countStart: countStart, intervalMs: intervalMs, isIncrement: isIncrement, countStop: countStop } = countdownOptions);
    intervalMs = intervalMs ?? 1e3;
    isIncrement = isIncrement ?? false;
    countStop = countStop ?? 0;
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $25236fb00e125bfb$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $25236fb00e125bfb$export$c32275ecbd12948f(false);
    const resetCountdown = ()=>{
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0, $acw62.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $25236fb00e125bfb$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated ? [
        count,
        {
            start: startCountdown,
            stop: stopCountdown,
            reset: resetCountdown
        }
    ] : [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $25236fb00e125bfb$export$ee5b5d04074a389e(fn) {
    const ref = (0, $acw62.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $acw62.useCallback)((...args)=>ref.current(...args), [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $25236fb00e125bfb$var$IS_SERVER = typeof window === "undefined";
function $25236fb00e125bfb$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $acw62.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($25236fb00e125bfb$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $25236fb00e125bfb$export$ee5b5d04074a389e((value)=>{
        if ($25236fb00e125bfb$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $25236fb00e125bfb$export$7080b3e976bc91ab("storage", handleStorageChange);
    $25236fb00e125bfb$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
var $25236fb00e125bfb$var$IS_SERVER2 = typeof window === "undefined";
function $25236fb00e125bfb$export$32d5543ab307c01(query, options) {
    const defaultValue = typeof options === "boolean" ? options : (options == null ? void 0 : options.defaultValue) ?? false;
    const initializeWithValue = typeof options === "boolean" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const getMatches = (query2)=>{
        if ($25236fb00e125bfb$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $25236fb00e125bfb$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $25236fb00e125bfb$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $25236fb00e125bfb$export$4673cbff94e146e2(options, localStorageKeyProps = $25236fb00e125bfb$var$LOCAL_STORAGE_KEY) {
    const counter = (0, $acw62.useRef)(0);
    counter.current++;
    const defaultValue = typeof options === "boolean" ? options : options == null ? void 0 : options.defaultValue;
    const localStorageKey = typeof options === "boolean" ? localStorageKeyProps ?? $25236fb00e125bfb$var$LOCAL_STORAGE_KEY : (options == null ? void 0 : options.localStorageKey) ?? $25236fb00e125bfb$var$LOCAL_STORAGE_KEY;
    const initializeWithValue = typeof options === "boolean" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const isDarkOS = $25236fb00e125bfb$export$32d5543ab307c01($25236fb00e125bfb$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $25236fb00e125bfb$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $25236fb00e125bfb$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay ?? 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
function $25236fb00e125bfb$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $acw62.useRef)(func);
    funcRef.current = func;
    (0, $acw62.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $25236fb00e125bfb$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $acw62.useRef)();
    $25236fb00e125bfb$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $acw62.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $25236fb00e125bfb$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $acw62.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $acw62.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $25236fb00e125bfb$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $25236fb00e125bfb$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $acw62.useRef)(null);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $25236fb00e125bfb$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $25236fb00e125bfb$export$b558662bb0641046(effect) {
    (0, $acw62.useEffect)(effect, []);
}
function $25236fb00e125bfb$export$2b86bedf890eab8(options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const [ref, setRef] = (0, $acw62.useState)(null);
    const readValue = (0, $acw62.useCallback)(()=>{
        return {
            width: (ref == null ? void 0 : ref.offsetWidth) ?? void 0,
            height: (ref == null ? void 0 : ref.offsetHeight) ?? void 0
        };
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    const [size, setSize] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return {
            width: void 0,
            height: void 0
        };
    });
    const handleSize = (0, $acw62.useCallback)(()=>{
        setSize(readValue());
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    $25236fb00e125bfb$export$7080b3e976bc91ab("resize", handleSize);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        handleSize();
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    const result = [
        setRef,
        size
    ];
    result.ref = result[0];
    result.width = size.width;
    result.height = size.height;
    return result;
}
function $25236fb00e125bfb$export$d852f5f778460fa4(url, options) {
    const cache = (0, $acw62.useRef)({});
    const cancelRequest = (0, $acw62.useRef)(false);
    const initialState = {
        error: void 0,
        data: void 0
    };
    const fetchReducer = (state2, action)=>{
        switch(action.type){
            case "loading":
                return {
                    ...initialState
                };
            case "fetched":
                return {
                    ...initialState,
                    data: action.payload
                };
            case "error":
                return {
                    ...initialState,
                    error: action.payload
                };
            default:
                return state2;
        }
    };
    const [state, dispatch] = (0, $acw62.useReducer)(fetchReducer, initialState);
    (0, $acw62.useEffect)(()=>{
        if (!url) return;
        cancelRequest.current = false;
        const fetchData = async ()=>{
            dispatch({
                type: "loading"
            });
            const currentCache = cache.current[url];
            if (currentCache) {
                dispatch({
                    type: "fetched",
                    payload: currentCache
                });
                return;
            }
            try {
                const response = await fetch(url, options);
                if (!response.ok) throw new Error(response.statusText);
                const data = await response.json();
                cache.current[url] = data;
                if (cancelRequest.current) return;
                dispatch({
                    type: "fetched",
                    payload: data
                });
            } catch (error) {
                if (cancelRequest.current) return;
                dispatch({
                    type: "error",
                    payload: error
                });
            }
        };
        fetchData();
        return ()=>{
            cancelRequest.current = true;
        };
    }, [
        url
    ]);
    return state;
}
function $25236fb00e125bfb$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $acw62.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $25236fb00e125bfb$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $25236fb00e125bfb$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $25236fb00e125bfb$export$c822f44b98c8bbf2() {
    const [isLoaded, setIsLoaded] = (0, $acw62.useState)(false);
    const handleImageOnLoad = ()=>{
        setIsLoaded(true);
    };
    const css = {
        // Thumbnail style.
        thumbnail: {
            visibility: isLoaded ? "hidden" : "visible",
            filter: "blur(8px)",
            transition: "visibility 0ms ease-out 500ms"
        },
        // Full image style.
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 500ms ease-in 0ms"
        }
    };
    return {
        handleImageOnLoad: handleImageOnLoad,
        css: css
    };
}
function $25236fb00e125bfb$export$a7395f9832c00176(optionsOrLegacyRef, legacyOptions) {
    var _a;
    const isLegacySignature = "current" in optionsOrLegacyRef;
    const options = isLegacySignature ? legacyOptions : optionsOrLegacyRef;
    const { threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false } = options ?? {};
    const [newRef, setNewRef] = (0, $acw62.useState)(null);
    const ref = isLegacySignature ? optionsOrLegacyRef.current : newRef;
    const [state, setState] = (0, $acw62.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $acw62.useRef)();
    callbackRef.current = options == null ? void 0 : options.onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $acw62.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    if (isLegacySignature) return state.entry;
    const result = [
        setNewRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $25236fb00e125bfb$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $25236fb00e125bfb$export$5964c316e853650f() {
    const isFirst = (0, $acw62.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
function $25236fb00e125bfb$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $acw62.useCallback)(()=>isMounted.current, []);
}
function $25236fb00e125bfb$export$314db5846aaeae6e(initialLocked = false, rootId = "___gatsby") {
    const [locked, setLocked] = (0, $acw62.useState)(initialLocked);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        if (!locked) return;
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = "hidden";
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) document.body.style.paddingRight = `${scrollBarWidth}px`;
        return ()=>{
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) document.body.style.paddingRight = originalPaddingRight;
        };
    }, [
        locked
    ]);
    (0, $acw62.useEffect)(()=>{
        if (locked !== initialLocked) setLocked(initialLocked);
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
function $25236fb00e125bfb$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $acw62.useState)(new Map(initialState));
    const actions = {
        set: (0, $acw62.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $acw62.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $acw62.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $acw62.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $25236fb00e125bfb$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown") {
    $25236fb00e125bfb$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    });
}
var $25236fb00e125bfb$var$IS_SERVER3 = typeof window === "undefined";
function $25236fb00e125bfb$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($25236fb00e125bfb$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        if ($25236fb00e125bfb$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $25236fb00e125bfb$export$7080b3e976bc91ab("storage", handleStorageChange);
    $25236fb00e125bfb$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $25236fb00e125bfb$var$initialSize = {
    width: void 0,
    height: void 0
};
function $25236fb00e125bfb$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $acw62.useState)($25236fb00e125bfb$var$initialSize);
    const isMounted = $25236fb00e125bfb$export$80c2a3957bcb42ea();
    const previousSize = (0, $acw62.useRef)({
        ...$25236fb00e125bfb$var$initialSize
    });
    const onResize = (0, $acw62.useRef)(void 0);
    onResize.current = options == null ? void 0 : options.onResize;
    (0, $acw62.useEffect)(()=>{
        if (!(ref == null ? void 0 : ref.current)) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $25236fb00e125bfb$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $25236fb00e125bfb$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize == null ? void 0 : onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $25236fb00e125bfb$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $25236fb00e125bfb$var$IS_SERVER4 = typeof window === "undefined";
function $25236fb00e125bfb$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($25236fb00e125bfb$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($25236fb00e125bfb$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $25236fb00e125bfb$export$40ae01be0011c1e6(setScreen, options == null ? void 0 : options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = (options == null ? void 0 : options.debounceDelay) ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $25236fb00e125bfb$export$7080b3e976bc91ab("resize", handleSize);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $25236fb00e125bfb$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $25236fb00e125bfb$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $25236fb00e125bfb$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $acw62.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $25236fb00e125bfb$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $acw62.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $25236fb00e125bfb$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $25236fb00e125bfb$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $25236fb00e125bfb$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $25236fb00e125bfb$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $25236fb00e125bfb$var$IS_SERVER5 = typeof window === "undefined";
function $25236fb00e125bfb$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $acw62.useState)(false);
    const target = (0, $acw62.useRef)(null);
    const originalStyle = (0, $acw62.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        if ($25236fb00e125bfb$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $25236fb00e125bfb$var$IS_SERVER6 = typeof window === "undefined";
function $25236fb00e125bfb$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $acw62.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($25236fb00e125bfb$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $25236fb00e125bfb$export$ee5b5d04074a389e((value)=>{
        if ($25236fb00e125bfb$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $25236fb00e125bfb$export$7080b3e976bc91ab("storage", handleStorageChange);
    $25236fb00e125bfb$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
// src/useSsr/useSsr.ts
function $25236fb00e125bfb$export$f4eafc809f5e6ccc() {
    var _a;
    const isDOM = // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    typeof window !== "undefined" && !!((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
    return {
        isBrowser: isDOM,
        isServer: !isDOM
    };
}
function $25236fb00e125bfb$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $acw62.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $acw62.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $acw62.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $acw62.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $25236fb00e125bfb$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $25236fb00e125bfb$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $25236fb00e125bfb$export$ec561688e440eda6(options) {
    const defaultValue = typeof options === "string" ? "system" : (options == null ? void 0 : options.defaultValue) ?? "system";
    const localStorageKey = typeof options === "string" ? options : (options == null ? void 0 : options.localStorageKey) ?? $25236fb00e125bfb$var$LOCAL_STORAGE_KEY2;
    const initializeWithValue = typeof options === "string" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const isDarkOS = $25236fb00e125bfb$export$32d5543ab307c01($25236fb00e125bfb$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $25236fb00e125bfb$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $25236fb00e125bfb$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $acw62.useRef)(callback);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $25236fb00e125bfb$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $acw62.useState)(!!defaultValue);
    const toggle = (0, $acw62.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
function $25236fb00e125bfb$export$496315a1608d9602(effect, deps) {
    const isFirst = $25236fb00e125bfb$export$5964c316e853650f();
    (0, $acw62.useEffect)(()=>{
        if (!isFirst) return effect();
    }, deps);
}
var $25236fb00e125bfb$var$IS_SERVER7 = typeof window === "undefined";
function $25236fb00e125bfb$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($25236fb00e125bfb$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $25236fb00e125bfb$export$40ae01be0011c1e6(setWindowSize, options == null ? void 0 : options.debounceDelay);
    function handleSize() {
        const setSize = (options == null ? void 0 : options.debounceDelay) ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $25236fb00e125bfb$export$7080b3e976bc91ab("resize", handleSize);
    $25236fb00e125bfb$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}



var $4635260bea7fd43a$exports = {};
$4635260bea7fd43a$exports = import.meta.resolve("hwi5M");


var $6edcd98a10fe152d$exports = {};
$6edcd98a10fe152d$exports = import.meta.resolve("21QxY");


function $28b6c57b6935bc3e$var$HeroSlick() {
    const displays = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>s.homeDisplay);
    const [activedIndex, setActivedIndex] = (0, $acw62.useState)(0);
    const [direction, setDirection] = (0, $acw62.useState)("right");
    const timer = (0, $acw62.useRef)(null);
    const [stopper, setStopper] = (0, $acw62.useState)(4000);
    if (!displays) return null;
    const next = (delay)=>{
        setDirection("right");
        setActivedIndex((current)=>{
            return current === displays.length - 1 ? 0 : current + 1;
        });
        if (delay) delayInterval();
    };
    const prev = (delay)=>{
        setDirection("left");
        setActivedIndex((current)=>{
            return current === 0 ? displays.length - 1 : current - 1;
        });
        if (delay) delayInterval();
    };
    const delayInterval = ()=>{
        setStopper(null);
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(()=>{
            setStopper(4000);
        }, 4000);
    };
    (0, $25236fb00e125bfb$export$f4b266cd2aae9cb1)(()=>next(false), stopper);
    (0, $acw62.useEffect)(()=>{
        ()=>{
            if (timer.current) clearTimeout(timer.current);
        };
    }, []);
    const variants = {
        hiddenNext: {
            opacity: 0,
            x: 35,
            zIndex: -10
        },
        hiddenPrev: {
            opacity: 0,
            x: -35,
            zIndex: -10
        },
        visible: {
            opacity: 1,
            x: 0,
            zIndex: 0,
            transition: {
                type: "tween",
                duration: 0.55
            }
        },
        exitNext: {
            opacity: 0,
            x: -35,
            zIndex: -10
        },
        exitPrev: {
            opacity: 0,
            x: 35,
            zIndex: -10
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "fixed top-navigationMobile md:top-navigation left-0 bottom-0 right-0 bg-white",
        children: [
            displays?.map(({ src: src }, index)=>{
                const isActive = index === activedIndex;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                    mode: "wait",
                    children: isActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).img, {
                        loading: "lazy",
                        className: "absolute h-full -left-[35px] w-[calc(100vw+70px)] min-w-[calc(100vw+70px)] object-center object-cover",
                        variants: variants,
                        initial: direction === "right" ? "hiddenNext" : "hiddenPrev",
                        animate: "visible",
                        exit: direction === "right" ? "exitNext" : "exitPrev",
                        src: src
                    }, src.slice(0, 10))
                });
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                onClick: ()=>prev(true),
                className: "fixed top-[calc((100lvh-theme(space.navigationMobile))/2)] md:top-[calc((100lvh-theme(space.navigation))/2)] translate-y-[80px] left-[11px] md:left-[52px]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4635260bea7fd43a$exports))),
                    className: "w-[45px] h-[45px] object-cover"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
                onClick: ()=>next(true),
                className: "fixed top-[calc((100lvh-theme(space.navigationMobile))/2)] md:top-[calc((100lvh-theme(space.navigation))/2)] translate-y-[80px] right-[11px] md:right-[52px]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6edcd98a10fe152d$exports))),
                    className: "w-[45px] h-[45px] object-cover"
                })
            })
        ]
    });
}
var $28b6c57b6935bc3e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($28b6c57b6935bc3e$var$HeroSlick);


var $7328b6e6a32d1a83$exports = {};
$7328b6e6a32d1a83$exports = import.meta.resolve("ejZbx");


var $7b49cefa9519a683$exports = {};
$7b49cefa9519a683$exports = import.meta.resolve("jInGW");


var $dc965ff797a9a84e$exports = {};
$dc965ff797a9a84e$exports = import.meta.resolve("iW1bO");


var $33512f93171664b6$exports = {};
$33512f93171664b6$exports = import.meta.resolve("l7kCN");


var $db9710d27ae761b2$exports = {};
$db9710d27ae761b2$exports = import.meta.resolve("7o71A");


var $ff7719e0d88ec926$exports = {};
$ff7719e0d88ec926$exports = import.meta.resolve("5BUmI");


var $f5bfc83df2e0df67$exports = {};
$f5bfc83df2e0df67$exports = import.meta.resolve("iWtd1");


var $5a769a12278e902e$exports = {};
$5a769a12278e902e$exports = import.meta.resolve("4Dium");


var $8bbf778a5167c620$exports = {};
$8bbf778a5167c620$exports = import.meta.resolve("96VQN");


var $9ea9fbf18a4e7d77$exports = {};
$9ea9fbf18a4e7d77$exports = import.meta.resolve("cVVMk");


var $ae1bc1ce220af8a0$exports = {};
$ae1bc1ce220af8a0$exports = import.meta.resolve("6CCM1");


var $d030f15ca92e9ccf$exports = {};
$d030f15ca92e9ccf$exports = import.meta.resolve("kcqoo");


var $a460a13985cecea8$exports = {};
$a460a13985cecea8$exports = import.meta.resolve("2Wbcl");



var $acw62 = parcelRequire("acw62");
// src/index.ts
// src/hooks/useChain.ts
// src/index.ts
var $8371d85a89ca5565$var$updateQueue = $8371d85a89ca5565$var$makeQueue();
var $8371d85a89ca5565$export$27f233d61a9e2fa4 = (fn)=>$8371d85a89ca5565$var$schedule(fn, $8371d85a89ca5565$var$updateQueue);
var $8371d85a89ca5565$var$writeQueue = $8371d85a89ca5565$var$makeQueue();
$8371d85a89ca5565$export$27f233d61a9e2fa4.write = (fn)=>$8371d85a89ca5565$var$schedule(fn, $8371d85a89ca5565$var$writeQueue);
var $8371d85a89ca5565$var$onStartQueue = $8371d85a89ca5565$var$makeQueue();
$8371d85a89ca5565$export$27f233d61a9e2fa4.onStart = (fn)=>$8371d85a89ca5565$var$schedule(fn, $8371d85a89ca5565$var$onStartQueue);
var $8371d85a89ca5565$var$onFrameQueue = $8371d85a89ca5565$var$makeQueue();
$8371d85a89ca5565$export$27f233d61a9e2fa4.onFrame = (fn)=>$8371d85a89ca5565$var$schedule(fn, $8371d85a89ca5565$var$onFrameQueue);
var $8371d85a89ca5565$var$onFinishQueue = $8371d85a89ca5565$var$makeQueue();
$8371d85a89ca5565$export$27f233d61a9e2fa4.onFinish = (fn)=>$8371d85a89ca5565$var$schedule(fn, $8371d85a89ca5565$var$onFinishQueue);
var $8371d85a89ca5565$var$timeouts = [];
$8371d85a89ca5565$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $8371d85a89ca5565$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $8371d85a89ca5565$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $8371d85a89ca5565$var$timeouts.splice(i, 1);
        $8371d85a89ca5565$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $8371d85a89ca5565$var$timeouts.splice($8371d85a89ca5565$var$findTimeout(time), 0, timeout);
    $8371d85a89ca5565$var$pendingCount += 1;
    $8371d85a89ca5565$var$start();
    return timeout;
};
var $8371d85a89ca5565$var$findTimeout = (time)=>~(~$8371d85a89ca5565$var$timeouts.findIndex((t)=>t.time > time) || ~$8371d85a89ca5565$var$timeouts.length);
$8371d85a89ca5565$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $8371d85a89ca5565$var$onStartQueue.delete(fn);
    $8371d85a89ca5565$var$onFrameQueue.delete(fn);
    $8371d85a89ca5565$var$onFinishQueue.delete(fn);
    $8371d85a89ca5565$var$updateQueue.delete(fn);
    $8371d85a89ca5565$var$writeQueue.delete(fn);
};
$8371d85a89ca5565$export$27f233d61a9e2fa4.sync = (fn)=>{
    $8371d85a89ca5565$var$sync = true;
    $8371d85a89ca5565$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $8371d85a89ca5565$var$sync = false;
};
$8371d85a89ca5565$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $8371d85a89ca5565$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $8371d85a89ca5565$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $8371d85a89ca5565$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$8371d85a89ca5565$export$27f233d61a9e2fa4.use = (impl)=>$8371d85a89ca5565$var$nativeRaf = impl;
$8371d85a89ca5565$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$8371d85a89ca5565$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$8371d85a89ca5565$export$27f233d61a9e2fa4.catch = console.error;
$8371d85a89ca5565$export$27f233d61a9e2fa4.frameLoop = "always";
$8371d85a89ca5565$export$27f233d61a9e2fa4.advance = ()=>{
    if ($8371d85a89ca5565$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $8371d85a89ca5565$var$update();
};
var $8371d85a89ca5565$var$ts = -1;
var $8371d85a89ca5565$var$pendingCount = 0;
var $8371d85a89ca5565$var$sync = false;
function $8371d85a89ca5565$var$schedule(fn, queue) {
    if ($8371d85a89ca5565$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $8371d85a89ca5565$var$start();
    }
}
function $8371d85a89ca5565$var$start() {
    if ($8371d85a89ca5565$var$ts < 0) {
        $8371d85a89ca5565$var$ts = 0;
        if ($8371d85a89ca5565$export$27f233d61a9e2fa4.frameLoop !== "demand") $8371d85a89ca5565$var$nativeRaf($8371d85a89ca5565$var$loop);
    }
}
function $8371d85a89ca5565$var$stop() {
    $8371d85a89ca5565$var$ts = -1;
}
function $8371d85a89ca5565$var$loop() {
    if (~$8371d85a89ca5565$var$ts) {
        $8371d85a89ca5565$var$nativeRaf($8371d85a89ca5565$var$loop);
        $8371d85a89ca5565$export$27f233d61a9e2fa4.batchedUpdates($8371d85a89ca5565$var$update);
    }
}
function $8371d85a89ca5565$var$update() {
    const prevTs = $8371d85a89ca5565$var$ts;
    $8371d85a89ca5565$var$ts = $8371d85a89ca5565$export$27f233d61a9e2fa4.now();
    const count = $8371d85a89ca5565$var$findTimeout($8371d85a89ca5565$var$ts);
    if (count) {
        $8371d85a89ca5565$var$eachSafely($8371d85a89ca5565$var$timeouts.splice(0, count), (t)=>t.handler());
        $8371d85a89ca5565$var$pendingCount -= count;
    }
    if (!$8371d85a89ca5565$var$pendingCount) {
        $8371d85a89ca5565$var$stop();
        return;
    }
    $8371d85a89ca5565$var$onStartQueue.flush();
    $8371d85a89ca5565$var$updateQueue.flush(prevTs ? Math.min(64, $8371d85a89ca5565$var$ts - prevTs) : 16.667);
    $8371d85a89ca5565$var$onFrameQueue.flush();
    $8371d85a89ca5565$var$writeQueue.flush();
    $8371d85a89ca5565$var$onFinishQueue.flush();
}
function $8371d85a89ca5565$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $8371d85a89ca5565$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $8371d85a89ca5565$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $8371d85a89ca5565$var$pendingCount -= current.size;
                $8371d85a89ca5565$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $8371d85a89ca5565$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $8371d85a89ca5565$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $8371d85a89ca5565$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $8371d85a89ca5565$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $8371d85a89ca5565$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $8371d85a89ca5565$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $8371d85a89ca5565$var$ts = -1;
        $8371d85a89ca5565$var$timeouts = [];
        $8371d85a89ca5565$var$onStartQueue = $8371d85a89ca5565$var$makeQueue();
        $8371d85a89ca5565$var$updateQueue = $8371d85a89ca5565$var$makeQueue();
        $8371d85a89ca5565$var$onFrameQueue = $8371d85a89ca5565$var$makeQueue();
        $8371d85a89ca5565$var$writeQueue = $8371d85a89ca5565$var$makeQueue();
        $8371d85a89ca5565$var$onFinishQueue = $8371d85a89ca5565$var$makeQueue();
        $8371d85a89ca5565$var$pendingCount = 0;
    }
};



var $acw62 = parcelRequire("acw62");
var $f3d407035a5bac25$var$__defProp = Object.defineProperty;
var $f3d407035a5bac25$var$__export = (target, all)=>{
    for(var name in all)$f3d407035a5bac25$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $f3d407035a5bac25$export$cceeabf822b64fc0 = {};
$f3d407035a5bac25$var$__export($f3d407035a5bac25$export$cceeabf822b64fc0, {
    assign: ()=>$f3d407035a5bac25$var$assign,
    colors: ()=>$f3d407035a5bac25$var$colors,
    createStringInterpolator: ()=>$f3d407035a5bac25$var$createStringInterpolator,
    skipAnimation: ()=>$f3d407035a5bac25$var$skipAnimation,
    to: ()=>$f3d407035a5bac25$var$to,
    willAdvance: ()=>$f3d407035a5bac25$var$willAdvance
});
// src/helpers.ts
function $f3d407035a5bac25$export$8793edee2d425525() {}
var $f3d407035a5bac25$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $f3d407035a5bac25$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $f3d407035a5bac25$export$248d38f6296296c5(a, b) {
    if ($f3d407035a5bac25$export$226b3eccf92c9ed9.arr(a)) {
        if (!$f3d407035a5bac25$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $f3d407035a5bac25$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $f3d407035a5bac25$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($f3d407035a5bac25$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $f3d407035a5bac25$export$45b10814cc054894 = (a)=>$f3d407035a5bac25$export$226b3eccf92c9ed9.und(a) ? [] : $f3d407035a5bac25$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $f3d407035a5bac25$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $f3d407035a5bac25$export$79b2f7037acddd43(items, iterator);
    }
}
var $f3d407035a5bac25$export$7ba486852759e806 = (queue, ...args)=>$f3d407035a5bac25$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $f3d407035a5bac25$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $f3d407035a5bac25$var$createStringInterpolator;
var $f3d407035a5bac25$var$to;
var $f3d407035a5bac25$var$colors = null;
var $f3d407035a5bac25$var$skipAnimation = false;
var $f3d407035a5bac25$var$willAdvance = $f3d407035a5bac25$export$8793edee2d425525;
var $f3d407035a5bac25$var$assign = (globals)=>{
    if (globals.to) $f3d407035a5bac25$var$to = globals.to;
    if (globals.now) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $f3d407035a5bac25$var$colors = globals.colors;
    if (globals.skipAnimation != null) $f3d407035a5bac25$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $f3d407035a5bac25$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $f3d407035a5bac25$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $f3d407035a5bac25$var$startQueue = /* @__PURE__ */ new Set();
var $f3d407035a5bac25$var$currentFrame = [];
var $f3d407035a5bac25$var$prevFrame = [];
var $f3d407035a5bac25$var$priority = 0;
var $f3d407035a5bac25$export$a57f5080a3bcc90a = {
    get idle () {
        return !$f3d407035a5bac25$var$startQueue.size && !$f3d407035a5bac25$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($f3d407035a5bac25$var$priority > animation.priority) {
            $f3d407035a5bac25$var$startQueue.add(animation);
            (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).onStart($f3d407035a5bac25$var$flushStartQueue);
        } else {
            $f3d407035a5bac25$var$startSafely(animation);
            (0, $8371d85a89ca5565$export$27f233d61a9e2fa4)($f3d407035a5bac25$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $f3d407035a5bac25$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($f3d407035a5bac25$var$priority) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).onFrame(()=>$f3d407035a5bac25$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $f3d407035a5bac25$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $f3d407035a5bac25$var$currentFrame.splice(prevIndex, 1);
                $f3d407035a5bac25$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $f3d407035a5bac25$var$currentFrame = [];
        $f3d407035a5bac25$var$startQueue.clear();
    }
};
function $f3d407035a5bac25$var$flushStartQueue() {
    $f3d407035a5bac25$var$startQueue.forEach($f3d407035a5bac25$var$startSafely);
    $f3d407035a5bac25$var$startQueue.clear();
    (0, $8371d85a89ca5565$export$27f233d61a9e2fa4)($f3d407035a5bac25$var$advance);
}
function $f3d407035a5bac25$var$startSafely(animation) {
    if (!$f3d407035a5bac25$var$currentFrame.includes(animation)) $f3d407035a5bac25$var$startUnsafely(animation);
}
function $f3d407035a5bac25$var$startUnsafely(animation) {
    $f3d407035a5bac25$var$currentFrame.splice($f3d407035a5bac25$var$findIndex($f3d407035a5bac25$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $f3d407035a5bac25$var$advance(dt) {
    const nextFrame = $f3d407035a5bac25$var$prevFrame;
    for(let i = 0; i < $f3d407035a5bac25$var$currentFrame.length; i++){
        const animation = $f3d407035a5bac25$var$currentFrame[i];
        $f3d407035a5bac25$var$priority = animation.priority;
        if (!animation.idle) {
            $f3d407035a5bac25$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $f3d407035a5bac25$var$priority = 0;
    $f3d407035a5bac25$var$prevFrame = $f3d407035a5bac25$var$currentFrame;
    $f3d407035a5bac25$var$prevFrame.length = 0;
    $f3d407035a5bac25$var$currentFrame = nextFrame;
    return $f3d407035a5bac25$var$currentFrame.length > 0;
}
function $f3d407035a5bac25$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $f3d407035a5bac25$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $f3d407035a5bac25$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $f3d407035a5bac25$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $f3d407035a5bac25$var$PERCENTAGE = $f3d407035a5bac25$var$NUMBER + "%";
function $f3d407035a5bac25$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $f3d407035a5bac25$export$8972dc0e6ad9238f = new RegExp("rgb" + $f3d407035a5bac25$var$call($f3d407035a5bac25$var$NUMBER, $f3d407035a5bac25$var$NUMBER, $f3d407035a5bac25$var$NUMBER));
var $f3d407035a5bac25$export$4e46ac54fc82cf3b = new RegExp("rgba" + $f3d407035a5bac25$var$call($f3d407035a5bac25$var$NUMBER, $f3d407035a5bac25$var$NUMBER, $f3d407035a5bac25$var$NUMBER, $f3d407035a5bac25$var$NUMBER));
var $f3d407035a5bac25$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $f3d407035a5bac25$var$call($f3d407035a5bac25$var$NUMBER, $f3d407035a5bac25$var$PERCENTAGE, $f3d407035a5bac25$var$PERCENTAGE));
var $f3d407035a5bac25$export$810b04175080204c = new RegExp("hsla" + $f3d407035a5bac25$var$call($f3d407035a5bac25$var$NUMBER, $f3d407035a5bac25$var$PERCENTAGE, $f3d407035a5bac25$var$PERCENTAGE, $f3d407035a5bac25$var$NUMBER));
var $f3d407035a5bac25$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $f3d407035a5bac25$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $f3d407035a5bac25$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $f3d407035a5bac25$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $f3d407035a5bac25$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $f3d407035a5bac25$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($f3d407035a5bac25$var$colors && $f3d407035a5bac25$var$colors[color] !== void 0) return $f3d407035a5bac25$var$colors[color];
    if (match = $f3d407035a5bac25$export$8972dc0e6ad9238f.exec(color)) return ($f3d407035a5bac25$var$parse255(match[1]) << 24 | // r
    $f3d407035a5bac25$var$parse255(match[2]) << 16 | // g
    $f3d407035a5bac25$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $f3d407035a5bac25$export$4e46ac54fc82cf3b.exec(color)) return ($f3d407035a5bac25$var$parse255(match[1]) << 24 | // r
    $f3d407035a5bac25$var$parse255(match[2]) << 16 | // g
    $f3d407035a5bac25$var$parse255(match[3]) << 8 | // b
    $f3d407035a5bac25$var$parse1(match[4])) >>> // a
    0;
    if (match = $f3d407035a5bac25$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $f3d407035a5bac25$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $f3d407035a5bac25$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $f3d407035a5bac25$export$8f4a7c0bb78e6ea8.exec(color)) return ($f3d407035a5bac25$var$hslToRgb($f3d407035a5bac25$var$parse360(match[1]), // h
    $f3d407035a5bac25$var$parsePercentage(match[2]), // s
    $f3d407035a5bac25$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $f3d407035a5bac25$export$810b04175080204c.exec(color)) return ($f3d407035a5bac25$var$hslToRgb($f3d407035a5bac25$var$parse360(match[1]), // h
    $f3d407035a5bac25$var$parsePercentage(match[2]), // s
    $f3d407035a5bac25$var$parsePercentage(match[3])) | $f3d407035a5bac25$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $f3d407035a5bac25$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f3d407035a5bac25$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $f3d407035a5bac25$var$hue2rgb(p, q, h + 1 / 3);
    const g = $f3d407035a5bac25$var$hue2rgb(p, q, h);
    const b = $f3d407035a5bac25$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $f3d407035a5bac25$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $f3d407035a5bac25$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $f3d407035a5bac25$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $f3d407035a5bac25$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $f3d407035a5bac25$export$61db176b839af1f(input) {
    let int32Color = $f3d407035a5bac25$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $f3d407035a5bac25$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($f3d407035a5bac25$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($f3d407035a5bac25$export$226b3eccf92c9ed9.arr(range)) return $f3d407035a5bac25$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($f3d407035a5bac25$export$226b3eccf92c9ed9.str(range.output[0])) return $f3d407035a5bac25$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $f3d407035a5bac25$var$findRange(input, inputRange);
        return $f3d407035a5bac25$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $f3d407035a5bac25$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $f3d407035a5bac25$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $f3d407035a5bac25$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $f3d407035a5bac25$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $f3d407035a5bac25$var$c1 = 1.70158;
var $f3d407035a5bac25$var$c2 = $f3d407035a5bac25$var$c1 * 1.525;
var $f3d407035a5bac25$var$c3 = $f3d407035a5bac25$var$c1 + 1;
var $f3d407035a5bac25$var$c4 = 2 * Math.PI / 3;
var $f3d407035a5bac25$var$c5 = 2 * Math.PI / 4.5;
var $f3d407035a5bac25$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $f3d407035a5bac25$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$f3d407035a5bac25$var$c3 * x * x * x - $f3d407035a5bac25$var$c1 * x * x,
    easeOutBack: (x)=>1 + $f3d407035a5bac25$var$c3 * Math.pow(x - 1, 3) + $f3d407035a5bac25$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($f3d407035a5bac25$var$c2 + 1) * 2 * x - $f3d407035a5bac25$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($f3d407035a5bac25$var$c2 + 1) * (x * 2 - 2) + $f3d407035a5bac25$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $f3d407035a5bac25$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $f3d407035a5bac25$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $f3d407035a5bac25$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $f3d407035a5bac25$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $f3d407035a5bac25$var$bounceOut(1 - x),
    easeOutBounce: $f3d407035a5bac25$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $f3d407035a5bac25$var$bounceOut(1 - 2 * x)) / 2 : (1 + $f3d407035a5bac25$var$bounceOut(2 * x - 1)) / 2,
    steps: $f3d407035a5bac25$var$steps
};
// src/fluids.ts
var $f3d407035a5bac25$var$$get = Symbol.for("FluidValue.get");
var $f3d407035a5bac25$var$$observers = Symbol.for("FluidValue.observers");
var $f3d407035a5bac25$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$f3d407035a5bac25$var$$get]);
var $f3d407035a5bac25$export$e37b7520edd66839 = (arg)=>arg && arg[$f3d407035a5bac25$var$$get] ? arg[$f3d407035a5bac25$var$$get]() : arg;
var $f3d407035a5bac25$export$133f54e9f7cf1796 = (target)=>target[$f3d407035a5bac25$var$$observers] || null;
function $f3d407035a5bac25$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $f3d407035a5bac25$export$31752c40a5fab62a(target, event) {
    const observers = target[$f3d407035a5bac25$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $f3d407035a5bac25$export$8cbca1207adce0c0(observer2, event);
    });
}
var $f3d407035a5bac25$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $f3d407035a5bac25$export$a3b4618659637aa3(this, get);
    }
};
$f3d407035a5bac25$var$$get, $f3d407035a5bac25$var$$observers;
var $f3d407035a5bac25$export$a3b4618659637aa3 = (target, get)=>$f3d407035a5bac25$var$setHidden(target, $f3d407035a5bac25$var$$get, get);
function $f3d407035a5bac25$export$72d604e3f8d000a5(target, observer2) {
    if (target[$f3d407035a5bac25$var$$get]) {
        let observers = target[$f3d407035a5bac25$var$$observers];
        if (!observers) $f3d407035a5bac25$var$setHidden(target, $f3d407035a5bac25$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $f3d407035a5bac25$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$f3d407035a5bac25$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$f3d407035a5bac25$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $f3d407035a5bac25$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $f3d407035a5bac25$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $f3d407035a5bac25$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $f3d407035a5bac25$var$unitRegex = new RegExp(`(${$f3d407035a5bac25$var$numberRegex.source})(%|[a-z]+)`, "i");
var $f3d407035a5bac25$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $f3d407035a5bac25$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $f3d407035a5bac25$var$variableToRgba = (input)=>{
    const [token, fallback] = $f3d407035a5bac25$var$parseCSSVariable(input);
    if (!token || $f3d407035a5bac25$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $f3d407035a5bac25$var$cssVariableRegex.test(fallback)) return $f3d407035a5bac25$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $f3d407035a5bac25$var$parseCSSVariable = (current)=>{
    const match = $f3d407035a5bac25$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $f3d407035a5bac25$var$namedColorRegex;
var $f3d407035a5bac25$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $f3d407035a5bac25$export$4759a013d387347a = (config)=>{
    if (!$f3d407035a5bac25$var$namedColorRegex) $f3d407035a5bac25$var$namedColorRegex = $f3d407035a5bac25$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($f3d407035a5bac25$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $f3d407035a5bac25$export$e37b7520edd66839(value).replace($f3d407035a5bac25$var$cssVariableRegex, $f3d407035a5bac25$var$variableToRgba).replace($f3d407035a5bac25$var$colorRegex, $f3d407035a5bac25$export$61db176b839af1f).replace($f3d407035a5bac25$var$namedColorRegex, $f3d407035a5bac25$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($f3d407035a5bac25$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$f3d407035a5bac25$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$f3d407035a5bac25$var$unitRegex.test(output[0]) && output.find((value)=>$f3d407035a5bac25$var$unitRegex.test(value))?.replace($f3d407035a5bac25$var$numberRegex, "");
        let i = 0;
        return output[0].replace($f3d407035a5bac25$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($f3d407035a5bac25$var$rgbaRegex, $f3d407035a5bac25$var$rgbaRound);
    };
};
// src/deprecations.ts
var $f3d407035a5bac25$export$82e9f45cca5ba907 = "react-spring: ";
var $f3d407035a5bac25$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$f3d407035a5bac25$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $f3d407035a5bac25$var$warnInterpolate = $f3d407035a5bac25$export$d2de3aaeafa91619(console.warn);
function $f3d407035a5bac25$export$2abfcde8ae218ba8() {
    $f3d407035a5bac25$var$warnInterpolate(`${$f3d407035a5bac25$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $f3d407035a5bac25$var$warnDirectCall = $f3d407035a5bac25$export$d2de3aaeafa91619(console.warn);
function $f3d407035a5bac25$export$d99d974913ad3b12() {
    $f3d407035a5bac25$var$warnDirectCall(`${$f3d407035a5bac25$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $f3d407035a5bac25$export$75bed621f62abfa9(value) {
    return $f3d407035a5bac25$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$f3d407035a5bac25$export$48d7c418edadb60c() && $f3d407035a5bac25$var$cssVariableRegex.test(value) || value in ($f3d407035a5bac25$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $f3d407035a5bac25$var$observer;
var $f3d407035a5bac25$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $f3d407035a5bac25$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $f3d407035a5bac25$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $f3d407035a5bac25$var$resizeElement(handler, target) {
    if (!$f3d407035a5bac25$var$observer) {
        if (typeof ResizeObserver !== "undefined") $f3d407035a5bac25$var$observer = new ResizeObserver($f3d407035a5bac25$var$handleObservation);
    }
    let elementHandlers = $f3d407035a5bac25$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $f3d407035a5bac25$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($f3d407035a5bac25$var$observer) $f3d407035a5bac25$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $f3d407035a5bac25$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $f3d407035a5bac25$var$observer) $f3d407035a5bac25$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $f3d407035a5bac25$var$listeners = /* @__PURE__ */ new Set();
var $f3d407035a5bac25$var$cleanupWindowResizeHandler;
var $f3d407035a5bac25$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $f3d407035a5bac25$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $f3d407035a5bac25$var$resizeWindow = (callback)=>{
    $f3d407035a5bac25$var$listeners.add(callback);
    if (!$f3d407035a5bac25$var$cleanupWindowResizeHandler) $f3d407035a5bac25$var$cleanupWindowResizeHandler = $f3d407035a5bac25$var$createResizeHandler();
    return ()=>{
        $f3d407035a5bac25$var$listeners.delete(callback);
        if (!$f3d407035a5bac25$var$listeners.size && $f3d407035a5bac25$var$cleanupWindowResizeHandler) {
            $f3d407035a5bac25$var$cleanupWindowResizeHandler();
            $f3d407035a5bac25$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $f3d407035a5bac25$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $f3d407035a5bac25$var$resizeWindow(callback);
    else return $f3d407035a5bac25$var$resizeElement(callback, container);
};
// src/progress.ts
var $f3d407035a5bac25$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $f3d407035a5bac25$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $f3d407035a5bac25$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $f3d407035a5bac25$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $f3d407035a5bac25$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $f3d407035a5bac25$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $f3d407035a5bac25$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $f3d407035a5bac25$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $f3d407035a5bac25$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $f3d407035a5bac25$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $f3d407035a5bac25$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $f3d407035a5bac25$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $f3d407035a5bac25$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$f3d407035a5bac25$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $f3d407035a5bac25$var$scrollListeners.set(container, listener);
        const target = $f3d407035a5bac25$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $f3d407035a5bac25$var$resizeListeners.set(container, $f3d407035a5bac25$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $f3d407035a5bac25$var$scrollListeners.get(container);
    (0, $8371d85a89ca5565$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers2 = $f3d407035a5bac25$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $f3d407035a5bac25$var$scrollListeners.get(container);
        $f3d407035a5bac25$var$scrollListeners.delete(container);
        if (listener) {
            $f3d407035a5bac25$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $f3d407035a5bac25$var$resizeListeners.get(container)?.();
        }
    };
};
function $f3d407035a5bac25$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $f3d407035a5bac25$export$700979bc83e7db82 = $f3d407035a5bac25$export$48d7c418edadb60c() ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $f3d407035a5bac25$var$useIsMounted = ()=>{
    const isMounted = (0, $acw62.useRef)(false);
    $f3d407035a5bac25$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $f3d407035a5bac25$export$91db9bc4f8ac944a() {
    const update = (0, $acw62.useState)()[1];
    const isMounted = $f3d407035a5bac25$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $f3d407035a5bac25$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $acw62.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $acw62.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $f3d407035a5bac25$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $acw62.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $f3d407035a5bac25$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $f3d407035a5bac25$export$392544347a18b6ea = (effect)=>(0, $acw62.useEffect)(effect, $f3d407035a5bac25$var$emptyDeps);
var $f3d407035a5bac25$var$emptyDeps = [];
function $f3d407035a5bac25$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $f3d407035a5bac25$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $acw62.useState)(null);
    $f3d407035a5bac25$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $f3d407035a5bac25$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $acw62 = parcelRequire("acw62");
// src/Animated.ts


var $acw62 = parcelRequire("acw62");
var $cc1ee2bdb34481bf$var$$node = Symbol.for("Animated:node");
var $cc1ee2bdb34481bf$export$3df5e165e801a70f = (value)=>!!value && value[$cc1ee2bdb34481bf$var$$node] === value;
var $cc1ee2bdb34481bf$export$6b63995194a3a9e4 = (owner)=>owner && owner[$cc1ee2bdb34481bf$var$$node];
var $cc1ee2bdb34481bf$export$b553cb5b22b81b04 = (owner, node)=>(0, $f3d407035a5bac25$export$5c74248ea0e35446)(owner, $cc1ee2bdb34481bf$var$$node, node);
var $cc1ee2bdb34481bf$export$ccab2b64c5d440 = (owner)=>owner && owner[$cc1ee2bdb34481bf$var$$node] && owner[$cc1ee2bdb34481bf$var$$node].getPayload();
var $cc1ee2bdb34481bf$export$31627395a3b18e54 = class {
    constructor(){
        $cc1ee2bdb34481bf$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $cc1ee2bdb34481bf$export$cb1e8f3c05d37ad5 = class extends $cc1ee2bdb34481bf$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $cc1ee2bdb34481bf$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $cc1ee2bdb34481bf$export$f6c6c4cbd7fa5b93 = class extends $cc1ee2bdb34481bf$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $f3d407035a5bac25$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $cc1ee2bdb34481bf$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $f3d407035a5bac25$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $cc1ee2bdb34481bf$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $cc1ee2bdb34481bf$export$f1b0b9e366a6e2d4 = class extends $cc1ee2bdb34481bf$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($cc1ee2bdb34481bf$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $f3d407035a5bac25$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $f3d407035a5bac25$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($cc1ee2bdb34481bf$var$TreeContext.dependencies && (0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(source)) $cc1ee2bdb34481bf$var$TreeContext.dependencies.add(source);
        const payload = $cc1ee2bdb34481bf$export$ccab2b64c5d440(source);
        if (payload) (0, $f3d407035a5bac25$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $cc1ee2bdb34481bf$export$ede394683406942d = class extends $cc1ee2bdb34481bf$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $cc1ee2bdb34481bf$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($cc1ee2bdb34481bf$var$makeAnimated));
        return true;
    }
};
function $cc1ee2bdb34481bf$var$makeAnimated(value) {
    const nodeType = (0, $f3d407035a5bac25$export$75bed621f62abfa9)(value) ? $cc1ee2bdb34481bf$export$f6c6c4cbd7fa5b93 : $cc1ee2bdb34481bf$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $cc1ee2bdb34481bf$export$e6b77ddbe47b132e(value) {
    const parentNode = $cc1ee2bdb34481bf$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(value) ? $cc1ee2bdb34481bf$export$ede394683406942d : (0, $f3d407035a5bac25$export$75bed621f62abfa9)(value) ? $cc1ee2bdb34481bf$export$f6c6c4cbd7fa5b93 : $cc1ee2bdb34481bf$export$cb1e8f3c05d37ad5;
}
var $cc1ee2bdb34481bf$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $acw62.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $acw62.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $acw62.useCallback)((value)=>{
            instanceRef.current = $cc1ee2bdb34481bf$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $cc1ee2bdb34481bf$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $f3d407035a5bac25$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $cc1ee2bdb34481bf$var$PropsObserver(callback, deps);
        const observerRef = (0, $acw62.useRef)();
        (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(deps, (dep)=>(0, $f3d407035a5bac25$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $f3d407035a5bac25$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $f3d407035a5bac25$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $acw62.useEffect)(callback, []);
        (0, $f3d407035a5bac25$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $f3d407035a5bac25$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $f3d407035a5bac25$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $acw62.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $cc1ee2bdb34481bf$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $cc1ee2bdb34481bf$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $cc1ee2bdb34481bf$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $cc1ee2bdb34481bf$export$f1b0b9e366a6e2d4(props);
    $cc1ee2bdb34481bf$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $cc1ee2bdb34481bf$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $cc1ee2bdb34481bf$var$cacheKey = Symbol.for("AnimatedComponent");
var $cc1ee2bdb34481bf$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $cc1ee2bdb34481bf$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $cc1ee2bdb34481bf$var$getDisplayName(Component) || "Anonymous";
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $cc1ee2bdb34481bf$var$withAnimated(Component, hostConfig));
        else Component = Component[$cc1ee2bdb34481bf$var$cacheKey] || (Component[$cc1ee2bdb34481bf$var$cacheKey] = $cc1ee2bdb34481bf$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(components)) key = $cc1ee2bdb34481bf$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $cc1ee2bdb34481bf$var$getDisplayName = (arg)=>(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $40401742f75f21f9$export$b24b633b1364b94b = class {
};


function $d44e0aefbcb8bf2f$var$callProp(value, ...args) {
    return (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $d44e0aefbcb8bf2f$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $f3d407035a5bac25$export$45b10814cc054894)(value).includes(key)));
var $d44e0aefbcb8bf2f$var$resolveProp = (prop, key)=>(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $d44e0aefbcb8bf2f$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $d44e0aefbcb8bf2f$var$noopTransform = (value)=>value;
var $d44e0aefbcb8bf2f$var$getDefaultProps = (props, transform = $d44e0aefbcb8bf2f$var$noopTransform)=>{
    let keys = $d44e0aefbcb8bf2f$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $d44e0aefbcb8bf2f$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $d44e0aefbcb8bf2f$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $d44e0aefbcb8bf2f$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$d44e0aefbcb8bf2f$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $d44e0aefbcb8bf2f$export$b971039a739bf227(props) {
    const to2 = $d44e0aefbcb8bf2f$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $d44e0aefbcb8bf2f$var$computeGoal(value) {
    value = (0, $f3d407035a5bac25$export$e37b7520edd66839)(value);
    return (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(value) ? value.map($d44e0aefbcb8bf2f$var$computeGoal) : (0, $f3d407035a5bac25$export$75bed621f62abfa9)(value) ? (0, $f3d407035a5bac25$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $d44e0aefbcb8bf2f$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $d44e0aefbcb8bf2f$var$isAsyncTo(to2) {
    return (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(to2) || (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(to2) && (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $d44e0aefbcb8bf2f$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $d44e0aefbcb8bf2f$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $d44e0aefbcb8bf2f$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $f3d407035a5bac25$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $d44e0aefbcb8bf2f$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $f3d407035a5bac25$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $d44e0aefbcb8bf2f$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $d44e0aefbcb8bf2f$var$defaults = {
    ...$d44e0aefbcb8bf2f$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $f3d407035a5bac25$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $d44e0aefbcb8bf2f$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $d44e0aefbcb8bf2f$var$defaults);
    }
};
function $d44e0aefbcb8bf2f$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $d44e0aefbcb8bf2f$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $d44e0aefbcb8bf2f$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $d44e0aefbcb8bf2f$var$defaults)if (config2[key] == null) config2[key] = $d44e0aefbcb8bf2f$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $d44e0aefbcb8bf2f$var$sanitizeConfig(config2, props) {
    if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.tension) || !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.damping) || !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $d44e0aefbcb8bf2f$var$emptyArray = [];
var $d44e0aefbcb8bf2f$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $d44e0aefbcb8bf2f$var$emptyArray;
        this.toValues = null;
        this.fromValues = $d44e0aefbcb8bf2f$var$emptyArray;
        this.config = new $d44e0aefbcb8bf2f$var$AnimationConfig();
        this.immediate = false;
    }
};
function $d44e0aefbcb8bf2f$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $d44e0aefbcb8bf2f$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $d44e0aefbcb8bf2f$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $d44e0aefbcb8bf2f$var$matchProp(pause, key);
            delay = $d44e0aefbcb8bf2f$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $f3d407035a5bac25$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $d44e0aefbcb8bf2f$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $d44e0aefbcb8bf2f$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $d44e0aefbcb8bf2f$var$getNoopResult(target.get()) : $d44e0aefbcb8bf2f$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $d44e0aefbcb8bf2f$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $d44e0aefbcb8bf2f$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $d44e0aefbcb8bf2f$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $d44e0aefbcb8bf2f$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $d44e0aefbcb8bf2f$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $d44e0aefbcb8bf2f$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $d44e0aefbcb8bf2f$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $d44e0aefbcb8bf2f$export$d362d093fa99dc7();
            const skipAnimationSignal = new $d44e0aefbcb8bf2f$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $f3d407035a5bac25$export$cceeabf822b64fc0).skipAnimation) {
                    $d44e0aefbcb8bf2f$var$stopAsync(state);
                    skipAnimationSignal.result = $d44e0aefbcb8bf2f$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $f3d407035a5bac25$export$cceeabf822b64fc0).skipAnimation) {
            $d44e0aefbcb8bf2f$var$stopAsync(state);
            return $d44e0aefbcb8bf2f$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $d44e0aefbcb8bf2f$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $d44e0aefbcb8bf2f$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $d44e0aefbcb8bf2f$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(onRest)) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $d44e0aefbcb8bf2f$var$stopAsync(state, cancelId) {
    (0, $f3d407035a5bac25$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $d44e0aefbcb8bf2f$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $d44e0aefbcb8bf2f$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $d44e0aefbcb8bf2f$var$isFrameValue = (value)=>value instanceof $d44e0aefbcb8bf2f$export$8229896f80e2495e;
var $d44e0aefbcb8bf2f$var$nextId = 1;
var $d44e0aefbcb8bf2f$export$8229896f80e2495e = class extends (0, $f3d407035a5bac25$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $d44e0aefbcb8bf2f$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $f3d407035a5bac25$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $f3d407035a5bac25$export$2abfcde8ae218ba8)();
        return (0, $f3d407035a5bac25$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $f3d407035a5bac25$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $f3d407035a5bac25$export$a57f5080a3bcc90a).sort(this);
        (0, $f3d407035a5bac25$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $d44e0aefbcb8bf2f$var$$P = Symbol.for("SpringPhase");
var $d44e0aefbcb8bf2f$var$HAS_ANIMATED = 1;
var $d44e0aefbcb8bf2f$var$IS_ANIMATING = 2;
var $d44e0aefbcb8bf2f$var$IS_PAUSED = 4;
var $d44e0aefbcb8bf2f$var$hasAnimated = (target)=>(target[$d44e0aefbcb8bf2f$var$$P] & $d44e0aefbcb8bf2f$var$HAS_ANIMATED) > 0;
var $d44e0aefbcb8bf2f$var$isAnimating = (target)=>(target[$d44e0aefbcb8bf2f$var$$P] & $d44e0aefbcb8bf2f$var$IS_ANIMATING) > 0;
var $d44e0aefbcb8bf2f$var$isPaused = (target)=>(target[$d44e0aefbcb8bf2f$var$$P] & $d44e0aefbcb8bf2f$var$IS_PAUSED) > 0;
var $d44e0aefbcb8bf2f$var$setActiveBit = (target, active)=>active ? target[$d44e0aefbcb8bf2f$var$$P] |= $d44e0aefbcb8bf2f$var$IS_ANIMATING | $d44e0aefbcb8bf2f$var$HAS_ANIMATED : target[$d44e0aefbcb8bf2f$var$$P] &= ~$d44e0aefbcb8bf2f$var$IS_ANIMATING;
var $d44e0aefbcb8bf2f$var$setPausedBit = (target, paused)=>paused ? target[$d44e0aefbcb8bf2f$var$$P] |= $d44e0aefbcb8bf2f$var$IS_PAUSED : target[$d44e0aefbcb8bf2f$var$$P] &= ~$d44e0aefbcb8bf2f$var$IS_PAUSED;
// src/SpringValue.ts
var $d44e0aefbcb8bf2f$export$5854d13427d5a954 = class extends $d44e0aefbcb8bf2f$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $d44e0aefbcb8bf2f$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(arg1) || !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($d44e0aefbcb8bf2f$var$isAnimating(this) || this._state.asyncTo) || $d44e0aefbcb8bf2f$var$isPaused(this);
    }
    get goal() {
        return (0, $f3d407035a5bac25$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $cc1ee2bdb34481bf$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $d44e0aefbcb8bf2f$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $d44e0aefbcb8bf2f$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $d44e0aefbcb8bf2f$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $cc1ee2bdb34481bf$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $f3d407035a5bac25$export$45b10814cc054894)((0, $f3d407035a5bac25$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $cc1ee2bdb34481bf$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $f3d407035a5bac25$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($d44e0aefbcb8bf2f$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$d44e0aefbcb8bf2f$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $d44e0aefbcb8bf2f$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $d44e0aefbcb8bf2f$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$d44e0aefbcb8bf2f$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $f3d407035a5bac25$export$e37b7520edd66839)(from);
            if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $d44e0aefbcb8bf2f$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $d44e0aefbcb8bf2f$var$resolveProp(value, key) : value));
        $d44e0aefbcb8bf2f$var$mergeActiveFn(this, props, "onProps");
        $d44e0aefbcb8bf2f$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $d44e0aefbcb8bf2f$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$d44e0aefbcb8bf2f$var$isPaused(this)) {
                        $d44e0aefbcb8bf2f$var$setPausedBit(this, true);
                        (0, $f3d407035a5bac25$export$7ba486852759e806)(state.pauseQueue);
                        $d44e0aefbcb8bf2f$var$sendEvent(this, "onPause", $d44e0aefbcb8bf2f$var$getFinishedResult(this, $d44e0aefbcb8bf2f$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($d44e0aefbcb8bf2f$var$isPaused(this)) {
                        $d44e0aefbcb8bf2f$var$setPausedBit(this, false);
                        if ($d44e0aefbcb8bf2f$var$isAnimating(this)) this._resume();
                        (0, $f3d407035a5bac25$export$7ba486852759e806)(state.resumeQueue);
                        $d44e0aefbcb8bf2f$var$sendEvent(this, "onResume", $d44e0aefbcb8bf2f$var$getFinishedResult(this, $d44e0aefbcb8bf2f$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $d44e0aefbcb8bf2f$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($d44e0aefbcb8bf2f$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($d44e0aefbcb8bf2f$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $f3d407035a5bac25$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $f3d407035a5bac25$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $f3d407035a5bac25$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $d44e0aefbcb8bf2f$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $d44e0aefbcb8bf2f$var$mergeConfig(config2, $d44e0aefbcb8bf2f$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $d44e0aefbcb8bf2f$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this);
        if (!node || (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(to2)) return resolve($d44e0aefbcb8bf2f$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(from) && $d44e0aefbcb8bf2f$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $d44e0aefbcb8bf2f$var$computeGoal(to2);
        const isAnimatable = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).num(goal) || (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(goal) || (0, $f3d407035a5bac25$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $d44e0aefbcb8bf2f$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $cc1ee2bdb34481bf$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$d44e0aefbcb8bf2f$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $f3d407035a5bac25$export$248d38f6296296c5)($d44e0aefbcb8bf2f$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $f3d407035a5bac25$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $f3d407035a5bac25$export$248d38f6296296c5)(config2.decay, decay) || !(0, $f3d407035a5bac25$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $d44e0aefbcb8bf2f$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $cc1ee2bdb34481bf$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $f3d407035a5bac25$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $f3d407035a5bac25$export$79b2f7037acddd43)($d44e0aefbcb8bf2f$var$ACTIVE_EVENTS, (type)=>$d44e0aefbcb8bf2f$var$mergeActiveFn(this, props, type));
                const result = $d44e0aefbcb8bf2f$var$getFinishedResult(this, $d44e0aefbcb8bf2f$var$checkFinished(this, prevTo));
                (0, $f3d407035a5bac25$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $d44e0aefbcb8bf2f$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($d44e0aefbcb8bf2f$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($d44e0aefbcb8bf2f$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($d44e0aefbcb8bf2f$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $f3d407035a5bac25$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $f3d407035a5bac25$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(to2)) {
            (0, $f3d407035a5bac25$export$72d604e3f8d000a5)(to2, this);
            if ($d44e0aefbcb8bf2f$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(to2)) (0, $f3d407035a5bac25$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $f3d407035a5bac25$export$e37b7520edd66839)(arg);
        if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $f3d407035a5bac25$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $cc1ee2bdb34481bf$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $cc1ee2bdb34481bf$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $d44e0aefbcb8bf2f$var$sendEvent(this, "onStart", $d44e0aefbcb8bf2f$var$getFinishedResult(this, $d44e0aefbcb8bf2f$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $d44e0aefbcb8bf2f$var$callProp(this.animation.onChange, value, this);
        }
        $d44e0aefbcb8bf2f$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this).reset((0, $f3d407035a5bac25$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$d44e0aefbcb8bf2f$var$isAnimating(this)) {
            $d44e0aefbcb8bf2f$var$setActiveBit(this, true);
            if (!$d44e0aefbcb8bf2f$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $f3d407035a5bac25$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $f3d407035a5bac25$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($d44e0aefbcb8bf2f$var$isAnimating(this)) {
            $d44e0aefbcb8bf2f$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $f3d407035a5bac25$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $d44e0aefbcb8bf2f$var$getCancelledResult(this.get()) : $d44e0aefbcb8bf2f$var$getFinishedResult(this.get(), $d44e0aefbcb8bf2f$var$checkFinished(this, goal ?? anim.to));
            (0, $f3d407035a5bac25$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $d44e0aefbcb8bf2f$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $d44e0aefbcb8bf2f$var$checkFinished(target, to2) {
    const goal = $d44e0aefbcb8bf2f$var$computeGoal(to2);
    const value = $d44e0aefbcb8bf2f$var$computeGoal(target.get());
    return (0, $f3d407035a5bac25$export$248d38f6296296c5)(value, goal);
}
function $d44e0aefbcb8bf2f$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $d44e0aefbcb8bf2f$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $d44e0aefbcb8bf2f$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $d44e0aefbcb8bf2f$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $d44e0aefbcb8bf2f$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $d44e0aefbcb8bf2f$var$createUpdate(props) {
    const { to: to2, from: from } = props = $d44e0aefbcb8bf2f$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(to2)) $d44e0aefbcb8bf2f$var$findDefined(to2, keys);
    if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(from)) $d44e0aefbcb8bf2f$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $d44e0aefbcb8bf2f$var$declareUpdate(props) {
    const update2 = $d44e0aefbcb8bf2f$var$createUpdate(props);
    if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $d44e0aefbcb8bf2f$var$getDefaultProps(update2);
    return update2;
}
function $d44e0aefbcb8bf2f$var$findDefined(values, keys) {
    (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $d44e0aefbcb8bf2f$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $d44e0aefbcb8bf2f$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $d44e0aefbcb8bf2f$var$getDefaultProp(props, type) ? $d44e0aefbcb8bf2f$var$resolveProp(props[type], target.key) : void 0;
}
function $d44e0aefbcb8bf2f$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $d44e0aefbcb8bf2f$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $d44e0aefbcb8bf2f$var$nextId2 = 1;
var $d44e0aefbcb8bf2f$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $d44e0aefbcb8bf2f$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($d44e0aefbcb8bf2f$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $f3d407035a5bac25$export$45b10814cc054894)(props).map($d44e0aefbcb8bf2f$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $d44e0aefbcb8bf2f$var$prepareKeys(this, queue);
        return $d44e0aefbcb8bf2f$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)((0, $f3d407035a5bac25$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $d44e0aefbcb8bf2f$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)((0, $f3d407035a5bac25$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)((0, $f3d407035a5bac25$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $f3d407035a5bac25$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $f3d407035a5bac25$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $f3d407035a5bac25$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $d44e0aefbcb8bf2f$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$d44e0aefbcb8bf2f$var$flushUpdate(ctrl, props))).then((results)=>$d44e0aefbcb8bf2f$var$getCombinedResult(ctrl, results));
}
async function $d44e0aefbcb8bf2f$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(to2) || (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $f3d407035a5bac25$export$79b2f7037acddd43)($d44e0aefbcb8bf2f$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $f3d407035a5bac25$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $d44e0aefbcb8bf2f$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($d44e0aefbcb8bf2f$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $f3d407035a5bac25$export$8793edee2d425525),
            resume: (0, $f3d407035a5bac25$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $d44e0aefbcb8bf2f$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($d44e0aefbcb8bf2f$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($d44e0aefbcb8bf2f$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $d44e0aefbcb8bf2f$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $d44e0aefbcb8bf2f$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $d44e0aefbcb8bf2f$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $d44e0aefbcb8bf2f$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $d44e0aefbcb8bf2f$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $f3d407035a5bac25$export$79b2f7037acddd43)((0, $f3d407035a5bac25$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $d44e0aefbcb8bf2f$var$createUpdate(props2);
        if (!(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $d44e0aefbcb8bf2f$var$prepareSprings(springs, props2, (key)=>{
            return $d44e0aefbcb8bf2f$var$createSpring(key);
        });
    });
    $d44e0aefbcb8bf2f$var$setSprings(ctrl, springs);
    return springs;
}
function $d44e0aefbcb8bf2f$var$setSprings(ctrl, springs) {
    (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $f3d407035a5bac25$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $d44e0aefbcb8bf2f$var$createSpring(key, observer) {
    const spring = new $d44e0aefbcb8bf2f$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $f3d407035a5bac25$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $d44e0aefbcb8bf2f$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $f3d407035a5bac25$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $d44e0aefbcb8bf2f$var$prepareKeys(ctrl, queue) {
    (0, $f3d407035a5bac25$export$79b2f7037acddd43)(queue, (props)=>{
        $d44e0aefbcb8bf2f$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $d44e0aefbcb8bf2f$var$createSpring(key, ctrl);
        });
    });
}
var $d44e0aefbcb8bf2f$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $acw62.useContext)($d44e0aefbcb8bf2f$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $f3d407035a5bac25$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $d44e0aefbcb8bf2f$var$ctx;
    return /* @__PURE__ */ $acw62.createElement(Provider, {
        value: props
    }, children);
};
var $d44e0aefbcb8bf2f$var$ctx = $d44e0aefbcb8bf2f$var$makeContext($d44e0aefbcb8bf2f$export$f12a216ec50d2cf1, {});
$d44e0aefbcb8bf2f$export$f12a216ec50d2cf1.Provider = $d44e0aefbcb8bf2f$var$ctx.Provider;
$d44e0aefbcb8bf2f$export$f12a216ec50d2cf1.Consumer = $d44e0aefbcb8bf2f$var$ctx.Consumer;
function $d44e0aefbcb8bf2f$var$makeContext(target, init) {
    Object.assign(target, $acw62.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $d44e0aefbcb8bf2f$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $f3d407035a5bac25$export$d99d974913ad3b12)();
        const results = [];
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $d44e0aefbcb8bf2f$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $acw62.useMemo)(()=>propsFn || arguments.length == 3 ? $d44e0aefbcb8bf2f$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $acw62.useRef)(0);
    const forceUpdate = (0, $f3d407035a5bac25$export$91db9bc4f8ac944a)();
    const state = (0, $acw62.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $d44e0aefbcb8bf2f$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $d44e0aefbcb8bf2f$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $d44e0aefbcb8bf2f$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($d44e0aefbcb8bf2f$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $acw62.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $f3d407035a5bac25$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $acw62.useMemo)(()=>{
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $d44e0aefbcb8bf2f$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $acw62.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $d44e0aefbcb8bf2f$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $d44e0aefbcb8bf2f$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$d44e0aefbcb8bf2f$var$getSprings(ctrl, updates[i]));
    const context = (0, $acw62.useContext)($d44e0aefbcb8bf2f$export$f12a216ec50d2cf1);
    const prevContext = (0, $f3d407035a5bac25$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $d44e0aefbcb8bf2f$var$hasProps(context);
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $d44e0aefbcb8bf2f$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $f3d407035a5bac25$export$392544347a18b6ea)(()=>()=>{
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $d44e0aefbcb8bf2f$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $d44e0aefbcb8bf2f$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $d44e0aefbcb8bf2f$var$initSpringRef = ()=>$d44e0aefbcb8bf2f$export$2471ae76e2946684();
var $d44e0aefbcb8bf2f$export$564bff9c23cad2ca = ()=>(0, $acw62.useState)($d44e0aefbcb8bf2f$var$initSpringRef)[0];
var $d44e0aefbcb8bf2f$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $f3d407035a5bac25$export$fe4300aa8eebea86)(()=>new $d44e0aefbcb8bf2f$export$5854d13427d5a954(initial, props));
    (0, $f3d407035a5bac25$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $d44e0aefbcb8bf2f$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $d44e0aefbcb8bf2f$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $d44e0aefbcb8bf2f$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $d44e0aefbcb8bf2f$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $acw62.useMemo)(()=>propsFn || arguments.length == 3 ? $d44e0aefbcb8bf2f$export$2471ae76e2946684() : void 0, []);
    const items = (0, $f3d407035a5bac25$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $acw62.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $f3d407035a5bac25$export$392544347a18b6ea)(()=>{
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $d44e0aefbcb8bf2f$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $d44e0aefbcb8bf2f$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>(0, $f3d407035a5bac25$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $d44e0aefbcb8bf2f$var$detachRefs(ctrl, ref);
            $d44e0aefbcb8bf2f$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $f3d407035a5bac25$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $f3d407035a5bac25$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $d44e0aefbcb8bf2f$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $f3d407035a5bac25$export$91db9bc4f8ac944a)();
    const defaultProps = $d44e0aefbcb8bf2f$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $acw62.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $acw62.useRef)(false);
    (0, $f3d407035a5bac25$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $d44e0aefbcb8bf2f$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $d44e0aefbcb8bf2f$var$callProp(to2, t.item, i);
        to2 = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).obj(to2) ? $d44e0aefbcb8bf2f$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $d44e0aefbcb8bf2f$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $d44e0aefbcb8bf2f$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $d44e0aefbcb8bf2f$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $d44e0aefbcb8bf2f$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $d44e0aefbcb8bf2f$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $acw62.useContext)($d44e0aefbcb8bf2f$export$f12a216ec50d2cf1);
    const prevContext = (0, $f3d407035a5bac25$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $d44e0aefbcb8bf2f$var$hasProps(context);
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $f3d407035a5bac25$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $f3d407035a5bac25$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $d44e0aefbcb8bf2f$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $acw62.createElement(elem.type, {
                ...elem.props,
                key: (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).str(t.key) || (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $d44e0aefbcb8bf2f$var$nextKey = 1;
function $d44e0aefbcb8bf2f$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $d44e0aefbcb8bf2f$var$nextKey++;
        });
    }
    return (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(keys) ? items : (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $f3d407035a5bac25$export$45b10814cc054894)(keys);
}
var $d44e0aefbcb8bf2f$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $d44e0aefbcb8bf2f$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $f3d407035a5bac25$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $d44e0aefbcb8bf2f$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $d44e0aefbcb8bf2f$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $f3d407035a5bac25$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $d44e0aefbcb8bf2f$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $d44e0aefbcb8bf2f$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)();
    const propsFn = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $d44e0aefbcb8bf2f$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $f3d407035a5bac25$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $d44e0aefbcb8bf2f$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $d44e0aefbcb8bf2f$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($d44e0aefbcb8bf2f$export$c4af9125706c4d30(props));
}
function $d44e0aefbcb8bf2f$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $d44e0aefbcb8bf2f$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $d44e0aefbcb8bf2f$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $d44e0aefbcb8bf2f$export$7b286972b8d8ccbf(items, props)(children);
}
var $d44e0aefbcb8bf2f$export$b0cc4f9860136880 = class extends $d44e0aefbcb8bf2f$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $f3d407035a5bac25$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $cc1ee2bdb34481bf$export$e6b77ddbe47b132e)(value);
        (0, $cc1ee2bdb34481bf$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $f3d407035a5bac25$export$248d38f6296296c5)(value, oldValue)) {
            (0, $cc1ee2bdb34481bf$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $d44e0aefbcb8bf2f$var$checkIdle(this._active)) $d44e0aefbcb8bf2f$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $f3d407035a5bac25$export$e37b7520edd66839)) : (0, $f3d407035a5bac25$export$45b10814cc054894)((0, $f3d407035a5bac25$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$d44e0aefbcb8bf2f$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $f3d407035a5bac25$export$79b2f7037acddd43)((0, $cc1ee2bdb34481bf$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $f3d407035a5bac25$export$cceeabf822b64fc0).skipAnimation) {
                (0, $8371d85a89ca5565$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $d44e0aefbcb8bf2f$var$becomeIdle(this);
            } else (0, $f3d407035a5bac25$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)((0, $f3d407035a5bac25$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(source)) (0, $f3d407035a5bac25$export$72d604e3f8d000a5)(source, this);
            if ($d44e0aefbcb8bf2f$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)((0, $f3d407035a5bac25$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(source)) (0, $f3d407035a5bac25$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $d44e0aefbcb8bf2f$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $f3d407035a5bac25$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($d44e0aefbcb8bf2f$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $d44e0aefbcb8bf2f$var$isIdle(source) {
    return source.idle !== false;
}
function $d44e0aefbcb8bf2f$var$checkIdle(active) {
    return !active.size || Array.from(active).every($d44e0aefbcb8bf2f$var$isIdle);
}
function $d44e0aefbcb8bf2f$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)((0, $cc1ee2bdb34481bf$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $f3d407035a5bac25$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $d44e0aefbcb8bf2f$export$2c618a4308a30424 = (source, ...args)=>new $d44e0aefbcb8bf2f$export$b0cc4f9860136880(source, args);
var $d44e0aefbcb8bf2f$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $f3d407035a5bac25$export$2abfcde8ae218ba8)(), new $d44e0aefbcb8bf2f$export$b0cc4f9860136880(source, args));
(0, $f3d407035a5bac25$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $f3d407035a5bac25$export$4759a013d387347a,
    to: (source, args)=>new $d44e0aefbcb8bf2f$export$b0cc4f9860136880(source, args)
});
var $d44e0aefbcb8bf2f$export$722fbec263ad908a = (0, $f3d407035a5bac25$export$a57f5080a3bcc90a).advance;





// src/applyAnimatedValues.ts
var $4f6ab5611462e1e0$var$isCustomPropRE = /^--/;
function $4f6ab5611462e1e0$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$4f6ab5611462e1e0$var$isCustomPropRE.test(name) && !($4f6ab5611462e1e0$var$isUnitlessNumber.hasOwnProperty(name) && $4f6ab5611462e1e0$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $4f6ab5611462e1e0$var$attributeCache = {};
function $4f6ab5611462e1e0$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $4f6ab5611462e1e0$var$attributeCache[name] || ($4f6ab5611462e1e0$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $4f6ab5611462e1e0$var$dangerousStyleValue(name, style[name]);
        if ($4f6ab5611462e1e0$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $4f6ab5611462e1e0$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $4f6ab5611462e1e0$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $4f6ab5611462e1e0$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$4f6ab5611462e1e0$var$isUnitlessNumber = Object.keys($4f6ab5611462e1e0$var$isUnitlessNumber).reduce((acc, prop)=>{
    $4f6ab5611462e1e0$var$prefixes.forEach((prefix)=>acc[$4f6ab5611462e1e0$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $4f6ab5611462e1e0$var$isUnitlessNumber);
var $4f6ab5611462e1e0$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $4f6ab5611462e1e0$var$pxTransforms = /^(translate)/;
var $4f6ab5611462e1e0$var$degTransforms = /^(rotate|skew)/;
var $4f6ab5611462e1e0$var$addUnit = (value, unit)=>(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $4f6ab5611462e1e0$var$isValueIdentity = (value, id)=>(0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$4f6ab5611462e1e0$var$isValueIdentity(v, id)) : (0, $f3d407035a5bac25$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $4f6ab5611462e1e0$var$AnimatedStyle = class extends (0, $cc1ee2bdb34481bf$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$4f6ab5611462e1e0$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $4f6ab5611462e1e0$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $f3d407035a5bac25$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($4f6ab5611462e1e0$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $4f6ab5611462e1e0$var$pxTransforms.test(key) ? "px" : $4f6ab5611462e1e0$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $f3d407035a5bac25$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$4f6ab5611462e1e0$var$addUnit(deg, unit)})`,
                        $4f6ab5611462e1e0$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$4f6ab5611462e1e0$var$addUnit(v, unit)).join(",")})`,
                        $4f6ab5611462e1e0$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $4f6ab5611462e1e0$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $4f6ab5611462e1e0$var$FluidTransform = class extends (0, $f3d407035a5bac25$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $f3d407035a5bac25$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $f3d407035a5bac25$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $f3d407035a5bac25$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $f3d407035a5bac25$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $f3d407035a5bac25$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $f3d407035a5bac25$export$79b2f7037acddd43)(input, (value)=>(0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(value) && (0, $f3d407035a5bac25$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $f3d407035a5bac25$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $f3d407035a5bac25$export$79b2f7037acddd43)(input, (value)=>(0, $f3d407035a5bac25$export$57ea7e3a7f6280c7)(value) && (0, $f3d407035a5bac25$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $f3d407035a5bac25$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $4f6ab5611462e1e0$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $f3d407035a5bac25$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $11492dca620dcaa5$exports.unstable_batchedUpdates),
    createStringInterpolator: $f3d407035a5bac25$export$4759a013d387347a,
    colors: $f3d407035a5bac25$export$8f45430ccf837300
});
var $4f6ab5611462e1e0$var$host = (0, $cc1ee2bdb34481bf$export$4ee5c78f6dcbcef)($4f6ab5611462e1e0$var$primitives, {
    applyAnimatedValues: $4f6ab5611462e1e0$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $4f6ab5611462e1e0$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $4f6ab5611462e1e0$export$407448d2b89b1813 = $4f6ab5611462e1e0$var$host.animated;





function $9abc031f5f410ea8$var$stopAnimation(visualElement) {
    visualElement.values.forEach((value)=>value.stop());
}
/**
 * @public
 */ function $9abc031f5f410ea8$export$e2858afe37bd256a() {
    /**
     * Track whether the host component has mounted.
     */ let hasMounted = false;
    /**
     * A collection of linked component animation controls.
     */ const subscribers = new Set();
    const controls = {
        subscribe (visualElement) {
            subscribers.add(visualElement);
            return ()=>void subscribers.delete(visualElement);
        },
        start (definition, transitionOverride) {
            (0, $bf99d85f7a843912$export$f5708dca728d7177)(hasMounted, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            const animations = [];
            subscribers.forEach((visualElement)=>{
                animations.push((0, $7d7d5f8a14d3a662$export$ff62cf473653f109)(visualElement, definition, {
                    transitionOverride: transitionOverride
                }));
            });
            return Promise.all(animations);
        },
        set (definition) {
            (0, $bf99d85f7a843912$export$f5708dca728d7177)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement)=>{
                (0, $ea04fe669600292a$export$b7771d60d308862f)(visualElement, definition);
            });
        },
        stop () {
            subscribers.forEach((visualElement)=>{
                $9abc031f5f410ea8$var$stopAnimation(visualElement);
            });
        },
        mount () {
            hasMounted = true;
            return ()=>{
                hasMounted = false;
                controls.stop();
            };
        }
    };
    return controls;
}




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */ function $0c0f401e731e2e92$export$c705d7acb130fe23() {
    const controls = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)((0, $9abc031f5f410ea8$export$e2858afe37bd256a));
    (0, $9c674755a93db746$export$700979bc83e7db82)(controls.mount, []);
    return controls;
}
const $0c0f401e731e2e92$export$9e2608686d4ad846 = $0c0f401e731e2e92$export$c705d7acb130fe23;


const $0644053fea3ad634$var$$c14c5160115f36ed$var$getSpringTransition = (type, options)=>{
    const { distance: distance } = options;
    switch(type){
        case "slide-bottom-to-top":
            return {
                false: {
                    opacity: 0,
                    transform: `translateY(${distance}px)`
                },
                true: {
                    opacity: 1,
                    transform: "translateX(0)"
                }
            };
        case "slide-top-to-bottom":
            return {
                false: {
                    opacity: 0,
                    transform: `translateY(-${distance}px)`
                },
                true: {
                    opacity: 1,
                    transform: "translateX(0)"
                }
            };
        case "slide-left-to-right":
            return {
                false: {
                    opacity: 0,
                    transform: `translateX(-${distance}px)`
                },
                true: {
                    opacity: 1,
                    transform: "translateX(0)"
                }
            };
        case "slide-right-to-left":
            return {
                false: {
                    opacity: 0,
                    transform: `translateX(${distance}px)`
                },
                true: {
                    opacity: 1,
                    transform: "translateX(0)"
                }
            };
        case "fade":
            return {
                false: {
                    opacity: 0
                },
                true: {
                    opacity: 1
                }
            };
    }
};
const $0644053fea3ad634$export$78358bd54413399e = (0, $acw62.memo)((props)=>{
    const { leftProps: { animateDisabled: animateDisabled, ...leftProps }, ref: ref, animation: animation } = $0644053fea3ad634$var$$c14c5160115f36ed$var$useAnimatedSpringInView(props);
    if (animateDisabled) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", leftProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f6ab5611462e1e0$export$407448d2b89b1813).img, {
        ...leftProps,
        ref: ref,
        style: animation
    });
});
const $0644053fea3ad634$export$c1a28a92d4f040ed = (0, $acw62.memo)((props)=>{
    const { leftProps: { animateDisabled: animateDisabled, ...leftProps }, ref: ref, animation: animation } = $0644053fea3ad634$var$$c14c5160115f36ed$var$useAnimatedSpringInView(props);
    if (animateDisabled) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", leftProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f6ab5611462e1e0$export$407448d2b89b1813).div, {
        ...leftProps,
        ref: ref,
        style: animation
    });
});
function $0644053fea3ad634$var$$c14c5160115f36ed$var$useAnimatedSpringInView(props) {
    const { distance: distance = 100, delay: delay = 200, type: type = "fade", duration: duration = 600, ...leftProps } = props;
    const [ref, inView] = (0, $d44e0aefbcb8bf2f$export$2f62ee6831462844)({
        once: true
    });
    const config = (0, $acw62.useMemo)(()=>$0644053fea3ad634$var$$c14c5160115f36ed$var$getSpringTransition(type, {
            distance: distance
        })[String(inView)], [
        type,
        distance,
        inView
    ]);
    const animation = (0, $d44e0aefbcb8bf2f$export$c4af9125706c4d30)({
        ...config,
        delay: delay,
        config: {
            duration: duration
        }
    });
    return {
        leftProps: leftProps,
        ref: ref,
        animation: animation
    };
}
const $0644053fea3ad634$var$$ace0ca38577b4572$var$getMotionTransition = (type, options)=>{
    const { distance: distance, delay: delay } = options;
    const transition = {
        delay: delay / 1000,
        type: "tween"
    };
    switch(type){
        case "slide-bottom-to-top":
            return {
                visible: {
                    opacity: 1,
                    y: 0,
                    transition: transition
                },
                hidden: {
                    opacity: 0,
                    y: distance,
                    transition: transition
                }
            };
        case "slide-top-to-bottom":
            return {
                visible: {
                    opacity: 1,
                    y: 0,
                    transition: transition
                },
                hidden: {
                    opacity: 0,
                    y: -distance,
                    transition: transition
                }
            };
        case "slide-left-to-right":
            return {
                visible: {
                    opacity: 1,
                    x: 0,
                    transition: transition
                },
                hidden: {
                    opacity: 0,
                    x: -distance,
                    transition: transition
                }
            };
        case "slide-right-to-left":
            return {
                visible: {
                    opacity: 1,
                    x: 0,
                    transition: transition
                },
                hidden: {
                    opacity: 0,
                    x: distance,
                    transition: transition
                }
            };
        case "fade":
            return {
                visible: {
                    opacity: 1,
                    transition: transition
                },
                hidden: {
                    opacity: 0,
                    transition: transition
                }
            };
    }
};
const $0644053fea3ad634$export$4ed9cb29134c38f2 = (0, $acw62.memo)((props)=>{
    const { leftProps: { animateDisabled: animateDisabled, ...leftProps }, ref: ref, controls: controls, variants: variants } = $0644053fea3ad634$var$$ace0ca38577b4572$var$useAnimatedMotionInView(props);
    if (animateDisabled) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", leftProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a93b6401f922fd1e$export$e25e478948902b8b).img, {
        ...leftProps,
        animate: controls,
        initial: "hidden",
        ref: ref,
        variants: variants
    });
});
const $0644053fea3ad634$export$907b712da4353231 = (0, $acw62.memo)((props)=>{
    const { leftProps: { animateDisabled: animateDisabled, ...leftProps }, ref: ref, controls: controls, variants: variants } = $0644053fea3ad634$var$$ace0ca38577b4572$var$useAnimatedMotionInView(props);
    if (animateDisabled) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", leftProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        ...leftProps,
        animate: controls,
        initial: "hidden",
        ref: ref,
        variants: variants
    });
});
function $0644053fea3ad634$var$$ace0ca38577b4572$var$useAnimatedMotionInView(props) {
    const { distance: distance = 100, delay: delay = 200, type: type = "fade", duration: duration = 600, ...leftProps } = props;
    const [ref, inView] = (0, $d44e0aefbcb8bf2f$export$2f62ee6831462844)({
        once: true
    });
    const controls = (0, $0c0f401e731e2e92$export$9e2608686d4ad846)();
    const variants = (0, $acw62.useMemo)(()=>$0644053fea3ad634$var$$ace0ca38577b4572$var$getMotionTransition(type, {
            distance: distance,
            delay: delay
        }), [
        type,
        distance,
        inView,
        delay
    ]);
    (0, $acw62.useEffect)(()=>{
        if (inView) controls.start("visible");
    }, [
        controls,
        inView
    ]);
    return {
        leftProps: leftProps,
        ref: ref,
        controls: controls,
        variants: variants
    };
}






var $acw62 = parcelRequire("acw62");



var $81f47d27d2adc425$exports = {};
$81f47d27d2adc425$exports = import.meta.resolve("dw1JN");


function $3cf2ddfe144541ce$var$ScrollToTop({}) {
    const passingHome = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>s.passing.home);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "scrolltotop-div",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("fixed right-[31px] bottom-[31px] md:right-[50px] md:bottom-[50px] transition-all duration-300", {
            'opacity-100 z-[1001]': passingHome,
            'opacity-0 z-[-1001]': !passingHome
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3cf2ddfe144541ce$var$ScrollToTopButton, {})
    });
}
var $3cf2ddfe144541ce$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($3cf2ddfe144541ce$var$ScrollToTop);
const $3cf2ddfe144541ce$var$ScrollToTopButton = /*#__PURE__*/ (0, $acw62.memo)(()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab278db22d2b79f2$export$2e2bcd8739ae039), {
        className: "!p-0 w-[55px] h-[55px] shadow-lg",
        onClick: ()=>window.scrollTo(0, 0),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($81f47d27d2adc425$exports))),
            className: "object-contain"
        })
    }));


const $e89d73536f9b4406$var$SPRING_DEFAULT = {
    distance: 20,
    duration: 950
};
function $e89d73536f9b4406$var$Home() {
    const [isMobile, passing] = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>[
            s.isMobile,
            s.passing
        ]);
    (0, $acw62.useEffect)(()=>{
        if (passing.home || isMobile) (0, $7f1ca03e50a4c851$export$16fe725363162b27).getState().showHeader();
        else (0, $7f1ca03e50a4c851$export$16fe725363162b27).getState().hideHeader();
    }, [
        passing.home,
        isMobile
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "test"
            }),
            !passing.location && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$FixedHeroWindow, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($dc965ff797a9a84e$exports))),
                imageClassName: "brightness-75",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "absolute top-[50%] -translate-y-0.5 font-fromage font-light uppercase text-white px-5 text-[48px] md:text-[64px] text-center w-full m-auto",
                    children: "Contact & Locations"
                })
            }),
            !passing.career && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$FixedHeroWindow, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($33512f93171664b6$exports))),
                imageClassName: "brightness-75",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "absolute top-[50%] -translate-y-0.5 font-fromage font-light uppercase text-white text-[40px] md:text-[64px] text-center w-full m-auto",
                    children: "Career"
                })
            }),
            !passing.features && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$FixedHeroWindow, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($db9710d27ae761b2$exports)))
            }),
            !passing.home && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28b6c57b6935bc3e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "home",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute top-0 left-0 h-screen w-screen bg-white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$About, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$FeatureProducts, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$MerchandiseProducts, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$Menu, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$Career, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$ContactLocations, {
                        isMobile: isMobile
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cf2ddfe144541ce$export$2e2bcd8739ae039), {})
        ]
    });
}
var $e89d73536f9b4406$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($e89d73536f9b4406$var$Home);
const $e89d73536f9b4406$var$FixedHeroWindow = /*#__PURE__*/ (0, $acw62.memo)(({ src: src, imageClassName: imageClassName, children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "fixed top-0 left-0 h-screen w-screen",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("w-full h-full object-cover", imageClassName),
                src: src
            }),
            children
        ]
    });
});
const $e89d73536f9b4406$var$About = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(({ isMobile: isMobile }, _ref)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e89d73536f9b4406$var$BoundaryWrapper, {
        id: "about",
        className: "about",
        boundaryType: "home",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "about-item mb-[50px] md:mb-0 !items-end",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0644053fea3ad634$export$c1a28a92d4f040ed), {
                        type: "slide-left-to-right",
                        animateDisabled: isMobile,
                        ...$e89d73536f9b4406$var$SPRING_DEFAULT,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "about-item-heading",
                                children: "About Angus T"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "md:max-w-[470px]",
                                children: "At Angus T, crafting the perfect croissant is both an art and a tradition. Using a family recipe passed down through generations from a small village in Belgium, Angus T was founded in 2016 with a vision to serve world-class croissants in a warm and welcoming space."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$78358bd54413399e), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7328b6e6a32d1a83$exports))),
                        type: "slide-bottom-to-top",
                        className: "landscape",
                        ...$e89d73536f9b4406$var$SPRING_DEFAULT
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "about-item !flex-col-reverse md:!flex-row !items-start",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$78358bd54413399e), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7b49cefa9519a683$exports))),
                        type: "slide-bottom-to-top",
                        className: "portrait",
                        ...$e89d73536f9b4406$var$SPRING_DEFAULT
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$c1a28a92d4f040ed), {
                        type: "slide-right-to-left",
                        animateDisabled: isMobile,
                        ...$e89d73536f9b4406$var$SPRING_DEFAULT,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "whitespace-pre-wrap md:max-w-[410px]",
                            children: "Quality-driven, niche, and unapologetic, every pastry is handcrafted daily in our open kitchen using the freshest ingredients sourced both locally and from Europe. While we stay true to traditional techniques and never take shortcuts, we continue to push creative boundaries with bold flavours and refined textures \n\nWith simple ingredients, time-tested recipes, and a commitment to exceptional craftsmanship, we\u2019ve built lasting relationships with our customers \u2014 one croissant at a time."
                        })
                    })
                ]
            })
        ]
    });
}));
const $e89d73536f9b4406$var$FeatureProducts = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)((_, _ref)=>{
    const products = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>s.featureProducts);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center justify-center !h-[calc(100vh-theme(space.navigationMobile))] md:!h-[100vh]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "font-natural text-white text-[64px] md:text-[128px] text-center w-full m-auto",
                    children: "Defined by Croissants"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e89d73536f9b4406$var$BoundaryWrapper, {
                id: "features",
                className: "features",
                boundaryType: "features",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "heading",
                        children: "Featured Products"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "feature-items",
                        children: products?.map((product, index)=>{
                            const delay = index === 0 ? 600 : index === 1 ? 0 : 1000;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "feature-item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$78358bd54413399e), {
                                        type: "slide-bottom-to-top",
                                        delay: delay,
                                        src: product.mainImage,
                                        alt: "feature product",
                                        ...$e89d73536f9b4406$var$SPRING_DEFAULT
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "title",
                                        children: product.title
                                    })
                                ]
                            });
                        })
                    })
                ]
            })
        ]
    });
}));
const $e89d73536f9b4406$var$MerchandiseProducts = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)((_, _ref)=>{
    const products = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>s.merchandiseProducts);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e89d73536f9b4406$var$BoundaryWrapper, {
            id: "merchandise-features",
            className: "merchandise features",
            boundaryType: "features",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "heading",
                    children: "Merchandise"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "feature-items",
                    children: products?.map((product, index)=>{
                        const delay = index === 0 ? 600 : index === 1 ? 0 : 1000;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "feature-item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$78358bd54413399e), {
                                    type: "slide-bottom-to-top",
                                    delay: delay,
                                    src: product.mainImage,
                                    alt: "feature product",
                                    ...$e89d73536f9b4406$var$SPRING_DEFAULT
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "title",
                                    children: product.title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "description text-center mt-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: product.description
                                    })
                                })
                            ]
                        });
                    })
                })
            ]
        })
    });
}));
const $e89d73536f9b4406$var$Menu = /*#__PURE__*/ (0, $acw62.memo)(()=>{
    const menuSections = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>s.menu);
    const [MenuColLeft, MenuColRight] = (0, $acw62.useMemo)(()=>menuSections ? (0, $453bfe9446abeb38$export$4264d5c1fe0b6503)(menuSections) : [
            [],
            []
        ], [
        menuSections
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        id: "menu",
        className: "menu",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "heading",
                children: "Menu"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "layout-mobile",
                children: menuSections?.map(({ title: title, items: items, withBorder: withBorder, comments: comments })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$MenuSection, {
                        title: title,
                        items: items,
                        withBorder: withBorder,
                        comments: comments
                    }))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "layout",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: MenuColLeft.map(({ title: title, items: items, withBorder: withBorder, comments: comments })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$MenuSection, {
                                title: title,
                                items: items,
                                withBorder: withBorder,
                                comments: comments
                            }))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: MenuColRight.map(({ title: title, items: items, withBorder: withBorder, comments: comments })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$MenuSection, {
                                title: title,
                                items: items,
                                withBorder: withBorder,
                                comments: comments
                            }))
                    })
                ]
            })
        ]
    });
});
const $e89d73536f9b4406$var$MenuSection = /*#__PURE__*/ (0, $acw62.memo)(({ title: title, items: items, withBorder: withBorder, comments: comments })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("menu-section", {
            "with-border": withBorder
        }),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "menu-section-heading",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "menu-items",
                children: [
                    items.map(({ label: label, price: price })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "menu-item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: price
                                })
                            ]
                        })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "menu-comments",
                        children: comments
                    })
                ]
            })
        ]
    }));
const $e89d73536f9b4406$var$Career = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(({ isMobile: isMobile }, _ref)=>{
    const careers = (0, $7f1ca03e50a4c851$export$16fe725363162b27)((s)=>s.careers);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$BoundaryWrapper, {
        id: "career",
        className: "career",
        boundaryType: "career",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "career-items",
            children: careers?.map((career)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "career-item",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$78358bd54413399e), {
                            type: "slide-bottom-to-top",
                            src: career.src,
                            alt: "career-role",
                            ...$e89d73536f9b4406$var$SPRING_DEFAULT
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0644053fea3ad634$export$c1a28a92d4f040ed), {
                            type: "slide-right-to-left",
                            animateDisabled: isMobile,
                            ...$e89d73536f9b4406$var$SPRING_DEFAULT,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "title",
                                    children: career.title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "description",
                                    children: career.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    type: "button",
                                    href: "mailto:info@angust.com",
                                    children: "Apply Now"
                                })
                            ]
                        })
                    ]
                }))
        })
    });
}));
const $e89d73536f9b4406$var$LOCATIONS = [
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5a769a12278e902e$exports))),
        title: "Angus T",
        title2: "Yaletown",
        description: "Hours\n\nMonday \u2013 Thursday\n8:00am \u2013 4:30pm\n\nFriday \u2013 Sunday & Holidays\n8:00am \u2013 5:30pm",
        addressOne: "1036 Mainland Street",
        addressTwo: "Vancouver,BC V6B 2T4",
        email: "info@angust.com",
        phone: "604-559-5989",
        directionUrl: "https://maps.app.goo.gl/ADNWhRrXjKU1dyB7A",
        isActive: true
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8bbf778a5167c620$exports))),
        title: "Angus T",
        title2: "Park Royal",
        description: `Hours

Monday \u{2013} Sunday
8:00am \u{2013} 7:00pm`,
        addressOne: "794 Main Street",
        addressTwo: "West Vancouver, BC V7T 0A4",
        email: "parkroyal@angust.com",
        phone: "604-281-0690",
        directionUrl: "https://maps.app.goo.gl/N98McL4Wp6RhUfQk9",
        isActive: true
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9ea9fbf18a4e7d77$exports))),
        title: "Angus T",
        title2: "River District",
        description: `Hours

Monday \u{2013} Sunday
8:00am \u{2013} 6:00pm`,
        addressOne: "8590 River District Crossing",
        addressTwo: "Vancouver, BC V5S 0C2",
        email: "riverdistrict@angust.com",
        phone: "604-800-8803",
        directionUrl: "https://maps.app.goo.gl/44myp5chdP4Gigs29",
        isActive: true
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ae1bc1ce220af8a0$exports))),
        title: "Angus T",
        title2: "SW Marine Dr.\n(Central Kitchen)",
        description: `Hours

Monday \u{2013} Friday
10:00am \u{2013} 4:00pm`,
        addressOne: "8370 Ontario St #123",
        addressTwo: "Vancouver, BC V5X 0K5",
        email: "central@angust.com",
        phone: "604-983-6111",
        directionUrl: "https://maps.app.goo.gl/D2v3Hnbmhsa4e6Wr7",
        isActive: true
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d030f15ca92e9ccf$exports))),
        title: "Angus T",
        title2: "Waterfront",
        description: `Hours\nTo Be Announced`,
        addressOne: "660 W Cordova St.",
        addressTwo: "Vancouver, BC V6C 1S9",
        email: "info@angust.com",
        phone: "",
        directionUrl: "https://www.google.com/maps/place/660+W+Cordova+St,+Vancouver,+BC/@49.2855509,-123.11264,19z",
        isActive: false,
        showAddress: true
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a460a13985cecea8$exports))),
        title: "Angus T",
        title2: "West end",
        description: `Hours

Monday \u{2013} Sunday
7:30am \u{2013} 6:00pm`,
        addressOne: "1305 Davie St.",
        addressTwo: "Vancouver, BC V6E 1N5",
        email: "westend@angust.com",
        phone: "604-559-9979",
        directionUrl: "https://maps.app.goo.gl/wr5EAnyVbyatXSGJ9",
        isActive: true
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f5bfc83df2e0df67$exports))),
        title: "Angus T",
        title2: "Gilmore",
        description: `Hours\nTo Be Announced`,
        addressOne: "4265 Dawson St.",
        addressTwo: "Burnaby, BC V5C 0N5",
        email: "info@angust.com",
        phone: "",
        directionUrl: "https://www.google.com/maps/place/4265+Dawson+St,+Burnaby,+BC/@49.2489292,-123.0123239,19z",
        isActive: false,
        showAddress: true
    }
];
const $e89d73536f9b4406$var$ContactLocations = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(({ isMobile: isMobile }, _ref)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e89d73536f9b4406$var$BoundaryWrapper, {
        id: "contact-locations",
        className: "contact-locations",
        boundaryType: "location",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "contact-locations-items",
            children: $e89d73536f9b4406$var$LOCATIONS.map((location, index)=>location.isActive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "contact-locations-item",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$78358bd54413399e), {
                            type: "slide-bottom-to-top",
                            src: location.src,
                            alt: "contact-locations",
                            ...$e89d73536f9b4406$var$SPRING_DEFAULT
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0644053fea3ad634$export$c1a28a92d4f040ed), {
                            type: "slide-right-to-left",
                            animateDisabled: isMobile,
                            ...$e89d73536f9b4406$var$SPRING_DEFAULT,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "title",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "md:inline-flex",
                                            children: location.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "md:ml-2 md:inline-flex",
                                            children: location.title2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "description",
                                    children: location.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "description",
                                    children: `${location.addressOne}
${location.addressTwo}`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "description underline !-mt-[15px] md:!-mt-[35px] mb-[50px]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: location.directionUrl || encodeURI(`http://maps.google.com/?q=${location.addressOne},${location.addressTwo}`),
                                        children: "Get Direction"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "description",
                                    children: `${location.email}
${location.phone}`
                                })
                            ]
                        })
                    ]
                }, location.title2 || index) : location.showAddress ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "contact-locations-item",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$78358bd54413399e), {
                            type: "slide-bottom-to-top",
                            src: location.src || (0, (/*@__PURE__*/$parcel$interopDefault($ff7719e0d88ec926$exports))),
                            alt: "contact-locations",
                            ...$e89d73536f9b4406$var$SPRING_DEFAULT
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0644053fea3ad634$export$c1a28a92d4f040ed), {
                            type: "slide-right-to-left",
                            animateDisabled: isMobile,
                            ...$e89d73536f9b4406$var$SPRING_DEFAULT,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "title",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "md:inline-flex",
                                            children: location.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "md:ml-2 md:inline-flex",
                                            children: location.title2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "description",
                                    children: location.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "description",
                                    children: `${location.addressOne}
${location.addressTwo}`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "description underline !-mt-[15px] md:!-mt-[35px] mb-[50px]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: location.directionUrl || encodeURI(`http://maps.google.com/?q=${location.addressOne},${location.addressTwo}`),
                                        children: "Get Direction"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "description",
                                    children: [
                                        "For more information",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "please email us at",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        location.email
                                    ]
                                })
                            ]
                        })
                    ]
                }, location.title2 || index) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "contact-locations-item",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0644053fea3ad634$export$78358bd54413399e), {
                            type: "slide-bottom-to-top",
                            src: location.src || (0, (/*@__PURE__*/$parcel$interopDefault($ff7719e0d88ec926$exports))),
                            alt: "contact-locations",
                            ...$e89d73536f9b4406$var$SPRING_DEFAULT
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0644053fea3ad634$export$c1a28a92d4f040ed), {
                            type: "slide-right-to-left",
                            animateDisabled: isMobile,
                            ...$e89d73536f9b4406$var$SPRING_DEFAULT,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "title",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "md:inline-flex",
                                            children: location.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "md:ml-2 md:inline-flex",
                                            children: location.title2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "description",
                                    children: location.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {
                                    hidden: isMobile
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {
                                    hidden: isMobile
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "description",
                                    children: [
                                        "Follow us on Instagram",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "for latest updates",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "on our new locations"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "description",
                                    children: [
                                        "For more information",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "please email us at",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        location.email
                                    ]
                                })
                            ]
                        })
                    ]
                }, location.title2 || index))
        })
    });
}));
const $e89d73536f9b4406$var$BoundaryWrapper = /*#__PURE__*/ (0, $acw62.memo)((props)=>{
    const { boundaryType: boundaryType, ...left } = props;
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        function checkPosition() {
            if (!ref.current) return;
            (0, $7f1ca03e50a4c851$export$16fe725363162b27).getState().setPassing(boundaryType, ref.current.getBoundingClientRect().top <= -100);
        }
        window.addEventListener("scroll", checkPosition);
        return ()=>window.removeEventListener("scroll", checkPosition);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...left,
        ref: ref
    });
});




var $acw62 = parcelRequire("acw62");

function $59a85d4d7fb93f43$var$ErrorPage({}) {
    const error = (0, $7939e29d663dd3ed$export$ed527bf60f6e05f2)();
    if (!error) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "error-page-div",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Opps"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-10",
                children: [
                    "Something wrong: ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        children: error.statusText || error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "underline",
                children: "Go back"
            })
        ]
    });
}
var $59a85d4d7fb93f43$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($59a85d4d7fb93f43$var$ErrorPage);




var $acw62 = parcelRequire("acw62");
function $3e73c04aeb704288$var$ContactUs() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "Contact Us"
    });
}
var $3e73c04aeb704288$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($3e73c04aeb704288$var$ContactUs);




var $acw62 = parcelRequire("acw62");
function $33ca6f295433b7e8$var$AboutUs() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "About Us"
    });
}
var $33ca6f295433b7e8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($33ca6f295433b7e8$var$AboutUs);


const $f85b6d3c5c511c65$var$container = document.getElementById("root");
const $f85b6d3c5c511c65$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($f85b6d3c5c511c65$var$container);
const $f85b6d3c5c511c65$var$queryClient = new (0, $993a0f6ad9d6681b$export$405d0624ed55a03f)();
const $f85b6d3c5c511c65$var$router = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebca63daf69a6024$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e89d73536f9b4406$export$2e2bcd8739ae039), {})
            },
            {
                path: "about-us",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ca6f295433b7e8$export$2e2bcd8739ae039), {})
            },
            {
                path: "contact-us",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e73c04aeb704288$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59a85d4d7fb93f43$export$2e2bcd8739ae039), {})
    }
]);
$f85b6d3c5c511c65$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0126047dd734bc33$export$45604f0cc8ae667b), {
        client: $f85b6d3c5c511c65$var$queryClient,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$323e4fc2fa4753fb), {
            router: $f85b6d3c5c511c65$var$router
        })
    })
}));


//# sourceMappingURL=angust-website.edb2513f.js.map
